const NobelPrize = {
    id10000: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Wilhelm C. Röntgen a-t-il reçu le Prix Nobel de Physique en reconnaissance des services extraordinaires qu’il a rendus par la découverte des rayons remarquables qui portent son nom ?",
      answers: ["1928","1919","1901","1902"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10001: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1901 en reconnaissance des services extraordinaires qu’il a rendus par la découverte des rayons remarquables qui portent son nom ?",
      answers: ["Carl F. Braun","Wilhelm C. Röntgen","Lord Rayleigh (John W. Strutt)","David J. Wineland"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10002: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Wilhelm C. Röntgen a-t-il reçu le Prix Nobel en 1901 ?",
      answers: ["pour sa découverte de la diffraction des rayons X par les cristaux","en reconnaissance des services extraordinaires qu’il a rendus par la découverte des rayons remarquables qui portent son nom","pour sa découverte de l’effet Doppler dans les rayons canaux et de la séparation des lignes spectrales dans les champs électriques","en reconnaissance des services extraordinaires qu’ils ont rendus conjointement par leurs recherches sur les phénomènes de rayonnement découverts par le professeur Henri Becquerel"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10003: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Wilhelm C. Röntgen a-t-il reçu le Prix Nobel en 1901 ?",
      answers: ["Paix","Physiologie ou Médecine","Physique","Sciences Économiques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10004: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Jacobus H. van ’t Hoff a-t-il reçu le Prix Nobel de Chimie en reconnaissance des services extraordinaires qu’il a rendus par la découverte des lois de la dynamique chimique et de la pression osmotique dans les solutions ?",
      answers: ["1901","1936","1924","1981"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10005: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1901 en reconnaissance des services extraordinaires qu’il a rendus par la découverte des lois de la dynamique chimique et de la pression osmotique dans les solutions ?",
      answers: ["Harold C. Urey","Elias James Corey","Hans von Euler-Chelpin","Jacobus H. van ’t Hoff"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10006: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Jacobus H. van ’t Hoff a-t-il reçu le Prix Nobel en 1901 ?",
      answers: ["pour sa méthode d’hydrogénation des composés organiques en présence de métaux finement divisés","en reconnaissance des services extraordinaires qu’il a rendus à l’avancement de la chimie par sa théorie de la dissociation électrolytique","pour son travail sur les réactions d’hydrogénation catalysées de manière chirale","en reconnaissance des services extraordinaires qu’il a rendus par la découverte des lois de la dynamique chimique et de la pression osmotique dans les solutions"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10007: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Jacobus H. van ’t Hoff a-t-il reçu le Prix Nobel en 1901 ?",
      answers: ["Physique","Physiologie ou Médecine","Chimie","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10008: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Emil A. von Behring a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour son travail sur la thérapie sérique, en particulier son application contre la diphtérie, qui a ouvert une nouvelle voie dans le domaine de la science médicale ?",
      answers: ["1902","1903","1909","1901"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10009: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1901 pour son travail sur la thérapie sérique, en particulier son application contre la diphtérie, qui a ouvert une nouvelle voie dans le domaine de la science médicale ?",
      answers: ["Emil A. von Behring","Emil T. Kocher","Ronald Ross","Shinya Yamanaka"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10010: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Emil A. von Behring a-t-il reçu le Prix Nobel en 1901 ?",
      answers: ["pour la découverte de la production de mutations par irradiation aux rayons X","pour son travail sur la thérapie sérique, en particulier son application contre la diphtérie, qui a ouvert une nouvelle voie dans le domaine de la science médicale","pour ses découvertes concernant les mécanismes d’action des hormones","en reconnaissance de sa contribution au traitement des maladies, en particulier le lupus vulgaris, par la thérapie par la lumière concentrée"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10011: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Emil A. von Behring a-t-il reçu le Prix Nobel en 1901 ?",
      answers: ["Physiologie ou Médecine","Physique","Paix","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10012: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Sully Prudhomme a-t-il reçu le Prix Nobel de Littérature en reconnaissance spéciale de sa composition poétique, qui témoigne d’un idéalisme élevé, d’une perfection artistique et d’une rare combinaison de qualités du cœur et de l’esprit ?",
      answers: ["1930","1901","1907","1904"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10013: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1901 en reconnaissance spéciale de sa composition poétique, qui témoigne d’un idéalisme élevé, d’une perfection artistique et d’une rare combinaison de qualités du cœur et de l’esprit ?",
      answers: ["Rudyard Kipling","Sinclair Lewis","Henri Bergson","Sully Prudhomme"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10014: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Sully Prudhomme a-t-il reçu le Prix Nobel en 1901 ?",
      answers: ["en reconnaissance de l’originalité fraîche et de la véritable inspiration de sa production poétique, qui reflète fidèlement les paysages naturels et l’esprit natif de son peuple","en reconnaissance spéciale de sa composition poétique, qui témoigne d’un idéalisme élevé, d’une perfection artistique et d’une rare combinaison de qualités du cœur et de l’esprit","pour ses écrits approfondis et artistiquement significatifs dans lesquels les problèmes et conditions humaines sont présentés avec un amour intrépide de la vérité","pour ses écrits réalistes et imaginatifs, combinant un humour sympathique et une perception sociale aiguë"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10015: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Sully Prudhomme a-t-il reçu le Prix Nobel en 1901 ?",
      answers: ["Chimie","Littérature","Physiologie ou Médecine","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10016: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Jean H. Dunant a-t-il reçu le Prix Nobel de Paix pour son rôle dans la fondation du Comité International de la Croix-Rouge ?",
      answers: ["1910","1911","1901","1954"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10017: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1901 pour son rôle dans la fondation du Comité International de la Croix-Rouge ?",
      answers: ["Comité International de la Croix-Rouge","Institut de Droit International","Jean H. Dunant","Auguste Beernaert"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10018: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Jean H. Dunant a-t-il reçu le Prix Nobel en 1901 ?",
      answers: ["pour son rôle dans la fondation du Comité International de la Croix-Rouge","pour leurs efforts en faveur de la paix à travers le mouvement pacifiste et l’arbitrage international","pour leurs efforts en faveur de la paix en tant que leaders du mouvement pacifiste international","pour leurs efforts visant à créer la paix au Moyen-Orient"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10019: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Jean H. Dunant a-t-il reçu le Prix Nobel en 1901 ?",
      answers: ["Physique","Chimie","Paix","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10020: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Frédéric Passy a-t-il reçu le Prix Nobel de Paix pour son travail de longue date en faveur de la paix et de l’arbitrage international ?",
      answers: ["1901","1903","1985","1910"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10021: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1901 pour son travail de longue date en faveur de la paix et de l’arbitrage international ?",
      answers: ["Bureau international Nansen pour les réfugiés","Élie Ducommun","Comité International de la Croix-Rouge (CICR)","Frédéric Passy"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10022: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Frédéric Passy a-t-il reçu le Prix Nobel en 1901 ?",
      answers: ["pour son rôle dans la fondation du Comité International de la Croix-Rouge","pour ses efforts en faveur de la paix et de la diplomatie internationale","pour leurs efforts en faveur de la paix en tant que leaders du mouvement pacifiste international","pour son travail de longue date en faveur de la paix et de l’arbitrage international"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10023: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Frédéric Passy a-t-il reçu le Prix Nobel en 1901 ?",
      answers: ["Chimie","Sciences Économiques","Paix","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10024: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Hendrik A. Lorentz a-t-il reçu le Prix Nobel de Physique en reconnaissance des services extraordinaires qu’ils ont rendus par leurs recherches sur l’influence du magnétisme sur les phénomènes de rayonnement ?",
      answers: ["1902","1973","1931","1917"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10025: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1902 en reconnaissance des services extraordinaires qu’ils ont rendus par leurs recherches sur l’influence du magnétisme sur les phénomènes de rayonnement ?",
      answers: ["Wilhelm C. Röntgen","Antoine H. Becquerel","Hendrik A. Lorentz","Enrico Fermi"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10026: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Hendrik A. Lorentz a-t-il reçu le Prix Nobel en 1902 ?",
      answers: ["en reconnaissance des services extraordinaires qu’il a rendus par la découverte des rayons remarquables qui portent son nom","en reconnaissance des services extraordinaires qu’ils ont rendus par leurs recherches sur l’influence du magnétisme sur les phénomènes de rayonnement","pour le développement de semi-conducteurs utilisés dans l’électronique à haute vitesse et l’optoélectronique","pour sa méthode de résonance pour enregistrer les propriétés magnétiques des noyaux atomiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10027: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Hendrik A. Lorentz a-t-il reçu le Prix Nobel en 1902 ?",
      answers: ["Paix","Sciences Économiques","Physique","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10028: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Pieter Zeeman a-t-il reçu le Prix Nobel de Physique en reconnaissance des services extraordinaires qu’ils ont rendus par leurs recherches sur l’influence du magnétisme sur les phénomènes de rayonnement ?",
      answers: ["1956","1904","1902","2009"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10029: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1902 en reconnaissance des services extraordinaires qu’ils ont rendus par leurs recherches sur l’influence du magnétisme sur les phénomènes de rayonnement ?",
      answers: ["John D. Cockcroft","John H. Van Vleck","Pieter Zeeman","Gabriel Lippmann"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10030: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Pieter Zeeman a-t-il reçu le Prix Nobel en 1902 ?",
      answers: ["pour la découverte du neutron","en reconnaissance des services extraordinaires qu’il a rendus par la découverte des rayons remarquables qui portent son nom","pour ses instruments optiques de précision et les recherches spectroscopiques et métrologiques réalisées avec ceux-ci","en reconnaissance des services extraordinaires qu’ils ont rendus par leurs recherches sur l’influence du magnétisme sur les phénomènes de rayonnement"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10031: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Pieter Zeeman a-t-il reçu le Prix Nobel en 1902 ?",
      answers: ["Physiologie ou Médecine","Physique","Chimie","Littérature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10032: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Hermann E. Fischer a-t-il reçu le Prix Nobel de Chimie en reconnaissance des services extraordinaires qu’il a rendus par son travail sur la synthèse des sucres et des purines ?",
      answers: ["1963","1903","1902","1906"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10033: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1902 en reconnaissance des services extraordinaires qu’il a rendus par son travail sur la synthèse des sucres et des purines ?",
      answers: ["Hermann E. Fischer","Svante A. Arrhenius","Peter J.W. Debye","Jacobus H. van ’t Hoff"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10034: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Hermann E. Fischer a-t-il reçu le Prix Nobel en 1902 ?",
      answers: ["en reconnaissance des services extraordinaires qu’il a rendus à l’avancement de la chimie par sa théorie de la dissociation électrolytique","pour ses recherches sur la désintégration des éléments et la chimie des substances radioactives","en reconnaissance des services extraordinaires qu’il a rendus par son travail sur la synthèse des sucres et des purines","pour leurs travaux sur la chimie de l’atmosphère, notamment concernant la formation et la décomposition de l’ozone"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10035: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Hermann E. Fischer a-t-il reçu le Prix Nobel en 1902 ?",
      answers: ["Physique","Chimie","Paix","Littérature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10036: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Ronald Ross a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour son travail sur le paludisme, par lequel il a montré comment le parasite pénètre dans l’organisme et ainsi jeté les bases de recherches fructueuses sur cette maladie ?",
      answers: ["1912","1902","1903","1906"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10037: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1902 pour son travail sur le paludisme, par lequel il a montré comment le parasite pénètre dans l’organisme et ainsi jeté les bases de recherches fructueuses sur cette maladie ?",
      answers: ["Ivan P. Pavlov","Ronald Ross","Santiago Ramón y Cajal","Camillo Golgi"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10038: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Ronald Ross a-t-il reçu le Prix Nobel en 1902 ?",
      answers: ["pour son travail sur la thérapie sérique, en particulier son application contre la diphtérie, qui a ouvert une nouvelle voie dans le domaine de la science médicale","en reconnaissance de leurs travaux sur la structure du système nerveux","pour son travail sur le paludisme, par lequel il a montré comment le parasite pénètre dans l’organisme et ainsi jeté les bases de recherches fructueuses sur cette maladie","pour leurs découvertes concernant une nouvelle thérapie contre les infections causées par des parasites"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10039: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Ronald Ross a-t-il reçu le Prix Nobel en 1902 ?",
      answers: ["Sciences Économiques","Paix","Physiologie ou Médecine","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10040: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Theodor Mommsen a-t-il reçu le Prix Nobel de Littérature en tant que plus grand maître vivant de l’art de l’écriture historique, avec une mention spéciale pour son œuvre monumentale, 'Histoire romaine' ?",
      answers: ["1901","2020","1929","1902"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10041: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1902 en tant que plus grand maître vivant de l’art de l’écriture historique, avec une mention spéciale pour son œuvre monumentale, 'Histoire romaine' ?",
      answers: ["Rudyard Kipling","Theodor Mommsen","Carl Spitteler","Shmuel Yosef Agnon"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10042: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Theodor Mommsen a-t-il reçu le Prix Nobel en 1902 ?",
      answers: ["en reconnaissance des nombreuses et brillantes compositions qui, d’une manière individuelle et originale, ont ravivé les grandes traditions du drame espagnol","en tant que plus grand maître vivant de l’art de l’écriture historique, avec une mention spéciale pour son œuvre monumentale, 'Histoire romaine'","en raison de ses mérites exceptionnels en tant qu’écrivain épique","pour ses réalisations importantes dans la poésie lyrique contemporaine ainsi que dans le domaine de la grande tradition épique russe"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10043: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Theodor Mommsen a-t-il reçu le Prix Nobel en 1902 ?",
      answers: ["Littérature","Sciences Économiques","Physiologie ou Médecine","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10044: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Élie Ducommun a-t-il reçu le Prix Nobel de Paix pour leurs efforts en faveur de la paix en tant que leaders du mouvement pacifiste international ?",
      answers: ["1901","1904","1902","1905"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10045: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1902 pour leurs efforts en faveur de la paix en tant que leaders du mouvement pacifiste international ?",
      answers: ["Élie Ducommun","Jean H. Dunant","Denis Mukwege","Charles A. Gobat"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10046: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Élie Ducommun a-t-il reçu le Prix Nobel en 1902 ?",
      answers: ["pour son rôle dans la fondation de la Société des Nations","pour leurs efforts en faveur de la paix en tant que leaders du mouvement pacifiste international","pour son rôle dans les accords de Locarno favorisant la paix en Europe","pour son roman 'Quand les armes se taisent' et son travail en faveur de la paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10047: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Élie Ducommun a-t-il reçu le Prix Nobel en 1902 ?",
      answers: ["Physique","Physiologie ou Médecine","Paix","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10048: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Charles A. Gobat a-t-il reçu le Prix Nobel de Paix pour leurs efforts en faveur de la paix en tant que leaders du mouvement pacifiste international ?",
      answers: ["1908","1905","1922","1902"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10049: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1902 pour leurs efforts en faveur de la paix en tant que leaders du mouvement pacifiste international ?",
      answers: ["Élie Ducommun","Charles A. Gobat","Sir William R. Cremer","Ligue des Sociétés de la Croix-Rouge"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10050: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Charles A. Gobat a-t-il reçu le Prix Nobel en 1902 ?",
      answers: ["pour son travail de longue date en faveur de la paix et de l’arbitrage international","pour leurs efforts en faveur de la paix en tant que leaders du mouvement pacifiste international","pour leur rôle dans la promotion du droit international et de l’arbitrage","pour son travail en faveur de la paix et de la coopération internationale à travers la Société des Nations"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10051: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Charles A. Gobat a-t-il reçu le Prix Nobel en 1902 ?",
      answers: ["Physiologie ou Médecine","Physique","Sciences Économiques","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10052: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Antoine H. Becquerel a-t-il reçu le Prix Nobel de Physique en reconnaissance des services extraordinaires qu’il a rendus par sa découverte de la radioactivité spontanée ?",
      answers: ["1910","1905","1902","1903"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10053: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1903 en reconnaissance des services extraordinaires qu’il a rendus par sa découverte de la radioactivité spontanée ?",
      answers: ["Antoine H. Becquerel","Owen W. Richardson","Pierre Curie","Gabriel Lippmann"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10054: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Antoine H. Becquerel a-t-il reçu le Prix Nobel en 1903 ?",
      answers: ["pour ses découvertes concernant les lois régissant le rayonnement thermique","en reconnaissance des services extraordinaires qu’il a rendus par sa découverte de la radioactivité spontanée","pour ses travaux sur le phénomène thermionique et en particulier pour la découverte de la loi qui porte son nom","en reconnaissance des services extraordinaires qu’ils ont rendus conjointement par leurs recherches sur les phénomènes de rayonnement découverts par le professeur Henri Becquerel"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10055: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Antoine H. Becquerel a-t-il reçu le Prix Nobel en 1903 ?",
      answers: ["Paix","Physique","Chimie","Littérature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10056: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Pierre Curie a-t-il reçu le Prix Nobel de Physique en reconnaissance des services extraordinaires qu’ils ont rendus conjointement par leurs recherches sur les phénomènes de rayonnement découverts par le professeur Henri Becquerel ?",
      answers: ["1904","1907","1903","1933"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10057: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1903 en reconnaissance des services extraordinaires qu’ils ont rendus conjointement par leurs recherches sur les phénomènes de rayonnement découverts par le professeur Henri Becquerel ?",
      answers: ["Charles K. Kao","Heike Kamerlingh Onnes","Paul A.M. Dirac","Pierre Curie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10058: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Pierre Curie a-t-il reçu le Prix Nobel en 1903 ?",
      answers: ["en reconnaissance des services extraordinaires qu’ils ont rendus conjointement par leurs recherches sur les phénomènes de rayonnement découverts par le professeur Henri Becquerel","en reconnaissance des services extraordinaires qu’ils ont rendus par leurs recherches sur l’influence du magnétisme sur les phénomènes de rayonnement","pour leurs contributions pionnières à l’astrophysique, notamment la détection des neutrinos cosmiques","en reconnaissance des services extraordinaires qu’il a rendus par sa découverte de la radioactivité spontanée"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10059: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Pierre Curie a-t-il reçu le Prix Nobel en 1903 ?",
      answers: ["Chimie","Physique","Paix","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10060: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Marie Curie a-t-il reçu le Prix Nobel de Physique en reconnaissance des services extraordinaires qu’ils ont rendus conjointement par leurs recherches sur les phénomènes de rayonnement découverts par le professeur Henri Becquerel ?",
      answers: ["1904","2024","1903","1909"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10061: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1903 en reconnaissance des services extraordinaires qu’ils ont rendus conjointement par leurs recherches sur les phénomènes de rayonnement découverts par le professeur Henri Becquerel ?",
      answers: ["Marie Curie","Ferenc Krausz","Pierre Curie","Antoine H. Becquerel"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10062: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Marie Curie a-t-il reçu le Prix Nobel en 1903 ?",
      answers: ["pour ses recherches sur les densités des gaz les plus importants et pour sa découverte de l’argon en lien avec ces études","en reconnaissance des services extraordinaires qu’ils ont rendus conjointement par leurs recherches sur les phénomènes de rayonnement découverts par le professeur Henri Becquerel","pour l’invention d’un appareil permettant de produire des pressions extrêmement élevées et pour les découvertes qu’il a réalisées dans le domaine de la physique des hautes pressions","en reconnaissance des services extraordinaires qu’il a rendus par sa découverte de la radioactivité spontanée"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10063: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Marie Curie a-t-il reçu le Prix Nobel en 1903 ?",
      answers: ["Sciences Économiques","Physiologie ou Médecine","Paix","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10064: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Svante A. Arrhenius a-t-il reçu le Prix Nobel de Chimie en reconnaissance des services extraordinaires qu’il a rendus à l’avancement de la chimie par sa théorie de la dissociation électrolytique ?",
      answers: ["1904","1914","1905","1903"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10065: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1903 en reconnaissance des services extraordinaires qu’il a rendus à l’avancement de la chimie par sa théorie de la dissociation électrolytique ?",
      answers: ["Vladimir Prelog","Marie Curie","Svante A. Arrhenius","Hermann E. Fischer"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10066: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Svante A. Arrhenius a-t-il reçu le Prix Nobel en 1903 ?",
      answers: ["en reconnaissance des services extraordinaires qu’il a rendus à l’avancement de la chimie par sa théorie de la dissociation électrolytique","en reconnaissance de ses déterminations précises des poids atomiques de nombreux éléments chimiques","en reconnaissance des services qu’il a rendus à l’avancement de la chimie organique et de l’industrie chimique par ses travaux sur les colorants organiques et les composés hydroaromatiques","en reconnaissance des grands services qu’il a rendus par la découverte du fluor et l’introduction du four électrique qui porte son nom dans le service de la science"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10067: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Svante A. Arrhenius a-t-il reçu le Prix Nobel en 1903 ?",
      answers: ["Paix","Chimie","Physique","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10068: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Niels R. Finsen a-t-il reçu le Prix Nobel de Physiologie ou Médecine en reconnaissance de sa contribution au traitement des maladies, en particulier le lupus vulgaris, par la thérapie par la lumière concentrée ?",
      answers: ["1906","1902","1905","1903"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10069: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1903 en reconnaissance de sa contribution au traitement des maladies, en particulier le lupus vulgaris, par la thérapie par la lumière concentrée ?",
      answers: ["Renato Dulbecco","Robert Koch","William P. Murphy","Niels R. Finsen"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10070: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Niels R. Finsen a-t-il reçu le Prix Nobel en 1903 ?",
      answers: ["pour la découverte de la pénicilline et de son effet curatif dans diverses maladies infectieuses","en reconnaissance de sa contribution au traitement des maladies, en particulier le lupus vulgaris, par la thérapie par la lumière concentrée","pour leurs découvertes concernant les prostaglandines et les substances biologiquement actives apparentées","pour son travail sur le paludisme, par lequel il a montré comment le parasite pénètre dans l’organisme et ainsi jeté les bases de recherches fructueuses sur cette maladie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10071: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Niels R. Finsen a-t-il reçu le Prix Nobel en 1903 ?",
      answers: ["Chimie","Physiologie ou Médecine","Littérature","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10072: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Bjørnstjerne Bjørnson a-t-il reçu le Prix Nobel de Littérature en hommage à sa poésie noble, magnifique et variée, qui a toujours été distinguée à la fois par la fraîcheur de son inspiration et par une pureté rare de son esprit ?",
      answers: ["1903","1963","1944","2002"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10073: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1903 en hommage à sa poésie noble, magnifique et variée, qui a toujours été distinguée à la fois par la fraîcheur de son inspiration et par une pureté rare de son esprit ?",
      answers: ["Tomas Tranströmer","Rudyard Kipling","Frédéric Mistral","Bjørnstjerne Bjørnson"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10074: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Bjørnstjerne Bjørnson a-t-il reçu le Prix Nobel en 1903 ?",
      answers: ["non seulement en considération de son érudition profonde et de ses recherches critiques, mais surtout en hommage à l’énergie créatrice et à la pureté du style de ses chefs-d’œuvre poétiques","en hommage à sa poésie noble, magnifique et variée, qui a toujours été distinguée à la fois par la fraîcheur de son inspiration et par une pureté rare de son esprit","en reconnaissance de sa quête sérieuse de la vérité, de sa puissance pénétrante de pensée et de son style chaleureux et vivant","en tant que plus grand maître vivant de l’art de l’écriture historique, avec une mention spéciale pour son œuvre monumentale, 'Histoire romaine'"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10075: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Bjørnstjerne Bjørnson a-t-il reçu le Prix Nobel en 1903 ?",
      answers: ["Paix","Physiologie ou Médecine","Chimie","Littérature"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10076: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Sir William R. Cremer a-t-il reçu le Prix Nobel de Paix pour son travail de longue date en faveur de la paix et de l’arbitrage international ?",
      answers: ["1964","1947","1903","1902"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10077: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1903 pour son travail de longue date en faveur de la paix et de l’arbitrage international ?",
      answers: ["Frédéric Passy","Austen Chamberlain","Klas P. Arnoldson","Sir William R. Cremer"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10078: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Sir William R. Cremer a-t-il reçu le Prix Nobel en 1903 ?",
      answers: ["pour leurs efforts en faveur de la paix en tant que leaders du mouvement pacifiste international","pour leurs efforts en faveur de la paix à travers le mouvement pacifiste et l’arbitrage international","pour son travail de longue date en faveur de la paix et de l’arbitrage international","pour leurs contributions à la paix à travers la diplomatie et le mouvement pacifiste"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10079: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Sir William R. Cremer a-t-il reçu le Prix Nobel en 1903 ?",
      answers: ["Sciences Économiques","Chimie","Physique","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10080: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Lord Rayleigh (John W. Strutt) a-t-il reçu le Prix Nobel de Physique pour ses recherches sur les densités des gaz les plus importants et pour sa découverte de l’argon en lien avec ces études ?",
      answers: ["1904","1902","1907","1952"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10081: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1904 pour ses recherches sur les densités des gaz les plus importants et pour sa découverte de l’argon en lien avec ces études ?",
      answers: ["Marie Curie","Lord Rayleigh (John W. Strutt)","Samuel C.C. Ting","Albert Einstein"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10082: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Lord Rayleigh (John W. Strutt) a-t-il reçu le Prix Nobel en 1904 ?",
      answers: ["en reconnaissance des services extraordinaires qu’il a rendus par la découverte des rayons remarquables qui portent son nom","pour ses travaux sur les rayons cathodiques","pour ses recherches sur les densités des gaz les plus importants et pour sa découverte de l’argon en lien avec ces études","pour leurs investigations théoriques fondamentales sur la structure électronique des systèmes magnétiques et désordonnés"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10083: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Lord Rayleigh (John W. Strutt) a-t-il reçu le Prix Nobel en 1904 ?",
      answers: ["Sciences Économiques","Physiologie ou Médecine","Physique","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10084: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Sir William Ramsay a-t-il reçu le Prix Nobel de Chimie en reconnaissance des services qu’il a rendus par la découverte des éléments gazeux inertes dans l’air et la détermination de leur place dans le système périodique ?",
      answers: ["1906","1902","1922","1904"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10085: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1904 en reconnaissance des services qu’il a rendus par la découverte des éléments gazeux inertes dans l’air et la détermination de leur place dans le système périodique ?",
      answers: ["Sir William Ramsay","Svante A. Arrhenius","Adolf von Baeyer","Elias James Corey"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10086: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Sir William Ramsay a-t-il reçu le Prix Nobel en 1904 ?",
      answers: ["en reconnaissance des services qu’il a rendus à la chimie organique et à l’industrie chimique par ses travaux pionniers dans le domaine des composés alicycliques","en reconnaissance des services qu’il a rendus à l’avancement de la chimie organique et de l’industrie chimique par ses travaux sur les colorants organiques et les composés hydroaromatiques","pour ses recherches sur les produits végétaux d’importance biologique, en particulier les alcaloïdes","en reconnaissance des services qu’il a rendus par la découverte des éléments gazeux inertes dans l’air et la détermination de leur place dans le système périodique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10087: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Sir William Ramsay a-t-il reçu le Prix Nobel en 1904 ?",
      answers: ["Chimie","Physique","Littérature","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10088: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Ivan P. Pavlov a-t-il reçu le Prix Nobel de Physiologie ou Médecine en reconnaissance de son travail sur la physiologie de la digestion, par lequel la connaissance de cet aspect vital a été transformée et élargie ?",
      answers: ["1934","1902","1904","1903"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10089: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1904 en reconnaissance de son travail sur la physiologie de la digestion, par lequel la connaissance de cet aspect vital a été transformée et élargie ?",
      answers: ["Leland H. Hartwell","Charles L. A. Laveran","John F. Enders","Ivan P. Pavlov"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10090: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Ivan P. Pavlov a-t-il reçu le Prix Nobel en 1904 ?",
      answers: ["en reconnaissance de ses travaux sur le rôle joué par les protozoaires dans la causation des maladies","pour la découverte des enzymes de restriction et leur application aux problèmes de génétique moléculaire","en reconnaissance de leurs travaux sur la structure du système nerveux","en reconnaissance de son travail sur la physiologie de la digestion, par lequel la connaissance de cet aspect vital a été transformée et élargie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10091: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Ivan P. Pavlov a-t-il reçu le Prix Nobel en 1904 ?",
      answers: ["Sciences Économiques","Paix","Physiologie ou Médecine","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10092: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Frédéric Mistral a-t-il reçu le Prix Nobel de Littérature en reconnaissance de l’originalité fraîche et de la véritable inspiration de sa production poétique, qui reflète fidèlement les paysages naturels et l’esprit natif de son peuple ?",
      answers: ["1908","1924","1904","1961"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10093: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1904 en reconnaissance de l’originalité fraîche et de la véritable inspiration de sa production poétique, qui reflète fidèlement les paysages naturels et l’esprit natif de son peuple ?",
      answers: ["Rudyard Kipling","Selma Lagerlöf","Frédéric Mistral","José Echegaray"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10094: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Frédéric Mistral a-t-il reçu le Prix Nobel en 1904 ?",
      answers: ["pour ses descriptions riches et véritablement épiques de la vie paysanne en Chine et pour ses chefs-d’œuvre biographiques","en reconnaissance de l’originalité fraîche et de la véritable inspiration de sa production poétique, qui reflète fidèlement les paysages naturels et l’esprit natif de son peuple","pour la force rare et la fertilité de son imagination poétique avec lesquelles il a combiné une curiosité intellectuelle et un style audacieux et frais","pour l’art rigoureux avec lequel il a développé les traditions de la prose classique russe"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10095: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Frédéric Mistral a-t-il reçu le Prix Nobel en 1904 ?",
      answers: ["Littérature","Physiologie ou Médecine","Physique","Sciences Économiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10096: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année José Echegaray a-t-il reçu le Prix Nobel de Littérature en reconnaissance des nombreuses et brillantes compositions qui, d’une manière individuelle et originale, ont ravivé les grandes traditions du drame espagnol ?",
      answers: ["1929","1908","1903","1904"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10097: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1904 en reconnaissance des nombreuses et brillantes compositions qui, d’une manière individuelle et originale, ont ravivé les grandes traditions du drame espagnol ?",
      answers: ["Frédéric Mistral","José Echegaray","Giosuè Carducci","Selma Lagerlöf"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10098: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison José Echegaray a-t-il reçu le Prix Nobel en 1904 ?",
      answers: ["en considération de la puissance d’observation, de l’originalité de l’imagination et de la virilité des idées qui caractérisent les créations de cet auteur mondialement célèbre","pour la force éthique avec laquelle il a poursuivi les traditions indispensables de la littérature russe","en appréciation de ses activités littéraires multiformes, et en particulier de ses œuvres dramatiques, qui se distinguent par une richesse d’imagination","en reconnaissance des nombreuses et brillantes compositions qui, d’une manière individuelle et originale, ont ravivé les grandes traditions du drame espagnol"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10099: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie José Echegaray a-t-il reçu le Prix Nobel en 1904 ?",
      answers: ["Littérature","Physique","Chimie","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10100: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Institut de Droit International a-t-il reçu le Prix Nobel de Paix pour ses efforts visant à codifier le droit international et à promouvoir la paix ?",
      answers: ["1904","1921","2006","1907"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10101: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1904 pour ses efforts visant à codifier le droit international et à promouvoir la paix ?",
      answers: ["Elihu Root","Lê Đức Thọ","Institut de Droit International","Fredrik Bajer"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10102: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Institut de Droit International a-t-il reçu le Prix Nobel en 1904 ?",
      answers: ["pour son rôle dans la fondation du Comité International de la Croix-Rouge","pour leur travail en faveur de la paix et des réformes sociales","pour ses efforts visant à codifier le droit international et à promouvoir la paix","pour son travail humanitaire pendant la Première Guerre mondiale"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10103: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Institut de Droit International a-t-il reçu le Prix Nobel en 1904 ?",
      answers: ["Physiologie ou Médecine","Paix","Physique","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10104: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Philipp Lenard a-t-il reçu le Prix Nobel de Physique pour ses travaux sur les rayons cathodiques ?",
      answers: ["1950","1903","1905","1920"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10105: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1905 pour ses travaux sur les rayons cathodiques ?",
      answers: ["James Franck","Antoine H. Becquerel","Joseph J. Thomson","Philipp Lenard"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10106: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Philipp Lenard a-t-il reçu le Prix Nobel en 1905 ?",
      answers: ["pour ses travaux sur les rayons cathodiques","pour l’invention et le développement du cyclotron et pour les résultats obtenus, en particulier en ce qui concerne les éléments radioactifs artificiels","en reconnaissance des services extraordinaires qu’il a rendus par sa découverte de la radioactivité spontanée","pour ses découvertes et inventions fondamentales qui permettent l’apprentissage automatique avec des réseaux neuronaux artificiels"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10107: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Philipp Lenard a-t-il reçu le Prix Nobel en 1905 ?",
      answers: ["Littérature","Chimie","Physique","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10108: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Adolf von Baeyer a-t-il reçu le Prix Nobel de Chimie en reconnaissance des services qu’il a rendus à l’avancement de la chimie organique et de l’industrie chimique par ses travaux sur les colorants organiques et les composés hydroaromatiques ?",
      answers: ["1905","1904","1906","1909"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10109: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1905 en reconnaissance des services qu’il a rendus à l’avancement de la chimie organique et de l’industrie chimique par ses travaux sur les colorants organiques et les composés hydroaromatiques ?",
      answers: ["Frederick Soddy","Adolf von Baeyer","Frederick Sanger","Henri Moissan"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10110: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Adolf von Baeyer a-t-il reçu le Prix Nobel en 1905 ?",
      answers: ["en reconnaissance des services qu’il a rendus par la découverte des éléments gazeux inertes dans l’air et la détermination de leur place dans le système périodique","en reconnaissance des grands services qu’il a rendus par la découverte du fluor et l’introduction du four électrique qui porte son nom dans le service de la science","en reconnaissance des services extraordinaires qu’il a rendus par son travail sur la synthèse des sucres et des purines","en reconnaissance des services qu’il a rendus à l’avancement de la chimie organique et de l’industrie chimique par ses travaux sur les colorants organiques et les composés hydroaromatiques"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10111: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Adolf von Baeyer a-t-il reçu le Prix Nobel en 1905 ?",
      answers: ["Physiologie ou Médecine","Chimie","Physique","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10112: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Robert Koch a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour ses recherches et découvertes concernant la tuberculose ?",
      answers: ["1904","1907","1903","1905"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10113: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1905 pour ses recherches et découvertes concernant la tuberculose ?",
      answers: ["Robert Koch","Joseph E. Murray","Gerhard Domagk","Howard M. Temin"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10114: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Robert Koch a-t-il reçu le Prix Nobel en 1905 ?",
      answers: ["pour sa découverte relative à la production de chaleur dans les muscles","pour ses recherches et découvertes concernant la tuberculose","pour son travail sur la physiologie et la pathologie de l’appareil vestibulaire","pour leurs découvertes concernant la transmission chimique des impulsions nerveuses"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10115: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Robert Koch a-t-il reçu le Prix Nobel en 1905 ?",
      answers: ["Physique","Physiologie ou Médecine","Paix","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10116: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Henryk Sienkiewicz a-t-il reçu le Prix Nobel de Littérature en raison de ses mérites exceptionnels en tant qu’écrivain épique ?",
      answers: ["1920","1906","1905","1921"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10117: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1905 en raison de ses mérites exceptionnels en tant qu’écrivain épique ?",
      answers: ["Czesław Miłosz","Henryk Sienkiewicz","Giosuè Carducci","Selma Lagerlöf"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10118: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Henryk Sienkiewicz a-t-il reçu le Prix Nobel en 1905 ?",
      answers: ["en appréciation de l’idéalisme élevé, de l’imagination vive et de la perception spirituelle qui caractérisent ses écrits","en raison de ses mérites exceptionnels en tant qu’écrivain épique","pour sa poésie lyrique, qui constitue un exemple de haute spiritualité et de pureté artistique en langue espagnole","pour ses romans et nouvelles, dans lesquels le fantastique et le réaliste se combinent dans un monde richement composé d’imagination"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10119: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Henryk Sienkiewicz a-t-il reçu le Prix Nobel en 1905 ?",
      answers: ["Physiologie ou Médecine","Littérature","Chimie","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10120: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Baronne Bertha von Suttner a-t-il reçu le Prix Nobel de Paix pour son roman 'Quand les armes se taisent' et son travail en faveur de la paix ?",
      answers: ["2005","1902","1905","1910"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10121: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1905 pour son roman 'Quand les armes se taisent' et son travail en faveur de la paix ?",
      answers: ["Comité International de la Croix-Rouge","Institut de Droit International","Baronne Bertha von Suttner","Sir William R. Cremer"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10122: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Baronne Bertha von Suttner a-t-il reçu le Prix Nobel en 1905 ?",
      answers: ["pour son roman 'Quand les armes se taisent' et son travail en faveur de la paix","pour son travail de longue date en faveur de la paix et de l’arbitrage international","pour son rôle dans la négociation de la paix dans la guerre russo-japonaise","pour ses efforts en faveur de la paix et de la diplomatie internationale"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10123: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Baronne Bertha von Suttner a-t-il reçu le Prix Nobel en 1905 ?",
      answers: ["Physiologie ou Médecine","Physique","Paix","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10124: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Joseph J. Thomson a-t-il reçu le Prix Nobel de Physique en reconnaissance des grands mérites de ses recherches théoriques et expérimentales sur la conduction de l’électricité par les gaz ?",
      answers: ["1905","1908","1907","1906"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10125: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1906 en reconnaissance des grands mérites de ses recherches théoriques et expérimentales sur la conduction de l’électricité par les gaz ?",
      answers: ["Antoine H. Becquerel","Max Planck","Joseph J. Thomson","James Franck"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10126: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Joseph J. Thomson a-t-il reçu le Prix Nobel en 1906 ?",
      answers: ["en reconnaissance des services extraordinaires qu’il a rendus par la découverte des rayons remarquables qui portent son nom","pour sa contribution au développement de la méthode des faisceaux moléculaires et sa découverte du moment magnétique du proton","pour leurs recherches pionnières en astrophysique radio : Hewish pour son rôle décisif dans la découverte des pulsars","en reconnaissance des grands mérites de ses recherches théoriques et expérimentales sur la conduction de l’électricité par les gaz"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10127: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Joseph J. Thomson a-t-il reçu le Prix Nobel en 1906 ?",
      answers: ["Littérature","Chimie","Physique","Paix"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10128: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Henri Moissan a-t-il reçu le Prix Nobel de Chimie en reconnaissance des grands services qu’il a rendus par la découverte du fluor et l’introduction du four électrique qui porte son nom dans le service de la science ?",
      answers: ["1977","1907","1903","1906"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10129: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1906 en reconnaissance des grands services qu’il a rendus par la découverte du fluor et l’introduction du four électrique qui porte son nom dans le service de la science ?",
      answers: ["Adolf von Baeyer","Henri Moissan","William H. Stein","John E. Walker"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10130: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Henri Moissan a-t-il reçu le Prix Nobel en 1906 ?",
      answers: ["pour ses recherches biochimiques et sa découverte de la fermentation sans cellules","en reconnaissance des grands services qu’il a rendus par la découverte du fluor et l’introduction du four électrique qui porte son nom dans le service de la science","en reconnaissance des services qu’il a rendus à l’avancement de la chimie organique et de l’industrie chimique par ses travaux sur les colorants organiques et les composés hydroaromatiques","pour des études sur la structure et la fonction du ribosome"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10131: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Henri Moissan a-t-il reçu le Prix Nobel en 1906 ?",
      answers: ["Physique","Chimie","Littérature","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10132: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Camillo Golgi a-t-il reçu le Prix Nobel de Physiologie ou Médecine en reconnaissance de leurs travaux sur la structure du système nerveux ?",
      answers: ["1903","1922","1986","1906"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10133: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1906 en reconnaissance de leurs travaux sur la structure du système nerveux ?",
      answers: ["Allvar Gullstrand","Camillo Golgi","Jacques Monod","Élie Metchnikoff"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10134: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Camillo Golgi a-t-il reçu le Prix Nobel en 1906 ?",
      answers: ["pour ses recherches et découvertes concernant la tuberculose","pour la découverte des enzymes de restriction et leur application aux problèmes de génétique moléculaire","en reconnaissance de leurs travaux sur la structure du système nerveux","pour la découverte du rôle joué par le sinus et les mécanismes aortiques dans la régulation de la respiration"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10135: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Camillo Golgi a-t-il reçu le Prix Nobel en 1906 ?",
      answers: ["Physiologie ou Médecine","Paix","Littérature","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10136: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Santiago Ramón y Cajal a-t-il reçu le Prix Nobel de Physiologie ou Médecine en reconnaissance de leurs travaux sur la structure du système nerveux ?",
      answers: ["1906","1921","1920","1908"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10137: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1906 en reconnaissance de leurs travaux sur la structure du système nerveux ?",
      answers: ["Camillo Golgi","Arthur Kornberg","Sir Martin J. Evans","Santiago Ramón y Cajal"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10138: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Santiago Ramón y Cajal a-t-il reçu le Prix Nobel en 1906 ?",
      answers: ["en reconnaissance de leurs travaux sur la structure du système nerveux","en reconnaissance de ses travaux sur le rôle joué par les protozoaires dans la causation des maladies","en reconnaissance de sa contribution au traitement des maladies, en particulier le lupus vulgaris, par la thérapie par la lumière concentrée","pour leurs découvertes concernant la spécificité de la réponse immunitaire à médiation cellulaire"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10139: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Santiago Ramón y Cajal a-t-il reçu le Prix Nobel en 1906 ?",
      answers: ["Physiologie ou Médecine","Sciences Économiques","Paix","Littérature"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10140: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Giosuè Carducci a-t-il reçu le Prix Nobel de Littérature non seulement en considération de son érudition profonde et de ses recherches critiques, mais surtout en hommage à l’énergie créatrice et à la pureté du style de ses chefs-d’œuvre poétiques ?",
      answers: ["1904","1906","1901","1915"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10141: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1906 non seulement en considération de son érudition profonde et de ses recherches critiques, mais surtout en hommage à l’énergie créatrice et à la pureté du style de ses chefs-d’œuvre poétiques ?",
      answers: ["Bjørnstjerne Bjørnson","Knut Pedersen Hamsun","Henryk Sienkiewicz","Giosuè Carducci"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10142: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Giosuè Carducci a-t-il reçu le Prix Nobel en 1906 ?",
      answers: ["en hommage particulier à son œuvre épique, 'Olympischer Frühling'","en reconnaissance de sa quête sérieuse de la vérité, de sa puissance pénétrante de pensée et de son style chaleureux et vivant","non seulement en considération de son érudition profonde et de ses recherches critiques, mais surtout en hommage à l’énergie créatrice et à la pureté du style de ses chefs-d’œuvre poétiques","en appréciation de l’idéalisme élevé, de l’imagination vive et de la perception spirituelle qui caractérisent ses écrits"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10143: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Giosuè Carducci a-t-il reçu le Prix Nobel en 1906 ?",
      answers: ["Chimie","Littérature","Paix","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10144: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Theodore Roosevelt a-t-il reçu le Prix Nobel de Paix pour son rôle dans la négociation de la paix dans la guerre russo-japonaise ?",
      answers: ["1906","1908","1905","1917"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10145: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1906 pour son rôle dans la négociation de la paix dans la guerre russo-japonaise ?",
      answers: ["Baronne Bertha von Suttner","Louis Renault","Jean H. Dunant","Theodore Roosevelt"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10146: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Theodore Roosevelt a-t-il reçu le Prix Nobel en 1906 ?",
      answers: ["pour son rôle dans la négociation de la paix dans la guerre russo-japonaise","pour leurs efforts en faveur de la paix à travers le mouvement pacifiste italien et international","pour son travail de longue date en faveur de la paix et de l’arbitrage international","pour leurs efforts en faveur de la paix à travers le mouvement pacifiste et l’arbitrage international"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10147: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Theodore Roosevelt a-t-il reçu le Prix Nobel en 1906 ?",
      answers: ["Chimie","Sciences Économiques","Paix","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10148: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Albert A. Michelson a-t-il reçu le Prix Nobel de Physique pour ses instruments optiques de précision et les recherches spectroscopiques et métrologiques réalisées avec ceux-ci ?",
      answers: ["1908","1906","1907","1901"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10149: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1907 pour ses instruments optiques de précision et les recherches spectroscopiques et métrologiques réalisées avec ceux-ci ?",
      answers: ["Albert A. Michelson","Johannes D. van der Waals","Louis de Broglie","Pierre Curie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10150: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Albert A. Michelson a-t-il reçu le Prix Nobel en 1907 ?",
      answers: ["en reconnaissance des grands mérites de ses recherches théoriques et expérimentales sur la conduction de l’électricité par les gaz","pour ses recherches sur les densités des gaz les plus importants et pour sa découverte de l’argon en lien avec ces études","pour ses travaux sur l’équation d’état des gaz et des liquides","pour ses instruments optiques de précision et les recherches spectroscopiques et métrologiques réalisées avec ceux-ci"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10151: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Albert A. Michelson a-t-il reçu le Prix Nobel en 1907 ?",
      answers: ["Sciences Économiques","Physique","Chimie","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10152: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Eduard Buchner a-t-il reçu le Prix Nobel de Chimie pour ses recherches biochimiques et sa découverte de la fermentation sans cellules ?",
      answers: ["1914","1909","1907","1905"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10153: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1907 pour ses recherches biochimiques et sa découverte de la fermentation sans cellules ?",
      answers: ["Venkatraman Ramakrishnan","Marie Curie","Eduard Buchner","Henri Moissan"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10154: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Eduard Buchner a-t-il reçu le Prix Nobel en 1907 ?",
      answers: ["pour sa contribution à la compréhension du transfert d’énergie biologique par la formulation de la théorie chimi-osmotique","en reconnaissance des services rendus à l’avancement de la chimie par la découverte des éléments radium et polonium","pour ses contributions à notre connaissance de la chimie des substances radioactives et ses recherches sur l’origine et la nature des isotopes","pour ses recherches biochimiques et sa découverte de la fermentation sans cellules"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10155: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Eduard Buchner a-t-il reçu le Prix Nobel en 1907 ?",
      answers: ["Chimie","Physique","Littérature","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10156: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Charles L. A. Laveran a-t-il reçu le Prix Nobel de Physiologie ou Médecine en reconnaissance de ses travaux sur le rôle joué par les protozoaires dans la causation des maladies ?",
      answers: ["1907","2024","1909","1929"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10157: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1907 en reconnaissance de ses travaux sur le rôle joué par les protozoaires dans la causation des maladies ?",
      answers: ["Charles L. A. Laveran","Élie Metchnikoff","Camillo Golgi","Santiago Ramón y Cajal"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10158: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Charles L. A. Laveran a-t-il reçu le Prix Nobel en 1907 ?",
      answers: ["en reconnaissance de ses travaux sur le rôle joué par les protozoaires dans la causation des maladies","en reconnaissance de leurs travaux sur la structure du système nerveux","pour la découverte des microARN, une nouvelle classe de petites molécules d’ARN qui jouent un rôle crucial dans la régulation génique","pour sa découverte de la vitamine antineuritique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10159: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Charles L. A. Laveran a-t-il reçu le Prix Nobel en 1907 ?",
      answers: ["Physique","Physiologie ou Médecine","Littérature","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10160: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Rudyard Kipling a-t-il reçu le Prix Nobel de Littérature en considération de la puissance d’observation, de l’originalité de l’imagination et de la virilité des idées qui caractérisent les créations de cet auteur mondialement célèbre ?",
      answers: ["1907","1922","1913","1906"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10161: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1907 en considération de la puissance d’observation, de l’originalité de l’imagination et de la virilité des idées qui caractérisent les créations de cet auteur mondialement célèbre ?",
      answers: ["Rabindranath Tagore","Rudyard Kipling","Henryk Sienkiewicz","Rudolf C. Eucken"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10162: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Rudyard Kipling a-t-il reçu le Prix Nobel en 1907 ?",
      answers: ["en considération de la puissance d’observation, de l’originalité de l’imagination et de la virilité des idées qui caractérisent les créations de cet auteur mondialement célèbre","en raison de ses mérites exceptionnels en tant qu’écrivain épique","en reconnaissance de sa signification en tant que représentant éminent d’une nouvelle ère dans notre littérature","pour une écriture passionnée aux vastes horizons, caractérisée par une intelligence sensuelle et une intégrité humaniste"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10163: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Rudyard Kipling a-t-il reçu le Prix Nobel en 1907 ?",
      answers: ["Physiologie ou Médecine","Physique","Sciences Économiques","Littérature"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10164: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Ernesto T. Moneta a-t-il reçu le Prix Nobel de Paix pour leurs efforts en faveur de la paix à travers le mouvement pacifiste italien et international ?",
      answers: ["1907","1943","1986","1915"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10165: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1907 pour leurs efforts en faveur de la paix à travers le mouvement pacifiste italien et international ?",
      answers: ["Louis Renault","Fridtjof Nansen","Anwar Sadat","Ernesto T. Moneta"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10166: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Ernesto T. Moneta a-t-il reçu le Prix Nobel en 1907 ?",
      answers: ["pour leurs efforts en faveur de la paix à travers le mouvement pacifiste italien et international","pour ses efforts visant à promouvoir la paix à travers la coopération religieuse","pour leurs efforts en faveur de la paix à travers le mouvement pacifiste et l’arbitrage international","pour ses efforts visant à codifier le droit international et à promouvoir la paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10167: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Ernesto T. Moneta a-t-il reçu le Prix Nobel en 1907 ?",
      answers: ["Chimie","Physique","Paix","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10168: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Louis Renault a-t-il reçu le Prix Nobel de Paix pour leurs efforts en faveur de la paix à travers le mouvement pacifiste italien et international ?",
      answers: ["1911","1909","1906","1907"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10169: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1907 pour leurs efforts en faveur de la paix à travers le mouvement pacifiste italien et international ?",
      answers: ["Theodore Roosevelt","Louis Renault","Ernesto T. Moneta","Sir William R. Cremer"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10170: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Louis Renault a-t-il reçu le Prix Nobel en 1907 ?",
      answers: ["pour leurs efforts en faveur de la paix à travers le mouvement pacifiste italien et international","pour leurs contributions à la paix à travers la diplomatie et le mouvement pacifiste","pour leurs contributions à la négociation des accords de Camp David pour la paix au Moyen-Orient","pour leurs efforts en faveur de la paix à travers le mouvement pacifiste et l’arbitrage international"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10171: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Louis Renault a-t-il reçu le Prix Nobel en 1907 ?",
      answers: ["Physiologie ou Médecine","Paix","Chimie","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10172: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Gabriel Lippmann a-t-il reçu le Prix Nobel de Physique pour sa méthode de reproduction des couleurs par photographie basée sur le phénomène d’interférence ?",
      answers: ["1908","1905","1910","1906"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10173: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1908 pour sa méthode de reproduction des couleurs par photographie basée sur le phénomène d’interférence ?",
      answers: ["Johannes D. van der Waals","Anton Zeilinger","Gabriel Lippmann","Albert A. Michelson"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10174: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Gabriel Lippmann a-t-il reçu le Prix Nobel en 1908 ?",
      answers: ["en reconnaissance des services extraordinaires qu’ils ont rendus conjointement par leurs recherches sur les phénomènes de rayonnement découverts par le professeur Henri Becquerel","pour sa méthode de reproduction des couleurs par photographie basée sur le phénomène d’interférence","pour des expériences avec des photons intriqués, établissant la violation des inégalités de Bell et ouvrant la voie à la science de l’information quantique","pour la découverte de nouvelles formes productives de la théorie atomique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10175: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Gabriel Lippmann a-t-il reçu le Prix Nobel en 1908 ?",
      answers: ["Physique","Physiologie ou Médecine","Chimie","Littérature"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10176: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Ernest Rutherford a-t-il reçu le Prix Nobel de Chimie pour ses recherches sur la désintégration des éléments et la chimie des substances radioactives ?",
      answers: ["1908","1907","1918","1928"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10177: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1908 pour ses recherches sur la désintégration des éléments et la chimie des substances radioactives ?",
      answers: ["Ahmed H. Zewail","Eduard Buchner","Ernest Rutherford","Otto Wallach"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10178: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Ernest Rutherford a-t-il reçu le Prix Nobel en 1908 ?",
      answers: ["pour ses recherches sur la désintégration des éléments et la chimie des substances radioactives","en reconnaissance des services extraordinaires qu’il a rendus par son travail sur la synthèse des sucres et des purines","pour la découverte du réactif de Grignard, qui a grandement contribué au développement de la chimie organique","en reconnaissance des services qu’il a rendus à l’avancement de la chimie organique et de l’industrie chimique par ses travaux sur les colorants organiques et les composés hydroaromatiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10179: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Ernest Rutherford a-t-il reçu le Prix Nobel en 1908 ?",
      answers: ["Paix","Physique","Littérature","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10180: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Paul Ehrlich a-t-il reçu le Prix Nobel de Physiologie ou Médecine en reconnaissance de leurs travaux sur l’immunité ?",
      answers: ["1922","1904","1908","1901"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10181: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1908 en reconnaissance de leurs travaux sur l’immunité ?",
      answers: ["Paul Ehrlich","Severo Ochoa","Élie Metchnikoff","John O’Keefe"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10182: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Paul Ehrlich a-t-il reçu le Prix Nobel en 1908 ?",
      answers: ["en reconnaissance de leurs travaux sur l’immunité","pour leur découverte des mécanismes de la synthèse biologique de l’acide ribonucléique et de l’acide désoxyribonucléique","en reconnaissance de leurs travaux sur la structure du système nerveux","pour leur découverte de la thérapie du cancer par inhibition de la régulation immunitaire négative"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10183: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Paul Ehrlich a-t-il reçu le Prix Nobel en 1908 ?",
      answers: ["Physique","Physiologie ou Médecine","Paix","Littérature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10184: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Élie Metchnikoff a-t-il reçu le Prix Nobel de Physiologie ou Médecine en reconnaissance de leurs travaux sur l’immunité ?",
      answers: ["1908","1922","1924","1905"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10185: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1908 en reconnaissance de leurs travaux sur l’immunité ?",
      answers: ["Emil T. Kocher","Yoshinori Ohsumi","Paul Ehrlich","Élie Metchnikoff"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10186: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Élie Metchnikoff a-t-il reçu le Prix Nobel en 1908 ?",
      answers: ["pour son travail sur la physiologie et la pathologie de l’appareil vestibulaire","pour ses travaux sur la physiologie, la pathologie et la chirurgie de la glande thyroïde","en reconnaissance de leurs travaux sur l’immunité","pour ses travaux sur le typhus"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10187: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Élie Metchnikoff a-t-il reçu le Prix Nobel en 1908 ?",
      answers: ["Chimie","Physiologie ou Médecine","Physique","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10188: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Rudolf C. Eucken a-t-il reçu le Prix Nobel de Littérature en reconnaissance de sa quête sérieuse de la vérité, de sa puissance pénétrante de pensée et de son style chaleureux et vivant ?",
      answers: ["1911","1910","1908","1932"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10189: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1908 en reconnaissance de sa quête sérieuse de la vérité, de sa puissance pénétrante de pensée et de son style chaleureux et vivant ?",
      answers: ["Rudolf C. Eucken","José Echegaray","Rabindranath Tagore","George Bernard Shaw"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10190: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Rudolf C. Eucken a-t-il reçu le Prix Nobel en 1908 ?",
      answers: ["en appréciation de l’idéalisme élevé, de l’imagination vive et de la perception spirituelle qui caractérisent ses écrits","pour la puissance, l’honnêteté et les émotions profondes de ses œuvres dramatiques, qui incarnent un concept original de la tragédie","pour son art narratif passionné qui, enraciné dans la culture et les traditions juives polonaises, donne une portée universelle à la condition humaine","en reconnaissance de sa quête sérieuse de la vérité, de sa puissance pénétrante de pensée et de son style chaleureux et vivant"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10191: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Rudolf C. Eucken a-t-il reçu le Prix Nobel en 1908 ?",
      answers: ["Paix","Physique","Chimie","Littérature"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10192: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Klas P. Arnoldson a-t-il reçu le Prix Nobel de Paix pour leurs efforts en faveur de la paix à travers le mouvement pacifiste et l’arbitrage international ?",
      answers: ["1910","1915","1908","1927"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10193: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1908 pour leurs efforts en faveur de la paix à travers le mouvement pacifiste et l’arbitrage international ?",
      answers: ["Klas P. Arnoldson","Grameen Bank","Louis Renault","Campagne Internationale pour l’Interdiction des Mines Antipersonnel (ICBL)"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10194: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Klas P. Arnoldson a-t-il reçu le Prix Nobel en 1908 ?",
      answers: ["pour leur rôle dans la promotion du droit international et de l’arbitrage","pour son travail dans la rédaction de la Déclaration universelle des droits de l’homme","pour leur travail en faveur d’un monde mieux organisé et plus pacifique","pour leurs efforts en faveur de la paix à travers le mouvement pacifiste et l’arbitrage international"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10195: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Klas P. Arnoldson a-t-il reçu le Prix Nobel en 1908 ?",
      answers: ["Paix","Physique","Littérature","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10196: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Fredrik Bajer a-t-il reçu le Prix Nobel de Paix pour leurs efforts en faveur de la paix à travers le mouvement pacifiste et l’arbitrage international ?",
      answers: ["1902","1908","1907","1901"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10197: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1908 pour leurs efforts en faveur de la paix à travers le mouvement pacifiste et l’arbitrage international ?",
      answers: ["Paul H.B. d’Estournelles de Constant","Jean H. Dunant","Auguste Beernaert","Fredrik Bajer"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10198: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Fredrik Bajer a-t-il reçu le Prix Nobel en 1908 ?",
      answers: ["pour leurs efforts en faveur de la paix à travers le mouvement pacifiste et l’arbitrage international","pour leurs efforts visant à empêcher l’utilisation militaire de l’énergie nucléaire et à promouvoir son usage pacifique","pour leurs efforts en faveur de la paix à travers le mouvement pacifiste italien et international","pour son roman 'Quand les armes se taisent' et son travail en faveur de la paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10199: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Fredrik Bajer a-t-il reçu le Prix Nobel en 1908 ?",
      answers: ["Physiologie ou Médecine","Chimie","Physique","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10200: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Guglielmo Marconi a-t-il reçu le Prix Nobel de Physique en reconnaissance de leurs contributions au développement de la télégraphie sans fil ?",
      answers: ["1916","1925","1909","1926"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10201: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1909 en reconnaissance de leurs contributions au développement de la télégraphie sans fil ?",
      answers: ["Guglielmo Marconi","Gabriel Lippmann","James Franck","Pyotr Kapitsa"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10202: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Guglielmo Marconi a-t-il reçu le Prix Nobel en 1909 ?",
      answers: ["en reconnaissance de leurs contributions au développement de la télégraphie sans fil","pour ses recherches sur les densités des gaz les plus importants et pour sa découverte de l’argon en lien avec ces études","pour sa découverte de la loi de l’effet photoélectrique","pour ses travaux sur l’équation d’état des gaz et des liquides"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10203: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Guglielmo Marconi a-t-il reçu le Prix Nobel en 1909 ?",
      answers: ["Physiologie ou Médecine","Physique","Paix","Littérature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10204: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Carl F. Braun a-t-il reçu le Prix Nobel de Physique en reconnaissance de leurs contributions au développement de la télégraphie sans fil ?",
      answers: ["1938","1943","1909","2000"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10205: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1909 en reconnaissance de leurs contributions au développement de la télégraphie sans fil ?",
      answers: ["Wilhelm Wien","Carl F. Braun","Lord Rayleigh (John W. Strutt)","Guglielmo Marconi"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10206: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Carl F. Braun a-t-il reçu le Prix Nobel en 1909 ?",
      answers: ["pour ses découvertes concernant les lois régissant le rayonnement thermique","pour ses instruments optiques de précision et les recherches spectroscopiques et métrologiques réalisées avec ceux-ci","pour son invention de régulateurs automatiques destinés à être utilisés avec des accumulateurs de gaz pour l’éclairage des phares et des bouées","en reconnaissance de leurs contributions au développement de la télégraphie sans fil"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10207: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Carl F. Braun a-t-il reçu le Prix Nobel en 1909 ?",
      answers: ["Chimie","Physiologie ou Médecine","Littérature","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10208: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Wilhelm Ostwald a-t-il reçu le Prix Nobel de Chimie en reconnaissance de ses travaux sur la catalyse et pour ses recherches sur les principes fondamentaux régissant l’équilibre chimique et les vitesses de réaction ?",
      answers: ["1904","1917","1909","1957"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10209: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1909 en reconnaissance de ses travaux sur la catalyse et pour ses recherches sur les principes fondamentaux régissant l’équilibre chimique et les vitesses de réaction ?",
      answers: ["Bernard L. Feringa","Otto Wallach","Wilhelm Ostwald","Eduard Buchner"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10210: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Wilhelm Ostwald a-t-il reçu le Prix Nobel en 1909 ?",
      answers: ["pour la découverte du réactif de Grignard, qui a grandement contribué au développement de la chimie organique","pour son travail sur l’utilisation des isotopes comme traceurs dans l’étude des processus chimiques","en reconnaissance de ses travaux sur la catalyse et pour ses recherches sur les principes fondamentaux régissant l’équilibre chimique et les vitesses de réaction","pour ses recherches et inventions en chimie agricole et alimentaire, en particulier pour sa méthode de conservation du fourrage"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10211: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Wilhelm Ostwald a-t-il reçu le Prix Nobel en 1909 ?",
      answers: ["Paix","Physique","Physiologie ou Médecine","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10212: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Emil T. Kocher a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour ses travaux sur la physiologie, la pathologie et la chirurgie de la glande thyroïde ?",
      answers: ["1908","1904","1909","1910"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10213: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1909 pour ses travaux sur la physiologie, la pathologie et la chirurgie de la glande thyroïde ?",
      answers: ["Emil T. Kocher","Charles L. A. Laveran","Santiago Ramón y Cajal","Niels R. Finsen"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10214: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Emil T. Kocher a-t-il reçu le Prix Nobel en 1909 ?",
      answers: ["pour sa découverte du mécanisme de l’électrocardiogramme","en reconnaissance de son travail sur la suture vasculaire et la transplantation d’organes et de vaisseaux sanguins","pour ses travaux sur la physiologie, la pathologie et la chirurgie de la glande thyroïde","pour leurs découvertes concernant le monoxyde d’azote comme molécule de signalisation dans le système cardiovasculaire"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10215: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Emil T. Kocher a-t-il reçu le Prix Nobel en 1909 ?",
      answers: ["Chimie","Littérature","Physiologie ou Médecine","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10216: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Selma Lagerlöf a-t-il reçu le Prix Nobel de Littérature en appréciation de l’idéalisme élevé, de l’imagination vive et de la perception spirituelle qui caractérisent ses écrits ?",
      answers: ["1909","1912","1938","1904"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10217: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1909 en appréciation de l’idéalisme élevé, de l’imagination vive et de la perception spirituelle qui caractérisent ses écrits ?",
      answers: ["Rudyard Kipling","Pearl Buck","Selma Lagerlöf","Carl Spitteler"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10218: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Selma Lagerlöf a-t-il reçu le Prix Nobel en 1909 ?",
      answers: ["en reconnaissance de l’originalité fraîche et de la véritable inspiration de sa production poétique, qui reflète fidèlement les paysages naturels et l’esprit natif de son peuple","pour sa poésie variée et riche, inspirée par de hauts idéaux","en hommage à l’art consommé, pénétré d’idéalisme, qu’il a démontré tout au long de sa longue carrière productive","en appréciation de l’idéalisme élevé, de l’imagination vive et de la perception spirituelle qui caractérisent ses écrits"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10219: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Selma Lagerlöf a-t-il reçu le Prix Nobel en 1909 ?",
      answers: ["Littérature","Physique","Chimie","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10220: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Auguste Beernaert a-t-il reçu le Prix Nobel de Paix pour leurs contributions à la paix à travers la diplomatie et le mouvement pacifiste ?",
      answers: ["1910","1909","1902","1929"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10221: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1909 pour leurs contributions à la paix à travers la diplomatie et le mouvement pacifiste ?",
      answers: ["Auguste Beernaert","Frédéric Passy","Bureau International Permanent de la Paix","Paul H.B. d’Estournelles de Constant"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10222: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Auguste Beernaert a-t-il reçu le Prix Nobel en 1909 ?",
      answers: ["pour sa contribution décisive à la construction d’une démocratie pluraliste en Tunisie après la Révolution du Jasmin de 2011","pour leurs contributions à la paix à travers la diplomatie et le mouvement pacifiste","pour son rôle dans la négociation de la paix dans la guerre russo-japonaise","pour son rôle dans la création de la Société des Nations et ses efforts pour la paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10223: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Auguste Beernaert a-t-il reçu le Prix Nobel en 1909 ?",
      answers: ["Chimie","Sciences Économiques","Physique","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10224: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Paul H.B. d’Estournelles de Constant a-t-il reçu le Prix Nobel de Paix pour leurs contributions à la paix à travers la diplomatie et le mouvement pacifiste ?",
      answers: ["1972","1911","2020","1909"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10225: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1909 pour leurs contributions à la paix à travers la diplomatie et le mouvement pacifiste ?",
      answers: ["Paul H.B. d’Estournelles de Constant","Ernesto T. Moneta","Frédéric Passy","Tobias M.C. Asser"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10226: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Paul H.B. d’Estournelles de Constant a-t-il reçu le Prix Nobel en 1909 ?",
      answers: ["pour leurs contributions à la paix à travers la diplomatie et le mouvement pacifiste","pour leurs efforts en faveur de la paix en tant que leaders du mouvement pacifiste international","pour leurs efforts en faveur de la paix à travers le mouvement pacifiste et l’arbitrage international","pour son rôle dans la médiation de la paix entre le Paraguay et la Bolivie lors de la guerre du Chaco"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10227: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Paul H.B. d’Estournelles de Constant a-t-il reçu le Prix Nobel en 1909 ?",
      answers: ["Physiologie ou Médecine","Physique","Paix","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10228: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Johannes D. van der Waals a-t-il reçu le Prix Nobel de Physique pour ses travaux sur l’équation d’état des gaz et des liquides ?",
      answers: ["1910","1908","1958","1911"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10229: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1910 pour ses travaux sur l’équation d’état des gaz et des liquides ?",
      answers: ["Herbert Kroemer","Guglielmo Marconi","Dennis Gabor","Johannes D. van der Waals"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10230: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Johannes D. van der Waals a-t-il reçu le Prix Nobel en 1910 ?",
      answers: ["pour la découverte et l’interprétation de l’effet Cherenkov","pour leurs travaux fondamentaux dans le domaine de l’électronique quantique, qui ont conduit à la construction d’oscillateurs et d’amplificateurs basés sur le principe du maser-laser","pour sa découverte de l’effet Doppler dans les rayons canaux et de la séparation des lignes spectrales dans les champs électriques","pour ses travaux sur l’équation d’état des gaz et des liquides"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10231: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Johannes D. van der Waals a-t-il reçu le Prix Nobel en 1910 ?",
      answers: ["Physique","Sciences Économiques","Littérature","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10232: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Otto Wallach a-t-il reçu le Prix Nobel de Chimie en reconnaissance des services qu’il a rendus à la chimie organique et à l’industrie chimique par ses travaux pionniers dans le domaine des composés alicycliques ?",
      answers: ["1910","1909","1903","1911"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10233: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1910 en reconnaissance des services qu’il a rendus à la chimie organique et à l’industrie chimique par ses travaux pionniers dans le domaine des composés alicycliques ?",
      answers: ["Fritz Haber","Otto Wallach","Richard M. Willstätter","George P. Smith"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10234: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Otto Wallach a-t-il reçu le Prix Nobel en 1910 ?",
      answers: ["en reconnaissance de ses travaux sur la catalyse et pour ses recherches sur les principes fondamentaux régissant l’équilibre chimique et les vitesses de réaction","pour son travail sur la ribonucléase, en particulier concernant la connexion entre la séquence d’acides aminés et la conformation biologiquement active","en reconnaissance des services qu’il a rendus à la chimie organique et à l’industrie chimique par ses travaux pionniers dans le domaine des composés alicycliques","pour ses contributions à notre connaissance de la structure moléculaire par ses recherches sur les moments dipolaires et la diffraction des rayons X et des électrons dans les gaz"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10235: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Otto Wallach a-t-il reçu le Prix Nobel en 1910 ?",
      answers: ["Chimie","Physique","Paix","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10236: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Albrecht Kossel a-t-il reçu le Prix Nobel de Physiologie ou Médecine en reconnaissance de ses contributions à notre connaissance de la chimie cellulaire par ses travaux sur les protéines, y compris les substances nucléiques ?",
      answers: ["1917","1966","1982","1910"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10237: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1910 en reconnaissance de ses contributions à notre connaissance de la chimie cellulaire par ses travaux sur les protéines, y compris les substances nucléiques ?",
      answers: ["George Wald","May-Britt Moser","Albrecht Kossel","Charles R. Richet"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10238: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Albrecht Kossel a-t-il reçu le Prix Nobel en 1910 ?",
      answers: ["pour leurs découvertes de principes importants pour le traitement médicamenteux","pour la découverte de la manière dont les chromosomes sont protégés par les télomères et l’enzyme télomérase","en reconnaissance de ses contributions à notre connaissance de la chimie cellulaire par ses travaux sur les protéines, y compris les substances nucléiques","pour ses travaux sur la dioptrique de l’œil"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10239: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Albrecht Kossel a-t-il reçu le Prix Nobel en 1910 ?",
      answers: ["Physiologie ou Médecine","Sciences Économiques","Physique","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10240: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Paul J.L. Heyse a-t-il reçu le Prix Nobel de Littérature en hommage à l’art consommé, pénétré d’idéalisme, qu’il a démontré tout au long de sa longue carrière productive ?",
      answers: ["1911","1902","1964","1910"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10241: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1910 en hommage à l’art consommé, pénétré d’idéalisme, qu’il a démontré tout au long de sa longue carrière productive ?",
      answers: ["Roger Martin du Gard","Maurice Maeterlinck","Paul J.L. Heyse","Rudolf C. Eucken"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10242: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Paul J.L. Heyse a-t-il reçu le Prix Nobel en 1910 ?",
      answers: ["en hommage à l’art consommé, pénétré d’idéalisme, qu’il a démontré tout au long de sa longue carrière productive","en raison de ses mérites exceptionnels en tant qu’écrivain épique","pour sa poésie variée et riche, inspirée par de hauts idéaux","pour ses écrits qui, par leur combinaison d’une large perspective sur son temps et une habileté sensible dans la caractérisation, ont contribué au renouveau de la littérature allemande"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10243: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Paul J.L. Heyse a-t-il reçu le Prix Nobel en 1910 ?",
      answers: ["Physiologie ou Médecine","Littérature","Sciences Économiques","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10244: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Bureau International Permanent de la Paix a-t-il reçu le Prix Nobel de Paix pour son rôle de centre du mouvement pacifiste international ?",
      answers: ["1910","1908","1907","1909"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10245: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1910 pour son rôle de centre du mouvement pacifiste international ?",
      answers: ["Louis Renault","Bureau International Permanent de la Paix","Theodore Roosevelt","Comité International de la Croix-Rouge"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10246: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Bureau International Permanent de la Paix a-t-il reçu le Prix Nobel en 1910 ?",
      answers: ["pour leur rôle dans la promotion du droit international et de l’arbitrage","pour leurs efforts visant à sauvegarder la liberté d’expression, condition préalable à la démocratie et à une paix durable","pour son rôle de centre du mouvement pacifiste international","pour son travail humanitaire pendant la Première Guerre mondiale"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10247: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Bureau International Permanent de la Paix a-t-il reçu le Prix Nobel en 1910 ?",
      answers: ["Physique","Physiologie ou Médecine","Paix","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10248: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Wilhelm Wien a-t-il reçu le Prix Nobel de Physique pour ses découvertes concernant les lois régissant le rayonnement thermique ?",
      answers: ["1917","1909","1974","1911"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10249: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1911 pour ses découvertes concernant les lois régissant le rayonnement thermique ?",
      answers: ["Carl F. Braun","Werner Heisenberg","Nils G. Dalén","Wilhelm Wien"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10250: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Wilhelm Wien a-t-il reçu le Prix Nobel en 1911 ?",
      answers: ["pour son invention de régulateurs automatiques destinés à être utilisés avec des accumulateurs de gaz pour l’éclairage des phares et des bouées","pour sa découverte de la diffraction des rayons X par les cristaux","en reconnaissance des services extraordinaires qu’ils ont rendus par leurs recherches sur l’influence du magnétisme sur les phénomènes de rayonnement","pour ses découvertes concernant les lois régissant le rayonnement thermique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10251: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Wilhelm Wien a-t-il reçu le Prix Nobel en 1911 ?",
      answers: ["Physique","Littérature","Physiologie ou Médecine","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10252: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Marie Curie a-t-il reçu le Prix Nobel de Chimie en reconnaissance des services rendus à l’avancement de la chimie par la découverte des éléments radium et polonium ?",
      answers: ["1911","1914","1992","1913"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10253: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1911 en reconnaissance des services rendus à l’avancement de la chimie par la découverte des éléments radium et polonium ?",
      answers: ["Marie Curie","Adolf von Baeyer","Frederick Soddy","Otto Wallach"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10254: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Marie Curie a-t-il reçu le Prix Nobel en 1911 ?",
      answers: ["en reconnaissance des services rendus à l’avancement de la chimie par la découverte des éléments radium et polonium","pour leurs études sur les structures des protéines globulaires","pour son travail sur l’utilisation des isotopes comme traceurs dans l’étude des processus chimiques","en reconnaissance de ses déterminations précises des poids atomiques de nombreux éléments chimiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10255: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Marie Curie a-t-il reçu le Prix Nobel en 1911 ?",
      answers: ["Paix","Physiologie ou Médecine","Physique","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10256: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Allvar Gullstrand a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour ses travaux sur la dioptrique de l’œil ?",
      answers: ["1931","1912","1908","1911"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10257: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1911 pour ses travaux sur la dioptrique de l’œil ?",
      answers: ["Albrecht Kossel","Alexis Carrel","Allvar Gullstrand","Charles R. Richet"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10258: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Allvar Gullstrand a-t-il reçu le Prix Nobel en 1911 ?",
      answers: ["pour ses découvertes concernant le rôle des chromosomes dans l’hérédité","pour leurs découvertes concernant la thérapie par le foie dans les cas d’anémie","pour ses travaux sur la dioptrique de l’œil","en reconnaissance de ses travaux sur le rôle joué par les protozoaires dans la causation des maladies"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10259: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Allvar Gullstrand a-t-il reçu le Prix Nobel en 1911 ?",
      answers: ["Physiologie ou Médecine","Littérature","Chimie","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10260: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Maurice Maeterlinck a-t-il reçu le Prix Nobel de Littérature en appréciation de ses activités littéraires multiformes, et en particulier de ses œuvres dramatiques, qui se distinguent par une richesse d’imagination ?",
      answers: ["1964","1911","1913","1986"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10261: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1911 en appréciation de ses activités littéraires multiformes, et en particulier de ses œuvres dramatiques, qui se distinguent par une richesse d’imagination ?",
      answers: ["Gerhart Hauptmann","Gabriela Mistral","Selma Lagerlöf","Maurice Maeterlinck"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10262: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Maurice Maeterlinck a-t-il reçu le Prix Nobel en 1911 ?",
      answers: ["en appréciation de l’idéalisme élevé, de l’imagination vive et de la perception spirituelle qui caractérisent ses écrits","non seulement en considération de son érudition profonde et de ses recherches critiques, mais surtout en hommage à l’énergie créatrice et à la pureté du style de ses chefs-d’œuvre poétiques","en appréciation de ses activités littéraires multiformes, et en particulier de ses œuvres dramatiques, qui se distinguent par une richesse d’imagination","en hommage particulier à son œuvre épique, 'Olympischer Frühling'"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10263: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Maurice Maeterlinck a-t-il reçu le Prix Nobel en 1911 ?",
      answers: ["Chimie","Sciences Économiques","Physiologie ou Médecine","Littérature"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10264: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Tobias M.C. Asser a-t-il reçu le Prix Nobel de Paix pour leur rôle dans la promotion du droit international et de l’arbitrage ?",
      answers: ["1910","1931","1911","1906"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10265: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1911 pour leur rôle dans la promotion du droit international et de l’arbitrage ?",
      answers: ["Tobias M.C. Asser","Baronne Bertha von Suttner","Woodrow Wilson","Ernesto T. Moneta"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10266: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Tobias M.C. Asser a-t-il reçu le Prix Nobel en 1911 ?",
      answers: ["pour leurs contributions à la paix à travers la diplomatie et le mouvement pacifiste","pour leurs efforts en faveur de la paix à travers le mouvement pacifiste italien et international","pour son travail de longue date en faveur de la paix et de l’arbitrage international","pour leur rôle dans la promotion du droit international et de l’arbitrage"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10267: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Tobias M.C. Asser a-t-il reçu le Prix Nobel en 1911 ?",
      answers: ["Physique","Physiologie ou Médecine","Paix","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10268: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Alfred H. Fried a-t-il reçu le Prix Nobel de Paix pour leur rôle dans la promotion du droit international et de l’arbitrage ?",
      answers: ["1960","1911","1915","1902"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10269: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1911 pour leur rôle dans la promotion du droit international et de l’arbitrage ?",
      answers: ["Klas P. Arnoldson","Alfred H. Fried","Norman Borlaug","Charles A. Gobat"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10270: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Alfred H. Fried a-t-il reçu le Prix Nobel en 1911 ?",
      answers: ["pour leur travail visant à interdire et éliminer les mines antipersonnel","pour leur rôle dans la promotion du droit international et de l’arbitrage","pour leurs négociations conjointes ayant conduit à un cessez-le-feu au Vietnam","pour leurs efforts en faveur de la paix à travers le mouvement pacifiste et l’arbitrage international"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10271: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Alfred H. Fried a-t-il reçu le Prix Nobel en 1911 ?",
      answers: ["Paix","Physiologie ou Médecine","Littérature","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10272: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Nils G. Dalén a-t-il reçu le Prix Nobel de Physique pour son invention de régulateurs automatiques destinés à être utilisés avec des accumulateurs de gaz pour l’éclairage des phares et des bouées ?",
      answers: ["1912","1918","1930","1948"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10273: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1912 pour son invention de régulateurs automatiques destinés à être utilisés avec des accumulateurs de gaz pour l’éclairage des phares et des bouées ?",
      answers: ["Leo Esaki","Aage N. Bohr","Nils G. Dalén","David M. Lee"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10274: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Nils G. Dalén a-t-il reçu le Prix Nobel en 1912 ?",
      answers: ["pour ses recherches sur les propriétés de la matière à basse température, qui ont conduit, entre autres, à la production d’hélium liquide","en reconnaissance des services extraordinaires qu’ils ont rendus conjointement par leurs recherches sur les phénomènes de rayonnement découverts par le professeur Henri Becquerel","pour son invention de régulateurs automatiques destinés à être utilisés avec des accumulateurs de gaz pour l’éclairage des phares et des bouées","pour leurs services dans l’analyse de la structure cristalline au moyen des rayons X"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10275: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Nils G. Dalén a-t-il reçu le Prix Nobel en 1912 ?",
      answers: ["Physique","Chimie","Littérature","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10276: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Victor Grignard a-t-il reçu le Prix Nobel de Chimie pour la découverte du réactif de Grignard, qui a grandement contribué au développement de la chimie organique ?",
      answers: ["1913","1926","1905","1912"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10277: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1912 pour la découverte du réactif de Grignard, qui a grandement contribué au développement de la chimie organique ?",
      answers: ["Victor Grignard","Otto Wallach","Theodor Svedberg","John H. Northrop"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10278: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Victor Grignard a-t-il reçu le Prix Nobel en 1912 ?",
      answers: ["pour ses découvertes dans le domaine de la chimie des macromolécules","pour des études sur la structure et la fonction du ribosome","pour la découverte du réactif de Grignard, qui a grandement contribué au développement de la chimie organique","pour ses contributions à notre connaissance de la chimie des substances radioactives et ses recherches sur l’origine et la nature des isotopes"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10279: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Victor Grignard a-t-il reçu le Prix Nobel en 1912 ?",
      answers: ["Sciences Économiques","Chimie","Physiologie ou Médecine","Littérature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10280: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Paul Sabatier a-t-il reçu le Prix Nobel de Chimie pour sa méthode d’hydrogénation des composés organiques en présence de métaux finement divisés ?",
      answers: ["1901","1921","1912","1909"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10281: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1912 pour sa méthode d’hydrogénation des composés organiques en présence de métaux finement divisés ?",
      answers: ["Adolf O. Windaus","William F. Giauque","Paul Sabatier","K. Barry Sharpless"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10282: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Paul Sabatier a-t-il reçu le Prix Nobel en 1912 ?",
      answers: ["pour la conception et la synthèse de machines moléculaires","pour sa méthode d’hydrogénation des composés organiques en présence de métaux finement divisés","pour la découverte du réactif de Grignard, qui a grandement contribué au développement de la chimie organique","en reconnaissance des services qu’il a rendus à la chimie organique et à l’industrie chimique par ses travaux pionniers dans le domaine des composés alicycliques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10283: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Paul Sabatier a-t-il reçu le Prix Nobel en 1912 ?",
      answers: ["Littérature","Physiologie ou Médecine","Physique","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10284: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Alexis Carrel a-t-il reçu le Prix Nobel de Physiologie ou Médecine en reconnaissance de son travail sur la suture vasculaire et la transplantation d’organes et de vaisseaux sanguins ?",
      answers: ["1906","1910","1911","1912"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10285: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1912 en reconnaissance de son travail sur la suture vasculaire et la transplantation d’organes et de vaisseaux sanguins ?",
      answers: ["Alexis Carrel","Earl W. Sutherland Jr.","Svante Pääbo","Charles R. Richet"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10286: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Alexis Carrel a-t-il reçu le Prix Nobel en 1912 ?",
      answers: ["pour leurs découvertes sur les principes de l’introduction de modifications génétiques spécifiques chez la souris par l’utilisation de cellules souches embryonnaires","pour leurs découvertes concernant les fonctions des neurones","en reconnaissance de son travail sur la suture vasculaire et la transplantation d’organes et de vaisseaux sanguins","pour ses travaux sur la physiologie, la pathologie et la chirurgie de la glande thyroïde"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10287: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Alexis Carrel a-t-il reçu le Prix Nobel en 1912 ?",
      answers: ["Paix","Physiologie ou Médecine","Sciences Économiques","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10288: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Gerhart Hauptmann a-t-il reçu le Prix Nobel de Littérature principalement en reconnaissance de sa production fructueuse, variée et exceptionnelle dans le domaine de l’art dramatique ?",
      answers: ["1961","1908","1924","1912"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10289: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1912 principalement en reconnaissance de sa production fructueuse, variée et exceptionnelle dans le domaine de l’art dramatique ?",
      answers: ["Gerhart Hauptmann","Gabriel García Márquez","Aleksandr Soljenitsyne","Rabindranath Tagore"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10290: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Gerhart Hauptmann a-t-il reçu le Prix Nobel en 1912 ?",
      answers: ["en hommage à l’art consommé, pénétré d’idéalisme, qu’il a démontré tout au long de sa longue carrière productive","en appréciation de l’idéalisme élevé, de l’imagination vive et de la perception spirituelle qui caractérisent ses écrits","principalement en reconnaissance de sa production fructueuse, variée et exceptionnelle dans le domaine de l’art dramatique","en appréciation de ses activités littéraires multiformes, et en particulier de ses œuvres dramatiques, qui se distinguent par une richesse d’imagination"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10291: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Gerhart Hauptmann a-t-il reçu le Prix Nobel en 1912 ?",
      answers: ["Physique","Paix","Chimie","Littérature"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10292: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Elihu Root a-t-il reçu le Prix Nobel de Paix pour ses efforts en faveur de la paix et de la diplomatie internationale ?",
      answers: ["1915","1988","1912","1926"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10293: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1912 pour ses efforts en faveur de la paix et de la diplomatie internationale ?",
      answers: ["Haut-Commissariat des Nations Unies pour les Réfugiés (HCR)","Elihu Root","Fridtjof Nansen","Tobias M.C. Asser"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10294: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Elihu Root a-t-il reçu le Prix Nobel en 1912 ?",
      answers: ["pour son travail humanitaire pendant les périodes de conflit","pour leurs contributions à la paix à travers la diplomatie et le mouvement pacifiste","pour ses efforts en faveur de la paix et de la diplomatie internationale","pour leur rôle dans la promotion du droit international et de l’arbitrage"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10295: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Elihu Root a-t-il reçu le Prix Nobel en 1912 ?",
      answers: ["Paix","Chimie","Physique","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10296: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Heike Kamerlingh Onnes a-t-il reçu le Prix Nobel de Physique pour ses recherches sur les propriétés de la matière à basse température, qui ont conduit, entre autres, à la production d’hélium liquide ?",
      answers: ["1912","1913","1926","1921"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10297: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1913 pour ses recherches sur les propriétés de la matière à basse température, qui ont conduit, entre autres, à la production d’hélium liquide ?",
      answers: ["Heike Kamerlingh Onnes","Nils G. Dalén","Wilhelm C. Röntgen","Owen W. Richardson"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10298: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Heike Kamerlingh Onnes a-t-il reçu le Prix Nobel en 1913 ?",
      answers: ["pour leurs services dans l’analyse de la structure cristalline au moyen des rayons X","pour son invention de régulateurs automatiques destinés à être utilisés avec des accumulateurs de gaz pour l’éclairage des phares et des bouées","pour ses découvertes concernant les lois régissant le rayonnement thermique","pour ses recherches sur les propriétés de la matière à basse température, qui ont conduit, entre autres, à la production d’hélium liquide"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10299: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Heike Kamerlingh Onnes a-t-il reçu le Prix Nobel en 1913 ?",
      answers: ["Chimie","Physiologie ou Médecine","Physique","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10300: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Alfred Werner a-t-il reçu le Prix Nobel de Chimie en reconnaissance de son travail sur la liaison des atomes dans les molécules, par lequel il a ouvert de nouveaux champs en chimie inorganique ?",
      answers: ["1910","1911","1924","1913"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10301: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1913 en reconnaissance de son travail sur la liaison des atomes dans les molécules, par lequel il a ouvert de nouveaux champs en chimie inorganique ?",
      answers: ["Otto Wallach","Paul Sabatier","Jennifer A. Doudna","Alfred Werner"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10302: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Alfred Werner a-t-il reçu le Prix Nobel en 1913 ?",
      answers: ["en reconnaissance de son travail sur la liaison des atomes dans les molécules, par lequel il a ouvert de nouveaux champs en chimie inorganique","en reconnaissance des services rendus à l’avancement de la chimie par la découverte des éléments radium et polonium","en reconnaissance de ses déterminations précises des poids atomiques de nombreux éléments chimiques","en reconnaissance de ses travaux sur la catalyse et pour ses recherches sur les principes fondamentaux régissant l’équilibre chimique et les vitesses de réaction"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10303: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Alfred Werner a-t-il reçu le Prix Nobel en 1913 ?",
      answers: ["Physiologie ou Médecine","Paix","Chimie","Sciences Économiques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10304: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Charles R. Richet a-t-il reçu le Prix Nobel de Physiologie ou Médecine en reconnaissance de son travail sur l’anaphylaxie ?",
      answers: ["1912","1963","1913","1909"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10305: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1913 en reconnaissance de son travail sur l’anaphylaxie ?",
      answers: ["Albrecht Kossel","Allvar Gullstrand","Charles R. Richet","Hans Spemann"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10306: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Charles R. Richet a-t-il reçu le Prix Nobel en 1913 ?",
      answers: ["pour son travail sur la physiologie et la pathologie de l’appareil vestibulaire","en reconnaissance de son travail sur l’anaphylaxie","pour leurs découvertes concernant les fonctions des neurones","pour leur découverte de la bactérie Helicobacter pylori et son rôle dans la gastrite et l’ulcère gastrique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10307: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Charles R. Richet a-t-il reçu le Prix Nobel en 1913 ?",
      answers: ["Sciences Économiques","Physiologie ou Médecine","Chimie","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10308: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Rabindranath Tagore a-t-il reçu le Prix Nobel de Littérature en raison de ses vers profondément sensibles, frais et beaux, par lesquels il a rendu sa pensée poétique accessible à l’Occident ?",
      answers: ["1980","1969","2012","1913"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10309: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1913 en raison de ses vers profondément sensibles, frais et beaux, par lesquels il a rendu sa pensée poétique accessible à l’Occident ?",
      answers: ["Rudolf C. Eucken","Rabindranath Tagore","Maurice Maeterlinck","Frans E. Sillanpää"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10310: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Rabindranath Tagore a-t-il reçu le Prix Nobel en 1913 ?",
      answers: ["en raison de ses vers profondément sensibles, frais et beaux, par lesquels il a rendu sa pensée poétique accessible à l’Occident","pour une œuvre d’une portée universelle, marquée d’amertume et d’ingéniosité linguistique, qui a ouvert de nouvelles voies au roman et au théâtre chinois","en reconnaissance de ses brillantes réalisations littéraires, caractérisées par la noblesse du style, une profonde sympathie humaine et une véritable allure gauloise","en hommage à l’art consommé, pénétré d’idéalisme, qu’il a démontré tout au long de sa longue carrière productive"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10311: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Rabindranath Tagore a-t-il reçu le Prix Nobel en 1913 ?",
      answers: ["Sciences Économiques","Littérature","Chimie","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10312: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Comité International de la Croix-Rouge a-t-il reçu le Prix Nobel de Paix pour son travail humanitaire pendant les périodes de conflit ?",
      answers: ["1904","1914","1912","1913"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10313: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1913 pour son travail humanitaire pendant les périodes de conflit ?",
      answers: ["Tobias M.C. Asser","Auguste Beernaert","Ludwig Quidde","Comité International de la Croix-Rouge"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10314: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Comité International de la Croix-Rouge a-t-il reçu le Prix Nobel en 1913 ?",
      answers: ["pour son travail humanitaire pendant les périodes de conflit","pour son travail visant à promouvoir la justice sociale et les droits des travailleurs","pour son rôle dans la fondation du Comité International de la Croix-Rouge","pour leurs contributions à la négociation des accords de Camp David pour la paix au Moyen-Orient"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10315: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Comité International de la Croix-Rouge a-t-il reçu le Prix Nobel en 1913 ?",
      answers: ["Littérature","Physique","Physiologie ou Médecine","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10316: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Max von Laue a-t-il reçu le Prix Nobel de Physique pour sa découverte de la diffraction des rayons X par les cristaux ?",
      answers: ["1914","1909","1924","1939"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10317: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1914 pour sa découverte de la diffraction des rayons X par les cristaux ?",
      answers: ["Max von Laue","Lev Landau","Guglielmo Marconi","Heike Kamerlingh Onnes"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10318: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Max von Laue a-t-il reçu le Prix Nobel en 1914 ?",
      answers: ["pour ses recherches sur la structure des atomes et le rayonnement qui en émane","pour sa découverte de la diffraction des rayons X par les cristaux","pour leur contribution au développement de la spectroscopie laser","pour leurs services dans l’analyse de la structure cristalline au moyen des rayons X"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10319: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Max von Laue a-t-il reçu le Prix Nobel en 1914 ?",
      answers: ["Physiologie ou Médecine","Chimie","Physique","Paix"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10320: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Theodore W. Richards a-t-il reçu le Prix Nobel de Chimie en reconnaissance de ses déterminations précises des poids atomiques de nombreux éléments chimiques ?",
      answers: ["1918","1914","1930","1902"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10321: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1914 en reconnaissance de ses déterminations précises des poids atomiques de nombreux éléments chimiques ?",
      answers: ["Svante A. Arrhenius","Theodore W. Richards","Wendell M. Stanley","Theodor Svedberg"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10322: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Theodore W. Richards a-t-il reçu le Prix Nobel en 1914 ?",
      answers: ["en reconnaissance des services qu’il a rendus à l’avancement de la chimie organique et de l’industrie chimique par ses travaux sur les colorants organiques et les composés hydroaromatiques","en reconnaissance de ses déterminations précises des poids atomiques de nombreux éléments chimiques","pour son travail sur les réactions d’oxydation catalysées de manière chirale","pour leurs contributions à la compréhension de la connexion entre la structure chimique et l’activité catalytique du centre actif de la molécule de ribonucléase"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10323: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Theodore W. Richards a-t-il reçu le Prix Nobel en 1914 ?",
      answers: ["Sciences Économiques","Physique","Chimie","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10324: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Robert Bárány a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour son travail sur la physiologie et la pathologie de l’appareil vestibulaire ?",
      answers: ["1922","1914","1932","1912"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10325: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1914 pour son travail sur la physiologie et la pathologie de l’appareil vestibulaire ?",
      answers: ["Christiaan Eijkman","Robert Bárány","William P. Murphy","Élie Metchnikoff"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10326: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Robert Bárány a-t-il reçu le Prix Nobel en 1914 ?",
      answers: ["pour sa découverte de la relation fixe entre la consommation d’oxygène et le métabolisme de l’acide lactique dans les muscles","en reconnaissance de son travail sur la suture vasculaire et la transplantation d’organes et de vaisseaux sanguins","pour son travail sur la physiologie et la pathologie de l’appareil vestibulaire","pour leurs découvertes concernant le mécanisme et la régulation du métabolisme du cholestérol et des acides gras"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10327: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Robert Bárány a-t-il reçu le Prix Nobel en 1914 ?",
      answers: ["Chimie","Sciences Économiques","Physiologie ou Médecine","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10328: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Sir William H. Bragg a-t-il reçu le Prix Nobel de Physique pour leurs services dans l’analyse de la structure cristalline au moyen des rayons X ?",
      answers: ["1914","1915","1936","1911"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10329: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1915 pour leurs services dans l’analyse de la structure cristalline au moyen des rayons X ?",
      answers: ["Sir William H. Bragg","William L. Bragg","Max von Laue","Gerd Binnig"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10330: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Sir William H. Bragg a-t-il reçu le Prix Nobel en 1915 ?",
      answers: ["en reconnaissance des services extraordinaires qu’ils ont rendus par leurs recherches sur l’influence du magnétisme sur les phénomènes de rayonnement","en reconnaissance des services extraordinaires qu’il a rendus par sa découverte de la radioactivité spontanée","pour leurs services dans l’analyse de la structure cristalline au moyen des rayons X","en reconnaissance des services qu’il a rendus à la mesure précise en physique par sa découverte des anomalies des alliages d’acier au nickel"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10331: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Sir William H. Bragg a-t-il reçu le Prix Nobel en 1915 ?",
      answers: ["Chimie","Physique","Littérature","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10332: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année William L. Bragg a-t-il reçu le Prix Nobel de Physique pour leurs services dans l’analyse de la structure cristalline au moyen des rayons X ?",
      answers: ["1915","1910","1935","1911"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10333: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1915 pour leurs services dans l’analyse de la structure cristalline au moyen des rayons X ?",
      answers: ["Sir William H. Bragg","William L. Bragg","Hendrik A. Lorentz","Subrahmanyan Chandrasekhar"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10334: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison William L. Bragg a-t-il reçu le Prix Nobel en 1915 ?",
      answers: ["pour sa théorie des phénomènes critiques en relation avec les transitions de phase","pour des méthodes expérimentales générant des impulsions lumineuses extrêmement courtes permettant l’étude des dynamiques électroniques dans la matière","pour l’invention de la chambre à bulles","pour leurs services dans l’analyse de la structure cristalline au moyen des rayons X"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10335: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie William L. Bragg a-t-il reçu le Prix Nobel en 1915 ?",
      answers: ["Physiologie ou Médecine","Physique","Chimie","Littérature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10336: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Richard M. Willstätter a-t-il reçu le Prix Nobel de Chimie pour ses recherches sur les pigments végétaux, en particulier la chlorophylle ?",
      answers: ["2002","1914","1915","1916"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10337: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1915 pour ses recherches sur les pigments végétaux, en particulier la chlorophylle ?",
      answers: ["Richard M. Willstätter","Irène Joliot-Curie","Arne W.K. Tiselius","Fritz Haber"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10338: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Richard M. Willstätter a-t-il reçu le Prix Nobel en 1915 ?",
      answers: ["pour leur préparation d’enzymes et de protéines virales sous une forme pure","pour ses recherches sur les pigments végétaux, en particulier la chlorophylle","en reconnaissance de ses déterminations précises des poids atomiques de nombreux éléments chimiques","pour la découverte du réactif de Grignard, qui a grandement contribué au développement de la chimie organique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10339: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Richard M. Willstätter a-t-il reçu le Prix Nobel en 1915 ?",
      answers: ["Paix","Chimie","Physiologie ou Médecine","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10340: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Verner von Heidenstam a-t-il reçu le Prix Nobel de Littérature en reconnaissance de sa signification en tant que représentant éminent d’une nouvelle ère dans notre littérature ?",
      answers: ["1916","1918","1907","1909"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10341: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1916 en reconnaissance de sa signification en tant que représentant éminent d’une nouvelle ère dans notre littérature ?",
      answers: ["Rabindranath Tagore","Gabriel García Márquez","Verner von Heidenstam","Grazia Deledda"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10342: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Verner von Heidenstam a-t-il reçu le Prix Nobel en 1916 ?",
      answers: ["principalement pour son grand roman, 'Les Buddenbrook', qui est devenu un classique de la littérature contemporaine","en reconnaissance de sa signification en tant que représentant éminent d’une nouvelle ère dans notre littérature","en reconnaissance des nombreuses et brillantes compositions qui, d’une manière individuelle et originale, ont ravivé les grandes traditions du drame espagnol","pour sa poésie variée et riche, inspirée par de hauts idéaux"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10343: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Verner von Heidenstam a-t-il reçu le Prix Nobel en 1916 ?",
      answers: ["Physique","Sciences Économiques","Littérature","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10344: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Charles G. Barkla a-t-il reçu le Prix Nobel de Physique pour sa découverte du rayonnement X caractéristique des éléments ?",
      answers: ["1939","1917","1958","1931"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10345: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1917 pour sa découverte du rayonnement X caractéristique des éléments ?",
      answers: ["Charles G. Barkla","Albert Einstein","Murray Gell-Mann","George E. Smith"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10346: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Charles G. Barkla a-t-il reçu le Prix Nobel en 1917 ?",
      answers: ["pour leurs découvertes expérimentales concernant les phénomènes de tunnel dans les semi-conducteurs et les supraconducteurs, respectivement","pour sa contribution au développement de la méthode des faisceaux moléculaires et sa découverte du moment magnétique du proton","pour sa découverte de l’effet Doppler dans les rayons canaux et de la séparation des lignes spectrales dans les champs électriques","pour sa découverte du rayonnement X caractéristique des éléments"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10347: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Charles G. Barkla a-t-il reçu le Prix Nobel en 1917 ?",
      answers: ["Physique","Sciences Économiques","Physiologie ou Médecine","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10348: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Karl A. Gjellerup a-t-il reçu le Prix Nobel de Littérature pour sa poésie variée et riche, inspirée par de hauts idéaux ?",
      answers: ["1916","1929","2012","1917"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10349: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1917 pour sa poésie variée et riche, inspirée par de hauts idéaux ?",
      answers: ["Karl A. Gjellerup","William Butler Yeats","Henrik Pontoppidan","Carl Spitteler"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10350: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Karl A. Gjellerup a-t-il reçu le Prix Nobel en 1917 ?",
      answers: ["pour ses descriptions authentiques de la vie actuelle au Danemark","en hommage particulier à son œuvre épique, 'Olympischer Frühling'","pour sa poésie variée et riche, inspirée par de hauts idéaux","en raison de ses vers profondément sensibles, frais et beaux, par lesquels il a rendu sa pensée poétique accessible à l’Occident"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10351: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Karl A. Gjellerup a-t-il reçu le Prix Nobel en 1917 ?",
      answers: ["Chimie","Physique","Physiologie ou Médecine","Littérature"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10352: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Henrik Pontoppidan a-t-il reçu le Prix Nobel de Littérature pour ses descriptions authentiques de la vie actuelle au Danemark ?",
      answers: ["1906","1902","1917","1915"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10353: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1917 pour ses descriptions authentiques de la vie actuelle au Danemark ?",
      answers: ["Karl A. Gjellerup","Henrik Pontoppidan","Verner von Heidenstam","Carl Spitteler"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10354: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Henrik Pontoppidan a-t-il reçu le Prix Nobel en 1917 ?",
      answers: ["pour ses descriptions authentiques de la vie actuelle au Danemark","pour la manière heureuse dont il a poursuivi les traditions honorables du théâtre espagnol","pour sa poésie variée et riche, inspirée par de hauts idéaux","en hommage particulier à son œuvre épique, 'Olympischer Frühling'"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10355: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Henrik Pontoppidan a-t-il reçu le Prix Nobel en 1917 ?",
      answers: ["Physique","Paix","Chimie","Littérature"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10356: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Comité International de la Croix-Rouge a-t-il reçu le Prix Nobel de Paix pour son travail humanitaire pendant la Première Guerre mondiale ?",
      answers: ["1922","1927","1909","1917"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10357: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1917 pour son travail humanitaire pendant la Première Guerre mondiale ?",
      answers: ["Comité International de la Croix-Rouge (CICR)","Comité International de la Croix-Rouge","Henry Kissinger","Woodrow Wilson"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10358: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Comité International de la Croix-Rouge a-t-il reçu le Prix Nobel en 1917 ?",
      answers: ["pour ses efforts visant à codifier le droit international et à promouvoir la paix","pour son rôle dans la fondation du Comité International de la Croix-Rouge","pour son rôle de leader dans la défense non violente des droits humains en Amérique latine","pour son travail humanitaire pendant la Première Guerre mondiale"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10359: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Comité International de la Croix-Rouge a-t-il reçu le Prix Nobel en 1917 ?",
      answers: ["Littérature","Paix","Physiologie ou Médecine","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10360: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Max Planck a-t-il reçu le Prix Nobel de Physique en reconnaissance des services qu’il a rendus à l’avancement de la physique par sa découverte des quanta d’énergie ?",
      answers: ["1918","1919","1917","1923"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10361: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1918 en reconnaissance des services qu’il a rendus à l’avancement de la physique par sa découverte des quanta d’énergie ?",
      answers: ["Edward M. Purcell","Max Planck","Ernst Ruska","Guglielmo Marconi"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10362: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Max Planck a-t-il reçu le Prix Nobel en 1918 ?",
      answers: ["pour ses recherches sur la structure des atomes et le rayonnement qui en émane","pour sa découverte de la loi de l’effet photoélectrique","en reconnaissance des services qu’il a rendus à l’avancement de la physique par sa découverte des quanta d’énergie","pour sa méthode de rendre visibles les trajectoires des particules chargées électriquement au moyen de la condensation de la vapeur"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10363: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Max Planck a-t-il reçu le Prix Nobel en 1918 ?",
      answers: ["Chimie","Sciences Économiques","Physique","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10364: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Fritz Haber a-t-il reçu le Prix Nobel de Chimie pour la synthèse de l’ammoniac à partir de ses éléments ?",
      answers: ["1918","1911","1970","1935"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10365: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1918 pour la synthèse de l’ammoniac à partir de ses éléments ?",
      answers: ["Fritz Haber","Donald J. Cram","Sir William Ramsay","James B. Sumner"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10366: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Fritz Haber a-t-il reçu le Prix Nobel en 1918 ?",
      answers: ["pour son travail sur les hormones sexuelles","pour leurs recherches sur la fermentation des sucres et les enzymes fermentatives","pour la synthèse de l’ammoniac à partir de ses éléments","pour ses contributions à notre connaissance de la chimie des substances radioactives et ses recherches sur l’origine et la nature des isotopes"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10367: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Fritz Haber a-t-il reçu le Prix Nobel en 1918 ?",
      answers: ["Chimie","Paix","Physique","Littérature"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10368: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Johannes Stark a-t-il reçu le Prix Nobel de Physique pour sa découverte de l’effet Doppler dans les rayons canaux et de la séparation des lignes spectrales dans les champs électriques ?",
      answers: ["1918","1919","1917","1920"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10369: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1919 pour sa découverte de l’effet Doppler dans les rayons canaux et de la séparation des lignes spectrales dans les champs électriques ?",
      answers: ["Charles G. Barkla","Otto Stern","Brian P. Schmidt","Johannes Stark"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10370: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Johannes Stark a-t-il reçu le Prix Nobel en 1919 ?",
      answers: ["pour sa découverte de l’effet Doppler dans les rayons canaux et de la séparation des lignes spectrales dans les champs électriques","pour leur découverte des lois régissant l’impact d’un électron sur un atome","pour ses découvertes et recherches dans le domaine de la spectroscopie des rayons X","en reconnaissance de leurs contributions au développement de la télégraphie sans fil"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10371: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Johannes Stark a-t-il reçu le Prix Nobel en 1919 ?",
      answers: ["Physique","Chimie","Paix","Sciences Économiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10372: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Jules Bordet a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour ses découvertes relatives à l’immunité ?",
      answers: ["1926","1910","1906","1919"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10373: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1919 pour ses découvertes relatives à l’immunité ?",
      answers: ["Jules Bordet","Paul Ehrlich","Corneille Heymans","David H. Hubel"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10374: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Jules Bordet a-t-il reçu le Prix Nobel en 1919 ?",
      answers: ["pour ses découvertes relatives à l’immunité","pour leurs découvertes concernant les hormones du cortex surrénalien, leur structure et leurs effets biologiques","pour leurs découvertes concernant les fonctions hautement différenciées des fibres nerveuses individuelles","pour leurs découvertes sur les récepteurs olfactifs et l’organisation du système olfactif"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10375: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Jules Bordet a-t-il reçu le Prix Nobel en 1919 ?",
      answers: ["Sciences Économiques","Chimie","Physiologie ou Médecine","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10376: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Carl Spitteler a-t-il reçu le Prix Nobel de Littérature en hommage particulier à son œuvre épique, 'Olympischer Frühling' ?",
      answers: ["1919","1935","1917","1908"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10377: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1919 en hommage particulier à son œuvre épique, 'Olympischer Frühling' ?",
      answers: ["Carl Spitteler","William Butler Yeats","Knut Pedersen Hamsun","Heinrich Böll"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10378: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Carl Spitteler a-t-il reçu le Prix Nobel en 1919 ?",
      answers: ["qui, dans une vaste perspective culturelle et avec des accents poétiques, façonne le drame de l’existence","en reconnaissance de sa signification en tant que représentant éminent d’une nouvelle ère dans notre littérature","pour ses descriptions riches et véritablement épiques de la vie paysanne en Chine et pour ses chefs-d’œuvre biographiques","en hommage particulier à son œuvre épique, 'Olympischer Frühling'"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10379: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Carl Spitteler a-t-il reçu le Prix Nobel en 1919 ?",
      answers: ["Physiologie ou Médecine","Littérature","Sciences Économiques","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10380: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Woodrow Wilson a-t-il reçu le Prix Nobel de Paix pour son rôle dans la fondation de la Société des Nations ?",
      answers: ["1959","1919","1923","1912"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10381: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1919 pour son rôle dans la fondation de la Société des Nations ?",
      answers: ["Comité International de la Croix-Rouge","Jane Addams","Frédéric Passy","Woodrow Wilson"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10382: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Woodrow Wilson a-t-il reçu le Prix Nobel en 1919 ?",
      answers: ["pour son rôle dans la fondation de la Société des Nations","pour son roman 'Quand les armes se taisent' et son travail en faveur de la paix","pour ses efforts visant à obtenir un monde sans armes nucléaires et pour avoir démontré par des témoignages que les armes nucléaires ne doivent plus jamais être utilisées","pour ses efforts visant à promouvoir la paix à travers la coopération religieuse"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10383: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Woodrow Wilson a-t-il reçu le Prix Nobel en 1919 ?",
      answers: ["Littérature","Physiologie ou Médecine","Paix","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10384: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Walther Nernst a-t-il reçu le Prix Nobel de Chimie en reconnaissance de son travail en thermochimie ?",
      answers: ["1939","1918","1909","1920"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10385: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1920 en reconnaissance de son travail en thermochimie ?",
      answers: ["Christian B. Anfinsen","Charles J. Pedersen","Walther Nernst","Glenn T. Seaborg"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10386: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Walther Nernst a-t-il reçu le Prix Nobel en 1920 ?",
      answers: ["en reconnaissance de son travail en thermochimie","pour ses recherches sur l’électrophorèse et l’analyse par adsorption, en particulier pour ses découvertes concernant la nature complexe des protéines sériques","en reconnaissance de ses déterminations précises des poids atomiques de nombreux éléments chimiques","pour ses contributions à la connaissance de la structure électronique et de la géométrie des molécules, en particulier des radicaux libres"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10387: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Walther Nernst a-t-il reçu le Prix Nobel en 1920 ?",
      answers: ["Physiologie ou Médecine","Chimie","Sciences Économiques","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10388: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Charles Édouard Guillaume a-t-il reçu le Prix Nobel de Physique en reconnaissance des services qu’il a rendus à la mesure précise en physique par sa découverte des anomalies des alliages d’acier au nickel ?",
      answers: ["1961","1913","1926","1920"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10389: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1920 en reconnaissance des services qu’il a rendus à la mesure précise en physique par sa découverte des anomalies des alliages d’acier au nickel ?",
      answers: ["Philipp Lenard","Charles Édouard Guillaume","Nils G. Dalén","William L. Bragg"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10390: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Charles Édouard Guillaume a-t-il reçu le Prix Nobel en 1920 ?",
      answers: ["pour leur découverte expérimentale de la diffraction des électrons par les cristaux","pour ses travaux sur la charge élémentaire de l’électricité et sur l’effet photoélectrique","pour des contributions décisives à l’observatoire LIGO et à la détection des ondes gravitationnelles","en reconnaissance des services qu’il a rendus à la mesure précise en physique par sa découverte des anomalies des alliages d’acier au nickel"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10391: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Charles Édouard Guillaume a-t-il reçu le Prix Nobel en 1920 ?",
      answers: ["Sciences Économiques","Paix","Physique","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10392: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Knut Pedersen Hamsun a-t-il reçu le Prix Nobel de Littérature pour son œuvre monumentale, 'La croissance du sol' ?",
      answers: ["1920","1960","2024","1939"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10393: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1920 pour son œuvre monumentale, 'La croissance du sol' ?",
      answers: ["François Mauriac","William Butler Yeats","Henrik Pontoppidan","Knut Pedersen Hamsun"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10394: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Knut Pedersen Hamsun a-t-il reçu le Prix Nobel en 1920 ?",
      answers: ["en appréciation de l’idéalisme élevé, de l’imagination vive et de la perception spirituelle qui caractérisent ses écrits","pour sa poésie lyrique qui, inspirée par des émotions puissantes, a fait de son nom un symbole des aspirations idéalistes de tout le monde latino-américain","pour son œuvre monumentale, 'La croissance du sol'","pour sa contribution puissante et artistiquement unique à la fiction américaine contemporaine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10395: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Knut Pedersen Hamsun a-t-il reçu le Prix Nobel en 1920 ?",
      answers: ["Littérature","Paix","Physique","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10396: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Léon Bourgeois a-t-il reçu le Prix Nobel de Paix pour son rôle dans la création de la Société des Nations et ses efforts pour la paix ?",
      answers: ["1921","1920","1928","1922"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10397: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1920 pour son rôle dans la création de la Société des Nations et ses efforts pour la paix ?",
      answers: ["Woodrow Wilson","Elihu Root","Ernesto T. Moneta","Léon Bourgeois"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10398: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Léon Bourgeois a-t-il reçu le Prix Nobel en 1920 ?",
      answers: ["pour son travail en faveur de la paix et de la coopération internationale à travers la Société des Nations","pour son rôle dans la création de la Société des Nations et ses efforts pour la paix","pour ses efforts visant à combattre la faim et à améliorer les conditions de paix dans les zones de conflit","pour son travail visant à promouvoir la justice sociale et les droits des travailleurs"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10399: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Léon Bourgeois a-t-il reçu le Prix Nobel en 1920 ?",
      answers: ["Physiologie ou Médecine","Physique","Chimie","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10400: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Albert Einstein a-t-il reçu le Prix Nobel de Physique pour sa découverte de la loi de l’effet photoélectrique ?",
      answers: ["1985","1963","1927","1921"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10401: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1921 pour sa découverte de la loi de l’effet photoélectrique ?",
      answers: ["Charles Édouard Guillaume","Carl D. Anderson","Manne Siegbahn","Albert Einstein"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10402: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Albert Einstein a-t-il reçu le Prix Nobel en 1921 ?",
      answers: ["pour ses investigations sur la physique de la haute atmosphère, en particulier pour la découverte de la couche dite Appleton","pour leurs contributions à la théorie unifiée des interactions faible et électromagnétique entre particules élémentaires","pour sa découverte de la loi de l’effet photoélectrique","pour la découverte et l’interprétation de l’effet Cherenkov"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10403: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Albert Einstein a-t-il reçu le Prix Nobel en 1921 ?",
      answers: ["Physique","Physiologie ou Médecine","Chimie","Sciences Économiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10404: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Frederick Soddy a-t-il reçu le Prix Nobel de Chimie pour ses contributions à notre connaissance de la chimie des substances radioactives et ses recherches sur l’origine et la nature des isotopes ?",
      answers: ["1921","1935","1911","1931"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10405: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1921 pour ses contributions à notre connaissance de la chimie des substances radioactives et ses recherches sur l’origine et la nature des isotopes ?",
      answers: ["Frederick Soddy","Fritz Pregl","Arthur Harden","Francis W. Aston"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10406: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Frederick Soddy a-t-il reçu le Prix Nobel en 1921 ?",
      answers: ["pour ses recherches biochimiques et sa découverte de la fermentation sans cellules","pour leurs recherches sur les mécanismes des réactions chimiques","pour ses contributions à notre connaissance de la chimie des substances radioactives et ses recherches sur l’origine et la nature des isotopes","pour leurs contributions à la dynamique des processus chimiques élémentaires"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10407: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Frederick Soddy a-t-il reçu le Prix Nobel en 1921 ?",
      answers: ["Physique","Physiologie ou Médecine","Chimie","Paix"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10408: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Anatole France a-t-il reçu le Prix Nobel de Littérature en reconnaissance de ses brillantes réalisations littéraires, caractérisées par la noblesse du style, une profonde sympathie humaine et une véritable allure gauloise ?",
      answers: ["1916","1927","1921","1924"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10409: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1921 en reconnaissance de ses brillantes réalisations littéraires, caractérisées par la noblesse du style, une profonde sympathie humaine et une véritable allure gauloise ?",
      answers: ["Anatole France","John Galsworthy","William Butler Yeats","Maurice Maeterlinck"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10410: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Anatole France a-t-il reçu le Prix Nobel en 1921 ?",
      answers: ["pour sa poésie toujours inspirée, qui donne une expression hautement artistique à l’esprit d’une nation entière","pour son œuvre monumentale, 'La croissance du sol'","en reconnaissance de ses brillantes réalisations littéraires, caractérisées par la noblesse du style, une profonde sympathie humaine et une véritable allure gauloise","pour la manière heureuse dont il a poursuivi les traditions honorables du théâtre espagnol"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10411: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Anatole France a-t-il reçu le Prix Nobel en 1921 ?",
      answers: ["Littérature","Chimie","Physique","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10412: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Christian Lous Lange a-t-il reçu le Prix Nobel de Paix pour son travail en faveur de la paix et de la coopération internationale à travers la Société des Nations ?",
      answers: ["1902","1921","1929","1930"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10413: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1921 pour son travail en faveur de la paix et de la coopération internationale à travers la Société des Nations ?",
      answers: ["Karl Hjalmar Branting","Comité International de la Croix-Rouge","Christian Lous Lange","Léon Bourgeois"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10414: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Christian Lous Lange a-t-il reçu le Prix Nobel en 1921 ?",
      answers: ["pour son rôle dans la création de la Société des Nations et ses efforts pour la paix","pour son rôle dans les accords de Locarno favorisant la paix en Europe","pour son roman 'Quand les armes se taisent' et son travail en faveur de la paix","pour son travail en faveur de la paix et de la coopération internationale à travers la Société des Nations"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10415: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Christian Lous Lange a-t-il reçu le Prix Nobel en 1921 ?",
      answers: ["Littérature","Paix","Physiologie ou Médecine","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10416: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Karl Hjalmar Branting a-t-il reçu le Prix Nobel de Paix pour son travail en faveur de la paix et de la coopération internationale à travers la Société des Nations ?",
      answers: ["1921","1952","1946","1922"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10417: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1921 pour son travail en faveur de la paix et de la coopération internationale à travers la Société des Nations ?",
      answers: ["Léon Bourgeois","Fridtjof Nansen","Christian Lous Lange","Karl Hjalmar Branting"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10418: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Karl Hjalmar Branting a-t-il reçu le Prix Nobel en 1921 ?",
      answers: ["pour son rôle dans la fondation de la Société des Nations","pour son rôle dans la création de la Société des Nations et ses efforts pour la paix","pour son travail humanitaire, notamment en faveur des réfugiés et des victimes de la Première Guerre mondiale","pour son travail en faveur de la paix et de la coopération internationale à travers la Société des Nations"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10419: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Karl Hjalmar Branting a-t-il reçu le Prix Nobel en 1921 ?",
      answers: ["Chimie","Paix","Physiologie ou Médecine","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10420: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Niels Bohr a-t-il reçu le Prix Nobel de Physique pour ses recherches sur la structure des atomes et le rayonnement qui en émane ?",
      answers: ["1948","1917","1988","1922"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10421: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1922 pour ses recherches sur la structure des atomes et le rayonnement qui en émane ?",
      answers: ["Albert Einstein","Saul Perlmutter","Niels Bohr","Pieter Zeeman"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10422: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Niels Bohr a-t-il reçu le Prix Nobel en 1922 ?",
      answers: ["pour sa démonstration de l’existence de nouveaux éléments radioactifs produits par irradiation neutronique et pour sa découverte connexe des réactions nucléaires provoquées par des neutrons lents","pour ses travaux sur le phénomène thermionique et en particulier pour la découverte de la loi qui porte son nom","pour leur découverte des lois régissant l’impact d’un électron sur un atome","pour ses recherches sur la structure des atomes et le rayonnement qui en émane"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10423: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Niels Bohr a-t-il reçu le Prix Nobel en 1922 ?",
      answers: ["Chimie","Physique","Sciences Économiques","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10424: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Francis W. Aston a-t-il reçu le Prix Nobel de Chimie pour sa découverte, au moyen de son spectromètre de masse, des isotopes dans un grand nombre d’éléments non radioactifs, et pour son énonciation de la règle des nombres entiers ?",
      answers: ["1924","1918","1921","1922"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10425: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1922 pour sa découverte, au moyen de son spectromètre de masse, des isotopes dans un grand nombre d’éléments non radioactifs, et pour son énonciation de la règle des nombres entiers ?",
      answers: ["Richard M. Willstätter","Max F. Perutz","Francis W. Aston","Frederick Soddy"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10426: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Francis W. Aston a-t-il reçu le Prix Nobel en 1922 ?",
      answers: ["en reconnaissance de son travail en thermochimie","pour sa découverte, au moyen de son spectromètre de masse, des isotopes dans un grand nombre d’éléments non radioactifs, et pour son énonciation de la règle des nombres entiers","en reconnaissance de leur synthèse de nouveaux éléments radioactifs","pour la découverte de la dégradation des protéines médiée par l’ubiquitine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10427: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Francis W. Aston a-t-il reçu le Prix Nobel en 1922 ?",
      answers: ["Littérature","Chimie","Physiologie ou Médecine","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10428: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Archibald V. Hill a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour sa découverte relative à la production de chaleur dans les muscles ?",
      answers: ["1922","1964","1918","1921"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10429: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1922 pour sa découverte relative à la production de chaleur dans les muscles ?",
      answers: ["Archibald V. Hill","Sir James W. Black","Hermann J. Muller","George W. Beadle"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10430: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Archibald V. Hill a-t-il reçu le Prix Nobel en 1922 ?",
      answers: ["pour leurs découvertes sur la régulation génétique du développement des organes et de la mort cellulaire programmée","pour sa découverte de la relation fixe entre la consommation d’oxygène et le métabolisme de l’acide lactique dans les muscles","pour la découverte de l’insuline","pour sa découverte relative à la production de chaleur dans les muscles"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10431: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Archibald V. Hill a-t-il reçu le Prix Nobel en 1922 ?",
      answers: ["Littérature","Chimie","Physique","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10432: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Otto F. Meyerhof a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour sa découverte de la relation fixe entre la consommation d’oxygène et le métabolisme de l’acide lactique dans les muscles ?",
      answers: ["1956","1916","1914","1922"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10433: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1922 pour sa découverte de la relation fixe entre la consommation d’oxygène et le métabolisme de l’acide lactique dans les muscles ?",
      answers: ["Johannes A.B. Fibiger","Otto F. Meyerhof","Jules Bordet","Archibald V. Hill"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10434: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Otto F. Meyerhof a-t-il reçu le Prix Nobel en 1922 ?",
      answers: ["pour sa découverte du mécanisme de l’électrocardiogramme","pour sa découverte relative à la production de chaleur dans les muscles","pour sa découverte de la relation fixe entre la consommation d’oxygène et le métabolisme de l’acide lactique dans les muscles","pour leur découverte que les gènes agissent en régulant des événements chimiques définis"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10435: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Otto F. Meyerhof a-t-il reçu le Prix Nobel en 1922 ?",
      answers: ["Chimie","Paix","Physiologie ou Médecine","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10436: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Jacinto Benavente a-t-il reçu le Prix Nobel de Littérature pour la manière heureuse dont il a poursuivi les traditions honorables du théâtre espagnol ?",
      answers: ["1923","1922","1924","1927"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10437: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1922 pour la manière heureuse dont il a poursuivi les traditions honorables du théâtre espagnol ?",
      answers: ["William Butler Yeats","Karl A. Gjellerup","Jacinto Benavente","Nadine Gordimer"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10438: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Jacinto Benavente a-t-il reçu le Prix Nobel en 1922 ?",
      answers: ["qui, dans des romans caractérisés par une force visionnaire et une portée poétique, donne vie à un aspect essentiel de la réalité américaine","pour son art distingué de la narration qui trouve sa plus haute expression dans 'La Saga des Forsyte'","pour une poésie qui, avec une précision ironique, permet au contexte historique et biologique de se manifester dans des fragments de réalité humaine","pour la manière heureuse dont il a poursuivi les traditions honorables du théâtre espagnol"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10439: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Jacinto Benavente a-t-il reçu le Prix Nobel en 1922 ?",
      answers: ["Physiologie ou Médecine","Chimie","Physique","Littérature"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10440: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Fridtjof Nansen a-t-il reçu le Prix Nobel de Paix pour son travail humanitaire, notamment en faveur des réfugiés et des victimes de la Première Guerre mondiale ?",
      answers: ["1927","1922","1921","1923"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10441: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1922 pour son travail humanitaire, notamment en faveur des réfugiés et des victimes de la Première Guerre mondiale ?",
      answers: ["Karl Hjalmar Branting","Woodrow Wilson","Christian Lous Lange","Fridtjof Nansen"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10442: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Fridtjof Nansen a-t-il reçu le Prix Nobel en 1922 ?",
      answers: ["pour son travail humanitaire, notamment en faveur des réfugiés et des victimes de la Première Guerre mondiale","pour sa lutte non violente pour la libération du Tibet et son engagement pour la paix mondiale","pour son rôle dans le plan Dawes visant à stabiliser l’économie allemande et à promouvoir la paix","pour leurs contributions à la réconciliation franco-allemande et à la paix mondiale"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10443: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Fridtjof Nansen a-t-il reçu le Prix Nobel en 1922 ?",
      answers: ["Chimie","Paix","Physique","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10444: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Robert A. Millikan a-t-il reçu le Prix Nobel de Physique pour ses travaux sur la charge élémentaire de l’électricité et sur l’effet photoélectrique ?",
      answers: ["1923","1917","1920","1925"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10445: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1923 pour ses travaux sur la charge élémentaire de l’électricité et sur l’effet photoélectrique ?",
      answers: ["Gustav Hertz","Erwin Schrödinger","Max Born","Robert A. Millikan"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10446: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Robert A. Millikan a-t-il reçu le Prix Nobel en 1923 ?",
      answers: ["pour ses travaux sur la charge élémentaire de l’électricité et sur l’effet photoélectrique","pour sa découverte de l’effet Doppler dans les rayons canaux et de la séparation des lignes spectrales dans les champs électriques","pour sa méthode de rendre visibles les trajectoires des particules chargées électriquement au moyen de la condensation de la vapeur","pour la découverte de la liberté asymptotique dans la théorie de l’interaction forte"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10447: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Robert A. Millikan a-t-il reçu le Prix Nobel en 1923 ?",
      answers: ["Physiologie ou Médecine","Littérature","Physique","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10448: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Fritz Pregl a-t-il reçu le Prix Nobel de Chimie pour son invention de la méthode de microanalyse des substances organiques ?",
      answers: ["1924","1923","1990","1946"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10449: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1923 pour son invention de la méthode de microanalyse des substances organiques ?",
      answers: ["Wilhelm Ostwald","Fritz Pregl","Victor Grignard","Paul J. Flory"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10450: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Fritz Pregl a-t-il reçu le Prix Nobel en 1923 ?",
      answers: ["pour la découverte du réactif de Grignard, qui a grandement contribué au développement de la chimie organique","pour sa démonstration de la nature hétérogène des solutions colloïdales et pour les méthodes qu’il a utilisées, qui sont devenues fondamentales en chimie colloïdale moderne","pour ses travaux sur les systèmes dispersés","pour son invention de la méthode de microanalyse des substances organiques"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10451: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Fritz Pregl a-t-il reçu le Prix Nobel en 1923 ?",
      answers: ["Physiologie ou Médecine","Chimie","Physique","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10452: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Frederick G. Banting a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour la découverte de l’insuline ?",
      answers: ["1923","1901","1917","1916"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10453: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1923 pour la découverte de l’insuline ?",
      answers: ["George H. Whipple","Severo Ochoa","Charles L. A. Laveran","Frederick G. Banting"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10454: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Frederick G. Banting a-t-il reçu le Prix Nobel en 1923 ?",
      answers: ["pour ses découvertes concernant la nature et le mode d’action des enzymes d’oxydation","pour la découverte de l’insuline","pour sa découverte de la nature chimique de la vitamine K","pour leurs découvertes concernant les transmetteurs humoraux dans les terminaisons nerveuses et le mécanisme de leur stockage, libération et inactivation"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10455: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Frederick G. Banting a-t-il reçu le Prix Nobel en 1923 ?",
      answers: ["Littérature","Physiologie ou Médecine","Chimie","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10456: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année John J.R. Macleod a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour la découverte de l’insuline ?",
      answers: ["1923","1918","1979","1938"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10457: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1923 pour la découverte de l’insuline ?",
      answers: ["Carl F. Cori","John J.R. Macleod","Julius Wagner-Jauregg","Willem Einthoven"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10458: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison John J.R. Macleod a-t-il reçu le Prix Nobel en 1923 ?",
      answers: ["pour ses découvertes en lien avec les processus de combustion biologique, avec une référence spéciale à la vitamine C et à la catalyse de l’acide fumarique","pour la découverte de l’insuline","pour leurs découvertes concernant les fonctions des neurones","pour sa découverte de la valeur thérapeutique de la lobotomie dans certaines psychoses"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10459: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie John J.R. Macleod a-t-il reçu le Prix Nobel en 1923 ?",
      answers: ["Chimie","Physique","Sciences Économiques","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10460: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année William Butler Yeats a-t-il reçu le Prix Nobel de Littérature pour sa poésie toujours inspirée, qui donne une expression hautement artistique à l’esprit d’une nation entière ?",
      answers: ["1914","1922","1923","1909"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10461: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1923 pour sa poésie toujours inspirée, qui donne une expression hautement artistique à l’esprit d’une nation entière ?",
      answers: ["Maurice Maeterlinck","Paul J.L. Heyse","George Bernard Shaw","William Butler Yeats"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10462: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison William Butler Yeats a-t-il reçu le Prix Nobel en 1923 ?",
      answers: ["pour sa grande épopée nationale, 'Les Paysans'","pour sa poésie toujours inspirée, qui donne une expression hautement artistique à l’esprit d’une nation entière","en reconnaissance de ses idées riches et vivifiantes et de l’éclatante habileté avec laquelle elles ont été présentées","pour ses pièces de théâtre et sa prose innovantes qui donnent une voix à l’indicible"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10463: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie William Butler Yeats a-t-il reçu le Prix Nobel en 1923 ?",
      answers: ["Paix","Physique","Physiologie ou Médecine","Littérature"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10464: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Manne Siegbahn a-t-il reçu le Prix Nobel de Physique pour ses découvertes et recherches dans le domaine de la spectroscopie des rayons X ?",
      answers: ["1907","1913","1933","1924"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10465: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1924 pour ses découvertes et recherches dans le domaine de la spectroscopie des rayons X ?",
      answers: ["Saul Perlmutter","Manne Siegbahn","Eugene Wigner","John Bardeen"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10466: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Manne Siegbahn a-t-il reçu le Prix Nobel en 1924 ?",
      answers: ["pour ses découvertes et recherches dans le domaine de la spectroscopie des rayons X","pour l’invention d’un appareil permettant de produire des pressions extrêmement élevées et pour les découvertes qu’il a réalisées dans le domaine de la physique des hautes pressions","pour sa méthode de reproduction des couleurs par photographie basée sur le phénomène d’interférence","pour leur découverte de l’antiproton"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10467: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Manne Siegbahn a-t-il reçu le Prix Nobel en 1924 ?",
      answers: ["Littérature","Sciences Économiques","Physiologie ou Médecine","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10468: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Willem Einthoven a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour sa découverte du mécanisme de l’électrocardiogramme ?",
      answers: ["1922","1917","1924","1929"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10469: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1924 pour sa découverte du mécanisme de l’électrocardiogramme ?",
      answers: ["Otto Loewi","Feodor Lynen","Julius Wagner-Jauregg","Willem Einthoven"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10470: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Willem Einthoven a-t-il reçu le Prix Nobel en 1924 ?",
      answers: ["pour leurs découvertes concernant la transmission chimique des impulsions nerveuses","pour sa découverte du mécanisme de l’électrocardiogramme","pour ses travaux sur la dioptrique de l’œil","pour leurs découvertes concernant les fonctions hautement différenciées des fibres nerveuses individuelles"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10471: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Willem Einthoven a-t-il reçu le Prix Nobel en 1924 ?",
      answers: ["Littérature","Physiologie ou Médecine","Chimie","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10472: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Władysław Reymont a-t-il reçu le Prix Nobel de Littérature pour sa grande épopée nationale, 'Les Paysans' ?",
      answers: ["1922","1906","1924","1943"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10473: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1924 pour sa grande épopée nationale, 'Les Paysans' ?",
      answers: ["Władysław Reymont","Eugene O’Neill","Anatole France","Frans E. Sillanpää"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10474: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Władysław Reymont a-t-il reçu le Prix Nobel en 1924 ?",
      answers: ["pour sa grande épopée nationale, 'Les Paysans'","en raison de ses vers profondément sensibles, frais et beaux, par lesquels il a rendu sa pensée poétique accessible à l’Occident","en reconnaissance de ses brillantes réalisations littéraires, caractérisées par la noblesse du style, une profonde sympathie humaine et une véritable allure gauloise","en reconnaissance de ses idées riches et vivifiantes et de l’éclatante habileté avec laquelle elles ont été présentées"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10475: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Władysław Reymont a-t-il reçu le Prix Nobel en 1924 ?",
      answers: ["Littérature","Physiologie ou Médecine","Physique","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10476: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année James Franck a-t-il reçu le Prix Nobel de Physique pour leur découverte des lois régissant l’impact d’un électron sur un atome ?",
      answers: ["1922","1938","1925","1930"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10477: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1925 pour leur découverte des lois régissant l’impact d’un électron sur un atome ?",
      answers: ["James Franck","Frits Zernike","Gustav Hertz","Manne Siegbahn"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10478: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison James Franck a-t-il reçu le Prix Nobel en 1925 ?",
      answers: ["pour ses travaux sur la structure discontinue de la matière, et en particulier pour sa découverte de l’équilibre de sédimentation","en reconnaissance des services extraordinaires qu’ils ont rendus conjointement par leurs recherches sur les phénomènes de rayonnement découverts par le professeur Henri Becquerel","pour leur découverte des lois régissant l’impact d’un électron sur un atome","pour la découverte de nouvelles formes productives de la théorie atomique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10479: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie James Franck a-t-il reçu le Prix Nobel en 1925 ?",
      answers: ["Physique","Chimie","Physiologie ou Médecine","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10480: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Gustav Hertz a-t-il reçu le Prix Nobel de Physique pour leur découverte des lois régissant l’impact d’un électron sur un atome ?",
      answers: ["1924","1925","1928","1996"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10481: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1925 pour leur découverte des lois régissant l’impact d’un électron sur un atome ?",
      answers: ["Manne Siegbahn","Carl E. Wieman","Charles Édouard Guillaume","Gustav Hertz"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10482: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Gustav Hertz a-t-il reçu le Prix Nobel en 1925 ?",
      answers: ["pour la découverte de la connexion entre le mouvement collectif et le mouvement des particules dans les noyaux atomiques et le développement de la théorie de la structure nucléaire basée sur cette connexion","pour leur découverte des lois régissant l’impact d’un électron sur un atome","pour ses recherches sur la structure des atomes et le rayonnement qui en émane","pour sa démonstration de la méthode du contraste de phase et en particulier pour son invention du microscope à contraste de phase"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10483: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Gustav Hertz a-t-il reçu le Prix Nobel en 1925 ?",
      answers: ["Sciences Économiques","Physique","Chimie","Littérature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10484: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Richard A. Zsigmondy a-t-il reçu le Prix Nobel de Chimie pour sa démonstration de la nature hétérogène des solutions colloïdales et pour les méthodes qu’il a utilisées, qui sont devenues fondamentales en chimie colloïdale moderne ?",
      answers: ["1922","1924","1929","1925"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10485: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1925 pour sa démonstration de la nature hétérogène des solutions colloïdales et pour les méthodes qu’il a utilisées, qui sont devenues fondamentales en chimie colloïdale moderne ?",
      answers: ["Cyril N. Hinshelwood","Theodor Svedberg","Francis W. Aston","Richard A. Zsigmondy"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10486: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Richard A. Zsigmondy a-t-il reçu le Prix Nobel en 1925 ?",
      answers: ["pour sa démonstration de la nature hétérogène des solutions colloïdales et pour les méthodes qu’il a utilisées, qui sont devenues fondamentales en chimie colloïdale moderne","pour le développement des batteries lithium-ion","pour leurs recherches sur la fermentation des sucres et les enzymes fermentatives","en reconnaissance de ses travaux sur la catalyse et pour ses recherches sur les principes fondamentaux régissant l’équilibre chimique et les vitesses de réaction"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10487: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Richard A. Zsigmondy a-t-il reçu le Prix Nobel en 1925 ?",
      answers: ["Physiologie ou Médecine","Littérature","Physique","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10488: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année George Bernard Shaw a-t-il reçu le Prix Nobel de Littérature pour son œuvre marquée à la fois par l’idéalisme et l’humanité, sa satire stimulante souvent empreinte d’une beauté poétique singulière ?",
      answers: ["1924","1925","1973","1921"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10489: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1925 pour son œuvre marquée à la fois par l’idéalisme et l’humanité, sa satire stimulante souvent empreinte d’une beauté poétique singulière ?",
      answers: ["Grazia Deledda","William Butler Yeats","George Bernard Shaw","Gabriel García Márquez"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10490: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison George Bernard Shaw a-t-il reçu le Prix Nobel en 1925 ?",
      answers: ["pour ses écrits empreints d’idéalisme décrivant la vie sur son île natale et traitant avec profondeur et sympathie les problèmes humains en général","pour sa poésie","pour son œuvre marquée à la fois par l’idéalisme et l’humanité, sa satire stimulante souvent empreinte d’une beauté poétique singulière","pour sa poésie variée et riche, inspirée par de hauts idéaux"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10491: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie George Bernard Shaw a-t-il reçu le Prix Nobel en 1925 ?",
      answers: ["Physique","Paix","Physiologie ou Médecine","Littérature"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10492: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Austen Chamberlain a-t-il reçu le Prix Nobel de Paix pour son rôle dans les accords de Locarno favorisant la paix en Europe ?",
      answers: ["1924","1925","1947","1934"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10493: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1925 pour son rôle dans les accords de Locarno favorisant la paix en Europe ?",
      answers: ["Ferdinand Buisson","Charles G. Dawes","Austen Chamberlain","Christian Lous Lange"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10494: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Austen Chamberlain a-t-il reçu le Prix Nobel en 1925 ?",
      answers: ["pour son rôle dans les accords de Locarno favorisant la paix en Europe","pour son travail en faveur de la paix et de la conférence sur le désarmement","pour son roman 'Quand les armes se taisent' et son travail en faveur de la paix","pour son travail en faveur de la paix et de la coopération internationale à travers la Société des Nations"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10495: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Austen Chamberlain a-t-il reçu le Prix Nobel en 1925 ?",
      answers: ["Physiologie ou Médecine","Physique","Paix","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10496: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Charles G. Dawes a-t-il reçu le Prix Nobel de Paix pour son rôle dans le plan Dawes visant à stabiliser l’économie allemande et à promouvoir la paix ?",
      answers: ["1925","1926","1922","1967"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10497: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1925 pour son rôle dans le plan Dawes visant à stabiliser l’économie allemande et à promouvoir la paix ?",
      answers: ["Nicholas M. Butler","Charles G. Dawes","Austen Chamberlain","Emily G. Balch"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10498: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Charles G. Dawes a-t-il reçu le Prix Nobel en 1925 ?",
      answers: ["pour leur travail pour la fin pacifique du régime de l’apartheid et pour poser les bases d’une nouvelle Afrique du Sud démocratique","pour leur rôle dans la promotion du droit international et de l’arbitrage","pour son rôle dans le plan Dawes visant à stabiliser l’économie allemande et à promouvoir la paix","pour son travail humanitaire, notamment en faveur des réfugiés et des victimes de la Première Guerre mondiale"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10499: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Charles G. Dawes a-t-il reçu le Prix Nobel en 1925 ?",
      answers: ["Sciences Économiques","Chimie","Paix","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10500: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Jean Perrin a-t-il reçu le Prix Nobel de Physique pour ses travaux sur la structure discontinue de la matière, et en particulier pour sa découverte de l’équilibre de sédimentation ?",
      answers: ["1926","1931","1904","1952"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10501: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1926 pour ses travaux sur la structure discontinue de la matière, et en particulier pour sa découverte de l’équilibre de sédimentation ?",
      answers: ["Jean Perrin","Isidor I. Rabi","Wilhelm C. Röntgen","Gustav Hertz"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10502: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Jean Perrin a-t-il reçu le Prix Nobel en 1926 ?",
      answers: ["pour ses travaux sur la structure discontinue de la matière, et en particulier pour sa découverte de l’équilibre de sédimentation","pour sa méthode de rendre visibles les trajectoires des particules chargées électriquement au moyen de la condensation de la vapeur","pour ses travaux sur le phénomène thermionique et en particulier pour la découverte de la loi qui porte son nom","pour sa découverte du rayonnement X caractéristique des éléments"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10503: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Jean Perrin a-t-il reçu le Prix Nobel en 1926 ?",
      answers: ["Littérature","Chimie","Physique","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10504: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Theodor Svedberg a-t-il reçu le Prix Nobel de Chimie pour ses travaux sur les systèmes dispersés ?",
      answers: ["1929","1946","1927","1926"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10505: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1926 pour ses travaux sur les systèmes dispersés ?",
      answers: ["Theodor Svedberg","Richard A. Zsigmondy","Leopold Ružička","Heinrich O. Wieland"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10506: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Theodor Svedberg a-t-il reçu le Prix Nobel en 1926 ?",
      answers: ["pour leurs recherches sur la fermentation des sucres et les enzymes fermentatives","pour ses travaux sur les systèmes dispersés","pour la découverte et le développement de la protéine fluorescente verte (GFP)","pour ses recherches sur les acides biliaires et les substances apparentées"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10507: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Theodor Svedberg a-t-il reçu le Prix Nobel en 1926 ?",
      answers: ["Physique","Chimie","Physiologie ou Médecine","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10508: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Johannes A.B. Fibiger a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour sa découverte du Spiroptera carcinoma ?",
      answers: ["1925","1907","1926","1932"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10509: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1926 pour sa découverte du Spiroptera carcinoma ?",
      answers: ["Johannes A.B. Fibiger","Alexis Carrel","Tasuku Honjo","Hugo Theorell"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10510: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Johannes A.B. Fibiger a-t-il reçu le Prix Nobel en 1926 ?",
      answers: ["pour ses découvertes concernant la fièvre jaune et comment la combattre","pour sa découverte de la valeur thérapeutique de l’inoculation du paludisme dans le traitement de la paralysie générale","pour sa découverte du Spiroptera carcinoma","pour sa découverte de la nature et du mode d’action de l’enzyme respiratoire"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10511: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Johannes A.B. Fibiger a-t-il reçu le Prix Nobel en 1926 ?",
      answers: ["Paix","Physiologie ou Médecine","Chimie","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10512: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Grazia Deledda a-t-il reçu le Prix Nobel de Littérature pour ses écrits empreints d’idéalisme décrivant la vie sur son île natale et traitant avec profondeur et sympathie les problèmes humains en général ?",
      answers: ["1929","1936","1969","1926"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10513: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1926 pour ses écrits empreints d’idéalisme décrivant la vie sur son île natale et traitant avec profondeur et sympathie les problèmes humains en général ?",
      answers: ["Grazia Deledda","Eugene O’Neill","Henri Bergson","Sigrid Undset"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10514: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Grazia Deledda a-t-il reçu le Prix Nobel en 1926 ?",
      answers: ["pour son renouvellement audacieux et ingénieux de l’art dramatique et scénique","pour ses écrits empreints d’idéalisme décrivant la vie sur son île natale et traitant avec profondeur et sympathie les problèmes humains en général","pour la manière heureuse dont il a poursuivi les traditions honorables du théâtre espagnol","pour sa grande épopée nationale, 'Les Paysans'"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10515: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Grazia Deledda a-t-il reçu le Prix Nobel en 1926 ?",
      answers: ["Physiologie ou Médecine","Littérature","Physique","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10516: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Aristide Briand a-t-il reçu le Prix Nobel de Paix pour son rôle dans les accords de Locarno favorisant la paix en Europe ?",
      answers: ["1951","1926","1927","1991"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10517: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1926 pour son rôle dans les accords de Locarno favorisant la paix en Europe ?",
      answers: ["Ludwig Quidde","Bureau international Nansen pour les réfugiés","Aristide Briand","Ferdinand Buisson"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10518: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Aristide Briand a-t-il reçu le Prix Nobel en 1926 ?",
      answers: ["pour son travail humanitaire, notamment en faveur des réfugiés et des victimes de la Première Guerre mondiale","pour leurs contributions à la réconciliation franco-allemande et à la paix mondiale","pour son rôle dans les accords de Locarno favorisant la paix en Europe","pour leurs contributions à la paix à travers la diplomatie et le mouvement pacifiste"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10519: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Aristide Briand a-t-il reçu le Prix Nobel en 1926 ?",
      answers: ["Sciences Économiques","Physique","Paix","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10520: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Gustav Stresemann a-t-il reçu le Prix Nobel de Paix pour son rôle dans les accords de Locarno favorisant la paix en Europe ?",
      answers: ["1926","1929","1925","1928"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10521: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1926 pour son rôle dans les accords de Locarno favorisant la paix en Europe ?",
      answers: ["Aristide Briand","Gustav Stresemann","Betty Williams","Fridtjof Nansen"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10522: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Gustav Stresemann a-t-il reçu le Prix Nobel en 1926 ?",
      answers: ["pour son rôle dans les accords de Locarno favorisant la paix en Europe","pour son travail humanitaire pendant la Première Guerre mondiale","pour ses efforts importants sur plusieurs continents et pendant plus de trois décennies pour résoudre les conflits internationaux","pour leurs contributions à la réconciliation franco-allemande et à la paix mondiale"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10523: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Gustav Stresemann a-t-il reçu le Prix Nobel en 1926 ?",
      answers: ["Littérature","Chimie","Physiologie ou Médecine","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10524: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Arthur H. Compton a-t-il reçu le Prix Nobel de Physique pour sa découverte de l’effet qui porte son nom ?",
      answers: ["1926","1933","1927","1935"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10525: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1927 pour sa découverte de l’effet qui porte son nom ?",
      answers: ["Philipp Lenard","Max Born","Charles Édouard Guillaume","Arthur H. Compton"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10526: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Arthur H. Compton a-t-il reçu le Prix Nobel en 1927 ?",
      answers: ["pour son invention de régulateurs automatiques destinés à être utilisés avec des accumulateurs de gaz pour l’éclairage des phares et des bouées","pour la découverte du neutron","pour la création de la mécanique quantique, dont l’application a conduit, entre autres, à la découverte des formes allotropiques de l’hydrogène","pour sa découverte de l’effet qui porte son nom"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10527: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Arthur H. Compton a-t-il reçu le Prix Nobel en 1927 ?",
      answers: ["Physiologie ou Médecine","Chimie","Paix","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10528: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Charles T.R. Wilson a-t-il reçu le Prix Nobel de Physique pour sa méthode de rendre visibles les trajectoires des particules chargées électriquement au moyen de la condensation de la vapeur ?",
      answers: ["1924","1927","1925","1932"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10529: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1927 pour sa méthode de rendre visibles les trajectoires des particules chargées électriquement au moyen de la condensation de la vapeur ?",
      answers: ["Owen W. Richardson","Gustav Hertz","Arthur H. Compton","Charles T.R. Wilson"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10530: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Charles T.R. Wilson a-t-il reçu le Prix Nobel en 1927 ?",
      answers: ["pour ses travaux sur le phénomène thermionique et en particulier pour la découverte de la loi qui porte son nom","pour sa contribution au développement de la spectroscopie électronique à haute résolution","pour sa découverte de la nature ondulatoire des électrons","pour sa méthode de rendre visibles les trajectoires des particules chargées électriquement au moyen de la condensation de la vapeur"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10531: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Charles T.R. Wilson a-t-il reçu le Prix Nobel en 1927 ?",
      answers: ["Chimie","Physiologie ou Médecine","Physique","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10532: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Heinrich O. Wieland a-t-il reçu le Prix Nobel de Chimie pour ses recherches sur les acides biliaires et les substances apparentées ?",
      answers: ["1931","1926","1927","1914"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10533: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1927 pour ses recherches sur les acides biliaires et les substances apparentées ?",
      answers: ["Richard M. Willstätter","Heinrich O. Wieland","Arthur Harden","Jaroslav Heyrovský"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10534: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Heinrich O. Wieland a-t-il reçu le Prix Nobel en 1927 ?",
      answers: ["pour ses travaux sur les systèmes dispersés","pour les services rendus par ses recherches sur la constitution des stérols et leur connexion avec les vitamines","pour ses recherches sur les acides biliaires et les substances apparentées","en reconnaissance de leurs contributions à l’invention et au développement des méthodes de synthèse chimique à haute pression"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10535: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Heinrich O. Wieland a-t-il reçu le Prix Nobel en 1927 ?",
      answers: ["Physique","Physiologie ou Médecine","Littérature","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10536: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Julius Wagner-Jauregg a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour sa découverte de la valeur thérapeutique de l’inoculation du paludisme dans le traitement de la paralysie générale ?",
      answers: ["1925","1923","1920","1927"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10537: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1927 pour sa découverte de la valeur thérapeutique de l’inoculation du paludisme dans le traitement de la paralysie générale ?",
      answers: ["Otto Loewi","Haldan K. Hartline","Julius Wagner-Jauregg","Jacques Monod"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10538: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Julius Wagner-Jauregg a-t-il reçu le Prix Nobel en 1927 ?",
      answers: ["pour la découverte de la production de mutations par irradiation aux rayons X","pour sa découverte de la nature et du mode d’action de l’enzyme respiratoire","pour sa découverte de la valeur thérapeutique de l’inoculation du paludisme dans le traitement de la paralysie générale","en reconnaissance de son travail sur la physiologie de la digestion, par lequel la connaissance de cet aspect vital a été transformée et élargie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10539: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Julius Wagner-Jauregg a-t-il reçu le Prix Nobel en 1927 ?",
      answers: ["Chimie","Physiologie ou Médecine","Littérature","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10540: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Henri Bergson a-t-il reçu le Prix Nobel de Littérature en reconnaissance de ses idées riches et vivifiantes et de l’éclatante habileté avec laquelle elles ont été présentées ?",
      answers: ["1928","1927","1924","1945"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10541: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1927 en reconnaissance de ses idées riches et vivifiantes et de l’éclatante habileté avec laquelle elles ont été présentées ?",
      answers: ["Toni Morrison","Bjørnstjerne Bjørnson","J. M. Coetzee","Henri Bergson"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10542: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Henri Bergson a-t-il reçu le Prix Nobel en 1927 ?",
      answers: ["en reconnaissance de ses idées riches et vivifiantes et de l’éclatante habileté avec laquelle elles ont été présentées","pour son art vigoureux et graphique de la description et sa capacité à créer, avec esprit et humour, de nouveaux types de personnages","pour son œuvre marquée à la fois par l’idéalisme et l’humanité, sa satire stimulante souvent empreinte d’une beauté poétique singulière","pour sa grande épopée nationale, 'Les Paysans'"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10543: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Henri Bergson a-t-il reçu le Prix Nobel en 1927 ?",
      answers: ["Physiologie ou Médecine","Chimie","Physique","Littérature"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10544: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Ferdinand Buisson a-t-il reçu le Prix Nobel de Paix pour leurs contributions à la réconciliation franco-allemande et à la paix mondiale ?",
      answers: ["1955","1927","1926","1981"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10545: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1927 pour leurs contributions à la réconciliation franco-allemande et à la paix mondiale ?",
      answers: ["Ludwig Quidde","Ferdinand Buisson","Gustav Stresemann","Nathan Söderblom"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10546: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Ferdinand Buisson a-t-il reçu le Prix Nobel en 1927 ?",
      answers: ["pour son travail humanitaire pendant la Première Guerre mondiale","pour son rôle dans le Pacte Briand-Kellogg, qui visait à renoncer à la guerre comme instrument de politique nationale","pour ses efforts visant à promouvoir la paix à travers la coopération religieuse","pour leurs contributions à la réconciliation franco-allemande et à la paix mondiale"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10547: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Ferdinand Buisson a-t-il reçu le Prix Nobel en 1927 ?",
      answers: ["Chimie","Physique","Paix","Sciences Économiques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10548: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Ludwig Quidde a-t-il reçu le Prix Nobel de Paix pour leurs contributions à la réconciliation franco-allemande et à la paix mondiale ?",
      answers: ["1906","1927","1929","1924"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10549: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1927 pour leurs contributions à la réconciliation franco-allemande et à la paix mondiale ?",
      answers: ["Ludwig Quidde","Tobias M.C. Asser","Fridtjof Nansen","Aristide Briand"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10550: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Ludwig Quidde a-t-il reçu le Prix Nobel en 1927 ?",
      answers: ["pour son rôle dans les accords de Locarno favorisant la paix en Europe","pour leur travail en faveur de la paix et des réformes sociales","pour leurs efforts visant à empêcher l’utilisation militaire de l’énergie nucléaire et à promouvoir son usage pacifique","pour leurs contributions à la réconciliation franco-allemande et à la paix mondiale"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10551: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Ludwig Quidde a-t-il reçu le Prix Nobel en 1927 ?",
      answers: ["Physiologie ou Médecine","Chimie","Paix","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10552: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Owen W. Richardson a-t-il reçu le Prix Nobel de Physique pour ses travaux sur le phénomène thermionique et en particulier pour la découverte de la loi qui porte son nom ?",
      answers: ["1954","1980","1928","1925"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10553: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1928 pour ses travaux sur le phénomène thermionique et en particulier pour la découverte de la loi qui porte son nom ?",
      answers: ["John Bardeen","Dennis Gabor","Owen W. Richardson","Russell A. Hulse"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10554: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Owen W. Richardson a-t-il reçu le Prix Nobel en 1928 ?",
      answers: ["pour ses travaux sur le phénomène thermionique et en particulier pour la découverte de la loi qui porte son nom","pour leur découverte de l’antiproton","pour sa méthode de rendre visibles les trajectoires des particules chargées électriquement au moyen de la condensation de la vapeur","pour la découverte du neutron"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10555: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Owen W. Richardson a-t-il reçu le Prix Nobel en 1928 ?",
      answers: ["Physique","Chimie","Paix","Littérature"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10556: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Adolf O. Windaus a-t-il reçu le Prix Nobel de Chimie pour les services rendus par ses recherches sur la constitution des stérols et leur connexion avec les vitamines ?",
      answers: ["1937","1933","1936","1928"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10557: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1928 pour les services rendus par ses recherches sur la constitution des stérols et leur connexion avec les vitamines ?",
      answers: ["Yves Chauvin","Heinrich O. Wieland","George de Hevesy","Adolf O. Windaus"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10558: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Adolf O. Windaus a-t-il reçu le Prix Nobel en 1928 ?",
      answers: ["pour ses recherches et inventions en chimie agricole et alimentaire, en particulier pour sa méthode de conservation du fourrage","pour le développement de la méthode de métathèse en synthèse organique","pour les services rendus par ses recherches sur la constitution des stérols et leur connexion avec les vitamines","pour leurs recherches sur la fermentation des sucres et les enzymes fermentatives"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10559: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Adolf O. Windaus a-t-il reçu le Prix Nobel en 1928 ?",
      answers: ["Physiologie ou Médecine","Chimie","Sciences Économiques","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10560: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Charles J.H. Nicolle a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour ses travaux sur le typhus ?",
      answers: ["1929","2024","1927","1928"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10561: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1928 pour ses travaux sur le typhus ?",
      answers: ["Julius Wagner-Jauregg","Sir Peter Mansfield","Sir Frederick G. Hopkins","Charles J.H. Nicolle"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10562: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Charles J.H. Nicolle a-t-il reçu le Prix Nobel en 1928 ?",
      answers: ["pour ses découvertes relatives à l’immunité","pour ses travaux sur le typhus","pour sa découverte de la vitamine antineuritique","pour sa découverte du rôle joué par l’hormone du lobe antérieur de l’hypophyse dans le métabolisme des sucres"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10563: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Charles J.H. Nicolle a-t-il reçu le Prix Nobel en 1928 ?",
      answers: ["Physiologie ou Médecine","Littérature","Physique","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10564: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Sigrid Undset a-t-il reçu le Prix Nobel de Littérature principalement pour ses descriptions puissantes de la vie nordique au Moyen Âge ?",
      answers: ["1995","1928","1931","2009"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10565: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1928 principalement pour ses descriptions puissantes de la vie nordique au Moyen Âge ?",
      answers: ["Sigrid Undset","Yasunari Kawabata","Theodor Mommsen","Grazia Deledda"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10566: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Sigrid Undset a-t-il reçu le Prix Nobel en 1928 ?",
      answers: ["pour une œuvre poétique d’une grande luminosité, soutenue par une vision historique, fruit d’un engagement multiculturel","pour sa poésie toujours inspirée, qui donne une expression hautement artistique à l’esprit d’une nation entière","principalement pour ses descriptions puissantes de la vie nordique au Moyen Âge","principalement pour son grand roman, 'Les Buddenbrook', qui est devenu un classique de la littérature contemporaine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10567: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Sigrid Undset a-t-il reçu le Prix Nobel en 1928 ?",
      answers: ["Littérature","Paix","Physique","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10568: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Louis de Broglie a-t-il reçu le Prix Nobel de Physique pour sa découverte de la nature ondulatoire des électrons ?",
      answers: ["1985","1937","1929","1939"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10569: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1929 pour sa découverte de la nature ondulatoire des électrons ?",
      answers: ["Louis de Broglie","Albert Einstein","Enrico Fermi","Frank Wilczek"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10570: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Louis de Broglie a-t-il reçu le Prix Nobel en 1929 ?",
      answers: ["pour sa découverte de la nature ondulatoire des électrons","pour son développement de la méthode photographique pour l’étude des processus nucléaires et ses découvertes concernant les mésons réalisées avec cette méthode","pour leurs recherches pionnières sur la diffusion inélastique profonde des électrons sur les protons et les neutrons liés","pour le développement de la technique du piège à ions"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10571: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Louis de Broglie a-t-il reçu le Prix Nobel en 1929 ?",
      answers: ["Physique","Physiologie ou Médecine","Littérature","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10572: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Arthur Harden a-t-il reçu le Prix Nobel de Chimie pour leurs recherches sur la fermentation des sucres et les enzymes fermentatives ?",
      answers: ["1930","1966","1906","1929"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10573: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1929 pour leurs recherches sur la fermentation des sucres et les enzymes fermentatives ?",
      answers: ["Arthur Harden","Jacobus H. van ’t Hoff","Aziz Sancar","Fritz Pregl"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10574: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Arthur Harden a-t-il reçu le Prix Nobel en 1929 ?",
      answers: ["pour le développement de la cryo-microscopie électronique pour la détermination de la structure à haute résolution des biomolécules en solution","pour ses recherches sur les acides biliaires et les substances apparentées","pour ses recherches sur l’électrophorèse et l’analyse par adsorption, en particulier pour ses découvertes concernant la nature complexe des protéines sériques","pour leurs recherches sur la fermentation des sucres et les enzymes fermentatives"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10575: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Arthur Harden a-t-il reçu le Prix Nobel en 1929 ?",
      answers: ["Sciences Économiques","Paix","Chimie","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10576: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Hans von Euler-Chelpin a-t-il reçu le Prix Nobel de Chimie pour leurs recherches sur la fermentation des sucres et les enzymes fermentatives ?",
      answers: ["1931","1936","1929","1975"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10577: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1929 pour leurs recherches sur la fermentation des sucres et les enzymes fermentatives ?",
      answers: ["Martin Karplus","Carl Bosch","Hans von Euler-Chelpin","Arthur Harden"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10578: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Hans von Euler-Chelpin a-t-il reçu le Prix Nobel en 1929 ?",
      answers: ["pour leurs recherches sur la fermentation des sucres et les enzymes fermentatives","pour ses recherches sur les acides biliaires et les substances apparentées","pour leurs études des réactions chimiques extrêmement rapides, réalisées par des perturbations de l’équilibre","pour le développement de la microscopie à fluorescence à super-résolution"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10579: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Hans von Euler-Chelpin a-t-il reçu le Prix Nobel en 1929 ?",
      answers: ["Sciences Économiques","Paix","Chimie","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10580: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Christiaan Eijkman a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour sa découverte de la vitamine antineuritique ?",
      answers: ["2011","1964","1929","1925"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10581: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1929 pour sa découverte de la vitamine antineuritique ?",
      answers: ["Charles J.H. Nicolle","Karl Landsteiner","Edward C. Kendall","Christiaan Eijkman"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10582: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Christiaan Eijkman a-t-il reçu le Prix Nobel en 1929 ?",
      answers: ["pour ses découvertes en lien avec les processus de combustion biologique, avec une référence spéciale à la vitamine C et à la catalyse de l’acide fumarique","pour leurs découvertes concernant la thérapie par le foie dans les cas d’anémie","pour sa découverte de la vitamine antineuritique","pour sa découverte des vitamines stimulant la croissance"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10583: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Christiaan Eijkman a-t-il reçu le Prix Nobel en 1929 ?",
      answers: ["Physiologie ou Médecine","Chimie","Paix","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10584: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Sir Frederick G. Hopkins a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour sa découverte des vitamines stimulant la croissance ?",
      answers: ["1935","1929","1948","1924"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10585: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1929 pour sa découverte des vitamines stimulant la croissance ?",
      answers: ["Salvador E. Luria","Charles J.H. Nicolle","Sir Frederick G. Hopkins","Albert Szent-Györgyi"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10586: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Sir Frederick G. Hopkins a-t-il reçu le Prix Nobel en 1929 ?",
      answers: ["pour leurs découvertes concernant les hormones du cortex surrénalien, leur structure et leurs effets biologiques","pour sa découverte de l’effet organisateur dans le développement embryonnaire","pour sa découverte des vitamines stimulant la croissance","en reconnaissance de son travail sur l’anaphylaxie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10587: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Sir Frederick G. Hopkins a-t-il reçu le Prix Nobel en 1929 ?",
      answers: ["Littérature","Physique","Physiologie ou Médecine","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10588: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Thomas Mann a-t-il reçu le Prix Nobel de Littérature principalement pour son grand roman, 'Les Buddenbrook', qui est devenu un classique de la littérature contemporaine ?",
      answers: ["1960","1962","1930","1929"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10589: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1929 principalement pour son grand roman, 'Les Buddenbrook', qui est devenu un classique de la littérature contemporaine ?",
      answers: ["Luigi Pirandello","Thomas Mann","Henrik Pontoppidan","Ernest Hemingway"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10590: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Thomas Mann a-t-il reçu le Prix Nobel en 1929 ?",
      answers: ["pour son œuvre monumentale, 'La croissance du sol'","principalement pour son grand roman, 'Les Buddenbrook', qui est devenu un classique de la littérature contemporaine","pour son art narratif passionné qui, enraciné dans la culture et les traditions juives polonaises, donne une portée universelle à la condition humaine","en hommage particulier à son œuvre épique, 'Olympischer Frühling'"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10591: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Thomas Mann a-t-il reçu le Prix Nobel en 1929 ?",
      answers: ["Physiologie ou Médecine","Chimie","Paix","Littérature"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10592: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Frank B. Kellogg a-t-il reçu le Prix Nobel de Paix pour son rôle dans le Pacte Briand-Kellogg, qui visait à renoncer à la guerre comme instrument de politique nationale ?",
      answers: ["2012","1930","1915","1929"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10593: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1929 pour son rôle dans le Pacte Briand-Kellogg, qui visait à renoncer à la guerre comme instrument de politique nationale ?",
      answers: ["Aristide Briand","Albert Schweitzer","Ferdinand Buisson","Frank B. Kellogg"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10594: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Frank B. Kellogg a-t-il reçu le Prix Nobel en 1929 ?",
      answers: ["pour son rôle dans les accords de Locarno favorisant la paix en Europe","pour son rôle dans le Pacte Briand-Kellogg, qui visait à renoncer à la guerre comme instrument de politique nationale","pour leur travail en faveur de la paix et des réformes sociales","pour son travail de longue date en faveur de la paix et de l’arbitrage international"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10595: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Frank B. Kellogg a-t-il reçu le Prix Nobel en 1929 ?",
      answers: ["Physique","Chimie","Physiologie ou Médecine","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10596: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Sir Chandrasekhara V. Raman a-t-il reçu le Prix Nobel de Physique pour ses travaux sur la diffusion de la lumière et pour la découverte de l’effet qui porte son nom ?",
      answers: ["1931","1971","1928","1930"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10597: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1930 pour ses travaux sur la diffusion de la lumière et pour la découverte de l’effet qui porte son nom ?",
      answers: ["Antony Hewish","Sir Chandrasekhara V. Raman","Tsung-Dao Lee","Carl F. Braun"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10598: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Sir Chandrasekhara V. Raman a-t-il reçu le Prix Nobel en 1930 ?",
      answers: ["pour ses travaux sur la diffusion de la lumière et pour la découverte de l’effet qui porte son nom","pour ses découvertes et recherches dans le domaine de la spectroscopie des rayons X","pour ses travaux sur la charge élémentaire de l’électricité et sur l’effet photoélectrique","pour ses travaux sur le phénomène thermionique et en particulier pour la découverte de la loi qui porte son nom"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10599: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Sir Chandrasekhara V. Raman a-t-il reçu le Prix Nobel en 1930 ?",
      answers: ["Physiologie ou Médecine","Chimie","Physique","Paix"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10600: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Hans Fischer a-t-il reçu le Prix Nobel de Chimie pour ses recherches sur la constitution de l’hème et de la chlorophylle et en particulier pour sa synthèse de l’hème ?",
      answers: ["1930","1916","1913","1974"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10601: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1930 pour ses recherches sur la constitution de l’hème et de la chlorophylle et en particulier pour sa synthèse de l’hème ?",
      answers: ["Heinrich O. Wieland","Irving Langmuir","Francis W. Aston","Hans Fischer"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10602: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Hans Fischer a-t-il reçu le Prix Nobel en 1930 ?",
      answers: ["pour leurs recherches sur la fermentation des sucres et les enzymes fermentatives","pour ses recherches sur la constitution de l’hème et de la chlorophylle et en particulier pour sa synthèse de l’hème","pour ses recherches sur les acides biliaires et les substances apparentées","pour ses découvertes dans le domaine de la chimie des macromolécules"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10603: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Hans Fischer a-t-il reçu le Prix Nobel en 1930 ?",
      answers: ["Physiologie ou Médecine","Sciences Économiques","Physique","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10604: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Karl Landsteiner a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour sa découverte des groupes sanguins humains ?",
      answers: ["1928","1924","1964","1930"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10605: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1930 pour sa découverte des groupes sanguins humains ?",
      answers: ["Willem Einthoven","Edward C. Kendall","Sir Frederick G. Hopkins","Karl Landsteiner"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10606: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Karl Landsteiner a-t-il reçu le Prix Nobel en 1930 ?",
      answers: ["pour sa découverte des groupes sanguins humains","pour ses travaux sur le typhus","pour leurs découvertes concernant l’organisation structurelle et fonctionnelle de la cellule","pour la découverte des effets antibactériens du prontosil"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10607: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Karl Landsteiner a-t-il reçu le Prix Nobel en 1930 ?",
      answers: ["Littérature","Physique","Physiologie ou Médecine","Paix"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10608: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Sinclair Lewis a-t-il reçu le Prix Nobel de Littérature pour son art vigoureux et graphique de la description et sa capacité à créer, avec esprit et humour, de nouveaux types de personnages ?",
      answers: ["1922","1930","1924","1934"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10609: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1930 pour son art vigoureux et graphique de la description et sa capacité à créer, avec esprit et humour, de nouveaux types de personnages ?",
      answers: ["Sinclair Lewis","Rabindranath Tagore","John Galsworthy","J. M. Coetzee"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10610: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Sinclair Lewis a-t-il reçu le Prix Nobel en 1930 ?",
      answers: ["principalement pour son grand roman, 'Les Buddenbrook', qui est devenu un classique de la littérature contemporaine","pour son art vigoureux et graphique de la description et sa capacité à créer, avec esprit et humour, de nouveaux types de personnages","pour une œuvre poétique créative qui illumine la condition humaine dans l’univers et la société actuelle","pour son renouvellement audacieux et ingénieux de l’art dramatique et scénique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10611: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Sinclair Lewis a-t-il reçu le Prix Nobel en 1930 ?",
      answers: ["Physique","Paix","Chimie","Littérature"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10612: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Nathan Söderblom a-t-il reçu le Prix Nobel de Paix pour ses efforts visant à promouvoir la paix à travers la coopération religieuse ?",
      answers: ["1927","1928","1933","1930"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10613: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1930 pour ses efforts visant à promouvoir la paix à travers la coopération religieuse ?",
      answers: ["Nathan Söderblom","Carlos Saavedra Lamas","Abiy Ahmed Ali","Frank B. Kellogg"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10614: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Nathan Söderblom a-t-il reçu le Prix Nobel en 1930 ?",
      answers: ["pour son rôle dans le Pacte Briand-Kellogg, qui visait à renoncer à la guerre comme instrument de politique nationale","pour ses efforts visant à promouvoir la paix à travers la coopération religieuse","pour son rôle dans le plan Dawes visant à stabiliser l’économie allemande et à promouvoir la paix","pour son travail humanitaire et son engagement pour la paix et la dignité humaine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10615: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Nathan Söderblom a-t-il reçu le Prix Nobel en 1930 ?",
      answers: ["Sciences Économiques","Littérature","Paix","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10616: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Carl Bosch a-t-il reçu le Prix Nobel de Chimie en reconnaissance de leurs contributions à l’invention et au développement des méthodes de synthèse chimique à haute pression ?",
      answers: ["1931","1991","1933","1932"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10617: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1931 en reconnaissance de leurs contributions à l’invention et au développement des méthodes de synthèse chimique à haute pression ?",
      answers: ["Hans von Euler-Chelpin","Robert S. Mulliken","Carl Bosch","Adolf O. Windaus"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10618: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Carl Bosch a-t-il reçu le Prix Nobel en 1931 ?",
      answers: ["en reconnaissance de leurs contributions à l’invention et au développement des méthodes de synthèse chimique à haute pression","pour sa découverte de l’hydrogène lourd","pour ses recherches sur les caroténoïdes, les flavines et les vitamines A et B2","pour leurs contributions à la détermination des séquences de bases dans les acides nucléiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10619: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Carl Bosch a-t-il reçu le Prix Nobel en 1931 ?",
      answers: ["Paix","Chimie","Physique","Littérature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10620: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Friedrich Bergius a-t-il reçu le Prix Nobel de Chimie en reconnaissance de leurs contributions à l’invention et au développement des méthodes de synthèse chimique à haute pression ?",
      answers: ["1965","1931","1933","1930"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10621: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1931 en reconnaissance de leurs contributions à l’invention et au développement des méthodes de synthèse chimique à haute pression ?",
      answers: ["Carl Bosch","Walther Nernst","Friedrich Bergius","Richard A. Zsigmondy"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10622: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Friedrich Bergius a-t-il reçu le Prix Nobel en 1931 ?",
      answers: ["pour ses travaux sur les systèmes dispersés","en reconnaissance de leurs contributions à l’invention et au développement des méthodes de synthèse chimique à haute pression","pour ses recherches sur les caroténoïdes, les flavines et les vitamines A et B2","pour ses études fondamentales sur la biochimie des acides nucléiques, en particulier l’ADN recombinant"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10623: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Friedrich Bergius a-t-il reçu le Prix Nobel en 1931 ?",
      answers: ["Physiologie ou Médecine","Chimie","Littérature","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10624: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Otto H. Warburg a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour sa découverte de la nature et du mode d’action de l’enzyme respiratoire ?",
      answers: ["2018","1996","1934","1931"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10625: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1931 pour sa découverte de la nature et du mode d’action de l’enzyme respiratoire ?",
      answers: ["Charles R. Richet","Thomas H. Morgan","Otto H. Warburg","Sir Bernard Katz"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10626: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Otto H. Warburg a-t-il reçu le Prix Nobel en 1931 ?",
      answers: ["pour sa découverte des groupes sanguins humains","pour leurs découvertes concernant les fonctions des neurones","pour leurs découvertes concernant le monoxyde d’azote comme molécule de signalisation dans le système cardiovasculaire","pour sa découverte de la nature et du mode d’action de l’enzyme respiratoire"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10627: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Otto H. Warburg a-t-il reçu le Prix Nobel en 1931 ?",
      answers: ["Physique","Paix","Physiologie ou Médecine","Sciences Économiques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10628: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Erik A. Karlfeldt a-t-il reçu le Prix Nobel de Littérature pour sa poésie ?",
      answers: ["1930","1931","1912","1954"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10629: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1931 pour sa poésie ?",
      answers: ["Pearl Buck","William Faulkner","Erik A. Karlfeldt","Władysław Reymont"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10630: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Erik A. Karlfeldt a-t-il reçu le Prix Nobel en 1931 ?",
      answers: ["pour son art distingué de la narration qui trouve sa plus haute expression dans 'La Saga des Forsyte'","pour sa poésie","pour son œuvre marquée à la fois par l’idéalisme et l’humanité, sa satire stimulante souvent empreinte d’une beauté poétique singulière","pour sa poésie variée et riche, inspirée par de hauts idéaux"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10631: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Erik A. Karlfeldt a-t-il reçu le Prix Nobel en 1931 ?",
      answers: ["Physiologie ou Médecine","Physique","Chimie","Littérature"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10632: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Jane Addams a-t-il reçu le Prix Nobel de Paix pour leur travail en faveur de la paix et des réformes sociales ?",
      answers: ["1930","1931","2018","1932"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10633: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1931 pour leur travail en faveur de la paix et des réformes sociales ?",
      answers: ["Kim Dae-jung","Jane Addams","Ferdinand Buisson","Wangari Maathai"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10634: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Jane Addams a-t-il reçu le Prix Nobel en 1931 ?",
      answers: ["pour leur travail en faveur de la paix et des réformes sociales","pour leurs efforts en faveur de la paix à travers le mouvement pacifiste italien et international","pour son rôle dans le plan Dawes visant à stabiliser l’économie allemande et à promouvoir la paix","pour leur travail humanitaire et leurs efforts pour la paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10635: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Jane Addams a-t-il reçu le Prix Nobel en 1931 ?",
      answers: ["Physique","Paix","Chimie","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10636: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Nicholas M. Butler a-t-il reçu le Prix Nobel de Paix pour leur travail en faveur de la paix et des réformes sociales ?",
      answers: ["1930","1967","1931","1953"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10637: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1931 pour leur travail en faveur de la paix et des réformes sociales ?",
      answers: ["Frank B. Kellogg","Nathan Söderblom","Emily G. Balch","Nicholas M. Butler"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10638: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Nicholas M. Butler a-t-il reçu le Prix Nobel en 1931 ?",
      answers: ["pour son rôle dans le Pacte Briand-Kellogg, qui visait à renoncer à la guerre comme instrument de politique nationale","pour leurs contributions à la réconciliation franco-allemande et à la paix mondiale","pour leur travail en faveur de la paix et des réformes sociales","pour son travail humanitaire pendant la Première Guerre mondiale"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10639: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Nicholas M. Butler a-t-il reçu le Prix Nobel en 1931 ?",
      answers: ["Paix","Littérature","Sciences Économiques","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10640: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Werner Heisenberg a-t-il reçu le Prix Nobel de Physique pour la création de la mécanique quantique, dont l’application a conduit, entre autres, à la découverte des formes allotropiques de l’hydrogène ?",
      answers: ["1935","1930","1955","1932"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10641: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1932 pour la création de la mécanique quantique, dont l’application a conduit, entre autres, à la découverte des formes allotropiques de l’hydrogène ?",
      answers: ["Carl D. Anderson","Horst L. Störmer","Werner Heisenberg","Arno Penzias"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10642: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Werner Heisenberg a-t-il reçu le Prix Nobel en 1932 ?",
      answers: ["pour leur découverte expérimentale de la diffraction des électrons par les cristaux","en reconnaissance des services qu’il a rendus à la mesure précise en physique par sa découverte des anomalies des alliages d’acier au nickel","pour avoir découvert que les méthodes développées pour étudier les phénomènes d’ordre dans les systèmes simples peuvent être généralisées à des formes plus complexes de la matière","pour la création de la mécanique quantique, dont l’application a conduit, entre autres, à la découverte des formes allotropiques de l’hydrogène"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10643: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Werner Heisenberg a-t-il reçu le Prix Nobel en 1932 ?",
      answers: ["Littérature","Physique","Physiologie ou Médecine","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10644: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Irving Langmuir a-t-il reçu le Prix Nobel de Chimie pour ses découvertes et recherches dans le domaine de la chimie des surfaces ?",
      answers: ["1932","1935","1931","1937"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10645: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1932 pour ses découvertes et recherches dans le domaine de la chimie des surfaces ?",
      answers: ["Harold C. Urey","Heinrich O. Wieland","Irving Langmuir","Hans von Euler-Chelpin"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10646: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Irving Langmuir a-t-il reçu le Prix Nobel en 1932 ?",
      answers: ["pour ses recherches sur les acides biliaires et les substances apparentées","pour ses développements de méthodes computationnelles en chimie quantique","pour ses découvertes et recherches dans le domaine de la chimie des surfaces","en reconnaissance de son travail sur la liaison des atomes dans les molécules, par lequel il a ouvert de nouveaux champs en chimie inorganique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10647: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Irving Langmuir a-t-il reçu le Prix Nobel en 1932 ?",
      answers: ["Littérature","Paix","Chimie","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10648: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Sir Charles S. Sherrington a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant les fonctions des neurones ?",
      answers: ["1931","1950","1932","1930"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10649: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1932 pour leurs découvertes concernant les fonctions des neurones ?",
      answers: ["Johannes A.B. Fibiger","Otto H. Warburg","Emil A. von Behring","Sir Charles S. Sherrington"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10650: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Sir Charles S. Sherrington a-t-il reçu le Prix Nobel en 1932 ?",
      answers: ["pour leurs découvertes concernant la thérapie par le foie dans les cas d’anémie","pour leurs découvertes concernant les fonctions des neurones","pour ses travaux sur la physiologie, la pathologie et la chirurgie de la glande thyroïde","pour sa découverte des groupes sanguins humains"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10651: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Sir Charles S. Sherrington a-t-il reçu le Prix Nobel en 1932 ?",
      answers: ["Physique","Paix","Physiologie ou Médecine","Sciences Économiques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10652: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Edgar D. Adrian a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant les fonctions des neurones ?",
      answers: ["1959","1913","1932","1927"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10653: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1932 pour leurs découvertes concernant les fonctions des neurones ?",
      answers: ["Edgar D. Adrian","Hermann J. Muller","Johannes A.B. Fibiger","William P. Murphy"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10654: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Edgar D. Adrian a-t-il reçu le Prix Nobel en 1932 ?",
      answers: ["pour leurs découvertes concernant les prostaglandines et les substances biologiquement actives apparentées","pour leurs découvertes concernant les fonctions des neurones","pour leurs découvertes concernant la thérapie par le foie dans les cas d’anémie","pour leurs découvertes concernant la transmission chimique des impulsions nerveuses"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10655: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Edgar D. Adrian a-t-il reçu le Prix Nobel en 1932 ?",
      answers: ["Physiologie ou Médecine","Paix","Chimie","Sciences Économiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10656: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année John Galsworthy a-t-il reçu le Prix Nobel de Littérature pour son art distingué de la narration qui trouve sa plus haute expression dans 'La Saga des Forsyte' ?",
      answers: ["1932","1933","1960","1985"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10657: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1932 pour son art distingué de la narration qui trouve sa plus haute expression dans 'La Saga des Forsyte' ?",
      answers: ["Sigrid Undset","William Butler Yeats","Jacinto Benavente","John Galsworthy"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10658: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison John Galsworthy a-t-il reçu le Prix Nobel en 1932 ?",
      answers: ["principalement en reconnaissance de sa production fructueuse, variée et exceptionnelle dans le domaine de l’art dramatique","pour la vigueur artistique et la profonde indépendance d’esprit avec lesquelles il cherche dans ses écrits des réponses aux questions éternelles de l’humanité","pour l’art rigoureux avec lequel il a développé les traditions de la prose classique russe","pour son art distingué de la narration qui trouve sa plus haute expression dans 'La Saga des Forsyte'"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10659: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie John Galsworthy a-t-il reçu le Prix Nobel en 1932 ?",
      answers: ["Physiologie ou Médecine","Chimie","Littérature","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10660: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Erwin Schrödinger a-t-il reçu le Prix Nobel de Physique pour la découverte de nouvelles formes productives de la théorie atomique ?",
      answers: ["1967","1933","1932","1948"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10661: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1933 pour la découverte de nouvelles formes productives de la théorie atomique ?",
      answers: ["Paul A.M. Dirac","James Chadwick","Brian P. Schmidt","Erwin Schrödinger"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10662: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Erwin Schrödinger a-t-il reçu le Prix Nobel en 1933 ?",
      answers: ["en reconnaissance des services qu’il a rendus à la mesure précise en physique par sa découverte des anomalies des alliages d’acier au nickel","pour ses découvertes concernant la structure fine du spectre de l’hydrogène","pour leurs contributions fondamentales à l’électrodynamique quantique, avec des conséquences profondes pour la physique des particules élémentaires","pour la découverte de nouvelles formes productives de la théorie atomique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10663: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Erwin Schrödinger a-t-il reçu le Prix Nobel en 1933 ?",
      answers: ["Paix","Sciences Économiques","Littérature","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10664: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Paul A.M. Dirac a-t-il reçu le Prix Nobel de Physique pour la découverte de nouvelles formes productives de la théorie atomique ?",
      answers: ["1926","1933","1901","1930"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10665: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1933 pour la découverte de nouvelles formes productives de la théorie atomique ?",
      answers: ["Paul A.M. Dirac","Carl D. Anderson","Subrahmanyan Chandrasekhar","Victor F. Hess"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10666: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Paul A.M. Dirac a-t-il reçu le Prix Nobel en 1933 ?",
      answers: ["pour sa découverte de l’effet qui porte son nom","pour la découverte de la connexion entre le mouvement collectif et le mouvement des particules dans les noyaux atomiques et le développement de la théorie de la structure nucléaire basée sur cette connexion","pour la découverte de nouvelles formes productives de la théorie atomique","pour la création de la mécanique quantique, dont l’application a conduit, entre autres, à la découverte des formes allotropiques de l’hydrogène"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10667: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Paul A.M. Dirac a-t-il reçu le Prix Nobel en 1933 ?",
      answers: ["Chimie","Littérature","Physique","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10668: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Thomas H. Morgan a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour ses découvertes concernant le rôle des chromosomes dans l’hérédité ?",
      answers: ["1931","1934","1927","1933"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10669: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1933 pour ses découvertes concernant le rôle des chromosomes dans l’hérédité ?",
      answers: ["Thomas H. Morgan","Sir Howard Florey","George R. Minot","Otto H. Warburg"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10670: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Thomas H. Morgan a-t-il reçu le Prix Nobel en 1933 ?",
      answers: ["pour ses découvertes concernant le rôle des chromosomes dans l’hérédité","pour leurs découvertes concernant la thérapie par le foie dans les cas d’anémie","pour leurs découvertes concernant les fonctions des neurones","pour ses découvertes en lien avec les processus de combustion biologique, avec une référence spéciale à la vitamine C et à la catalyse de l’acide fumarique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10671: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Thomas H. Morgan a-t-il reçu le Prix Nobel en 1933 ?",
      answers: ["Physiologie ou Médecine","Littérature","Chimie","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10672: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Ivan A. Bunin a-t-il reçu le Prix Nobel de Littérature pour l’art rigoureux avec lequel il a développé les traditions de la prose classique russe ?",
      answers: ["1931","1933","1910","1935"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10673: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1933 pour l’art rigoureux avec lequel il a développé les traditions de la prose classique russe ?",
      answers: ["Carl Spitteler","Ivan A. Bunin","Erik A. Karlfeldt","Juan Ramón Jiménez"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10674: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Ivan A. Bunin a-t-il reçu le Prix Nobel en 1933 ?",
      answers: ["pour l’art rigoureux avec lequel il a développé les traditions de la prose classique russe","pour sa poésie","pour sa compréhension profonde des paysans de son pays et l’art exquis avec lequel il a dépeint leur mode de vie et leur relation avec la nature","pour sa maîtrise narrative qui exprime avec une grande sensibilité l’essence de l’esprit japonais"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10675: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Ivan A. Bunin a-t-il reçu le Prix Nobel en 1933 ?",
      answers: ["Chimie","Sciences Économiques","Physiologie ou Médecine","Littérature"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10676: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Sir Norman Angell a-t-il reçu le Prix Nobel de Paix pour son livre 'La Grande Illusion' et son travail en faveur de la paix internationale ?",
      answers: ["1928","1930","1933","1926"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10677: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1933 pour son livre 'La Grande Illusion' et son travail en faveur de la paix internationale ?",
      answers: ["Ferdinand Buisson","Comité International de la Croix-Rouge","Aristide Briand","Sir Norman Angell"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10678: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Sir Norman Angell a-t-il reçu le Prix Nobel en 1933 ?",
      answers: ["pour son travail de médiation en Palestine en 1948-1949","pour son travail humanitaire en faveur des réfugiés","pour son livre 'La Grande Illusion' et son travail en faveur de la paix internationale","pour ses efforts visant à renforcer la coopération en Europe occidentale et à réconcilier l’Allemagne avec les autres nations"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10679: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Sir Norman Angell a-t-il reçu le Prix Nobel en 1933 ?",
      answers: ["Chimie","Physique","Physiologie ou Médecine","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10680: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année George H. Whipple a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant la thérapie par le foie dans les cas d’anémie ?",
      answers: ["1984","1964","1926","1934"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10681: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1934 pour leurs découvertes concernant la thérapie par le foie dans les cas d’anémie ?",
      answers: ["William G. Kaelin Jr.","Willem Einthoven","George H. Whipple","George R. Minot"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10682: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison George H. Whipple a-t-il reçu le Prix Nobel en 1934 ?",
      answers: ["pour leurs découvertes concernant l’organisation et l’élicitation des schémas de comportement individuels et sociaux","en reconnaissance de ses travaux sur le rôle joué par les protozoaires dans la causation des maladies","pour ses découvertes relatives à l’immunité","pour leurs découvertes concernant la thérapie par le foie dans les cas d’anémie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10683: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie George H. Whipple a-t-il reçu le Prix Nobel en 1934 ?",
      answers: ["Physiologie ou Médecine","Chimie","Paix","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10684: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année George R. Minot a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant la thérapie par le foie dans les cas d’anémie ?",
      answers: ["1906","1924","1932","1934"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10685: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1934 pour leurs découvertes concernant la thérapie par le foie dans les cas d’anémie ?",
      answers: ["George R. Minot","David Baltimore","Otto H. Warburg","Torsten N. Wiesel"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10686: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison George R. Minot a-t-il reçu le Prix Nobel en 1934 ?",
      answers: ["pour leurs découvertes concernant la thérapie par le foie dans les cas d’anémie","pour sa découverte de la vitamine K","pour ses découvertes concernant le rôle des chromosomes dans l’hérédité","pour leurs découvertes sur les récepteurs olfactifs et l’organisation du système olfactif"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10687: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie George R. Minot a-t-il reçu le Prix Nobel en 1934 ?",
      answers: ["Littérature","Physiologie ou Médecine","Physique","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10688: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année William P. Murphy a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant la thérapie par le foie dans les cas d’anémie ?",
      answers: ["2000","1936","1934","1921"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10689: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1934 pour leurs découvertes concernant la thérapie par le foie dans les cas d’anémie ?",
      answers: ["James D. Watson","William P. Murphy","George H. Whipple","George R. Minot"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10690: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison William P. Murphy a-t-il reçu le Prix Nobel en 1934 ?",
      answers: ["pour la découverte de la pénicilline et de son effet curatif dans diverses maladies infectieuses","pour leurs découvertes concernant les fonctions des neurones","pour leurs découvertes concernant la thérapie par le foie dans les cas d’anémie","pour sa découverte de la nature chimique de la vitamine K"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10691: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie William P. Murphy a-t-il reçu le Prix Nobel en 1934 ?",
      answers: ["Chimie","Physique","Physiologie ou Médecine","Sciences Économiques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10692: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Harold C. Urey a-t-il reçu le Prix Nobel de Chimie pour sa découverte de l’hydrogène lourd ?",
      answers: ["1934","1935","1914","1928"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10693: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1934 pour sa découverte de l’hydrogène lourd ?",
      answers: ["Herbert A. Hauptman","Leopold Ružička","Peter J.W. Debye","Harold C. Urey"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10694: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Harold C. Urey a-t-il reçu le Prix Nobel en 1934 ?",
      answers: ["pour sa découverte de l’hydrogène lourd","pour ses recherches biochimiques et sa découverte de la fermentation sans cellules","pour son travail sur l’utilisation des isotopes comme traceurs dans l’étude des processus chimiques","pour ses contributions à notre connaissance de la chimie des substances radioactives et ses recherches sur l’origine et la nature des isotopes"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10695: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Harold C. Urey a-t-il reçu le Prix Nobel en 1934 ?",
      answers: ["Physiologie ou Médecine","Chimie","Physique","Littérature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10696: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Luigi Pirandello a-t-il reçu le Prix Nobel de Littérature pour son renouvellement audacieux et ingénieux de l’art dramatique et scénique ?",
      answers: ["2009","1929","1934","1954"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10697: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1934 pour son renouvellement audacieux et ingénieux de l’art dramatique et scénique ?",
      answers: ["Camilo José Cela","Karl A. Gjellerup","Luigi Pirandello","Derek Walcott"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10698: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Luigi Pirandello a-t-il reçu le Prix Nobel en 1934 ?",
      answers: ["pour son art distingué de la narration qui trouve sa plus haute expression dans 'La Saga des Forsyte'","pour son renouvellement audacieux et ingénieux de l’art dramatique et scénique","pour ses écrits réalistes et imaginatifs, combinant un humour sympathique et une perception sociale aiguë","pour ses descriptions riches et véritablement épiques de la vie paysanne en Chine et pour ses chefs-d’œuvre biographiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10699: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Luigi Pirandello a-t-il reçu le Prix Nobel en 1934 ?",
      answers: ["Paix","Littérature","Physique","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10700: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Arthur Henderson a-t-il reçu le Prix Nobel de Paix pour son travail en faveur de la paix et de la conférence sur le désarmement ?",
      answers: ["1968","1934","1933","1932"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10701: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1934 pour son travail en faveur de la paix et de la conférence sur le désarmement ?",
      answers: ["Ludwig Quidde","Charles G. Dawes","Arthur Henderson","Bureau international Nansen pour les réfugiés"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10702: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Arthur Henderson a-t-il reçu le Prix Nobel en 1934 ?",
      answers: ["pour son travail en faveur de la paix et de la conférence sur le désarmement","pour son combat contre le militarisme en Allemagne","pour son rôle dans la fondation de la Société des Nations","pour ses efforts visant à renforcer la coopération en Europe occidentale et à réconcilier l’Allemagne avec les autres nations"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10703: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Arthur Henderson a-t-il reçu le Prix Nobel en 1934 ?",
      answers: ["Physique","Chimie","Paix","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10704: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année James Chadwick a-t-il reçu le Prix Nobel de Physique pour la découverte du neutron ?",
      answers: ["1922","1936","1912","1935"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10705: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1935 pour la découverte du neutron ?",
      answers: ["Martin Ryle","Tsung-Dao Lee","Dennis Gabor","James Chadwick"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10706: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison James Chadwick a-t-il reçu le Prix Nobel en 1935 ?",
      answers: ["pour sa contribution au développement de la méthode des faisceaux moléculaires et sa découverte du moment magnétique du proton","pour la découverte du neutron","pour la découverte de nouvelles formes productives de la théorie atomique","pour sa découverte de la nature ondulatoire des électrons"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10707: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie James Chadwick a-t-il reçu le Prix Nobel en 1935 ?",
      answers: ["Littérature","Chimie","Physique","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10708: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Frédéric Joliot a-t-il reçu le Prix Nobel de Chimie en reconnaissance de leur synthèse de nouveaux éléments radioactifs ?",
      answers: ["1935","1934","1960","1936"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10709: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1935 en reconnaissance de leur synthèse de nouveaux éléments radioactifs ?",
      answers: ["Marie Curie","Venkatraman Ramakrishnan","Frédéric Joliot","Carl Bosch"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10710: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Frédéric Joliot a-t-il reçu le Prix Nobel en 1935 ?",
      answers: ["pour ses travaux sur les systèmes dispersés","pour la synthèse de l’ammoniac à partir de ses éléments","en reconnaissance de leur synthèse de nouveaux éléments radioactifs","en reconnaissance des services rendus à l’avancement de la chimie par la découverte des éléments radium et polonium"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10711: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Frédéric Joliot a-t-il reçu le Prix Nobel en 1935 ?",
      answers: ["Chimie","Paix","Littérature","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10712: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Irène Joliot-Curie a-t-il reçu le Prix Nobel de Chimie en reconnaissance de leur synthèse de nouveaux éléments radioactifs ?",
      answers: ["1955","1966","1937","1935"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10713: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1935 en reconnaissance de leur synthèse de nouveaux éléments radioactifs ?",
      answers: ["Paul Berg","Ronald G.W. Norrish","Peter J.W. Debye","Irène Joliot-Curie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10714: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Irène Joliot-Curie a-t-il reçu le Prix Nobel en 1935 ?",
      answers: ["pour leurs recherches sur les mécanismes des réactions chimiques","en reconnaissance de leur synthèse de nouveaux éléments radioactifs","pour son travail sur les caroténoïdes et les vitamines","pour leur élucidation du mécanisme enzymatique sous-jacent à la synthèse de l’adénosine triphosphate (ATP)"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10715: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Irène Joliot-Curie a-t-il reçu le Prix Nobel en 1935 ?",
      answers: ["Chimie","Sciences Économiques","Physique","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10716: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Hans Spemann a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour sa découverte de l’effet organisateur dans le développement embryonnaire ?",
      answers: ["1932","1939","1935","1934"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10717: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1935 pour sa découverte de l’effet organisateur dans le développement embryonnaire ?",
      answers: ["Fritz A. Lipmann","Leland H. Hartwell","Hans Spemann","Hermann J. Muller"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10718: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Hans Spemann a-t-il reçu le Prix Nobel en 1935 ?",
      answers: ["pour leurs découvertes concernant la thérapie par le foie dans les cas d’anémie","pour sa découverte de l’effet organisateur dans le développement embryonnaire","pour leur découverte de la capacité du virus de la poliomyélite à se développer dans des cultures de divers types de tissus","pour la découverte de la production de mutations par irradiation aux rayons X"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10719: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Hans Spemann a-t-il reçu le Prix Nobel en 1935 ?",
      answers: ["Paix","Littérature","Physiologie ou Médecine","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10720: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Carl von Ossietzky a-t-il reçu le Prix Nobel de Paix pour son combat contre le militarisme en Allemagne ?",
      answers: ["1935","1905","1955","1995"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10721: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1935 pour son combat contre le militarisme en Allemagne ?",
      answers: ["Bureau international Nansen pour les réfugiés","Andrei Sakharov","Arthur Henderson","Carl von Ossietzky"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10722: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Carl von Ossietzky a-t-il reçu le Prix Nobel en 1935 ?",
      answers: ["pour son travail en faveur de la paix et de la Société des Nations","pour son travail humanitaire exceptionnel pendant la Seconde Guerre mondiale","pour son combat contre le militarisme en Allemagne","pour leur travail visant à promouvoir une solution pacifique au conflit en Irlande du Nord"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10723: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Carl von Ossietzky a-t-il reçu le Prix Nobel en 1935 ?",
      answers: ["Chimie","Physiologie ou Médecine","Paix","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10724: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Victor F. Hess a-t-il reçu le Prix Nobel de Physique pour sa découverte du rayonnement cosmique ?",
      answers: ["1936","1948","1933","1937"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10725: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1936 pour sa découverte du rayonnement cosmique ?",
      answers: ["Wolfgang Ketterle","Carl D. Anderson","Victor F. Hess","James Franck"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10726: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Victor F. Hess a-t-il reçu le Prix Nobel en 1936 ?",
      answers: ["pour sa méthode de rendre visibles les trajectoires des particules chargées électriquement au moyen de la condensation de la vapeur","pour la création de la mécanique quantique, dont l’application a conduit, entre autres, à la découverte des formes allotropiques de l’hydrogène","pour la découverte de la liberté asymptotique dans la théorie de l’interaction forte","pour sa découverte du rayonnement cosmique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10727: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Victor F. Hess a-t-il reçu le Prix Nobel en 1936 ?",
      answers: ["Physique","Chimie","Sciences Économiques","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10728: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Carl D. Anderson a-t-il reçu le Prix Nobel de Physique pour sa découverte du positron ?",
      answers: ["1954","1936","1935","1929"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10729: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1936 pour sa découverte du positron ?",
      answers: ["Carl D. Anderson","Victor F. Hess","William B. Shockley","Percy W. Bridgman"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10730: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Carl D. Anderson a-t-il reçu le Prix Nobel en 1936 ?",
      answers: ["pour leur découverte expérimentale de la diffraction des électrons par les cristaux","pour sa découverte de la nature ondulatoire des électrons","pour sa découverte du positron","pour sa découverte du rayonnement cosmique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10731: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Carl D. Anderson a-t-il reçu le Prix Nobel en 1936 ?",
      answers: ["Paix","Physiologie ou Médecine","Chimie","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10732: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Peter J.W. Debye a-t-il reçu le Prix Nobel de Chimie pour ses contributions à notre connaissance de la structure moléculaire par ses recherches sur les moments dipolaires et la diffraction des rayons X et des électrons dans les gaz ?",
      answers: ["1936","1998","1958","1927"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10733: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1936 pour ses contributions à notre connaissance de la structure moléculaire par ses recherches sur les moments dipolaires et la diffraction des rayons X et des électrons dans les gaz ?",
      answers: ["Peter J.W. Debye","Fritz Haber","Friedrich Bergius","Hans Fischer"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10734: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Peter J.W. Debye a-t-il reçu le Prix Nobel en 1936 ?",
      answers: ["pour ses contributions à notre connaissance de la structure moléculaire par ses recherches sur les moments dipolaires et la diffraction des rayons X et des électrons dans les gaz","pour ses recherches sur la stéréochimie des molécules organiques et des réactions","pour le développement des batteries lithium-ion","pour leurs recherches sur les mécanismes des réactions chimiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10735: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Peter J.W. Debye a-t-il reçu le Prix Nobel en 1936 ?",
      answers: ["Chimie","Sciences Économiques","Physique","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10736: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Sir Henry H. Dale a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant la transmission chimique des impulsions nerveuses ?",
      answers: ["1938","1936","1937","1972"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10737: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1936 pour leurs découvertes concernant la transmission chimique des impulsions nerveuses ?",
      answers: ["William P. Murphy","Alan L. Hodgkin","Sir Henry H. Dale","George H. Whipple"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10738: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Sir Henry H. Dale a-t-il reçu le Prix Nobel en 1936 ?",
      answers: ["pour leurs découvertes concernant le monoxyde d’azote comme molécule de signalisation dans le système cardiovasculaire","pour la découverte du rôle joué par le sinus et les mécanismes aortiques dans la régulation de la respiration","pour ses travaux sur le typhus","pour leurs découvertes concernant la transmission chimique des impulsions nerveuses"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10739: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Sir Henry H. Dale a-t-il reçu le Prix Nobel en 1936 ?",
      answers: ["Paix","Sciences Économiques","Physiologie ou Médecine","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10740: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Otto Loewi a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant la transmission chimique des impulsions nerveuses ?",
      answers: ["1945","1936","1920","1980"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10741: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1936 pour leurs découvertes concernant la transmission chimique des impulsions nerveuses ?",
      answers: ["Robert W. Holley","Otto Loewi","Jack W. Szostak","Richard Axel"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10742: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Otto Loewi a-t-il reçu le Prix Nobel en 1936 ?",
      answers: ["pour leurs découvertes concernant la transmission chimique des impulsions nerveuses","pour ses découvertes concernant le rôle des chromosomes dans l’hérédité","pour la découverte de la pénicilline et de son effet curatif dans diverses maladies infectieuses","pour leurs découvertes concernant la production d’hormones peptidiques dans le cerveau"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10743: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Otto Loewi a-t-il reçu le Prix Nobel en 1936 ?",
      answers: ["Chimie","Physique","Physiologie ou Médecine","Sciences Économiques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10744: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Eugene O’Neill a-t-il reçu le Prix Nobel de Littérature pour la puissance, l’honnêteté et les émotions profondes de ses œuvres dramatiques, qui incarnent un concept original de la tragédie ?",
      answers: ["1939","1947","1936","1937"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10745: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1936 pour la puissance, l’honnêteté et les émotions profondes de ses œuvres dramatiques, qui incarnent un concept original de la tragédie ?",
      answers: ["Eugene O’Neill","Henrik Pontoppidan","Roger Martin du Gard","Eyvind Johnson"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10746: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Eugene O’Neill a-t-il reçu le Prix Nobel en 1936 ?",
      answers: ["pour la puissance, l’honnêteté et les émotions profondes de ses œuvres dramatiques, qui incarnent un concept original de la tragédie","maîtresse de la nouvelle contemporaine","pour son art distingué de la narration qui trouve sa plus haute expression dans 'La Saga des Forsyte'","pour la puissance artistique et la vérité avec lesquelles il a dépeint les conflits humains ainsi que certains aspects fondamentaux de la vie contemporaine dans son cycle romanesque 'Les Thibault'"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10747: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Eugene O’Neill a-t-il reçu le Prix Nobel en 1936 ?",
      answers: ["Physique","Paix","Chimie","Littérature"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10748: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Carlos Saavedra Lamas a-t-il reçu le Prix Nobel de Paix pour son rôle dans la médiation de la paix entre le Paraguay et la Bolivie lors de la guerre du Chaco ?",
      answers: ["1962","1951","1931","1936"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10749: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1936 pour son rôle dans la médiation de la paix entre le Paraguay et la Bolivie lors de la guerre du Chaco ?",
      answers: ["Robert Cecil","Carlos Saavedra Lamas","Mère Teresa","Carl von Ossietzky"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10750: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Carlos Saavedra Lamas a-t-il reçu le Prix Nobel en 1936 ?",
      answers: ["pour sa campagne contre les essais nucléaires et son plaidoyer pour la paix mondiale","pour son travail humanitaire en faveur des réfugiés","pour son rôle dans la médiation de la paix entre le Paraguay et la Bolivie lors de la guerre du Chaco","pour son rôle dans le Plan Marshall et ses efforts pour promouvoir la paix en Europe"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10751: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Carlos Saavedra Lamas a-t-il reçu le Prix Nobel en 1936 ?",
      answers: ["Littérature","Physique","Physiologie ou Médecine","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10752: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Clinton J. Davisson a-t-il reçu le Prix Nobel de Physique pour leur découverte expérimentale de la diffraction des électrons par les cristaux ?",
      answers: ["1928","1946","1934","1937"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10753: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1937 pour leur découverte expérimentale de la diffraction des électrons par les cristaux ?",
      answers: ["Sir William H. Bragg","George P. Thomson","Andre Geim","Clinton J. Davisson"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10754: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Clinton J. Davisson a-t-il reçu le Prix Nobel en 1937 ?",
      answers: ["pour l’invention d’un appareil permettant de produire des pressions extrêmement élevées et pour les découvertes qu’il a réalisées dans le domaine de la physique des hautes pressions","pour leur découverte expérimentale de la diffraction des électrons par les cristaux","en reconnaissance des services extraordinaires qu’ils ont rendus conjointement par leurs recherches sur les phénomènes de rayonnement découverts par le professeur Henri Becquerel","pour la découverte de la liberté asymptotique dans la théorie de l’interaction forte"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10755: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Clinton J. Davisson a-t-il reçu le Prix Nobel en 1937 ?",
      answers: ["Paix","Littérature","Physique","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10756: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année George P. Thomson a-t-il reçu le Prix Nobel de Physique pour leur découverte expérimentale de la diffraction des électrons par les cristaux ?",
      answers: ["1931","1956","1936","1937"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10757: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1937 pour leur découverte expérimentale de la diffraction des électrons par les cristaux ?",
      answers: ["George P. Thomson","Carlo Rubbia","Otto Stern","Samuel C.C. Ting"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10758: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison George P. Thomson a-t-il reçu le Prix Nobel en 1937 ?",
      answers: ["en reconnaissance des grands mérites de ses recherches théoriques et expérimentales sur la conduction de l’électricité par les gaz","pour sa méthode de résonance pour enregistrer les propriétés magnétiques des noyaux atomiques","pour leur découverte expérimentale de la diffraction des électrons par les cristaux","pour leurs contributions décisives au grand projet qui a conduit à la découverte des particules W et Z, messagers de l’interaction faible"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10759: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie George P. Thomson a-t-il reçu le Prix Nobel en 1937 ?",
      answers: ["Sciences Économiques","Chimie","Littérature","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10760: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Walter N. Haworth a-t-il reçu le Prix Nobel de Chimie pour ses recherches sur les glucides et la vitamine C ?",
      answers: ["1937","1938","1918","1921"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10761: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1937 pour ses recherches sur les glucides et la vitamine C ?",
      answers: ["Peter J.W. Debye","Walter N. Haworth","Paul Karrer","Paul D. Boyer"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10762: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Walter N. Haworth a-t-il reçu le Prix Nobel en 1937 ?",
      answers: ["pour ses recherches sur les caroténoïdes, les flavines et les vitamines A et B2","pour ses recherches sur les glucides et la vitamine C","pour ses études fondamentales sur la biochimie des acides nucléiques, en particulier l’ADN recombinant","pour leurs recherches sur la fermentation des sucres et les enzymes fermentatives"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10763: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Walter N. Haworth a-t-il reçu le Prix Nobel en 1937 ?",
      answers: ["Littérature","Chimie","Physiologie ou Médecine","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10764: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Paul Karrer a-t-il reçu le Prix Nobel de Chimie pour ses recherches sur les caroténoïdes, les flavines et les vitamines A et B2 ?",
      answers: ["1996","1915","1937","1932"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10765: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1937 pour ses recherches sur les caroténoïdes, les flavines et les vitamines A et B2 ?",
      answers: ["Paul Karrer","Adolf F.J. Butenandt","Richard Kuhn","Hans Fischer"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10766: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Paul Karrer a-t-il reçu le Prix Nobel en 1937 ?",
      answers: ["pour son travail sur les hormones sexuelles","pour son travail sur la ribonucléase, en particulier concernant la connexion entre la séquence d’acides aminés et la conformation biologiquement active","en reconnaissance des services qu’il a rendus par la découverte des éléments gazeux inertes dans l’air et la détermination de leur place dans le système périodique","pour ses recherches sur les caroténoïdes, les flavines et les vitamines A et B2"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10767: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Paul Karrer a-t-il reçu le Prix Nobel en 1937 ?",
      answers: ["Sciences Économiques","Chimie","Physique","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10768: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Albert Szent-Györgyi a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour ses découvertes en lien avec les processus de combustion biologique, avec une référence spéciale à la vitamine C et à la catalyse de l’acide fumarique ?",
      answers: ["1923","1947","1935","1937"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10769: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1937 pour ses découvertes en lien avec les processus de combustion biologique, avec une référence spéciale à la vitamine C et à la catalyse de l’acide fumarique ?",
      answers: ["Albert Szent-Györgyi","Otto Loewi","Corneille Heymans","Sir Henry H. Dale"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10770: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Albert Szent-Györgyi a-t-il reçu le Prix Nobel en 1937 ?",
      answers: ["pour ses découvertes en lien avec les processus de combustion biologique, avec une référence spéciale à la vitamine C et à la catalyse de l’acide fumarique","pour leurs découvertes concernant le mécanisme et la régulation du métabolisme du cholestérol et des acides gras","pour la découverte des effets antibactériens du prontosil","pour sa découverte de l’effet organisateur dans le développement embryonnaire"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10771: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Albert Szent-Györgyi a-t-il reçu le Prix Nobel en 1937 ?",
      answers: ["Chimie","Physiologie ou Médecine","Sciences Économiques","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10772: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Roger Martin du Gard a-t-il reçu le Prix Nobel de Littérature pour la puissance artistique et la vérité avec lesquelles il a dépeint les conflits humains ainsi que certains aspects fondamentaux de la vie contemporaine dans son cycle romanesque 'Les Thibault' ?",
      answers: ["1962","1937","1938","1921"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10773: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1937 pour la puissance artistique et la vérité avec lesquelles il a dépeint les conflits humains ainsi que certains aspects fondamentaux de la vie contemporaine dans son cycle romanesque 'Les Thibault' ?",
      answers: ["Roger Martin du Gard","Vicente Aleixandre","Pearl Buck","Verner von Heidenstam"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10774: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Roger Martin du Gard a-t-il reçu le Prix Nobel en 1937 ?",
      answers: ["pour la pénétration spirituelle profonde et l’intensité artistique avec lesquelles il a exploré les drames de la vie humaine dans ses romans","pour la puissance, l’honnêteté et les émotions profondes de ses œuvres dramatiques, qui incarnent un concept original de la tragédie","pour sa maîtrise de l’art narratif, récemment démontrée dans Le Vieil Homme et la Mer, et pour l’influence qu’il a exercée sur le style contemporain","pour la puissance artistique et la vérité avec lesquelles il a dépeint les conflits humains ainsi que certains aspects fondamentaux de la vie contemporaine dans son cycle romanesque 'Les Thibault'"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10775: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Roger Martin du Gard a-t-il reçu le Prix Nobel en 1937 ?",
      answers: ["Sciences Économiques","Physiologie ou Médecine","Physique","Littérature"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10776: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Robert Cecil a-t-il reçu le Prix Nobel de Paix pour son travail en faveur de la paix et de la Société des Nations ?",
      answers: ["1947","1929","1934","1937"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10777: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1937 pour son travail en faveur de la paix et de la Société des Nations ?",
      answers: ["Comité International de la Croix-Rouge","Conseil des Amis pour le Service (Quakers britanniques)","Robert Cecil","Bureau international Nansen pour les réfugiés"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10778: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Robert Cecil a-t-il reçu le Prix Nobel en 1937 ?",
      answers: ["pour ses efforts visant à promouvoir la paix à travers la coopération religieuse","pour son combat contre le militarisme en Allemagne","pour son travail en faveur de la paix et de la Société des Nations","pour son rôle dans la médiation de la paix entre le Paraguay et la Bolivie lors de la guerre du Chaco"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10779: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Robert Cecil a-t-il reçu le Prix Nobel en 1937 ?",
      answers: ["Paix","Littérature","Physique","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10780: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Enrico Fermi a-t-il reçu le Prix Nobel de Physique pour sa démonstration de l’existence de nouveaux éléments radioactifs produits par irradiation neutronique et pour sa découverte connexe des réactions nucléaires provoquées par des neutrons lents ?",
      answers: ["1910","1938","1931","1937"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10781: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1938 pour sa démonstration de l’existence de nouveaux éléments radioactifs produits par irradiation neutronique et pour sa découverte connexe des réactions nucléaires provoquées par des neutrons lents ?",
      answers: ["Sir William H. Bragg","Enrico Fermi","Sir Edward Appleton","John R. Schrieffer"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10782: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Enrico Fermi a-t-il reçu le Prix Nobel en 1938 ?",
      answers: ["pour leurs contributions fondamentales à l’électrodynamique quantique, avec des conséquences profondes pour la physique des particules élémentaires","pour l’invention et le développement du cyclotron et pour les résultats obtenus, en particulier en ce qui concerne les éléments radioactifs artificiels","pour leur découverte expérimentale de la diffraction des électrons par les cristaux","pour sa démonstration de l’existence de nouveaux éléments radioactifs produits par irradiation neutronique et pour sa découverte connexe des réactions nucléaires provoquées par des neutrons lents"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10783: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Enrico Fermi a-t-il reçu le Prix Nobel en 1938 ?",
      answers: ["Chimie","Sciences Économiques","Physique","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10784: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Richard Kuhn a-t-il reçu le Prix Nobel de Chimie pour son travail sur les caroténoïdes et les vitamines ?",
      answers: ["1976","1975","1938","1917"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10785: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1938 pour son travail sur les caroténoïdes et les vitamines ?",
      answers: ["Fritz Pregl","Peter J.W. Debye","William H. Stein","Richard Kuhn"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10786: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Richard Kuhn a-t-il reçu le Prix Nobel en 1938 ?",
      answers: ["pour sa découverte, au moyen de son spectromètre de masse, des isotopes dans un grand nombre d’éléments non radioactifs, et pour son énonciation de la règle des nombres entiers","pour ses recherches sur les glucides et la vitamine C","pour ses recherches sur les caroténoïdes, les flavines et les vitamines A et B2","pour son travail sur les caroténoïdes et les vitamines"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10787: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Richard Kuhn a-t-il reçu le Prix Nobel en 1938 ?",
      answers: ["Physiologie ou Médecine","Paix","Physique","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10788: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Corneille Heymans a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour la découverte du rôle joué par le sinus et les mécanismes aortiques dans la régulation de la respiration ?",
      answers: ["1935","1938","1925","1939"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10789: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1938 pour la découverte du rôle joué par le sinus et les mécanismes aortiques dans la régulation de la respiration ?",
      answers: ["Willem Einthoven","Otto H. Warburg","Corneille Heymans","Albert Szent-Györgyi"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10790: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Corneille Heymans a-t-il reçu le Prix Nobel en 1938 ?",
      answers: ["pour leur découverte du cours de la conversion catalytique du glycogène","pour leurs découvertes concernant les mécanismes ioniques impliqués dans l’excitation et l’inhibition dans les parties périphériques et centrales de la membrane des cellules nerveuses","pour la découverte du rôle joué par le sinus et les mécanismes aortiques dans la régulation de la respiration","pour leurs découvertes concernant la régulation du métabolisme du cholestérol"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10791: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Corneille Heymans a-t-il reçu le Prix Nobel en 1938 ?",
      answers: ["Paix","Sciences Économiques","Chimie","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10792: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Pearl Buck a-t-il reçu le Prix Nobel de Littérature pour ses descriptions riches et véritablement épiques de la vie paysanne en Chine et pour ses chefs-d’œuvre biographiques ?",
      answers: ["1971","1966","1925","1938"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10793: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1938 pour ses descriptions riches et véritablement épiques de la vie paysanne en Chine et pour ses chefs-d’œuvre biographiques ?",
      answers: ["William Faulkner","William Golding","Pearl Buck","Bjørnstjerne Bjørnson"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10794: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Pearl Buck a-t-il reçu le Prix Nobel en 1938 ?",
      answers: ["pour la force rare et la fertilité de son imagination poétique avec lesquelles il a combiné une curiosité intellectuelle et un style audacieux et frais","pour la puissance artistique et la vérité avec lesquelles il a dépeint les conflits humains ainsi que certains aspects fondamentaux de la vie contemporaine dans son cycle romanesque 'Les Thibault'","pour sa grande épopée nationale, 'Les Paysans'","pour ses descriptions riches et véritablement épiques de la vie paysanne en Chine et pour ses chefs-d’œuvre biographiques"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10795: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Pearl Buck a-t-il reçu le Prix Nobel en 1938 ?",
      answers: ["Chimie","Littérature","Physiologie ou Médecine","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10796: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Bureau international Nansen pour les réfugiés a-t-il reçu le Prix Nobel de Paix pour son travail humanitaire en faveur des réfugiés ?",
      answers: ["1955","1957","1938","1917"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10797: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1938 pour son travail humanitaire en faveur des réfugiés ?",
      answers: ["Conseil des Amis pour le Service (Quakers britanniques)","Gustav Stresemann","Bureau international Nansen pour les réfugiés","John R. Mott"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10798: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Bureau international Nansen pour les réfugiés a-t-il reçu le Prix Nobel en 1938 ?",
      answers: ["pour son combat contre le militarisme en Allemagne","pour son travail visant à améliorer les conditions de vie des enfants dans le monde","pour son travail de longue date en faveur de la paix et du désarmement","pour son travail humanitaire en faveur des réfugiés"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10799: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Bureau international Nansen pour les réfugiés a-t-il reçu le Prix Nobel en 1938 ?",
      answers: ["Physique","Paix","Chimie","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10800: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Ernest O. Lawrence a-t-il reçu le Prix Nobel de Physique pour l’invention et le développement du cyclotron et pour les résultats obtenus, en particulier en ce qui concerne les éléments radioactifs artificiels ?",
      answers: ["1996","1937","1939","1963"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10801: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1939 pour l’invention et le développement du cyclotron et pour les résultats obtenus, en particulier en ce qui concerne les éléments radioactifs artificiels ?",
      answers: ["Ernest O. Lawrence","Carl D. Anderson","Eugene Wigner","John L. Hall"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10802: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Ernest O. Lawrence a-t-il reçu le Prix Nobel en 1939 ?",
      answers: ["pour sa découverte de l’effet qui porte son nom","pour l’invention et le développement du cyclotron et pour les résultats obtenus, en particulier en ce qui concerne les éléments radioactifs artificiels","pour la découverte du principe d’exclusion, également appelé principe de Pauli","pour sa découverte du rayonnement cosmique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10803: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Ernest O. Lawrence a-t-il reçu le Prix Nobel en 1939 ?",
      answers: ["Sciences Économiques","Physiologie ou Médecine","Chimie","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10804: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Adolf F.J. Butenandt a-t-il reçu le Prix Nobel de Chimie pour son travail sur les hormones sexuelles ?",
      answers: ["1939","1918","1935","1987"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10805: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1939 pour son travail sur les hormones sexuelles ?",
      answers: ["Linus Pauling","Adolf F.J. Butenandt","William F. Giauque","Leopold Ružička"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10806: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Adolf F.J. Butenandt a-t-il reçu le Prix Nobel en 1939 ?",
      answers: ["pour son invention de la méthode de microanalyse des substances organiques","pour leurs recherches sur les mécanismes des réactions chimiques","pour ses recherches sur l’électrophorèse et l’analyse par adsorption, en particulier pour ses découvertes concernant la nature complexe des protéines sériques","pour son travail sur les hormones sexuelles"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10807: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Adolf F.J. Butenandt a-t-il reçu le Prix Nobel en 1939 ?",
      answers: ["Chimie","Littérature","Paix","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10808: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Leopold Ružička a-t-il reçu le Prix Nobel de Chimie pour son travail sur les polyméthylènes et les terpènes supérieurs ?",
      answers: ["1939","1934","1961","1938"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10809: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1939 pour son travail sur les polyméthylènes et les terpènes supérieurs ?",
      answers: ["Alfred Werner","Leopold Ružička","Adolf F.J. Butenandt","Gerhard Herzberg"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10810: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Leopold Ružička a-t-il reçu le Prix Nobel en 1939 ?",
      answers: ["pour leurs théories, développées indépendamment, concernant le cours des réactions chimiques","pour leur préparation d’enzymes et de protéines virales sous une forme pure","pour les services rendus par ses recherches sur la constitution des stérols et leur connexion avec les vitamines","pour son travail sur les polyméthylènes et les terpènes supérieurs"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10811: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Leopold Ružička a-t-il reçu le Prix Nobel en 1939 ?",
      answers: ["Sciences Économiques","Chimie","Physiologie ou Médecine","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10812: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Gerhard Domagk a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour la découverte des effets antibactériens du prontosil ?",
      answers: ["1971","1939","1921","1930"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10813: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1939 pour la découverte des effets antibactériens du prontosil ?",
      answers: ["Joseph Erlanger","Ernst B. Chain","Corneille Heymans","Gerhard Domagk"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10814: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Gerhard Domagk a-t-il reçu le Prix Nobel en 1939 ?",
      answers: ["pour sa découverte de l’efficacité élevée du DDT comme poison de contact contre plusieurs arthropodes","pour la découverte de la pénicilline et de son effet curatif dans diverses maladies infectieuses","pour sa découverte relative à la production de chaleur dans les muscles","pour la découverte des effets antibactériens du prontosil"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10815: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Gerhard Domagk a-t-il reçu le Prix Nobel en 1939 ?",
      answers: ["Physiologie ou Médecine","Sciences Économiques","Littérature","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10816: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Frans E. Sillanpää a-t-il reçu le Prix Nobel de Littérature pour sa compréhension profonde des paysans de son pays et l’art exquis avec lequel il a dépeint leur mode de vie et leur relation avec la nature ?",
      answers: ["1960","1938","1905","1939"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10817: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1939 pour sa compréhension profonde des paysans de son pays et l’art exquis avec lequel il a dépeint leur mode de vie et leur relation avec la nature ?",
      answers: ["Giorgos Seferis","Gabriela Mistral","Pearl Buck","Frans E. Sillanpää"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10818: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Frans E. Sillanpää a-t-il reçu le Prix Nobel en 1939 ?",
      answers: ["pour son art distingué de la narration qui trouve sa plus haute expression dans 'La Saga des Forsyte'","pour la puissance artistique et la vérité avec lesquelles il a dépeint les conflits humains ainsi que certains aspects fondamentaux de la vie contemporaine dans son cycle romanesque 'Les Thibault'","pour sa compréhension profonde des paysans de son pays et l’art exquis avec lequel il a dépeint leur mode de vie et leur relation avec la nature","pour ses romans et nouvelles, dans lesquels le fantastique et le réaliste se combinent dans un monde richement composé d’imagination"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10819: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Frans E. Sillanpää a-t-il reçu le Prix Nobel en 1939 ?",
      answers: ["Paix","Physiologie ou Médecine","Sciences Économiques","Littérature"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10820: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Otto Stern a-t-il reçu le Prix Nobel de Physique pour sa contribution au développement de la méthode des faisceaux moléculaires et sa découverte du moment magnétique du proton ?",
      answers: ["1943","1959","1939","1938"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10821: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1943 pour sa contribution au développement de la méthode des faisceaux moléculaires et sa découverte du moment magnétique du proton ?",
      answers: ["Nils G. Dalén","Arthur H. Compton","Otto Stern","Richard P. Feynman"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10822: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Otto Stern a-t-il reçu le Prix Nobel en 1943 ?",
      answers: ["pour sa contribution au développement de la méthode des faisceaux moléculaires et sa découverte du moment magnétique du proton","pour sa contribution au développement de la spectroscopie électronique à haute résolution","pour leur découverte expérimentale de la diffraction des électrons par les cristaux","pour ses travaux sur les rayons cathodiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10823: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Otto Stern a-t-il reçu le Prix Nobel en 1943 ?",
      answers: ["Physique","Chimie","Paix","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10824: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année George de Hevesy a-t-il reçu le Prix Nobel de Chimie pour son travail sur l’utilisation des isotopes comme traceurs dans l’étude des processus chimiques ?",
      answers: ["1955","1944","1943","1947"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10825: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1943 pour son travail sur l’utilisation des isotopes comme traceurs dans l’étude des processus chimiques ?",
      answers: ["Fritz Pregl","Sir Robert Robinson","George de Hevesy","Paul Karrer"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10826: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison George de Hevesy a-t-il reçu le Prix Nobel en 1943 ?",
      answers: ["pour la détermination de la structure tridimensionnelle d’un centre réactionnel photosynthétique","pour son travail sur l’utilisation des isotopes comme traceurs dans l’étude des processus chimiques","pour leurs recherches sur les mécanismes des réactions chimiques","pour leurs réalisations exceptionnelles dans le développement de méthodes directes pour la détermination des structures cristallines"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10827: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie George de Hevesy a-t-il reçu le Prix Nobel en 1943 ?",
      answers: ["Chimie","Physique","Littérature","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10828: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Henrik Dam a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour sa découverte de la vitamine K ?",
      answers: ["1943","1982","1933","1937"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10829: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1943 pour sa découverte de la vitamine K ?",
      answers: ["Paul H. Müller","Henrik Dam","Herbert S. Gasser","Sir Howard Florey"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10830: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Henrik Dam a-t-il reçu le Prix Nobel en 1943 ?",
      answers: ["pour leurs découvertes concernant le traitement de l’information dans le système visuel","pour leurs découvertes concernant la fonction des canaux ioniques uniques dans les cellules","pour sa découverte de la vitamine K","pour sa découverte de la nature et du mode d’action de l’enzyme respiratoire"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10831: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Henrik Dam a-t-il reçu le Prix Nobel en 1943 ?",
      answers: ["Physiologie ou Médecine","Sciences Économiques","Physique","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10832: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Edward A. Doisy a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour sa découverte de la nature chimique de la vitamine K ?",
      answers: ["1933","1943","1950","1971"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10833: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1943 pour sa découverte de la nature chimique de la vitamine K ?",
      answers: ["Edward A. Doisy","Karl von Frisch","Salvador E. Luria","Henrik Dam"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10834: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Edward A. Doisy a-t-il reçu le Prix Nobel en 1943 ?",
      answers: ["pour sa découverte de la nature chimique de la vitamine K","pour sa découverte de la vitamine K","pour leurs découvertes concernant la thérapie par le foie dans les cas d’anémie","pour leurs découvertes concernant les hormones du cortex surrénalien, leur structure et leurs effets biologiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10835: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Edward A. Doisy a-t-il reçu le Prix Nobel en 1943 ?",
      answers: ["Chimie","Physiologie ou Médecine","Sciences Économiques","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10836: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Isidor I. Rabi a-t-il reçu le Prix Nobel de Physique pour sa méthode de résonance pour enregistrer les propriétés magnétiques des noyaux atomiques ?",
      answers: ["1930","1944","1946","1943"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10837: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1944 pour sa méthode de résonance pour enregistrer les propriétés magnétiques des noyaux atomiques ?",
      answers: ["Isidor I. Rabi","Wolfgang Pauli","Edward M. Purcell","Philip W. Anderson"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10838: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Isidor I. Rabi a-t-il reçu le Prix Nobel en 1944 ?",
      answers: ["en reconnaissance des services extraordinaires qu’ils ont rendus par leurs recherches sur l’influence du magnétisme sur les phénomènes de rayonnement","pour sa méthode de résonance pour enregistrer les propriétés magnétiques des noyaux atomiques","en reconnaissance des services qu’il a rendus à l’avancement de la physique par sa découverte des quanta d’énergie","pour leurs contributions fondamentales à l’électrodynamique quantique, avec des conséquences profondes pour la physique des particules élémentaires"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10839: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Isidor I. Rabi a-t-il reçu le Prix Nobel en 1944 ?",
      answers: ["Chimie","Sciences Économiques","Physique","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10840: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Otto Hahn a-t-il reçu le Prix Nobel de Chimie pour sa découverte de la fission nucléaire des noyaux lourds ?",
      answers: ["1933","1944","1914","1963"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10841: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1944 pour sa découverte de la fission nucléaire des noyaux lourds ?",
      answers: ["Arne W.K. Tiselius","Paul Berg","Otto Hahn","Artturi I. Virtanen"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10842: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Otto Hahn a-t-il reçu le Prix Nobel en 1944 ?",
      answers: ["pour sa découverte et le développement de la méthode d’analyse polarographique","pour le développement de modèles multi-échelles pour les systèmes chimiques complexes","pour sa découverte de la fission nucléaire des noyaux lourds","pour leurs recherches sur les mécanismes des réactions chimiques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10843: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Otto Hahn a-t-il reçu le Prix Nobel en 1944 ?",
      answers: ["Chimie","Paix","Physique","Littérature"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10844: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Joseph Erlanger a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant les fonctions hautement différenciées des fibres nerveuses individuelles ?",
      answers: ["1919","1945","1933","1944"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10845: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1944 pour leurs découvertes concernant les fonctions hautement différenciées des fibres nerveuses individuelles ?",
      answers: ["Herbert S. Gasser","Joseph Erlanger","William C. Campbell","Albert Szent-Györgyi"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10846: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Joseph Erlanger a-t-il reçu le Prix Nobel en 1944 ?",
      answers: ["pour leurs découvertes sur les principes de l’introduction de modifications génétiques spécifiques chez la souris par l’utilisation de cellules souches embryonnaires","pour sa découverte du rôle joué par l’hormone du lobe antérieur de l’hypophyse dans le métabolisme des sucres","pour leurs découvertes concernant les fonctions hautement différenciées des fibres nerveuses individuelles","pour sa découverte de la vitamine K"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10847: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Joseph Erlanger a-t-il reçu le Prix Nobel en 1944 ?",
      answers: ["Physique","Sciences Économiques","Paix","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10848: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Herbert S. Gasser a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant les fonctions hautement différenciées des fibres nerveuses individuelles ?",
      answers: ["1931","1954","1944","2000"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10849: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1944 pour leurs découvertes concernant les fonctions hautement différenciées des fibres nerveuses individuelles ?",
      answers: ["Walter R. Hess","Joseph Erlanger","Thomas H. Morgan","Herbert S. Gasser"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10850: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Herbert S. Gasser a-t-il reçu le Prix Nobel en 1944 ?",
      answers: ["pour leurs découvertes concernant les fonctions hautement différenciées des fibres nerveuses individuelles","pour ses découvertes concernant la nature et le mode d’action des enzymes d’oxydation","pour ses découvertes concernant le rôle des chromosomes dans l’hérédité","pour la découverte de la production de mutations par irradiation aux rayons X"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10851: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Herbert S. Gasser a-t-il reçu le Prix Nobel en 1944 ?",
      answers: ["Littérature","Chimie","Physique","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10852: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Comité International de la Croix-Rouge (CICR) a-t-il reçu le Prix Nobel de Paix pour son travail humanitaire exceptionnel pendant la Seconde Guerre mondiale ?",
      answers: ["1944","1957","1929","1943"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10853: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1944 pour son travail humanitaire exceptionnel pendant la Seconde Guerre mondiale ?",
      answers: ["Comité International de la Croix-Rouge (CICR)","Conseil des Amis pour le Service (Quakers britanniques)","Bureau International du Travail (BIT)","John R. Mott"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10854: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Comité International de la Croix-Rouge (CICR) a-t-il reçu le Prix Nobel en 1944 ?",
      answers: ["pour son travail en faveur de la paix et de la coopération internationale","pour son travail humanitaire exceptionnel pendant la Seconde Guerre mondiale","pour son travail en faveur des réfugiés européens après la Seconde Guerre mondiale","pour ses efforts visant à codifier le droit international et à promouvoir la paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10855: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Comité International de la Croix-Rouge (CICR) a-t-il reçu le Prix Nobel en 1944 ?",
      answers: ["Paix","Physiologie ou Médecine","Chimie","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10856: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Johannes V. Jensen a-t-il reçu le Prix Nobel de Littérature pour la force rare et la fertilité de son imagination poétique avec lesquelles il a combiné une curiosité intellectuelle et un style audacieux et frais ?",
      answers: ["1944","2016","1935","1916"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10857: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1944 pour la force rare et la fertilité de son imagination poétique avec lesquelles il a combiné une curiosité intellectuelle et un style audacieux et frais ?",
      answers: ["Maurice Maeterlinck","Vicente Aleixandre","Eugene O’Neill","Johannes V. Jensen"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10858: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Johannes V. Jensen a-t-il reçu le Prix Nobel en 1944 ?",
      answers: ["pour son renouvellement audacieux et ingénieux de l’art dramatique et scénique","pour sa poésie qui, contre l’arrière-plan de la tradition grecque, dépeint avec une force sensuelle et une clarté intellectuelle la lutte de l’homme moderne pour la liberté et la créativité","pour ses écrits inspirés qui, tout en croissant en audace et en pénétration, illustrent les idéaux humanitaires classiques et les hautes qualités de style","pour la force rare et la fertilité de son imagination poétique avec lesquelles il a combiné une curiosité intellectuelle et un style audacieux et frais"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10859: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Johannes V. Jensen a-t-il reçu le Prix Nobel en 1944 ?",
      answers: ["Physique","Littérature","Chimie","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10860: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Wolfgang Pauli a-t-il reçu le Prix Nobel de Physique pour la découverte du principe d’exclusion, également appelé principe de Pauli ?",
      answers: ["1960","1945","1944","1934"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10861: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1945 pour la découverte du principe d’exclusion, également appelé principe de Pauli ?",
      answers: ["Luis W. Alvarez","Wolfgang Pauli","Patrick M.S. Blackett","Nevill F. Mott"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10862: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Wolfgang Pauli a-t-il reçu le Prix Nobel en 1945 ?",
      answers: ["pour leurs contributions à la théorie unifiée des interactions faible et électromagnétique entre particules élémentaires","pour leurs travaux pionniers dans la découverte d’une nouvelle particule élémentaire lourde","pour l’invention d’un appareil permettant de produire des pressions extrêmement élevées et pour les découvertes qu’il a réalisées dans le domaine de la physique des hautes pressions","pour la découverte du principe d’exclusion, également appelé principe de Pauli"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10863: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Wolfgang Pauli a-t-il reçu le Prix Nobel en 1945 ?",
      answers: ["Physiologie ou Médecine","Paix","Physique","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10864: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Artturi I. Virtanen a-t-il reçu le Prix Nobel de Chimie pour ses recherches et inventions en chimie agricole et alimentaire, en particulier pour sa méthode de conservation du fourrage ?",
      answers: ["1975","1987","1922","1945"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10865: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1945 pour ses recherches et inventions en chimie agricole et alimentaire, en particulier pour sa méthode de conservation du fourrage ?",
      answers: ["James B. Sumner","John H. Northrop","Artturi I. Virtanen","Richard R. Schrock"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10866: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Artturi I. Virtanen a-t-il reçu le Prix Nobel en 1945 ?",
      answers: ["pour leur préparation d’enzymes et de protéines virales sous une forme pure","pour ses recherches et inventions en chimie agricole et alimentaire, en particulier pour sa méthode de conservation du fourrage","pour ses recherches sur les acides biliaires et les substances apparentées","en reconnaissance des services qu’il a rendus à l’avancement de la chimie organique et de l’industrie chimique par ses travaux sur les colorants organiques et les composés hydroaromatiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10867: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Artturi I. Virtanen a-t-il reçu le Prix Nobel en 1945 ?",
      answers: ["Sciences Économiques","Chimie","Paix","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10868: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Sir Alexander Fleming a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour la découverte de la pénicilline et de son effet curatif dans diverses maladies infectieuses ?",
      answers: ["1903","1945","1948","1947"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10869: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1945 pour la découverte de la pénicilline et de son effet curatif dans diverses maladies infectieuses ?",
      answers: ["George H. Hitchings","Nikolaas Tinbergen","Sir Howard Florey","Sir Alexander Fleming"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10870: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Sir Alexander Fleming a-t-il reçu le Prix Nobel en 1945 ?",
      answers: ["pour ses découvertes concernant la fièvre jaune et comment la combattre","pour sa découverte de l’efficacité élevée du DDT comme poison de contact contre plusieurs arthropodes","pour leurs découvertes concernant les fonctions hautement différenciées des fibres nerveuses individuelles","pour la découverte de la pénicilline et de son effet curatif dans diverses maladies infectieuses"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10871: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Sir Alexander Fleming a-t-il reçu le Prix Nobel en 1945 ?",
      answers: ["Chimie","Littérature","Paix","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10872: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Ernst B. Chain a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour la découverte de la pénicilline et de son effet curatif dans diverses maladies infectieuses ?",
      answers: ["1950","1952","1945","1973"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10873: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1945 pour la découverte de la pénicilline et de son effet curatif dans diverses maladies infectieuses ?",
      answers: ["Sir Alexander Fleming","Ernst B. Chain","Albert Szent-Györgyi","Edward A. Doisy"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10874: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Ernst B. Chain a-t-il reçu le Prix Nobel en 1945 ?",
      answers: ["pour la découverte de la pénicilline et de son effet curatif dans diverses maladies infectieuses","pour la découverte de l’insuline","pour la découverte des enzymes de restriction et leur application aux problèmes de génétique moléculaire","pour sa découverte des groupes sanguins humains"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10875: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Ernst B. Chain a-t-il reçu le Prix Nobel en 1945 ?",
      answers: ["Paix","Chimie","Sciences Économiques","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10876: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Sir Howard Florey a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour la découverte de la pénicilline et de son effet curatif dans diverses maladies infectieuses ?",
      answers: ["1988","1945","1950","1986"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10877: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1945 pour la découverte de la pénicilline et de son effet curatif dans diverses maladies infectieuses ?",
      answers: ["Sir Howard Florey","Herbert S. Gasser","Sir Bernard Katz","Hermann J. Muller"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10878: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Sir Howard Florey a-t-il reçu le Prix Nobel en 1945 ?",
      answers: ["pour la découverte des enzymes de restriction et leur application aux problèmes de génétique moléculaire","pour la découverte de la pénicilline et de son effet curatif dans diverses maladies infectieuses","pour sa découverte de la vitamine K","pour leurs découvertes concernant les fonctions des neurones"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10879: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Sir Howard Florey a-t-il reçu le Prix Nobel en 1945 ?",
      answers: ["Physique","Physiologie ou Médecine","Chimie","Littérature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10880: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Gabriela Mistral a-t-il reçu le Prix Nobel de Littérature pour sa poésie lyrique qui, inspirée par des émotions puissantes, a fait de son nom un symbole des aspirations idéalistes de tout le monde latino-américain ?",
      answers: ["1968","1983","1945","1948"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10881: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1945 pour sa poésie lyrique qui, inspirée par des émotions puissantes, a fait de son nom un symbole des aspirations idéalistes de tout le monde latino-américain ?",
      answers: ["Gabriela Mistral","Eugene O’Neill","André Gide","Peter Handke"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10882: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Gabriela Mistral a-t-il reçu le Prix Nobel en 1945 ?",
      answers: ["pour sa poésie qui, contre l’arrière-plan de la tradition grecque, dépeint avec une force sensuelle et une clarté intellectuelle la lutte de l’homme moderne pour la liberté et la créativité","pour sa poésie lyrique, qui constitue un exemple de haute spiritualité et de pureté artistique en langue espagnole","pour sa poésie lyrique qui, inspirée par des émotions puissantes, a fait de son nom un symbole des aspirations idéalistes de tout le monde latino-américain","pour sa poésie toujours inspirée, qui donne une expression hautement artistique à l’esprit d’une nation entière"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10883: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Gabriela Mistral a-t-il reçu le Prix Nobel en 1945 ?",
      answers: ["Littérature","Physique","Sciences Économiques","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10884: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Percy W. Bridgman a-t-il reçu le Prix Nobel de Physique pour l’invention d’un appareil permettant de produire des pressions extrêmement élevées et pour les découvertes qu’il a réalisées dans le domaine de la physique des hautes pressions ?",
      answers: ["1945","1948","1946","1957"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10885: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1946 pour l’invention d’un appareil permettant de produire des pressions extrêmement élevées et pour les découvertes qu’il a réalisées dans le domaine de la physique des hautes pressions ?",
      answers: ["Hideki Yukawa","Percy W. Bridgman","Ernest O. Lawrence","George P. Thomson"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10886: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Percy W. Bridgman a-t-il reçu le Prix Nobel en 1946 ?",
      answers: ["pour l’invention d’un appareil permettant de produire des pressions extrêmement élevées et pour les découvertes qu’il a réalisées dans le domaine de la physique des hautes pressions","pour sa découverte de l’effet Doppler dans les rayons canaux et de la séparation des lignes spectrales dans les champs électriques","pour son développement de la méthode de la chambre à brouillard de Wilson et ses découvertes dans les domaines de la physique nucléaire et des rayons cosmiques","pour la découverte des violations de principes fondamentaux de symétrie dans la désintégration des mésons K neutres"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10887: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Percy W. Bridgman a-t-il reçu le Prix Nobel en 1946 ?",
      answers: ["Paix","Chimie","Physiologie ou Médecine","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10888: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année James B. Sumner a-t-il reçu le Prix Nobel de Chimie pour sa découverte que les enzymes peuvent être cristallisées ?",
      answers: ["2009","1953","1946","1927"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10889: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1946 pour sa découverte que les enzymes peuvent être cristallisées ?",
      answers: ["George de Hevesy","Peter J.W. Debye","James B. Sumner","Alan G. MacDiarmid"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10890: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison James B. Sumner a-t-il reçu le Prix Nobel en 1946 ?",
      answers: ["pour sa découverte que les enzymes peuvent être cristallisées","pour la technique de phage display des peptides et des anticorps","pour leur préparation d’enzymes et de protéines virales sous une forme pure","pour ses études sur la structure des boranes éclairant les problèmes de liaison chimique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10891: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie James B. Sumner a-t-il reçu le Prix Nobel en 1946 ?",
      answers: ["Littérature","Chimie","Physique","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10892: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année John H. Northrop a-t-il reçu le Prix Nobel de Chimie pour leur préparation d’enzymes et de protéines virales sous une forme pure ?",
      answers: ["2019","1957","1946","1945"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10893: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1946 pour leur préparation d’enzymes et de protéines virales sous une forme pure ?",
      answers: ["Richard M. Willstätter","Arne W.K. Tiselius","Koichi Tanaka","John H. Northrop"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10894: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison John H. Northrop a-t-il reçu le Prix Nobel en 1946 ?",
      answers: ["pour ses recherches sur les pigments végétaux, en particulier la chlorophylle","pour leur découverte des propriétés catalytiques de l’ARN","pour leur préparation d’enzymes et de protéines virales sous une forme pure","pour sa découverte que les enzymes peuvent être cristallisées"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10895: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie John H. Northrop a-t-il reçu le Prix Nobel en 1946 ?",
      answers: ["Chimie","Littérature","Sciences Économiques","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10896: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Wendell M. Stanley a-t-il reçu le Prix Nobel de Chimie pour leur préparation d’enzymes et de protéines virales sous une forme pure ?",
      answers: ["1944","1946","1919","1945"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10897: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1946 pour leur préparation d’enzymes et de protéines virales sous une forme pure ?",
      answers: ["Wilhelm Ostwald","Giulio Natta","John H. Northrop","Wendell M. Stanley"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10898: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Wendell M. Stanley a-t-il reçu le Prix Nobel en 1946 ?",
      answers: ["pour leurs études des réactions chimiques extrêmement rapides, réalisées par des perturbations de l’équilibre","pour le développement de la microscopie à fluorescence à super-résolution","pour ses recherches sur l’électrophorèse et l’analyse par adsorption, en particulier pour ses découvertes concernant la nature complexe des protéines sériques","pour leur préparation d’enzymes et de protéines virales sous une forme pure"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10899: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Wendell M. Stanley a-t-il reçu le Prix Nobel en 1946 ?",
      answers: ["Physique","Paix","Chimie","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10900: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Hermann J. Muller a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour la découverte de la production de mutations par irradiation aux rayons X ?",
      answers: ["1939","1946","1947","1932"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10901: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1946 pour la découverte de la production de mutations par irradiation aux rayons X ?",
      answers: ["Bernardo A. Houssay","Ernst B. Chain","Hermann J. Muller","Howard M. Temin"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10902: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Hermann J. Muller a-t-il reçu le Prix Nobel en 1946 ?",
      answers: ["pour ses recherches et découvertes concernant la tuberculose","pour la découverte de la production de mutations par irradiation aux rayons X","pour la découverte du virus de l’hépatite C","pour ses découvertes en lien avec les processus de combustion biologique, avec une référence spéciale à la vitamine C et à la catalyse de l’acide fumarique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10903: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Hermann J. Muller a-t-il reçu le Prix Nobel en 1946 ?",
      answers: ["Chimie","Physique","Paix","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10904: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Emily G. Balch a-t-il reçu le Prix Nobel de Paix pour son travail en faveur de la paix et de la coopération internationale ?",
      answers: ["1948","1946","1954","1967"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10905: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1946 pour son travail en faveur de la paix et de la coopération internationale ?",
      answers: ["Emily G. Balch","Conseil des Amis pour le Service (Quakers britanniques)","Philip Noel-Baker","John R. Mott"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10906: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Emily G. Balch a-t-il reçu le Prix Nobel en 1946 ?",
      answers: ["pour son rôle dans la création de la Société des Nations et ses efforts pour la paix","pour son travail dans la promotion de la paix à travers les organisations religieuses et humanitaires","pour son rôle dans les accords de Locarno favorisant la paix en Europe","pour son travail en faveur de la paix et de la coopération internationale"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10907: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Emily G. Balch a-t-il reçu le Prix Nobel en 1946 ?",
      answers: ["Chimie","Physiologie ou Médecine","Sciences Économiques","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10908: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année John R. Mott a-t-il reçu le Prix Nobel de Paix pour son travail dans la promotion de la paix à travers les organisations religieuses et humanitaires ?",
      answers: ["1946","1939","1963","1938"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10909: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1946 pour son travail dans la promotion de la paix à travers les organisations religieuses et humanitaires ?",
      answers: ["Emily G. Balch","Lord John Boyd Orr","Malala Yousafzai","John R. Mott"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10910: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison John R. Mott a-t-il reçu le Prix Nobel en 1946 ?",
      answers: ["pour leurs négociations conjointes ayant conduit à un cessez-le-feu au Vietnam","pour son travail humanitaire et son engagement pour la paix et la dignité humaine","pour son travail dans la promotion de la paix à travers les organisations religieuses et humanitaires","pour sa campagne contre les essais nucléaires et son plaidoyer pour la paix mondiale"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10911: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie John R. Mott a-t-il reçu le Prix Nobel en 1946 ?",
      answers: ["Littérature","Paix","Chimie","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10912: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Hermann Hesse a-t-il reçu le Prix Nobel de Littérature pour ses écrits inspirés qui, tout en croissant en audace et en pénétration, illustrent les idéaux humanitaires classiques et les hautes qualités de style ?",
      answers: ["1981","1945","1946","1958"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10913: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1946 pour ses écrits inspirés qui, tout en croissant en audace et en pénétration, illustrent les idéaux humanitaires classiques et les hautes qualités de style ?",
      answers: ["Winston Churchill","William Faulkner","Hermann Hesse","Joseph Brodsky"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10914: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Hermann Hesse a-t-il reçu le Prix Nobel en 1946 ?",
      answers: ["pour sa maîtrise de l’art narratif, récemment démontrée dans Le Vieil Homme et la Mer, et pour l’influence qu’il a exercée sur le style contemporain","pour la force rare et la fertilité de son imagination poétique avec lesquelles il a combiné une curiosité intellectuelle et un style audacieux et frais","pour sa poésie lyrique qui, inspirée par des émotions puissantes, a fait de son nom un symbole des aspirations idéalistes de tout le monde latino-américain","pour ses écrits inspirés qui, tout en croissant en audace et en pénétration, illustrent les idéaux humanitaires classiques et les hautes qualités de style"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10915: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Hermann Hesse a-t-il reçu le Prix Nobel en 1946 ?",
      answers: ["Paix","Sciences Économiques","Littérature","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10916: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Sir Edward Appleton a-t-il reçu le Prix Nobel de Physique pour ses investigations sur la physique de la haute atmosphère, en particulier pour la découverte de la couche dite Appleton ?",
      answers: ["1948","1947","1916","1975"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10917: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1947 pour ses investigations sur la physique de la haute atmosphère, en particulier pour la découverte de la couche dite Appleton ?",
      answers: ["Percy W. Bridgman","Polykarp Kusch","Sir Edward Appleton","Burton Richter"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10918: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Sir Edward Appleton a-t-il reçu le Prix Nobel en 1947 ?",
      answers: ["pour sa contribution décisive à la physique des particules élémentaires, en particulier la découverte d’un grand nombre d’états de résonance","pour leur développement de nouvelles méthodes pour la mesure précise des propriétés magnétiques nucléaires","pour leur découverte des lois régissant l’impact d’un électron sur un atome","pour ses investigations sur la physique de la haute atmosphère, en particulier pour la découverte de la couche dite Appleton"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10919: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Sir Edward Appleton a-t-il reçu le Prix Nobel en 1947 ?",
      answers: ["Paix","Physique","Chimie","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10920: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Sir Robert Robinson a-t-il reçu le Prix Nobel de Chimie pour ses recherches sur les produits végétaux d’importance biologique, en particulier les alcaloïdes ?",
      answers: ["1944","1947","1945","1949"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10921: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1947 pour ses recherches sur les produits végétaux d’importance biologique, en particulier les alcaloïdes ?",
      answers: ["James B. Sumner","Sir Robert Robinson","William F. Giauque","M. Stanley Whittingham"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10922: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Sir Robert Robinson a-t-il reçu le Prix Nobel en 1947 ?",
      answers: ["pour leur préparation d’enzymes et de protéines virales sous une forme pure","pour des études mécanistiques sur la réparation de l’ADN","pour son travail sur la ribonucléase, en particulier concernant la connexion entre la séquence d’acides aminés et la conformation biologiquement active","pour ses recherches sur les produits végétaux d’importance biologique, en particulier les alcaloïdes"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10923: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Sir Robert Robinson a-t-il reçu le Prix Nobel en 1947 ?",
      answers: ["Physiologie ou Médecine","Chimie","Physique","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10924: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Carl F. Cori a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leur découverte du cours de la conversion catalytique du glycogène ?",
      answers: ["1930","1901","1947","1948"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10925: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1947 pour leur découverte du cours de la conversion catalytique du glycogène ?",
      answers: ["António Egas Moniz","Edward C. Kendall","Philip S. Hench","Carl F. Cori"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10926: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Carl F. Cori a-t-il reçu le Prix Nobel en 1947 ?",
      answers: ["pour sa découverte de la valeur thérapeutique de la lobotomie dans certaines psychoses","pour leur découverte du cours de la conversion catalytique du glycogène","pour la découverte de la production de mutations par irradiation aux rayons X","pour sa découverte de l’efficacité élevée du DDT comme poison de contact contre plusieurs arthropodes"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10927: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Carl F. Cori a-t-il reçu le Prix Nobel en 1947 ?",
      answers: ["Physiologie ou Médecine","Sciences Économiques","Chimie","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10928: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Gerty T. Cori a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leur découverte du cours de la conversion catalytique du glycogène ?",
      answers: ["1925","1946","1947","1907"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10929: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1947 pour leur découverte du cours de la conversion catalytique du glycogène ?",
      answers: ["Carl F. Cori","Paul H. Müller","Günter Blobel","Gerty T. Cori"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10930: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Gerty T. Cori a-t-il reçu le Prix Nobel en 1947 ?",
      answers: ["pour la découverte de la pénicilline et de son effet curatif dans diverses maladies infectieuses","pour leur découverte du cours de la conversion catalytique du glycogène","pour leurs découvertes concernant les hormones du cortex surrénalien, leur structure et leurs effets biologiques","pour la découverte du principe de production d’anticorps monoclonaux"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10931: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Gerty T. Cori a-t-il reçu le Prix Nobel en 1947 ?",
      answers: ["Littérature","Sciences Économiques","Physiologie ou Médecine","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10932: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Bernardo A. Houssay a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour sa découverte du rôle joué par l’hormone du lobe antérieur de l’hypophyse dans le métabolisme des sucres ?",
      answers: ["1946","1947","1989","1955"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10933: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1947 pour sa découverte du rôle joué par l’hormone du lobe antérieur de l’hypophyse dans le métabolisme des sucres ?",
      answers: ["Gerhard Domagk","Bernardo A. Houssay","Tadeus Reichstein","Haldan K. Hartline"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10934: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Bernardo A. Houssay a-t-il reçu le Prix Nobel en 1947 ?",
      answers: ["pour leurs découvertes concernant la thérapie par le foie dans les cas d’anémie","pour leur découverte du cours de la conversion catalytique du glycogène","pour la découverte de la pénicilline et de son effet curatif dans diverses maladies infectieuses","pour sa découverte du rôle joué par l’hormone du lobe antérieur de l’hypophyse dans le métabolisme des sucres"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10935: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Bernardo A. Houssay a-t-il reçu le Prix Nobel en 1947 ?",
      answers: ["Sciences Économiques","Littérature","Physiologie ou Médecine","Paix"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10936: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Conseil des Amis pour le Service (Quakers britanniques) a-t-il reçu le Prix Nobel de Paix pour leur travail humanitaire et leurs efforts pour la paix ?",
      answers: ["1947","1968","1944","1948"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10937: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1947 pour leur travail humanitaire et leurs efforts pour la paix ?",
      answers: ["Comité Américain des Amis pour le Service (Quakers américains)","Conseil des Amis pour le Service (Quakers britanniques)","Gustav Stresemann","John R. Mott"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10938: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Conseil des Amis pour le Service (Quakers britanniques) a-t-il reçu le Prix Nobel en 1947 ?",
      answers: ["pour son travail humanitaire en faveur des réfugiés","pour leur travail humanitaire et leurs efforts pour la paix","pour son travail dans la promotion de la paix à travers les organisations religieuses et humanitaires","pour son travail de médiation en Palestine en 1948-1949"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10939: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Conseil des Amis pour le Service (Quakers britanniques) a-t-il reçu le Prix Nobel en 1947 ?",
      answers: ["Physique","Physiologie ou Médecine","Paix","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10940: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Comité Américain des Amis pour le Service (Quakers américains) a-t-il reçu le Prix Nobel de Paix pour leur travail humanitaire et leurs efforts pour la paix ?",
      answers: ["1949","1995","1947","1982"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10941: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1947 pour leur travail humanitaire et leurs efforts pour la paix ?",
      answers: ["Carlos Saavedra Lamas","Ludwig Quidde","Jean H. Dunant","Comité Américain des Amis pour le Service (Quakers américains)"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10942: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Comité Américain des Amis pour le Service (Quakers américains) a-t-il reçu le Prix Nobel en 1947 ?",
      answers: ["pour son travail en faveur de la paix et de la coopération internationale","pour leur travail humanitaire et leurs efforts pour la paix","pour son rôle de leader dans la défense non violente des droits humains en Amérique latine","pour son travail en faveur de la paix et des droits des travailleurs"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10943: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Comité Américain des Amis pour le Service (Quakers américains) a-t-il reçu le Prix Nobel en 1947 ?",
      answers: ["Physique","Littérature","Physiologie ou Médecine","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10944: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année André Gide a-t-il reçu le Prix Nobel de Littérature pour ses écrits approfondis et artistiquement significatifs dans lesquels les problèmes et conditions humaines sont présentés avec un amour intrépide de la vérité ?",
      answers: ["1965","1947","1950","2001"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10945: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1947 pour ses écrits approfondis et artistiquement significatifs dans lesquels les problèmes et conditions humaines sont présentés avec un amour intrépide de la vérité ?",
      answers: ["Hermann Hesse","André Gide","Winston Churchill","Pär Lagerkvist"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10946: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison André Gide a-t-il reçu le Prix Nobel en 1947 ?",
      answers: ["pour avoir créé de nouvelles expressions poétiques dans la grande tradition de la chanson américaine","pour sa contribution exceptionnelle et pionnière à la poésie contemporaine","pour sa maîtrise de l’art narratif, récemment démontrée dans Le Vieil Homme et la Mer, et pour l’influence qu’il a exercée sur le style contemporain","pour ses écrits approfondis et artistiquement significatifs dans lesquels les problèmes et conditions humaines sont présentés avec un amour intrépide de la vérité"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10947: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie André Gide a-t-il reçu le Prix Nobel en 1947 ?",
      answers: ["Physiologie ou Médecine","Chimie","Paix","Littérature"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10948: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Patrick M.S. Blackett a-t-il reçu le Prix Nobel de Physique pour son développement de la méthode de la chambre à brouillard de Wilson et ses découvertes dans les domaines de la physique nucléaire et des rayons cosmiques ?",
      answers: ["1948","1929","1950","1946"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10949: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1948 pour son développement de la méthode de la chambre à brouillard de Wilson et ses découvertes dans les domaines de la physique nucléaire et des rayons cosmiques ?",
      answers: ["Robert Hofstadter","Patrick M.S. Blackett","Joseph H. Taylor Jr.","Sir Edward Appleton"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10950: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Patrick M.S. Blackett a-t-il reçu le Prix Nobel en 1948 ?",
      answers: ["pour ses recherches fondamentales en mécanique quantique, en particulier pour son interprétation statistique de la fonction d’onde","pour sa prédiction de l’existence des mésons sur la base de travaux théoriques sur les forces nucléaires","pour leur théorie développée conjointement de la supraconductivité, généralement appelée la théorie BCS","pour son développement de la méthode de la chambre à brouillard de Wilson et ses découvertes dans les domaines de la physique nucléaire et des rayons cosmiques"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10951: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Patrick M.S. Blackett a-t-il reçu le Prix Nobel en 1948 ?",
      answers: ["Chimie","Physique","Paix","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10952: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Arne W.K. Tiselius a-t-il reçu le Prix Nobel de Chimie pour ses recherches sur l’électrophorèse et l’analyse par adsorption, en particulier pour ses découvertes concernant la nature complexe des protéines sériques ?",
      answers: ["1949","1948","1936","1950"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10953: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1948 pour ses recherches sur l’électrophorèse et l’analyse par adsorption, en particulier pour ses découvertes concernant la nature complexe des protéines sériques ?",
      answers: ["George de Hevesy","Artturi I. Virtanen","John H. Northrop","Arne W.K. Tiselius"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10954: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Arne W.K. Tiselius a-t-il reçu le Prix Nobel en 1948 ?",
      answers: ["pour son travail sur les réactions d’hydrogénation catalysées de manière chirale","pour son travail sur les nucléotides et les coenzymes nucléotidiques","pour ses recherches sur l’électrophorèse et l’analyse par adsorption, en particulier pour ses découvertes concernant la nature complexe des protéines sériques","pour ses contributions dans le domaine de la thermodynamique chimique, en particulier concernant le comportement des substances à des températures extrêmement basses"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10955: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Arne W.K. Tiselius a-t-il reçu le Prix Nobel en 1948 ?",
      answers: ["Littérature","Physiologie ou Médecine","Chimie","Paix"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10956: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Paul H. Müller a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour sa découverte de l’efficacité élevée du DDT comme poison de contact contre plusieurs arthropodes ?",
      answers: ["1946","1948","1988","1947"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10957: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1948 pour sa découverte de l’efficacité élevée du DDT comme poison de contact contre plusieurs arthropodes ?",
      answers: ["Andrew Z. Fire","Paul H. Müller","Thomas H. Weller","Karl Landsteiner"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10958: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Paul H. Müller a-t-il reçu le Prix Nobel en 1948 ?",
      answers: ["pour leurs découvertes concernant les fonctions hautement différenciées des fibres nerveuses individuelles","pour sa découverte du rôle joué par l’hormone du lobe antérieur de l’hypophyse dans le métabolisme des sucres","pour sa découverte de l’efficacité élevée du DDT comme poison de contact contre plusieurs arthropodes","pour la découverte de la pénicilline et de son effet curatif dans diverses maladies infectieuses"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10959: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Paul H. Müller a-t-il reçu le Prix Nobel en 1948 ?",
      answers: ["Chimie","Physiologie ou Médecine","Paix","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10960: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année T.S. Eliot a-t-il reçu le Prix Nobel de Littérature pour sa contribution exceptionnelle et pionnière à la poésie contemporaine ?",
      answers: ["1904","1947","1928","1948"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10961: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1948 pour sa contribution exceptionnelle et pionnière à la poésie contemporaine ?",
      answers: ["T.S. Eliot","Heinrich Böll","André Gide","Pär Lagerkvist"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10962: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison T.S. Eliot a-t-il reçu le Prix Nobel en 1948 ?",
      answers: ["pour sa contribution puissante et artistiquement unique à la fiction américaine contemporaine","pour ses écrits approfondis et artistiquement significatifs dans lesquels les problèmes et conditions humaines sont présentés avec un amour intrépide de la vérité","pour la force rare et la fertilité de son imagination poétique avec lesquelles il a combiné une curiosité intellectuelle et un style audacieux et frais","pour sa contribution exceptionnelle et pionnière à la poésie contemporaine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10963: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie T.S. Eliot a-t-il reçu le Prix Nobel en 1948 ?",
      answers: ["Littérature","Chimie","Physique","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10964: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Hideki Yukawa a-t-il reçu le Prix Nobel de Physique pour sa prédiction de l’existence des mésons sur la base de travaux théoriques sur les forces nucléaires ?",
      answers: ["1949","1948","1947","1982"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10965: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1949 pour sa prédiction de l’existence des mésons sur la base de travaux théoriques sur les forces nucléaires ?",
      answers: ["Hideki Yukawa","James Chadwick","Maria Goeppert-Mayer","John J. Hopfield"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10966: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Hideki Yukawa a-t-il reçu le Prix Nobel en 1949 ?",
      answers: ["pour sa prédiction de l’existence des mésons sur la base de travaux théoriques sur les forces nucléaires","pour la découverte du principe d’exclusion, également appelé principe de Pauli","pour leurs travaux pionniers sur la transmutation des noyaux atomiques par des particules accélérées artificiellement","pour leurs contributions fondamentales à l’électrodynamique quantique, avec des conséquences profondes pour la physique des particules élémentaires"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10967: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Hideki Yukawa a-t-il reçu le Prix Nobel en 1949 ?",
      answers: ["Chimie","Physiologie ou Médecine","Physique","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10968: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année William F. Giauque a-t-il reçu le Prix Nobel de Chimie pour ses contributions dans le domaine de la thermodynamique chimique, en particulier concernant le comportement des substances à des températures extrêmement basses ?",
      answers: ["1946","1903","1949","1950"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10969: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1949 pour ses contributions dans le domaine de la thermodynamique chimique, en particulier concernant le comportement des substances à des températures extrêmement basses ?",
      answers: ["Walter Gilbert","Paul J. Flory","Artturi I. Virtanen","William F. Giauque"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10970: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison William F. Giauque a-t-il reçu le Prix Nobel en 1949 ?",
      answers: ["pour leur découverte des fullerènes","pour leurs découvertes dans la chimie des éléments transuraniens","pour ses contributions dans le domaine de la thermodynamique chimique, en particulier concernant le comportement des substances à des températures extrêmement basses","pour la découverte et le développement des polymères conducteurs"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10971: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie William F. Giauque a-t-il reçu le Prix Nobel en 1949 ?",
      answers: ["Physique","Littérature","Chimie","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10972: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Walter R. Hess a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour sa découverte de l’organisation fonctionnelle du cerveau moyen en tant que coordinateur des activités des organes internes ?",
      answers: ["1939","1948","1949","1950"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10973: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1949 pour sa découverte de l’organisation fonctionnelle du cerveau moyen en tant que coordinateur des activités des organes internes ?",
      answers: ["George E. Palade","Werner Forssmann","António Egas Moniz","Walter R. Hess"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10974: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Walter R. Hess a-t-il reçu le Prix Nobel en 1949 ?",
      answers: ["pour sa découverte de l’organisation fonctionnelle du cerveau moyen en tant que coordinateur des activités des organes internes","pour sa découverte de la valeur thérapeutique de la lobotomie dans certaines psychoses","pour sa découverte de la streptomycine, le premier antibiotique efficace contre la tuberculose","pour leurs découvertes concernant les fonctions hautement différenciées des fibres nerveuses individuelles"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10975: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Walter R. Hess a-t-il reçu le Prix Nobel en 1949 ?",
      answers: ["Physiologie ou Médecine","Physique","Littérature","Sciences Économiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10976: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année António Egas Moniz a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour sa découverte de la valeur thérapeutique de la lobotomie dans certaines psychoses ?",
      answers: ["2018","1949","1944","2004"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10977: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1949 pour sa découverte de la valeur thérapeutique de la lobotomie dans certaines psychoses ?",
      answers: ["Alan L. Hodgkin","António Egas Moniz","Severo Ochoa","Daniel Bovet"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10978: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison António Egas Moniz a-t-il reçu le Prix Nobel en 1949 ?",
      answers: ["pour sa découverte de la streptomycine, le premier antibiotique efficace contre la tuberculose","pour sa découverte de la valeur thérapeutique de la lobotomie dans certaines psychoses","pour leurs découvertes concernant les hormones du cortex surrénalien, leur structure et leurs effets biologiques","pour leurs découvertes concernant les fonctions hautement différenciées des fibres nerveuses individuelles"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10979: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie António Egas Moniz a-t-il reçu le Prix Nobel en 1949 ?",
      answers: ["Paix","Physiologie ou Médecine","Physique","Littérature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10980: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Lord John Boyd Orr a-t-il reçu le Prix Nobel de Paix pour son travail visant à promouvoir la paix à travers l’amélioration de la nutrition mondiale ?",
      answers: ["1949","1937","1950","1948"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10981: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1949 pour son travail visant à promouvoir la paix à travers l’amélioration de la nutrition mondiale ?",
      answers: ["Ligue des Sociétés de la Croix-Rouge","Memorial","Léon Jouhaux","Lord John Boyd Orr"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10982: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Lord John Boyd Orr a-t-il reçu le Prix Nobel en 1949 ?",
      answers: ["pour son travail humanitaire exceptionnel pendant la Seconde Guerre mondiale","pour son travail en faveur des réfugiés européens après la Seconde Guerre mondiale","pour son travail visant à promouvoir la paix à travers l’amélioration de la nutrition mondiale","pour son livre 'La Grande Illusion' et son travail en faveur de la paix internationale"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10983: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Lord John Boyd Orr a-t-il reçu le Prix Nobel en 1949 ?",
      answers: ["Chimie","Paix","Physiologie ou Médecine","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10984: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année William Faulkner a-t-il reçu le Prix Nobel de Littérature pour sa contribution puissante et artistiquement unique à la fiction américaine contemporaine ?",
      answers: ["1960","1949","1952","1944"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10985: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1949 pour sa contribution puissante et artistiquement unique à la fiction américaine contemporaine ?",
      answers: ["Gabriel García Márquez","William Faulkner","Frans E. Sillanpää","Winston Churchill"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10986: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison William Faulkner a-t-il reçu le Prix Nobel en 1949 ?",
      answers: ["pour sa contribution exceptionnelle et pionnière à la poésie contemporaine","pour la vigueur artistique et la profonde indépendance d’esprit avec lesquelles il cherche dans ses écrits des réponses aux questions éternelles de l’humanité","qui, avec un réalisme hallucinatoire, fusionne contes populaires, histoire et contemporain","pour sa contribution puissante et artistiquement unique à la fiction américaine contemporaine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10987: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie William Faulkner a-t-il reçu le Prix Nobel en 1949 ?",
      answers: ["Physiologie ou Médecine","Sciences Économiques","Chimie","Littérature"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10988: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Otto Diels a-t-il reçu le Prix Nobel de Chimie pour leur découverte et le développement de la synthèse par diène ?",
      answers: ["1956","1953","1950","1948"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10989: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1950 pour leur découverte et le développement de la synthèse par diène ?",
      answers: ["Richard L.M. Synge","Otto Diels","Aaron Klug","Artturi I. Virtanen"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10990: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Otto Diels a-t-il reçu le Prix Nobel en 1950 ?",
      answers: ["pour leur élucidation du mécanisme enzymatique sous-jacent à la synthèse de l’adénosine triphosphate (ATP)","pour leurs contributions au développement du concept de conformation et son application en chimie","pour leur découverte et le développement de la synthèse par diène","pour leur préparation d’enzymes et de protéines virales sous une forme pure"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10991: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Otto Diels a-t-il reçu le Prix Nobel en 1950 ?",
      answers: ["Littérature","Physique","Chimie","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10992: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Kurt Alder a-t-il reçu le Prix Nobel de Chimie pour leur découverte et le développement de la synthèse par diène ?",
      answers: ["1950","1907","1943","1952"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10993: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1950 pour leur découverte et le développement de la synthèse par diène ?",
      answers: ["Svante A. Arrhenius","Kurt Alder","Richard Kuhn","Otto Diels"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id10994: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Kurt Alder a-t-il reçu le Prix Nobel en 1950 ?",
      answers: ["pour leur découverte et le développement de la synthèse par diène","pour leur invention de la chromatographie de partage","pour leurs découvertes dans la chimie des éléments transuraniens","pour ses travaux sur les systèmes dispersés"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10995: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Kurt Alder a-t-il reçu le Prix Nobel en 1950 ?",
      answers: ["Physiologie ou Médecine","Littérature","Sciences Économiques","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10996: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Cecil F. Powell a-t-il reçu le Prix Nobel de Physique pour son développement de la méthode photographique pour l’étude des processus nucléaires et ses découvertes concernant les mésons réalisées avec cette méthode ?",
      answers: ["1950","1949","1929","1939"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id10997: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1950 pour son développement de la méthode photographique pour l’étude des processus nucléaires et ses découvertes concernant les mésons réalisées avec cette méthode ?",
      answers: ["John D. Cockcroft","Sir Edward Appleton","F. Duncan M. Haldane","Cecil F. Powell"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id10998: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Cecil F. Powell a-t-il reçu le Prix Nobel en 1950 ?",
      answers: ["pour leur découverte des lois régissant l’impact d’un électron sur un atome","pour leurs travaux pionniers sur la transmutation des noyaux atomiques par des particules accélérées artificiellement","pour son développement de la méthode photographique pour l’étude des processus nucléaires et ses découvertes concernant les mésons réalisées avec cette méthode","pour sa découverte du positron"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id10999: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Cecil F. Powell a-t-il reçu le Prix Nobel en 1950 ?",
      answers: ["Paix","Littérature","Chimie","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11000: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Philip S. Hench a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant les hormones du cortex surrénalien, leur structure et leurs effets biologiques ?",
      answers: ["1948","1945","1949","1950"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11001: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1950 pour leurs découvertes concernant les hormones du cortex surrénalien, leur structure et leurs effets biologiques ?",
      answers: ["Fritz A. Lipmann","Tadeus Reichstein","Philip S. Hench","Max Theiler"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11002: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Philip S. Hench a-t-il reçu le Prix Nobel en 1950 ?",
      answers: ["pour leurs découvertes concernant les hormones du cortex surrénalien, leur structure et leurs effets biologiques","pour leurs découvertes concernant de nouveaux mécanismes d’origine et de dissémination des maladies infectieuses","pour sa découverte de l’organisation fonctionnelle du cerveau moyen en tant que coordinateur des activités des organes internes","pour leurs découvertes concernant le cathétérisme cardiaque et les changements pathologiques dans le système circulatoire"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11003: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Philip S. Hench a-t-il reçu le Prix Nobel en 1950 ?",
      answers: ["Physiologie ou Médecine","Physique","Littérature","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11004: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Edward C. Kendall a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant les hormones du cortex surrénalien, leur structure et leurs effets biologiques ?",
      answers: ["1970","1956","1950","1967"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11005: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1950 pour leurs découvertes concernant les hormones du cortex surrénalien, leur structure et leurs effets biologiques ?",
      answers: ["Selman A. Waksman","Paul H. Müller","Tadeus Reichstein","Edward C. Kendall"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11006: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Edward C. Kendall a-t-il reçu le Prix Nobel en 1950 ?",
      answers: ["pour la découverte des enzymes de restriction et leur application aux problèmes de génétique moléculaire","pour sa découverte de la valeur thérapeutique de la lobotomie dans certaines psychoses","pour leurs découvertes concernant les hormones du cortex surrénalien, leur structure et leurs effets biologiques","pour leur découverte du cours de la conversion catalytique du glycogène"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11007: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Edward C. Kendall a-t-il reçu le Prix Nobel en 1950 ?",
      answers: ["Physique","Physiologie ou Médecine","Chimie","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11008: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Tadeus Reichstein a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant les hormones du cortex surrénalien, leur structure et leurs effets biologiques ?",
      answers: ["1974","1950","1936","1914"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11009: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1950 pour leurs découvertes concernant les hormones du cortex surrénalien, leur structure et leurs effets biologiques ?",
      answers: ["John F. Enders","Tadeus Reichstein","David Baltimore","James D. Watson"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11010: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Tadeus Reichstein a-t-il reçu le Prix Nobel en 1950 ?",
      answers: ["pour leurs découvertes concernant la thérapie par le foie dans les cas d’anémie","pour leur découverte du cours de la conversion catalytique du glycogène","pour leurs découvertes concernant les hormones du cortex surrénalien, leur structure et leurs effets biologiques","pour leur découverte de la capacité du virus de la poliomyélite à se développer dans des cultures de divers types de tissus"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11011: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Tadeus Reichstein a-t-il reçu le Prix Nobel en 1950 ?",
      answers: ["Chimie","Physique","Littérature","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11012: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Ralph Bunche a-t-il reçu le Prix Nobel de Paix pour son travail de médiation en Palestine en 1948-1949 ?",
      answers: ["1922","1950","1937","2007"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11013: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1950 pour son travail de médiation en Palestine en 1948-1949 ?",
      answers: ["Comité Américain des Amis pour le Service (Quakers américains)","George C. Marshall","Ralph Bunche","Comité International de la Croix-Rouge (CICR)"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11014: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Ralph Bunche a-t-il reçu le Prix Nobel en 1950 ?",
      answers: ["pour leur travail humanitaire et leurs efforts pour la paix","pour son roman 'Quand les armes se taisent' et son travail en faveur de la paix","pour son travail de médiation en Palestine en 1948-1949","pour son travail en faveur de la paix en Amérique centrale"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11015: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Ralph Bunche a-t-il reçu le Prix Nobel en 1950 ?",
      answers: ["Chimie","Physique","Physiologie ou Médecine","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11016: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année William Faulkner a-t-il reçu le Prix Nobel de Littérature pour sa contribution puissante et artistiquement unique à la fiction américaine contemporaine ?",
      answers: ["1935","1949","1971","1950"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11017: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1950 pour sa contribution puissante et artistiquement unique à la fiction américaine contemporaine ?",
      answers: ["Patrick White","Kenzaburo Oe","William Faulkner","Erik A. Karlfeldt"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11018: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison William Faulkner a-t-il reçu le Prix Nobel en 1950 ?",
      answers: ["pour la force rare et la fertilité de son imagination poétique avec lesquelles il a combiné une curiosité intellectuelle et un style audacieux et frais","pour sa contribution puissante et artistiquement unique à la fiction américaine contemporaine","pour avoir uni une prose narrative perceptive à un regard incorruptible dans des œuvres qui nous obligent à voir la présence d’histoires supprimées","pour son art distingué de la narration qui trouve sa plus haute expression dans 'La Saga des Forsyte'"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11019: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie William Faulkner a-t-il reçu le Prix Nobel en 1950 ?",
      answers: ["Physique","Paix","Littérature","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11020: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année John D. Cockcroft a-t-il reçu le Prix Nobel de Physique pour leurs travaux pionniers sur la transmutation des noyaux atomiques par des particules accélérées artificiellement ?",
      answers: ["1950","1949","1936","1951"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11021: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1951 pour leurs travaux pionniers sur la transmutation des noyaux atomiques par des particules accélérées artificiellement ?",
      answers: ["Willis E. Lamb","Ernest T.S. Walton","Cecil F. Powell","John D. Cockcroft"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11022: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison John D. Cockcroft a-t-il reçu le Prix Nobel en 1951 ?",
      answers: ["pour ses contributions et découvertes concernant la classification des particules élémentaires et leurs interactions","pour l’invention d’un capteur d’imagerie à semi-conducteur – le capteur CCD","pour leur percée importante dans la découverte de la supraconductivité dans les matériaux céramiques","pour leurs travaux pionniers sur la transmutation des noyaux atomiques par des particules accélérées artificiellement"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11023: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie John D. Cockcroft a-t-il reçu le Prix Nobel en 1951 ?",
      answers: ["Physique","Chimie","Physiologie ou Médecine","Littérature"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11024: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Ernest T.S. Walton a-t-il reçu le Prix Nobel de Physique pour leurs travaux pionniers sur la transmutation des noyaux atomiques par des particules accélérées artificiellement ?",
      answers: ["1950","1997","1977","1951"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11025: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1951 pour leurs travaux pionniers sur la transmutation des noyaux atomiques par des particules accélérées artificiellement ?",
      answers: ["Ernest T.S. Walton","Eric A. Cornell","Sir Edward Appleton","Enrico Fermi"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11026: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Ernest T.S. Walton a-t-il reçu le Prix Nobel en 1951 ?",
      answers: ["pour leurs découvertes concernant la structure en couches du noyau atomique","pour leurs travaux pionniers sur la transmutation des noyaux atomiques par des particules accélérées artificiellement","pour l’invention d’un appareil permettant de produire des pressions extrêmement élevées et pour les découvertes qu’il a réalisées dans le domaine de la physique des hautes pressions","pour leurs recherches sur les semi-conducteurs et leur découverte de l’effet transistor"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11027: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Ernest T.S. Walton a-t-il reçu le Prix Nobel en 1951 ?",
      answers: ["Physiologie ou Médecine","Paix","Chimie","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11028: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Edwin M. McMillan a-t-il reçu le Prix Nobel de Chimie pour leurs découvertes dans la chimie des éléments transuraniens ?",
      answers: ["1951","2022","1949","1971"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11029: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1951 pour leurs découvertes dans la chimie des éléments transuraniens ?",
      answers: ["Sir Robert Robinson","Glenn T. Seaborg","Kurt Alder","Edwin M. McMillan"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11030: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Edwin M. McMillan a-t-il reçu le Prix Nobel en 1951 ?",
      answers: ["pour leur découverte et le développement de la synthèse par diène","pour leurs découvertes dans la chimie des éléments transuraniens","pour leur préparation d’enzymes et de protéines virales sous une forme pure","pour ses contributions dans le domaine de la thermodynamique chimique, en particulier concernant le comportement des substances à des températures extrêmement basses"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11031: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Edwin M. McMillan a-t-il reçu le Prix Nobel en 1951 ?",
      answers: ["Chimie","Physiologie ou Médecine","Physique","Littérature"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11032: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Glenn T. Seaborg a-t-il reçu le Prix Nobel de Chimie pour leurs découvertes dans la chimie des éléments transuraniens ?",
      answers: ["1946","1968","1960","1951"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11033: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1951 pour leurs découvertes dans la chimie des éléments transuraniens ?",
      answers: ["Glenn T. Seaborg","Giulio Natta","Edwin M. McMillan","Roald Hoffmann"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11034: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Glenn T. Seaborg a-t-il reçu le Prix Nobel en 1951 ?",
      answers: ["pour son travail sur l’utilisation des isotopes comme traceurs dans l’étude des processus chimiques","pour leurs découvertes dans la chimie des éléments transuraniens","pour le développement de la microscopie à fluorescence à super-résolution","pour sa découverte des nucléotides sucrés et leur rôle dans la biosynthèse des glucides"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11035: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Glenn T. Seaborg a-t-il reçu le Prix Nobel en 1951 ?",
      answers: ["Littérature","Physique","Sciences Économiques","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11036: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Max Theiler a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour ses découvertes concernant la fièvre jaune et comment la combattre ?",
      answers: ["1985","1993","1958","1951"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11037: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1951 pour ses découvertes concernant la fièvre jaune et comment la combattre ?",
      answers: ["D. Carleton Gajdusek","Max Theiler","Richard Axel","Selman A. Waksman"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11038: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Max Theiler a-t-il reçu le Prix Nobel en 1951 ?",
      answers: ["pour leur découverte de la capacité du virus de la poliomyélite à se développer dans des cultures de divers types de tissus","pour leurs découvertes concernant le cathétérisme cardiaque et les changements pathologiques dans le système circulatoire","pour leurs découvertes concernant les hormones du cortex surrénalien, leur structure et leurs effets biologiques","pour ses découvertes concernant la fièvre jaune et comment la combattre"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11039: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Max Theiler a-t-il reçu le Prix Nobel en 1951 ?",
      answers: ["Chimie","Littérature","Physique","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11040: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Léon Jouhaux a-t-il reçu le Prix Nobel de Paix pour son travail en faveur de la paix et des droits des travailleurs ?",
      answers: ["1933","1917","1951","1952"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11041: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1951 pour son travail en faveur de la paix et des droits des travailleurs ?",
      answers: ["Jean H. Dunant","Léon Jouhaux","Arthur Henderson","Dominique Pire"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11042: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Léon Jouhaux a-t-il reçu le Prix Nobel en 1951 ?",
      answers: ["pour son travail en faveur de la paix et des droits des travailleurs","pour son travail de médiation en Palestine en 1948-1949","pour son travail en faveur des réfugiés européens après la Seconde Guerre mondiale","pour leurs contributions à la réconciliation franco-allemande et à la paix mondiale"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11043: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Léon Jouhaux a-t-il reçu le Prix Nobel en 1951 ?",
      answers: ["Physiologie ou Médecine","Sciences Économiques","Littérature","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11044: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Pär Lagerkvist a-t-il reçu le Prix Nobel de Littérature pour la vigueur artistique et la profonde indépendance d’esprit avec lesquelles il cherche dans ses écrits des réponses aux questions éternelles de l’humanité ?",
      answers: ["2024","1951","1953","1959"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11045: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1951 pour la vigueur artistique et la profonde indépendance d’esprit avec lesquelles il cherche dans ses écrits des réponses aux questions éternelles de l’humanité ?",
      answers: ["John Galsworthy","François Mauriac","Louise Glück","Pär Lagerkvist"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11046: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Pär Lagerkvist a-t-il reçu le Prix Nobel en 1951 ?",
      answers: ["pour la vigueur artistique et la profonde indépendance d’esprit avec lesquelles il cherche dans ses écrits des réponses aux questions éternelles de l’humanité","pour sa contribution puissante et artistiquement unique à la fiction américaine contemporaine","pour sa contribution exceptionnelle et pionnière à la poésie contemporaine","en appréciation de l’idéalisme élevé, de l’imagination vive et de la perception spirituelle qui caractérisent ses écrits"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11047: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Pär Lagerkvist a-t-il reçu le Prix Nobel en 1951 ?",
      answers: ["Physique","Physiologie ou Médecine","Littérature","Sciences Économiques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11048: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Felix Bloch a-t-il reçu le Prix Nobel de Physique pour leur développement de nouvelles méthodes pour la mesure précise des propriétés magnétiques nucléaires ?",
      answers: ["2001","1952","1951","1965"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11049: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1952 pour leur développement de nouvelles méthodes pour la mesure précise des propriétés magnétiques nucléaires ?",
      answers: ["Paul A.M. Dirac","Felix Bloch","Edward M. Purcell","Carl D. Anderson"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11050: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Felix Bloch a-t-il reçu le Prix Nobel en 1952 ?",
      answers: ["pour la découverte du principe d’exclusion, également appelé principe de Pauli","pour le développement de semi-conducteurs utilisés dans l’électronique à haute vitesse et l’optoélectronique","pour des expériences révolutionnaires sur le matériau bidimensionnel graphène","pour leur développement de nouvelles méthodes pour la mesure précise des propriétés magnétiques nucléaires"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11051: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Felix Bloch a-t-il reçu le Prix Nobel en 1952 ?",
      answers: ["Chimie","Paix","Physiologie ou Médecine","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11052: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Edward M. Purcell a-t-il reçu le Prix Nobel de Physique pour leur développement de nouvelles méthodes pour la mesure précise des propriétés magnétiques nucléaires ?",
      answers: ["1947","1950","1927","1952"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11053: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1952 pour leur développement de nouvelles méthodes pour la mesure précise des propriétés magnétiques nucléaires ?",
      answers: ["Edward M. Purcell","Chen Ning Yang","Carl D. Anderson","Max von Laue"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11054: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Edward M. Purcell a-t-il reçu le Prix Nobel en 1952 ?",
      answers: ["pour la découverte et l’interprétation de l’effet Cherenkov","pour la découverte d’un objet compact supermassif au centre de notre galaxie","pour leur développement de nouvelles méthodes pour la mesure précise des propriétés magnétiques nucléaires","pour leur investigation approfondie des lois dites de parité, qui a conduit à d’importantes découvertes concernant les particules élémentaires"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11055: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Edward M. Purcell a-t-il reçu le Prix Nobel en 1952 ?",
      answers: ["Chimie","Physique","Paix","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11056: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Archer J.P. Martin a-t-il reçu le Prix Nobel de Chimie pour leur invention de la chromatographie de partage ?",
      answers: ["2013","1948","1926","1952"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11057: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1952 pour leur invention de la chromatographie de partage ?",
      answers: ["Yuan T. Lee","Richard L.M. Synge","Archer J.P. Martin","Alfred Werner"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11058: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Archer J.P. Martin a-t-il reçu le Prix Nobel en 1952 ?",
      answers: ["pour leur découverte et le développement de la synthèse par diène","pour le développement de la chimie bioorthogonale","pour leurs réalisations exceptionnelles dans le développement de méthodes directes pour la détermination des structures cristallines","pour leur invention de la chromatographie de partage"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11059: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Archer J.P. Martin a-t-il reçu le Prix Nobel en 1952 ?",
      answers: ["Chimie","Physiologie ou Médecine","Paix","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11060: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Richard L.M. Synge a-t-il reçu le Prix Nobel de Chimie pour leur invention de la chromatographie de partage ?",
      answers: ["1965","1908","1952","1955"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11061: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1952 pour leur invention de la chromatographie de partage ?",
      answers: ["Otto Diels","Adolf O. Windaus","Linus Pauling","Richard L.M. Synge"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11062: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Richard L.M. Synge a-t-il reçu le Prix Nobel en 1952 ?",
      answers: ["pour son travail sur les nucléotides et les coenzymes nucléotidiques","pour leurs découvertes dans la chimie des éléments transuraniens","pour leur invention de la chromatographie de partage","pour son travail sur les composés soufrés biologiquement importants, en particulier pour la première synthèse d’une hormone polypeptidique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11063: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Richard L.M. Synge a-t-il reçu le Prix Nobel en 1952 ?",
      answers: ["Chimie","Physiologie ou Médecine","Paix","Sciences Économiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11064: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Selman A. Waksman a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour sa découverte de la streptomycine, le premier antibiotique efficace contre la tuberculose ?",
      answers: ["1937","1947","1969","1952"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11065: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1952 pour sa découverte de la streptomycine, le premier antibiotique efficace contre la tuberculose ?",
      answers: ["Werner Forssmann","Torsten N. Wiesel","Selman A. Waksman","André F. Cournand"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11066: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Selman A. Waksman a-t-il reçu le Prix Nobel en 1952 ?",
      answers: ["pour sa découverte de la streptomycine, le premier antibiotique efficace contre la tuberculose","pour ses découvertes concernant la fièvre jaune et comment la combattre","pour leurs découvertes concernant la structure moléculaire des acides nucléiques et son importance pour le transfert d’information dans le matériel vivant","pour sa découverte de la vitamine K"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11067: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Selman A. Waksman a-t-il reçu le Prix Nobel en 1952 ?",
      answers: ["Sciences Économiques","Physique","Chimie","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11068: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Albert Schweitzer a-t-il reçu le Prix Nobel de Paix pour son travail humanitaire et son engagement pour la paix et la dignité humaine ?",
      answers: ["1954","1909","1952","1948"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11069: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1952 pour son travail humanitaire et son engagement pour la paix et la dignité humaine ?",
      answers: ["Lester B. Pearson","Elihu Root","Albert Schweitzer","José Ramos-Horta"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11070: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Albert Schweitzer a-t-il reçu le Prix Nobel en 1952 ?",
      answers: ["pour son travail humanitaire et son engagement pour la paix et la dignité humaine","pour leur travail humanitaire et leurs efforts pour la paix","pour son rôle dans le Plan Marshall et ses efforts pour promouvoir la paix en Europe","pour son travail en faveur de la paix et des droits des travailleurs"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11071: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Albert Schweitzer a-t-il reçu le Prix Nobel en 1952 ?",
      answers: ["Sciences Économiques","Chimie","Paix","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11072: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année François Mauriac a-t-il reçu le Prix Nobel de Littérature pour la pénétration spirituelle profonde et l’intensité artistique avec lesquelles il a exploré les drames de la vie humaine dans ses romans ?",
      answers: ["1955","1952","1937","1927"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11073: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1952 pour la pénétration spirituelle profonde et l’intensité artistique avec lesquelles il a exploré les drames de la vie humaine dans ses romans ?",
      answers: ["William Faulkner","Johannes V. Jensen","T.S. Eliot","François Mauriac"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11074: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison François Mauriac a-t-il reçu le Prix Nobel en 1952 ?",
      answers: ["pour la vigueur artistique et la profonde indépendance d’esprit avec lesquelles il cherche dans ses écrits des réponses aux questions éternelles de l’humanité","pour la pénétration spirituelle profonde et l’intensité artistique avec lesquelles il a exploré les drames de la vie humaine dans ses romans","pour la force éthique avec laquelle il a poursuivi les traditions indispensables de la littérature russe","pour sa maîtrise de la description historique et biographique ainsi que pour son éloquence brillante dans la défense des valeurs humaines exaltées"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11075: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie François Mauriac a-t-il reçu le Prix Nobel en 1952 ?",
      answers: ["Paix","Physique","Littérature","Sciences Économiques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11076: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Frits Zernike a-t-il reçu le Prix Nobel de Physique pour sa démonstration de la méthode du contraste de phase et en particulier pour son invention du microscope à contraste de phase ?",
      answers: ["1936","1953","1952","1947"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11077: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1953 pour sa démonstration de la méthode du contraste de phase et en particulier pour son invention du microscope à contraste de phase ?",
      answers: ["Melvin Schwartz","Polykarp Kusch","Isidor I. Rabi","Frits Zernike"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11078: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Frits Zernike a-t-il reçu le Prix Nobel en 1953 ?",
      answers: ["pour son développement de la méthode photographique pour l’étude des processus nucléaires et ses découvertes concernant les mésons réalisées avec cette méthode","pour sa mesure précise du moment magnétique de l’électron","pour sa démonstration de la méthode du contraste de phase et en particulier pour son invention du microscope à contraste de phase","pour sa prédiction de l’existence des mésons sur la base de travaux théoriques sur les forces nucléaires"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11079: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Frits Zernike a-t-il reçu le Prix Nobel en 1953 ?",
      answers: ["Littérature","Sciences Économiques","Physique","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11080: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Hermann Staudinger a-t-il reçu le Prix Nobel de Chimie pour ses découvertes dans le domaine de la chimie des macromolécules ?",
      answers: ["1957","1969","1953","1954"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11081: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1953 pour ses découvertes dans le domaine de la chimie des macromolécules ?",
      answers: ["Sir Robert Robinson","Giulio Natta","Edwin M. McMillan","Hermann Staudinger"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11082: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Hermann Staudinger a-t-il reçu le Prix Nobel en 1953 ?",
      answers: ["pour ses découvertes dans le domaine de la chimie des macromolécules","pour ses recherches sur les pigments végétaux, en particulier la chlorophylle","pour leurs études sur les structures des protéines globulaires","pour leur invention de la chromatographie de partage"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11083: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Hermann Staudinger a-t-il reçu le Prix Nobel en 1953 ?",
      answers: ["Physique","Paix","Physiologie ou Médecine","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11084: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Hans A. Krebs a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour sa découverte du cycle de l’acide citrique ?",
      answers: ["1946","1954","1955","1953"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11085: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1953 pour sa découverte du cycle de l’acide citrique ?",
      answers: ["Rolf M. Zinkernagel","Hans A. Krebs","Peyton Rous","Fritz A. Lipmann"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11086: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Hans A. Krebs a-t-il reçu le Prix Nobel en 1953 ?",
      answers: ["pour leurs découvertes concernant les hormones du cortex surrénalien, leur structure et leurs effets biologiques","pour sa découverte du cycle de l’acide citrique","pour sa découverte du coenzyme A et son importance dans le métabolisme intermédiaire","pour sa découverte de la streptomycine, le premier antibiotique efficace contre la tuberculose"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11087: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Hans A. Krebs a-t-il reçu le Prix Nobel en 1953 ?",
      answers: ["Physiologie ou Médecine","Physique","Littérature","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11088: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Fritz A. Lipmann a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour sa découverte du coenzyme A et son importance dans le métabolisme intermédiaire ?",
      answers: ["1953","1932","1966","1955"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11089: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1953 pour sa découverte du coenzyme A et son importance dans le métabolisme intermédiaire ?",
      answers: ["Sir Howard Florey","Fritz A. Lipmann","Maurice H.F. Wilkins","Selman A. Waksman"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11090: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Fritz A. Lipmann a-t-il reçu le Prix Nobel en 1953 ?",
      answers: ["pour leur découverte de la capacité du virus de la poliomyélite à se développer dans des cultures de divers types de tissus","pour sa découverte du coenzyme A et son importance dans le métabolisme intermédiaire","pour leurs découvertes de principes importants pour le traitement médicamenteux","pour leurs découvertes concernant la structure moléculaire des acides nucléiques et son importance pour le transfert d’information dans le matériel vivant"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11091: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Fritz A. Lipmann a-t-il reçu le Prix Nobel en 1953 ?",
      answers: ["Physiologie ou Médecine","Littérature","Chimie","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11092: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année George C. Marshall a-t-il reçu le Prix Nobel de Paix pour son rôle dans le Plan Marshall et ses efforts pour promouvoir la paix en Europe ?",
      answers: ["1950","1954","1948","1953"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11093: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1953 pour son rôle dans le Plan Marshall et ses efforts pour promouvoir la paix en Europe ?",
      answers: ["Baronne Bertha von Suttner","George C. Marshall","Haut-Commissariat des Nations Unies pour les Réfugiés (HCR)","Philip Noel-Baker"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11094: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison George C. Marshall a-t-il reçu le Prix Nobel en 1953 ?",
      answers: ["pour son travail en faveur des réfugiés européens après la Seconde Guerre mondiale","pour son travail en faveur de la paix et de la coopération internationale","pour son rôle dans le Plan Marshall et ses efforts pour promouvoir la paix en Europe","pour leurs négociations conjointes ayant conduit à un cessez-le-feu au Vietnam"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11095: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie George C. Marshall a-t-il reçu le Prix Nobel en 1953 ?",
      answers: ["Paix","Chimie","Sciences Économiques","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11096: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Winston Churchill a-t-il reçu le Prix Nobel de Littérature pour sa maîtrise de la description historique et biographique ainsi que pour son éloquence brillante dans la défense des valeurs humaines exaltées ?",
      answers: ["1952","2019","1953","2024"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11097: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1953 pour sa maîtrise de la description historique et biographique ainsi que pour son éloquence brillante dans la défense des valeurs humaines exaltées ?",
      answers: ["Winston Churchill","Roger Martin du Gard","Ernest Hemingway","Ivo Andrić"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11098: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Winston Churchill a-t-il reçu le Prix Nobel en 1953 ?",
      answers: ["pour la pénétration spirituelle profonde et l’intensité artistique avec lesquelles il a exploré les drames de la vie humaine dans ses romans","qui, à travers des œuvres riches en nuances, a donné forme à un art narratif arabe qui s’applique à toute l’humanité","pour sa maîtrise de la description historique et biographique ainsi que pour son éloquence brillante dans la défense des valeurs humaines exaltées","pour la vigueur artistique et la profonde indépendance d’esprit avec lesquelles il cherche dans ses écrits des réponses aux questions éternelles de l’humanité"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11099: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Winston Churchill a-t-il reçu le Prix Nobel en 1953 ?",
      answers: ["Littérature","Paix","Physique","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11100: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Max Born a-t-il reçu le Prix Nobel de Physique pour ses recherches fondamentales en mécanique quantique, en particulier pour son interprétation statistique de la fonction d’onde ?",
      answers: ["1954","1950","1958","1953"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11101: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1954 pour ses recherches fondamentales en mécanique quantique, en particulier pour son interprétation statistique de la fonction d’onde ?",
      answers: ["John D. Cockcroft","Felix Bloch","Nicolaas Bloembergen","Max Born"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11102: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Max Born a-t-il reçu le Prix Nobel en 1954 ?",
      answers: ["pour ses recherches fondamentales en mécanique quantique, en particulier pour son interprétation statistique de la fonction d’onde","pour ses contributions à la théorie du noyau atomique et des particules élémentaires, notamment par la découverte et l’application des principes de symétrie fondamentaux","pour leurs recherches sur les semi-conducteurs et leur découverte de l’effet transistor","pour leur découverte expérimentale de la diffraction des électrons par les cristaux"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11103: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Max Born a-t-il reçu le Prix Nobel en 1954 ?",
      answers: ["Physique","Chimie","Littérature","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11104: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Linus Pauling a-t-il reçu le Prix Nobel de Chimie pour ses recherches sur la nature de la liaison chimique et son application à l’élucidation de la structure des substances complexes ?",
      answers: ["1954","1951","1960","1963"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11105: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1954 pour ses recherches sur la nature de la liaison chimique et son application à l’élucidation de la structure des substances complexes ?",
      answers: ["Linus Pauling","Robert J. Lefkowitz","Nikolay N. Semenov","Artturi I. Virtanen"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11106: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Linus Pauling a-t-il reçu le Prix Nobel en 1954 ?",
      answers: ["pour son travail sur les composés soufrés biologiquement importants, en particulier pour la première synthèse d’une hormone polypeptidique","pour ses recherches sur la nature de la liaison chimique et son application à l’élucidation de la structure des substances complexes","pour leurs découvertes dans la chimie des éléments transuraniens","pour leurs études des réactions chimiques extrêmement rapides, réalisées par des perturbations de l’équilibre"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11107: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Linus Pauling a-t-il reçu le Prix Nobel en 1954 ?",
      answers: ["Paix","Chimie","Physique","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11108: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année John F. Enders a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leur découverte de la capacité du virus de la poliomyélite à se développer dans des cultures de divers types de tissus ?",
      answers: ["1953","1954","1921","1929"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11109: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1954 pour leur découverte de la capacité du virus de la poliomyélite à se développer dans des cultures de divers types de tissus ?",
      answers: ["André F. Cournand","Thomas H. Weller","Howard M. Temin","John F. Enders"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11110: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison John F. Enders a-t-il reçu le Prix Nobel en 1954 ?",
      answers: ["pour leurs découvertes concernant la régulation génétique de la synthèse des enzymes et des virus","pour sa découverte du coenzyme A et son importance dans le métabolisme intermédiaire","pour leur découverte de la capacité du virus de la poliomyélite à se développer dans des cultures de divers types de tissus","pour leur découverte des mécanismes de la synthèse biologique de l’acide ribonucléique et de l’acide désoxyribonucléique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11111: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie John F. Enders a-t-il reçu le Prix Nobel en 1954 ?",
      answers: ["Chimie","Paix","Physique","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11112: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Frederick C. Robbins a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leur découverte de la capacité du virus de la poliomyélite à se développer dans des cultures de divers types de tissus ?",
      answers: ["1970","1954","1958","1948"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11113: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1954 pour leur découverte de la capacité du virus de la poliomyélite à se développer dans des cultures de divers types de tissus ?",
      answers: ["Frederick C. Robbins","John F. Enders","James D. Watson","Ernst B. Chain"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11114: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Frederick C. Robbins a-t-il reçu le Prix Nobel en 1954 ?",
      answers: ["pour leur découverte de la capacité du virus de la poliomyélite à se développer dans des cultures de divers types de tissus","pour ses découvertes concernant la spécialisation fonctionnelle des hémisphères cérébraux","pour leur découverte de la bactérie Helicobacter pylori et son rôle dans la gastrite et l’ulcère gastrique","pour leurs découvertes concernant les structures génétiquement déterminées à la surface des cellules qui régulent les réactions immunitaires"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11115: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Frederick C. Robbins a-t-il reçu le Prix Nobel en 1954 ?",
      answers: ["Physique","Chimie","Littérature","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11116: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Thomas H. Weller a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leur découverte de la capacité du virus de la poliomyélite à se développer dans des cultures de divers types de tissus ?",
      answers: ["1954","2009","1946","1955"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11117: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1954 pour leur découverte de la capacité du virus de la poliomyélite à se développer dans des cultures de divers types de tissus ?",
      answers: ["George H. Whipple","Thomas H. Weller","Johannes A.B. Fibiger","Hans A. Krebs"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11118: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Thomas H. Weller a-t-il reçu le Prix Nobel en 1954 ?",
      answers: ["pour leurs découvertes des facteurs de croissance","pour ses découvertes concernant la nature et le mode d’action des enzymes d’oxydation","pour leur découverte de la capacité du virus de la poliomyélite à se développer dans des cultures de divers types de tissus","pour leurs découvertes concernant les processus physiologiques et chimiques primaires dans la vision"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11119: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Thomas H. Weller a-t-il reçu le Prix Nobel en 1954 ?",
      answers: ["Paix","Physiologie ou Médecine","Chimie","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11120: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Haut-Commissariat des Nations Unies pour les Réfugiés (HCR) a-t-il reçu le Prix Nobel de Paix pour son travail humanitaire en faveur des réfugiés ?",
      answers: ["1956","1954","1907","1950"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11121: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1954 pour son travail humanitaire en faveur des réfugiés ?",
      answers: ["Gustav Stresemann","George C. Marshall","Haut-Commissariat des Nations Unies pour les Réfugiés (HCR)","Lester B. Pearson"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11122: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Haut-Commissariat des Nations Unies pour les Réfugiés (HCR) a-t-il reçu le Prix Nobel en 1954 ?",
      answers: ["pour son rôle dans le Plan Marshall et ses efforts pour promouvoir la paix en Europe","pour son travail humanitaire pendant les périodes de conflit","pour son travail de médiation en Palestine en 1948-1949","pour son travail humanitaire en faveur des réfugiés"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11123: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Haut-Commissariat des Nations Unies pour les Réfugiés (HCR) a-t-il reçu le Prix Nobel en 1954 ?",
      answers: ["Paix","Physiologie ou Médecine","Chimie","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11124: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Ernest Hemingway a-t-il reçu le Prix Nobel de Littérature pour sa maîtrise de l’art narratif, récemment démontrée dans Le Vieil Homme et la Mer, et pour l’influence qu’il a exercée sur le style contemporain ?",
      answers: ["1972","1971","1954","1952"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11125: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1954 pour sa maîtrise de l’art narratif, récemment démontrée dans Le Vieil Homme et la Mer, et pour l’influence qu’il a exercée sur le style contemporain ?",
      answers: ["Saint-John Perse","Ernest Hemingway","Nadine Gordimer","Samuel Beckett"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11126: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Ernest Hemingway a-t-il reçu le Prix Nobel en 1954 ?",
      answers: ["pour sa contribution puissante et artistiquement unique à la fiction américaine contemporaine","pour la vigueur artistique et la profonde indépendance d’esprit avec lesquelles il cherche dans ses écrits des réponses aux questions éternelles de l’humanité","pour sa maîtrise de l’art narratif, récemment démontrée dans Le Vieil Homme et la Mer, et pour l’influence qu’il a exercée sur le style contemporain","pour sa maîtrise narrative qui exprime avec une grande sensibilité l’essence de l’esprit japonais"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11127: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Ernest Hemingway a-t-il reçu le Prix Nobel en 1954 ?",
      answers: ["Chimie","Littérature","Paix","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11128: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Willis E. Lamb a-t-il reçu le Prix Nobel de Physique pour ses découvertes concernant la structure fine du spectre de l’hydrogène ?",
      answers: ["2024","1962","1955","1902"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11129: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1955 pour ses découvertes concernant la structure fine du spectre de l’hydrogène ?",
      answers: ["Pavel A. Cherenkov","Jerome I. Friedman","Willis E. Lamb","Gerd Binnig"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11130: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Willis E. Lamb a-t-il reçu le Prix Nobel en 1955 ?",
      answers: ["pour leur découverte des lois régissant l’impact d’un électron sur un atome","pour ses découvertes concernant la structure fine du spectre de l’hydrogène","pour leurs recherches sur les semi-conducteurs et leur découverte de l’effet transistor","pour ses contributions à la théorie du noyau atomique et des particules élémentaires, notamment par la découverte et l’application des principes de symétrie fondamentaux"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11131: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Willis E. Lamb a-t-il reçu le Prix Nobel en 1955 ?",
      answers: ["Physique","Chimie","Sciences Économiques","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11132: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Polykarp Kusch a-t-il reçu le Prix Nobel de Physique pour sa mesure précise du moment magnétique de l’électron ?",
      answers: ["1937","1951","1991","1955"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11133: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1955 pour sa mesure précise du moment magnétique de l’électron ?",
      answers: ["Willis E. Lamb","Polykarp Kusch","Richard P. Feynman","Sin-Itiro Tomonaga"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11134: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Polykarp Kusch a-t-il reçu le Prix Nobel en 1955 ?",
      answers: ["pour ses réalisations pionnières concernant la transmission de la lumière dans les fibres pour la communication optique","pour sa démonstration de la méthode du contraste de phase et en particulier pour son invention du microscope à contraste de phase","pour leur investigation approfondie des lois dites de parité, qui a conduit à d’importantes découvertes concernant les particules élémentaires","pour sa mesure précise du moment magnétique de l’électron"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11135: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Polykarp Kusch a-t-il reçu le Prix Nobel en 1955 ?",
      answers: ["Chimie","Littérature","Physique","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11136: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Vincent du Vigneaud a-t-il reçu le Prix Nobel de Chimie pour son travail sur les composés soufrés biologiquement importants, en particulier pour la première synthèse d’une hormone polypeptidique ?",
      answers: ["1951","1954","1955","2016"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11137: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1955 pour son travail sur les composés soufrés biologiquement importants, en particulier pour la première synthèse d’une hormone polypeptidique ?",
      answers: ["Richard L.M. Synge","Willard F. Libby","Vincent du Vigneaud","Sir Alexander Todd"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11138: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Vincent du Vigneaud a-t-il reçu le Prix Nobel en 1955 ?",
      answers: ["pour le développement de la microscopie à fluorescence à super-résolution","pour sa découverte des nucléotides sucrés et leur rôle dans la biosynthèse des glucides","pour son travail sur les composés soufrés biologiquement importants, en particulier pour la première synthèse d’une hormone polypeptidique","en reconnaissance des services extraordinaires qu’il a rendus par son travail sur la synthèse des sucres et des purines"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11139: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Vincent du Vigneaud a-t-il reçu le Prix Nobel en 1955 ?",
      answers: ["Paix","Physiologie ou Médecine","Physique","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11140: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Hugo Theorell a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour ses découvertes concernant la nature et le mode d’action des enzymes d’oxydation ?",
      answers: ["1951","1957","1955","1953"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11141: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1955 pour ses découvertes concernant la nature et le mode d’action des enzymes d’oxydation ?",
      answers: ["Hans A. Krebs","Selman A. Waksman","Hugo Theorell","Ronald Ross"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11142: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Hugo Theorell a-t-il reçu le Prix Nobel en 1955 ?",
      answers: ["pour leur découverte des mécanismes de la synthèse biologique de l’acide ribonucléique et de l’acide désoxyribonucléique","pour leur découverte de la capacité du virus de la poliomyélite à se développer dans des cultures de divers types de tissus","pour ses découvertes concernant la nature et le mode d’action des enzymes d’oxydation","pour la découverte de la production de mutations par irradiation aux rayons X"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11143: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Hugo Theorell a-t-il reçu le Prix Nobel en 1955 ?",
      answers: ["Sciences Économiques","Chimie","Paix","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11144: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Halldór Laxness a-t-il reçu le Prix Nobel de Littérature pour sa puissance épique vivante qui a renouvelé le grand art narratif de l’Islande ?",
      answers: ["1953","1948","1955","2008"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11145: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1955 pour sa puissance épique vivante qui a renouvelé le grand art narratif de l’Islande ?",
      answers: ["Juan Ramón Jiménez","François Mauriac","Winston Churchill","Halldór Laxness"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11146: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Halldór Laxness a-t-il reçu le Prix Nobel en 1955 ?",
      answers: ["pour sa maîtrise de l’art narratif, récemment démontrée dans Le Vieil Homme et la Mer, et pour l’influence qu’il a exercée sur le style contemporain","pour la force rare et la fertilité de son imagination poétique avec lesquelles il a combiné une curiosité intellectuelle et un style audacieux et frais","pour sa puissance épique vivante qui a renouvelé le grand art narratif de l’Islande","pour ses écrits empreints d’idéalisme décrivant la vie sur son île natale et traitant avec profondeur et sympathie les problèmes humains en général"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11147: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Halldór Laxness a-t-il reçu le Prix Nobel en 1955 ?",
      answers: ["Paix","Physiologie ou Médecine","Chimie","Littérature"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11148: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année John Bardeen a-t-il reçu le Prix Nobel de Physique pour leurs recherches sur les semi-conducteurs et leur découverte de l’effet transistor ?",
      answers: ["1957","1916","1968","1956"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11149: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1956 pour leurs recherches sur les semi-conducteurs et leur découverte de l’effet transistor ?",
      answers: ["Walter H. Brattain","Klaus Hasselmann","Arthur L. Schawlow","John Bardeen"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11150: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison John Bardeen a-t-il reçu le Prix Nobel en 1956 ?",
      answers: ["pour la découverte de l’origine de la brisure de symétrie qui prédit l’existence d’au moins trois familles de quarks dans la nature","pour leur percée importante dans la découverte de la supraconductivité dans les matériaux céramiques","pour leur théorie développée conjointement de la supraconductivité, généralement appelée la théorie BCS","pour leurs recherches sur les semi-conducteurs et leur découverte de l’effet transistor"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11151: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie John Bardeen a-t-il reçu le Prix Nobel en 1956 ?",
      answers: ["Littérature","Physique","Physiologie ou Médecine","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11152: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Walter H. Brattain a-t-il reçu le Prix Nobel de Physique pour leurs recherches sur les semi-conducteurs et leur découverte de l’effet transistor ?",
      answers: ["1956","1983","1936","1946"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11153: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1956 pour leurs recherches sur les semi-conducteurs et leur découverte de l’effet transistor ?",
      answers: ["Owen Chamberlain","Willis E. Lamb","Rudolf Mössbauer","Walter H. Brattain"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11154: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Walter H. Brattain a-t-il reçu le Prix Nobel en 1956 ?",
      answers: ["pour leur investigation approfondie des lois dites de parité, qui a conduit à d’importantes découvertes concernant les particules élémentaires","pour la découverte théorique d’un mécanisme contribuant à notre compréhension de l’origine de la masse des particules subatomiques","pour leurs recherches sur les semi-conducteurs et leur découverte de l’effet transistor","pour la découverte et l’interprétation de l’effet Cherenkov"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11155: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Walter H. Brattain a-t-il reçu le Prix Nobel en 1956 ?",
      answers: ["Chimie","Physiologie ou Médecine","Paix","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11156: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année William B. Shockley a-t-il reçu le Prix Nobel de Physique pour leurs recherches sur les semi-conducteurs et leur découverte de l’effet transistor ?",
      answers: ["1956","1982","1960","1953"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11157: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1956 pour leurs recherches sur les semi-conducteurs et leur découverte de l’effet transistor ?",
      answers: ["Arno Penzias","Victor F. Hess","William B. Shockley","Lev Landau"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11158: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison William B. Shockley a-t-il reçu le Prix Nobel en 1956 ?",
      answers: ["pour la découverte de nouvelles formes productives de la théorie atomique","pour leurs recherches sur les semi-conducteurs et leur découverte de l’effet transistor","pour ses recherches fondamentales en mécanique quantique, en particulier pour son interprétation statistique de la fonction d’onde","pour ses découvertes concernant la structure fine du spectre de l’hydrogène"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11159: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie William B. Shockley a-t-il reçu le Prix Nobel en 1956 ?",
      answers: ["Littérature","Physique","Paix","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11160: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Cyril N. Hinshelwood a-t-il reçu le Prix Nobel de Chimie pour leurs recherches sur les mécanismes des réactions chimiques ?",
      answers: ["1957","1903","1970","1956"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11161: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1956 pour leurs recherches sur les mécanismes des réactions chimiques ?",
      answers: ["Yves Chauvin","Nikolay N. Semenov","Archer J.P. Martin","Cyril N. Hinshelwood"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11162: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Cyril N. Hinshelwood a-t-il reçu le Prix Nobel en 1956 ?",
      answers: ["pour leurs contributions au développement du concept de conformation et son application en chimie","pour ses travaux sur les mécanismes des réactions de transfert d’électrons, en particulier dans les complexes métalliques","pour le développement de la méthode de métathèse en synthèse organique","pour leurs recherches sur les mécanismes des réactions chimiques"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11163: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Cyril N. Hinshelwood a-t-il reçu le Prix Nobel en 1956 ?",
      answers: ["Physique","Physiologie ou Médecine","Chimie","Paix"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11164: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Nikolay N. Semenov a-t-il reçu le Prix Nobel de Chimie pour leurs recherches sur les mécanismes des réactions chimiques ?",
      answers: ["1955","1959","1956","1954"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11165: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1956 pour leurs recherches sur les mécanismes des réactions chimiques ?",
      answers: ["Cyril N. Hinshelwood","Arthur Harden","George Porter","Nikolay N. Semenov"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11166: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Nikolay N. Semenov a-t-il reçu le Prix Nobel en 1956 ?",
      answers: ["pour leurs recherches sur les mécanismes des réactions chimiques","pour ses recherches sur les acides biliaires et les substances apparentées","pour ses recherches biochimiques et sa découverte de la fermentation sans cellules","pour sa contribution à la compréhension du transfert d’énergie biologique par la formulation de la théorie chimi-osmotique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11167: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Nikolay N. Semenov a-t-il reçu le Prix Nobel en 1956 ?",
      answers: ["Sciences Économiques","Chimie","Physique","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11168: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année André F. Cournand a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant le cathétérisme cardiaque et les changements pathologiques dans le système circulatoire ?",
      answers: ["1955","1906","1944","1956"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11169: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1956 pour leurs découvertes concernant le cathétérisme cardiaque et les changements pathologiques dans le système circulatoire ?",
      answers: ["André F. Cournand","Daniel Bovet","Alan L. Hodgkin","Hamilton O. Smith"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11170: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison André F. Cournand a-t-il reçu le Prix Nobel en 1956 ?",
      answers: ["pour leurs découvertes concernant le cathétérisme cardiaque et les changements pathologiques dans le système circulatoire","pour leurs découvertes concernant la régulation génétique de la synthèse des enzymes et des virus","pour leurs découvertes concernant les structures génétiquement déterminées à la surface des cellules qui régulent les réactions immunitaires","pour ses découvertes concernant les composés synthétiques qui inhibent l’action de certaines substances corporelles, notamment leur effet sur le système vasculaire et les muscles squelettiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11171: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie André F. Cournand a-t-il reçu le Prix Nobel en 1956 ?",
      answers: ["Sciences Économiques","Paix","Chimie","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11172: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Werner Forssmann a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant le cathétérisme cardiaque et les changements pathologiques dans le système circulatoire ?",
      answers: ["1955","1933","1956","1965"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11173: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1956 pour leurs découvertes concernant le cathétérisme cardiaque et les changements pathologiques dans le système circulatoire ?",
      answers: ["Fritz A. Lipmann","Werner Forssmann","Joseph E. Murray","André F. Cournand"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11174: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Werner Forssmann a-t-il reçu le Prix Nobel en 1956 ?",
      answers: ["pour leurs découvertes concernant les hormones du cortex surrénalien, leur structure et leurs effets biologiques","pour leurs découvertes concernant le cathétérisme cardiaque et les changements pathologiques dans le système circulatoire","pour la découverte de la pénicilline et de son effet curatif dans diverses maladies infectieuses","pour le développement de radio-immunoessais des hormones peptidiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11175: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Werner Forssmann a-t-il reçu le Prix Nobel en 1956 ?",
      answers: ["Paix","Physiologie ou Médecine","Littérature","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11176: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Dickinson W. Richards a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant le cathétérisme cardiaque et les changements pathologiques dans le système circulatoire ?",
      answers: ["1938","1948","1956","1955"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11177: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1956 pour leurs découvertes concernant le cathétérisme cardiaque et les changements pathologiques dans le système circulatoire ?",
      answers: ["Dickinson W. Richards","Werner Forssmann","Thomas H. Weller","André F. Cournand"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11178: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Dickinson W. Richards a-t-il reçu le Prix Nobel en 1956 ?",
      answers: ["pour leurs découvertes concernant les processus physiologiques et chimiques primaires dans la vision","pour leurs découvertes concernant le cathétérisme cardiaque et les changements pathologiques dans le système circulatoire","pour leurs découvertes concernant la régulation génétique de la synthèse des enzymes et des virus","pour sa découverte de la valeur thérapeutique de l’inoculation du paludisme dans le traitement de la paralysie générale"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11179: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Dickinson W. Richards a-t-il reçu le Prix Nobel en 1956 ?",
      answers: ["Physique","Chimie","Paix","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11180: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Juan Ramón Jiménez a-t-il reçu le Prix Nobel de Littérature pour sa poésie lyrique, qui constitue un exemple de haute spiritualité et de pureté artistique en langue espagnole ?",
      answers: ["1969","1956","1948","1962"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11181: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1956 pour sa poésie lyrique, qui constitue un exemple de haute spiritualité et de pureté artistique en langue espagnole ?",
      answers: ["Isaac Bashevis Singer","Gabriela Mistral","Juan Ramón Jiménez","Heinrich Böll"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11182: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Juan Ramón Jiménez a-t-il reçu le Prix Nobel en 1956 ?",
      answers: ["pour la puissance artistique et la vérité avec lesquelles il a dépeint les conflits humains ainsi que certains aspects fondamentaux de la vie contemporaine dans son cycle romanesque 'Les Thibault'","pour sa production littéraire importante, qui éclaire avec une lucidité sérieuse les problèmes de la conscience humaine à notre époque","pour sa contribution puissante et artistiquement unique à la fiction américaine contemporaine","pour sa poésie lyrique, qui constitue un exemple de haute spiritualité et de pureté artistique en langue espagnole"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11183: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Juan Ramón Jiménez a-t-il reçu le Prix Nobel en 1956 ?",
      answers: ["Physique","Littérature","Chimie","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11184: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Chen Ning Yang a-t-il reçu le Prix Nobel de Physique pour leur investigation approfondie des lois dites de parité, qui a conduit à d’importantes découvertes concernant les particules élémentaires ?",
      answers: ["2020","1999","1957","1962"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11185: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1957 pour leur investigation approfondie des lois dites de parité, qui a conduit à d’importantes découvertes concernant les particules élémentaires ?",
      answers: ["Owen Chamberlain","Chen Ning Yang","Subrahmanyan Chandrasekhar","Hans G. Dehmelt"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11186: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Chen Ning Yang a-t-il reçu le Prix Nobel en 1957 ?",
      answers: ["pour leurs contributions à la théorie unifiée des interactions faible et électromagnétique entre particules élémentaires","pour ses contributions à la théorie du noyau atomique et des particules élémentaires, notamment par la découverte et l’application des principes de symétrie fondamentaux","en reconnaissance des services qu’il a rendus à la mesure précise en physique par sa découverte des anomalies des alliages d’acier au nickel","pour leur investigation approfondie des lois dites de parité, qui a conduit à d’importantes découvertes concernant les particules élémentaires"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11187: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Chen Ning Yang a-t-il reçu le Prix Nobel en 1957 ?",
      answers: ["Physique","Sciences Économiques","Physiologie ou Médecine","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11188: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Tsung-Dao Lee a-t-il reçu le Prix Nobel de Physique pour leur investigation approfondie des lois dites de parité, qui a conduit à d’importantes découvertes concernant les particules élémentaires ?",
      answers: ["1957","1961","1979","1968"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11189: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1957 pour leur investigation approfondie des lois dites de parité, qui a conduit à d’importantes découvertes concernant les particules élémentaires ?",
      answers: ["Michel Mayor","Walter H. Brattain","Tsung-Dao Lee","Edward M. Purcell"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11190: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Tsung-Dao Lee a-t-il reçu le Prix Nobel en 1957 ?",
      answers: ["pour la découverte et l’interprétation de l’effet Cherenkov","pour leur investigation approfondie des lois dites de parité, qui a conduit à d’importantes découvertes concernant les particules élémentaires","pour son développement de la méthode de la chambre à brouillard de Wilson et ses découvertes dans les domaines de la physique nucléaire et des rayons cosmiques","pour des découvertes théoriques sur les transitions de phase topologiques et les phases topologiques de la matière"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11191: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Tsung-Dao Lee a-t-il reçu le Prix Nobel en 1957 ?",
      answers: ["Chimie","Paix","Physiologie ou Médecine","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11192: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Sir Alexander Todd a-t-il reçu le Prix Nobel de Chimie pour son travail sur les nucléotides et les coenzymes nucléotidiques ?",
      answers: ["1959","1957","1969","1972"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11193: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1957 pour son travail sur les nucléotides et les coenzymes nucléotidiques ?",
      answers: ["Dorothy Crowfoot Hodgkin","Roderick MacKinnon","Sir Alexander Todd","Vincent du Vigneaud"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11194: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Sir Alexander Todd a-t-il reçu le Prix Nobel en 1957 ?",
      answers: ["pour sa découverte et le développement de la méthode d’analyse polarographique","pour son travail sur les nucléotides et les coenzymes nucléotidiques","pour la découverte et le développement de la protéine fluorescente verte (GFP)","pour ses découvertes dans le domaine de la chimie des macromolécules"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11195: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Sir Alexander Todd a-t-il reçu le Prix Nobel en 1957 ?",
      answers: ["Chimie","Paix","Physique","Littérature"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11196: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Daniel Bovet a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour ses découvertes concernant les composés synthétiques qui inhibent l’action de certaines substances corporelles, notamment leur effet sur le système vasculaire et les muscles squelettiques ?",
      answers: ["1957","1968","1951","1945"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11197: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1957 pour ses découvertes concernant les composés synthétiques qui inhibent l’action de certaines substances corporelles, notamment leur effet sur le système vasculaire et les muscles squelettiques ?",
      answers: ["Albrecht Kossel","Daniel Bovet","Allan M. Cormack","Hugo Theorell"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11198: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Daniel Bovet a-t-il reçu le Prix Nobel en 1957 ?",
      answers: ["pour leurs découvertes concernant le cathétérisme cardiaque et les changements pathologiques dans le système circulatoire","pour ses découvertes concernant les composés synthétiques qui inhibent l’action de certaines substances corporelles, notamment leur effet sur le système vasculaire et les muscles squelettiques","pour leur découverte que les gènes agissent en régulant des événements chimiques définis","pour leurs découvertes concernant les processus physiologiques et chimiques primaires dans la vision"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11199: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Daniel Bovet a-t-il reçu le Prix Nobel en 1957 ?",
      answers: ["Physiologie ou Médecine","Physique","Chimie","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11200: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Lester B. Pearson a-t-il reçu le Prix Nobel de Paix pour son rôle dans la résolution de la crise de Suez par la création de la première force de maintien de la paix des Nations Unies ?",
      answers: ["1959","1961","1957","1974"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11201: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1957 pour son rôle dans la résolution de la crise de Suez par la création de la première force de maintien de la paix des Nations Unies ?",
      answers: ["Elie Wiesel","Lester B. Pearson","Conseil des Amis pour le Service (Quakers britanniques)","George C. Marshall"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11202: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Lester B. Pearson a-t-il reçu le Prix Nobel en 1957 ?",
      answers: ["pour son travail en renforçant les Nations Unies et en promouvant la paix mondiale","pour son roman 'Quand les armes se taisent' et son travail en faveur de la paix","pour son rôle dans la résolution de la crise de Suez par la création de la première force de maintien de la paix des Nations Unies","pour son rôle dans le Plan Marshall et ses efforts pour promouvoir la paix en Europe"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11203: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Lester B. Pearson a-t-il reçu le Prix Nobel en 1957 ?",
      answers: ["Chimie","Physique","Physiologie ou Médecine","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11204: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Albert Camus a-t-il reçu le Prix Nobel de Littérature pour sa production littéraire importante, qui éclaire avec une lucidité sérieuse les problèmes de la conscience humaine à notre époque ?",
      answers: ["1957","1951","1920","1961"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11205: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1957 pour sa production littéraire importante, qui éclaire avec une lucidité sérieuse les problèmes de la conscience humaine à notre époque ?",
      answers: ["V. S. Naipaul","Albert Camus","Winston Churchill","Ivo Andrić"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11206: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Albert Camus a-t-il reçu le Prix Nobel en 1957 ?",
      answers: ["pour sa production littéraire importante, qui éclaire avec une lucidité sérieuse les problèmes de la conscience humaine à notre époque","pour sa poésie lyrique qui exprime avec une intensité classique les expériences tragiques de la vie à notre époque","pour son art narratif passionné qui, enraciné dans la culture et les traditions juives polonaises, donne une portée universelle à la condition humaine","pour son œuvre lyrique éminente, qui rend un hommage artistique à la culture grecque"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11207: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Albert Camus a-t-il reçu le Prix Nobel en 1957 ?",
      answers: ["Paix","Littérature","Physique","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11208: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Pavel A. Cherenkov a-t-il reçu le Prix Nobel de Physique pour la découverte et l’interprétation de l’effet Cherenkov ?",
      answers: ["1954","1959","1958","1962"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11209: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1958 pour la découverte et l’interprétation de l’effet Cherenkov ?",
      answers: ["Pavel A. Cherenkov","Louis Néel","Hendrik A. Lorentz","Walter H. Brattain"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11210: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Pavel A. Cherenkov a-t-il reçu le Prix Nobel en 1958 ?",
      answers: ["pour la découverte et l’interprétation de l’effet Cherenkov","pour ses contributions à la théorie des réactions nucléaires, en particulier ses découvertes concernant la production d’énergie dans les étoiles","pour leur investigation approfondie des lois dites de parité, qui a conduit à d’importantes découvertes concernant les particules élémentaires","pour son développement de la méthode photographique pour l’étude des processus nucléaires et ses découvertes concernant les mésons réalisées avec cette méthode"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11211: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Pavel A. Cherenkov a-t-il reçu le Prix Nobel en 1958 ?",
      answers: ["Physique","Paix","Chimie","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11212: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Il’ja M. Frank a-t-il reçu le Prix Nobel de Physique pour la découverte et l’interprétation de l’effet Cherenkov ?",
      answers: ["1969","1956","1960","1958"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11213: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1958 pour la découverte et l’interprétation de l’effet Cherenkov ?",
      answers: ["Werner Heisenberg","Il’ja M. Frank","Willis E. Lamb","J. Georg Bednorz"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11214: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Il’ja M. Frank a-t-il reçu le Prix Nobel en 1958 ?",
      answers: ["pour leurs travaux pionniers sur la transmutation des noyaux atomiques par des particules accélérées artificiellement","pour leurs recherches sur les semi-conducteurs et leur découverte de l’effet transistor","pour leurs recherches pionnières sur la diffusion inélastique profonde des électrons sur les protons et les neutrons liés","pour la découverte et l’interprétation de l’effet Cherenkov"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11215: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Il’ja M. Frank a-t-il reçu le Prix Nobel en 1958 ?",
      answers: ["Physiologie ou Médecine","Paix","Chimie","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11216: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Igor Y. Tamm a-t-il reçu le Prix Nobel de Physique pour la découverte et l’interprétation de l’effet Cherenkov ?",
      answers: ["1956","1958","2018","1960"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11217: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1958 pour la découverte et l’interprétation de l’effet Cherenkov ?",
      answers: ["Peter Grünberg","Martin Ryle","Pavel A. Cherenkov","Igor Y. Tamm"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11218: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Igor Y. Tamm a-t-il reçu le Prix Nobel en 1958 ?",
      answers: ["pour leurs découvertes concernant la structure en couches du noyau atomique","pour leurs contributions fondamentales à l’électrodynamique quantique, avec des conséquences profondes pour la physique des particules élémentaires","pour la découverte et l’interprétation de l’effet Cherenkov","pour ses découvertes concernant la structure fine du spectre de l’hydrogène"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11219: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Igor Y. Tamm a-t-il reçu le Prix Nobel en 1958 ?",
      answers: ["Physiologie ou Médecine","Paix","Littérature","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11220: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Frederick Sanger a-t-il reçu le Prix Nobel de Chimie pour son travail sur la structure des protéines, en particulier celle de l’insuline ?",
      answers: ["1974","1963","1958","1964"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11221: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1958 pour son travail sur la structure des protéines, en particulier celle de l’insuline ?",
      answers: ["Frederick Sanger","Sir Alexander Todd","Aaron Klug","Emmanuelle Charpentier"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11222: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Frederick Sanger a-t-il reçu le Prix Nobel en 1958 ?",
      answers: ["pour les services rendus par ses recherches sur la constitution des stérols et leur connexion avec les vitamines","pour leurs découvertes dans la chimie des éléments transuraniens","pour ses recherches sur l’assimilation du dioxyde de carbone par les plantes","pour son travail sur la structure des protéines, en particulier celle de l’insuline"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11223: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Frederick Sanger a-t-il reçu le Prix Nobel en 1958 ?",
      answers: ["Littérature","Chimie","Paix","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11224: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Joshua Lederberg a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour ses découvertes concernant la recombinaison génétique et l’organisation du matériel génétique des bactéries ?",
      answers: ["1924","1958","1970","1926"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11225: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1958 pour ses découvertes concernant la recombinaison génétique et l’organisation du matériel génétique des bactéries ?",
      answers: ["Joshua Lederberg","Hugo Theorell","Edward L. Tatum","Selman A. Waksman"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11226: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Joshua Lederberg a-t-il reçu le Prix Nobel en 1958 ?",
      answers: ["pour ses découvertes concernant la recombinaison génétique et l’organisation du matériel génétique des bactéries","pour sa découverte de la vitamine K","pour leurs découvertes concernant les transmetteurs humoraux dans les terminaisons nerveuses et le mécanisme de leur stockage, libération et inactivation","pour leurs découvertes concernant le mécanisme et la régulation du métabolisme du cholestérol et des acides gras"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11227: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Joshua Lederberg a-t-il reçu le Prix Nobel en 1958 ?",
      answers: ["Physique","Physiologie ou Médecine","Chimie","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11228: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année George W. Beadle a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leur découverte que les gènes agissent en régulant des événements chimiques définis ?",
      answers: ["1946","1961","1958","1975"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11229: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1958 pour leur découverte que les gènes agissent en régulant des événements chimiques définis ?",
      answers: ["George W. Beadle","John R. Vane","Edward C. Kendall","Joshua Lederberg"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11230: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison George W. Beadle a-t-il reçu le Prix Nobel en 1958 ?",
      answers: ["pour leurs découvertes concernant le cathétérisme cardiaque et les changements pathologiques dans le système circulatoire","pour leur découverte que les gènes agissent en régulant des événements chimiques définis","pour ses découvertes concernant la recombinaison génétique et l’organisation du matériel génétique des bactéries","pour la découverte de la pénicilline et de son effet curatif dans diverses maladies infectieuses"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11231: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie George W. Beadle a-t-il reçu le Prix Nobel en 1958 ?",
      answers: ["Paix","Physiologie ou Médecine","Sciences Économiques","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11232: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Edward L. Tatum a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leur découverte que les gènes agissent en régulant des événements chimiques définis ?",
      answers: ["1958","1967","1962","1963"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11233: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1958 pour leur découverte que les gènes agissent en régulant des événements chimiques définis ?",
      answers: ["John F. Enders","Georg von Békésy","Maurice H.F. Wilkins","Edward L. Tatum"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11234: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Edward L. Tatum a-t-il reçu le Prix Nobel en 1958 ?",
      answers: ["pour leurs découvertes concernant les transmetteurs humoraux dans les terminaisons nerveuses et le mécanisme de leur stockage, libération et inactivation","pour sa découverte de la relation fixe entre la consommation d’oxygène et le métabolisme de l’acide lactique dans les muscles","pour leurs découvertes concernant la structure moléculaire des acides nucléiques et son importance pour le transfert d’information dans le matériel vivant","pour leur découverte que les gènes agissent en régulant des événements chimiques définis"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11235: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Edward L. Tatum a-t-il reçu le Prix Nobel en 1958 ?",
      answers: ["Littérature","Chimie","Physique","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11236: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Dominique Pire a-t-il reçu le Prix Nobel de Paix pour son travail en faveur des réfugiés européens après la Seconde Guerre mondiale ?",
      answers: ["1958","1947","1903","1957"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11237: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1958 pour son travail en faveur des réfugiés européens après la Seconde Guerre mondiale ?",
      answers: ["Dominique Pire","Lester B. Pearson","Fonds des Nations Unies pour l’Enfance (UNICEF)","Lord John Boyd Orr"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11238: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Dominique Pire a-t-il reçu le Prix Nobel en 1958 ?",
      answers: ["pour ses efforts visant à renforcer la coopération en Europe occidentale et à réconcilier l’Allemagne avec les autres nations","pour son travail de longue date en faveur de la paix et du désarmement","pour leur travail humanitaire et leurs efforts pour la paix","pour son travail en faveur des réfugiés européens après la Seconde Guerre mondiale"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11239: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Dominique Pire a-t-il reçu le Prix Nobel en 1958 ?",
      answers: ["Littérature","Paix","Chimie","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11240: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Boris Pasternak a-t-il reçu le Prix Nobel de Littérature pour ses réalisations importantes dans la poésie lyrique contemporaine ainsi que dans le domaine de la grande tradition épique russe ?",
      answers: ["1972","1958","1952","1934"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11241: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1958 pour ses réalisations importantes dans la poésie lyrique contemporaine ainsi que dans le domaine de la grande tradition épique russe ?",
      answers: ["Boris Pasternak","Claude Simon","Albert Camus","André Gide"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11242: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Boris Pasternak a-t-il reçu le Prix Nobel en 1958 ?",
      answers: ["pour la force épique avec laquelle il a retracé les thèmes et dépeint les destinées humaines tirées de l’histoire de son pays","pour sa production littéraire importante, qui éclaire avec une lucidité sérieuse les problèmes de la conscience humaine à notre époque","pour sa puissance épique vivante qui a renouvelé le grand art narratif de l’Islande","pour ses réalisations importantes dans la poésie lyrique contemporaine ainsi que dans le domaine de la grande tradition épique russe"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11243: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Boris Pasternak a-t-il reçu le Prix Nobel en 1958 ?",
      answers: ["Physique","Chimie","Littérature","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11244: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Emilio Segrè a-t-il reçu le Prix Nobel de Physique pour leur découverte de l’antiproton ?",
      answers: ["1962","1958","1959","1922"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11245: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1959 pour leur découverte de l’antiproton ?",
      answers: ["Owen Chamberlain","Hannes Alfvén","Emilio Segrè","Leon N. Cooper"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11246: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Emilio Segrè a-t-il reçu le Prix Nobel en 1959 ?",
      answers: ["pour leurs recherches sur les semi-conducteurs et leur découverte de l’effet transistor","pour la réalisation de la condensation de Bose-Einstein dans des gaz dilués d’atomes alcalins","pour leur découverte de l’antiproton","pour ses recherches sur l’absorption par résonance des rayons gamma et sa découverte de l’effet qui porte son nom"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11247: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Emilio Segrè a-t-il reçu le Prix Nobel en 1959 ?",
      answers: ["Physiologie ou Médecine","Chimie","Physique","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11248: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Owen Chamberlain a-t-il reçu le Prix Nobel de Physique pour leur découverte de l’antiproton ?",
      answers: ["1958","1959","1963","1964"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11249: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1959 pour leur découverte de l’antiproton ?",
      answers: ["Lev Landau","Emilio Segrè","Owen Chamberlain","Steven Chu"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11250: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Owen Chamberlain a-t-il reçu le Prix Nobel en 1959 ?",
      answers: ["pour la découverte et l’interprétation de l’effet Cherenkov","pour l’invention de la chambre à bulles","pour leur contribution au développement de la spectroscopie laser","pour leur découverte de l’antiproton"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11251: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Owen Chamberlain a-t-il reçu le Prix Nobel en 1959 ?",
      answers: ["Sciences Économiques","Littérature","Physiologie ou Médecine","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11252: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Jaroslav Heyrovský a-t-il reçu le Prix Nobel de Chimie pour sa découverte et le développement de la méthode d’analyse polarographique ?",
      answers: ["1959","1954","1967","1963"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11253: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1959 pour sa découverte et le développement de la méthode d’analyse polarographique ?",
      answers: ["Sir William Ramsay","Jaroslav Heyrovský","John E. Walker","Carl Bosch"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11254: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Jaroslav Heyrovský a-t-il reçu le Prix Nobel en 1959 ?",
      answers: ["pour sa découverte et le développement de la méthode d’analyse polarographique","pour le développement de la microscopie à fluorescence à super-résolution","pour leurs recherches sur les mécanismes des réactions chimiques","pour ses développements de méthodes computationnelles en chimie quantique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11255: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Jaroslav Heyrovský a-t-il reçu le Prix Nobel en 1959 ?",
      answers: ["Littérature","Physique","Chimie","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11256: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Severo Ochoa a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leur découverte des mécanismes de la synthèse biologique de l’acide ribonucléique et de l’acide désoxyribonucléique ?",
      answers: ["1959","1979","1960","1958"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11257: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1959 pour leur découverte des mécanismes de la synthèse biologique de l’acide ribonucléique et de l’acide désoxyribonucléique ?",
      answers: ["Edward C. Kendall","Georg von Békésy","Severo Ochoa","Hans A. Krebs"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11258: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Severo Ochoa a-t-il reçu le Prix Nobel en 1959 ?",
      answers: ["pour leur découverte des mécanismes de la synthèse biologique de l’acide ribonucléique et de l’acide désoxyribonucléique","pour ses découvertes sur le mécanisme physique de la stimulation dans la cochlée","pour le développement de la tomographie assistée par ordinateur","pour leurs découvertes concernant la régulation génétique de la synthèse des enzymes et des virus"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11259: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Severo Ochoa a-t-il reçu le Prix Nobel en 1959 ?",
      answers: ["Physique","Chimie","Littérature","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11260: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Arthur Kornberg a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leur découverte des mécanismes de la synthèse biologique de l’acide ribonucléique et de l’acide désoxyribonucléique ?",
      answers: ["1956","2016","1959","1953"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11261: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1959 pour leur découverte des mécanismes de la synthèse biologique de l’acide ribonucléique et de l’acide désoxyribonucléique ?",
      answers: ["Joshua Lederberg","Max Theiler","Arthur Kornberg","Hugo Theorell"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11262: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Arthur Kornberg a-t-il reçu le Prix Nobel en 1959 ?",
      answers: ["pour leurs découvertes concernant l’organisation et l’élicitation des schémas de comportement individuels et sociaux","pour leurs découvertes concernant les processus physiologiques et chimiques primaires dans la vision","pour leur découverte des mécanismes de la synthèse biologique de l’acide ribonucléique et de l’acide désoxyribonucléique","pour sa découverte du principe génétique de la génération de la diversité des anticorps"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11263: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Arthur Kornberg a-t-il reçu le Prix Nobel en 1959 ?",
      answers: ["Physique","Paix","Physiologie ou Médecine","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11264: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Philip Noel-Baker a-t-il reçu le Prix Nobel de Paix pour son travail de longue date en faveur de la paix et du désarmement ?",
      answers: ["1959","1987","1958","1937"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11265: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1959 pour son travail de longue date en faveur de la paix et du désarmement ?",
      answers: ["Philip Noel-Baker","Bureau international Nansen pour les réfugiés","Alfonso García Robles","Adolfo Pérez Esquivel"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11266: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Philip Noel-Baker a-t-il reçu le Prix Nobel en 1959 ?",
      answers: ["pour son travail visant à améliorer les conditions de vie des enfants dans le monde","pour son travail de longue date en faveur de la paix et du désarmement","pour son rôle dans la résolution de la crise de Suez par la création de la première force de maintien de la paix des Nations Unies","pour leurs négociations conjointes ayant conduit à un cessez-le-feu au Vietnam"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11267: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Philip Noel-Baker a-t-il reçu le Prix Nobel en 1959 ?",
      answers: ["Paix","Physiologie ou Médecine","Physique","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11268: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Salvatore Quasimodo a-t-il reçu le Prix Nobel de Littérature pour sa poésie lyrique qui exprime avec une intensité classique les expériences tragiques de la vie à notre époque ?",
      answers: ["1927","1959","1964","1958"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11269: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1959 pour sa poésie lyrique qui exprime avec une intensité classique les expériences tragiques de la vie à notre époque ?",
      answers: ["Jean-Paul Sartre","Salvatore Quasimodo","Eugenio Montale","Halldór Laxness"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11270: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Salvatore Quasimodo a-t-il reçu le Prix Nobel en 1959 ?",
      answers: ["pour son œuvre qui, riche en idées et empreinte d’un esprit de liberté et de quête de vérité, a exercé une profonde influence sur notre époque","pour sa poésie lyrique qui exprime avec une intensité classique les expériences tragiques de la vie à notre époque","pour sa maîtrise de l’art narratif, récemment démontrée dans Le Vieil Homme et la Mer, et pour l’influence qu’il a exercée sur le style contemporain","pour son art narratif passionné qui, enraciné dans la culture et les traditions juives polonaises, donne une portée universelle à la condition humaine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11271: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Salvatore Quasimodo a-t-il reçu le Prix Nobel en 1959 ?",
      answers: ["Sciences Économiques","Physiologie ou Médecine","Littérature","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11272: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Donald A. Glaser a-t-il reçu le Prix Nobel de Physique pour l’invention de la chambre à bulles ?",
      answers: ["1956","1959","1960","1948"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11273: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1960 pour l’invention de la chambre à bulles ?",
      answers: ["Murray Gell-Mann","Donald A. Glaser","Alain Aspect","Emilio Segrè"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11274: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Donald A. Glaser a-t-il reçu le Prix Nobel en 1960 ?",
      answers: ["pour leur théorie développée conjointement de la supraconductivité, généralement appelée la théorie BCS","pour leurs découvertes concernant la structure en couches du noyau atomique","pour le développement de méthodes pour refroidir et piéger les atomes avec la lumière laser","pour l’invention de la chambre à bulles"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11275: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Donald A. Glaser a-t-il reçu le Prix Nobel en 1960 ?",
      answers: ["Physique","Physiologie ou Médecine","Littérature","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11276: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Willard F. Libby a-t-il reçu le Prix Nobel de Chimie pour sa méthode de datation par le carbone-14 dans l’archéologie, la géologie, la géophysique et d’autres disciplines ?",
      answers: ["1959","1972","1986","1960"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11277: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1960 pour sa méthode de datation par le carbone-14 dans l’archéologie, la géologie, la géophysique et d’autres disciplines ?",
      answers: ["Mario J. Molina","William S. Knowles","John Jumper","Willard F. Libby"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11278: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Willard F. Libby a-t-il reçu le Prix Nobel en 1960 ?",
      answers: ["pour ses recherches sur l’assimilation du dioxyde de carbone par les plantes","pour sa méthode de datation par le carbone-14 dans l’archéologie, la géologie, la géophysique et d’autres disciplines","pour leurs découvertes dans le domaine de la chimie et de la technologie des hauts polymères","pour ses recherches sur la constitution de l’hème et de la chlorophylle et en particulier pour sa synthèse de l’hème"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11279: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Willard F. Libby a-t-il reçu le Prix Nobel en 1960 ?",
      answers: ["Physiologie ou Médecine","Chimie","Sciences Économiques","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11280: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Sir Frank Macfarlane Burnet a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour la découverte de la tolérance immunologique acquise ?",
      answers: ["1968","1960","1952","1998"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11281: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1960 pour la découverte de la tolérance immunologique acquise ?",
      answers: ["Paul H. Müller","Sir Frank Macfarlane Burnet","Sir Paul M. Nurse","Roger Guillemin"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11282: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Sir Frank Macfarlane Burnet a-t-il reçu le Prix Nobel en 1960 ?",
      answers: ["pour leurs découvertes concernant les mécanismes ioniques impliqués dans l’excitation et l’inhibition dans les parties périphériques et centrales de la membrane des cellules nerveuses","pour leur découverte de la capacité du virus de la poliomyélite à se développer dans des cultures de divers types de tissus","pour leurs découvertes concernant les hormones du cortex surrénalien, leur structure et leurs effets biologiques","pour la découverte de la tolérance immunologique acquise"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11283: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Sir Frank Macfarlane Burnet a-t-il reçu le Prix Nobel en 1960 ?",
      answers: ["Chimie","Physiologie ou Médecine","Physique","Littérature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11284: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Peter B. Medawar a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour la découverte de la tolérance immunologique acquise ?",
      answers: ["1969","1959","1961","1960"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11285: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1960 pour la découverte de la tolérance immunologique acquise ?",
      answers: ["Edward L. Tatum","Peter B. Medawar","Alan L. Hodgkin","Hugo Theorell"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11286: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Peter B. Medawar a-t-il reçu le Prix Nobel en 1960 ?",
      answers: ["pour leur découverte des mécanismes de la synthèse biologique de l’acide ribonucléique et de l’acide désoxyribonucléique","pour sa découverte du coenzyme A et son importance dans le métabolisme intermédiaire","pour leurs découvertes concernant l’organisation structurelle et fonctionnelle de la cellule","pour la découverte de la tolérance immunologique acquise"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11287: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Peter B. Medawar a-t-il reçu le Prix Nobel en 1960 ?",
      answers: ["Chimie","Physiologie ou Médecine","Physique","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11288: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Albert Lutuli a-t-il reçu le Prix Nobel de Paix pour sa lutte non violente contre l’apartheid en Afrique du Sud ?",
      answers: ["1963","1958","1956","1960"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11289: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1960 pour sa lutte non violente contre l’apartheid en Afrique du Sud ?",
      answers: ["Willy Brandt","Albert Lutuli","Dominique Pire","Menachem Begin"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11290: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Albert Lutuli a-t-il reçu le Prix Nobel en 1960 ?",
      answers: ["pour son travail en faveur des réfugiés européens après la Seconde Guerre mondiale","pour ses contributions à la révolution verte, augmentant la production alimentaire mondiale","pour sa lutte non violente contre l’apartheid en Afrique du Sud","pour son travail pour la démocratie et les droits humains en Corée du Sud et en Asie de l’Est, et pour la paix avec la Corée du Nord"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11291: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Albert Lutuli a-t-il reçu le Prix Nobel en 1960 ?",
      answers: ["Physiologie ou Médecine","Chimie","Physique","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11292: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Saint-John Perse a-t-il reçu le Prix Nobel de Littérature pour la hauteur et l’imagerie visionnaire de sa poésie qui reflète de manière créative les conditions de notre temps ?",
      answers: ["1962","1975","1960","1969"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11293: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1960 pour la hauteur et l’imagerie visionnaire de sa poésie qui reflète de manière créative les conditions de notre temps ?",
      answers: ["Selma Lagerlöf","Albert Camus","John Steinbeck","Saint-John Perse"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11294: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Saint-John Perse a-t-il reçu le Prix Nobel en 1960 ?",
      answers: ["cette épopée de l’expérience féminine qui, avec scepticisme, feu et une force visionnaire, a soumis une civilisation divisée à un examen","qui émule les bouffons du Moyen Âge en flagellant l’autorité et en défendant la dignité des opprimés","pour la pénétration spirituelle profonde et l’intensité artistique avec lesquelles il a exploré les drames de la vie humaine dans ses romans","pour la hauteur et l’imagerie visionnaire de sa poésie qui reflète de manière créative les conditions de notre temps"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11295: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Saint-John Perse a-t-il reçu le Prix Nobel en 1960 ?",
      answers: ["Littérature","Sciences Économiques","Physiologie ou Médecine","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11296: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Robert Hofstadter a-t-il reçu le Prix Nobel de Physique pour ses études pionnières sur la diffusion des électrons dans les noyaux atomiques et pour ses découvertes sur la structure des nucléons ?",
      answers: ["1960","1961","1959","1962"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11297: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1961 pour ses études pionnières sur la diffusion des électrons dans les noyaux atomiques et pour ses découvertes sur la structure des nucléons ?",
      answers: ["Julian Schwinger","Rudolf Mössbauer","Robert Hofstadter","Nevill F. Mott"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11298: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Robert Hofstadter a-t-il reçu le Prix Nobel en 1961 ?",
      answers: ["pour ses recherches sur l’absorption par résonance des rayons gamma et sa découverte de l’effet qui porte son nom","pour l’invention de la chambre à bulles","pour ses études pionnières sur la diffusion des électrons dans les noyaux atomiques et pour ses découvertes sur la structure des nucléons","pour sa contribution à l’invention du circuit intégré"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11299: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Robert Hofstadter a-t-il reçu le Prix Nobel en 1961 ?",
      answers: ["Physiologie ou Médecine","Physique","Paix","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11300: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Rudolf Mössbauer a-t-il reçu le Prix Nobel de Physique pour ses recherches sur l’absorption par résonance des rayons gamma et sa découverte de l’effet qui porte son nom ?",
      answers: ["1960","1992","1961","1981"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11301: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1961 pour ses recherches sur l’absorption par résonance des rayons gamma et sa découverte de l’effet qui porte son nom ?",
      answers: ["Philip W. Anderson","J. Hans D. Jensen","Leon N. Cooper","Rudolf Mössbauer"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11302: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Rudolf Mössbauer a-t-il reçu le Prix Nobel en 1961 ?",
      answers: ["pour leurs travaux pionniers sur la transmutation des noyaux atomiques par des particules accélérées artificiellement","pour ses recherches sur l’absorption par résonance des rayons gamma et sa découverte de l’effet qui porte son nom","pour leur découverte de la superfluidité dans l’hélium-3","pour leurs recherches sur les semi-conducteurs et leur découverte de l’effet transistor"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11303: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Rudolf Mössbauer a-t-il reçu le Prix Nobel en 1961 ?",
      answers: ["Sciences Économiques","Paix","Physique","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11304: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Melvin Calvin a-t-il reçu le Prix Nobel de Chimie pour ses recherches sur l’assimilation du dioxyde de carbone par les plantes ?",
      answers: ["1916","1918","1964","1961"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11305: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1961 pour ses recherches sur l’assimilation du dioxyde de carbone par les plantes ?",
      answers: ["Willard F. Libby","Melvin Calvin","Dorothy Crowfoot Hodgkin","Yuan T. Lee"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11306: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Melvin Calvin a-t-il reçu le Prix Nobel en 1961 ?",
      answers: ["pour leurs découvertes dans le domaine de la chimie et de la technologie des hauts polymères","pour son travail sur l’utilisation des isotopes comme traceurs dans l’étude des processus chimiques","pour leurs études sur les structures des protéines globulaires","pour ses recherches sur l’assimilation du dioxyde de carbone par les plantes"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11307: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Melvin Calvin a-t-il reçu le Prix Nobel en 1961 ?",
      answers: ["Physique","Physiologie ou Médecine","Paix","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11308: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Georg von Békésy a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour ses découvertes sur le mécanisme physique de la stimulation dans la cochlée ?",
      answers: ["1959","1963","1961","1987"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11309: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1961 pour ses découvertes sur le mécanisme physique de la stimulation dans la cochlée ?",
      answers: ["Edward A. Doisy","Edmond H. Fischer","Rita Levi-Montalcini","Georg von Békésy"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11310: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Georg von Békésy a-t-il reçu le Prix Nobel en 1961 ?",
      answers: ["pour leurs découvertes concernant l’organisation et l’élicitation des schémas de comportement individuels et sociaux","pour leurs découvertes concernant la structure moléculaire des acides nucléiques et son importance pour le transfert d’information dans le matériel vivant","pour leurs découvertes concernant le cathétérisme cardiaque et les changements pathologiques dans le système circulatoire","pour ses découvertes sur le mécanisme physique de la stimulation dans la cochlée"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11311: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Georg von Békésy a-t-il reçu le Prix Nobel en 1961 ?",
      answers: ["Littérature","Physiologie ou Médecine","Chimie","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11312: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Dag Hammarskjöld a-t-il reçu le Prix Nobel de Paix pour son travail en renforçant les Nations Unies et en promouvant la paix mondiale ?",
      answers: ["1959","1967","1933","1961"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11313: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1961 pour son travail en renforçant les Nations Unies et en promouvant la paix mondiale ?",
      answers: ["Albert Lutuli","Bureau International du Travail (BIT)","Lester B. Pearson","Dag Hammarskjöld"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11314: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Dag Hammarskjöld a-t-il reçu le Prix Nobel en 1961 ?",
      answers: ["pour son travail en renforçant les Nations Unies et en promouvant la paix mondiale","pour leurs contributions à la négociation des accords de Camp David pour la paix au Moyen-Orient","pour leur contribution à la réduction des tensions et à la promotion de la paix dans le monde","pour son travail en faveur des réfugiés européens après la Seconde Guerre mondiale"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11315: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Dag Hammarskjöld a-t-il reçu le Prix Nobel en 1961 ?",
      answers: ["Physique","Paix","Littérature","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11316: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Ivo Andrić a-t-il reçu le Prix Nobel de Littérature pour la force épique avec laquelle il a retracé les thèmes et dépeint les destinées humaines tirées de l’histoire de son pays ?",
      answers: ["1907","1961","1954","1978"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11317: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1961 pour la force épique avec laquelle il a retracé les thèmes et dépeint les destinées humaines tirées de l’histoire de son pays ?",
      answers: ["Pearl Buck","Ivo Andrić","Luigi Pirandello","John Steinbeck"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11318: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Ivo Andrić a-t-il reçu le Prix Nobel en 1961 ?",
      answers: ["pour son art narratif profondément original sur la vie du peuple juif","pour la force épique avec laquelle il a retracé les thèmes et dépeint les destinées humaines tirées de l’histoire de son pays","pour la hauteur et l’imagerie visionnaire de sa poésie qui reflète de manière créative les conditions de notre temps","pour ses écrits lyriques et dramatiques exceptionnels qui interprètent le destin d’Israël avec une force émouvante"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11319: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Ivo Andrić a-t-il reçu le Prix Nobel en 1961 ?",
      answers: ["Littérature","Chimie","Sciences Économiques","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11320: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Lev Landau a-t-il reçu le Prix Nobel de Physique pour ses théories pionnières sur la matière condensée, en particulier l’hélium liquide ?",
      answers: ["1960","1962","1949","1930"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11321: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1962 pour ses théories pionnières sur la matière condensée, en particulier l’hélium liquide ?",
      answers: ["Lev Landau","James Rainwater","J. Hans D. Jensen","Murray Gell-Mann"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11322: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Lev Landau a-t-il reçu le Prix Nobel en 1962 ?",
      answers: ["pour leurs travaux fondamentaux dans le domaine de l’électronique quantique, qui ont conduit à la construction d’oscillateurs et d’amplificateurs basés sur le principe du maser-laser","pour ses théories pionnières sur la matière condensée, en particulier l’hélium liquide","pour leurs découvertes concernant la structure en couches du noyau atomique","pour leurs découvertes expérimentales concernant les phénomènes de tunnel dans les semi-conducteurs et les supraconducteurs, respectivement"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11323: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Lev Landau a-t-il reçu le Prix Nobel en 1962 ?",
      answers: ["Chimie","Physique","Sciences Économiques","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11324: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Max F. Perutz a-t-il reçu le Prix Nobel de Chimie pour leurs études sur les structures des protéines globulaires ?",
      answers: ["1995","1992","1956","1962"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11325: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1962 pour leurs études sur les structures des protéines globulaires ?",
      answers: ["Sir Alexander Todd","Robert B. Woodward","Max F. Perutz","John C. Kendrew"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11326: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Max F. Perutz a-t-il reçu le Prix Nobel en 1962 ?",
      answers: ["pour leurs études sur les structures des protéines globulaires","pour ses contributions à la connaissance de la structure électronique et de la géométrie des molécules, en particulier des radicaux libres","pour sa découverte et le développement de la méthode d’analyse polarographique","pour leurs théories, développées indépendamment, concernant le cours des réactions chimiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11327: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Max F. Perutz a-t-il reçu le Prix Nobel en 1962 ?",
      answers: ["Physique","Paix","Chimie","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11328: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année John C. Kendrew a-t-il reçu le Prix Nobel de Chimie pour leurs études sur les structures des protéines globulaires ?",
      answers: ["1946","1948","1964","1962"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11329: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1962 pour leurs études sur les structures des protéines globulaires ?",
      answers: ["Max F. Perutz","Sir Alexander Todd","John C. Kendrew","Derek H.R. Barton"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11330: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison John C. Kendrew a-t-il reçu le Prix Nobel en 1962 ?",
      answers: ["pour leurs recherches sur les mécanismes des réactions chimiques","pour leurs études sur les structures des protéines globulaires","pour sa méthode de datation par le carbone-14 dans l’archéologie, la géologie, la géophysique et d’autres disciplines","pour ses contributions fondamentales, théoriques et expérimentales, à la chimie physique des macromolécules"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11331: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie John C. Kendrew a-t-il reçu le Prix Nobel en 1962 ?",
      answers: ["Chimie","Physiologie ou Médecine","Paix","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11332: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Francis H.C. Crick a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant la structure moléculaire des acides nucléiques et son importance pour le transfert d’information dans le matériel vivant ?",
      answers: ["1955","1943","1957","1962"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11333: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1962 pour leurs découvertes concernant la structure moléculaire des acides nucléiques et son importance pour le transfert d’information dans le matériel vivant ?",
      answers: ["Konrad Bloch","Francis H.C. Crick","Tadeus Reichstein","César Milstein"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11334: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Francis H.C. Crick a-t-il reçu le Prix Nobel en 1962 ?",
      answers: ["pour leur découverte de la capacité du virus de la poliomyélite à se développer dans des cultures de divers types de tissus","pour ses découvertes sur le mécanisme physique de la stimulation dans la cochlée","pour leurs découvertes concernant la structure moléculaire des acides nucléiques et son importance pour le transfert d’information dans le matériel vivant","pour sa découverte des virus provoquant des tumeurs"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11335: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Francis H.C. Crick a-t-il reçu le Prix Nobel en 1962 ?",
      answers: ["Littérature","Physique","Physiologie ou Médecine","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11336: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année James D. Watson a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant la structure moléculaire des acides nucléiques et son importance pour le transfert d’information dans le matériel vivant ?",
      answers: ["1964","1960","1962","1997"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11337: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1962 pour leurs découvertes concernant la structure moléculaire des acides nucléiques et son importance pour le transfert d’information dans le matériel vivant ?",
      answers: ["James D. Watson","Fritz A. Lipmann","John F. Enders","Roger Guillemin"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11338: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison James D. Watson a-t-il reçu le Prix Nobel en 1962 ?",
      answers: ["pour ses découvertes concernant les composés synthétiques qui inhibent l’action de certaines substances corporelles, notamment leur effet sur le système vasculaire et les muscles squelettiques","pour leurs découvertes concernant le contrôle génétique du développement précoce de l’embryon","pour leur découverte que les gènes agissent en régulant des événements chimiques définis","pour leurs découvertes concernant la structure moléculaire des acides nucléiques et son importance pour le transfert d’information dans le matériel vivant"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11339: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie James D. Watson a-t-il reçu le Prix Nobel en 1962 ?",
      answers: ["Paix","Physique","Physiologie ou Médecine","Sciences Économiques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11340: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Maurice H.F. Wilkins a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant la structure moléculaire des acides nucléiques et son importance pour le transfert d’information dans le matériel vivant ?",
      answers: ["1932","1961","1918","1962"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11341: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1962 pour leurs découvertes concernant la structure moléculaire des acides nucléiques et son importance pour le transfert d’information dans le matériel vivant ?",
      answers: ["Joseph E. Murray","Maurice H.F. Wilkins","James D. Watson","Carl F. Cori"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11342: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Maurice H.F. Wilkins a-t-il reçu le Prix Nobel en 1962 ?",
      answers: ["pour ses découvertes sur le mécanisme physique de la stimulation dans la cochlée","pour leurs découvertes concernant la structure moléculaire des acides nucléiques et son importance pour le transfert d’information dans le matériel vivant","pour leurs découvertes concernant les transmetteurs humoraux dans les terminaisons nerveuses et le mécanisme de leur stockage, libération et inactivation","pour la découverte de la tolérance immunologique acquise"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11343: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Maurice H.F. Wilkins a-t-il reçu le Prix Nobel en 1962 ?",
      answers: ["Chimie","Paix","Physique","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11344: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Linus Pauling a-t-il reçu le Prix Nobel de Paix pour sa campagne contre les essais nucléaires et son plaidoyer pour la paix mondiale ?",
      answers: ["1959","1962","1961","1946"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11345: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1962 pour sa campagne contre les essais nucléaires et son plaidoyer pour la paix mondiale ?",
      answers: ["Christian Lous Lange","Dag Hammarskjöld","Linus Pauling","Ligue des Sociétés de la Croix-Rouge"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11346: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Linus Pauling a-t-il reçu le Prix Nobel en 1962 ?",
      answers: ["pour sa campagne contre les essais nucléaires et son plaidoyer pour la paix mondiale","pour leur travail humanitaire et leurs efforts pour la paix","pour sa lutte non violente contre l’apartheid en Afrique du Sud","pour son travail humanitaire dans les conflits armés"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11347: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Linus Pauling a-t-il reçu le Prix Nobel en 1962 ?",
      answers: ["Littérature","Physique","Paix","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11348: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année John Steinbeck a-t-il reçu le Prix Nobel de Littérature pour ses écrits réalistes et imaginatifs, combinant un humour sympathique et une perception sociale aiguë ?",
      answers: ["1915","1964","1962","1959"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11349: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1962 pour ses écrits réalistes et imaginatifs, combinant un humour sympathique et une perception sociale aiguë ?",
      answers: ["Jean-Paul Sartre","John Steinbeck","Patrick White","Pablo Neruda"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11350: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison John Steinbeck a-t-il reçu le Prix Nobel en 1962 ?",
      answers: ["pour la vigueur artistique et la profonde indépendance d’esprit avec lesquelles il cherche dans ses écrits des réponses aux questions éternelles de l’humanité","pour sa poésie lyrique qui exprime avec une intensité classique les expériences tragiques de la vie à notre époque","pour la hauteur et l’imagerie visionnaire de sa poésie qui reflète de manière créative les conditions de notre temps","pour ses écrits réalistes et imaginatifs, combinant un humour sympathique et une perception sociale aiguë"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11351: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie John Steinbeck a-t-il reçu le Prix Nobel en 1962 ?",
      answers: ["Sciences Économiques","Physique","Littérature","Paix"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11352: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Eugene Wigner a-t-il reçu le Prix Nobel de Physique pour ses contributions à la théorie du noyau atomique et des particules élémentaires, notamment par la découverte et l’application des principes de symétrie fondamentaux ?",
      answers: ["1962","1961","1963","1964"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11353: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1963 pour ses contributions à la théorie du noyau atomique et des particules élémentaires, notamment par la découverte et l’application des principes de symétrie fondamentaux ?",
      answers: ["Pavel A. Cherenkov","Richard P. Feynman","Eugene Wigner","Samuel C.C. Ting"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11354: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Eugene Wigner a-t-il reçu le Prix Nobel en 1963 ?",
      answers: ["pour leur conception du microscope à effet tunnel","pour ses contributions à la théorie du noyau atomique et des particules élémentaires, notamment par la découverte et l’application des principes de symétrie fondamentaux","pour leurs travaux fondamentaux dans le domaine de l’électronique quantique, qui ont conduit à la construction d’oscillateurs et d’amplificateurs basés sur le principe du maser-laser","pour leurs découvertes concernant la structure en couches du noyau atomique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11355: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Eugene Wigner a-t-il reçu le Prix Nobel en 1963 ?",
      answers: ["Paix","Physiologie ou Médecine","Physique","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11356: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Maria Goeppert-Mayer a-t-il reçu le Prix Nobel de Physique pour leurs découvertes concernant la structure en couches du noyau atomique ?",
      answers: ["1963","1954","1955","1970"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11357: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1963 pour leurs découvertes concernant la structure en couches du noyau atomique ?",
      answers: ["Maria Goeppert-Mayer","Owen Chamberlain","Donald A. Glaser","Klaus von Klitzing"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11358: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Maria Goeppert-Mayer a-t-il reçu le Prix Nobel en 1963 ?",
      answers: ["pour leurs découvertes concernant la structure en couches du noyau atomique","pour leur investigation approfondie des lois dites de parité, qui a conduit à d’importantes découvertes concernant les particules élémentaires","pour ses contributions à la théorie du noyau atomique et des particules élémentaires, notamment par la découverte et l’application des principes de symétrie fondamentaux","pour des expériences avec des photons intriqués, établissant la violation des inégalités de Bell et ouvrant la voie à la science de l’information quantique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11359: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Maria Goeppert-Mayer a-t-il reçu le Prix Nobel en 1963 ?",
      answers: ["Physiologie ou Médecine","Physique","Paix","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11360: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année J. Hans D. Jensen a-t-il reçu le Prix Nobel de Physique pour leurs découvertes concernant la structure en couches du noyau atomique ?",
      answers: ["1963","1961","1986","1974"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11361: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1963 pour leurs découvertes concernant la structure en couches du noyau atomique ?",
      answers: ["Nicolay G. Basov","J. Hans D. Jensen","Donald A. Glaser","Rudolf Mössbauer"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11362: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison J. Hans D. Jensen a-t-il reçu le Prix Nobel en 1963 ?",
      answers: ["pour ses contributions à la théorie du noyau atomique et des particules élémentaires, notamment par la découverte et l’application des principes de symétrie fondamentaux","pour l’invention d’un capteur d’imagerie à semi-conducteur – le capteur CCD","pour le développement de la technique du piège à ions","pour leurs découvertes concernant la structure en couches du noyau atomique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11363: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie J. Hans D. Jensen a-t-il reçu le Prix Nobel en 1963 ?",
      answers: ["Physique","Physiologie ou Médecine","Littérature","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11364: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Giulio Natta a-t-il reçu le Prix Nobel de Chimie pour leurs découvertes dans le domaine de la chimie et de la technologie des hauts polymères ?",
      answers: ["1973","1963","1960","1959"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11365: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1963 pour leurs découvertes dans le domaine de la chimie et de la technologie des hauts polymères ?",
      answers: ["Sir J. Fraser Stoddart","Jaroslav Heyrovský","Willard F. Libby","Giulio Natta"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11366: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Giulio Natta a-t-il reçu le Prix Nobel en 1963 ?",
      answers: ["pour le développement de méthodes d’analyse des macromolécules biologiques","pour leurs découvertes dans le domaine de la chimie et de la technologie des hauts polymères","pour ses recherches sur les pigments végétaux, en particulier la chlorophylle","pour sa contribution à la chimie des carbocations"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11367: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Giulio Natta a-t-il reçu le Prix Nobel en 1963 ?",
      answers: ["Chimie","Physiologie ou Médecine","Sciences Économiques","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11368: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Karl Ziegler a-t-il reçu le Prix Nobel de Chimie pour leurs découvertes dans le domaine de la chimie et de la technologie des hauts polymères ?",
      answers: ["1970","1953","1962","1963"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11369: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1963 pour leurs découvertes dans le domaine de la chimie et de la technologie des hauts polymères ?",
      answers: ["Ilya Prigogine","Edwin M. McMillan","Giulio Natta","Karl Ziegler"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11370: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Karl Ziegler a-t-il reçu le Prix Nobel en 1963 ?",
      answers: ["pour ses déterminations par des techniques de rayons X des structures de substances biochimiques importantes","pour leurs découvertes dans le domaine de la chimie et de la technologie des hauts polymères","pour la technique de phage display des peptides et des anticorps","pour leurs études des réactions chimiques extrêmement rapides, réalisées par des perturbations de l’équilibre"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11371: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Karl Ziegler a-t-il reçu le Prix Nobel en 1963 ?",
      answers: ["Physiologie ou Médecine","Sciences Économiques","Littérature","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11372: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Sir John Eccles a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant les mécanismes ioniques impliqués dans l’excitation et l’inhibition dans les parties périphériques et centrales de la membrane des cellules nerveuses ?",
      answers: ["1960","1963","2006","1964"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11373: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1963 pour leurs découvertes concernant les mécanismes ioniques impliqués dans l’excitation et l’inhibition dans les parties périphériques et centrales de la membrane des cellules nerveuses ?",
      answers: ["Andrew Z. Fire","Phillip A. Sharp","Joseph Erlanger","Sir John Eccles"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11374: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Sir John Eccles a-t-il reçu le Prix Nobel en 1963 ?",
      answers: ["pour sa découverte des virus provoquant des tumeurs","pour leurs découvertes concernant les mécanismes ioniques impliqués dans l’excitation et l’inhibition dans les parties périphériques et centrales de la membrane des cellules nerveuses","pour leurs découvertes concernant la structure moléculaire des acides nucléiques et son importance pour le transfert d’information dans le matériel vivant","pour ses découvertes concernant la fièvre jaune et comment la combattre"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11375: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Sir John Eccles a-t-il reçu le Prix Nobel en 1963 ?",
      answers: ["Paix","Sciences Économiques","Physique","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11376: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Alan L. Hodgkin a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant les mécanismes ioniques impliqués dans l’excitation et l’inhibition dans les parties périphériques et centrales de la membrane des cellules nerveuses ?",
      answers: ["1981","1953","1963","1961"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11377: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1963 pour leurs découvertes concernant les mécanismes ioniques impliqués dans l’excitation et l’inhibition dans les parties périphériques et centrales de la membrane des cellules nerveuses ?",
      answers: ["Andrew F. Huxley","Har Gobind Khorana","Alfred D. Hershey","Alan L. Hodgkin"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11378: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Alan L. Hodgkin a-t-il reçu le Prix Nobel en 1963 ?",
      answers: ["pour leurs découvertes concernant le mécanisme et la régulation du métabolisme du cholestérol et des acides gras","pour sa découverte de l’effet organisateur dans le développement embryonnaire","pour leurs découvertes concernant les mécanismes ioniques impliqués dans l’excitation et l’inhibition dans les parties périphériques et centrales de la membrane des cellules nerveuses","pour le développement de la tomographie assistée par ordinateur"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11379: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Alan L. Hodgkin a-t-il reçu le Prix Nobel en 1963 ?",
      answers: ["Physique","Chimie","Littérature","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11380: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Andrew F. Huxley a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant les mécanismes ioniques impliqués dans l’excitation et l’inhibition dans les parties périphériques et centrales de la membrane des cellules nerveuses ?",
      answers: ["1983","1963","1955","1964"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11381: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1963 pour leurs découvertes concernant les mécanismes ioniques impliqués dans l’excitation et l’inhibition dans les parties périphériques et centrales de la membrane des cellules nerveuses ?",
      answers: ["Andrew F. Huxley","Alan L. Hodgkin","Severo Ochoa","Sir John Eccles"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11382: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Andrew F. Huxley a-t-il reçu le Prix Nobel en 1963 ?",
      answers: ["pour leurs découvertes concernant la structure moléculaire des acides nucléiques et son importance pour le transfert d’information dans le matériel vivant","pour sa découverte de la streptomycine, le premier antibiotique efficace contre la tuberculose","pour leurs découvertes concernant les mécanismes ioniques impliqués dans l’excitation et l’inhibition dans les parties périphériques et centrales de la membrane des cellules nerveuses","pour la découverte de la manière dont les chromosomes sont protégés par les télomères et l’enzyme télomérase"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11383: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Andrew F. Huxley a-t-il reçu le Prix Nobel en 1963 ?",
      answers: ["Physiologie ou Médecine","Physique","Littérature","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11384: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Comité International de la Croix-Rouge (CICR) a-t-il reçu le Prix Nobel de Paix pour son travail humanitaire dans les conflits armés ?",
      answers: ["1963","1960","1911","1967"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11385: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1963 pour son travail humanitaire dans les conflits armés ?",
      answers: ["Ligue des Sociétés de la Croix-Rouge","Lê Đức Thọ","Dominique Pire","Comité International de la Croix-Rouge (CICR)"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11386: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Comité International de la Croix-Rouge (CICR) a-t-il reçu le Prix Nobel en 1963 ?",
      answers: ["pour son travail humanitaire dans les conflits armés","pour son travail de longue date en faveur de la paix et du désarmement","pour son rôle dans les accords de Locarno favorisant la paix en Europe","pour son travail dans la rédaction de la Déclaration universelle des droits de l’homme"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11387: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Comité International de la Croix-Rouge (CICR) a-t-il reçu le Prix Nobel en 1963 ?",
      answers: ["Littérature","Physiologie ou Médecine","Paix","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11388: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Ligue des Sociétés de la Croix-Rouge a-t-il reçu le Prix Nobel de Paix pour son travail humanitaire dans les conflits armés ?",
      answers: ["1989","1963","1965","1962"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11389: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1963 pour son travail humanitaire dans les conflits armés ?",
      answers: ["Eisaku Satō","Ligue des Sociétés de la Croix-Rouge","David Trimble","Carlos Filipe Ximenes Belo"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11390: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Ligue des Sociétés de la Croix-Rouge a-t-il reçu le Prix Nobel en 1963 ?",
      answers: ["pour son travail visant à promouvoir la justice sociale et les droits des travailleurs","pour ses efforts extraordinaires visant à renforcer la diplomatie internationale et la coopération entre les peuples","pour leurs efforts visant à créer la paix au Moyen-Orient","pour son travail humanitaire dans les conflits armés"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11391: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Ligue des Sociétés de la Croix-Rouge a-t-il reçu le Prix Nobel en 1963 ?",
      answers: ["Paix","Physiologie ou Médecine","Chimie","Littérature"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11392: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Giorgos Seferis a-t-il reçu le Prix Nobel de Littérature pour son œuvre lyrique éminente, qui rend un hommage artistique à la culture grecque ?",
      answers: ["1963","1967","1962","1964"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11393: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1963 pour son œuvre lyrique éminente, qui rend un hommage artistique à la culture grecque ?",
      answers: ["Mikhail Cholokhov","Jean-Paul Sartre","Nelly Sachs","Giorgos Seferis"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11394: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Giorgos Seferis a-t-il reçu le Prix Nobel en 1963 ?",
      answers: ["en hommage à sa poésie noble, magnifique et variée, qui a toujours été distinguée à la fois par la fraîcheur de son inspiration et par une pureté rare de son esprit","pour sa poésie","pour son œuvre qui, riche en idées et empreinte d’un esprit de liberté et de quête de vérité, a exercé une profonde influence sur notre époque","pour son œuvre lyrique éminente, qui rend un hommage artistique à la culture grecque"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11395: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Giorgos Seferis a-t-il reçu le Prix Nobel en 1963 ?",
      answers: ["Littérature","Physique","Paix","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11396: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Charles H. Townes a-t-il reçu le Prix Nobel de Physique pour leurs travaux fondamentaux dans le domaine de l’électronique quantique, qui ont conduit à la construction d’oscillateurs et d’amplificateurs basés sur le principe du maser-laser ?",
      answers: ["1964","1985","1967","1971"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11397: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1964 pour leurs travaux fondamentaux dans le domaine de l’électronique quantique, qui ont conduit à la construction d’oscillateurs et d’amplificateurs basés sur le principe du maser-laser ?",
      answers: ["Nicolay G. Basov","Tsung-Dao Lee","Charles H. Townes","Robert W. Wilson"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11398: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Charles H. Townes a-t-il reçu le Prix Nobel en 1964 ?",
      answers: ["pour la découverte de la connexion entre le mouvement collectif et le mouvement des particules dans les noyaux atomiques et le développement de la théorie de la structure nucléaire basée sur cette connexion","pour leurs travaux fondamentaux dans le domaine de l’électronique quantique, qui ont conduit à la construction d’oscillateurs et d’amplificateurs basés sur le principe du maser-laser","pour leurs recherches pionnières sur la diffusion inélastique profonde des électrons sur les protons et les neutrons liés","pour leur découverte de l’effet Hall quantique fractionnaire"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11399: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Charles H. Townes a-t-il reçu le Prix Nobel en 1964 ?",
      answers: ["Physique","Physiologie ou Médecine","Chimie","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11400: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Nicolay G. Basov a-t-il reçu le Prix Nobel de Physique pour leurs travaux fondamentaux dans le domaine de l’électronique quantique, qui ont conduit à la construction d’oscillateurs et d’amplificateurs basés sur le principe du maser-laser ?",
      answers: ["1967","1964","2003","1959"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11401: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1964 pour leurs travaux fondamentaux dans le domaine de l’électronique quantique, qui ont conduit à la construction d’oscillateurs et d’amplificateurs basés sur le principe du maser-laser ?",
      answers: ["Antony Hewish","Frank Wilczek","Nicolay G. Basov","Charles H. Townes"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11402: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Nicolay G. Basov a-t-il reçu le Prix Nobel en 1964 ?",
      answers: ["pour leur découverte de la forme du corps noir et de l’anisotropie du fond diffus cosmologique","pour leurs travaux fondamentaux dans le domaine de l’électronique quantique, qui ont conduit à la construction d’oscillateurs et d’amplificateurs basés sur le principe du maser-laser","pour leurs découvertes concernant la structure en couches du noyau atomique","pour le développement de la technique du piège à ions"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11403: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Nicolay G. Basov a-t-il reçu le Prix Nobel en 1964 ?",
      answers: ["Physiologie ou Médecine","Littérature","Physique","Sciences Économiques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11404: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Aleksandr M. Prokhorov a-t-il reçu le Prix Nobel de Physique pour leurs travaux fondamentaux dans le domaine de l’électronique quantique, qui ont conduit à la construction d’oscillateurs et d’amplificateurs basés sur le principe du maser-laser ?",
      answers: ["1916","1972","1973","1964"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11405: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1964 pour leurs travaux fondamentaux dans le domaine de l’électronique quantique, qui ont conduit à la construction d’oscillateurs et d’amplificateurs basés sur le principe du maser-laser ?",
      answers: ["Aleksandr M. Prokhorov","Samuel C.C. Ting","Konstantin Novoselov","F. Duncan M. Haldane"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11406: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Aleksandr M. Prokhorov a-t-il reçu le Prix Nobel en 1964 ?",
      answers: ["pour la découverte de la magnétorésistance géante","pour ses contributions à la théorie du noyau atomique et des particules élémentaires, notamment par la découverte et l’application des principes de symétrie fondamentaux","pour la découverte et l’interprétation de l’effet Cherenkov","pour leurs travaux fondamentaux dans le domaine de l’électronique quantique, qui ont conduit à la construction d’oscillateurs et d’amplificateurs basés sur le principe du maser-laser"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11407: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Aleksandr M. Prokhorov a-t-il reçu le Prix Nobel en 1964 ?",
      answers: ["Physiologie ou Médecine","Sciences Économiques","Physique","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11408: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Dorothy Crowfoot Hodgkin a-t-il reçu le Prix Nobel de Chimie pour ses déterminations par des techniques de rayons X des structures de substances biochimiques importantes ?",
      answers: ["1929","1961","1964","1966"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11409: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1964 pour ses déterminations par des techniques de rayons X des structures de substances biochimiques importantes ?",
      answers: ["Dorothy Crowfoot Hodgkin","Giulio Natta","Otto Hahn","George de Hevesy"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11410: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Dorothy Crowfoot Hodgkin a-t-il reçu le Prix Nobel en 1964 ?",
      answers: ["pour ses déterminations par des techniques de rayons X des structures de substances biochimiques importantes","pour la prédiction de la structure des protéines","pour leurs réalisations exceptionnelles dans le développement de méthodes directes pour la détermination des structures cristallines","pour leurs travaux pionniers, réalisés indépendamment, sur la chimie des organométalliques, appelés composés sandwich"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11411: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Dorothy Crowfoot Hodgkin a-t-il reçu le Prix Nobel en 1964 ?",
      answers: ["Physique","Chimie","Physiologie ou Médecine","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11412: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Konrad Bloch a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant le mécanisme et la régulation du métabolisme du cholestérol et des acides gras ?",
      answers: ["1969","1957","1964","1960"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11413: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1964 pour leurs découvertes concernant le mécanisme et la régulation du métabolisme du cholestérol et des acides gras ?",
      answers: ["Feodor Lynen","Jacques Monod","Charles B. Huggins","Konrad Bloch"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11414: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Konrad Bloch a-t-il reçu le Prix Nobel en 1964 ?",
      answers: ["pour leurs découvertes concernant le mécanisme et la régulation du métabolisme du cholestérol et des acides gras","pour la découverte de la tolérance immunologique acquise","pour leurs découvertes concernant la régulation génétique de la synthèse des enzymes et des virus","pour sa découverte des éléments génétiques mobiles"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11415: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Konrad Bloch a-t-il reçu le Prix Nobel en 1964 ?",
      answers: ["Physique","Littérature","Physiologie ou Médecine","Paix"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11416: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Feodor Lynen a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant le mécanisme et la régulation du métabolisme du cholestérol et des acides gras ?",
      answers: ["1948","1964","1970","1971"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11417: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1964 pour leurs découvertes concernant le mécanisme et la régulation du métabolisme du cholestérol et des acides gras ?",
      answers: ["Roger Guillemin","Hans A. Krebs","Severo Ochoa","Feodor Lynen"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11418: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Feodor Lynen a-t-il reçu le Prix Nobel en 1964 ?",
      answers: ["pour leurs découvertes concernant le traitement de l’information dans le système visuel","pour leurs découvertes concernant le mécanisme et la régulation du métabolisme du cholestérol et des acides gras","pour leurs découvertes concernant la régulation génétique de la synthèse des enzymes et des virus","pour leurs découvertes concernant la structure moléculaire des acides nucléiques et son importance pour le transfert d’information dans le matériel vivant"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11419: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Feodor Lynen a-t-il reçu le Prix Nobel en 1964 ?",
      answers: ["Physique","Littérature","Physiologie ou Médecine","Sciences Économiques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11420: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Martin Luther King Jr. a-t-il reçu le Prix Nobel de Paix pour sa lutte non violente pour les droits civils des Afro-Américains ?",
      answers: ["1964","1967","2008","1968"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11421: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1964 pour sa lutte non violente pour les droits civils des Afro-Américains ?",
      answers: ["Charles G. Dawes","Martin Luther King Jr.","Léon Bourgeois","Lech Wałęsa"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11422: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Martin Luther King Jr. a-t-il reçu le Prix Nobel en 1964 ?",
      answers: ["pour leur travail visant à promouvoir une solution pacifique au conflit en Irlande du Nord","pour sa lutte non violente pour les droits civils des Afro-Américains","pour ses efforts visant à renforcer la coopération en Europe occidentale et à réconcilier l’Allemagne avec les autres nations","pour son travail de médiation en Palestine en 1948-1949"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11423: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Martin Luther King Jr. a-t-il reçu le Prix Nobel en 1964 ?",
      answers: ["Physique","Paix","Physiologie ou Médecine","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11424: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Jean-Paul Sartre a-t-il reçu le Prix Nobel de Littérature pour son œuvre qui, riche en idées et empreinte d’un esprit de liberté et de quête de vérité, a exercé une profonde influence sur notre époque ?",
      answers: ["1964","2015","1926","1952"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11425: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1964 pour son œuvre qui, riche en idées et empreinte d’un esprit de liberté et de quête de vérité, a exercé une profonde influence sur notre époque ?",
      answers: ["Jean-Paul Sartre","Giorgos Seferis","Mikhail Cholokhov","Albert Camus"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11426: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Jean-Paul Sartre a-t-il reçu le Prix Nobel en 1964 ?",
      answers: ["pour son œuvre qui, riche en idées et empreinte d’un esprit de liberté et de quête de vérité, a exercé une profonde influence sur notre époque","pour ses réalisations littéraires éclatantes, enracinées dans les traits nationaux et les traditions des peuples indiens d’Amérique latine","pour son art narratif profondément original sur la vie du peuple juif","pour son œuvre lyrique éminente, qui rend un hommage artistique à la culture grecque"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11427: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Jean-Paul Sartre a-t-il reçu le Prix Nobel en 1964 ?",
      answers: ["Littérature","Physique","Paix","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11428: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Sin-Itiro Tomonaga a-t-il reçu le Prix Nobel de Physique pour leurs contributions fondamentales à l’électrodynamique quantique, avec des conséquences profondes pour la physique des particules élémentaires ?",
      answers: ["1983","1974","1955","1965"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11429: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1965 pour leurs contributions fondamentales à l’électrodynamique quantique, avec des conséquences profondes pour la physique des particules élémentaires ?",
      answers: ["Charles H. Townes","Chen Ning Yang","Charles T.R. Wilson","Sin-Itiro Tomonaga"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11430: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Sin-Itiro Tomonaga a-t-il reçu le Prix Nobel en 1965 ?",
      answers: ["pour ses travaux fondamentaux et ses découvertes concernant l’antiferromagnétisme et le ferrimagnétisme qui ont conduit à d’importantes applications en physique de l’état solide","pour leurs travaux fondamentaux dans le domaine de l’électronique quantique, qui ont conduit à la construction d’oscillateurs et d’amplificateurs basés sur le principe du maser-laser","pour leurs contributions fondamentales à l’électrodynamique quantique, avec des conséquences profondes pour la physique des particules élémentaires","pour leur découverte de la forme du corps noir et de l’anisotropie du fond diffus cosmologique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11431: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Sin-Itiro Tomonaga a-t-il reçu le Prix Nobel en 1965 ?",
      answers: ["Physique","Paix","Physiologie ou Médecine","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11432: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Julian Schwinger a-t-il reçu le Prix Nobel de Physique pour leurs contributions fondamentales à l’électrodynamique quantique, avec des conséquences profondes pour la physique des particules élémentaires ?",
      answers: ["1974","1965","1966","1954"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11433: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1965 pour leurs contributions fondamentales à l’électrodynamique quantique, avec des conséquences profondes pour la physique des particules élémentaires ?",
      answers: ["J. Hans D. Jensen","Rudolf Mössbauer","Anthony J. Leggett","Julian Schwinger"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11434: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Julian Schwinger a-t-il reçu le Prix Nobel en 1965 ?",
      answers: ["pour leur théorie développée conjointement de la supraconductivité, généralement appelée la théorie BCS","pour l’invention de la méthode des champs oscillatoires séparés et son utilisation dans le maser à hydrogène","pour la découverte de nouvelles formes productives de la théorie atomique","pour leurs contributions fondamentales à l’électrodynamique quantique, avec des conséquences profondes pour la physique des particules élémentaires"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11435: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Julian Schwinger a-t-il reçu le Prix Nobel en 1965 ?",
      answers: ["Paix","Littérature","Physique","Sciences Économiques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11436: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Richard P. Feynman a-t-il reçu le Prix Nobel de Physique pour leurs contributions fondamentales à l’électrodynamique quantique, avec des conséquences profondes pour la physique des particules élémentaires ?",
      answers: ["1996","1960","1913","1965"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11437: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1965 pour leurs contributions fondamentales à l’électrodynamique quantique, avec des conséquences profondes pour la physique des particules élémentaires ?",
      answers: ["Richard P. Feynman","William A. Fowler","Martin Ryle","Sin-Itiro Tomonaga"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11438: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Richard P. Feynman a-t-il reçu le Prix Nobel en 1965 ?",
      answers: ["pour leurs contributions fondamentales à l’électrodynamique quantique, avec des conséquences profondes pour la physique des particules élémentaires","pour ses contributions fondamentales à la magnétohydrodynamique avec des applications fructueuses dans différents domaines de la physique des plasmas","pour ses théories pionnières sur la matière condensée, en particulier l’hélium liquide","pour sa démonstration de la méthode du contraste de phase et en particulier pour son invention du microscope à contraste de phase"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11439: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Richard P. Feynman a-t-il reçu le Prix Nobel en 1965 ?",
      answers: ["Littérature","Sciences Économiques","Paix","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11440: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Robert B. Woodward a-t-il reçu le Prix Nobel de Chimie pour ses contributions exceptionnelles à l’art de la synthèse organique ?",
      answers: ["1936","1963","1939","1965"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11441: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1965 pour ses contributions exceptionnelles à l’art de la synthèse organique ?",
      answers: ["Ronald G.W. Norrish","Peter J.W. Debye","Robert B. Woodward","Manfred Eigen"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11442: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Robert B. Woodward a-t-il reçu le Prix Nobel en 1965 ?",
      answers: ["pour ses contributions exceptionnelles à l’art de la synthèse organique","pour leur élucidation du mécanisme enzymatique sous-jacent à la synthèse de l’adénosine triphosphate (ATP)","pour leurs contributions au développement du concept de conformation et son application en chimie","pour leurs découvertes dans le domaine de la chimie et de la technologie des hauts polymères"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11443: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Robert B. Woodward a-t-il reçu le Prix Nobel en 1965 ?",
      answers: ["Physiologie ou Médecine","Chimie","Sciences Économiques","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11444: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année François Jacob a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant la régulation génétique de la synthèse des enzymes et des virus ?",
      answers: ["1967","2023","1965","1933"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11445: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1965 pour leurs découvertes concernant la régulation génétique de la synthèse des enzymes et des virus ?",
      answers: ["Peyton Rous","François Jacob","Victor Ambros","Alan L. Hodgkin"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11446: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison François Jacob a-t-il reçu le Prix Nobel en 1965 ?",
      answers: ["pour leurs découvertes concernant le mécanisme et la régulation du métabolisme du cholestérol et des acides gras","pour le développement de radio-immunoessais des hormones peptidiques","pour leurs découvertes concernant les transmetteurs humoraux dans les terminaisons nerveuses et le mécanisme de leur stockage, libération et inactivation","pour leurs découvertes concernant la régulation génétique de la synthèse des enzymes et des virus"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11447: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie François Jacob a-t-il reçu le Prix Nobel en 1965 ?",
      answers: ["Paix","Sciences Économiques","Physiologie ou Médecine","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11448: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année André Lwoff a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant la régulation génétique de la synthèse des enzymes et des virus ?",
      answers: ["1957","1991","1973","1965"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11449: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1965 pour leurs découvertes concernant la régulation génétique de la synthèse des enzymes et des virus ?",
      answers: ["Sir Howard Florey","François Jacob","André Lwoff","Carol W. Greider"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11450: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison André Lwoff a-t-il reçu le Prix Nobel en 1965 ?",
      answers: ["pour leurs découvertes sur la régulation du cycle cellulaire","pour leurs découvertes concernant le traitement de l’information dans le système visuel","en reconnaissance de ses travaux sur le rôle joué par les protozoaires dans la causation des maladies","pour leurs découvertes concernant la régulation génétique de la synthèse des enzymes et des virus"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11451: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie André Lwoff a-t-il reçu le Prix Nobel en 1965 ?",
      answers: ["Chimie","Physique","Physiologie ou Médecine","Paix"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11452: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Jacques Monod a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant la régulation génétique de la synthèse des enzymes et des virus ?",
      answers: ["1964","1965","1972","1969"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11453: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1965 pour leurs découvertes concernant la régulation génétique de la synthèse des enzymes et des virus ?",
      answers: ["Nikolaas Tinbergen","Maurice H.F. Wilkins","Jacques Monod","Renato Dulbecco"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11454: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Jacques Monod a-t-il reçu le Prix Nobel en 1965 ?",
      answers: ["pour leurs découvertes concernant les processus physiologiques et chimiques primaires dans la vision","pour leurs découvertes concernant la régulation génétique de la synthèse des enzymes et des virus","pour leur découverte de la capacité du virus de la poliomyélite à se développer dans des cultures de divers types de tissus","pour leurs découvertes concernant le mécanisme et la régulation du métabolisme du cholestérol et des acides gras"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11455: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Jacques Monod a-t-il reçu le Prix Nobel en 1965 ?",
      answers: ["Paix","Littérature","Physiologie ou Médecine","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11456: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Fonds des Nations Unies pour l’Enfance (UNICEF) a-t-il reçu le Prix Nobel de Paix pour son travail visant à améliorer les conditions de vie des enfants dans le monde ?",
      answers: ["1964","1965","1935","1975"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11457: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1965 pour son travail visant à améliorer les conditions de vie des enfants dans le monde ?",
      answers: ["Fonds des Nations Unies pour l’Enfance (UNICEF)","Rigoberta Menchú Tum","Comité International de la Croix-Rouge (CICR)","René Cassin"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11458: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Fonds des Nations Unies pour l’Enfance (UNICEF) a-t-il reçu le Prix Nobel en 1965 ?",
      answers: ["pour son travail humanitaire exceptionnel pendant la Seconde Guerre mondiale","pour son travail humanitaire dans les conflits armés","pour sa campagne contre les essais nucléaires et son plaidoyer pour la paix mondiale","pour son travail visant à améliorer les conditions de vie des enfants dans le monde"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11459: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Fonds des Nations Unies pour l’Enfance (UNICEF) a-t-il reçu le Prix Nobel en 1965 ?",
      answers: ["Physique","Chimie","Physiologie ou Médecine","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11460: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Mikhail Cholokhov a-t-il reçu le Prix Nobel de Littérature pour la puissance artistique et l’intégrité avec lesquelles il a dépeint une phase historique dans la vie du peuple russe dans son épopée du Don ?",
      answers: ["1925","1958","1965","1971"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11461: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1965 pour la puissance artistique et l’intégrité avec lesquelles il a dépeint une phase historique dans la vie du peuple russe dans son épopée du Don ?",
      answers: ["Mikhail Cholokhov","Kenzaburo Oe","Eugenio Montale","Giosuè Carducci"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11462: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Mikhail Cholokhov a-t-il reçu le Prix Nobel en 1965 ?",
      answers: ["pour son art narratif passionné qui, enraciné dans la culture et les traditions juives polonaises, donne une portée universelle à la condition humaine","pour son renouvellement audacieux et ingénieux de l’art dramatique et scénique","pour ses écrits lyriques et dramatiques exceptionnels qui interprètent le destin d’Israël avec une force émouvante","pour la puissance artistique et l’intégrité avec lesquelles il a dépeint une phase historique dans la vie du peuple russe dans son épopée du Don"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11463: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Mikhail Cholokhov a-t-il reçu le Prix Nobel en 1965 ?",
      answers: ["Physiologie ou Médecine","Chimie","Physique","Littérature"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11464: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Alfred Kastler a-t-il reçu le Prix Nobel de Physique pour la découverte et le développement de méthodes optiques pour l’étude des résonances hertziennes dans les atomes ?",
      answers: ["1966","1970","1972","1988"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11465: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1966 pour la découverte et le développement de méthodes optiques pour l’étude des résonances hertziennes dans les atomes ?",
      answers: ["Alfred Kastler","Robert C. Richardson","Frederick Reines","Aleksandr M. Prokhorov"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11466: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Alfred Kastler a-t-il reçu le Prix Nobel en 1966 ?",
      answers: ["pour ses travaux fondamentaux et ses découvertes concernant l’antiferromagnétisme et le ferrimagnétisme qui ont conduit à d’importantes applications en physique de l’état solide","pour leur théorie développée conjointement de la supraconductivité, généralement appelée la théorie BCS","pour la découverte et le développement de méthodes optiques pour l’étude des résonances hertziennes dans les atomes","pour leurs travaux fondamentaux dans le domaine de l’électronique quantique, qui ont conduit à la construction d’oscillateurs et d’amplificateurs basés sur le principe du maser-laser"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11467: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Alfred Kastler a-t-il reçu le Prix Nobel en 1966 ?",
      answers: ["Physique","Chimie","Littérature","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11468: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Robert S. Mulliken a-t-il reçu le Prix Nobel de Chimie pour son travail fondamental sur les liaisons chimiques et la structure électronique des molécules par la méthode des orbitales moléculaires ?",
      answers: ["1966","1974","1960","1967"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11469: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1966 pour son travail fondamental sur les liaisons chimiques et la structure électronique des molécules par la méthode des orbitales moléculaires ?",
      answers: ["Kurt Alder","Frederick Sanger","Derek H.R. Barton","Robert S. Mulliken"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11470: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Robert S. Mulliken a-t-il reçu le Prix Nobel en 1966 ?",
      answers: ["pour leurs découvertes dans le domaine de la chimie et de la technologie des hauts polymères","pour leurs études des réactions chimiques extrêmement rapides, réalisées par des perturbations de l’équilibre","pour son travail fondamental sur les liaisons chimiques et la structure électronique des molécules par la méthode des orbitales moléculaires","pour sa découverte que les enzymes peuvent être cristallisées"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11471: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Robert S. Mulliken a-t-il reçu le Prix Nobel en 1966 ?",
      answers: ["Physiologie ou Médecine","Paix","Chimie","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11472: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Charles B. Huggins a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour ses découvertes concernant le traitement hormonal du cancer de la prostate ?",
      answers: ["1966","1973","1950","1951"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11473: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1966 pour ses découvertes concernant le traitement hormonal du cancer de la prostate ?",
      answers: ["Ragnar Granit","George Wald","Peyton Rous","Charles B. Huggins"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11474: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Charles B. Huggins a-t-il reçu le Prix Nobel en 1966 ?",
      answers: ["pour leur découverte de l’origine cellulaire des rétrovirus oncogènes","pour sa découverte de l’effet organisateur dans le développement embryonnaire","pour leurs découvertes concernant la régulation génétique de la synthèse des enzymes et des virus","pour ses découvertes concernant le traitement hormonal du cancer de la prostate"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11475: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Charles B. Huggins a-t-il reçu le Prix Nobel en 1966 ?",
      answers: ["Physiologie ou Médecine","Chimie","Physique","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11476: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Peyton Rous a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour sa découverte des virus provoquant des tumeurs ?",
      answers: ["1953","1970","1975","1966"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11477: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1966 pour sa découverte des virus provoquant des tumeurs ?",
      answers: ["Marshall W. Nirenberg","Drew Weissman","Julius Axelrod","Peyton Rous"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11478: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Peyton Rous a-t-il reçu le Prix Nobel en 1966 ?",
      answers: ["pour sa découverte du coenzyme A et son importance dans le métabolisme intermédiaire","pour ses découvertes concernant la spécialisation fonctionnelle des hémisphères cérébraux","pour leurs découvertes concernant le mécanisme de réplication et la structure génétique des virus","pour sa découverte des virus provoquant des tumeurs"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11479: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Peyton Rous a-t-il reçu le Prix Nobel en 1966 ?",
      answers: ["Physiologie ou Médecine","Littérature","Physique","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11480: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Shmuel Yosef Agnon a-t-il reçu le Prix Nobel de Littérature pour son art narratif profondément original sur la vie du peuple juif ?",
      answers: ["1970","1968","1965","1966"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11481: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1966 pour son art narratif profondément original sur la vie du peuple juif ?",
      answers: ["William Golding","Pär Lagerkvist","Shmuel Yosef Agnon","Octavio Paz"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11482: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Shmuel Yosef Agnon a-t-il reçu le Prix Nobel en 1966 ?",
      answers: ["pour un art narratif épique et psychologique qui a introduit un nouveau continent dans la littérature","pour une œuvre d’une portée universelle, marquée d’amertume et d’ingéniosité linguistique, qui a ouvert de nouvelles voies au roman et au théâtre chinois","pour son art narratif profondément original sur la vie du peuple juif","pour sa maîtrise narrative qui exprime avec une grande sensibilité l’essence de l’esprit japonais"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11483: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Shmuel Yosef Agnon a-t-il reçu le Prix Nobel en 1966 ?",
      answers: ["Physiologie ou Médecine","Paix","Littérature","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11484: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Nelly Sachs a-t-il reçu le Prix Nobel de Littérature pour ses écrits lyriques et dramatiques exceptionnels qui interprètent le destin d’Israël avec une force émouvante ?",
      answers: ["1966","1965","1982","1971"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11485: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1966 pour ses écrits lyriques et dramatiques exceptionnels qui interprètent le destin d’Israël avec une force émouvante ?",
      answers: ["Nelly Sachs","Yasunari Kawabata","Shmuel Yosef Agnon","Juan Ramón Jiménez"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11486: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Nelly Sachs a-t-il reçu le Prix Nobel en 1966 ?",
      answers: ["pour son art narratif profondément original sur la vie du peuple juif","pour une œuvre littéraire empreinte de clarté de pensée et d’intensité poétique","pour la puissance artistique et l’intégrité avec lesquelles il a dépeint une phase historique dans la vie du peuple russe dans son épopée du Don","pour ses écrits lyriques et dramatiques exceptionnels qui interprètent le destin d’Israël avec une force émouvante"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11487: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Nelly Sachs a-t-il reçu le Prix Nobel en 1966 ?",
      answers: ["Chimie","Physiologie ou Médecine","Sciences Économiques","Littérature"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11488: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Hans Bethe a-t-il reçu le Prix Nobel de Physique pour ses contributions à la théorie des réactions nucléaires, en particulier ses découvertes concernant la production d’énergie dans les étoiles ?",
      answers: ["1965","1983","1967","1954"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11489: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1967 pour ses contributions à la théorie des réactions nucléaires, en particulier ses découvertes concernant la production d’énergie dans les étoiles ?",
      answers: ["Robert Hofstadter","Hans Bethe","Willis E. Lamb","Richard P. Feynman"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11490: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Hans Bethe a-t-il reçu le Prix Nobel en 1967 ?",
      answers: ["pour leurs découvertes expérimentales concernant les phénomènes de tunnel dans les semi-conducteurs et les supraconducteurs, respectivement","pour ses contributions à la théorie des réactions nucléaires, en particulier ses découvertes concernant la production d’énergie dans les étoiles","pour leurs contributions à la théorie unifiée des interactions faible et électromagnétique entre particules élémentaires","pour la découverte et le développement de méthodes optiques pour l’étude des résonances hertziennes dans les atomes"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11491: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Hans Bethe a-t-il reçu le Prix Nobel en 1967 ?",
      answers: ["Littérature","Paix","Physique","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11492: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Manfred Eigen a-t-il reçu le Prix Nobel de Chimie pour leurs études des réactions chimiques extrêmement rapides, réalisées par des perturbations de l’équilibre ?",
      answers: ["2008","1954","1967","1965"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11493: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1967 pour leurs études des réactions chimiques extrêmement rapides, réalisées par des perturbations de l’équilibre ?",
      answers: ["John B. Goodenough","George Porter","Manfred Eigen","Robert S. Mulliken"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11494: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Manfred Eigen a-t-il reçu le Prix Nobel en 1967 ?",
      answers: ["pour leurs études des réactions chimiques extrêmement rapides, réalisées par des perturbations de l’équilibre","pour la détermination de la structure tridimensionnelle d’un centre réactionnel photosynthétique","pour le développement d’une méthode d’édition du génome","pour ses recherches sur la nature de la liaison chimique et son application à l’élucidation de la structure des substances complexes"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11495: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Manfred Eigen a-t-il reçu le Prix Nobel en 1967 ?",
      answers: ["Physiologie ou Médecine","Physique","Chimie","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11496: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Ronald G.W. Norrish a-t-il reçu le Prix Nobel de Chimie pour leurs études des réactions chimiques extrêmement rapides, réalisées par des perturbations de l’équilibre ?",
      answers: ["1939","1967","1963","1966"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11497: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1967 pour leurs études des réactions chimiques extrêmement rapides, réalisées par des perturbations de l’équilibre ?",
      answers: ["Giulio Natta","Ronald G.W. Norrish","Yves Chauvin","Manfred Eigen"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11498: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Ronald G.W. Norrish a-t-il reçu le Prix Nobel en 1967 ?",
      answers: ["pour leurs découvertes dans le domaine de la chimie et de la technologie des hauts polymères","pour le développement de modèles multi-échelles pour les systèmes chimiques complexes","pour leurs études des réactions chimiques extrêmement rapides, réalisées par des perturbations de l’équilibre","pour leurs études sur les structures des protéines globulaires"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11499: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Ronald G.W. Norrish a-t-il reçu le Prix Nobel en 1967 ?",
      answers: ["Physique","Paix","Physiologie ou Médecine","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11500: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année George Porter a-t-il reçu le Prix Nobel de Chimie pour leurs études des réactions chimiques extrêmement rapides, réalisées par des perturbations de l’équilibre ?",
      answers: ["1965","1983","1967","1969"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11501: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1967 pour leurs études des réactions chimiques extrêmement rapides, réalisées par des perturbations de l’équilibre ?",
      answers: ["George Porter","William N. Lipscomb","Hans von Euler-Chelpin","Robert B. Woodward"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11502: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison George Porter a-t-il reçu le Prix Nobel en 1967 ?",
      answers: ["pour des études mécanistiques sur la réparation de l’ADN","pour le développement de méthodes d’analyse des macromolécules biologiques","pour leurs études des réactions chimiques extrêmement rapides, réalisées par des perturbations de l’équilibre","pour le développement de la cryo-microscopie électronique pour la détermination de la structure à haute résolution des biomolécules en solution"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11503: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie George Porter a-t-il reçu le Prix Nobel en 1967 ?",
      answers: ["Physiologie ou Médecine","Littérature","Chimie","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11504: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Ragnar Granit a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant les processus physiologiques et chimiques primaires dans la vision ?",
      answers: ["1953","1913","1967","1971"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11505: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1967 pour leurs découvertes concernant les processus physiologiques et chimiques primaires dans la vision ?",
      answers: ["Ragnar Granit","George Wald","Haldan K. Hartline","David H. Hubel"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11506: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Ragnar Granit a-t-il reçu le Prix Nobel en 1967 ?",
      answers: ["pour leur découverte de la capacité du virus de la poliomyélite à se développer dans des cultures de divers types de tissus","pour leurs découvertes concernant la fonction des canaux ioniques uniques dans les cellules","pour leurs découvertes concernant les processus physiologiques et chimiques primaires dans la vision","pour leur interprétation du code génétique et sa fonction dans la synthèse des protéines"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11507: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Ragnar Granit a-t-il reçu le Prix Nobel en 1967 ?",
      answers: ["Physiologie ou Médecine","Physique","Paix","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11508: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Haldan K. Hartline a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant les processus physiologiques et chimiques primaires dans la vision ?",
      answers: ["1927","1965","2005","1967"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11509: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1967 pour leurs découvertes concernant les processus physiologiques et chimiques primaires dans la vision ?",
      answers: ["Peyton Rous","George Wald","Robert W. Holley","Haldan K. Hartline"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11510: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Haldan K. Hartline a-t-il reçu le Prix Nobel en 1967 ?",
      answers: ["pour la découverte de la tolérance immunologique acquise","pour leurs découvertes concernant les processus physiologiques et chimiques primaires dans la vision","pour ses découvertes concernant le traitement hormonal du cancer de la prostate","pour leurs découvertes concernant le traitement de l’information dans le système visuel"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11511: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Haldan K. Hartline a-t-il reçu le Prix Nobel en 1967 ?",
      answers: ["Littérature","Physiologie ou Médecine","Sciences Économiques","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11512: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année George Wald a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant les processus physiologiques et chimiques primaires dans la vision ?",
      answers: ["1967","1964","1969","1972"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11513: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1967 pour leurs découvertes concernant les processus physiologiques et chimiques primaires dans la vision ?",
      answers: ["Ragnar Granit","George Wald","Haldan K. Hartline","Robert G. Edwards"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11514: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison George Wald a-t-il reçu le Prix Nobel en 1967 ?",
      answers: ["pour leurs découvertes concernant le mécanisme et la régulation du métabolisme du cholestérol et des acides gras","pour leurs découvertes concernant les processus physiologiques et chimiques primaires dans la vision","pour leurs découvertes concernant la structure moléculaire des acides nucléiques et son importance pour le transfert d’information dans le matériel vivant","pour sa découverte des virus provoquant des tumeurs"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11515: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie George Wald a-t-il reçu le Prix Nobel en 1967 ?",
      answers: ["Littérature","Physiologie ou Médecine","Physique","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11516: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Miguel Ángel Asturias a-t-il reçu le Prix Nobel de Littérature pour ses réalisations littéraires éclatantes, enracinées dans les traits nationaux et les traditions des peuples indiens d’Amérique latine ?",
      answers: ["1975","1964","1970","1967"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11517: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1967 pour ses réalisations littéraires éclatantes, enracinées dans les traits nationaux et les traditions des peuples indiens d’Amérique latine ?",
      answers: ["Aleksandr Soljenitsyne","Ernest Hemingway","John Steinbeck","Miguel Ángel Asturias"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11518: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Miguel Ángel Asturias a-t-il reçu le Prix Nobel en 1967 ?",
      answers: ["en hommage à l’art consommé, pénétré d’idéalisme, qu’il a démontré tout au long de sa longue carrière productive","pour sa maîtrise narrative qui exprime avec une grande sensibilité l’essence de l’esprit japonais","pour la hauteur et l’imagerie visionnaire de sa poésie qui reflète de manière créative les conditions de notre temps","pour ses réalisations littéraires éclatantes, enracinées dans les traits nationaux et les traditions des peuples indiens d’Amérique latine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11519: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Miguel Ángel Asturias a-t-il reçu le Prix Nobel en 1967 ?",
      answers: ["Physiologie ou Médecine","Sciences Économiques","Paix","Littérature"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11520: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Luis W. Alvarez a-t-il reçu le Prix Nobel de Physique pour sa contribution décisive à la physique des particules élémentaires, en particulier la découverte d’un grand nombre d’états de résonance ?",
      answers: ["1971","1968","1969","1921"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11521: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1968 pour sa contribution décisive à la physique des particules élémentaires, en particulier la découverte d’un grand nombre d’états de résonance ?",
      answers: ["Gérard Mourou","Alfred Kastler","John Bardeen","Luis W. Alvarez"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11522: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Luis W. Alvarez a-t-il reçu le Prix Nobel en 1968 ?",
      answers: ["pour ses théories pionnières sur la matière condensée, en particulier l’hélium liquide","pour leurs contributions fondamentales à l’électrodynamique quantique, avec des conséquences profondes pour la physique des particules élémentaires","pour la découverte de nouvelles formes productives de la théorie atomique","pour sa contribution décisive à la physique des particules élémentaires, en particulier la découverte d’un grand nombre d’états de résonance"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11523: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Luis W. Alvarez a-t-il reçu le Prix Nobel en 1968 ?",
      answers: ["Littérature","Physique","Physiologie ou Médecine","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11524: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Lars Onsager a-t-il reçu le Prix Nobel de Chimie pour la découverte de la relation de réciprocité qui porte son nom, fondamentale pour la thermodynamique des processus irréversibles ?",
      answers: ["1972","2011","1968","1967"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11525: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1968 pour la découverte de la relation de réciprocité qui porte son nom, fondamentale pour la thermodynamique des processus irréversibles ?",
      answers: ["Ronald G.W. Norrish","John C. Kendrew","Lars Onsager","Luis Federico Leloir"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11526: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Lars Onsager a-t-il reçu le Prix Nobel en 1968 ?",
      answers: ["pour leurs études sur les structures des protéines globulaires","pour leurs contributions au développement du concept de conformation et son application en chimie","pour son développement de la théorie de la fonctionnelle de la densité","pour la découverte de la relation de réciprocité qui porte son nom, fondamentale pour la thermodynamique des processus irréversibles"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11527: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Lars Onsager a-t-il reçu le Prix Nobel en 1968 ?",
      answers: ["Physique","Paix","Chimie","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11528: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Robert W. Holley a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leur interprétation du code génétique et sa fonction dans la synthèse des protéines ?",
      answers: ["1965","1966","1924","1968"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11529: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1968 pour leur interprétation du code génétique et sa fonction dans la synthèse des protéines ?",
      answers: ["Paul H. Müller","Julius Axelrod","Marshall W. Nirenberg","Robert W. Holley"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11530: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Robert W. Holley a-t-il reçu le Prix Nobel en 1968 ?",
      answers: ["pour leurs découvertes sur la régulation du cycle cellulaire","pour leurs découvertes concernant les structures génétiquement déterminées à la surface des cellules qui régulent les réactions immunitaires","pour leur interprétation du code génétique et sa fonction dans la synthèse des protéines","pour ses découvertes concernant le traitement hormonal du cancer de la prostate"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11531: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Robert W. Holley a-t-il reçu le Prix Nobel en 1968 ?",
      answers: ["Littérature","Physique","Physiologie ou Médecine","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11532: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Har Gobind Khorana a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leur interprétation du code génétique et sa fonction dans la synthèse des protéines ?",
      answers: ["1950","1968","1969","1997"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11533: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1968 pour leur interprétation du code génétique et sa fonction dans la synthèse des protéines ?",
      answers: ["Sir Bernard Katz","Har Gobind Khorana","Alfred D. Hershey","Renato Dulbecco"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11534: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Har Gobind Khorana a-t-il reçu le Prix Nobel en 1968 ?",
      answers: ["pour leur interprétation du code génétique et sa fonction dans la synthèse des protéines","pour leurs découvertes concernant le mécanisme et la régulation du métabolisme du cholestérol et des acides gras","pour leur découverte des protéines G et leur rôle dans la transduction des signaux dans les cellules","pour leurs découvertes concernant les transmetteurs humoraux dans les terminaisons nerveuses et le mécanisme de leur stockage, libération et inactivation"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11535: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Har Gobind Khorana a-t-il reçu le Prix Nobel en 1968 ?",
      answers: ["Paix","Chimie","Physique","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11536: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Marshall W. Nirenberg a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leur interprétation du code génétique et sa fonction dans la synthèse des protéines ?",
      answers: ["1932","1968","1967","1969"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11537: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1968 pour leur interprétation du code génétique et sa fonction dans la synthèse des protéines ?",
      answers: ["Marshall W. Nirenberg","Edward L. Tatum","Maurice H.F. Wilkins","Werner Forssmann"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11538: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Marshall W. Nirenberg a-t-il reçu le Prix Nobel en 1968 ?",
      answers: ["pour leurs découvertes des facteurs de croissance","pour leur interprétation du code génétique et sa fonction dans la synthèse des protéines","pour ses découvertes concernant la fièvre jaune et comment la combattre","pour leurs découvertes concernant la régulation génétique de la synthèse des enzymes et des virus"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11539: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Marshall W. Nirenberg a-t-il reçu le Prix Nobel en 1968 ?",
      answers: ["Sciences Économiques","Physiologie ou Médecine","Chimie","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11540: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année René Cassin a-t-il reçu le Prix Nobel de Paix pour son travail dans la rédaction de la Déclaration universelle des droits de l’homme ?",
      answers: ["1985","1968","1978","1967"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11541: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1968 pour son travail dans la rédaction de la Déclaration universelle des droits de l’homme ?",
      answers: ["Willy Brandt","Shirin Ebadi","René Cassin","Comité International de la Croix-Rouge (CICR)"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11542: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison René Cassin a-t-il reçu le Prix Nobel en 1968 ?",
      answers: ["pour son travail dans la rédaction de la Déclaration universelle des droits de l’homme","pour sa campagne contre les essais nucléaires et son plaidoyer pour la paix mondiale","pour son travail visant à promouvoir la justice sociale et les droits des travailleurs","pour son travail humanitaire en faveur des réfugiés"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11543: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie René Cassin a-t-il reçu le Prix Nobel en 1968 ?",
      answers: ["Physiologie ou Médecine","Paix","Physique","Littérature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11544: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Yasunari Kawabata a-t-il reçu le Prix Nobel de Littérature pour sa maîtrise narrative qui exprime avec une grande sensibilité l’essence de l’esprit japonais ?",
      answers: ["1968","1936","1963","1970"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11545: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1968 pour sa maîtrise narrative qui exprime avec une grande sensibilité l’essence de l’esprit japonais ?",
      answers: ["Eugenio Montale","Ivo Andrić","Yasunari Kawabata","Vicente Aleixandre"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11546: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Yasunari Kawabata a-t-il reçu le Prix Nobel en 1968 ?",
      answers: ["pour la puissance artistique et l’intégrité avec lesquelles il a dépeint une phase historique dans la vie du peuple russe dans son épopée du Don","pour un art narratif épique et psychologique qui a introduit un nouveau continent dans la littérature","pour ses romans et nouvelles, dans lesquels le fantastique et le réaliste se combinent dans un monde richement composé d’imagination","pour sa maîtrise narrative qui exprime avec une grande sensibilité l’essence de l’esprit japonais"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11547: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Yasunari Kawabata a-t-il reçu le Prix Nobel en 1968 ?",
      answers: ["Physiologie ou Médecine","Chimie","Littérature","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11548: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Murray Gell-Mann a-t-il reçu le Prix Nobel de Physique pour ses contributions et découvertes concernant la classification des particules élémentaires et leurs interactions ?",
      answers: ["1969","1971","1950","1957"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11549: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1969 pour ses contributions et découvertes concernant la classification des particules élémentaires et leurs interactions ?",
      answers: ["Martin L. Perl","Donna Strickland","Murray Gell-Mann","Hans Bethe"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11550: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Murray Gell-Mann a-t-il reçu le Prix Nobel en 1969 ?",
      answers: ["pour leurs découvertes concernant la structure en couches du noyau atomique","pour ses contributions et découvertes concernant la classification des particules élémentaires et leurs interactions","pour son invention et son développement de la méthode holographique","pour leurs recherches pionnières en astrophysique radio : Hewish pour son rôle décisif dans la découverte des pulsars"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11551: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Murray Gell-Mann a-t-il reçu le Prix Nobel en 1969 ?",
      answers: ["Physiologie ou Médecine","Physique","Chimie","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11552: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Derek H.R. Barton a-t-il reçu le Prix Nobel de Chimie pour leurs contributions au développement du concept de conformation et son application en chimie ?",
      answers: ["1972","1979","1969","1959"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11553: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1969 pour leurs contributions au développement du concept de conformation et son application en chimie ?",
      answers: ["Luis Federico Leloir","Jens C. Skou","Derek H.R. Barton","Robert S. Mulliken"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11554: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Derek H.R. Barton a-t-il reçu le Prix Nobel en 1969 ?",
      answers: ["pour leurs travaux sur la chimie de l’atmosphère, notamment concernant la formation et la décomposition de l’ozone","pour son développement de la théorie et de la méthodologie de la synthèse organique","pour leurs études des réactions chimiques extrêmement rapides, réalisées par des perturbations de l’équilibre","pour leurs contributions au développement du concept de conformation et son application en chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11555: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Derek H.R. Barton a-t-il reçu le Prix Nobel en 1969 ?",
      answers: ["Sciences Économiques","Physique","Physiologie ou Médecine","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11556: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Odd Hassel a-t-il reçu le Prix Nobel de Chimie pour leurs contributions au développement du concept de conformation et son application en chimie ?",
      answers: ["1996","1969","1966","2002"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11557: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1969 pour leurs contributions au développement du concept de conformation et son application en chimie ?",
      answers: ["Derek H.R. Barton","Luis Federico Leloir","Odd Hassel","Gerhard Herzberg"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11558: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Odd Hassel a-t-il reçu le Prix Nobel en 1969 ?",
      answers: ["pour son invention de la méthode de microanalyse des substances organiques","pour leurs contributions au développement du concept de conformation et son application en chimie","pour le développement de modèles multi-échelles pour les systèmes chimiques complexes","pour la découverte de la relation de réciprocité qui porte son nom, fondamentale pour la thermodynamique des processus irréversibles"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11559: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Odd Hassel a-t-il reçu le Prix Nobel en 1969 ?",
      answers: ["Sciences Économiques","Physique","Chimie","Paix"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11560: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Max Delbrück a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant le mécanisme de réplication et la structure génétique des virus ?",
      answers: ["1955","1978","1958","1969"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11561: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1969 pour leurs découvertes concernant le mécanisme de réplication et la structure génétique des virus ?",
      answers: ["Arthur Kornberg","André F. Cournand","Max Delbrück","Sir Bernard Katz"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11562: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Max Delbrück a-t-il reçu le Prix Nobel en 1969 ?",
      answers: ["pour leur interprétation du code génétique et sa fonction dans la synthèse des protéines","pour ses découvertes sur les mécanismes de l’autophagie","pour leurs découvertes concernant le mécanisme de réplication et la structure génétique des virus","pour sa découverte des papillomavirus humains causant le cancer du col de l’utérus"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11563: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Max Delbrück a-t-il reçu le Prix Nobel en 1969 ?",
      answers: ["Littérature","Chimie","Physiologie ou Médecine","Paix"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11564: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Alfred D. Hershey a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant le mécanisme de réplication et la structure génétique des virus ?",
      answers: ["1960","2002","1969","1981"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11565: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1969 pour leurs découvertes concernant le mécanisme de réplication et la structure génétique des virus ?",
      answers: ["Alfred D. Hershey","Sir Peter Mansfield","Max Delbrück","Ulf von Euler"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11566: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Alfred D. Hershey a-t-il reçu le Prix Nobel en 1969 ?",
      answers: ["pour la découverte du principe de production d’anticorps monoclonaux","pour leurs découvertes concernant l’organisation structurelle et fonctionnelle de la cellule","pour ses découvertes concernant les composés synthétiques qui inhibent l’action de certaines substances corporelles, notamment leur effet sur le système vasculaire et les muscles squelettiques","pour leurs découvertes concernant le mécanisme de réplication et la structure génétique des virus"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11567: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Alfred D. Hershey a-t-il reçu le Prix Nobel en 1969 ?",
      answers: ["Physique","Paix","Littérature","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11568: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Salvador E. Luria a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant le mécanisme de réplication et la structure génétique des virus ?",
      answers: ["1964","1935","1967","1969"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11569: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1969 pour leurs découvertes concernant le mécanisme de réplication et la structure génétique des virus ?",
      answers: ["Salvador E. Luria","Feodor Lynen","Max Delbrück","Har Gobind Khorana"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11570: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Salvador E. Luria a-t-il reçu le Prix Nobel en 1969 ?",
      answers: ["pour leurs découvertes concernant le mécanisme de réplication et la structure génétique des virus","pour ses découvertes concernant le traitement hormonal du cancer de la prostate","pour leurs découvertes concernant les mécanismes ioniques impliqués dans l’excitation et l’inhibition dans les parties périphériques et centrales de la membrane des cellules nerveuses","pour la découverte du principe de production d’anticorps monoclonaux"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11571: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Salvador E. Luria a-t-il reçu le Prix Nobel en 1969 ?",
      answers: ["Physique","Chimie","Physiologie ou Médecine","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11572: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Bureau International du Travail (BIT) a-t-il reçu le Prix Nobel de Paix pour son travail visant à promouvoir la justice sociale et les droits des travailleurs ?",
      answers: ["1969","1992","1960","2008"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11573: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1969 pour son travail visant à promouvoir la justice sociale et les droits des travailleurs ?",
      answers: ["Bureau International du Travail (BIT)","Desmond Tutu","Willy Brandt","Lê Đức Thọ"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11574: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Bureau International du Travail (BIT) a-t-il reçu le Prix Nobel en 1969 ?",
      answers: ["pour son travail visant à promouvoir la justice sociale et les droits des travailleurs","pour leurs efforts visant à trouver une solution pacifique au conflit en Irlande du Nord","pour son travail humanitaire dans les conflits armés","pour son travail dans la rédaction de la Déclaration universelle des droits de l’homme"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11575: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Bureau International du Travail (BIT) a-t-il reçu le Prix Nobel en 1969 ?",
      answers: ["Sciences Économiques","Physique","Physiologie ou Médecine","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11576: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Samuel Beckett a-t-il reçu le Prix Nobel de Littérature pour son écriture qui, dans de nouvelles formes pour le roman et le théâtre, acquiert son élévation dans la détresse de l’homme moderne ?",
      answers: ["2021","1985","1969","1961"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11577: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1969 pour son écriture qui, dans de nouvelles formes pour le roman et le théâtre, acquiert son élévation dans la détresse de l’homme moderne ?",
      answers: ["Yasunari Kawabata","Jaroslav Seifert","Gabriel García Márquez","Samuel Beckett"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11578: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Samuel Beckett a-t-il reçu le Prix Nobel en 1969 ?",
      answers: ["pour ses réalisations littéraires éclatantes, enracinées dans les traits nationaux et les traditions des peuples indiens d’Amérique latine","pour son écriture qui, dans de nouvelles formes pour le roman et le théâtre, acquiert son élévation dans la détresse de l’homme moderne","pour sa poésie lyrique qui exprime avec une intensité classique les expériences tragiques de la vie à notre époque","pour une poésie qui, avec l’action d’une force élémentaire, donne vie au destin et aux rêves d’un continent"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11579: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Samuel Beckett a-t-il reçu le Prix Nobel en 1969 ?",
      answers: ["Physique","Physiologie ou Médecine","Chimie","Littérature"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11580: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Ragnar Frisch a-t-il reçu le Prix Nobel de Sciences Économiques pour avoir développé et appliqué des modèles dynamiques à l’analyse des processus économiques ?",
      answers: ["1943","1938","1969","1966"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11581: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1969 pour avoir développé et appliqué des modèles dynamiques à l’analyse des processus économiques ?",
      answers: ["Herbert A. Simon","Angus Deaton","Jan Tinbergen","Ragnar Frisch"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11582: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Ragnar Frisch a-t-il reçu le Prix Nobel en 1969 ?",
      answers: ["pour leurs analyses pionnières du développement économique, avec une attention particulière aux problèmes des pays en développement","pour son analyse de la consommation, de la pauvreté et du bien-être","pour leur analyse empirique des prix des actifs","pour avoir développé et appliqué des modèles dynamiques à l’analyse des processus économiques"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11583: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Ragnar Frisch a-t-il reçu le Prix Nobel en 1969 ?",
      answers: ["Paix","Sciences Économiques","Chimie","Littérature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11584: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Jan Tinbergen a-t-il reçu le Prix Nobel de Sciences Économiques pour avoir développé et appliqué des modèles dynamiques à l’analyse des processus économiques ?",
      answers: ["1966","1969","1983","1947"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11585: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1969 pour avoir développé et appliqué des modèles dynamiques à l’analyse des processus économiques ?",
      answers: ["Jan Tinbergen","James Tobin","Milton Friedman","James J. Heckman"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11586: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Jan Tinbergen a-t-il reçu le Prix Nobel en 1969 ?",
      answers: ["pour avoir développé et appliqué des modèles dynamiques à l’analyse des processus économiques","pour leurs contributions méthodologiques à l’analyse des relations causales","pour leur analyse des marchés avec des frictions de recherche","pour son travail scientifique qui a développé une théorie économique statique et dynamique et contribué à élever le niveau d’analyse en sciences économiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11587: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Jan Tinbergen a-t-il reçu le Prix Nobel en 1969 ?",
      answers: ["Physique","Paix","Physiologie ou Médecine","Sciences Économiques"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11588: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Hannes Alfvén a-t-il reçu le Prix Nobel de Physique pour ses contributions fondamentales à la magnétohydrodynamique avec des applications fructueuses dans différents domaines de la physique des plasmas ?",
      answers: ["1971","1973","2015","1970"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11589: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1970 pour ses contributions fondamentales à la magnétohydrodynamique avec des applications fructueuses dans différents domaines de la physique des plasmas ?",
      answers: ["Arno Penzias","Georges Charpak","Syukuro Manabe","Hannes Alfvén"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11590: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Hannes Alfvén a-t-il reçu le Prix Nobel en 1970 ?",
      answers: ["pour des méthodes expérimentales révolutionnaires permettant la mesure et la manipulation des systèmes quantiques individuels","pour ses contributions et découvertes concernant la classification des particules élémentaires et leurs interactions","pour ses contributions fondamentales à la magnétohydrodynamique avec des applications fructueuses dans différents domaines de la physique des plasmas","pour leurs contributions fondamentales à l’électrodynamique quantique, avec des conséquences profondes pour la physique des particules élémentaires"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11591: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Hannes Alfvén a-t-il reçu le Prix Nobel en 1970 ?",
      answers: ["Physiologie ou Médecine","Chimie","Littérature","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11592: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Louis Néel a-t-il reçu le Prix Nobel de Physique pour ses travaux fondamentaux et ses découvertes concernant l’antiferromagnétisme et le ferrimagnétisme qui ont conduit à d’importantes applications en physique de l’état solide ?",
      answers: ["1958","1971","2003","1970"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11593: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1970 pour ses travaux fondamentaux et ses découvertes concernant l’antiferromagnétisme et le ferrimagnétisme qui ont conduit à d’importantes applications en physique de l’état solide ?",
      answers: ["Alfred Kastler","Leo Esaki","Louis Néel","Luis W. Alvarez"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11594: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Louis Néel a-t-il reçu le Prix Nobel en 1970 ?",
      answers: ["pour leur découverte de la forme du corps noir et de l’anisotropie du fond diffus cosmologique","pour ses contributions fondamentales à la magnétohydrodynamique avec des applications fructueuses dans différents domaines de la physique des plasmas","pour la méthode du faisceau de neutrinos et la démonstration de la structure en doublet des leptons par la découverte du neutrino muonique","pour ses travaux fondamentaux et ses découvertes concernant l’antiferromagnétisme et le ferrimagnétisme qui ont conduit à d’importantes applications en physique de l’état solide"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11595: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Louis Néel a-t-il reçu le Prix Nobel en 1970 ?",
      answers: ["Physiologie ou Médecine","Chimie","Physique","Sciences Économiques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11596: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Julius Axelrod a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant les transmetteurs humoraux dans les terminaisons nerveuses et le mécanisme de leur stockage, libération et inactivation ?",
      answers: ["1976","1983","1970","1987"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11597: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1970 pour leurs découvertes concernant les transmetteurs humoraux dans les terminaisons nerveuses et le mécanisme de leur stockage, libération et inactivation ?",
      answers: ["Peyton Rous","Julius Axelrod","Philip S. Hench","Christian de Duve"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11598: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Julius Axelrod a-t-il reçu le Prix Nobel en 1970 ?",
      answers: ["pour leurs découvertes concernant l’organisation et l’élicitation des schémas de comportement individuels et sociaux","pour leurs découvertes sur les gènes discontinus","pour leurs découvertes concernant le mécanisme de réplication et la structure génétique des virus","pour leurs découvertes concernant les transmetteurs humoraux dans les terminaisons nerveuses et le mécanisme de leur stockage, libération et inactivation"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11599: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Julius Axelrod a-t-il reçu le Prix Nobel en 1970 ?",
      answers: ["Paix","Physiologie ou Médecine","Chimie","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11600: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Sir Bernard Katz a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant les transmetteurs humoraux dans les terminaisons nerveuses et le mécanisme de leur stockage, libération et inactivation ?",
      answers: ["1971","1970","1969","2016"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11601: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1970 pour leurs découvertes concernant les transmetteurs humoraux dans les terminaisons nerveuses et le mécanisme de leur stockage, libération et inactivation ?",
      answers: ["Earl W. Sutherland Jr.","Sir Bernard Katz","George W. Beadle","Andrew F. Huxley"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11602: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Sir Bernard Katz a-t-il reçu le Prix Nobel en 1970 ?",
      answers: ["pour leurs découvertes concernant les processus physiologiques et chimiques primaires dans la vision","pour leur découverte des mécanismes de la synthèse biologique de l’acide ribonucléique et de l’acide désoxyribonucléique","pour leurs découvertes concernant les transmetteurs humoraux dans les terminaisons nerveuses et le mécanisme de leur stockage, libération et inactivation","pour ses découvertes concernant les mécanismes d’action des hormones"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11603: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Sir Bernard Katz a-t-il reçu le Prix Nobel en 1970 ?",
      answers: ["Chimie","Physiologie ou Médecine","Physique","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11604: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Ulf von Euler a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant les transmetteurs humoraux dans les terminaisons nerveuses et le mécanisme de leur stockage, libération et inactivation ?",
      answers: ["1969","1970","1931","1972"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11605: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1970 pour leurs découvertes concernant les transmetteurs humoraux dans les terminaisons nerveuses et le mécanisme de leur stockage, libération et inactivation ?",
      answers: ["Ulf von Euler","Sir Bernard Katz","Otto F. Meyerhof","Edmond H. Fischer"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11606: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Ulf von Euler a-t-il reçu le Prix Nobel en 1970 ?",
      answers: ["pour leurs découvertes concernant le mécanisme de réplication et la structure génétique des virus","pour leurs découvertes concernant les transmetteurs humoraux dans les terminaisons nerveuses et le mécanisme de leur stockage, libération et inactivation","pour leurs découvertes concernant les mécanismes ioniques impliqués dans l’excitation et l’inhibition dans les parties périphériques et centrales de la membrane des cellules nerveuses","pour leurs découvertes concernant l’organisation et l’élicitation des schémas de comportement individuels et sociaux"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11607: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Ulf von Euler a-t-il reçu le Prix Nobel en 1970 ?",
      answers: ["Chimie","Paix","Physiologie ou Médecine","Sciences Économiques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11608: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Paul A. Samuelson a-t-il reçu le Prix Nobel de Sciences Économiques pour son travail scientifique qui a développé une théorie économique statique et dynamique et contribué à élever le niveau d’analyse en sciences économiques ?",
      answers: ["1969","2008","2023","1970"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11609: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1970 pour son travail scientifique qui a développé une théorie économique statique et dynamique et contribué à élever le niveau d’analyse en sciences économiques ?",
      answers: ["Jan Tinbergen","William Vickrey","Simon Kuznets","Paul A. Samuelson"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11610: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Paul A. Samuelson a-t-il reçu le Prix Nobel en 1970 ?",
      answers: ["pour avoir renouvelé la recherche en histoire économique en appliquant la théorie économique et les méthodes quantitatives","pour son travail scientifique qui a développé une théorie économique statique et dynamique et contribué à élever le niveau d’analyse en sciences économiques","pour avoir développé et appliqué des modèles dynamiques à l’analyse des processus économiques","pour ses recherches pionnières sur le processus de prise de décision au sein des organisations économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11611: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Paul A. Samuelson a-t-il reçu le Prix Nobel en 1970 ?",
      answers: ["Littérature","Physique","Sciences Économiques","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11612: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Norman Borlaug a-t-il reçu le Prix Nobel de Paix pour ses contributions à la révolution verte, augmentant la production alimentaire mondiale ?",
      answers: ["1982","1970","2012","1972"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11613: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1970 pour ses contributions à la révolution verte, augmentant la production alimentaire mondiale ?",
      answers: ["Dalaï Lama (Tenzin Gyatso)","Norman Borlaug","Seán MacBride","Willy Brandt"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11614: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Norman Borlaug a-t-il reçu le Prix Nobel en 1970 ?",
      answers: ["pour son travail visant à promouvoir la justice sociale et les droits des travailleurs","pour ses contributions à la révolution verte, augmentant la production alimentaire mondiale","pour son travail dans la rédaction de la Déclaration universelle des droits de l’homme","pour leurs négociations conjointes ayant conduit à un cessez-le-feu au Vietnam"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11615: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Norman Borlaug a-t-il reçu le Prix Nobel en 1970 ?",
      answers: ["Physique","Paix","Littérature","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11616: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Luis Federico Leloir a-t-il reçu le Prix Nobel de Chimie pour sa découverte des nucléotides sucrés et leur rôle dans la biosynthèse des glucides ?",
      answers: ["1968","1945","1970","1971"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11617: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1970 pour sa découverte des nucléotides sucrés et leur rôle dans la biosynthèse des glucides ?",
      answers: ["Odd Hassel","Luis Federico Leloir","Aaron Klug","Gerhard Herzberg"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11618: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Luis Federico Leloir a-t-il reçu le Prix Nobel en 1970 ?",
      answers: ["pour son travail sur l’utilisation des isotopes comme traceurs dans l’étude des processus chimiques","pour leur développement et leur utilisation de molécules avec des interactions spécifiques de reconnaissance structurale","pour sa découverte des nucléotides sucrés et leur rôle dans la biosynthèse des glucides","pour la découverte des quasi-cristaux"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11619: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Luis Federico Leloir a-t-il reçu le Prix Nobel en 1970 ?",
      answers: ["Chimie","Physique","Physiologie ou Médecine","Littérature"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11620: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Aleksandr Soljenitsyne a-t-il reçu le Prix Nobel de Littérature pour la force éthique avec laquelle il a poursuivi les traditions indispensables de la littérature russe ?",
      answers: ["2002","1970","1983","1969"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11621: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1970 pour la force éthique avec laquelle il a poursuivi les traditions indispensables de la littérature russe ?",
      answers: ["William Butler Yeats","Bob Dylan","Olga Tokarczuk","Aleksandr Soljenitsyne"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11622: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Aleksandr Soljenitsyne a-t-il reçu le Prix Nobel en 1970 ?",
      answers: ["pour la force éthique avec laquelle il a poursuivi les traditions indispensables de la littérature russe","pour ses réalisations importantes dans la poésie lyrique contemporaine ainsi que dans le domaine de la grande tradition épique russe","pour ses romans qui, avec la clarté de l’art réaliste et la diversité et l’universalité du mythe, éclairent la condition humaine dans le monde d’aujourd’hui","pour une œuvre poétique créative qui illumine la condition humaine dans l’univers et la société actuelle"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11623: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Aleksandr Soljenitsyne a-t-il reçu le Prix Nobel en 1970 ?",
      answers: ["Physiologie ou Médecine","Littérature","Chimie","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11624: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Dennis Gabor a-t-il reçu le Prix Nobel de Physique pour son invention et son développement de la méthode holographique ?",
      answers: ["1971","2000","1978","1917"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11625: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1971 pour son invention et son développement de la méthode holographique ?",
      answers: ["Dennis Gabor","Leon M. Lederman","David M. Lee","John F. Clauser"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11626: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Dennis Gabor a-t-il reçu le Prix Nobel en 1971 ?",
      answers: ["pour le développement de semi-conducteurs utilisés dans l’électronique à haute vitesse et l’optoélectronique","pour son invention et son développement de la méthode holographique","pour sa théorie des phénomènes critiques en relation avec les transitions de phase","pour ses travaux fondamentaux et ses découvertes concernant l’antiferromagnétisme et le ferrimagnétisme qui ont conduit à d’importantes applications en physique de l’état solide"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11627: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Dennis Gabor a-t-il reçu le Prix Nobel en 1971 ?",
      answers: ["Littérature","Sciences Économiques","Chimie","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11628: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Earl W. Sutherland Jr. a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour ses découvertes concernant les mécanismes d’action des hormones ?",
      answers: ["1976","1985","1974","1971"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11629: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1971 pour ses découvertes concernant les mécanismes d’action des hormones ?",
      answers: ["André Lwoff","Earl W. Sutherland Jr.","William C. Campbell","William P. Murphy"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11630: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Earl W. Sutherland Jr. a-t-il reçu le Prix Nobel en 1971 ?",
      answers: ["pour leurs découvertes concernant les processus physiologiques et chimiques primaires dans la vision","pour ses découvertes concernant les mécanismes d’action des hormones","pour leurs découvertes concernant les transmetteurs humoraux dans les terminaisons nerveuses et le mécanisme de leur stockage, libération et inactivation","pour leur découverte des mécanismes de la synthèse biologique de l’acide ribonucléique et de l’acide désoxyribonucléique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11631: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Earl W. Sutherland Jr. a-t-il reçu le Prix Nobel en 1971 ?",
      answers: ["Physique","Littérature","Chimie","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11632: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Simon Kuznets a-t-il reçu le Prix Nobel de Sciences Économiques pour son interprétation empiriquement fondée de la croissance économique qui a conduit à une nouvelle compréhension approfondie de la structure économique et sociale ?",
      answers: ["1972","1971","1931","1975"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11633: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1971 pour son interprétation empiriquement fondée de la croissance économique qui a conduit à une nouvelle compréhension approfondie de la structure économique et sociale ?",
      answers: ["Franco Modigliani","Robert M. Solow","Simon Kuznets","John R. Hicks"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11634: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Simon Kuznets a-t-il reçu le Prix Nobel en 1971 ?",
      answers: ["pour leur approche expérimentale visant à réduire la pauvreté dans le monde","pour son interprétation empiriquement fondée de la croissance économique qui a conduit à une nouvelle compréhension approfondie de la structure économique et sociale","pour leurs contributions pionnières à la théorie de l’équilibre économique général et à la théorie du bien-être","pour avoir développé et appliqué des modèles dynamiques à l’analyse des processus économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11635: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Simon Kuznets a-t-il reçu le Prix Nobel en 1971 ?",
      answers: ["Physique","Physiologie ou Médecine","Littérature","Sciences Économiques"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11636: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Willy Brandt a-t-il reçu le Prix Nobel de Paix pour ses efforts visant à renforcer la coopération en Europe occidentale et à réconcilier l’Allemagne avec les autres nations ?",
      answers: ["1971","1974","1970","1977"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11637: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1971 pour ses efforts visant à renforcer la coopération en Europe occidentale et à réconcilier l’Allemagne avec les autres nations ?",
      answers: ["Lech Wałęsa","Bureau International du Travail (BIT)","Willy Brandt","Martin Luther King Jr."],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11638: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Willy Brandt a-t-il reçu le Prix Nobel en 1971 ?",
      answers: ["pour sa lutte non violente pour la liberté syndicale et les droits des travailleurs en Pologne","pour sa lutte contre l’abus de pouvoir et pour la défense des droits humains et de la paix","pour ses efforts visant à renforcer la coopération en Europe occidentale et à réconcilier l’Allemagne avec les autres nations","pour son travail humanitaire dans les conflits armés"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11639: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Willy Brandt a-t-il reçu le Prix Nobel en 1971 ?",
      answers: ["Physique","Paix","Chimie","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11640: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Gerhard Herzberg a-t-il reçu le Prix Nobel de Chimie pour ses contributions à la connaissance de la structure électronique et de la géométrie des molécules, en particulier des radicaux libres ?",
      answers: ["1968","1978","2002","1971"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11641: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1971 pour ses contributions à la connaissance de la structure électronique et de la géométrie des molécules, en particulier des radicaux libres ?",
      answers: ["Lars Onsager","Luis Federico Leloir","Aaron Ciechanover","Gerhard Herzberg"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11642: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Gerhard Herzberg a-t-il reçu le Prix Nobel en 1971 ?",
      answers: ["pour leur découverte des fullerènes","pour leurs travaux pionniers, réalisés indépendamment, sur la chimie des organométalliques, appelés composés sandwich","pour leurs contributions au développement du concept de conformation et son application en chimie","pour ses contributions à la connaissance de la structure électronique et de la géométrie des molécules, en particulier des radicaux libres"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11643: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Gerhard Herzberg a-t-il reçu le Prix Nobel en 1971 ?",
      answers: ["Chimie","Physiologie ou Médecine","Paix","Littérature"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11644: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Pablo Neruda a-t-il reçu le Prix Nobel de Littérature pour une poésie qui, avec l’action d’une force élémentaire, donne vie au destin et aux rêves d’un continent ?",
      answers: ["1967","1971","1981","1970"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11645: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1971 pour une poésie qui, avec l’action d’une force élémentaire, donne vie au destin et aux rêves d’un continent ?",
      answers: ["Pablo Neruda","Isaac Bashevis Singer","Patrick White","Samuel Beckett"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11646: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Pablo Neruda a-t-il reçu le Prix Nobel en 1971 ?",
      answers: ["pour ses réalisations littéraires éclatantes, enracinées dans les traits nationaux et les traditions des peuples indiens d’Amérique latine","pour une poésie qui, avec l’action d’une force élémentaire, donne vie au destin et aux rêves d’un continent","qui, dans ses romans, combine la créativité du poète et du peintre avec une profonde conscience du temps dans la représentation de la condition humaine","pour sa maîtrise narrative qui exprime avec une grande sensibilité l’essence de l’esprit japonais"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11647: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Pablo Neruda a-t-il reçu le Prix Nobel en 1971 ?",
      answers: ["Physique","Chimie","Littérature","Paix"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11648: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année John Bardeen a-t-il reçu le Prix Nobel de Physique pour leur théorie développée conjointement de la supraconductivité, généralement appelée la théorie BCS ?",
      answers: ["1970","1972","1994","1966"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11649: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1972 pour leur théorie développée conjointement de la supraconductivité, généralement appelée la théorie BCS ?",
      answers: ["John Bardeen","Douglas D. Osheroff","Charles K. Kao","Chen Ning Yang"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11650: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison John Bardeen a-t-il reçu le Prix Nobel en 1972 ?",
      answers: ["pour leurs découvertes expérimentales concernant les phénomènes de tunnel dans les semi-conducteurs et les supraconducteurs, respectivement","pour leurs recherches pionnières en astrophysique radio : Ryle pour ses observations et inventions, notamment la technique de synthèse d’ouverture","pour ses prédictions théoriques des propriétés d’un supercourant à travers une barrière tunnel, en particulier les phénomènes connus sous le nom d’effets Josephson","pour leur théorie développée conjointement de la supraconductivité, généralement appelée la théorie BCS"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11651: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie John Bardeen a-t-il reçu le Prix Nobel en 1972 ?",
      answers: ["Paix","Physique","Sciences Économiques","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11652: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Leon N. Cooper a-t-il reçu le Prix Nobel de Physique pour leur théorie développée conjointement de la supraconductivité, généralement appelée la théorie BCS ?",
      answers: ["1980","1989","1972","1970"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11653: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1972 pour leur théorie développée conjointement de la supraconductivité, généralement appelée la théorie BCS ?",
      answers: ["John Bardeen","Alfred Kastler","Leon N. Cooper","Louis Néel"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11654: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Leon N. Cooper a-t-il reçu le Prix Nobel en 1972 ?",
      answers: ["pour la découverte de la connexion entre le mouvement collectif et le mouvement des particules dans les noyaux atomiques et le développement de la théorie de la structure nucléaire basée sur cette connexion","pour l’invention de la méthode des champs oscillatoires séparés et son utilisation dans le maser à hydrogène","pour leurs découvertes expérimentales concernant les phénomènes de tunnel dans les semi-conducteurs et les supraconducteurs, respectivement","pour leur théorie développée conjointement de la supraconductivité, généralement appelée la théorie BCS"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11655: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Leon N. Cooper a-t-il reçu le Prix Nobel en 1972 ?",
      answers: ["Chimie","Littérature","Physique","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11656: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année John R. Schrieffer a-t-il reçu le Prix Nobel de Physique pour leur théorie développée conjointement de la supraconductivité, généralement appelée la théorie BCS ?",
      answers: ["1973","1971","1963","1972"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11657: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1972 pour leur théorie développée conjointement de la supraconductivité, généralement appelée la théorie BCS ?",
      answers: ["John Bardeen","Aage N. Bohr","John R. Schrieffer","Samuel C.C. Ting"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11658: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison John R. Schrieffer a-t-il reçu le Prix Nobel en 1972 ?",
      answers: ["pour sa contribution au développement de la méthode des faisceaux moléculaires et sa découverte du moment magnétique du proton","pour ses contributions à la théorie des réactions nucléaires, en particulier ses découvertes concernant la production d’énergie dans les étoiles","pour leur théorie développée conjointement de la supraconductivité, généralement appelée la théorie BCS","pour leurs contributions fondamentales à l’électrodynamique quantique, avec des conséquences profondes pour la physique des particules élémentaires"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11659: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie John R. Schrieffer a-t-il reçu le Prix Nobel en 1972 ?",
      answers: ["Paix","Littérature","Physique","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11660: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Christian B. Anfinsen a-t-il reçu le Prix Nobel de Chimie pour son travail sur la ribonucléase, en particulier concernant la connexion entre la séquence d’acides aminés et la conformation biologiquement active ?",
      answers: ["1976","1970","1972","1990"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11661: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1972 pour son travail sur la ribonucléase, en particulier concernant la connexion entre la séquence d’acides aminés et la conformation biologiquement active ?",
      answers: ["Christian B. Anfinsen","Hans von Euler-Chelpin","Luis Federico Leloir","John W. Cornforth"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11662: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Christian B. Anfinsen a-t-il reçu le Prix Nobel en 1972 ?",
      answers: ["pour le développement de la cryo-microscopie électronique pour la détermination de la structure à haute résolution des biomolécules en solution","pour son travail sur la ribonucléase, en particulier concernant la connexion entre la séquence d’acides aminés et la conformation biologiquement active","pour leurs contributions à la compréhension de la connexion entre la structure chimique et l’activité catalytique du centre actif de la molécule de ribonucléase","pour sa méthode de datation par le carbone-14 dans l’archéologie, la géologie, la géophysique et d’autres disciplines"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11663: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Christian B. Anfinsen a-t-il reçu le Prix Nobel en 1972 ?",
      answers: ["Chimie","Paix","Physiologie ou Médecine","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11664: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Stanford Moore a-t-il reçu le Prix Nobel de Chimie pour leurs contributions à la compréhension de la connexion entre la structure chimique et l’activité catalytique du centre actif de la molécule de ribonucléase ?",
      answers: ["1973","1956","1972","1975"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11665: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1972 pour leurs contributions à la compréhension de la connexion entre la structure chimique et l’activité catalytique du centre actif de la molécule de ribonucléase ?",
      answers: ["William H. Stein","Stanford Moore","Edwin M. McMillan","Aaron Klug"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11666: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Stanford Moore a-t-il reçu le Prix Nobel en 1972 ?",
      answers: ["pour leurs contributions au développement du concept de conformation et son application en chimie","pour leur développement de l’utilisation des composés de bore et de phosphore, respectivement, dans la synthèse organique","pour sa découverte des nucléotides sucrés et leur rôle dans la biosynthèse des glucides","pour leurs contributions à la compréhension de la connexion entre la structure chimique et l’activité catalytique du centre actif de la molécule de ribonucléase"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11667: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Stanford Moore a-t-il reçu le Prix Nobel en 1972 ?",
      answers: ["Chimie","Littérature","Physiologie ou Médecine","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11668: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année William H. Stein a-t-il reçu le Prix Nobel de Chimie pour leurs contributions à la compréhension de la connexion entre la structure chimique et l’activité catalytique du centre actif de la molécule de ribonucléase ?",
      answers: ["1990","1970","1969","1972"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11669: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1972 pour leurs contributions à la compréhension de la connexion entre la structure chimique et l’activité catalytique du centre actif de la molécule de ribonucléase ?",
      answers: ["Arne W.K. Tiselius","William H. Stein","Odd Hassel","Christian B. Anfinsen"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11670: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison William H. Stein a-t-il reçu le Prix Nobel en 1972 ?",
      answers: ["pour leurs travaux pionniers, réalisés indépendamment, sur la chimie des organométalliques, appelés composés sandwich","pour leur développement et leur utilisation de molécules avec des interactions spécifiques de reconnaissance structurale","pour leurs contributions à la compréhension de la connexion entre la structure chimique et l’activité catalytique du centre actif de la molécule de ribonucléase","pour ses recherches et inventions en chimie agricole et alimentaire, en particulier pour sa méthode de conservation du fourrage"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11671: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie William H. Stein a-t-il reçu le Prix Nobel en 1972 ?",
      answers: ["Sciences Économiques","Physique","Physiologie ou Médecine","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11672: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Kenneth J. Arrow a-t-il reçu le Prix Nobel de Sciences Économiques pour leurs contributions pionnières à la théorie de l’équilibre économique général et à la théorie du bien-être ?",
      answers: ["2014","1958","1972","1939"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11673: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1972 pour leurs contributions pionnières à la théorie de l’équilibre économique général et à la théorie du bien-être ?",
      answers: ["Kenneth J. Arrow","James A. Mirrlees","Abhijit Banerjee","Eugene F. Fama"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11674: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Kenneth J. Arrow a-t-il reçu le Prix Nobel en 1972 ?",
      answers: ["pour leurs contributions pionnières à la théorie de l’équilibre économique général et à la théorie du bien-être","pour leur analyse des marchés avec des frictions de recherche","pour ses études pionnières sur les structures industrielles, le fonctionnement des marchés et les causes et effets de la régulation publique","pour leurs contributions fondamentales à la théorie économique des incitations sous information asymétrique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11675: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Kenneth J. Arrow a-t-il reçu le Prix Nobel en 1972 ?",
      answers: ["Physiologie ou Médecine","Paix","Sciences Économiques","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11676: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année John R. Hicks a-t-il reçu le Prix Nobel de Sciences Économiques pour leurs contributions pionnières à la théorie de l’équilibre économique général et à la théorie du bien-être ?",
      answers: ["2004","1930","1971","1972"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11677: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1972 pour leurs contributions pionnières à la théorie de l’équilibre économique général et à la théorie du bien-être ?",
      answers: ["John C. Harsanyi","John R. Hicks","Paul A. Samuelson","Kenneth J. Arrow"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11678: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison John R. Hicks a-t-il reçu le Prix Nobel en 1972 ?",
      answers: ["pour leurs contributions à la théorie des contrats","pour leur analyse des marchés avec information asymétrique","pour ses études sur la manière dont les institutions sont formées et affectent la prospérité","pour leurs contributions pionnières à la théorie de l’équilibre économique général et à la théorie du bien-être"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11679: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie John R. Hicks a-t-il reçu le Prix Nobel en 1972 ?",
      answers: ["Chimie","Littérature","Sciences Économiques","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11680: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Heinrich Böll a-t-il reçu le Prix Nobel de Littérature pour ses écrits qui, par leur combinaison d’une large perspective sur son temps et une habileté sensible dans la caractérisation, ont contribué au renouveau de la littérature allemande ?",
      answers: ["1973","1975","1972","1976"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11681: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1972 pour ses écrits qui, par leur combinaison d’une large perspective sur son temps et une habileté sensible dans la caractérisation, ont contribué au renouveau de la littérature allemande ?",
      answers: ["Heinrich Böll","Harry Martinson","Juan Ramón Jiménez","Dario Fo"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11682: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Heinrich Böll a-t-il reçu le Prix Nobel en 1972 ?",
      answers: ["pour un art narratif épique et psychologique qui a introduit un nouveau continent dans la littérature","pour sa poésie distinctive qui, avec une grande sensibilité artistique, a interprété les valeurs humaines sous le signe d’une vision de la vie sans illusions","pour une poésie qui, avec l’action d’une force élémentaire, donne vie au destin et aux rêves d’un continent","pour ses écrits qui, par leur combinaison d’une large perspective sur son temps et une habileté sensible dans la caractérisation, ont contribué au renouveau de la littérature allemande"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11683: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Heinrich Böll a-t-il reçu le Prix Nobel en 1972 ?",
      answers: ["Littérature","Physique","Physiologie ou Médecine","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11684: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Leo Esaki a-t-il reçu le Prix Nobel de Physique pour leurs découvertes expérimentales concernant les phénomènes de tunnel dans les semi-conducteurs et les supraconducteurs, respectivement ?",
      answers: ["1915","1974","1973","1984"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11685: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1973 pour leurs découvertes expérimentales concernant les phénomènes de tunnel dans les semi-conducteurs et les supraconducteurs, respectivement ?",
      answers: ["Samuel C.C. Ting","Sheldon Glashow","Leo Esaki","Ben R. Mottelson"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11686: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Leo Esaki a-t-il reçu le Prix Nobel en 1973 ?",
      answers: ["pour leurs découvertes expérimentales concernant les phénomènes de tunnel dans les semi-conducteurs et les supraconducteurs, respectivement","pour des découvertes théoriques sur les transitions de phase topologiques et les phases topologiques de la matière","pour la découverte de l’expansion accelérée de l’univers par l’observation des supernovae lointaines","pour la découverte d’un objet compact supermassif au centre de notre galaxie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11687: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Leo Esaki a-t-il reçu le Prix Nobel en 1973 ?",
      answers: ["Physiologie ou Médecine","Sciences Économiques","Chimie","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11688: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Ivar Giaever a-t-il reçu le Prix Nobel de Physique pour leurs découvertes expérimentales concernant les phénomènes de tunnel dans les semi-conducteurs et les supraconducteurs, respectivement ?",
      answers: ["1980","1967","1973","1974"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11689: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1973 pour leurs découvertes expérimentales concernant les phénomènes de tunnel dans les semi-conducteurs et les supraconducteurs, respectivement ?",
      answers: ["Didier Queloz","Leo Esaki","Ivar Giaever","Isamu Akasaki"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11690: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Ivar Giaever a-t-il reçu le Prix Nobel en 1973 ?",
      answers: ["pour leur découverte du rayonnement de fond cosmique micro-ondes","pour la découverte des violations de principes fondamentaux de symétrie dans la désintégration des mésons K neutres","pour la découverte et l’interprétation de l’effet Cherenkov","pour leurs découvertes expérimentales concernant les phénomènes de tunnel dans les semi-conducteurs et les supraconducteurs, respectivement"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11691: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Ivar Giaever a-t-il reçu le Prix Nobel en 1973 ?",
      answers: ["Physique","Chimie","Littérature","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11692: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Brian D. Josephson a-t-il reçu le Prix Nobel de Physique pour ses prédictions théoriques des propriétés d’un supercourant à travers une barrière tunnel, en particulier les phénomènes connus sous le nom d’effets Josephson ?",
      answers: ["1977","1944","1962","1973"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11693: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1973 pour ses prédictions théoriques des propriétés d’un supercourant à travers une barrière tunnel, en particulier les phénomènes connus sous le nom d’effets Josephson ?",
      answers: ["John D. Cockcroft","Brian D. Josephson","Leo Esaki","Martin Ryle"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11694: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Brian D. Josephson a-t-il reçu le Prix Nobel en 1973 ?",
      answers: ["pour leurs découvertes expérimentales concernant les phénomènes de tunnel dans les semi-conducteurs et les supraconducteurs, respectivement","pour ses prédictions théoriques des propriétés d’un supercourant à travers une barrière tunnel, en particulier les phénomènes connus sous le nom d’effets Josephson","pour l’invention de diodes électroluminescentes bleues efficaces, permettant des sources de lumière blanche brillantes et économes en énergie","pour leur théorie développée conjointement de la supraconductivité, généralement appelée la théorie BCS"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11695: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Brian D. Josephson a-t-il reçu le Prix Nobel en 1973 ?",
      answers: ["Littérature","Chimie","Physique","Sciences Économiques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11696: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Ernst Otto Fischer a-t-il reçu le Prix Nobel de Chimie pour leurs travaux pionniers, réalisés indépendamment, sur la chimie des organométalliques, appelés composés sandwich ?",
      answers: ["1982","1973","1966","1972"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11697: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1973 pour leurs travaux pionniers, réalisés indépendamment, sur la chimie des organométalliques, appelés composés sandwich ?",
      answers: ["Paul J. Flory","Roald Hoffmann","Ernst Otto Fischer","Christian B. Anfinsen"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11698: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Ernst Otto Fischer a-t-il reçu le Prix Nobel en 1973 ?",
      answers: ["pour leurs travaux pionniers, réalisés indépendamment, sur la chimie des organométalliques, appelés composés sandwich","pour leurs découvertes dans le domaine de la chimie et de la technologie des hauts polymères","pour sa contribution à la compréhension du transfert d’énergie biologique par la formulation de la théorie chimi-osmotique","pour leurs contributions à la compréhension de la connexion entre la structure chimique et l’activité catalytique du centre actif de la molécule de ribonucléase"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11699: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Ernst Otto Fischer a-t-il reçu le Prix Nobel en 1973 ?",
      answers: ["Physiologie ou Médecine","Chimie","Littérature","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11700: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Geoffrey Wilkinson a-t-il reçu le Prix Nobel de Chimie pour leurs travaux pionniers, réalisés indépendamment, sur la chimie des organométalliques, appelés composés sandwich ?",
      answers: ["1970","1972","1973","1919"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11701: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1973 pour leurs travaux pionniers, réalisés indépendamment, sur la chimie des organométalliques, appelés composés sandwich ?",
      answers: ["Richard Kuhn","Geoffrey Wilkinson","Sir Alexander Todd","Luis Federico Leloir"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11702: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Geoffrey Wilkinson a-t-il reçu le Prix Nobel en 1973 ?",
      answers: ["pour leurs réalisations exceptionnelles dans le développement de méthodes directes pour la détermination des structures cristallines","pour leur découverte et le développement de la synthèse par diène","pour leurs travaux sur la chimie de l’atmosphère, notamment concernant la formation et la décomposition de l’ozone","pour leurs travaux pionniers, réalisés indépendamment, sur la chimie des organométalliques, appelés composés sandwich"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11703: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Geoffrey Wilkinson a-t-il reçu le Prix Nobel en 1973 ?",
      answers: ["Chimie","Paix","Physiologie ou Médecine","Sciences Économiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11704: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Konrad Lorenz a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant l’organisation et l’élicitation des schémas de comportement individuels et sociaux ?",
      answers: ["1973","1990","1967","1965"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11705: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1973 pour leurs découvertes concernant l’organisation et l’élicitation des schémas de comportement individuels et sociaux ?",
      answers: ["Karl von Frisch","Sir Bernard Katz","Edward C. Kendall","Konrad Lorenz"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11706: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Konrad Lorenz a-t-il reçu le Prix Nobel en 1973 ?",
      answers: ["pour leurs découvertes concernant les transmetteurs humoraux dans les terminaisons nerveuses et le mécanisme de leur stockage, libération et inactivation","pour leurs découvertes concernant la régulation du métabolisme du cholestérol","pour leurs découvertes concernant l’organisation et l’élicitation des schémas de comportement individuels et sociaux","pour leurs découvertes concernant l’organisation structurelle et fonctionnelle de la cellule"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11707: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Konrad Lorenz a-t-il reçu le Prix Nobel en 1973 ?",
      answers: ["Physique","Physiologie ou Médecine","Sciences Économiques","Littérature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11708: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Nikolaas Tinbergen a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant l’organisation et l’élicitation des schémas de comportement individuels et sociaux ?",
      answers: ["1968","1972","1973","1975"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11709: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1973 pour leurs découvertes concernant l’organisation et l’élicitation des schémas de comportement individuels et sociaux ?",
      answers: ["Nikolaas Tinbergen","Konrad Lorenz","Peyton Rous","Sir Bernard Katz"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11710: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Nikolaas Tinbergen a-t-il reçu le Prix Nobel en 1973 ?",
      answers: ["pour sa découverte des virus provoquant des tumeurs","pour leurs découvertes concernant de nouveaux mécanismes d’origine et de dissémination des maladies infectieuses","pour leurs découvertes concernant l’organisation et l’élicitation des schémas de comportement individuels et sociaux","pour leurs découvertes concernant les structures génétiquement déterminées à la surface des cellules qui régulent les réactions immunitaires"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11711: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Nikolaas Tinbergen a-t-il reçu le Prix Nobel en 1973 ?",
      answers: ["Physique","Physiologie ou Médecine","Paix","Littérature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11712: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Karl von Frisch a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant l’organisation et l’élicitation des schémas de comportement individuels et sociaux ?",
      answers: ["1961","1968","1973","1972"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11713: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1973 pour leurs découvertes concernant l’organisation et l’élicitation des schémas de comportement individuels et sociaux ?",
      answers: ["Sir Bernard Katz","Karl von Frisch","Konrad Bloch","Baruj Benacerraf"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11714: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Karl von Frisch a-t-il reçu le Prix Nobel en 1973 ?",
      answers: ["pour leurs découvertes concernant l’organisation et l’élicitation des schémas de comportement individuels et sociaux","pour la découverte de l’insuline","pour la découverte des enzymes de restriction et leur application aux problèmes de génétique moléculaire","pour leurs découvertes sur la régulation du cycle cellulaire"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11715: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Karl von Frisch a-t-il reçu le Prix Nobel en 1973 ?",
      answers: ["Physique","Paix","Physiologie ou Médecine","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11716: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Henry Kissinger a-t-il reçu le Prix Nobel de Paix pour leurs négociations conjointes ayant conduit à un cessez-le-feu au Vietnam ?",
      answers: ["1970","2014","1914","1973"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11717: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1973 pour leurs négociations conjointes ayant conduit à un cessez-le-feu au Vietnam ?",
      answers: ["Henry Kissinger","Médecins Internationaux pour la Prévention de la Guerre Nucléaire","Eisaku Satō","Bureau International du Travail (BIT)"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11718: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Henry Kissinger a-t-il reçu le Prix Nobel en 1973 ?",
      answers: ["pour leur travail en faveur du désarmement et de la paix mondiale","pour leurs négociations conjointes ayant conduit à un cessez-le-feu au Vietnam","pour son travail humanitaire pendant la Première Guerre mondiale","pour son travail en faveur des droits humains et de la libération des prisonniers politiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11719: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Henry Kissinger a-t-il reçu le Prix Nobel en 1973 ?",
      answers: ["Paix","Physique","Chimie","Littérature"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11720: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Lê Đức Thọ a-t-il reçu le Prix Nobel de Paix pour leurs négociations conjointes ayant conduit à un cessez-le-feu au Vietnam ?",
      answers: ["1972","1919","1974","1973"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11721: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1973 pour leurs négociations conjointes ayant conduit à un cessez-le-feu au Vietnam ?",
      answers: ["Henry Kissinger","René Cassin","Lê Đức Thọ","Martin Luther King Jr."],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11722: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Lê Đức Thọ a-t-il reçu le Prix Nobel en 1973 ?",
      answers: ["pour son travail humanitaire dans les conflits armés","pour leurs négociations conjointes ayant conduit à un cessez-le-feu au Vietnam","pour son travail en renforçant les Nations Unies et en promouvant la paix mondiale","pour sa campagne contre les essais nucléaires et son plaidoyer pour la paix mondiale"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11723: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Lê Đức Thọ a-t-il reçu le Prix Nobel en 1973 ?",
      answers: ["Chimie","Littérature","Physiologie ou Médecine","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11724: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Patrick White a-t-il reçu le Prix Nobel de Littérature pour un art narratif épique et psychologique qui a introduit un nouveau continent dans la littérature ?",
      answers: ["1972","2008","1973","1912"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11725: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1973 pour un art narratif épique et psychologique qui a introduit un nouveau continent dans la littérature ?",
      answers: ["Harry Martinson","Joseph Brodsky","Patrick White","Heinrich Böll"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11726: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Patrick White a-t-il reçu le Prix Nobel en 1973 ?",
      answers: ["pour des écrits qui capturent la goutte de rosée et reflètent le cosmos","qui, dans des romans caractérisés par une force visionnaire et une portée poétique, donne vie à un aspect essentiel de la réalité américaine","pour un art narratif épique et psychologique qui a introduit un nouveau continent dans la littérature","pour sa poésie qui, contre l’arrière-plan de la tradition grecque, dépeint avec une force sensuelle et une clarté intellectuelle la lutte de l’homme moderne pour la liberté et la créativité"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11727: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Patrick White a-t-il reçu le Prix Nobel en 1973 ?",
      answers: ["Littérature","Sciences Économiques","Chimie","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11728: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Antony Hewish a-t-il reçu le Prix Nobel de Physique pour leurs recherches pionnières en astrophysique radio : Hewish pour son rôle décisif dans la découverte des pulsars ?",
      answers: ["1974","1981","1952","1983"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11729: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1974 pour leurs recherches pionnières en astrophysique radio : Hewish pour son rôle décisif dans la découverte des pulsars ?",
      answers: ["Vitaly L. Ginzburg","Antony Hewish","Martin Ryle","Aage N. Bohr"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11730: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Antony Hewish a-t-il reçu le Prix Nobel en 1974 ?",
      answers: ["pour son invention et son développement de la méthode holographique","pour la découverte de la connexion entre le mouvement collectif et le mouvement des particules dans les noyaux atomiques et le développement de la théorie de la structure nucléaire basée sur cette connexion","pour leurs contributions à la théorie unifiée des interactions faible et électromagnétique entre particules élémentaires","pour leurs recherches pionnières en astrophysique radio : Hewish pour son rôle décisif dans la découverte des pulsars"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11731: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Antony Hewish a-t-il reçu le Prix Nobel en 1974 ?",
      answers: ["Paix","Chimie","Littérature","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11732: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Martin Ryle a-t-il reçu le Prix Nobel de Physique pour leurs recherches pionnières en astrophysique radio : Ryle pour ses observations et inventions, notamment la technique de synthèse d’ouverture ?",
      answers: ["1974","1971","1976","1980"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11733: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1974 pour leurs recherches pionnières en astrophysique radio : Ryle pour ses observations et inventions, notamment la technique de synthèse d’ouverture ?",
      answers: ["Martin Ryle","Igor Y. Tamm","James Rainwater","Antony Hewish"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11734: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Martin Ryle a-t-il reçu le Prix Nobel en 1974 ?",
      answers: ["pour leurs découvertes expérimentales concernant les phénomènes de tunnel dans les semi-conducteurs et les supraconducteurs, respectivement","pour leurs recherches pionnières en astrophysique radio : Ryle pour ses observations et inventions, notamment la technique de synthèse d’ouverture","pour le développement de la spectroscopie neutronique","pour son travail fondamental sur l’optique électronique et la conception du premier microscope électronique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11735: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Martin Ryle a-t-il reçu le Prix Nobel en 1974 ?",
      answers: ["Physiologie ou Médecine","Littérature","Chimie","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11736: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Paul J. Flory a-t-il reçu le Prix Nobel de Chimie pour ses contributions fondamentales, théoriques et expérimentales, à la chimie physique des macromolécules ?",
      answers: ["1982","1923","1974","1973"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11737: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1974 pour ses contributions fondamentales, théoriques et expérimentales, à la chimie physique des macromolécules ?",
      answers: ["Paul J. Flory","Walter Gilbert","Robert S. Mulliken","Odd Hassel"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11738: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Paul J. Flory a-t-il reçu le Prix Nobel en 1974 ?",
      answers: ["pour leurs contributions à la compréhension de la connexion entre la structure chimique et l’activité catalytique du centre actif de la molécule de ribonucléase","pour leurs travaux pionniers, réalisés indépendamment, sur la chimie des organométalliques, appelés composés sandwich","pour ses études fondamentales sur la biochimie des acides nucléiques, en particulier l’ADN recombinant","pour ses contributions fondamentales, théoriques et expérimentales, à la chimie physique des macromolécules"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11739: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Paul J. Flory a-t-il reçu le Prix Nobel en 1974 ?",
      answers: ["Physiologie ou Médecine","Physique","Chimie","Sciences Économiques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11740: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Albert Claude a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant l’organisation structurelle et fonctionnelle de la cellule ?",
      answers: ["1917","1969","1974","1990"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11741: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1974 pour leurs découvertes concernant l’organisation structurelle et fonctionnelle de la cellule ?",
      answers: ["Michael Houghton","Nikolaas Tinbergen","Albert Claude","Baruj Benacerraf"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11742: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Albert Claude a-t-il reçu le Prix Nobel en 1974 ?",
      answers: ["pour leurs découvertes concernant l’organisation structurelle et fonctionnelle de la cellule","pour leurs découvertes concernant la production d’hormones peptidiques dans le cerveau","pour leurs découvertes concernant les processus physiologiques et chimiques primaires dans la vision","pour leurs découvertes concernant les prostaglandines et les substances biologiquement actives apparentées"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11743: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Albert Claude a-t-il reçu le Prix Nobel en 1974 ?",
      answers: ["Paix","Littérature","Physique","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11744: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Christian de Duve a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant l’organisation structurelle et fonctionnelle de la cellule ?",
      answers: ["1974","1976","1971","1968"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11745: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1974 pour leurs découvertes concernant l’organisation structurelle et fonctionnelle de la cellule ?",
      answers: ["David Baltimore","Christian de Duve","George E. Palade","Tadeus Reichstein"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11746: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Christian de Duve a-t-il reçu le Prix Nobel en 1974 ?",
      answers: ["pour leurs découvertes concernant de nouveaux mécanismes d’origine et de dissémination des maladies infectieuses","pour leurs découvertes concernant l’organisation structurelle et fonctionnelle de la cellule","pour leurs découvertes concernant le mécanisme et la régulation du métabolisme du cholestérol et des acides gras","pour leurs découvertes concernant l’interaction entre les virus tumoraux et le matériel génétique de la cellule"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11747: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Christian de Duve a-t-il reçu le Prix Nobel en 1974 ?",
      answers: ["Physiologie ou Médecine","Physique","Paix","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11748: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année George E. Palade a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant l’organisation structurelle et fonctionnelle de la cellule ?",
      answers: ["2006","1974","1972","1965"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11749: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1974 pour leurs découvertes concernant l’organisation structurelle et fonctionnelle de la cellule ?",
      answers: ["Daniel Bovet","Ulf von Euler","George E. Palade","Christian de Duve"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11750: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison George E. Palade a-t-il reçu le Prix Nobel en 1974 ?",
      answers: ["pour leurs découvertes concernant l’organisation structurelle et fonctionnelle de la cellule","pour leurs découvertes concernant les processus physiologiques et chimiques primaires dans la vision","pour la découverte du principe de production d’anticorps monoclonaux","pour la découverte de la tolérance immunologique acquise"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11751: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie George E. Palade a-t-il reçu le Prix Nobel en 1974 ?",
      answers: ["Littérature","Physique","Physiologie ou Médecine","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11752: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Seán MacBride a-t-il reçu le Prix Nobel de Paix pour son travail en faveur des droits humains et de la paix internationale ?",
      answers: ["1974","1975","1976","1953"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11753: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1974 pour son travail en faveur des droits humains et de la paix internationale ?",
      answers: ["Eisaku Satō","Bureau International du Travail (BIT)","Seán MacBride","Médecins Internationaux pour la Prévention de la Guerre Nucléaire"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11754: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Seán MacBride a-t-il reçu le Prix Nobel en 1974 ?",
      answers: ["pour leurs négociations conjointes ayant conduit à un cessez-le-feu au Vietnam","pour son travail en faveur des droits humains et de la paix internationale","pour son travail en faveur de la paix et de la coopération internationale","pour son travail humanitaire en faveur des réfugiés dans le monde entier"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11755: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Seán MacBride a-t-il reçu le Prix Nobel en 1974 ?",
      answers: ["Littérature","Physiologie ou Médecine","Physique","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11756: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Eisaku Satō a-t-il reçu le Prix Nobel de Paix pour sa contribution à la politique de non-prolifération nucléaire du Japon et à la paix en Asie ?",
      answers: ["1984","1965","1913","1974"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11757: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1974 pour sa contribution à la politique de non-prolifération nucléaire du Japon et à la paix en Asie ?",
      answers: ["Andrei Sakharov","Eisaku Satō","Carlos Saavedra Lamas","Seán MacBride"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11758: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Eisaku Satō a-t-il reçu le Prix Nobel en 1974 ?",
      answers: ["pour son travail en renforçant les Nations Unies et en promouvant la paix mondiale","pour sa contribution à la politique de non-prolifération nucléaire du Japon et à la paix en Asie","pour leur travail visant à promouvoir une solution pacifique au conflit en Irlande du Nord","pour son rôle de leader dans la défense non violente des droits humains en Amérique latine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11759: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Eisaku Satō a-t-il reçu le Prix Nobel en 1974 ?",
      answers: ["Paix","Littérature","Physiologie ou Médecine","Sciences Économiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11760: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Eyvind Johnson a-t-il reçu le Prix Nobel de Littérature pour un art narratif, perspicace dans les pays et les époques, au service de la liberté ?",
      answers: ["1976","1981","1997","1974"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11761: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1974 pour un art narratif, perspicace dans les pays et les époques, au service de la liberté ?",
      answers: ["Jaroslav Seifert","Claude Simon","Eyvind Johnson","Harry Martinson"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11762: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Eyvind Johnson a-t-il reçu le Prix Nobel en 1974 ?",
      answers: ["pour un art narratif, perspicace dans les pays et les époques, au service de la liberté","pour des écrits qui capturent la goutte de rosée et reflètent le cosmos","pour sa poésie lyrique qui exprime avec une intensité classique les expériences tragiques de la vie à notre époque","pour ses écrits lyriques et dramatiques exceptionnels qui interprètent le destin d’Israël avec une force émouvante"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11763: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Eyvind Johnson a-t-il reçu le Prix Nobel en 1974 ?",
      answers: ["Chimie","Littérature","Physique","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11764: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Harry Martinson a-t-il reçu le Prix Nobel de Littérature pour des écrits qui capturent la goutte de rosée et reflètent le cosmos ?",
      answers: ["1979","1959","1974","1972"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11765: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1974 pour des écrits qui capturent la goutte de rosée et reflètent le cosmos ?",
      answers: ["Nadine Gordimer","William Golding","Harry Martinson","Yasunari Kawabata"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11766: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Harry Martinson a-t-il reçu le Prix Nobel en 1974 ?",
      answers: ["pour sa poésie qui, avec une fraîcheur, une sensualité et une inventivité riches, donne une image libératrice de l’esprit indomptable et de la polyvalence de l’homme","pour des écrits qui capturent la goutte de rosée et reflètent le cosmos","pour ses écrits qui, par leur combinaison d’une large perspective sur son temps et une habileté sensible dans la caractérisation, ont contribué au renouveau de la littérature allemande","pour une poésie qui, avec l’action d’une force élémentaire, donne vie au destin et aux rêves d’un continent"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11767: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Harry Martinson a-t-il reçu le Prix Nobel en 1974 ?",
      answers: ["Chimie","Littérature","Physique","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11768: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Aage N. Bohr a-t-il reçu le Prix Nobel de Physique pour la découverte de la connexion entre le mouvement collectif et le mouvement des particules dans les noyaux atomiques et le développement de la théorie de la structure nucléaire basée sur cette connexion ?",
      answers: ["1974","2009","1969","1975"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11769: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1975 pour la découverte de la connexion entre le mouvement collectif et le mouvement des particules dans les noyaux atomiques et le développement de la théorie de la structure nucléaire basée sur cette connexion ?",
      answers: ["Antony Hewish","Aage N. Bohr","John R. Schrieffer","James Rainwater"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11770: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Aage N. Bohr a-t-il reçu le Prix Nobel en 1975 ?",
      answers: ["pour la découverte de la connexion entre le mouvement collectif et le mouvement des particules dans les noyaux atomiques et le développement de la théorie de la structure nucléaire basée sur cette connexion","pour le développement de semi-conducteurs utilisés dans l’électronique à haute vitesse et l’optoélectronique","pour leurs travaux pionniers dans la découverte d’une nouvelle particule élémentaire lourde","pour la découverte des violations de principes fondamentaux de symétrie dans la désintégration des mésons K neutres"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11771: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Aage N. Bohr a-t-il reçu le Prix Nobel en 1975 ?",
      answers: ["Physique","Paix","Littérature","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11772: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Ben R. Mottelson a-t-il reçu le Prix Nobel de Physique pour la découverte de la connexion entre le mouvement collectif et le mouvement des particules dans les noyaux atomiques et le développement de la théorie de la structure nucléaire basée sur cette connexion ?",
      answers: ["1975","1986","1953","1977"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11773: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1975 pour la découverte de la connexion entre le mouvement collectif et le mouvement des particules dans les noyaux atomiques et le développement de la théorie de la structure nucléaire basée sur cette connexion ?",
      answers: ["Carl F. Braun","Igor Y. Tamm","Ben R. Mottelson","Arno Penzias"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11774: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Ben R. Mottelson a-t-il reçu le Prix Nobel en 1975 ?",
      answers: ["pour leur théorie développée conjointement de la supraconductivité, généralement appelée la théorie BCS","pour leurs recherches pionnières en astrophysique radio : Ryle pour ses observations et inventions, notamment la technique de synthèse d’ouverture","pour le développement de la technique du piège à ions","pour la découverte de la connexion entre le mouvement collectif et le mouvement des particules dans les noyaux atomiques et le développement de la théorie de la structure nucléaire basée sur cette connexion"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11775: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Ben R. Mottelson a-t-il reçu le Prix Nobel en 1975 ?",
      answers: ["Physiologie ou Médecine","Chimie","Sciences Économiques","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11776: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année James Rainwater a-t-il reçu le Prix Nobel de Physique pour la découverte de la connexion entre le mouvement collectif et le mouvement des particules dans les noyaux atomiques et le développement de la théorie de la structure nucléaire basée sur cette connexion ?",
      answers: ["2017","1934","1975","1955"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11777: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1975 pour la découverte de la connexion entre le mouvement collectif et le mouvement des particules dans les noyaux atomiques et le développement de la théorie de la structure nucléaire basée sur cette connexion ?",
      answers: ["James Rainwater","Hannes Alfvén","James W. Cronin","Georges Charpak"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11778: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison James Rainwater a-t-il reçu le Prix Nobel en 1975 ?",
      answers: ["pour leurs recherches pionnières en astrophysique radio : Ryle pour ses observations et inventions, notamment la technique de synthèse d’ouverture","pour leurs investigations théoriques fondamentales sur la structure électronique des systèmes magnétiques et désordonnés","pour la découverte de la connexion entre le mouvement collectif et le mouvement des particules dans les noyaux atomiques et le développement de la théorie de la structure nucléaire basée sur cette connexion","pour leurs recherches pionnières en astrophysique radio : Hewish pour son rôle décisif dans la découverte des pulsars"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11779: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie James Rainwater a-t-il reçu le Prix Nobel en 1975 ?",
      answers: ["Physiologie ou Médecine","Sciences Économiques","Littérature","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11780: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année John W. Cornforth a-t-il reçu le Prix Nobel de Chimie pour son travail sur la stéréochimie des réactions enzymatiques ?",
      answers: ["1994","1974","1951","1975"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11781: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1975 pour son travail sur la stéréochimie des réactions enzymatiques ?",
      answers: ["John W. Cornforth","Paul Berg","William N. Lipscomb","Aaron Klug"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11782: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison John W. Cornforth a-t-il reçu le Prix Nobel en 1975 ?",
      answers: ["pour ses recherches sur la stéréochimie des molécules organiques et des réactions","pour son travail sur la stéréochimie des réactions enzymatiques","pour le développement de la chimie bioorthogonale","pour son travail sur la ribonucléase, en particulier concernant la connexion entre la séquence d’acides aminés et la conformation biologiquement active"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11783: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie John W. Cornforth a-t-il reçu le Prix Nobel en 1975 ?",
      answers: ["Chimie","Paix","Littérature","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11784: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Vladimir Prelog a-t-il reçu le Prix Nobel de Chimie pour ses recherches sur la stéréochimie des molécules organiques et des réactions ?",
      answers: ["1967","1978","1981","1975"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11785: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1975 pour ses recherches sur la stéréochimie des molécules organiques et des réactions ?",
      answers: ["Kenichi Fukui","John W. Cornforth","Vladimir Prelog","Jacobus H. van ’t Hoff"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11786: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Vladimir Prelog a-t-il reçu le Prix Nobel en 1975 ?",
      answers: ["pour ses études des processus chimiques sur les surfaces solides","pour son travail sur la stéréochimie des réactions enzymatiques","pour leurs travaux sur la chimie de l’atmosphère, notamment concernant la formation et la décomposition de l’ozone","pour ses recherches sur la stéréochimie des molécules organiques et des réactions"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11787: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Vladimir Prelog a-t-il reçu le Prix Nobel en 1975 ?",
      answers: ["Physique","Littérature","Physiologie ou Médecine","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11788: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année David Baltimore a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant l’interaction entre les virus tumoraux et le matériel génétique de la cellule ?",
      answers: ["1974","1976","1996","1975"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11789: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1975 pour leurs découvertes concernant l’interaction entre les virus tumoraux et le matériel génétique de la cellule ?",
      answers: ["Hamilton O. Smith","Renato Dulbecco","Edmond H. Fischer","David Baltimore"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11790: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison David Baltimore a-t-il reçu le Prix Nobel en 1975 ?",
      answers: ["pour leurs découvertes concernant l’organisation et l’élicitation des schémas de comportement individuels et sociaux","pour leurs découvertes concernant l’interaction entre les virus tumoraux et le matériel génétique de la cellule","pour leurs découvertes concernant les structures génétiquement déterminées à la surface des cellules qui régulent les réactions immunitaires","pour leurs découvertes concernant l’organisation structurelle et fonctionnelle de la cellule"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11791: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie David Baltimore a-t-il reçu le Prix Nobel en 1975 ?",
      answers: ["Physiologie ou Médecine","Physique","Chimie","Sciences Économiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11792: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Renato Dulbecco a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant l’interaction entre les virus tumoraux et le matériel génétique de la cellule ?",
      answers: ["1985","1974","1975","1964"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11793: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1975 pour leurs découvertes concernant l’interaction entre les virus tumoraux et le matériel génétique de la cellule ?",
      answers: ["Baruch S. Blumberg","Renato Dulbecco","Allan M. Cormack","D. Carleton Gajdusek"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11794: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Renato Dulbecco a-t-il reçu le Prix Nobel en 1975 ?",
      answers: ["pour leurs découvertes concernant le traitement de l’information dans le système visuel","pour sa découverte du coenzyme A et son importance dans le métabolisme intermédiaire","pour leurs découvertes concernant les structures génétiquement déterminées à la surface des cellules qui régulent les réactions immunitaires","pour leurs découvertes concernant l’interaction entre les virus tumoraux et le matériel génétique de la cellule"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11795: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Renato Dulbecco a-t-il reçu le Prix Nobel en 1975 ?",
      answers: ["Physique","Physiologie ou Médecine","Littérature","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11796: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Howard M. Temin a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant l’interaction entre les virus tumoraux et le matériel génétique de la cellule ?",
      answers: ["1975","1963","1930","1977"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11797: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1975 pour leurs découvertes concernant l’interaction entre les virus tumoraux et le matériel génétique de la cellule ?",
      answers: ["Howard M. Temin","Sune K. Bergström","George R. Minot","Renato Dulbecco"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11798: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Howard M. Temin a-t-il reçu le Prix Nobel en 1975 ?",
      answers: ["pour leurs découvertes concernant la production d’hormones peptidiques dans le cerveau","pour leurs découvertes concernant l’interaction entre les virus tumoraux et le matériel génétique de la cellule","pour la découverte du rôle joué par le sinus et les mécanismes aortiques dans la régulation de la respiration","pour leurs découvertes concernant la régulation génétique de la synthèse des enzymes et des virus"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11799: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Howard M. Temin a-t-il reçu le Prix Nobel en 1975 ?",
      answers: ["Physique","Paix","Physiologie ou Médecine","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11800: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Andrei Sakharov a-t-il reçu le Prix Nobel de Paix pour sa lutte contre l’abus de pouvoir et pour la défense des droits humains et de la paix ?",
      answers: ["1930","1973","1975","1948"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11801: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1975 pour sa lutte contre l’abus de pouvoir et pour la défense des droits humains et de la paix ?",
      answers: ["Andrei Sakharov","Al Gore","George C. Marshall","Anwar Sadat"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11802: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Andrei Sakharov a-t-il reçu le Prix Nobel en 1975 ?",
      answers: ["pour leur contribution à la réduction des tensions et à la promotion de la paix dans le monde","pour son travail visant à promouvoir la justice sociale et les droits des travailleurs","pour son rôle de leader dans la défense non violente des droits humains en Amérique latine","pour sa lutte contre l’abus de pouvoir et pour la défense des droits humains et de la paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11803: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Andrei Sakharov a-t-il reçu le Prix Nobel en 1975 ?",
      answers: ["Physique","Paix","Physiologie ou Médecine","Littérature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11804: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Eugenio Montale a-t-il reçu le Prix Nobel de Littérature pour sa poésie distinctive qui, avec une grande sensibilité artistique, a interprété les valeurs humaines sous le signe d’une vision de la vie sans illusions ?",
      answers: ["1921","1978","1974","1975"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11805: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1975 pour sa poésie distinctive qui, avec une grande sensibilité artistique, a interprété les valeurs humaines sous le signe d’une vision de la vie sans illusions ?",
      answers: ["Eugenio Montale","Grazia Deledda","Vicente Aleixandre","Rudolf C. Eucken"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11806: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Eugenio Montale a-t-il reçu le Prix Nobel en 1975 ?",
      answers: ["pour ses écrits qui, par leur combinaison d’une large perspective sur son temps et une habileté sensible dans la caractérisation, ont contribué au renouveau de la littérature allemande","qui, avec une lucidité sans compromis, exprime la condition exposée de l’homme dans un monde de conflits sévères","pour sa poésie distinctive qui, avec une grande sensibilité artistique, a interprété les valeurs humaines sous le signe d’une vision de la vie sans illusions","pour sa puissance épique vivante qui a renouvelé le grand art narratif de l’Islande"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11807: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Eugenio Montale a-t-il reçu le Prix Nobel en 1975 ?",
      answers: ["Paix","Physique","Littérature","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11808: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Burton Richter a-t-il reçu le Prix Nobel de Physique pour leurs travaux pionniers dans la découverte d’une nouvelle particule élémentaire lourde ?",
      answers: ["1960","1976","1973","1963"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11809: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1976 pour leurs travaux pionniers dans la découverte d’une nouvelle particule élémentaire lourde ?",
      answers: ["George P. Thomson","Sir William H. Bragg","Brian D. Josephson","Burton Richter"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11810: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Burton Richter a-t-il reçu le Prix Nobel en 1976 ?",
      answers: ["pour leurs travaux pionniers dans la découverte d’une nouvelle particule élémentaire lourde","pour la découverte de la connexion entre le mouvement collectif et le mouvement des particules dans les noyaux atomiques et le développement de la théorie de la structure nucléaire basée sur cette connexion","pour sa contribution à l’invention du circuit intégré","pour leurs investigations théoriques fondamentales sur la structure électronique des systèmes magnétiques et désordonnés"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11811: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Burton Richter a-t-il reçu le Prix Nobel en 1976 ?",
      answers: ["Physique","Chimie","Paix","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11812: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Samuel C.C. Ting a-t-il reçu le Prix Nobel de Physique pour leurs travaux pionniers dans la découverte d’une nouvelle particule élémentaire lourde ?",
      answers: ["1982","1981","1976","1980"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11813: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1976 pour leurs travaux pionniers dans la découverte d’une nouvelle particule élémentaire lourde ?",
      answers: ["Burton Richter","Luis W. Alvarez","K. Alex Müller","Samuel C.C. Ting"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11814: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Samuel C.C. Ting a-t-il reçu le Prix Nobel en 1976 ?",
      answers: ["pour leur découverte expérimentale de la diffraction des électrons par les cristaux","pour leurs travaux pionniers dans la découverte d’une nouvelle particule élémentaire lourde","pour la découverte de l’effet Hall quantique","pour ses contributions à la théorie des réactions nucléaires, en particulier ses découvertes concernant la production d’énergie dans les étoiles"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11815: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Samuel C.C. Ting a-t-il reçu le Prix Nobel en 1976 ?",
      answers: ["Littérature","Physique","Chimie","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11816: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année William N. Lipscomb a-t-il reçu le Prix Nobel de Chimie pour ses études sur la structure des boranes éclairant les problèmes de liaison chimique ?",
      answers: ["1975","1976","1971","1924"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11817: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1976 pour ses études sur la structure des boranes éclairant les problèmes de liaison chimique ?",
      answers: ["William N. Lipscomb","Lars Onsager","Paul J. Flory","George P. Smith"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11818: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison William N. Lipscomb a-t-il reçu le Prix Nobel en 1976 ?",
      answers: ["pour des études sur la structure et la fonction du ribosome","pour ses études sur la structure des boranes éclairant les problèmes de liaison chimique","pour leur découverte des propriétés catalytiques de l’ARN","pour la détermination de la structure tridimensionnelle d’un centre réactionnel photosynthétique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11819: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie William N. Lipscomb a-t-il reçu le Prix Nobel en 1976 ?",
      answers: ["Physiologie ou Médecine","Paix","Chimie","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11820: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Baruch S. Blumberg a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant de nouveaux mécanismes d’origine et de dissémination des maladies infectieuses ?",
      answers: ["1977","1974","1975","1976"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11821: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1976 pour leurs découvertes concernant de nouveaux mécanismes d’origine et de dissémination des maladies infectieuses ?",
      answers: ["Leland H. Hartwell","Max Delbrück","David Baltimore","Baruch S. Blumberg"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11822: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Baruch S. Blumberg a-t-il reçu le Prix Nobel en 1976 ?",
      answers: ["pour leurs découvertes concernant le traitement de l’information dans le système visuel","pour leurs découvertes concernant la production d’hormones peptidiques dans le cerveau","pour leurs découvertes concernant de nouveaux mécanismes d’origine et de dissémination des maladies infectieuses","pour ses découvertes concernant la transmission des signaux dans le système nerveux"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11823: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Baruch S. Blumberg a-t-il reçu le Prix Nobel en 1976 ?",
      answers: ["Littérature","Physiologie ou Médecine","Chimie","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11824: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année D. Carleton Gajdusek a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant de nouveaux mécanismes d’origine et de dissémination des maladies infectieuses ?",
      answers: ["1968","1971","1975","1976"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11825: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1976 pour leurs découvertes concernant de nouveaux mécanismes d’origine et de dissémination des maladies infectieuses ?",
      answers: ["Howard M. Temin","Jean Dausset","D. Carleton Gajdusek","Sir Bernard Katz"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11826: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison D. Carleton Gajdusek a-t-il reçu le Prix Nobel en 1976 ?",
      answers: ["pour la découverte des enzymes de restriction et leur application aux problèmes de génétique moléculaire","pour leurs découvertes concernant de nouveaux mécanismes d’origine et de dissémination des maladies infectieuses","pour leurs découvertes concernant le contrôle génétique du développement précoce de l’embryon","pour leurs découvertes concernant le mécanisme et la régulation du métabolisme du cholestérol et des acides gras"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11827: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie D. Carleton Gajdusek a-t-il reçu le Prix Nobel en 1976 ?",
      answers: ["Paix","Physique","Physiologie ou Médecine","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11828: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Betty Williams a-t-il reçu le Prix Nobel de Paix pour leur travail visant à promouvoir une solution pacifique au conflit en Irlande du Nord ?",
      answers: ["1973","1974","1977","1976"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11829: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1976 pour leur travail visant à promouvoir une solution pacifique au conflit en Irlande du Nord ?",
      answers: ["Betty Williams","Lech Wałęsa","Lê Đức Thọ","Anwar Sadat"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11830: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Betty Williams a-t-il reçu le Prix Nobel en 1976 ?",
      answers: ["pour leur lutte non violente pour la sécurité des femmes et pour les droits des femmes à participer pleinement aux processus de paix","pour leurs contributions à la négociation des accords de Camp David pour la paix au Moyen-Orient","pour leur travail visant à promouvoir une solution pacifique au conflit en Irlande du Nord","pour sa lutte contre l’abus de pouvoir et pour la défense des droits humains et de la paix"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11831: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Betty Williams a-t-il reçu le Prix Nobel en 1976 ?",
      answers: ["Chimie","Paix","Physiologie ou Médecine","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11832: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Mairead Corrigan a-t-il reçu le Prix Nobel de Paix pour leur travail visant à promouvoir une solution pacifique au conflit en Irlande du Nord ?",
      answers: ["1950","2023","1976","1975"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11833: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1976 pour leur travail visant à promouvoir une solution pacifique au conflit en Irlande du Nord ?",
      answers: ["Norman Borlaug","Anwar Sadat","Betty Williams","Mairead Corrigan"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11834: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Mairead Corrigan a-t-il reçu le Prix Nobel en 1976 ?",
      answers: ["pour son rôle de leader dans la défense non violente des droits humains en Amérique latine","pour leur contribution à la réduction des tensions et à la promotion de la paix dans le monde","pour leurs négociations conjointes ayant conduit à un cessez-le-feu au Vietnam","pour leur travail visant à promouvoir une solution pacifique au conflit en Irlande du Nord"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11835: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Mairead Corrigan a-t-il reçu le Prix Nobel en 1976 ?",
      answers: ["Physique","Chimie","Paix","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11836: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Milton Friedman a-t-il reçu le Prix Nobel de Sciences Économiques pour ses réalisations dans les domaines de l’analyse de la consommation, de l’histoire et de la théorie monétaire et pour sa démonstration de la complexité de la politique de stabilisation ?",
      answers: ["1976","1974","1957","1932"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11837: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1976 pour ses réalisations dans les domaines de l’analyse de la consommation, de l’histoire et de la théorie monétaire et pour sa démonstration de la complexité de la politique de stabilisation ?",
      answers: ["Milton Friedman","Harry M. Markowitz","John R. Hicks","George A. Akerlof"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11838: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Milton Friedman a-t-il reçu le Prix Nobel en 1976 ?",
      answers: ["pour leurs contributions pionnières à la théorie de l’économie financière","pour avoir posé les bases de la théorie de la conception des mécanismes","pour ses réalisations dans les domaines de l’analyse de la consommation, de l’histoire et de la théorie monétaire et pour sa démonstration de la complexité de la politique de stabilisation","pour son analyse de la théorie des marchés financiers et de leurs relations avec les décisions de dépenses, l’emploi, la production et les prix"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11839: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Milton Friedman a-t-il reçu le Prix Nobel en 1976 ?",
      answers: ["Physique","Sciences Économiques","Littérature","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11840: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Vicente Aleixandre a-t-il reçu le Prix Nobel de Littérature pour une œuvre poétique créative qui illumine la condition humaine dans l’univers et la société actuelle ?",
      answers: ["2016","1966","1977","1981"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11841: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1977 pour une œuvre poétique créative qui illumine la condition humaine dans l’univers et la société actuelle ?",
      answers: ["Salvatore Quasimodo","Isaac Bashevis Singer","Vicente Aleixandre","Harry Martinson"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11842: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Vicente Aleixandre a-t-il reçu le Prix Nobel en 1977 ?",
      answers: ["pour son art narratif passionné qui, enraciné dans la culture et les traditions juives polonaises, donne une portée universelle à la condition humaine","pour ses écrits réalistes et imaginatifs, combinant un humour sympathique et une perception sociale aiguë","pour sa poésie distinctive qui, avec une grande sensibilité artistique, a interprété les valeurs humaines sous le signe d’une vision de la vie sans illusions","pour une œuvre poétique créative qui illumine la condition humaine dans l’univers et la société actuelle"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11843: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Vicente Aleixandre a-t-il reçu le Prix Nobel en 1977 ?",
      answers: ["Littérature","Paix","Physique","Sciences Économiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11844: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Philip W. Anderson a-t-il reçu le Prix Nobel de Physique pour leurs investigations théoriques fondamentales sur la structure électronique des systèmes magnétiques et désordonnés ?",
      answers: ["2011","1978","1982","1977"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11845: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1977 pour leurs investigations théoriques fondamentales sur la structure électronique des systèmes magnétiques et désordonnés ?",
      answers: ["Philip W. Anderson","Brian D. Josephson","Patrick M.S. Blackett","Burton Richter"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11846: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Philip W. Anderson a-t-il reçu le Prix Nobel en 1977 ?",
      answers: ["pour des découvertes théoriques sur les transitions de phase topologiques et les phases topologiques de la matière","pour leurs contributions fondamentales à l’électrodynamique quantique, avec des conséquences profondes pour la physique des particules élémentaires","pour leurs contributions à la théorie unifiée des interactions faible et électromagnétique entre particules élémentaires","pour leurs investigations théoriques fondamentales sur la structure électronique des systèmes magnétiques et désordonnés"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11847: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Philip W. Anderson a-t-il reçu le Prix Nobel en 1977 ?",
      answers: ["Physique","Littérature","Paix","Sciences Économiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11848: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Nevill F. Mott a-t-il reçu le Prix Nobel de Physique pour leurs investigations théoriques fondamentales sur la structure électronique des systèmes magnétiques et désordonnés ?",
      answers: ["1983","1974","1977","1979"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11849: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1977 pour leurs investigations théoriques fondamentales sur la structure électronique des systèmes magnétiques et désordonnés ?",
      answers: ["Philip W. Anderson","Kai M. Siegbahn","John H. Van Vleck","Nevill F. Mott"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11850: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Nevill F. Mott a-t-il reçu le Prix Nobel en 1977 ?",
      answers: ["pour leurs investigations théoriques fondamentales sur la structure électronique des systèmes magnétiques et désordonnés","pour la méthode du faisceau de neutrinos et la démonstration de la structure en doublet des leptons par la découverte du neutrino muonique","pour leurs travaux pionniers dans la découverte d’une nouvelle particule élémentaire lourde","pour leur théorie développée conjointement de la supraconductivité, généralement appelée la théorie BCS"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11851: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Nevill F. Mott a-t-il reçu le Prix Nobel en 1977 ?",
      answers: ["Physiologie ou Médecine","Chimie","Paix","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11852: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année John H. Van Vleck a-t-il reçu le Prix Nobel de Physique pour leurs investigations théoriques fondamentales sur la structure électronique des systèmes magnétiques et désordonnés ?",
      answers: ["1975","1979","1976","1977"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11853: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1977 pour leurs investigations théoriques fondamentales sur la structure électronique des systèmes magnétiques et désordonnés ?",
      answers: ["Kai M. Siegbahn","John H. Van Vleck","Kenneth G. Wilson","Arno Penzias"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11854: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison John H. Van Vleck a-t-il reçu le Prix Nobel en 1977 ?",
      answers: ["pour leurs investigations théoriques fondamentales sur la structure électronique des systèmes magnétiques et désordonnés","pour leurs contributions à la théorie unifiée des interactions faible et électromagnétique entre particules élémentaires","pour la découverte de la connexion entre le mouvement collectif et le mouvement des particules dans les noyaux atomiques et le développement de la théorie de la structure nucléaire basée sur cette connexion","pour la découverte des violations de principes fondamentaux de symétrie dans la désintégration des mésons K neutres"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11855: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie John H. Van Vleck a-t-il reçu le Prix Nobel en 1977 ?",
      answers: ["Littérature","Physique","Chimie","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11856: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Ilya Prigogine a-t-il reçu le Prix Nobel de Chimie pour ses contributions à la thermodynamique hors équilibre, en particulier la théorie des structures dissipatives ?",
      answers: ["1960","1973","1972","1977"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11857: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1977 pour ses contributions à la thermodynamique hors équilibre, en particulier la théorie des structures dissipatives ?",
      answers: ["Michael Smith","John W. Cornforth","Derek H.R. Barton","Ilya Prigogine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11858: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Ilya Prigogine a-t-il reçu le Prix Nobel en 1977 ?",
      answers: ["pour ses contributions au développement de la spectroscopie par résonance magnétique nucléaire à haute résolution","pour leurs découvertes dans la chimie des éléments transuraniens","pour ses contributions à la thermodynamique hors équilibre, en particulier la théorie des structures dissipatives","pour des études mécanistiques sur la réparation de l’ADN"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11859: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Ilya Prigogine a-t-il reçu le Prix Nobel en 1977 ?",
      answers: ["Physique","Chimie","Paix","Littérature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11860: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Roger Guillemin a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant la production d’hormones peptidiques dans le cerveau ?",
      answers: ["1981","1983","1969","1977"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11861: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1977 pour leurs découvertes concernant la production d’hormones peptidiques dans le cerveau ?",
      answers: ["Bruce A. Beutler","Rosalyn Yalow","Roger Guillemin","Baruj Benacerraf"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11862: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Roger Guillemin a-t-il reçu le Prix Nobel en 1977 ?",
      answers: ["pour leurs découvertes concernant la production d’hormones peptidiques dans le cerveau","pour ses découvertes concernant la transmission des signaux dans le système nerveux","pour la découverte des enzymes de restriction et leur application aux problèmes de génétique moléculaire","pour leurs découvertes concernant l’organisation structurelle et fonctionnelle de la cellule"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11863: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Roger Guillemin a-t-il reçu le Prix Nobel en 1977 ?",
      answers: ["Sciences Économiques","Physique","Physiologie ou Médecine","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11864: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Andrew V. Schally a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant la production d’hormones peptidiques dans le cerveau ?",
      answers: ["1975","1977","1992","2010"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11865: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1977 pour leurs découvertes concernant la production d’hormones peptidiques dans le cerveau ?",
      answers: ["Rosalyn Yalow","Andrew V. Schally","Christiane Nüsslein-Volhard","Roger Guillemin"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11866: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Andrew V. Schally a-t-il reçu le Prix Nobel en 1977 ?",
      answers: ["pour le développement de radio-immunoessais des hormones peptidiques","pour leurs découvertes concernant de nouveaux mécanismes d’origine et de dissémination des maladies infectieuses","pour leurs découvertes concernant les processus physiologiques et chimiques primaires dans la vision","pour leurs découvertes concernant la production d’hormones peptidiques dans le cerveau"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11867: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Andrew V. Schally a-t-il reçu le Prix Nobel en 1977 ?",
      answers: ["Paix","Chimie","Littérature","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11868: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Rosalyn Yalow a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour le développement de radio-immunoessais des hormones peptidiques ?",
      answers: ["1977","1972","1974","1910"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11869: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1977 pour le développement de radio-immunoessais des hormones peptidiques ?",
      answers: ["George Wald","Ferid Murad","Roger Guillemin","Rosalyn Yalow"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11870: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Rosalyn Yalow a-t-il reçu le Prix Nobel en 1977 ?",
      answers: ["pour leurs découvertes concernant le traitement de l’information dans le système visuel","pour leurs découvertes concernant la production d’hormones peptidiques dans le cerveau","pour leurs découvertes concernant les processus physiologiques et chimiques primaires dans la vision","pour le développement de radio-immunoessais des hormones peptidiques"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11871: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Rosalyn Yalow a-t-il reçu le Prix Nobel en 1977 ?",
      answers: ["Physique","Sciences Économiques","Chimie","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11872: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Amnesty International a-t-il reçu le Prix Nobel de Paix pour son travail en faveur des droits humains et de la libération des prisonniers politiques ?",
      answers: ["1977","1978","1985","1992"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11873: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1977 pour son travail en faveur des droits humains et de la libération des prisonniers politiques ?",
      answers: ["Médecins Internationaux pour la Prévention de la Guerre Nucléaire","Abiy Ahmed Ali","Amnesty International","Lech Wałęsa"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11874: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Amnesty International a-t-il reçu le Prix Nobel en 1977 ?",
      answers: ["pour leurs efforts visant à développer et diffuser une meilleure compréhension du changement climatique d’origine humaine","pour son rôle de leader dans la défense non violente des droits humains en Amérique latine","pour leur travail en faveur du désarmement et de la paix mondiale","pour son travail en faveur des droits humains et de la libération des prisonniers politiques"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11875: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Amnesty International a-t-il reçu le Prix Nobel en 1977 ?",
      answers: ["Chimie","Littérature","Physiologie ou Médecine","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11876: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Vicente Aleixandre a-t-il reçu le Prix Nobel de Littérature pour une œuvre poétique créative qui illumine la condition humaine dans l’univers et la société actuelle ?",
      answers: ["1979","1977","1973","1962"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11877: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1977 pour une œuvre poétique créative qui illumine la condition humaine dans l’univers et la société actuelle ?",
      answers: ["Elias Canetti","Vicente Aleixandre","Camilo José Cela","Hermann Hesse"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11878: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Vicente Aleixandre a-t-il reçu le Prix Nobel en 1977 ?",
      answers: ["pour une œuvre poétique créative qui illumine la condition humaine dans l’univers et la société actuelle","qui, dans ses romans, combine la créativité du poète et du peintre avec une profonde conscience du temps dans la représentation de la condition humaine","pour un art narratif épique et psychologique qui a introduit un nouveau continent dans la littérature","pour des écrits marqués par une large perspective, une richesse d’idées et une puissance artistique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11879: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Vicente Aleixandre a-t-il reçu le Prix Nobel en 1977 ?",
      answers: ["Physique","Littérature","Chimie","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11880: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Pyotr Kapitsa a-t-il reçu le Prix Nobel de Physique pour ses inventions et découvertes fondamentales dans la physique des basses températures ?",
      answers: ["1977","1978","1979","1970"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11881: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1978 pour ses inventions et découvertes fondamentales dans la physique des basses températures ?",
      answers: ["Pavel A. Cherenkov","Pyotr Kapitsa","Aleksandr M. Prokhorov","Abdus Salam"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11882: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Pyotr Kapitsa a-t-il reçu le Prix Nobel en 1978 ?",
      answers: ["pour ses contributions à la théorie du noyau atomique et des particules élémentaires, notamment par la découverte et l’application des principes de symétrie fondamentaux","pour la découverte des violations de principes fondamentaux de symétrie dans la désintégration des mésons K neutres","pour ses inventions et découvertes fondamentales dans la physique des basses températures","pour leurs contributions décisives au grand projet qui a conduit à la découverte des particules W et Z, messagers de l’interaction faible"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11883: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Pyotr Kapitsa a-t-il reçu le Prix Nobel en 1978 ?",
      answers: ["Paix","Physique","Physiologie ou Médecine","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11884: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Arno Penzias a-t-il reçu le Prix Nobel de Physique pour leur découverte du rayonnement de fond cosmique micro-ondes ?",
      answers: ["1978","1973","1975","1990"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11885: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1978 pour leur découverte du rayonnement de fond cosmique micro-ondes ?",
      answers: ["Arno Penzias","Steven Weinberg","Brian P. Schmidt","David J. Thouless"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11886: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Arno Penzias a-t-il reçu le Prix Nobel en 1978 ?",
      answers: ["pour la découverte de la liberté asymptotique dans la théorie de l’interaction forte","pour sa contribution décisive à la physique des particules élémentaires, en particulier la découverte d’un grand nombre d’états de résonance","pour leur découverte du rayonnement de fond cosmique micro-ondes","pour ses inventions et découvertes fondamentales dans la physique des basses températures"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11887: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Arno Penzias a-t-il reçu le Prix Nobel en 1978 ?",
      answers: ["Physique","Chimie","Paix","Sciences Économiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11888: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Robert W. Wilson a-t-il reçu le Prix Nobel de Physique pour leur découverte du rayonnement de fond cosmique micro-ondes ?",
      answers: ["1977","1970","1978","1982"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11889: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1978 pour leur découverte du rayonnement de fond cosmique micro-ondes ?",
      answers: ["Brian D. Josephson","Konstantin Novoselov","Arno Penzias","Robert W. Wilson"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11890: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Robert W. Wilson a-t-il reçu le Prix Nobel en 1978 ?",
      answers: ["pour leurs investigations théoriques fondamentales sur la structure électronique des systèmes magnétiques et désordonnés","pour leur conception du microscope à effet tunnel","pour leur découverte du rayonnement de fond cosmique micro-ondes","pour leurs contributions à la théorie unifiée des interactions faible et électromagnétique entre particules élémentaires"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11891: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Robert W. Wilson a-t-il reçu le Prix Nobel en 1978 ?",
      answers: ["Physique","Physiologie ou Médecine","Sciences Économiques","Littérature"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11892: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Peter Mitchell a-t-il reçu le Prix Nobel de Chimie pour sa contribution à la compréhension du transfert d’énergie biologique par la formulation de la théorie chimi-osmotique ?",
      answers: ["1976","1980","1956","1978"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11893: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1978 pour sa contribution à la compréhension du transfert d’énergie biologique par la formulation de la théorie chimi-osmotique ?",
      answers: ["Peter Mitchell","Frederick Sanger","Paul J. Flory","Cyril N. Hinshelwood"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11894: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Peter Mitchell a-t-il reçu le Prix Nobel en 1978 ?",
      answers: ["pour sa contribution à la compréhension du transfert d’énergie biologique par la formulation de la théorie chimi-osmotique","pour leurs études des réactions chimiques extrêmement rapides, réalisées par des perturbations de l’équilibre","pour son développement de la microscopie électronique cristallographique et son élucidation structurale des complexes nucléoprotéiques biologiquement importants","pour leurs travaux sur la chimie de l’atmosphère, notamment concernant la formation et la décomposition de l’ozone"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11895: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Peter Mitchell a-t-il reçu le Prix Nobel en 1978 ?",
      answers: ["Paix","Physique","Chimie","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11896: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Werner Arber a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour la découverte des enzymes de restriction et leur application aux problèmes de génétique moléculaire ?",
      answers: ["1978","1975","1948","1980"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11897: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1978 pour la découverte des enzymes de restriction et leur application aux problèmes de génétique moléculaire ?",
      answers: ["Sir James W. Black","Roger Guillemin","Daniel Nathans","Werner Arber"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11898: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Werner Arber a-t-il reçu le Prix Nobel en 1978 ?",
      answers: ["pour la découverte des enzymes de restriction et leur application aux problèmes de génétique moléculaire","pour sa découverte des cellules dendritiques et de leur rôle dans l’immunité adaptative","pour leurs découvertes concernant les processus physiologiques et chimiques primaires dans la vision","pour ses découvertes concernant les mécanismes d’action des hormones"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11899: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Werner Arber a-t-il reçu le Prix Nobel en 1978 ?",
      answers: ["Sciences Économiques","Physique","Littérature","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11900: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Daniel Nathans a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour la découverte des enzymes de restriction et leur application aux problèmes de génétique moléculaire ?",
      answers: ["1979","1978","1972","1974"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11901: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1978 pour la découverte des enzymes de restriction et leur application aux problèmes de génétique moléculaire ?",
      answers: ["Christian de Duve","Daniel Nathans","Barbara McClintock","George D. Snell"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11902: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Daniel Nathans a-t-il reçu le Prix Nobel en 1978 ?",
      answers: ["pour leurs découvertes concernant la spécificité de la réponse immunitaire à médiation cellulaire","pour leurs découvertes concernant la structure moléculaire des acides nucléiques et son importance pour le transfert d’information dans le matériel vivant","pour la découverte des enzymes de restriction et leur application aux problèmes de génétique moléculaire","pour la découverte du virus de l’hépatite C"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11903: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Daniel Nathans a-t-il reçu le Prix Nobel en 1978 ?",
      answers: ["Paix","Sciences Économiques","Physiologie ou Médecine","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11904: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Hamilton O. Smith a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour la découverte des enzymes de restriction et leur application aux problèmes de génétique moléculaire ?",
      answers: ["2006","1978","1963","1985"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11905: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1978 pour la découverte des enzymes de restriction et leur application aux problèmes de génétique moléculaire ?",
      answers: ["Francis H.C. Crick","Hamilton O. Smith","Daniel Nathans","Earl W. Sutherland Jr."],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11906: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Hamilton O. Smith a-t-il reçu le Prix Nobel en 1978 ?",
      answers: ["pour leurs découvertes concernant le contrôle génétique du développement précoce de l’embryon","pour le développement de radio-immunoessais des hormones peptidiques","pour sa découverte des éléments génétiques mobiles","pour la découverte des enzymes de restriction et leur application aux problèmes de génétique moléculaire"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11907: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Hamilton O. Smith a-t-il reçu le Prix Nobel en 1978 ?",
      answers: ["Paix","Physique","Chimie","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11908: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Anwar Sadat a-t-il reçu le Prix Nobel de Paix pour leurs contributions à la négociation des accords de Camp David pour la paix au Moyen-Orient ?",
      answers: ["1965","1979","1989","1978"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11909: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1978 pour leurs contributions à la négociation des accords de Camp David pour la paix au Moyen-Orient ?",
      answers: ["Betty Williams","Amnesty International","Menachem Begin","Anwar Sadat"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11910: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Anwar Sadat a-t-il reçu le Prix Nobel en 1978 ?",
      answers: ["pour sa contribution au développement durable, à la démocratie et à la paix","pour son travail en faveur de la paix et de la Société des Nations","pour leurs contributions à la négociation des accords de Camp David pour la paix au Moyen-Orient","pour son travail visant à promouvoir la paix à travers l’amélioration de la nutrition mondiale"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11911: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Anwar Sadat a-t-il reçu le Prix Nobel en 1978 ?",
      answers: ["Physiologie ou Médecine","Chimie","Paix","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11912: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Menachem Begin a-t-il reçu le Prix Nobel de Paix pour leurs contributions à la négociation des accords de Camp David pour la paix au Moyen-Orient ?",
      answers: ["1977","1969","1978","1979"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11913: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1978 pour leurs contributions à la négociation des accords de Camp David pour la paix au Moyen-Orient ?",
      answers: ["Leymah Gbowee","Jody Williams","Willy Brandt","Menachem Begin"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11914: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Menachem Begin a-t-il reçu le Prix Nobel en 1978 ?",
      answers: ["pour leurs efforts visant à trouver une solution pacifique au conflit en Irlande du Nord","pour son travail humanitaire dans les conflits armés","pour son travail de longue date en faveur de la paix et du désarmement","pour leurs contributions à la négociation des accords de Camp David pour la paix au Moyen-Orient"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11915: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Menachem Begin a-t-il reçu le Prix Nobel en 1978 ?",
      answers: ["Paix","Physiologie ou Médecine","Chimie","Sciences Économiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11916: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Herbert A. Simon a-t-il reçu le Prix Nobel de Sciences Économiques pour ses recherches pionnières sur le processus de prise de décision au sein des organisations économiques ?",
      answers: ["1958","1978","1991","1979"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11917: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1978 pour ses recherches pionnières sur le processus de prise de décision au sein des organisations économiques ?",
      answers: ["John C. Harsanyi","James M. Buchanan Jr.","Herbert A. Simon","James J. Heckman"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11918: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Herbert A. Simon a-t-il reçu le Prix Nobel en 1978 ?",
      answers: ["pour ses recherches sur les banques et les crises financières","pour ses contributions fondamentales au développement des systèmes de comptabilité nationale","pour ses recherches pionnières sur le processus de prise de décision au sein des organisations économiques","pour leurs contributions pionnières à la théorie de l’équilibre économique général et à la théorie du bien-être"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11919: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Herbert A. Simon a-t-il reçu le Prix Nobel en 1978 ?",
      answers: ["Sciences Économiques","Chimie","Physiologie ou Médecine","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11920: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Isaac Bashevis Singer a-t-il reçu le Prix Nobel de Littérature pour son art narratif passionné qui, enraciné dans la culture et les traditions juives polonaises, donne une portée universelle à la condition humaine ?",
      answers: ["1986","1978","1977","1979"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11921: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1978 pour son art narratif passionné qui, enraciné dans la culture et les traditions juives polonaises, donne une portée universelle à la condition humaine ?",
      answers: ["William Butler Yeats","Sinclair Lewis","Władysław Reymont","Isaac Bashevis Singer"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11922: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Isaac Bashevis Singer a-t-il reçu le Prix Nobel en 1978 ?",
      answers: ["pour sa poésie qui, contre l’arrière-plan de la tradition grecque, dépeint avec une force sensuelle et une clarté intellectuelle la lutte de l’homme moderne pour la liberté et la créativité","pour sa grande épopée nationale, 'Les Paysans'","maîtresse de la nouvelle contemporaine","pour son art narratif passionné qui, enraciné dans la culture et les traditions juives polonaises, donne une portée universelle à la condition humaine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11923: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Isaac Bashevis Singer a-t-il reçu le Prix Nobel en 1978 ?",
      answers: ["Paix","Physiologie ou Médecine","Littérature","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11924: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Sheldon Glashow a-t-il reçu le Prix Nobel de Physique pour leurs contributions à la théorie unifiée des interactions faible et électromagnétique entre particules élémentaires ?",
      answers: ["1984","1976","1987","1979"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11925: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1979 pour leurs contributions à la théorie unifiée des interactions faible et électromagnétique entre particules élémentaires ?",
      answers: ["Sheldon Glashow","James Peebles","Steven Weinberg","Antony Hewish"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11926: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Sheldon Glashow a-t-il reçu le Prix Nobel en 1979 ?",
      answers: ["pour l’invention et le développement du cyclotron et pour les résultats obtenus, en particulier en ce qui concerne les éléments radioactifs artificiels","pour leurs contributions à la théorie unifiée des interactions faible et électromagnétique entre particules élémentaires","pour leurs investigations théoriques fondamentales sur la structure électronique des systèmes magnétiques et désordonnés","pour leur investigation approfondie des lois dites de parité, qui a conduit à d’importantes découvertes concernant les particules élémentaires"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11927: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Sheldon Glashow a-t-il reçu le Prix Nobel en 1979 ?",
      answers: ["Physiologie ou Médecine","Chimie","Paix","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11928: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Abdus Salam a-t-il reçu le Prix Nobel de Physique pour leurs contributions à la théorie unifiée des interactions faible et électromagnétique entre particules élémentaires ?",
      answers: ["1925","1979","1976","1909"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11929: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1979 pour leurs contributions à la théorie unifiée des interactions faible et électromagnétique entre particules élémentaires ?",
      answers: ["Robert W. Wilson","Adam G. Riess","Brian D. Josephson","Abdus Salam"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11930: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Abdus Salam a-t-il reçu le Prix Nobel en 1979 ?",
      answers: ["pour leurs investigations théoriques fondamentales sur la structure électronique des systèmes magnétiques et désordonnés","pour la découverte des violations de principes fondamentaux de symétrie dans la désintégration des mésons K neutres","pour leurs contributions à la théorie unifiée des interactions faible et électromagnétique entre particules élémentaires","pour ses études théoriques et expérimentales des réactions nucléaires importantes dans la formation des éléments chimiques dans l’univers"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11931: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Abdus Salam a-t-il reçu le Prix Nobel en 1979 ?",
      answers: ["Physiologie ou Médecine","Paix","Physique","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11932: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Steven Weinberg a-t-il reçu le Prix Nobel de Physique pour leurs contributions à la théorie unifiée des interactions faible et électromagnétique entre particules élémentaires ?",
      answers: ["1918","1979","2010","1975"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11933: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1979 pour leurs contributions à la théorie unifiée des interactions faible et électromagnétique entre particules élémentaires ?",
      answers: ["Brian D. Josephson","Steven Weinberg","Richard E. Taylor","Abdus Salam"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11934: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Steven Weinberg a-t-il reçu le Prix Nobel en 1979 ?",
      answers: ["pour leurs investigations théoriques fondamentales sur la structure électronique des systèmes magnétiques et désordonnés","pour la découverte d’un nouveau type de pulsar, une découverte qui a ouvert de nouvelles possibilités pour l’étude de la gravitation","pour leur découverte du rayonnement de fond cosmique micro-ondes","pour leurs contributions à la théorie unifiée des interactions faible et électromagnétique entre particules élémentaires"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11935: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Steven Weinberg a-t-il reçu le Prix Nobel en 1979 ?",
      answers: ["Physiologie ou Médecine","Physique","Chimie","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11936: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Georg Wittig a-t-il reçu le Prix Nobel de Chimie pour leur développement de l’utilisation des composés de bore et de phosphore, respectivement, dans la synthèse organique ?",
      answers: ["1977","1979","1997","1925"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11937: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1979 pour leur développement de l’utilisation des composés de bore et de phosphore, respectivement, dans la synthèse organique ?",
      answers: ["William H. Stein","Georg Wittig","Thomas R. Cech","John H. Northrop"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11938: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Georg Wittig a-t-il reçu le Prix Nobel en 1979 ?",
      answers: ["pour le développement d’une méthode d’édition du génome","pour leur développement de l’utilisation des composés de bore et de phosphore, respectivement, dans la synthèse organique","pour leurs réalisations exceptionnelles dans le développement de méthodes directes pour la détermination des structures cristallines","pour leur développement et leur utilisation de molécules avec des interactions spécifiques de reconnaissance structurale"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11939: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Georg Wittig a-t-il reçu le Prix Nobel en 1979 ?",
      answers: ["Chimie","Paix","Littérature","Sciences Économiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11940: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Herbert C. Brown a-t-il reçu le Prix Nobel de Chimie pour leur développement de l’utilisation des composés de bore et de phosphore, respectivement, dans la synthèse organique ?",
      answers: ["1975","1995","1979","1977"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11941: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1979 pour leur développement de l’utilisation des composés de bore et de phosphore, respectivement, dans la synthèse organique ?",
      answers: ["William N. Lipscomb","Herbert C. Brown","Henry Taube","Peter Mitchell"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11942: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Herbert C. Brown a-t-il reçu le Prix Nobel en 1979 ?",
      answers: ["pour la conception et la synthèse de machines moléculaires","pour leur développement de l’utilisation des composés de bore et de phosphore, respectivement, dans la synthèse organique","pour leur préparation d’enzymes et de protéines virales sous une forme pure","pour leurs contributions à la détermination des séquences de bases dans les acides nucléiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11943: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Herbert C. Brown a-t-il reçu le Prix Nobel en 1979 ?",
      answers: ["Chimie","Physiologie ou Médecine","Physique","Littérature"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11944: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Allan M. Cormack a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour le développement de la tomographie assistée par ordinateur ?",
      answers: ["1979","1980","1978","1977"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11945: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1979 pour le développement de la tomographie assistée par ordinateur ?",
      answers: ["Allan M. Cormack","Baruj Benacerraf","Godfrey N. Hounsfield","Roger W. Sperry"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11946: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Allan M. Cormack a-t-il reçu le Prix Nobel en 1979 ?",
      answers: ["pour leurs découvertes de principes importants pour le traitement médicamenteux","pour la découverte du principe de production d’anticorps monoclonaux","pour le développement de la tomographie assistée par ordinateur","pour leurs découvertes concernant le mécanisme de réplication et la structure génétique des virus"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11947: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Allan M. Cormack a-t-il reçu le Prix Nobel en 1979 ?",
      answers: ["Chimie","Physiologie ou Médecine","Littérature","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11948: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Godfrey N. Hounsfield a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour le développement de la tomographie assistée par ordinateur ?",
      answers: ["1979","1975","1968","1977"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11949: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1979 pour le développement de la tomographie assistée par ordinateur ?",
      answers: ["Erwin Neher","Werner Arber","Roger W. Sperry","Godfrey N. Hounsfield"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11950: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Godfrey N. Hounsfield a-t-il reçu le Prix Nobel en 1979 ?",
      answers: ["pour leurs découvertes concernant la régulation du métabolisme du cholestérol","pour leurs découvertes concernant la structure moléculaire des acides nucléiques et son importance pour le transfert d’information dans le matériel vivant","pour le développement de la tomographie assistée par ordinateur","pour leurs découvertes sur les gènes discontinus"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11951: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Godfrey N. Hounsfield a-t-il reçu le Prix Nobel en 1979 ?",
      answers: ["Chimie","Paix","Physiologie ou Médecine","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11952: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Mère Teresa a-t-il reçu le Prix Nobel de Paix pour son travail visant à aider les pauvres et à promouvoir la paix mondiale ?",
      answers: ["1970","1978","1999","1979"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11953: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1979 pour son travail visant à aider les pauvres et à promouvoir la paix mondiale ?",
      answers: ["Menachem Begin","Henry Kissinger","Alfonso García Robles","Mère Teresa"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11954: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Mère Teresa a-t-il reçu le Prix Nobel en 1979 ?",
      answers: ["pour ses efforts visant à instaurer la paix et la coopération internationale, notamment pour son initiative décisive dans la résolution du conflit frontalier avec l’Érythrée","pour leur travail en faveur du désarmement et de la paix mondiale","pour son rôle de leader dans la défense non violente des droits humains en Amérique latine","pour son travail visant à aider les pauvres et à promouvoir la paix mondiale"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11955: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Mère Teresa a-t-il reçu le Prix Nobel en 1979 ?",
      answers: ["Physique","Paix","Physiologie ou Médecine","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11956: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Theodore W. Schultz a-t-il reçu le Prix Nobel de Sciences Économiques pour leurs analyses pionnières du développement économique, avec une attention particulière aux problèmes des pays en développement ?",
      answers: ["1973","2005","2022","1979"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11957: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1979 pour leurs analyses pionnières du développement économique, avec une attention particulière aux problèmes des pays en développement ?",
      answers: ["Sir W. Arthur Lewis","Trygve Haavelmo","Theodore W. Schultz","Franco Modigliani"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11958: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Theodore W. Schultz a-t-il reçu le Prix Nobel en 1979 ?",
      answers: ["pour ses améliorations à la théorie des enchères et ses inventions de nouveaux formats d’enchères","pour leur analyse des marchés avec information asymétrique","pour ses contributions pionnières à la théorie des marchés et à l’utilisation efficace des ressources","pour leurs analyses pionnières du développement économique, avec une attention particulière aux problèmes des pays en développement"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11959: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Theodore W. Schultz a-t-il reçu le Prix Nobel en 1979 ?",
      answers: ["Chimie","Physiologie ou Médecine","Sciences Économiques","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11960: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Sir W. Arthur Lewis a-t-il reçu le Prix Nobel de Sciences Économiques pour leurs analyses pionnières du développement économique, avec une attention particulière aux problèmes des pays en développement ?",
      answers: ["1925","1993","1971","1979"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11961: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1979 pour leurs analyses pionnières du développement économique, avec une attention particulière aux problèmes des pays en développement ?",
      answers: ["Theodore W. Schultz","Merton H. Miller","Herbert A. Simon","Sir W. Arthur Lewis"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11962: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Sir W. Arthur Lewis a-t-il reçu le Prix Nobel en 1979 ?",
      answers: ["pour ses méthodes d’analyse des données microéconomiques","pour leurs contributions pionnières à la théorie de l’équilibre économique général et à la théorie du bien-être","pour leurs analyses pionnières du développement économique, avec une attention particulière aux problèmes des pays en développement","pour leurs contributions pionnières à la théorie de l’économie financière"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11963: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Sir W. Arthur Lewis a-t-il reçu le Prix Nobel en 1979 ?",
      answers: ["Physiologie ou Médecine","Physique","Sciences Économiques","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11964: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Odysseas Elytis a-t-il reçu le Prix Nobel de Littérature pour sa poésie qui, contre l’arrière-plan de la tradition grecque, dépeint avec une force sensuelle et une clarté intellectuelle la lutte de l’homme moderne pour la liberté et la créativité ?",
      answers: ["1979","1967","1916","1950"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11965: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1979 pour sa poésie qui, contre l’arrière-plan de la tradition grecque, dépeint avec une force sensuelle et une clarté intellectuelle la lutte de l’homme moderne pour la liberté et la créativité ?",
      answers: ["Odysseas Elytis","Derek Walcott","Czesław Miłosz","Henrik Pontoppidan"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11966: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Odysseas Elytis a-t-il reçu le Prix Nobel en 1979 ?",
      answers: ["qui, avec une lucidité sans compromis, exprime la condition exposée de l’homme dans un monde de conflits sévères","pour sa poésie qui, contre l’arrière-plan de la tradition grecque, dépeint avec une force sensuelle et une clarté intellectuelle la lutte de l’homme moderne pour la liberté et la créativité","pour des écrits marqués par une large perspective, une richesse d’idées et une puissance artistique","pour sa pénétration sans compromis et empreinte de compassion des effets du colonialisme et du destin des réfugiés"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11967: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Odysseas Elytis a-t-il reçu le Prix Nobel en 1979 ?",
      answers: ["Chimie","Littérature","Sciences Économiques","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11968: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année James W. Cronin a-t-il reçu le Prix Nobel de Physique pour la découverte des violations de principes fondamentaux de symétrie dans la désintégration des mésons K neutres ?",
      answers: ["1951","1995","1980","1962"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11969: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1980 pour la découverte des violations de principes fondamentaux de symétrie dans la désintégration des mésons K neutres ?",
      answers: ["James W. Cronin","Subrahmanyan Chandrasekhar","Val L. Fitch","George E. Smith"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11970: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison James W. Cronin a-t-il reçu le Prix Nobel en 1980 ?",
      answers: ["pour la découverte des violations de principes fondamentaux de symétrie dans la désintégration des mésons K neutres","pour leurs contributions à la théorie unifiée des interactions faible et électromagnétique entre particules élémentaires","pour leurs investigations théoriques fondamentales sur la structure électronique des systèmes magnétiques et désordonnés","pour leur contribution au développement de la spectroscopie laser"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11971: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie James W. Cronin a-t-il reçu le Prix Nobel en 1980 ?",
      answers: ["Paix","Physique","Chimie","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11972: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Val L. Fitch a-t-il reçu le Prix Nobel de Physique pour la découverte des violations de principes fondamentaux de symétrie dans la désintégration des mésons K neutres ?",
      answers: ["1919","1981","1980","1984"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11973: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1980 pour la découverte des violations de principes fondamentaux de symétrie dans la désintégration des mésons K neutres ?",
      answers: ["James W. Cronin","Nicolaas Bloembergen","Val L. Fitch","Claude Cohen-Tannoudji"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11974: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Val L. Fitch a-t-il reçu le Prix Nobel en 1980 ?",
      answers: ["pour leur investigation approfondie des lois dites de parité, qui a conduit à d’importantes découvertes concernant les particules élémentaires","pour leurs travaux pionniers dans la découverte d’une nouvelle particule élémentaire lourde","pour sa contribution au développement de la spectroscopie électronique à haute résolution","pour la découverte des violations de principes fondamentaux de symétrie dans la désintégration des mésons K neutres"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11975: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Val L. Fitch a-t-il reçu le Prix Nobel en 1980 ?",
      answers: ["Physiologie ou Médecine","Paix","Chimie","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11976: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Paul Berg a-t-il reçu le Prix Nobel de Chimie pour ses études fondamentales sur la biochimie des acides nucléiques, en particulier l’ADN recombinant ?",
      answers: ["1980","2006","1966","1982"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11977: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1980 pour ses études fondamentales sur la biochimie des acides nucléiques, en particulier l’ADN recombinant ?",
      answers: ["Bruce Merrifield","Max F. Perutz","Ada E. Yonath","Paul Berg"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11978: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Paul Berg a-t-il reçu le Prix Nobel en 1980 ?",
      answers: ["pour leur développement de l’utilisation des composés de bore et de phosphore, respectivement, dans la synthèse organique","pour ses études fondamentales sur la biochimie des acides nucléiques, en particulier l’ADN recombinant","pour ses développements de méthodes computationnelles en chimie quantique","pour leurs contributions à la détermination des séquences de bases dans les acides nucléiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11979: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Paul Berg a-t-il reçu le Prix Nobel en 1980 ?",
      answers: ["Physiologie ou Médecine","Physique","Chimie","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11980: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Walter Gilbert a-t-il reçu le Prix Nobel de Chimie pour leurs contributions à la détermination des séquences de bases dans les acides nucléiques ?",
      answers: ["1978","1982","1980","2011"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11981: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1980 pour leurs contributions à la détermination des séquences de bases dans les acides nucléiques ?",
      answers: ["Walter Gilbert","Paul Berg","Herbert A. Hauptman","Thomas R. Cech"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11982: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Walter Gilbert a-t-il reçu le Prix Nobel en 1980 ?",
      answers: ["pour leurs découvertes dans la chimie des éléments transuraniens","pour son développement de la méthodologie de la synthèse chimique sur phase solide","pour leurs contributions à la détermination des séquences de bases dans les acides nucléiques","pour ses contributions fondamentales, théoriques et expérimentales, à la chimie physique des macromolécules"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11983: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Walter Gilbert a-t-il reçu le Prix Nobel en 1980 ?",
      answers: ["Physiologie ou Médecine","Littérature","Paix","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11984: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Frederick Sanger a-t-il reçu le Prix Nobel de Chimie pour leurs contributions à la détermination des séquences de bases dans les acides nucléiques ?",
      answers: ["1987","1980","1966","1979"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11985: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1980 pour leurs contributions à la détermination des séquences de bases dans les acides nucléiques ?",
      answers: ["William F. Giauque","Johann Deisenhofer","Walter Gilbert","Frederick Sanger"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11986: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Frederick Sanger a-t-il reçu le Prix Nobel en 1980 ?",
      answers: ["pour leurs contributions à la détermination des séquences de bases dans les acides nucléiques","pour leur préparation d’enzymes et de protéines virales sous une forme pure","pour ses travaux sur les mécanismes des réactions de transfert d’électrons, en particulier dans les complexes métalliques","pour leur développement de l’utilisation des composés de bore et de phosphore, respectivement, dans la synthèse organique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11987: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Frederick Sanger a-t-il reçu le Prix Nobel en 1980 ?",
      answers: ["Physiologie ou Médecine","Chimie","Physique","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11988: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Baruj Benacerraf a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant les structures génétiquement déterminées à la surface des cellules qui régulent les réactions immunitaires ?",
      answers: ["1996","1980","1913","1990"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11989: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1980 pour leurs découvertes concernant les structures génétiquement déterminées à la surface des cellules qui régulent les réactions immunitaires ?",
      answers: ["John R. Vane","Walter R. Hess","Baruj Benacerraf","Eric F. Wieschaus"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11990: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Baruj Benacerraf a-t-il reçu le Prix Nobel en 1980 ?",
      answers: ["pour le développement de la tomographie assistée par ordinateur","pour leurs découvertes concernant les structures génétiquement déterminées à la surface des cellules qui régulent les réactions immunitaires","pour leurs découvertes concernant les prostaglandines et les substances biologiquement actives apparentées","pour la découverte du rôle joué par le sinus et les mécanismes aortiques dans la régulation de la respiration"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id11991: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Baruj Benacerraf a-t-il reçu le Prix Nobel en 1980 ?",
      answers: ["Littérature","Chimie","Physiologie ou Médecine","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11992: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Jean Dausset a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant les structures génétiquement déterminées à la surface des cellules qui régulent les réactions immunitaires ?",
      answers: ["1980","1982","1979","1984"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11993: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1980 pour leurs découvertes concernant les structures génétiquement déterminées à la surface des cellules qui régulent les réactions immunitaires ?",
      answers: ["Jean Dausset","Yoshinori Ohsumi","Robert F. Furchgott","Jack W. Szostak"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11994: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Jean Dausset a-t-il reçu le Prix Nobel en 1980 ?",
      answers: ["pour leurs découvertes sur les modifications des bases nucléosidiques qui ont permis le développement de vaccins à ARNm efficaces contre le COVID-19","pour leurs découvertes sur la régulation génétique du développement des organes et de la mort cellulaire programmée","pour la découverte des enzymes de restriction et leur application aux problèmes de génétique moléculaire","pour leurs découvertes concernant les structures génétiquement déterminées à la surface des cellules qui régulent les réactions immunitaires"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11995: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Jean Dausset a-t-il reçu le Prix Nobel en 1980 ?",
      answers: ["Littérature","Physique","Physiologie ou Médecine","Paix"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id11996: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année George D. Snell a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant les structures génétiquement déterminées à la surface des cellules qui régulent les réactions immunitaires ?",
      answers: ["1980","1977","1981","1984"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11997: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1980 pour leurs découvertes concernant les structures génétiquement déterminées à la surface des cellules qui régulent les réactions immunitaires ?",
      answers: ["Jean Dausset","Sir Bernard Katz","Daniel Nathans","George D. Snell"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id11998: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison George D. Snell a-t-il reçu le Prix Nobel en 1980 ?",
      answers: ["pour leurs découvertes concernant les structures génétiquement déterminées à la surface des cellules qui régulent les réactions immunitaires","pour la découverte de la pénicilline et de son effet curatif dans diverses maladies infectieuses","pour leurs découvertes concernant le traitement de l’information dans le système visuel","pour la découverte des enzymes de restriction et leur application aux problèmes de génétique moléculaire"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id11999: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie George D. Snell a-t-il reçu le Prix Nobel en 1980 ?",
      answers: ["Sciences Économiques","Paix","Physique","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12000: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Adolfo Pérez Esquivel a-t-il reçu le Prix Nobel de Paix pour son rôle de leader dans la défense non violente des droits humains en Amérique latine ?",
      answers: ["1981","1983","1980","1994"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12001: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1980 pour son rôle de leader dans la défense non violente des droits humains en Amérique latine ?",
      answers: ["John Hume","Menachem Begin","Adolfo Pérez Esquivel","Muhammad Yunus"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12002: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Adolfo Pérez Esquivel a-t-il reçu le Prix Nobel en 1980 ?",
      answers: ["pour son rôle de leader dans la défense non violente des droits humains en Amérique latine","pour ses efforts en faveur de la démocratie et des droits humains, notamment pour les femmes et les enfants","pour leurs efforts visant à créer la paix au Moyen-Orient","pour leur travail visant à promouvoir une solution pacifique au conflit en Irlande du Nord"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12003: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Adolfo Pérez Esquivel a-t-il reçu le Prix Nobel en 1980 ?",
      answers: ["Littérature","Paix","Physiologie ou Médecine","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12004: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Czesław Miłosz a-t-il reçu le Prix Nobel de Littérature qui, avec une lucidité sans compromis, exprime la condition exposée de l’homme dans un monde de conflits sévères ?",
      answers: ["1901","1980","1977","1985"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12005: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1980 qui, avec une lucidité sans compromis, exprime la condition exposée de l’homme dans un monde de conflits sévères ?",
      answers: ["Pablo Neruda","Juan Ramón Jiménez","Czesław Miłosz","Isaac Bashevis Singer"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12006: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Czesław Miłosz a-t-il reçu le Prix Nobel en 1980 ?",
      answers: ["qui, avec une lucidité sans compromis, exprime la condition exposée de l’homme dans un monde de conflits sévères","pour des écrits marqués par une large perspective, une richesse d’idées et une puissance artistique","pour la pénétration spirituelle profonde et l’intensité artistique avec lesquelles il a exploré les drames de la vie humaine dans ses romans","qui, dans ses romans, combine la créativité du poète et du peintre avec une profonde conscience du temps dans la représentation de la condition humaine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12007: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Czesław Miłosz a-t-il reçu le Prix Nobel en 1980 ?",
      answers: ["Physique","Physiologie ou Médecine","Littérature","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12008: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Lawrence R. Klein a-t-il reçu le Prix Nobel de Sciences Économiques pour la création de modèles économétriques et leur application à l’analyse des fluctuations économiques et des politiques économiques ?",
      answers: ["1980","1977","1978","1964"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12009: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1980 pour la création de modèles économétriques et leur application à l’analyse des fluctuations économiques et des politiques économiques ?",
      answers: ["Simon Kuznets","Theodore W. Schultz","John F. Nash Jr.","Lawrence R. Klein"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12010: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Lawrence R. Klein a-t-il reçu le Prix Nobel en 1980 ?",
      answers: ["pour leurs analyses pionnières du développement économique, avec une attention particulière aux problèmes des pays en développement","pour avoir posé les bases de la théorie de la conception des mécanismes","pour avoir renouvelé la recherche en histoire économique en appliquant la théorie économique et les méthodes quantitatives","pour la création de modèles économétriques et leur application à l’analyse des fluctuations économiques et des politiques économiques"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12011: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Lawrence R. Klein a-t-il reçu le Prix Nobel en 1980 ?",
      answers: ["Paix","Physiologie ou Médecine","Sciences Économiques","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12012: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Nicolaas Bloembergen a-t-il reçu le Prix Nobel de Physique pour leur contribution au développement de la spectroscopie laser ?",
      answers: ["1930","1981","1975","2002"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12013: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1981 pour leur contribution au développement de la spectroscopie laser ?",
      answers: ["Arthur B. McDonald","Nicolaas Bloembergen","Arno Penzias","Kai M. Siegbahn"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12014: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Nicolaas Bloembergen a-t-il reçu le Prix Nobel en 1981 ?",
      answers: ["pour leur contribution au développement de la spectroscopie laser","pour leurs contributions à la théorie unifiée des interactions faible et électromagnétique entre particules élémentaires","pour la découverte des violations de principes fondamentaux de symétrie dans la désintégration des mésons K neutres","pour des découvertes théoriques sur les transitions de phase topologiques et les phases topologiques de la matière"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12015: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Nicolaas Bloembergen a-t-il reçu le Prix Nobel en 1981 ?",
      answers: ["Chimie","Physique","Physiologie ou Médecine","Littérature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12016: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Arthur L. Schawlow a-t-il reçu le Prix Nobel de Physique pour leur contribution au développement de la spectroscopie laser ?",
      answers: ["1980","1975","1982","1981"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12017: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1981 pour leur contribution au développement de la spectroscopie laser ?",
      answers: ["Arthur L. Schawlow","William A. Fowler","Shuji Nakamura","Nicolaas Bloembergen"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12018: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Arthur L. Schawlow a-t-il reçu le Prix Nobel en 1981 ?",
      answers: ["pour ses inventions et découvertes fondamentales dans la physique des basses températures","pour leurs travaux pionniers dans la découverte d’une nouvelle particule élémentaire lourde","pour ses études théoriques et expérimentales des réactions nucléaires importantes dans la formation des éléments chimiques dans l’univers","pour leur contribution au développement de la spectroscopie laser"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12019: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Arthur L. Schawlow a-t-il reçu le Prix Nobel en 1981 ?",
      answers: ["Chimie","Physique","Paix","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12020: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Kai M. Siegbahn a-t-il reçu le Prix Nobel de Physique pour sa contribution au développement de la spectroscopie électronique à haute résolution ?",
      answers: ["1981","1982","1984","1986"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12021: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1981 pour sa contribution au développement de la spectroscopie électronique à haute résolution ?",
      answers: ["Kai M. Siegbahn","Arno Penzias","Arthur L. Schawlow","Val L. Fitch"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12022: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Kai M. Siegbahn a-t-il reçu le Prix Nobel en 1981 ?",
      answers: ["pour sa contribution au développement de la spectroscopie électronique à haute résolution","pour leur découverte du rayonnement de fond cosmique micro-ondes","pour ses investigations sur la physique de la haute atmosphère, en particulier pour la découverte de la couche dite Appleton","pour sa théorie des phénomènes critiques en relation avec les transitions de phase"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12023: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Kai M. Siegbahn a-t-il reçu le Prix Nobel en 1981 ?",
      answers: ["Sciences Économiques","Physique","Littérature","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12024: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Roald Hoffmann a-t-il reçu le Prix Nobel de Chimie pour leurs théories, développées indépendamment, concernant le cours des réactions chimiques ?",
      answers: ["1981","1985","2004","1959"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12025: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1981 pour leurs théories, développées indépendamment, concernant le cours des réactions chimiques ?",
      answers: ["Kenichi Fukui","William E. Moerner","John W. Cornforth","Roald Hoffmann"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12026: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Roald Hoffmann a-t-il reçu le Prix Nobel en 1981 ?",
      answers: ["pour leur développement de l’utilisation des composés de bore et de phosphore, respectivement, dans la synthèse organique","pour leurs contributions à la détermination des séquences de bases dans les acides nucléiques","pour leurs théories, développées indépendamment, concernant le cours des réactions chimiques","en reconnaissance de ses travaux sur la catalyse et pour ses recherches sur les principes fondamentaux régissant l’équilibre chimique et les vitesses de réaction"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12027: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Roald Hoffmann a-t-il reçu le Prix Nobel en 1981 ?",
      answers: ["Littérature","Physiologie ou Médecine","Paix","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12028: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Kenichi Fukui a-t-il reçu le Prix Nobel de Chimie pour leurs théories, développées indépendamment, concernant le cours des réactions chimiques ?",
      answers: ["1983","1963","1982","1981"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12029: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1981 pour leurs théories, développées indépendamment, concernant le cours des réactions chimiques ?",
      answers: ["Sidney Altman","Kenichi Fukui","Richard Kuhn","Charles J. Pedersen"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12030: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Kenichi Fukui a-t-il reçu le Prix Nobel en 1981 ?",
      answers: ["pour leurs contributions au développement du concept de conformation et son application en chimie","pour leurs théories, développées indépendamment, concernant le cours des réactions chimiques","pour son travail sur les composés soufrés biologiquement importants, en particulier pour la première synthèse d’une hormone polypeptidique","pour leur développement de l’utilisation des composés de bore et de phosphore, respectivement, dans la synthèse organique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12031: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Kenichi Fukui a-t-il reçu le Prix Nobel en 1981 ?",
      answers: ["Littérature","Physique","Chimie","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12032: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Roger W. Sperry a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour ses découvertes concernant la spécialisation fonctionnelle des hémisphères cérébraux ?",
      answers: ["2019","1981","1985","1909"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12033: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1981 pour ses découvertes concernant la spécialisation fonctionnelle des hémisphères cérébraux ?",
      answers: ["Howard M. Temin","Eric R. Kandel","Godfrey N. Hounsfield","Roger W. Sperry"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12034: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Roger W. Sperry a-t-il reçu le Prix Nobel en 1981 ?",
      answers: ["pour leurs découvertes concernant le traitement de l’information dans le système visuel","pour ses découvertes concernant la spécialisation fonctionnelle des hémisphères cérébraux","pour leurs découvertes concernant les prostaglandines et les substances biologiquement actives apparentées","pour leurs découvertes concernant l’organisation structurelle et fonctionnelle de la cellule"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12035: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Roger W. Sperry a-t-il reçu le Prix Nobel en 1981 ?",
      answers: ["Sciences Économiques","Physiologie ou Médecine","Physique","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12036: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année David H. Hubel a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant le traitement de l’information dans le système visuel ?",
      answers: ["1981","1986","2005","1973"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12037: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1981 pour leurs découvertes concernant le traitement de l’information dans le système visuel ?",
      answers: ["Yoshinori Ohsumi","David H. Hubel","André Lwoff","Baruj Benacerraf"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12038: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison David H. Hubel a-t-il reçu le Prix Nobel en 1981 ?",
      answers: ["pour ses découvertes concernant la spécialisation fonctionnelle des hémisphères cérébraux","pour leurs découvertes concernant l’organisation et l’élicitation des schémas de comportement individuels et sociaux","pour leurs découvertes concernant le traitement de l’information dans le système visuel","pour leur découverte que les gènes agissent en régulant des événements chimiques définis"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12039: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie David H. Hubel a-t-il reçu le Prix Nobel en 1981 ?",
      answers: ["Physique","Physiologie ou Médecine","Chimie","Littérature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12040: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Torsten N. Wiesel a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant le traitement de l’information dans le système visuel ?",
      answers: ["2009","1977","1981","1983"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12041: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1981 pour leurs découvertes concernant le traitement de l’information dans le système visuel ?",
      answers: ["George E. Palade","Torsten N. Wiesel","Paul Greengard","Baruj Benacerraf"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12042: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Torsten N. Wiesel a-t-il reçu le Prix Nobel en 1981 ?",
      answers: ["pour leurs découvertes concernant de nouveaux mécanismes d’origine et de dissémination des maladies infectieuses","pour leurs découvertes concernant le traitement de l’information dans le système visuel","pour leurs découvertes de principes importants pour le traitement médicamenteux","pour ses découvertes concernant la spécialisation fonctionnelle des hémisphères cérébraux"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12043: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Torsten N. Wiesel a-t-il reçu le Prix Nobel en 1981 ?",
      answers: ["Physiologie ou Médecine","Physique","Sciences Économiques","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12044: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Haut-Commissariat des Nations Unies pour les Réfugiés (HCR) a-t-il reçu le Prix Nobel de Paix pour son travail humanitaire en faveur des réfugiés dans le monde entier ?",
      answers: ["1981","1976","1905","1987"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12045: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1981 pour son travail humanitaire en faveur des réfugiés dans le monde entier ?",
      answers: ["Haut-Commissariat des Nations Unies pour les Réfugiés (HCR)","Ferdinand Buisson","Adolfo Pérez Esquivel","Nelson Mandela"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12046: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Haut-Commissariat des Nations Unies pour les Réfugiés (HCR) a-t-il reçu le Prix Nobel en 1981 ?",
      answers: ["pour son travail en faveur de la paix et des droits des travailleurs","pour son travail humanitaire en faveur des réfugiés dans le monde entier","pour son travail humanitaire dans les conflits armés","pour leur travail en faveur du désarmement et de la paix mondiale"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12047: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Haut-Commissariat des Nations Unies pour les Réfugiés (HCR) a-t-il reçu le Prix Nobel en 1981 ?",
      answers: ["Sciences Économiques","Littérature","Physiologie ou Médecine","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12048: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Elias Canetti a-t-il reçu le Prix Nobel de Littérature pour des écrits marqués par une large perspective, une richesse d’idées et une puissance artistique ?",
      answers: ["1964","1960","1981","1911"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12049: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1981 pour des écrits marqués par une large perspective, une richesse d’idées et une puissance artistique ?",
      answers: ["Elias Canetti","Vicente Aleixandre","William Faulkner","Patrick White"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12050: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Elias Canetti a-t-il reçu le Prix Nobel en 1981 ?",
      answers: ["qui, dans ses romans, combine la créativité du poète et du peintre avec une profonde conscience du temps dans la représentation de la condition humaine","pour sa poésie qui, avec une fraîcheur, une sensualité et une inventivité riches, donne une image libératrice de l’esprit indomptable et de la polyvalence de l’homme","pour des écrits marqués par une large perspective, une richesse d’idées et une puissance artistique","qui, avec une lucidité sans compromis, exprime la condition exposée de l’homme dans un monde de conflits sévères"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12051: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Elias Canetti a-t-il reçu le Prix Nobel en 1981 ?",
      answers: ["Paix","Sciences Économiques","Littérature","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12052: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année James Tobin a-t-il reçu le Prix Nobel de Sciences Économiques pour son analyse de la théorie des marchés financiers et de leurs relations avec les décisions de dépenses, l’emploi, la production et les prix ?",
      answers: ["1971","1981","1987","1983"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12053: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1981 pour son analyse de la théorie des marchés financiers et de leurs relations avec les décisions de dépenses, l’emploi, la production et les prix ?",
      answers: ["William F. Sharpe","Robert B. Wilson","Milton Friedman","James Tobin"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12054: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison James Tobin a-t-il reçu le Prix Nobel en 1981 ?",
      answers: ["pour ses études pionnières sur les structures industrielles, le fonctionnement des marchés et les causes et effets de la régulation publique","pour avoir développé et appliqué l’hypothèse des anticipations rationnelles","pour son analyse de la théorie des marchés financiers et de leurs relations avec les décisions de dépenses, l’emploi, la production et les prix","pour leurs contributions pionnières à la théorie de l’économie financière"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12055: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie James Tobin a-t-il reçu le Prix Nobel en 1981 ?",
      answers: ["Chimie","Physique","Physiologie ou Médecine","Sciences Économiques"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12056: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Kenneth G. Wilson a-t-il reçu le Prix Nobel de Physique pour sa théorie des phénomènes critiques en relation avec les transitions de phase ?",
      answers: ["1968","1982","1983","1979"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12057: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1982 pour sa théorie des phénomènes critiques en relation avec les transitions de phase ?",
      answers: ["Leo Esaki","Klaus von Klitzing","Sir William H. Bragg","Kenneth G. Wilson"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12058: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Kenneth G. Wilson a-t-il reçu le Prix Nobel en 1982 ?",
      answers: ["pour la découverte d’un objet compact supermassif au centre de notre galaxie","pour sa découverte de l’effet Doppler dans les rayons canaux et de la séparation des lignes spectrales dans les champs électriques","pour leurs investigations théoriques fondamentales sur la structure électronique des systèmes magnétiques et désordonnés","pour sa théorie des phénomènes critiques en relation avec les transitions de phase"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12059: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Kenneth G. Wilson a-t-il reçu le Prix Nobel en 1982 ?",
      answers: ["Physique","Paix","Physiologie ou Médecine","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12060: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année George J. Stigler a-t-il reçu le Prix Nobel de Sciences Économiques pour ses études pionnières sur les structures industrielles, le fonctionnement des marchés et les causes et effets de la régulation publique ?",
      answers: ["1981","1982","2003","1984"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12061: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1982 pour ses études pionnières sur les structures industrielles, le fonctionnement des marchés et les causes et effets de la régulation publique ?",
      answers: ["Herbert A. Simon","George J. Stigler","Bengt Holmström","Merton H. Miller"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12062: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison George J. Stigler a-t-il reçu le Prix Nobel en 1982 ?",
      answers: ["pour ses réalisations dans les domaines de l’analyse de la consommation, de l’histoire et de la théorie monétaire et pour sa démonstration de la complexité de la politique de stabilisation","pour leurs contributions pionnières à la théorie de l’économie financière","pour ses études pionnières sur les structures industrielles, le fonctionnement des marchés et les causes et effets de la régulation publique","pour leurs analyses pionnières du développement économique, avec une attention particulière aux problèmes des pays en développement"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12063: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie George J. Stigler a-t-il reçu le Prix Nobel en 1982 ?",
      answers: ["Paix","Physiologie ou Médecine","Sciences Économiques","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12064: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Aaron Klug a-t-il reçu le Prix Nobel de Chimie pour son développement de la microscopie électronique cristallographique et son élucidation structurale des complexes nucléoprotéiques biologiquement importants ?",
      answers: ["1978","1982","1906","1983"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12065: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1982 pour son développement de la microscopie électronique cristallographique et son élucidation structurale des complexes nucléoprotéiques biologiquement importants ?",
      answers: ["Lars Onsager","Hans von Euler-Chelpin","John C. Polanyi","Aaron Klug"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12066: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Aaron Klug a-t-il reçu le Prix Nobel en 1982 ?",
      answers: ["pour son développement de la microscopie électronique cristallographique et son élucidation structurale des complexes nucléoprotéiques biologiquement importants","pour ses recherches sur les caroténoïdes, les flavines et les vitamines A et B2","pour la découverte et le développement des polymères conducteurs","pour la conception et la synthèse de machines moléculaires"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12067: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Aaron Klug a-t-il reçu le Prix Nobel en 1982 ?",
      answers: ["Chimie","Physiologie ou Médecine","Littérature","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12068: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Sune K. Bergström a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant les prostaglandines et les substances biologiquement actives apparentées ?",
      answers: ["1983","1982","2017","1985"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12069: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1982 pour leurs découvertes concernant les prostaglandines et les substances biologiquement actives apparentées ?",
      answers: ["Sune K. Bergström","Linda B. Buck","Bengt I. Samuelsson","George E. Palade"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12070: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Sune K. Bergström a-t-il reçu le Prix Nobel en 1982 ?",
      answers: ["pour leurs découvertes concernant les prostaglandines et les substances biologiquement actives apparentées","pour la découverte du principe de production d’anticorps monoclonaux","pour le développement de la tomographie assistée par ordinateur","pour leurs découvertes concernant les structures génétiquement déterminées à la surface des cellules qui régulent les réactions immunitaires"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12071: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Sune K. Bergström a-t-il reçu le Prix Nobel en 1982 ?",
      answers: ["Physiologie ou Médecine","Chimie","Physique","Littérature"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12072: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Bengt I. Samuelsson a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant les prostaglandines et les substances biologiquement actives apparentées ?",
      answers: ["1982","1995","1963","1983"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12073: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1982 pour leurs découvertes concernant les prostaglandines et les substances biologiquement actives apparentées ?",
      answers: ["John R. Vane","George H. Hitchings","Sune K. Bergström","Bengt I. Samuelsson"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12074: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Bengt I. Samuelsson a-t-il reçu le Prix Nobel en 1982 ?",
      answers: ["pour leurs découvertes concernant le traitement de l’information dans le système visuel","pour leurs découvertes concernant les prostaglandines et les substances biologiquement actives apparentées","pour ses découvertes concernant la spécialisation fonctionnelle des hémisphères cérébraux","pour la découverte du principe de production d’anticorps monoclonaux"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12075: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Bengt I. Samuelsson a-t-il reçu le Prix Nobel en 1982 ?",
      answers: ["Physiologie ou Médecine","Littérature","Sciences Économiques","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12076: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année John R. Vane a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant les prostaglandines et les substances biologiquement actives apparentées ?",
      answers: ["1991","1905","1982","1971"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12077: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1982 pour leurs découvertes concernant les prostaglandines et les substances biologiquement actives apparentées ?",
      answers: ["D. Carleton Gajdusek","Sune K. Bergström","Susumu Tonegawa","John R. Vane"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12078: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison John R. Vane a-t-il reçu le Prix Nobel en 1982 ?",
      answers: ["pour ses découvertes concernant la spécialisation fonctionnelle des hémisphères cérébraux","pour leurs découvertes concernant les prostaglandines et les substances biologiquement actives apparentées","pour leurs découvertes concernant le traitement de l’information dans le système visuel","pour leurs découvertes sur le système de transport vésiculaire dans les cellules"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12079: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie John R. Vane a-t-il reçu le Prix Nobel en 1982 ?",
      answers: ["Chimie","Sciences Économiques","Physique","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12080: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Alfonso García Robles a-t-il reçu le Prix Nobel de Paix pour leur travail en faveur du désarmement et de la paix mondiale ?",
      answers: ["1999","1972","1978","1982"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12081: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1982 pour leur travail en faveur du désarmement et de la paix mondiale ?",
      answers: ["Rigoberta Menchú Tum","Alfonso García Robles","Desmond Tutu","Grameen Bank"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12082: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Alfonso García Robles a-t-il reçu le Prix Nobel en 1982 ?",
      answers: ["pour son rôle de figure unificatrice dans la campagne non violente contre l’apartheid en Afrique du Sud","pour ses efforts visant à promouvoir la paix à travers la coopération religieuse","pour sa lutte non violente pour la liberté syndicale et les droits des travailleurs en Pologne","pour leur travail en faveur du désarmement et de la paix mondiale"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12083: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Alfonso García Robles a-t-il reçu le Prix Nobel en 1982 ?",
      answers: ["Paix","Physique","Chimie","Littérature"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12084: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Alva Myrdal a-t-il reçu le Prix Nobel de Paix pour leur travail en faveur du désarmement et de la paix mondiale ?",
      answers: ["1980","1960","1982","1978"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12085: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1982 pour leur travail en faveur du désarmement et de la paix mondiale ?",
      answers: ["Lê Đức Thọ","Alva Myrdal","Mère Teresa","Alfonso García Robles"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12086: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Alva Myrdal a-t-il reçu le Prix Nobel en 1982 ?",
      answers: ["pour leur travail visant à interdire et éliminer les mines antipersonnel","pour sa lutte non violente pour la liberté syndicale et les droits des travailleurs en Pologne","pour leur travail en faveur du désarmement et de la paix mondiale","pour leur travail visant à promouvoir une solution pacifique au conflit en Irlande du Nord"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12087: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Alva Myrdal a-t-il reçu le Prix Nobel en 1982 ?",
      answers: ["Chimie","Sciences Économiques","Physiologie ou Médecine","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12088: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Gabriel García Márquez a-t-il reçu le Prix Nobel de Littérature pour ses romans et nouvelles, dans lesquels le fantastique et le réaliste se combinent dans un monde richement composé d’imagination ?",
      answers: ["2007","1982","1976","1977"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12089: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1982 pour ses romans et nouvelles, dans lesquels le fantastique et le réaliste se combinent dans un monde richement composé d’imagination ?",
      answers: ["Gabriel García Márquez","Vicente Aleixandre","Harold Pinter","Wole Soyinka"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12090: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Gabriel García Márquez a-t-il reçu le Prix Nobel en 1982 ?",
      answers: ["pour ses romans et nouvelles, dans lesquels le fantastique et le réaliste se combinent dans un monde richement composé d’imagination","pour la hauteur et l’imagerie visionnaire de sa poésie qui reflète de manière créative les conditions de notre temps","qui, dans une vaste perspective culturelle et avec des accents poétiques, façonne le drame de l’existence","pour une œuvre poétique créative qui illumine la condition humaine dans l’univers et la société actuelle"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12091: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Gabriel García Márquez a-t-il reçu le Prix Nobel en 1982 ?",
      answers: ["Chimie","Sciences Économiques","Littérature","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12092: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Subrahmanyan Chandrasekhar a-t-il reçu le Prix Nobel de Physique pour ses études théoriques des processus physiques importants pour la structure et l’évolution des étoiles ?",
      answers: ["1978","1916","1973","1983"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12093: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1983 pour ses études théoriques des processus physiques importants pour la structure et l’évolution des étoiles ?",
      answers: ["Klaus von Klitzing","Carlo Rubbia","Serge Haroche","Subrahmanyan Chandrasekhar"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12094: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Subrahmanyan Chandrasekhar a-t-il reçu le Prix Nobel en 1983 ?",
      answers: ["pour ses études théoriques des processus physiques importants pour la structure et l’évolution des étoiles","pour ses études théoriques et expérimentales des réactions nucléaires importantes dans la formation des éléments chimiques dans l’univers","pour leurs recherches pionnières sur la diffusion inélastique profonde des électrons sur les protons et les neutrons liés","pour sa démonstration de l’existence de nouveaux éléments radioactifs produits par irradiation neutronique et pour sa découverte connexe des réactions nucléaires provoquées par des neutrons lents"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12095: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Subrahmanyan Chandrasekhar a-t-il reçu le Prix Nobel en 1983 ?",
      answers: ["Paix","Physiologie ou Médecine","Littérature","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12096: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année William A. Fowler a-t-il reçu le Prix Nobel de Physique pour ses études théoriques et expérimentales des réactions nucléaires importantes dans la formation des éléments chimiques dans l’univers ?",
      answers: ["1931","1985","1983","1929"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12097: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1983 pour ses études théoriques et expérimentales des réactions nucléaires importantes dans la formation des éléments chimiques dans l’univers ?",
      answers: ["Klaus von Klitzing","Masatoshi Koshiba","William A. Fowler","Hannes Alfvén"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12098: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison William A. Fowler a-t-il reçu le Prix Nobel en 1983 ?",
      answers: ["pour leurs contributions décisives au grand projet qui a conduit à la découverte des particules W et Z, messagers de l’interaction faible","pour la découverte et l’interprétation de l’effet Cherenkov","pour sa contribution à la théorie quantique de la cohérence optique","pour ses études théoriques et expérimentales des réactions nucléaires importantes dans la formation des éléments chimiques dans l’univers"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12099: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie William A. Fowler a-t-il reçu le Prix Nobel en 1983 ?",
      answers: ["Paix","Physiologie ou Médecine","Physique","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12100: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Henry Taube a-t-il reçu le Prix Nobel de Chimie pour ses travaux sur les mécanismes des réactions de transfert d’électrons, en particulier dans les complexes métalliques ?",
      answers: ["1983","1984","2016","1981"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12101: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1983 pour ses travaux sur les mécanismes des réactions de transfert d’électrons, en particulier dans les complexes métalliques ?",
      answers: ["Henry Taube","Jerome Karle","Bruce Merrifield","Akira Yoshino"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12102: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Henry Taube a-t-il reçu le Prix Nobel en 1983 ?",
      answers: ["pour leur développement et leur utilisation de molécules avec des interactions spécifiques de reconnaissance structurale","pour ses travaux sur les mécanismes des réactions de transfert d’électrons, en particulier dans les complexes métalliques","pour leurs contributions à la dynamique des processus chimiques élémentaires","pour la découverte et le développement de la protéine fluorescente verte (GFP)"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12103: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Henry Taube a-t-il reçu le Prix Nobel en 1983 ?",
      answers: ["Chimie","Physiologie ou Médecine","Sciences Économiques","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12104: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Barbara McClintock a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour sa découverte des éléments génétiques mobiles ?",
      answers: ["1983","1980","2022","1982"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12105: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1983 pour sa découverte des éléments génétiques mobiles ?",
      answers: ["Barbara McClintock","Haldan K. Hartline","Joseph Erlanger","Jean Dausset"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12106: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Barbara McClintock a-t-il reçu le Prix Nobel en 1983 ?",
      answers: ["pour sa découverte des éléments génétiques mobiles","pour leurs découvertes concernant la thérapie par le foie dans les cas d’anémie","pour leurs découvertes des facteurs de croissance","pour leurs découvertes des mécanismes moléculaires contrôlant le rythme circadien"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12107: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Barbara McClintock a-t-il reçu le Prix Nobel en 1983 ?",
      answers: ["Physiologie ou Médecine","Paix","Physique","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12108: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Lech Wałęsa a-t-il reçu le Prix Nobel de Paix pour sa lutte non violente pour la liberté syndicale et les droits des travailleurs en Pologne ?",
      answers: ["1983","2014","2021","1981"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12109: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1983 pour sa lutte non violente pour la liberté syndicale et les droits des travailleurs en Pologne ?",
      answers: ["Dag Hammarskjöld","Anwar Sadat","Lech Wałęsa","Dalaï Lama (Tenzin Gyatso)"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12110: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Lech Wałęsa a-t-il reçu le Prix Nobel en 1983 ?",
      answers: ["pour leur rôle dans la promotion du droit international et de l’arbitrage","pour son rôle de centre du mouvement pacifiste international","pour sa lutte non violente pour la liberté syndicale et les droits des travailleurs en Pologne","pour son travail en faveur des droits humains et de la libération des prisonniers politiques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12111: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Lech Wałęsa a-t-il reçu le Prix Nobel en 1983 ?",
      answers: ["Paix","Physique","Chimie","Sciences Économiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12112: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année William Golding a-t-il reçu le Prix Nobel de Littérature pour ses romans qui, avec la clarté de l’art réaliste et la diversité et l’universalité du mythe, éclairent la condition humaine dans le monde d’aujourd’hui ?",
      answers: ["1930","1983","1980","1976"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12113: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1983 pour ses romans qui, avec la clarté de l’art réaliste et la diversité et l’universalité du mythe, éclairent la condition humaine dans le monde d’aujourd’hui ?",
      answers: ["William Golding","Gabriela Mistral","Derek Walcott","Toni Morrison"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12114: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison William Golding a-t-il reçu le Prix Nobel en 1983 ?",
      answers: ["pour ses réalisations littéraires éclatantes, enracinées dans les traits nationaux et les traditions des peuples indiens d’Amérique latine","auteur de nouveaux départs, d’aventures poétiques et d’extases sensuelles, explorateur d’une humanité au-delà et en deçà de la civilisation régnante","pour ses romans qui, avec la clarté de l’art réaliste et la diversité et l’universalité du mythe, éclairent la condition humaine dans le monde d’aujourd’hui","pour des écrits marqués par une large perspective, une richesse d’idées et une puissance artistique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12115: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie William Golding a-t-il reçu le Prix Nobel en 1983 ?",
      answers: ["Chimie","Physique","Littérature","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12116: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Gerard Debreu a-t-il reçu le Prix Nobel de Sciences Économiques pour avoir incorporé de nouvelles méthodes analytiques dans la théorie économique et pour sa reformulation rigoureuse de la théorie de l’équilibre général ?",
      answers: ["1983","1998","1980","1981"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12117: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1983 pour avoir incorporé de nouvelles méthodes analytiques dans la théorie économique et pour sa reformulation rigoureuse de la théorie de l’équilibre général ?",
      answers: ["Franco Modigliani","Richard Stone","Reinhard Selten","Gerard Debreu"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12118: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Gerard Debreu a-t-il reçu le Prix Nobel en 1983 ?",
      answers: ["pour leurs contributions fondamentales à la théorie économique des incitations sous information asymétrique","pour avoir incorporé de nouvelles méthodes analytiques dans la théorie économique et pour sa reformulation rigoureuse de la théorie de l’équilibre général","pour ses analyses pionnières de l’épargne et des marchés financiers","pour une nouvelle méthode de détermination de la valeur des produits dérivés"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12119: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Gerard Debreu a-t-il reçu le Prix Nobel en 1983 ?",
      answers: ["Physique","Chimie","Paix","Sciences Économiques"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12120: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Carlo Rubbia a-t-il reçu le Prix Nobel de Physique pour leurs contributions décisives au grand projet qui a conduit à la découverte des particules W et Z, messagers de l’interaction faible ?",
      answers: ["1983","2000","1984","1973"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12121: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1984 pour leurs contributions décisives au grand projet qui a conduit à la découverte des particules W et Z, messagers de l’interaction faible ?",
      answers: ["Carlo Rubbia","William A. Fowler","Nicolaas Bloembergen","James W. Cronin"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12122: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Carlo Rubbia a-t-il reçu le Prix Nobel en 1984 ?",
      answers: ["pour leurs contributions décisives au grand projet qui a conduit à la découverte des particules W et Z, messagers de l’interaction faible","pour le développement de la technique du piège à ions","pour la découverte du mécanisme de la brisure spontanée de la symétrie en physique des particules","pour leur conception du microscope à effet tunnel"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12123: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Carlo Rubbia a-t-il reçu le Prix Nobel en 1984 ?",
      answers: ["Paix","Physique","Chimie","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12124: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Simon van der Meer a-t-il reçu le Prix Nobel de Physique pour leurs contributions décisives au grand projet qui a conduit à la découverte des particules W et Z, messagers de l’interaction faible ?",
      answers: ["1986","1980","1988","1984"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12125: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1984 pour leurs contributions décisives au grand projet qui a conduit à la découverte des particules W et Z, messagers de l’interaction faible ?",
      answers: ["Nevill F. Mott","Kai M. Siegbahn","Kenneth G. Wilson","Simon van der Meer"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12126: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Simon van der Meer a-t-il reçu le Prix Nobel en 1984 ?",
      answers: ["pour le développement de méthodes pour refroidir et piéger les atomes avec la lumière laser","pour leurs travaux fondamentaux dans le domaine de l’électronique quantique, qui ont conduit à la construction d’oscillateurs et d’amplificateurs basés sur le principe du maser-laser","en reconnaissance de leurs contributions au développement de la télégraphie sans fil","pour leurs contributions décisives au grand projet qui a conduit à la découverte des particules W et Z, messagers de l’interaction faible"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12127: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Simon van der Meer a-t-il reçu le Prix Nobel en 1984 ?",
      answers: ["Physique","Chimie","Littérature","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12128: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Bruce Merrifield a-t-il reçu le Prix Nobel de Chimie pour son développement de la méthodologie de la synthèse chimique sur phase solide ?",
      answers: ["1982","1953","1984","2009"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12129: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1984 pour son développement de la méthodologie de la synthèse chimique sur phase solide ?",
      answers: ["John B. Fenn","Aaron Klug","Bruce Merrifield","George de Hevesy"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12130: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Bruce Merrifield a-t-il reçu le Prix Nobel en 1984 ?",
      answers: ["pour leurs études sur les structures des protéines globulaires","pour des études sur les récepteurs couplés aux protéines G","pour son développement de la méthodologie de la synthèse chimique sur phase solide","pour la découverte et le développement de la protéine fluorescente verte (GFP)"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12131: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Bruce Merrifield a-t-il reçu le Prix Nobel en 1984 ?",
      answers: ["Physiologie ou Médecine","Chimie","Paix","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12132: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Niels K. Jerne a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour ses théories concernant la spécificité du développement et du contrôle du système immunitaire ?",
      answers: ["1977","1987","1984","1923"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12133: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1984 pour ses théories concernant la spécificité du développement et du contrôle du système immunitaire ?",
      answers: ["César Milstein","Niels K. Jerne","Thomas H. Weller","Santiago Ramón y Cajal"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12134: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Niels K. Jerne a-t-il reçu le Prix Nobel en 1984 ?",
      answers: ["pour ses théories concernant la spécificité du développement et du contrôle du système immunitaire","pour le développement de radio-immunoessais des hormones peptidiques","pour leurs découvertes concernant les structures génétiquement déterminées à la surface des cellules qui régulent les réactions immunitaires","pour sa découverte des cellules dendritiques et de leur rôle dans l’immunité adaptative"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12135: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Niels K. Jerne a-t-il reçu le Prix Nobel en 1984 ?",
      answers: ["Littérature","Chimie","Physique","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12136: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Georges J.F. Köhler a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour la découverte du principe de production d’anticorps monoclonaux ?",
      answers: ["1982","1984","1992","1989"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12137: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1984 pour la découverte du principe de production d’anticorps monoclonaux ?",
      answers: ["Niels K. Jerne","Ragnar Granit","Georges J.F. Köhler","César Milstein"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12138: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Georges J.F. Köhler a-t-il reçu le Prix Nobel en 1984 ?",
      answers: ["pour ses théories concernant la spécificité du développement et du contrôle du système immunitaire","pour leur découverte du cours de la conversion catalytique du glycogène","en reconnaissance de leurs travaux sur la structure du système nerveux","pour la découverte du principe de production d’anticorps monoclonaux"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12139: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Georges J.F. Köhler a-t-il reçu le Prix Nobel en 1984 ?",
      answers: ["Paix","Sciences Économiques","Chimie","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12140: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année César Milstein a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour la découverte du principe de production d’anticorps monoclonaux ?",
      answers: ["1951","1985","1984","1949"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12141: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1984 pour la découverte du principe de production d’anticorps monoclonaux ?",
      answers: ["César Milstein","Jack W. Szostak","Daniel Nathans","Niels K. Jerne"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12142: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison César Milstein a-t-il reçu le Prix Nobel en 1984 ?",
      answers: ["pour ses théories concernant la spécificité du développement et du contrôle du système immunitaire","en reconnaissance de son travail sur l’anaphylaxie","pour leurs découvertes concernant l’imagerie par résonance magnétique","pour la découverte du principe de production d’anticorps monoclonaux"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12143: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie César Milstein a-t-il reçu le Prix Nobel en 1984 ?",
      answers: ["Sciences Économiques","Physiologie ou Médecine","Chimie","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12144: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Desmond Tutu a-t-il reçu le Prix Nobel de Paix pour son rôle de figure unificatrice dans la campagne non violente contre l’apartheid en Afrique du Sud ?",
      answers: ["1991","1988","1984","1949"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12145: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1984 pour son rôle de figure unificatrice dans la campagne non violente contre l’apartheid en Afrique du Sud ?",
      answers: ["Nihon Hidankyo","Desmond Tutu","Oscar Arias Sánchez","Nicholas M. Butler"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12146: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Desmond Tutu a-t-il reçu le Prix Nobel en 1984 ?",
      answers: ["pour leurs contributions à la négociation des accords de Camp David pour la paix au Moyen-Orient","pour leur travail en faveur du désarmement et de la paix mondiale","pour son rôle de figure unificatrice dans la campagne non violente contre l’apartheid en Afrique du Sud","pour sa lutte non violente pour la liberté syndicale et les droits des travailleurs en Pologne"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12147: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Desmond Tutu a-t-il reçu le Prix Nobel en 1984 ?",
      answers: ["Paix","Physique","Sciences Économiques","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12148: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Jaroslav Seifert a-t-il reçu le Prix Nobel de Littérature pour sa poésie qui, avec une fraîcheur, une sensualité et une inventivité riches, donne une image libératrice de l’esprit indomptable et de la polyvalence de l’homme ?",
      answers: ["1974","1983","1999","1984"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12149: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1984 pour sa poésie qui, avec une fraîcheur, une sensualité et une inventivité riches, donne une image libératrice de l’esprit indomptable et de la polyvalence de l’homme ?",
      answers: ["Jaroslav Seifert","Claude Simon","Gabriel García Márquez","Eugenio Montale"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12150: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Jaroslav Seifert a-t-il reçu le Prix Nobel en 1984 ?",
      answers: ["pour sa poésie qui, avec une fraîcheur, une sensualité et une inventivité riches, donne une image libératrice de l’esprit indomptable et de la polyvalence de l’homme","pour sa poésie distinctive qui, avec une grande sensibilité artistique, a interprété les valeurs humaines sous le signe d’une vision de la vie sans illusions","pour une œuvre poétique créative qui illumine la condition humaine dans l’univers et la société actuelle","pour une imagination narrative qui, avec une passion encyclopédique, représente le franchissement des frontières comme une forme de vie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12151: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Jaroslav Seifert a-t-il reçu le Prix Nobel en 1984 ?",
      answers: ["Chimie","Littérature","Physiologie ou Médecine","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12152: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Richard Stone a-t-il reçu le Prix Nobel de Sciences Économiques pour ses contributions fondamentales au développement des systèmes de comptabilité nationale ?",
      answers: ["1991","1985","1963","1984"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12153: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1984 pour ses contributions fondamentales au développement des systèmes de comptabilité nationale ?",
      answers: ["Robert E. Lucas Jr.","Richard H. Thaler","Herbert A. Simon","Richard Stone"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12154: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Richard Stone a-t-il reçu le Prix Nobel en 1984 ?",
      answers: ["pour leurs contributions à la macroéconomie dynamique","pour son analyse des politiques monétaires et fiscales sous différents régimes de taux de change","pour son développement des bases contractuelles et constitutionnelles de la théorie des décisions économiques et politiques","pour ses contributions fondamentales au développement des systèmes de comptabilité nationale"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12155: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Richard Stone a-t-il reçu le Prix Nobel en 1984 ?",
      answers: ["Sciences Économiques","Paix","Physique","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12156: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Klaus von Klitzing a-t-il reçu le Prix Nobel de Physique pour la découverte de l’effet Hall quantique ?",
      answers: ["1931","1985","1993","1989"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12157: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1985 pour la découverte de l’effet Hall quantique ?",
      answers: ["Ben R. Mottelson","Carlo Rubbia","Klaus von Klitzing","Samuel C.C. Ting"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12158: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Klaus von Klitzing a-t-il reçu le Prix Nobel en 1985 ?",
      answers: ["pour leurs contributions décisives au grand projet qui a conduit à la découverte des particules W et Z, messagers de l’interaction faible","pour leur découverte de la superfluidité dans l’hélium-3","pour la découverte de l’effet Hall quantique","pour leur découverte de l’antiproton"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12159: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Klaus von Klitzing a-t-il reçu le Prix Nobel en 1985 ?",
      answers: ["Physique","Physiologie ou Médecine","Sciences Économiques","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12160: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Herbert A. Hauptman a-t-il reçu le Prix Nobel de Chimie pour leurs réalisations exceptionnelles dans le développement de méthodes directes pour la détermination des structures cristallines ?",
      answers: ["1985","1984","1923","1986"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12161: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1985 pour leurs réalisations exceptionnelles dans le développement de méthodes directes pour la détermination des structures cristallines ?",
      answers: ["Dudley R. Herschbach","Morten Meldal","Herbert A. Hauptman","Venkatraman Ramakrishnan"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12162: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Herbert A. Hauptman a-t-il reçu le Prix Nobel en 1985 ?",
      answers: ["pour ses contributions à la thermodynamique hors équilibre, en particulier la théorie des structures dissipatives","pour ses travaux sur les mécanismes des réactions de transfert d’électrons, en particulier dans les complexes métalliques","pour sa contribution à la chimie des carbocations","pour leurs réalisations exceptionnelles dans le développement de méthodes directes pour la détermination des structures cristallines"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12163: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Herbert A. Hauptman a-t-il reçu le Prix Nobel en 1985 ?",
      answers: ["Sciences Économiques","Paix","Chimie","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12164: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Jerome Karle a-t-il reçu le Prix Nobel de Chimie pour leurs réalisations exceptionnelles dans le développement de méthodes directes pour la détermination des structures cristallines ?",
      answers: ["1953","1981","1985","1988"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12165: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1985 pour leurs réalisations exceptionnelles dans le développement de méthodes directes pour la détermination des structures cristallines ?",
      answers: ["Irène Joliot-Curie","Yuan T. Lee","Jerome Karle","Donald J. Cram"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12166: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Jerome Karle a-t-il reçu le Prix Nobel en 1985 ?",
      answers: ["pour ses contributions fondamentales à l’établissement de la mutagenèse dirigée par oligonucléotides","pour la technique de phage display des peptides et des anticorps","pour leur développement et leur utilisation de molécules avec des interactions spécifiques de reconnaissance structurale","pour leurs réalisations exceptionnelles dans le développement de méthodes directes pour la détermination des structures cristallines"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12167: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Jerome Karle a-t-il reçu le Prix Nobel en 1985 ?",
      answers: ["Physique","Chimie","Paix","Littérature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12168: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Joseph L. Goldstein a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant la régulation du métabolisme du cholestérol ?",
      answers: ["1984","1970","1951","1985"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12169: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1985 pour leurs découvertes concernant la régulation du métabolisme du cholestérol ?",
      answers: ["Allan M. Cormack","Sir Peter Mansfield","Joseph L. Goldstein","David H. Hubel"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12170: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Joseph L. Goldstein a-t-il reçu le Prix Nobel en 1985 ?",
      answers: ["pour leurs découvertes des facteurs de croissance","pour leurs découvertes concernant les transplantations d’organes et de cellules dans le traitement des maladies","pour la découverte de la manière dont les chromosomes sont protégés par les télomères et l’enzyme télomérase","pour leurs découvertes concernant la régulation du métabolisme du cholestérol"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12171: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Joseph L. Goldstein a-t-il reçu le Prix Nobel en 1985 ?",
      answers: ["Sciences Économiques","Littérature","Paix","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12172: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Michael S. Brown a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant la régulation du métabolisme du cholestérol ?",
      answers: ["2015","1977","1988","1985"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12173: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1985 pour leurs découvertes concernant la régulation du métabolisme du cholestérol ?",
      answers: ["Michael S. Brown","David H. Hubel","Joseph L. Goldstein","Edwin G. Krebs"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12174: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Michael S. Brown a-t-il reçu le Prix Nobel en 1985 ?",
      answers: ["pour leurs découvertes concernant les transmetteurs humoraux dans les terminaisons nerveuses et le mécanisme de leur stockage, libération et inactivation","pour leurs découvertes concernant la régulation du métabolisme du cholestérol","pour leurs découvertes concernant l’imagerie par résonance magnétique","pour sa découverte des papillomavirus humains causant le cancer du col de l’utérus"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12175: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Michael S. Brown a-t-il reçu le Prix Nobel en 1985 ?",
      answers: ["Sciences Économiques","Chimie","Physiologie ou Médecine","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12176: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Médecins Internationaux pour la Prévention de la Guerre Nucléaire a-t-il reçu le Prix Nobel de Paix pour leur travail visant à informer le public et à prévenir la guerre nucléaire ?",
      answers: ["1985","2022","1984","2018"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12177: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1985 pour leur travail visant à informer le public et à prévenir la guerre nucléaire ?",
      answers: ["Carlos Filipe Ximenes Belo","Médecins Internationaux pour la Prévention de la Guerre Nucléaire","Alfonso García Robles","Aung San Suu Kyi"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12178: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Médecins Internationaux pour la Prévention de la Guerre Nucléaire a-t-il reçu le Prix Nobel en 1985 ?",
      answers: ["pour leur travail visant à informer le public et à prévenir la guerre nucléaire","pour son travail humanitaire en faveur des réfugiés dans le monde entier","pour son message de paix, d’expiation et de dignité humaine en tant que témoin de l’Holocauste","pour leur contribution à la réduction des tensions et à la promotion de la paix dans le monde"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12179: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Médecins Internationaux pour la Prévention de la Guerre Nucléaire a-t-il reçu le Prix Nobel en 1985 ?",
      answers: ["Chimie","Paix","Physique","Littérature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12180: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Claude Simon a-t-il reçu le Prix Nobel de Littérature qui, dans ses romans, combine la créativité du poète et du peintre avec une profonde conscience du temps dans la représentation de la condition humaine ?",
      answers: ["1985","1924","1990","1974"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12181: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1985 qui, dans ses romans, combine la créativité du poète et du peintre avec une profonde conscience du temps dans la représentation de la condition humaine ?",
      answers: ["Wole Soyinka","Claude Simon","Camilo José Cela","Czesław Miłosz"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12182: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Claude Simon a-t-il reçu le Prix Nobel en 1985 ?",
      answers: ["qui, dans une vaste perspective culturelle et avec des accents poétiques, façonne le drame de l’existence","qui, dans ses romans, combine la créativité du poète et du peintre avec une profonde conscience du temps dans la représentation de la condition humaine","dont les contes burlesques et noirs dépeignent le visage oublié de l’histoire","qui, dans des romans caractérisés par une force visionnaire et une portée poétique, donne vie à un aspect essentiel de la réalité américaine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12183: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Claude Simon a-t-il reçu le Prix Nobel en 1985 ?",
      answers: ["Littérature","Physique","Chimie","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12184: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Franco Modigliani a-t-il reçu le Prix Nobel de Sciences Économiques pour ses analyses pionnières de l’épargne et des marchés financiers ?",
      answers: ["1987","1985","1984","1974"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12185: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1985 pour ses analyses pionnières de l’épargne et des marchés financiers ?",
      answers: ["Gary S. Becker","Franco Modigliani","Lawrence R. Klein","Christopher A. Sims"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12186: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Franco Modigliani a-t-il reçu le Prix Nobel en 1985 ?",
      answers: ["pour ses analyses pionnières de l’épargne et des marchés financiers","pour son développement des bases contractuelles et constitutionnelles de la théorie des décisions économiques et politiques","pour ses contributions fondamentales au développement des systèmes de comptabilité nationale","pour ses réalisations dans les domaines de l’analyse de la consommation, de l’histoire et de la théorie monétaire et pour sa démonstration de la complexité de la politique de stabilisation"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12187: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Franco Modigliani a-t-il reçu le Prix Nobel en 1985 ?",
      answers: ["Physiologie ou Médecine","Paix","Physique","Sciences Économiques"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12188: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Ernst Ruska a-t-il reçu le Prix Nobel de Physique pour son travail fondamental sur l’optique électronique et la conception du premier microscope électronique ?",
      answers: ["1985","1986","1993","1983"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12189: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1986 pour son travail fondamental sur l’optique électronique et la conception du premier microscope électronique ?",
      answers: ["Ernst Ruska","K. Alex Müller","Melvin Schwartz","Arthur H. Compton"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12190: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Ernst Ruska a-t-il reçu le Prix Nobel en 1986 ?",
      answers: ["pour son travail fondamental sur l’optique électronique et la conception du premier microscope électronique","pour leur conception du microscope à effet tunnel","pour la découverte de la liberté asymptotique dans la théorie de l’interaction forte","pour leur contribution au développement de la spectroscopie laser"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12191: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Ernst Ruska a-t-il reçu le Prix Nobel en 1986 ?",
      answers: ["Physiologie ou Médecine","Paix","Littérature","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12192: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Gerd Binnig a-t-il reçu le Prix Nobel de Physique pour leur conception du microscope à effet tunnel ?",
      answers: ["2000","1956","1993","1986"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12193: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1986 pour leur conception du microscope à effet tunnel ?",
      answers: ["Isidor I. Rabi","Carlo Rubbia","Gerd Binnig","K. Alex Müller"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12194: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Gerd Binnig a-t-il reçu le Prix Nobel en 1986 ?",
      answers: ["pour leurs contributions fondamentales à l’électrodynamique quantique, avec des conséquences profondes pour la physique des particules élémentaires","en reconnaissance des services extraordinaires qu’ils ont rendus conjointement par leurs recherches sur les phénomènes de rayonnement découverts par le professeur Henri Becquerel","pour la méthode du faisceau de neutrinos et la démonstration de la structure en doublet des leptons par la découverte du neutrino muonique","pour leur conception du microscope à effet tunnel"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12195: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Gerd Binnig a-t-il reçu le Prix Nobel en 1986 ?",
      answers: ["Chimie","Paix","Physique","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12196: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Heinrich Rohrer a-t-il reçu le Prix Nobel de Physique pour leur conception du microscope à effet tunnel ?",
      answers: ["1908","1982","1987","1986"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12197: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1986 pour leur conception du microscope à effet tunnel ?",
      answers: ["Heinrich Rohrer","Felix Bloch","Simon van der Meer","Robert W. Wilson"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12198: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Heinrich Rohrer a-t-il reçu le Prix Nobel en 1986 ?",
      answers: ["pour leurs recherches pionnières sur la diffusion inélastique profonde des électrons sur les protons et les neutrons liés","pour la découverte des violations de principes fondamentaux de symétrie dans la désintégration des mésons K neutres","pour leurs contributions pionnières à l’astrophysique, notamment la détection des neutrinos cosmiques","pour leur conception du microscope à effet tunnel"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12199: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Heinrich Rohrer a-t-il reçu le Prix Nobel en 1986 ?",
      answers: ["Physique","Physiologie ou Médecine","Chimie","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12200: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Dudley R. Herschbach a-t-il reçu le Prix Nobel de Chimie pour leurs contributions à la dynamique des processus chimiques élémentaires ?",
      answers: ["2015","1986","1981","1985"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12201: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1986 pour leurs contributions à la dynamique des processus chimiques élémentaires ?",
      answers: ["Charles J. Pedersen","Stanford Moore","Dudley R. Herschbach","Jerome Karle"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12202: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Dudley R. Herschbach a-t-il reçu le Prix Nobel en 1986 ?",
      answers: ["pour ses contributions fondamentales à l’établissement de la mutagenèse dirigée par oligonucléotides","pour la détermination de la structure tridimensionnelle d’un centre réactionnel photosynthétique","pour leurs contributions à la dynamique des processus chimiques élémentaires","pour leurs contributions à la compréhension de la connexion entre la structure chimique et l’activité catalytique du centre actif de la molécule de ribonucléase"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12203: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Dudley R. Herschbach a-t-il reçu le Prix Nobel en 1986 ?",
      answers: ["Physique","Sciences Économiques","Littérature","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12204: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Yuan T. Lee a-t-il reçu le Prix Nobel de Chimie pour leurs contributions à la dynamique des processus chimiques élémentaires ?",
      answers: ["1978","1975","1986","1985"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12205: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1986 pour leurs contributions à la dynamique des processus chimiques élémentaires ?",
      answers: ["Dudley R. Herschbach","Yuan T. Lee","Bruce Merrifield","Mario J. Molina"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12206: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Yuan T. Lee a-t-il reçu le Prix Nobel en 1986 ?",
      answers: ["pour son développement de la microscopie électronique cristallographique et son élucidation structurale des complexes nucléoprotéiques biologiquement importants","pour le développement de réactions de couplage catalysées par le palladium en synthèse organique","pour leurs contributions à la dynamique des processus chimiques élémentaires","pour leurs réalisations exceptionnelles dans le développement de méthodes directes pour la détermination des structures cristallines"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12207: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Yuan T. Lee a-t-il reçu le Prix Nobel en 1986 ?",
      answers: ["Sciences Économiques","Paix","Chimie","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12208: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année John C. Polanyi a-t-il reçu le Prix Nobel de Chimie pour leurs contributions à la dynamique des processus chimiques élémentaires ?",
      answers: ["1983","1980","1985","1986"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12209: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1986 pour leurs contributions à la dynamique des processus chimiques élémentaires ?",
      answers: ["Rudolph A. Marcus","Hans Fischer","Herbert A. Hauptman","John C. Polanyi"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12210: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison John C. Polanyi a-t-il reçu le Prix Nobel en 1986 ?",
      answers: ["pour le développement de réactions de couplage catalysées par le palladium en synthèse organique","pour leurs réalisations exceptionnelles dans le développement de méthodes directes pour la détermination des structures cristallines","pour sa découverte et le développement de la méthode d’analyse polarographique","pour leurs contributions à la dynamique des processus chimiques élémentaires"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12211: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie John C. Polanyi a-t-il reçu le Prix Nobel en 1986 ?",
      answers: ["Littérature","Paix","Chimie","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12212: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Stanley Cohen a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes des facteurs de croissance ?",
      answers: ["1987","1982","1990","1986"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12213: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1986 pour leurs découvertes des facteurs de croissance ?",
      answers: ["Hans Spemann","Sir Peter Mansfield","Rita Levi-Montalcini","Stanley Cohen"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12214: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Stanley Cohen a-t-il reçu le Prix Nobel en 1986 ?",
      answers: ["pour leurs découvertes concernant les transplantations d’organes et de cellules dans le traitement des maladies","pour leurs découvertes de principes importants pour le traitement médicamenteux","pour leurs découvertes des facteurs de croissance","pour leurs découvertes concernant les prostaglandines et les substances biologiquement actives apparentées"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12215: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Stanley Cohen a-t-il reçu le Prix Nobel en 1986 ?",
      answers: ["Paix","Chimie","Sciences Économiques","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12216: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Rita Levi-Montalcini a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes des facteurs de croissance ?",
      answers: ["2020","2000","1986","2002"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12217: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1986 pour leurs découvertes des facteurs de croissance ?",
      answers: ["Louis J. Ignarro","Robert W. Holley","Susumu Tonegawa","Rita Levi-Montalcini"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12218: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Rita Levi-Montalcini a-t-il reçu le Prix Nobel en 1986 ?",
      answers: ["pour leurs découvertes de principes importants pour le traitement médicamenteux","pour leurs découvertes concernant le traitement de l’information dans le système visuel","pour leurs découvertes des facteurs de croissance","pour sa découverte de l’effet organisateur dans le développement embryonnaire"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12219: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Rita Levi-Montalcini a-t-il reçu le Prix Nobel en 1986 ?",
      answers: ["Physiologie ou Médecine","Littérature","Chimie","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12220: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Elie Wiesel a-t-il reçu le Prix Nobel de Paix pour son message de paix, d’expiation et de dignité humaine en tant que témoin de l’Holocauste ?",
      answers: ["1967","1951","1953","1986"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12221: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1986 pour son message de paix, d’expiation et de dignité humaine en tant que témoin de l’Holocauste ?",
      answers: ["Bureau International du Travail (BIT)","Aung San Suu Kyi","Elie Wiesel","Forces de Maintien de la Paix des Nations Unies"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12222: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Elie Wiesel a-t-il reçu le Prix Nobel en 1986 ?",
      answers: ["pour leur travail en faveur du désarmement et de la paix mondiale","pour leurs contributions à la négociation des accords de Camp David pour la paix au Moyen-Orient","pour sa lutte non violente pour la liberté syndicale et les droits des travailleurs en Pologne","pour son message de paix, d’expiation et de dignité humaine en tant que témoin de l’Holocauste"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12223: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Elie Wiesel a-t-il reçu le Prix Nobel en 1986 ?",
      answers: ["Paix","Physiologie ou Médecine","Physique","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12224: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Wole Soyinka a-t-il reçu le Prix Nobel de Littérature qui, dans une vaste perspective culturelle et avec des accents poétiques, façonne le drame de l’existence ?",
      answers: ["1986","1975","1917","1989"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12225: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1986 qui, dans une vaste perspective culturelle et avec des accents poétiques, façonne le drame de l’existence ?",
      answers: ["Wole Soyinka","Günter Grass","Nadine Gordimer","Dario Fo"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12226: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Wole Soyinka a-t-il reçu le Prix Nobel en 1986 ?",
      answers: ["qui, dans une vaste perspective culturelle et avec des accents poétiques, façonne le drame de l’existence","qui, à travers des œuvres riches en nuances, a donné forme à un art narratif arabe qui s’applique à toute l’humanité","qui, avec une force poétique, crée un monde imaginaire où la vie et le mythe se condensent pour former une image déconcertante de la condition humaine actuelle","pour une œuvre poétique créative qui illumine la condition humaine dans l’univers et la société actuelle"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12227: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Wole Soyinka a-t-il reçu le Prix Nobel en 1986 ?",
      answers: ["Littérature","Sciences Économiques","Paix","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12228: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année James M. Buchanan Jr. a-t-il reçu le Prix Nobel de Sciences Économiques pour son développement des bases contractuelles et constitutionnelles de la théorie des décisions économiques et politiques ?",
      answers: ["1986","1912","1979","1952"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12229: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1986 pour son développement des bases contractuelles et constitutionnelles de la théorie des décisions économiques et politiques ?",
      answers: ["Lawrence R. Klein","William Vickrey","James M. Buchanan Jr.","Sir W. Arthur Lewis"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12230: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison James M. Buchanan Jr. a-t-il reçu le Prix Nobel en 1986 ?",
      answers: ["pour ses contributions fondamentales au développement des systèmes de comptabilité nationale","pour son développement des bases contractuelles et constitutionnelles de la théorie des décisions économiques et politiques","pour son analyse de la gouvernance économique, notamment des limites des entreprises","pour ses contributions pionnières à la théorie des marchés et à l’utilisation efficace des ressources"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12231: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie James M. Buchanan Jr. a-t-il reçu le Prix Nobel en 1986 ?",
      answers: ["Physique","Physiologie ou Médecine","Sciences Économiques","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12232: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année J. Georg Bednorz a-t-il reçu le Prix Nobel de Physique pour leur percée importante dans la découverte de la supraconductivité dans les matériaux céramiques ?",
      answers: ["1982","1956","1987","1995"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12233: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1987 pour leur percée importante dans la découverte de la supraconductivité dans les matériaux céramiques ?",
      answers: ["J. Georg Bednorz","Douglas D. Osheroff","Gerd Binnig","Georges Charpak"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12234: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison J. Georg Bednorz a-t-il reçu le Prix Nobel en 1987 ?",
      answers: ["pour ses contributions à la théorie des réactions nucléaires, en particulier ses découvertes concernant la production d’énergie dans les étoiles","pour leurs recherches pionnières en astrophysique radio : Ryle pour ses observations et inventions, notamment la technique de synthèse d’ouverture","pour leur percée importante dans la découverte de la supraconductivité dans les matériaux céramiques","pour la découverte de la connexion entre le mouvement collectif et le mouvement des particules dans les noyaux atomiques et le développement de la théorie de la structure nucléaire basée sur cette connexion"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12235: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie J. Georg Bednorz a-t-il reçu le Prix Nobel en 1987 ?",
      answers: ["Chimie","Physique","Paix","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12236: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année K. Alex Müller a-t-il reçu le Prix Nobel de Physique pour leur percée importante dans la découverte de la supraconductivité dans les matériaux céramiques ?",
      answers: ["2008","1987","1988","1983"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12237: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1987 pour leur percée importante dans la découverte de la supraconductivité dans les matériaux céramiques ?",
      answers: ["Klaus von Klitzing","Rudolf Mössbauer","Philip W. Anderson","K. Alex Müller"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12238: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison K. Alex Müller a-t-il reçu le Prix Nobel en 1987 ?",
      answers: ["pour son développement de la méthode de la chambre à brouillard de Wilson et ses découvertes dans les domaines de la physique nucléaire et des rayons cosmiques","pour la méthode du faisceau de neutrinos et la démonstration de la structure en doublet des leptons par la découverte du neutrino muonique","pour leur conception du microscope à effet tunnel","pour leur percée importante dans la découverte de la supraconductivité dans les matériaux céramiques"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12239: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie K. Alex Müller a-t-il reçu le Prix Nobel en 1987 ?",
      answers: ["Chimie","Physiologie ou Médecine","Physique","Sciences Économiques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12240: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Donald J. Cram a-t-il reçu le Prix Nobel de Chimie pour leur développement et leur utilisation de molécules avec des interactions spécifiques de reconnaissance structurale ?",
      answers: ["1987","1978","1998","1986"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12241: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1987 pour leur développement et leur utilisation de molécules avec des interactions spécifiques de reconnaissance structurale ?",
      answers: ["Geoffrey Wilkinson","Donald J. Cram","Jean-Marie Lehn","Aaron Klug"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12242: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Donald J. Cram a-t-il reçu le Prix Nobel en 1987 ?",
      answers: ["pour sa découverte des nucléotides sucrés et leur rôle dans la biosynthèse des glucides","pour la détermination de la structure tridimensionnelle d’un centre réactionnel photosynthétique","pour leurs contributions à la dynamique des processus chimiques élémentaires","pour leur développement et leur utilisation de molécules avec des interactions spécifiques de reconnaissance structurale"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12243: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Donald J. Cram a-t-il reçu le Prix Nobel en 1987 ?",
      answers: ["Paix","Physiologie ou Médecine","Physique","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12244: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Jean-Marie Lehn a-t-il reçu le Prix Nobel de Chimie pour leur développement et leur utilisation de molécules avec des interactions spécifiques de reconnaissance structurale ?",
      answers: ["2003","2014","1983","1987"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12245: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1987 pour leur développement et leur utilisation de molécules avec des interactions spécifiques de reconnaissance structurale ?",
      answers: ["Yuan T. Lee","John C. Polanyi","Jean-Marie Lehn","Michael Smith"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12246: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Jean-Marie Lehn a-t-il reçu le Prix Nobel en 1987 ?",
      answers: ["pour la découverte et le développement des polymères conducteurs","pour leurs réalisations exceptionnelles dans le développement de méthodes directes pour la détermination des structures cristallines","pour leur développement et leur utilisation de molécules avec des interactions spécifiques de reconnaissance structurale","pour la détermination de la structure tridimensionnelle d’un centre réactionnel photosynthétique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12247: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Jean-Marie Lehn a-t-il reçu le Prix Nobel en 1987 ?",
      answers: ["Chimie","Paix","Physique","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12248: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Charles J. Pedersen a-t-il reçu le Prix Nobel de Chimie pour leur développement et leur utilisation de molécules avec des interactions spécifiques de reconnaissance structurale ?",
      answers: ["1982","1987","1921","2011"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12249: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1987 pour leur développement et leur utilisation de molécules avec des interactions spécifiques de reconnaissance structurale ?",
      answers: ["Dudley R. Herschbach","Donald J. Cram","Charles J. Pedersen","Yuan T. Lee"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12250: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Charles J. Pedersen a-t-il reçu le Prix Nobel en 1987 ?",
      answers: ["pour le développement de la méthode de métathèse en synthèse organique","pour leurs contributions à la dynamique des processus chimiques élémentaires","pour leur développement et leur utilisation de molécules avec des interactions spécifiques de reconnaissance structurale","pour la détermination de la structure tridimensionnelle d’un centre réactionnel photosynthétique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12251: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Charles J. Pedersen a-t-il reçu le Prix Nobel en 1987 ?",
      answers: ["Physique","Paix","Chimie","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12252: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Susumu Tonegawa a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour sa découverte du principe génétique de la génération de la diversité des anticorps ?",
      answers: ["2010","1986","1993","1987"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12253: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1987 pour sa découverte du principe génétique de la génération de la diversité des anticorps ?",
      answers: ["Rita Levi-Montalcini","Rolf M. Zinkernagel","Susumu Tonegawa","Baruj Benacerraf"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12254: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Susumu Tonegawa a-t-il reçu le Prix Nobel en 1987 ?",
      answers: ["pour la découverte du rôle joué par le sinus et les mécanismes aortiques dans la régulation de la respiration","pour leurs découvertes de principes importants pour le traitement médicamenteux","pour sa découverte du principe génétique de la génération de la diversité des anticorps","pour leurs découvertes concernant l’organisation et l’élicitation des schémas de comportement individuels et sociaux"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12255: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Susumu Tonegawa a-t-il reçu le Prix Nobel en 1987 ?",
      answers: ["Littérature","Chimie","Physiologie ou Médecine","Paix"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12256: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Oscar Arias Sánchez a-t-il reçu le Prix Nobel de Paix pour son travail en faveur de la paix en Amérique centrale ?",
      answers: ["1914","1987","1988","2014"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12257: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1987 pour son travail en faveur de la paix en Amérique centrale ?",
      answers: ["Forces de Maintien de la Paix des Nations Unies","Rigoberta Menchú Tum","Oscar Arias Sánchez","Organisation pour l’Interdiction des Armes Chimiques (OIAC)"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12258: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Oscar Arias Sánchez a-t-il reçu le Prix Nobel en 1987 ?",
      answers: ["pour sa lutte non violente pour les droits civils des Afro-Américains","pour son travail en faveur de la paix en Amérique centrale","pour leurs efforts visant à créer la paix au Moyen-Orient","pour son message de paix, d’expiation et de dignité humaine en tant que témoin de l’Holocauste"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12259: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Oscar Arias Sánchez a-t-il reçu le Prix Nobel en 1987 ?",
      answers: ["Physique","Paix","Chimie","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12260: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Joseph Brodsky a-t-il reçu le Prix Nobel de Littérature pour une œuvre littéraire empreinte de clarté de pensée et d’intensité poétique ?",
      answers: ["1970","1987","1984","1986"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12261: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1987 pour une œuvre littéraire empreinte de clarté de pensée et d’intensité poétique ?",
      answers: ["Wole Soyinka","Claude Simon","Tomas Tranströmer","Joseph Brodsky"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12262: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Joseph Brodsky a-t-il reçu le Prix Nobel en 1987 ?",
      answers: ["qui, dans une vaste perspective culturelle et avec des accents poétiques, façonne le drame de l’existence","pour une œuvre littéraire empreinte de clarté de pensée et d’intensité poétique","pour une prose riche et intense qui, avec une compassion contenue, forme une vision provocante de la vulnérabilité humaine","pour ses écrits qui, par leur combinaison d’une large perspective sur son temps et une habileté sensible dans la caractérisation, ont contribué au renouveau de la littérature allemande"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12263: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Joseph Brodsky a-t-il reçu le Prix Nobel en 1987 ?",
      answers: ["Sciences Économiques","Physique","Littérature","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12264: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Robert M. Solow a-t-il reçu le Prix Nobel de Sciences Économiques pour ses contributions à la théorie de la croissance économique ?",
      answers: ["1999","1986","1990","1987"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12265: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1987 pour ses contributions à la théorie de la croissance économique ?",
      answers: ["Robert M. Solow","Franco Modigliani","Harry M. Markowitz","Myron S. Scholes"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12266: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Robert M. Solow a-t-il reçu le Prix Nobel en 1987 ?",
      answers: ["pour son développement des bases contractuelles et constitutionnelles de la théorie des décisions économiques et politiques","pour ses analyses pionnières de l’épargne et des marchés financiers","pour avoir intégré des perspectives psychologiques dans l’analyse économique, notamment sur le comportement humain sous incertitude","pour ses contributions à la théorie de la croissance économique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12267: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Robert M. Solow a-t-il reçu le Prix Nobel en 1987 ?",
      answers: ["Physiologie ou Médecine","Sciences Économiques","Littérature","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12268: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Leon M. Lederman a-t-il reçu le Prix Nobel de Physique pour la méthode du faisceau de neutrinos et la démonstration de la structure en doublet des leptons par la découverte du neutrino muonique ?",
      answers: ["1968","1911","1994","1988"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12269: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1988 pour la méthode du faisceau de neutrinos et la démonstration de la structure en doublet des leptons par la découverte du neutrino muonique ?",
      answers: ["Martinus J. G. Veltman","Leon M. Lederman","Jack S. Kilby","Steven Chu"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12270: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Leon M. Lederman a-t-il reçu le Prix Nobel en 1988 ?",
      answers: ["pour leur théorie développée conjointement de la supraconductivité, généralement appelée la théorie BCS","pour la méthode du faisceau de neutrinos et la démonstration de la structure en doublet des leptons par la découverte du neutrino muonique","pour le développement de méthodes pour refroidir et piéger les atomes avec la lumière laser","pour leur découverte du rayonnement de fond cosmique micro-ondes"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12271: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Leon M. Lederman a-t-il reçu le Prix Nobel en 1988 ?",
      answers: ["Sciences Économiques","Physique","Physiologie ou Médecine","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12272: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Melvin Schwartz a-t-il reçu le Prix Nobel de Physique pour la méthode du faisceau de neutrinos et la démonstration de la structure en doublet des leptons par la découverte du neutrino muonique ?",
      answers: ["1988","1982","1989","1984"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12273: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1988 pour la méthode du faisceau de neutrinos et la démonstration de la structure en doublet des leptons par la découverte du neutrino muonique ?",
      answers: ["Sheldon Glashow","Melvin Schwartz","John H. Van Vleck","François Englert"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12274: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Melvin Schwartz a-t-il reçu le Prix Nobel en 1988 ?",
      answers: ["pour leur percée importante dans la découverte de la supraconductivité dans les matériaux céramiques","pour leur contribution au développement de la spectroscopie laser","pour ses contributions et découvertes concernant la classification des particules élémentaires et leurs interactions","pour la méthode du faisceau de neutrinos et la démonstration de la structure en doublet des leptons par la découverte du neutrino muonique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12275: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Melvin Schwartz a-t-il reçu le Prix Nobel en 1988 ?",
      answers: ["Physique","Littérature","Sciences Économiques","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12276: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Jack Steinberger a-t-il reçu le Prix Nobel de Physique pour la méthode du faisceau de neutrinos et la démonstration de la structure en doublet des leptons par la découverte du neutrino muonique ?",
      answers: ["1988","1913","1991","1974"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12277: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1988 pour la méthode du faisceau de neutrinos et la démonstration de la structure en doublet des leptons par la découverte du neutrino muonique ?",
      answers: ["Norman F. Ramsey","Jack Steinberger","Anton Zeilinger","Martinus J. G. Veltman"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12278: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Jack Steinberger a-t-il reçu le Prix Nobel en 1988 ?",
      answers: ["pour leurs recherches pionnières en astrophysique radio : Ryle pour ses observations et inventions, notamment la technique de synthèse d’ouverture","pour la méthode du faisceau de neutrinos et la démonstration de la structure en doublet des leptons par la découverte du neutrino muonique","pour leur percée importante dans la découverte de la supraconductivité dans les matériaux céramiques","pour le développement de la technique du piège à ions"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12279: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Jack Steinberger a-t-il reçu le Prix Nobel en 1988 ?",
      answers: ["Physiologie ou Médecine","Paix","Physique","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12280: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Johann Deisenhofer a-t-il reçu le Prix Nobel de Chimie pour la détermination de la structure tridimensionnelle d’un centre réactionnel photosynthétique ?",
      answers: ["1949","1979","1981","1988"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12281: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1988 pour la détermination de la structure tridimensionnelle d’un centre réactionnel photosynthétique ?",
      answers: ["Roald Hoffmann","Melvin Calvin","Johann Deisenhofer","Aziz Sancar"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12282: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Johann Deisenhofer a-t-il reçu le Prix Nobel en 1988 ?",
      answers: ["pour son développement de la théorie de la fonctionnelle de la densité","pour la détermination de la structure tridimensionnelle d’un centre réactionnel photosynthétique","pour la découverte et la synthèse des points quantiques","pour leur élucidation du mécanisme enzymatique sous-jacent à la synthèse de l’adénosine triphosphate (ATP)"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12283: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Johann Deisenhofer a-t-il reçu le Prix Nobel en 1988 ?",
      answers: ["Physique","Physiologie ou Médecine","Chimie","Sciences Économiques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12284: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Robert Huber a-t-il reçu le Prix Nobel de Chimie pour la détermination de la structure tridimensionnelle d’un centre réactionnel photosynthétique ?",
      answers: ["1999","1972","1981","1988"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12285: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1988 pour la détermination de la structure tridimensionnelle d’un centre réactionnel photosynthétique ?",
      answers: ["John C. Polanyi","Hartmut Michel","Sidney Altman","Robert Huber"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12286: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Robert Huber a-t-il reçu le Prix Nobel en 1988 ?",
      answers: ["pour leurs travaux sur la chimie de l’atmosphère, notamment concernant la formation et la décomposition de l’ozone","pour leurs contributions à la dynamique des processus chimiques élémentaires","pour la détermination de la structure tridimensionnelle d’un centre réactionnel photosynthétique","pour leur élucidation du mécanisme enzymatique sous-jacent à la synthèse de l’adénosine triphosphate (ATP)"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12287: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Robert Huber a-t-il reçu le Prix Nobel en 1988 ?",
      answers: ["Physique","Physiologie ou Médecine","Littérature","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12288: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Hartmut Michel a-t-il reçu le Prix Nobel de Chimie pour la détermination de la structure tridimensionnelle d’un centre réactionnel photosynthétique ?",
      answers: ["1988","1989","1984","1922"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12289: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1988 pour la détermination de la structure tridimensionnelle d’un centre réactionnel photosynthétique ?",
      answers: ["Sidney Altman","Hartmut Michel","Frederick Sanger","Benjamin List"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12290: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Hartmut Michel a-t-il reçu le Prix Nobel en 1988 ?",
      answers: ["pour ses recherches sur les acides biliaires et les substances apparentées","pour la première découverte d’une enzyme transportant des ions, la Na+, K+-ATPase","pour la détermination de la structure tridimensionnelle d’un centre réactionnel photosynthétique","pour son développement de la microscopie électronique cristallographique et son élucidation structurale des complexes nucléoprotéiques biologiquement importants"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12291: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Hartmut Michel a-t-il reçu le Prix Nobel en 1988 ?",
      answers: ["Littérature","Chimie","Physiologie ou Médecine","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12292: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Sir James W. Black a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes de principes importants pour le traitement médicamenteux ?",
      answers: ["1988","1998","1991","1989"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12293: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1988 pour leurs découvertes de principes importants pour le traitement médicamenteux ?",
      answers: ["Sir James W. Black","Sir Henry H. Dale","Bert Sakmann","Oliver Smithies"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12294: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Sir James W. Black a-t-il reçu le Prix Nobel en 1988 ?",
      answers: ["pour ses découvertes sur les génomes des hominidés éteints et l’évolution humaine","pour leurs découvertes de principes importants pour le traitement médicamenteux","pour ses découvertes sur le mécanisme physique de la stimulation dans la cochlée","pour ses découvertes relatives à l’immunité"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12295: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Sir James W. Black a-t-il reçu le Prix Nobel en 1988 ?",
      answers: ["Chimie","Physiologie ou Médecine","Paix","Littérature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12296: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Gertrude B. Elion a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes de principes importants pour le traitement médicamenteux ?",
      answers: ["1993","1988","1985","1930"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12297: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1988 pour leurs découvertes de principes importants pour le traitement médicamenteux ?",
      answers: ["Susumu Tonegawa","Carol W. Greider","Alfred G. Gilman","Gertrude B. Elion"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12298: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Gertrude B. Elion a-t-il reçu le Prix Nobel en 1988 ?",
      answers: ["pour leurs découvertes de principes importants pour le traitement médicamenteux","pour sa découverte du cycle de l’acide citrique","pour sa découverte du principe génétique de la génération de la diversité des anticorps","pour leurs découvertes des facteurs de croissance"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12299: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Gertrude B. Elion a-t-il reçu le Prix Nobel en 1988 ?",
      answers: ["Physiologie ou Médecine","Chimie","Physique","Littérature"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12300: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année George H. Hitchings a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes de principes importants pour le traitement médicamenteux ?",
      answers: ["1988","1956","1979","1989"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12301: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1988 pour leurs découvertes de principes importants pour le traitement médicamenteux ?",
      answers: ["Robert F. Furchgott","George H. Hitchings","Sir James W. Black","Bruce A. Beutler"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12302: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison George H. Hitchings a-t-il reçu le Prix Nobel en 1988 ?",
      answers: ["pour leurs découvertes concernant la régulation du métabolisme du cholestérol","pour leurs découvertes concernant les transplantations d’organes et de cellules dans le traitement des maladies","pour leurs découvertes concernant les transmetteurs humoraux dans les terminaisons nerveuses et le mécanisme de leur stockage, libération et inactivation","pour leurs découvertes de principes importants pour le traitement médicamenteux"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12303: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie George H. Hitchings a-t-il reçu le Prix Nobel en 1988 ?",
      answers: ["Chimie","Physiologie ou Médecine","Sciences Économiques","Littérature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12304: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Forces de Maintien de la Paix des Nations Unies a-t-il reçu le Prix Nobel de Paix pour leur contribution à la réduction des tensions et à la promotion de la paix dans le monde ?",
      answers: ["1970","1988","1989","1996"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12305: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1988 pour leur contribution à la réduction des tensions et à la promotion de la paix dans le monde ?",
      answers: ["Ligue des Sociétés de la Croix-Rouge","Forces de Maintien de la Paix des Nations Unies","Campagne Internationale pour l’Interdiction des Mines Antipersonnel (ICBL)","Denis Mukwege"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12306: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Forces de Maintien de la Paix des Nations Unies a-t-il reçu le Prix Nobel en 1988 ?",
      answers: ["pour leur lutte contre l’oppression des enfants et des jeunes et pour le droit de tous les enfants à l’éducation","pour sa lutte non violente pour la libération du Tibet et son engagement pour la paix mondiale","pour son travail visant à améliorer les conditions de vie des enfants dans le monde","pour leur contribution à la réduction des tensions et à la promotion de la paix dans le monde"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12307: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Forces de Maintien de la Paix des Nations Unies a-t-il reçu le Prix Nobel en 1988 ?",
      answers: ["Sciences Économiques","Paix","Chimie","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12308: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Naguib Mahfouz a-t-il reçu le Prix Nobel de Littérature qui, à travers des œuvres riches en nuances, a donné forme à un art narratif arabe qui s’applique à toute l’humanité ?",
      answers: ["1988","1982","2013","1989"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12309: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1988 qui, à travers des œuvres riches en nuances, a donné forme à un art narratif arabe qui s’applique à toute l’humanité ?",
      answers: ["Kazuo Ishiguro","Naguib Mahfouz","Carl Spitteler","Pablo Neruda"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12310: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Naguib Mahfouz a-t-il reçu le Prix Nobel en 1988 ?",
      answers: ["qui, à travers des œuvres riches en nuances, a donné forme à un art narratif arabe qui s’applique à toute l’humanité","pour une œuvre littéraire empreinte de clarté de pensée et d’intensité poétique","principalement en reconnaissance de sa production fructueuse, variée et exceptionnelle dans le domaine de l’art dramatique","pour sa maîtrise de la description historique et biographique ainsi que pour son éloquence brillante dans la défense des valeurs humaines exaltées"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12311: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Naguib Mahfouz a-t-il reçu le Prix Nobel en 1988 ?",
      answers: ["Paix","Physiologie ou Médecine","Littérature","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12312: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Maurice Allais a-t-il reçu le Prix Nobel de Sciences Économiques pour ses contributions pionnières à la théorie des marchés et à l’utilisation efficace des ressources ?",
      answers: ["1989","1914","1988","1977"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12313: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1988 pour ses contributions pionnières à la théorie des marchés et à l’utilisation efficace des ressources ?",
      answers: ["Paul Krugman","Gary S. Becker","Maurice Allais","William Vickrey"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12314: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Maurice Allais a-t-il reçu le Prix Nobel en 1988 ?",
      answers: ["pour leurs contributions pionnières à la théorie de l’équilibre économique général et à la théorie du bien-être","pour ses contributions pionnières à la théorie des marchés et à l’utilisation efficace des ressources","pour ses méthodes d’analyse des séries temporelles économiques avec co-intégration","pour avoir incorporé de nouvelles méthodes analytiques dans la théorie économique et pour sa reformulation rigoureuse de la théorie de l’équilibre général"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12315: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Maurice Allais a-t-il reçu le Prix Nobel en 1988 ?",
      answers: ["Littérature","Sciences Économiques","Physiologie ou Médecine","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12316: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Norman F. Ramsey a-t-il reçu le Prix Nobel de Physique pour l’invention de la méthode des champs oscillatoires séparés et son utilisation dans le maser à hydrogène ?",
      answers: ["1981","1989","1984","1988"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12317: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1989 pour l’invention de la méthode des champs oscillatoires séparés et son utilisation dans le maser à hydrogène ?",
      answers: ["Leon M. Lederman","K. Alex Müller","Hans G. Dehmelt","Norman F. Ramsey"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12318: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Norman F. Ramsey a-t-il reçu le Prix Nobel en 1989 ?",
      answers: ["pour avoir découvert que les méthodes développées pour étudier les phénomènes d’ordre dans les systèmes simples peuvent être généralisées à des formes plus complexes de la matière","pour l’invention de la méthode des champs oscillatoires séparés et son utilisation dans le maser à hydrogène","pour la méthode du faisceau de neutrinos et la démonstration de la structure en doublet des leptons par la découverte du neutrino muonique","pour leur découverte expérimentale de la diffraction des électrons par les cristaux"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12319: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Norman F. Ramsey a-t-il reçu le Prix Nobel en 1989 ?",
      answers: ["Littérature","Physique","Physiologie ou Médecine","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12320: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Hans G. Dehmelt a-t-il reçu le Prix Nobel de Physique pour le développement de la technique du piège à ions ?",
      answers: ["1986","1992","2010","1989"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12321: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1989 pour le développement de la technique du piège à ions ?",
      answers: ["Richard E. Taylor","Hans G. Dehmelt","Russell A. Hulse","Wolfgang Paul"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12322: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Hans G. Dehmelt a-t-il reçu le Prix Nobel en 1989 ?",
      answers: ["pour leurs investigations théoriques fondamentales sur la structure électronique des systèmes magnétiques et désordonnés","pour la découverte d’un nouveau type de pulsar, une découverte qui a ouvert de nouvelles possibilités pour l’étude de la gravitation","en reconnaissance des services extraordinaires qu’ils ont rendus conjointement par leurs recherches sur les phénomènes de rayonnement découverts par le professeur Henri Becquerel","pour le développement de la technique du piège à ions"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12323: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Hans G. Dehmelt a-t-il reçu le Prix Nobel en 1989 ?",
      answers: ["Sciences Économiques","Chimie","Physiologie ou Médecine","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12324: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Wolfgang Paul a-t-il reçu le Prix Nobel de Physique pour le développement de la technique du piège à ions ?",
      answers: ["1999","1989","1960","1986"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12325: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1989 pour le développement de la technique du piège à ions ?",
      answers: ["Wolfgang Paul","Guglielmo Marconi","Arno Penzias","Norman F. Ramsey"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12326: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Wolfgang Paul a-t-il reçu le Prix Nobel en 1989 ?",
      answers: ["pour leurs contributions pionnières à l’astrophysique, notamment la détection des neutrinos cosmiques","pour le développement de la technique du piège à ions","pour leurs contributions décisives au grand projet qui a conduit à la découverte des particules W et Z, messagers de l’interaction faible","pour leurs travaux pionniers dans la découverte d’une nouvelle particule élémentaire lourde"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12327: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Wolfgang Paul a-t-il reçu le Prix Nobel en 1989 ?",
      answers: ["Paix","Physique","Chimie","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12328: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Sidney Altman a-t-il reçu le Prix Nobel de Chimie pour leur découverte des propriétés catalytiques de l’ARN ?",
      answers: ["1986","1989","1966","1969"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12329: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1989 pour leur découverte des propriétés catalytiques de l’ARN ?",
      answers: ["Friedrich Bergius","Peter Mitchell","Johann Deisenhofer","Sidney Altman"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12330: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Sidney Altman a-t-il reçu le Prix Nobel en 1989 ?",
      answers: ["pour la détermination de la structure tridimensionnelle d’un centre réactionnel photosynthétique","pour leurs réalisations exceptionnelles dans le développement de méthodes directes pour la détermination des structures cristallines","pour leur découverte des propriétés catalytiques de l’ARN","pour des études sur la structure et la fonction du ribosome"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12331: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Sidney Altman a-t-il reçu le Prix Nobel en 1989 ?",
      answers: ["Physiologie ou Médecine","Chimie","Paix","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12332: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Thomas R. Cech a-t-il reçu le Prix Nobel de Chimie pour leur découverte des propriétés catalytiques de l’ARN ?",
      answers: ["1988","1944","1989","1924"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12333: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1989 pour leur découverte des propriétés catalytiques de l’ARN ?",
      answers: ["K. Barry Sharpless","Morten Meldal","William N. Lipscomb","Thomas R. Cech"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12334: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Thomas R. Cech a-t-il reçu le Prix Nobel en 1989 ?",
      answers: ["pour leur développement de l’utilisation des composés de bore et de phosphore, respectivement, dans la synthèse organique","pour leur découverte des propriétés catalytiques de l’ARN","pour ses contributions à la théorie des réactions de transfert d’électrons dans les systèmes chimiques","pour ses contributions exceptionnelles à l’art de la synthèse organique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12335: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Thomas R. Cech a-t-il reçu le Prix Nobel en 1989 ?",
      answers: ["Physiologie ou Médecine","Sciences Économiques","Paix","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12336: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année J. Michael Bishop a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leur découverte de l’origine cellulaire des rétrovirus oncogènes ?",
      answers: ["1987","1992","1989","1994"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12337: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1989 pour leur découverte de l’origine cellulaire des rétrovirus oncogènes ?",
      answers: ["E. Donnall Thomas","J. Michael Bishop","Joseph E. Murray","Bert Sakmann"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12338: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison J. Michael Bishop a-t-il reçu le Prix Nobel en 1989 ?",
      answers: ["pour leurs découvertes concernant de nouveaux mécanismes d’origine et de dissémination des maladies infectieuses","pour leurs découvertes concernant la phosphorylation réversible des protéines comme mécanisme de régulation biologique","pour leur découverte de l’origine cellulaire des rétrovirus oncogènes","pour leurs découvertes concernant les transplantations d’organes et de cellules dans le traitement des maladies"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12339: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie J. Michael Bishop a-t-il reçu le Prix Nobel en 1989 ?",
      answers: ["Paix","Physiologie ou Médecine","Physique","Littérature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12340: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Harold E. Varmus a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leur découverte de l’origine cellulaire des rétrovirus oncogènes ?",
      answers: ["1988","1989","1986","1999"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12341: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1989 pour leur découverte de l’origine cellulaire des rétrovirus oncogènes ?",
      answers: ["Allan M. Cormack","George H. Hitchings","Harold E. Varmus","Gertrude B. Elion"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12342: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Harold E. Varmus a-t-il reçu le Prix Nobel en 1989 ?",
      answers: ["pour leur découverte de la capacité du virus de la poliomyélite à se développer dans des cultures de divers types de tissus","pour leurs découvertes concernant la spécificité de la réponse immunitaire à médiation cellulaire","pour leur découverte de l’origine cellulaire des rétrovirus oncogènes","pour leurs découvertes concernant la phosphorylation réversible des protéines comme mécanisme de régulation biologique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12343: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Harold E. Varmus a-t-il reçu le Prix Nobel en 1989 ?",
      answers: ["Physique","Sciences Économiques","Physiologie ou Médecine","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12344: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Dalaï Lama (Tenzin Gyatso) a-t-il reçu le Prix Nobel de Paix pour sa lutte non violente pour la libération du Tibet et son engagement pour la paix mondiale ?",
      answers: ["1992","1989","2000","1977"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12345: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1989 pour sa lutte non violente pour la libération du Tibet et son engagement pour la paix mondiale ?",
      answers: ["Aung San Suu Kyi","Henry Kissinger","Rigoberta Menchú Tum","Dalaï Lama (Tenzin Gyatso)"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12346: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Dalaï Lama (Tenzin Gyatso) a-t-il reçu le Prix Nobel en 1989 ?",
      answers: ["pour leurs efforts visant à créer la paix au Moyen-Orient","pour leur travail en faveur du désarmement et de la paix mondiale","pour sa lutte non violente pour la libération du Tibet et son engagement pour la paix mondiale","pour leurs efforts visant à réduire le rôle des armes nucléaires dans la politique internationale"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12347: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Dalaï Lama (Tenzin Gyatso) a-t-il reçu le Prix Nobel en 1989 ?",
      answers: ["Sciences Économiques","Chimie","Paix","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12348: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Camilo José Cela a-t-il reçu le Prix Nobel de Littérature pour une prose riche et intense qui, avec une compassion contenue, forme une vision provocante de la vulnérabilité humaine ?",
      answers: ["1989","1992","2009","1983"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12349: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1989 pour une prose riche et intense qui, avec une compassion contenue, forme une vision provocante de la vulnérabilité humaine ?",
      answers: ["Joseph Brodsky","Camilo José Cela","Isaac Bashevis Singer","Toni Morrison"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12350: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Camilo José Cela a-t-il reçu le Prix Nobel en 1989 ?",
      answers: ["pour sa maîtrise de l’art narratif, récemment démontrée dans Le Vieil Homme et la Mer, et pour l’influence qu’il a exercée sur le style contemporain","pour une prose riche et intense qui, avec une compassion contenue, forme une vision provocante de la vulnérabilité humaine","pour une écriture passionnée aux vastes horizons, caractérisée par une intelligence sensuelle et une intégrité humaniste","pour une œuvre littéraire empreinte de clarté de pensée et d’intensité poétique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12351: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Camilo José Cela a-t-il reçu le Prix Nobel en 1989 ?",
      answers: ["Physique","Sciences Économiques","Chimie","Littérature"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12352: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Trygve Haavelmo a-t-il reçu le Prix Nobel de Sciences Économiques pour sa clarification des fondements de la théorie économétrique probabiliste et son analyse des structures économiques simultanées ?",
      answers: ["1995","1989","1990","1982"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12353: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1989 pour sa clarification des fondements de la théorie économétrique probabiliste et son analyse des structures économiques simultanées ?",
      answers: ["Maurice Allais","William F. Sharpe","Trygve Haavelmo","Merton H. Miller"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12354: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Trygve Haavelmo a-t-il reçu le Prix Nobel en 1989 ?",
      answers: ["pour sa clarification des fondements de la théorie économétrique probabiliste et son analyse des structures économiques simultanées","pour leurs contributions pionnières à la théorie de l’économie financière","pour ses contributions à l’économie du bien-être","pour son analyse des politiques monétaires et fiscales sous différents régimes de taux de change"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12355: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Trygve Haavelmo a-t-il reçu le Prix Nobel en 1989 ?",
      answers: ["Physiologie ou Médecine","Sciences Économiques","Paix","Littérature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12356: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Jerome I. Friedman a-t-il reçu le Prix Nobel de Physique pour leurs recherches pionnières sur la diffusion inélastique profonde des électrons sur les protons et les neutrons liés ?",
      answers: ["1991","1990","1993","1917"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12357: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1990 pour leurs recherches pionnières sur la diffusion inélastique profonde des électrons sur les protons et les neutrons liés ?",
      answers: ["Jerome I. Friedman","Richard E. Taylor","Ben R. Mottelson","J. Georg Bednorz"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12358: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Jerome I. Friedman a-t-il reçu le Prix Nobel en 1990 ?",
      answers: ["pour ses contributions et découvertes concernant la classification des particules élémentaires et leurs interactions","pour leurs recherches pionnières sur la diffusion inélastique profonde des électrons sur les protons et les neutrons liés","pour leur percée importante dans la découverte de la supraconductivité dans les matériaux céramiques","pour son invention et son développement de détecteurs de particules, notamment la chambre proportionnelle à fils multiples"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12359: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Jerome I. Friedman a-t-il reçu le Prix Nobel en 1990 ?",
      answers: ["Physique","Chimie","Littérature","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12360: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Henry W. Kendall a-t-il reçu le Prix Nobel de Physique pour leurs recherches pionnières sur la diffusion inélastique profonde des électrons sur les protons et les neutrons liés ?",
      answers: ["2010","1988","1990","1993"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12361: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1990 pour leurs recherches pionnières sur la diffusion inélastique profonde des électrons sur les protons et les neutrons liés ?",
      answers: ["Norman F. Ramsey","Roy J. Glauber","Nicolaas Bloembergen","Henry W. Kendall"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12362: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Henry W. Kendall a-t-il reçu le Prix Nobel en 1990 ?",
      answers: ["pour leurs recherches pionnières sur la diffusion inélastique profonde des électrons sur les protons et les neutrons liés","pour le développement de la technique du piège à ions","pour la découverte que la formation des trous noirs est une prédiction robuste de la théorie de la relativité générale","pour leurs investigations théoriques fondamentales sur la structure électronique des systèmes magnétiques et désordonnés"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12363: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Henry W. Kendall a-t-il reçu le Prix Nobel en 1990 ?",
      answers: ["Chimie","Physique","Physiologie ou Médecine","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12364: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Richard E. Taylor a-t-il reçu le Prix Nobel de Physique pour leurs recherches pionnières sur la diffusion inélastique profonde des électrons sur les protons et les neutrons liés ?",
      answers: ["1986","1994","1989","1990"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12365: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1990 pour leurs recherches pionnières sur la diffusion inélastique profonde des électrons sur les protons et les neutrons liés ?",
      answers: ["Hans G. Dehmelt","Rudolf Mössbauer","Wolfgang Paul","Richard E. Taylor"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12366: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Richard E. Taylor a-t-il reçu le Prix Nobel en 1990 ?",
      answers: ["pour leurs recherches pionnières sur la diffusion inélastique profonde des électrons sur les protons et les neutrons liés","pour leur découverte de l’effet Hall quantique fractionnaire","pour leurs contributions décisives au grand projet qui a conduit à la découverte des particules W et Z, messagers de l’interaction faible","pour ses études théoriques et expérimentales des réactions nucléaires importantes dans la formation des éléments chimiques dans l’univers"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12367: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Richard E. Taylor a-t-il reçu le Prix Nobel en 1990 ?",
      answers: ["Chimie","Sciences Économiques","Physiologie ou Médecine","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12368: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Elias James Corey a-t-il reçu le Prix Nobel de Chimie pour son développement de la théorie et de la méthodologie de la synthèse organique ?",
      answers: ["1985","1988","1984","1990"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12369: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1990 pour son développement de la théorie et de la méthodologie de la synthèse organique ?",
      answers: ["Charles J. Pedersen","Elias James Corey","Donald J. Cram","Paul J. Crutzen"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12370: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Elias James Corey a-t-il reçu le Prix Nobel en 1990 ?",
      answers: ["pour ses contributions à la théorie des réactions de transfert d’électrons dans les systèmes chimiques","pour leur découverte des propriétés catalytiques de l’ARN","pour son développement de la théorie et de la méthodologie de la synthèse organique","pour son travail sur les réactions d’hydrogénation catalysées de manière chirale"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12371: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Elias James Corey a-t-il reçu le Prix Nobel en 1990 ?",
      answers: ["Littérature","Physiologie ou Médecine","Chimie","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12372: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Joseph E. Murray a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant les transplantations d’organes et de cellules dans le traitement des maladies ?",
      answers: ["1990","1984","1986","2013"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12373: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1990 pour leurs découvertes concernant les transplantations d’organes et de cellules dans le traitement des maladies ?",
      answers: ["Gregg L. Semenza","E. Donnall Thomas","Sir James W. Black","Joseph E. Murray"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12374: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Joseph E. Murray a-t-il reçu le Prix Nobel en 1990 ?",
      answers: ["pour leurs découvertes concernant la régulation génétique de la synthèse des enzymes et des virus","pour leurs découvertes concernant les transplantations d’organes et de cellules dans le traitement des maladies","pour leurs découvertes concernant le monoxyde d’azote comme molécule de signalisation dans le système cardiovasculaire","pour leurs découvertes concernant l’organisation et l’élicitation des schémas de comportement individuels et sociaux"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12375: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Joseph E. Murray a-t-il reçu le Prix Nobel en 1990 ?",
      answers: ["Sciences Économiques","Chimie","Littérature","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12376: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année E. Donnall Thomas a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant les transplantations d’organes et de cellules dans le traitement des maladies ?",
      answers: ["1990","2008","1991","1907"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12377: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1990 pour leurs découvertes concernant les transplantations d’organes et de cellules dans le traitement des maladies ?",
      answers: ["J. Michael Bishop","Joseph E. Murray","E. Donnall Thomas","Harold E. Varmus"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12378: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison E. Donnall Thomas a-t-il reçu le Prix Nobel en 1990 ?",
      answers: ["pour leurs découvertes concernant les transplantations d’organes et de cellules dans le traitement des maladies","pour leurs découvertes des facteurs de croissance","pour leurs découvertes concernant la fonction des canaux ioniques uniques dans les cellules","pour leur découverte de l’origine cellulaire des rétrovirus oncogènes"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12379: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie E. Donnall Thomas a-t-il reçu le Prix Nobel en 1990 ?",
      answers: ["Physiologie ou Médecine","Littérature","Physique","Sciences Économiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12380: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Octavio Paz a-t-il reçu le Prix Nobel de Littérature pour une écriture passionnée aux vastes horizons, caractérisée par une intelligence sensuelle et une intégrité humaniste ?",
      answers: ["1970","1992","1991","1990"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12381: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1990 pour une écriture passionnée aux vastes horizons, caractérisée par une intelligence sensuelle et une intégrité humaniste ?",
      answers: ["Pär Lagerkvist","Doris Lessing","Camilo José Cela","Octavio Paz"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12382: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Octavio Paz a-t-il reçu le Prix Nobel en 1990 ?",
      answers: ["qui, dans des romans caractérisés par une force visionnaire et une portée poétique, donne vie à un aspect essentiel de la réalité américaine","qui, par son écriture épique magnifique, a rendu un grand service à l’humanité","pour une écriture passionnée aux vastes horizons, caractérisée par une intelligence sensuelle et une intégrité humaniste","qui, dans une vaste perspective culturelle et avec des accents poétiques, façonne le drame de l’existence"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12383: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Octavio Paz a-t-il reçu le Prix Nobel en 1990 ?",
      answers: ["Littérature","Physiologie ou Médecine","Physique","Sciences Économiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12384: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Mikhail Gorbachev a-t-il reçu le Prix Nobel de Paix pour son rôle de leader dans le processus de paix qui a marqué une étape importante dans l’histoire mondiale ?",
      answers: ["1934","1990","2012","1914"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12385: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1990 pour son rôle de leader dans le processus de paix qui a marqué une étape importante dans l’histoire mondiale ?",
      answers: ["Shirin Ebadi","Nelson Mandela","Dmitry Muratov","Mikhail Gorbachev"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12386: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Mikhail Gorbachev a-t-il reçu le Prix Nobel en 1990 ?",
      answers: ["pour son rôle de leader dans le processus de paix qui a marqué une étape importante dans l’histoire mondiale","pour leurs efforts visant à créer un développement économique et social par le bas","pour ses efforts en faveur de la démocratie et des droits humains, notamment pour les femmes et les enfants","pour leur travail pour la fin pacifique du régime de l’apartheid et pour poser les bases d’une nouvelle Afrique du Sud démocratique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12387: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Mikhail Gorbachev a-t-il reçu le Prix Nobel en 1990 ?",
      answers: ["Physiologie ou Médecine","Sciences Économiques","Paix","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12388: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Merton H. Miller a-t-il reçu le Prix Nobel de Sciences Économiques pour leurs contributions pionnières à la théorie de l’économie financière ?",
      answers: ["1991","1981","1992","1990"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12389: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1990 pour leurs contributions pionnières à la théorie de l’économie financière ?",
      answers: ["William F. Sharpe","Oliver E. Williamson","Merton H. Miller","Harry M. Markowitz"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12390: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Merton H. Miller a-t-il reçu le Prix Nobel en 1990 ?",
      answers: ["pour son analyse de la théorie des marchés financiers et de leurs relations avec les décisions de dépenses, l’emploi, la production et les prix","pour sa découverte et sa clarification de la signification des coûts de transaction et des droits de propriété dans la structure économique","pour leurs contributions pionnières à la théorie de l’économie financière","pour avoir étendu l’analyse microéconomique à une large gamme de comportements humains et d’interactions"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12391: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Merton H. Miller a-t-il reçu le Prix Nobel en 1990 ?",
      answers: ["Physique","Physiologie ou Médecine","Sciences Économiques","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12392: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Harry M. Markowitz a-t-il reçu le Prix Nobel de Sciences Économiques pour leurs contributions pionnières à la théorie de l’économie financière ?",
      answers: ["1982","1947","1989","1990"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12393: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1990 pour leurs contributions pionnières à la théorie de l’économie financière ?",
      answers: ["Robert W. Fogel","Harry M. Markowitz","Maurice Allais","George J. Stigler"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12394: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Harry M. Markowitz a-t-il reçu le Prix Nobel en 1990 ?",
      answers: ["pour leurs contributions pionnières à la théorie de l’économie financière","pour son analyse de la consommation, de la pauvreté et du bien-être","pour ses recherches sur les banques et les crises financières","pour son développement des bases contractuelles et constitutionnelles de la théorie des décisions économiques et politiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12395: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Harry M. Markowitz a-t-il reçu le Prix Nobel en 1990 ?",
      answers: ["Physique","Littérature","Sciences Économiques","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12396: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année William F. Sharpe a-t-il reçu le Prix Nobel de Sciences Économiques pour leurs contributions pionnières à la théorie de l’économie financière ?",
      answers: ["1988","1991","1990","1992"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12397: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1990 pour leurs contributions pionnières à la théorie de l’économie financière ?",
      answers: ["Sir W. Arthur Lewis","James Tobin","William F. Sharpe","Elinor Ostrom"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12398: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison William F. Sharpe a-t-il reçu le Prix Nobel en 1990 ?",
      answers: ["pour leurs contributions pionnières à la théorie de l’économie financière","pour leurs analyses pionnières du développement économique, avec une attention particulière aux problèmes des pays en développement","pour leur approche expérimentale visant à réduire la pauvreté dans le monde","pour avoir étendu l’analyse microéconomique à une large gamme de comportements humains et d’interactions"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12399: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie William F. Sharpe a-t-il reçu le Prix Nobel en 1990 ?",
      answers: ["Sciences Économiques","Physiologie ou Médecine","Physique","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12400: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Pierre-Gilles de Gennes a-t-il reçu le Prix Nobel de Physique pour avoir découvert que les méthodes développées pour étudier les phénomènes d’ordre dans les systèmes simples peuvent être généralisées à des formes plus complexes de la matière ?",
      answers: ["1920","1995","1991","1901"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12401: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1991 pour avoir découvert que les méthodes développées pour étudier les phénomènes d’ordre dans les systèmes simples peuvent être généralisées à des formes plus complexes de la matière ?",
      answers: ["Pierre-Gilles de Gennes","Klaus von Klitzing","Wolfgang Paul","Georges Charpak"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12402: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Pierre-Gilles de Gennes a-t-il reçu le Prix Nobel en 1991 ?",
      answers: ["pour avoir découvert que les méthodes développées pour étudier les phénomènes d’ordre dans les systèmes simples peuvent être généralisées à des formes plus complexes de la matière","pour la méthode du faisceau de neutrinos et la démonstration de la structure en doublet des leptons par la découverte du neutrino muonique","pour l’invention de la méthode des champs oscillatoires séparés et son utilisation dans le maser à hydrogène","pour leurs contributions pionnières à l’astrophysique, notamment la détection des neutrinos cosmiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12403: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Pierre-Gilles de Gennes a-t-il reçu le Prix Nobel en 1991 ?",
      answers: ["Chimie","Physique","Paix","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12404: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Richard R. Ernst a-t-il reçu le Prix Nobel de Chimie pour ses contributions au développement de la spectroscopie par résonance magnétique nucléaire à haute résolution ?",
      answers: ["1965","1991","1983","2005"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12405: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1991 pour ses contributions au développement de la spectroscopie par résonance magnétique nucléaire à haute résolution ?",
      answers: ["Richard R. Ernst","Robert Huber","George Porter","Stanford Moore"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12406: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Richard R. Ernst a-t-il reçu le Prix Nobel en 1991 ?",
      answers: ["pour sa contribution à la chimie des carbocations","pour son développement de la théorie et de la méthodologie de la synthèse organique","pour ses contributions au développement de la spectroscopie par résonance magnétique nucléaire à haute résolution","pour leurs travaux sur la chimie de l’atmosphère, notamment concernant la formation et la décomposition de l’ozone"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12407: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Richard R. Ernst a-t-il reçu le Prix Nobel en 1991 ?",
      answers: ["Littérature","Chimie","Physiologie ou Médecine","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12408: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Erwin Neher a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant la fonction des canaux ioniques uniques dans les cellules ?",
      answers: ["1993","1985","1991","1994"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12409: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1991 pour leurs découvertes concernant la fonction des canaux ioniques uniques dans les cellules ?",
      answers: ["Bert Sakmann","E. Donnall Thomas","Erwin Neher","Joseph E. Murray"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12410: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Erwin Neher a-t-il reçu le Prix Nobel en 1991 ?",
      answers: ["pour leurs découvertes concernant la phosphorylation réversible des protéines comme mécanisme de régulation biologique","pour leurs découvertes de principes importants pour le traitement médicamenteux","pour leurs découvertes concernant la fonction des canaux ioniques uniques dans les cellules","pour leur découverte du cours de la conversion catalytique du glycogène"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12411: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Erwin Neher a-t-il reçu le Prix Nobel en 1991 ?",
      answers: ["Chimie","Physique","Paix","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12412: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Bert Sakmann a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant la fonction des canaux ioniques uniques dans les cellules ?",
      answers: ["1931","1989","1991","1992"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12413: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1991 pour leurs découvertes concernant la fonction des canaux ioniques uniques dans les cellules ?",
      answers: ["César Milstein","Sir James W. Black","Bert Sakmann","Ragnar Granit"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12414: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Bert Sakmann a-t-il reçu le Prix Nobel en 1991 ?",
      answers: ["pour leurs découvertes concernant la fonction des canaux ioniques uniques dans les cellules","pour leurs découvertes sur la régulation du cycle cellulaire","pour leurs découvertes concernant l’imagerie par résonance magnétique","pour leurs découvertes sur les gènes discontinus"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12415: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Bert Sakmann a-t-il reçu le Prix Nobel en 1991 ?",
      answers: ["Littérature","Sciences Économiques","Physiologie ou Médecine","Paix"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12416: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Nadine Gordimer a-t-il reçu le Prix Nobel de Littérature qui, par son écriture épique magnifique, a rendu un grand service à l’humanité ?",
      answers: ["1967","1955","1992","1991"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12417: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1991 qui, par son écriture épique magnifique, a rendu un grand service à l’humanité ?",
      answers: ["Nadine Gordimer","Derek Walcott","George Bernard Shaw","Naguib Mahfouz"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12418: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Nadine Gordimer a-t-il reçu le Prix Nobel en 1991 ?",
      answers: ["pour l’art rigoureux avec lequel il a développé les traditions de la prose classique russe","pour une œuvre poétique d’une grande luminosité, soutenue par une vision historique, fruit d’un engagement multiculturel","qui, par son écriture épique magnifique, a rendu un grand service à l’humanité","pour une œuvre littéraire empreinte de clarté de pensée et d’intensité poétique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12419: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Nadine Gordimer a-t-il reçu le Prix Nobel en 1991 ?",
      answers: ["Physique","Littérature","Physiologie ou Médecine","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12420: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Aung San Suu Kyi a-t-il reçu le Prix Nobel de Paix pour sa lutte non violente pour la démocratie et les droits humains ?",
      answers: ["1973","1992","1990","1991"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12421: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1991 pour sa lutte non violente pour la démocratie et les droits humains ?",
      answers: ["Forces de Maintien de la Paix des Nations Unies","Ellen Johnson Sirleaf","Aung San Suu Kyi","Joseph Rotblat"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12422: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Aung San Suu Kyi a-t-il reçu le Prix Nobel en 1991 ?",
      answers: ["pour leurs efforts visant à créer la paix au Moyen-Orient","pour son travail dans la rédaction de la Déclaration universelle des droits de l’homme","pour sa lutte non violente pour la démocratie et les droits humains","pour son rôle de leader dans le processus de paix qui a marqué une étape importante dans l’histoire mondiale"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12423: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Aung San Suu Kyi a-t-il reçu le Prix Nobel en 1991 ?",
      answers: ["Littérature","Paix","Physique","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12424: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Ronald H. Coase a-t-il reçu le Prix Nobel de Sciences Économiques pour sa découverte et sa clarification de la signification des coûts de transaction et des droits de propriété dans la structure économique ?",
      answers: ["2016","1991","1988","1966"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12425: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1991 pour sa découverte et sa clarification de la signification des coûts de transaction et des droits de propriété dans la structure économique ?",
      answers: ["Ronald H. Coase","Clive W. J. Granger","Daniel L. McFadden","Gary S. Becker"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12426: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Ronald H. Coase a-t-il reçu le Prix Nobel en 1991 ?",
      answers: ["pour leurs analyses pionnières du développement économique, avec une attention particulière aux problèmes des pays en développement","pour son analyse des modèles commerciaux et de la localisation de l’activité économique","pour ses contributions pionnières à la théorie des marchés et à l’utilisation efficace des ressources","pour sa découverte et sa clarification de la signification des coûts de transaction et des droits de propriété dans la structure économique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12427: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Ronald H. Coase a-t-il reçu le Prix Nobel en 1991 ?",
      answers: ["Sciences Économiques","Littérature","Physiologie ou Médecine","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12428: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Georges Charpak a-t-il reçu le Prix Nobel de Physique pour son invention et son développement de détecteurs de particules, notamment la chambre proportionnelle à fils multiples ?",
      answers: ["1992","1995","1958","1960"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12429: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1992 pour son invention et son développement de détecteurs de particules, notamment la chambre proportionnelle à fils multiples ?",
      answers: ["Frederick Reines","Georges Charpak","Hans G. Dehmelt","Douglas D. Osheroff"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12430: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Georges Charpak a-t-il reçu le Prix Nobel en 1992 ?",
      answers: ["pour leur découverte de l’antiproton","pour ses études théoriques et expérimentales des réactions nucléaires importantes dans la formation des éléments chimiques dans l’univers","pour son invention et son développement de détecteurs de particules, notamment la chambre proportionnelle à fils multiples","pour la découverte d’un objet compact supermassif au centre de notre galaxie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12431: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Georges Charpak a-t-il reçu le Prix Nobel en 1992 ?",
      answers: ["Littérature","Physique","Chimie","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12432: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Rudolph A. Marcus a-t-il reçu le Prix Nobel de Chimie pour ses contributions à la théorie des réactions de transfert d’électrons dans les systèmes chimiques ?",
      answers: ["1992","2016","1993","1965"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12433: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1992 pour ses contributions à la théorie des réactions de transfert d’électrons dans les systèmes chimiques ?",
      answers: ["William E. Moerner","Rudolph A. Marcus","Thomas R. Cech","George A. Olah"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12434: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Rudolph A. Marcus a-t-il reçu le Prix Nobel en 1992 ?",
      answers: ["pour leurs contributions au développement du concept de conformation et son application en chimie","pour ses contributions à la théorie des réactions de transfert d’électrons dans les systèmes chimiques","pour leurs travaux sur la chimie de l’atmosphère, notamment concernant la formation et la décomposition de l’ozone","pour ses recherches sur la désintégration des éléments et la chimie des substances radioactives"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12435: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Rudolph A. Marcus a-t-il reçu le Prix Nobel en 1992 ?",
      answers: ["Chimie","Littérature","Physique","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12436: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Edmond H. Fischer a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant la phosphorylation réversible des protéines comme mécanisme de régulation biologique ?",
      answers: ["1996","1997","1987","1992"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12437: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1992 pour leurs découvertes concernant la phosphorylation réversible des protéines comme mécanisme de régulation biologique ?",
      answers: ["Erwin Neher","Edmond H. Fischer","Satoshi Ōmura","Stanley B. Prusiner"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12438: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Edmond H. Fischer a-t-il reçu le Prix Nobel en 1992 ?",
      answers: ["pour leurs découvertes concernant la phosphorylation réversible des protéines comme mécanisme de régulation biologique","pour leurs découvertes concernant la structure moléculaire des acides nucléiques et son importance pour le transfert d’information dans le matériel vivant","pour leurs découvertes sur le système de transport vésiculaire dans les cellules","pour la découverte de la pénicilline et de son effet curatif dans diverses maladies infectieuses"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12439: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Edmond H. Fischer a-t-il reçu le Prix Nobel en 1992 ?",
      answers: ["Chimie","Sciences Économiques","Physique","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12440: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Edwin G. Krebs a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant la phosphorylation réversible des protéines comme mécanisme de régulation biologique ?",
      answers: ["1968","1925","1992","1997"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12441: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1992 pour leurs découvertes concernant la phosphorylation réversible des protéines comme mécanisme de régulation biologique ?",
      answers: ["John E. Sulston","Stanley Cohen","Richard J. Roberts","Edwin G. Krebs"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12442: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Edwin G. Krebs a-t-il reçu le Prix Nobel en 1992 ?",
      answers: ["pour leurs découvertes concernant la phosphorylation réversible des protéines comme mécanisme de régulation biologique","pour leurs découvertes concernant la fonction des canaux ioniques uniques dans les cellules","pour leur découverte des protéines G et leur rôle dans la transduction des signaux dans les cellules","pour leurs découvertes concernant le contrôle génétique du développement précoce de l’embryon"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12443: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Edwin G. Krebs a-t-il reçu le Prix Nobel en 1992 ?",
      answers: ["Physiologie ou Médecine","Paix","Chimie","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12444: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Derek Walcott a-t-il reçu le Prix Nobel de Littérature pour une œuvre poétique d’une grande luminosité, soutenue par une vision historique, fruit d’un engagement multiculturel ?",
      answers: ["1966","1997","1993","1992"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12445: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1992 pour une œuvre poétique d’une grande luminosité, soutenue par une vision historique, fruit d’un engagement multiculturel ?",
      answers: ["Czesław Miłosz","Derek Walcott","Octavio Paz","V. S. Naipaul"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12446: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Derek Walcott a-t-il reçu le Prix Nobel en 1992 ?",
      answers: ["pour une œuvre poétique d’une grande luminosité, soutenue par une vision historique, fruit d’un engagement multiculturel","qui, par son écriture épique magnifique, a rendu un grand service à l’humanité","qui, dans une vaste perspective culturelle et avec des accents poétiques, façonne le drame de l’existence","cette épopée de l’expérience féminine qui, avec scepticisme, feu et une force visionnaire, a soumis une civilisation divisée à un examen"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12447: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Derek Walcott a-t-il reçu le Prix Nobel en 1992 ?",
      answers: ["Physique","Physiologie ou Médecine","Paix","Littérature"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12448: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Rigoberta Menchú Tum a-t-il reçu le Prix Nobel de Paix pour son travail en faveur de la justice sociale et de la réconciliation ethno-culturelle basée sur le respect des droits des peuples indigènes ?",
      answers: ["1992","1977","2019","1994"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12449: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1992 pour son travail en faveur de la justice sociale et de la réconciliation ethno-culturelle basée sur le respect des droits des peuples indigènes ?",
      answers: ["Forces de Maintien de la Paix des Nations Unies","José Ramos-Horta","Rigoberta Menchú Tum","Carlos Filipe Ximenes Belo"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12450: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Rigoberta Menchú Tum a-t-il reçu le Prix Nobel en 1992 ?",
      answers: ["pour leurs contributions à la paix à travers la diplomatie et le mouvement pacifiste","pour leurs efforts visant à créer la paix au Moyen-Orient","pour leurs efforts visant à sauvegarder la liberté d’expression, condition préalable à la démocratie et à une paix durable","pour son travail en faveur de la justice sociale et de la réconciliation ethno-culturelle basée sur le respect des droits des peuples indigènes"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12451: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Rigoberta Menchú Tum a-t-il reçu le Prix Nobel en 1992 ?",
      answers: ["Paix","Littérature","Physique","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12452: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Gary S. Becker a-t-il reçu le Prix Nobel de Sciences Économiques pour avoir étendu l’analyse microéconomique à une large gamme de comportements humains et d’interactions ?",
      answers: ["1990","1996","1991","1992"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12453: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1992 pour avoir étendu l’analyse microéconomique à une large gamme de comportements humains et d’interactions ?",
      answers: ["Daniel Kahneman","James J. Heckman","Robert E. Lucas Jr.","Gary S. Becker"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12454: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Gary S. Becker a-t-il reçu le Prix Nobel en 1992 ?",
      answers: ["pour leurs contributions pionnières à la théorie de l’économie financière","pour ses analyses pionnières de l’épargne et des marchés financiers","pour leurs contributions à la théorie des contrats","pour avoir étendu l’analyse microéconomique à une large gamme de comportements humains et d’interactions"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12455: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Gary S. Becker a-t-il reçu le Prix Nobel en 1992 ?",
      answers: ["Chimie","Sciences Économiques","Physique","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12456: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Russell A. Hulse a-t-il reçu le Prix Nobel de Physique pour la découverte d’un nouveau type de pulsar, une découverte qui a ouvert de nouvelles possibilités pour l’étude de la gravitation ?",
      answers: ["1993","1992","1989","1990"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12457: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1993 pour la découverte d’un nouveau type de pulsar, une découverte qui a ouvert de nouvelles possibilités pour l’étude de la gravitation ?",
      answers: ["Richard E. Taylor","Pierre-Gilles de Gennes","Russell A. Hulse","Werner Heisenberg"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12458: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Russell A. Hulse a-t-il reçu le Prix Nobel en 1993 ?",
      answers: ["pour le développement de semi-conducteurs utilisés dans l’électronique à haute vitesse et l’optoélectronique","pour la découverte d’un nouveau type de pulsar, une découverte qui a ouvert de nouvelles possibilités pour l’étude de la gravitation","pour le développement de méthodes pour refroidir et piéger les atomes avec la lumière laser","pour la découverte que la formation des trous noirs est une prédiction robuste de la théorie de la relativité générale"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12459: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Russell A. Hulse a-t-il reçu le Prix Nobel en 1993 ?",
      answers: ["Littérature","Physiologie ou Médecine","Paix","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12460: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Joseph H. Taylor Jr. a-t-il reçu le Prix Nobel de Physique pour la découverte d’un nouveau type de pulsar, une découverte qui a ouvert de nouvelles possibilités pour l’étude de la gravitation ?",
      answers: ["1993","1962","1998","1988"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12461: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1993 pour la découverte d’un nouveau type de pulsar, une découverte qui a ouvert de nouvelles possibilités pour l’étude de la gravitation ?",
      answers: ["Joseph H. Taylor Jr.","Carl F. Braun","Clifford G. Shull","David J. Gross"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12462: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Joseph H. Taylor Jr. a-t-il reçu le Prix Nobel en 1993 ?",
      answers: ["pour la découverte d’un nouveau type de pulsar, une découverte qui a ouvert de nouvelles possibilités pour l’étude de la gravitation","pour avoir découvert que les méthodes développées pour étudier les phénomènes d’ordre dans les systèmes simples peuvent être généralisées à des formes plus complexes de la matière","pour leurs contributions fondamentales à l’électrodynamique quantique, avec des conséquences profondes pour la physique des particules élémentaires","pour la découverte de la magnétorésistance géante"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12463: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Joseph H. Taylor Jr. a-t-il reçu le Prix Nobel en 1993 ?",
      answers: ["Physiologie ou Médecine","Littérature","Physique","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12464: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Kary B. Mullis a-t-il reçu le Prix Nobel de Chimie pour son invention de la méthode de réaction en chaîne par polymérase (PCR) ?",
      answers: ["1993","2003","1927","1933"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12465: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1993 pour son invention de la méthode de réaction en chaîne par polymérase (PCR) ?",
      answers: ["Kary B. Mullis","Hartmut Michel","Michael Smith","John W. Cornforth"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12466: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Kary B. Mullis a-t-il reçu le Prix Nobel en 1993 ?",
      answers: ["pour la découverte et le développement des polymères conducteurs","pour son invention de la méthode de réaction en chaîne par polymérase (PCR)","pour leurs contributions au développement du concept de conformation et son application en chimie","pour leur préparation d’enzymes et de protéines virales sous une forme pure"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12467: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Kary B. Mullis a-t-il reçu le Prix Nobel en 1993 ?",
      answers: ["Chimie","Paix","Physiologie ou Médecine","Littérature"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12468: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Michael Smith a-t-il reçu le Prix Nobel de Chimie pour ses contributions fondamentales à l’établissement de la mutagenèse dirigée par oligonucléotides ?",
      answers: ["1993","2016","1997","1965"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12469: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1993 pour ses contributions fondamentales à l’établissement de la mutagenèse dirigée par oligonucléotides ?",
      answers: ["Michael Smith","Hartmut Michel","Geoffrey Wilkinson","Kary B. Mullis"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12470: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Michael Smith a-t-il reçu le Prix Nobel en 1993 ?",
      answers: ["pour ses contributions fondamentales à l’établissement de la mutagenèse dirigée par oligonucléotides","pour son travail sur la stéréochimie des réactions enzymatiques","pour leurs découvertes dans le domaine de la chimie et de la technologie des hauts polymères","pour leur développement et leur utilisation de molécules avec des interactions spécifiques de reconnaissance structurale"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12471: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Michael Smith a-t-il reçu le Prix Nobel en 1993 ?",
      answers: ["Paix","Physique","Chimie","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12472: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Phillip A. Sharp a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes sur les gènes discontinus ?",
      answers: ["1993","1992","1996","1995"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12473: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1993 pour leurs découvertes sur les gènes discontinus ?",
      answers: ["Stanley B. Prusiner","Barry J. Marshall","Phillip A. Sharp","Edmond H. Fischer"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12474: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Phillip A. Sharp a-t-il reçu le Prix Nobel en 1993 ?",
      answers: ["pour leurs découvertes sur les gènes discontinus","pour leur découverte des protéines G et leur rôle dans la transduction des signaux dans les cellules","pour leurs découvertes concernant la production d’hormones peptidiques dans le cerveau","pour leurs découvertes concernant les prostaglandines et les substances biologiquement actives apparentées"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12475: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Phillip A. Sharp a-t-il reçu le Prix Nobel en 1993 ?",
      answers: ["Physiologie ou Médecine","Littérature","Physique","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12476: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Richard J. Roberts a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes sur les gènes discontinus ?",
      answers: ["1994","1993","1990","1965"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12477: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1993 pour leurs découvertes sur les gènes discontinus ?",
      answers: ["Richard J. Roberts","Joseph E. Murray","Phillip A. Sharp","Ralph M. Steinman"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12478: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Richard J. Roberts a-t-il reçu le Prix Nobel en 1993 ?",
      answers: ["pour leurs découvertes concernant la spécificité de la réponse immunitaire à médiation cellulaire","pour leurs découvertes concernant la phosphorylation réversible des protéines comme mécanisme de régulation biologique","pour leurs découvertes sur les gènes discontinus","pour leurs découvertes concernant le contrôle génétique du développement précoce de l’embryon"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12479: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Richard J. Roberts a-t-il reçu le Prix Nobel en 1993 ?",
      answers: ["Paix","Physique","Physiologie ou Médecine","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12480: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Toni Morrison a-t-il reçu le Prix Nobel de Littérature qui, dans des romans caractérisés par une force visionnaire et une portée poétique, donne vie à un aspect essentiel de la réalité américaine ?",
      answers: ["1996","1981","1993","1994"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12481: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1993 qui, dans des romans caractérisés par une force visionnaire et une portée poétique, donne vie à un aspect essentiel de la réalité américaine ?",
      answers: ["Camilo José Cela","Toni Morrison","Isaac Bashevis Singer","Joseph Brodsky"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12482: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Toni Morrison a-t-il reçu le Prix Nobel en 1993 ?",
      answers: ["cette épopée de l’expérience féminine qui, avec scepticisme, feu et une force visionnaire, a soumis une civilisation divisée à un examen","qui émule les bouffons du Moyen Âge en flagellant l’autorité et en défendant la dignité des opprimés","qui, dans des romans caractérisés par une force visionnaire et une portée poétique, donne vie à un aspect essentiel de la réalité américaine","pour des œuvres d’une beauté lyrique et d’une profondeur éthique, qui exaltent les miracles du quotidien et le passé vivant"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12483: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Toni Morrison a-t-il reçu le Prix Nobel en 1993 ?",
      answers: ["Paix","Littérature","Physique","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12484: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Nelson Mandela a-t-il reçu le Prix Nobel de Paix pour leur travail pour la fin pacifique du régime de l’apartheid et pour poser les bases d’une nouvelle Afrique du Sud démocratique ?",
      answers: ["1993","1963","1992","1971"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12485: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1993 pour leur travail pour la fin pacifique du régime de l’apartheid et pour poser les bases d’une nouvelle Afrique du Sud démocratique ?",
      answers: ["Rigoberta Menchú Tum","Aung San Suu Kyi","Campagne Internationale pour l’Interdiction des Mines Antipersonnel (ICBL)","Nelson Mandela"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12486: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Nelson Mandela a-t-il reçu le Prix Nobel en 1993 ?",
      answers: ["pour son travail en faveur de la justice sociale et de la réconciliation ethno-culturelle basée sur le respect des droits des peuples indigènes","en reconnaissance de leur travail humanitaire pionnier dans plusieurs continents","pour son rôle de leader dans le processus de paix qui a marqué une étape importante dans l’histoire mondiale","pour leur travail pour la fin pacifique du régime de l’apartheid et pour poser les bases d’une nouvelle Afrique du Sud démocratique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12487: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Nelson Mandela a-t-il reçu le Prix Nobel en 1993 ?",
      answers: ["Physique","Chimie","Paix","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12488: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Frederik Willem de Klerk a-t-il reçu le Prix Nobel de Paix pour leur travail pour la fin pacifique du régime de l’apartheid et pour poser les bases d’une nouvelle Afrique du Sud démocratique ?",
      answers: ["1993","1988","1980","2018"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12489: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1993 pour leur travail pour la fin pacifique du régime de l’apartheid et pour poser les bases d’une nouvelle Afrique du Sud démocratique ?",
      answers: ["Juan Manuel Santos","Frederik Willem de Klerk","Malala Yousafzai","Mouvement Pugwash"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12490: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Frederik Willem de Klerk a-t-il reçu le Prix Nobel en 1993 ?",
      answers: ["pour leur travail pour la fin pacifique du régime de l’apartheid et pour poser les bases d’une nouvelle Afrique du Sud démocratique","pour leur lutte non violente pour la sécurité des femmes et pour les droits des femmes à participer pleinement aux processus de paix","en reconnaissance de leur travail humanitaire pionnier dans plusieurs continents","pour son travail en faveur de la justice sociale et de la réconciliation ethno-culturelle basée sur le respect des droits des peuples indigènes"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12491: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Frederik Willem de Klerk a-t-il reçu le Prix Nobel en 1993 ?",
      answers: ["Physique","Chimie","Physiologie ou Médecine","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12492: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Robert W. Fogel a-t-il reçu le Prix Nobel de Sciences Économiques pour avoir renouvelé la recherche en histoire économique en appliquant la théorie économique et les méthodes quantitatives ?",
      answers: ["1974","1973","1992","1993"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12493: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1993 pour avoir renouvelé la recherche en histoire économique en appliquant la théorie économique et les méthodes quantitatives ?",
      answers: ["Robert F. Engle","Reinhard Selten","George J. Stigler","Robert W. Fogel"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12494: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Robert W. Fogel a-t-il reçu le Prix Nobel en 1993 ?",
      answers: ["pour avoir étendu l’analyse microéconomique à une large gamme de comportements humains et d’interactions","pour ses études pionnières sur les structures industrielles, le fonctionnement des marchés et les causes et effets de la régulation publique","pour avoir renouvelé la recherche en histoire économique en appliquant la théorie économique et les méthodes quantitatives","pour ses méthodes d’analyse des séries temporelles économiques avec co-intégration"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12495: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Robert W. Fogel a-t-il reçu le Prix Nobel en 1993 ?",
      answers: ["Chimie","Paix","Sciences Économiques","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12496: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Douglass C. North a-t-il reçu le Prix Nobel de Sciences Économiques pour avoir renouvelé la recherche en histoire économique en appliquant la théorie économique et les méthodes quantitatives ?",
      answers: ["2002","1993","2023","2017"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12497: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1993 pour avoir renouvelé la recherche en histoire économique en appliquant la théorie économique et les méthodes quantitatives ?",
      answers: ["Finn E. Kydland","James A. Mirrlees","Douglass C. North","Daniel L. McFadden"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12498: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Douglass C. North a-t-il reçu le Prix Nobel en 1993 ?",
      answers: ["pour leurs contributions pionnières à la théorie de l’économie financière","pour ses méthodes d’analyse des données microéconomiques","pour sa découverte et sa clarification de la signification des coûts de transaction et des droits de propriété dans la structure économique","pour avoir renouvelé la recherche en histoire économique en appliquant la théorie économique et les méthodes quantitatives"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12499: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Douglass C. North a-t-il reçu le Prix Nobel en 1993 ?",
      answers: ["Physiologie ou Médecine","Chimie","Physique","Sciences Économiques"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12500: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Bertram N. Brockhouse a-t-il reçu le Prix Nobel de Physique pour le développement de la spectroscopie neutronique ?",
      answers: ["2010","1961","1994","2009"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12501: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1994 pour le développement de la spectroscopie neutronique ?",
      answers: ["Frederick Reines","Klaus von Klitzing","Bertram N. Brockhouse","Gerd Binnig"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12502: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Bertram N. Brockhouse a-t-il reçu le Prix Nobel en 1994 ?",
      answers: ["pour le développement de la spectroscopie neutronique","pour la détection du neutrino","pour le développement de la technique du piège à ions","pour ses études théoriques des processus physiques importants pour la structure et l’évolution des étoiles"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12503: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Bertram N. Brockhouse a-t-il reçu le Prix Nobel en 1994 ?",
      answers: ["Physiologie ou Médecine","Physique","Paix","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12504: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Clifford G. Shull a-t-il reçu le Prix Nobel de Physique pour le développement de la technique de diffraction neutronique ?",
      answers: ["1994","2008","1996","1993"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12505: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1994 pour le développement de la technique de diffraction neutronique ?",
      answers: ["Jack Steinberger","Clifford G. Shull","Martin L. Perl","Raymond Davis Jr."],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12506: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Clifford G. Shull a-t-il reçu le Prix Nobel en 1994 ?",
      answers: ["pour le développement de la technique de diffraction neutronique","pour la découverte du lepton tau","pour leurs contributions pionnières à la théorie des supraconducteurs et des superfluides","pour la détection du neutrino"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12507: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Clifford G. Shull a-t-il reçu le Prix Nobel en 1994 ?",
      answers: ["Physique","Littérature","Physiologie ou Médecine","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12508: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année George A. Olah a-t-il reçu le Prix Nobel de Chimie pour sa contribution à la chimie des carbocations ?",
      answers: ["1984","1989","1994","1966"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12509: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1994 pour sa contribution à la chimie des carbocations ?",
      answers: ["George A. Olah","Paul J. Crutzen","John Jumper","Brian K. Kobilka"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12510: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison George A. Olah a-t-il reçu le Prix Nobel en 1994 ?",
      answers: ["pour leurs travaux sur la chimie de l’atmosphère, notamment concernant la formation et la décomposition de l’ozone","pour sa contribution à la chimie des carbocations","pour leur découverte des fullerènes","pour ses contributions fondamentales à l’établissement de la mutagenèse dirigée par oligonucléotides"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12511: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie George A. Olah a-t-il reçu le Prix Nobel en 1994 ?",
      answers: ["Paix","Physiologie ou Médecine","Physique","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12512: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Alfred G. Gilman a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leur découverte des protéines G et leur rôle dans la transduction des signaux dans les cellules ?",
      answers: ["1995","1985","1932","1994"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12513: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1994 pour leur découverte des protéines G et leur rôle dans la transduction des signaux dans les cellules ?",
      answers: ["Martin Rodbell","Robert G. Edwards","Barry J. Marshall","Alfred G. Gilman"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12514: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Alfred G. Gilman a-t-il reçu le Prix Nobel en 1994 ?",
      answers: ["pour leur découverte des protéines G et leur rôle dans la transduction des signaux dans les cellules","pour leurs découvertes concernant le monoxyde d’azote comme molécule de signalisation dans le système cardiovasculaire","pour leurs découvertes concernant les prostaglandines et les substances biologiquement actives apparentées","pour leur découverte du virus de l’immunodéficience humaine (VIH)"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12515: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Alfred G. Gilman a-t-il reçu le Prix Nobel en 1994 ?",
      answers: ["Physiologie ou Médecine","Chimie","Paix","Sciences Économiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12516: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Martin Rodbell a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leur découverte des protéines G et leur rôle dans la transduction des signaux dans les cellules ?",
      answers: ["1999","1994","2020","1990"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12517: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1994 pour leur découverte des protéines G et leur rôle dans la transduction des signaux dans les cellules ?",
      answers: ["Konrad Lorenz","Louis J. Ignarro","Johannes A.B. Fibiger","Martin Rodbell"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12518: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Martin Rodbell a-t-il reçu le Prix Nobel en 1994 ?",
      answers: ["pour ses découvertes concernant la transmission des signaux dans le système nerveux","pour leur découverte des protéines G et leur rôle dans la transduction des signaux dans les cellules","pour leurs découvertes concernant le contrôle génétique du développement précoce de l’embryon","pour leurs découvertes sur les gènes discontinus"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12519: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Martin Rodbell a-t-il reçu le Prix Nobel en 1994 ?",
      answers: ["Physiologie ou Médecine","Chimie","Physique","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12520: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Kenzaburo Oe a-t-il reçu le Prix Nobel de Littérature qui, avec une force poétique, crée un monde imaginaire où la vie et le mythe se condensent pour former une image déconcertante de la condition humaine actuelle ?",
      answers: ["1994","1987","1919","2024"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12521: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1994 qui, avec une force poétique, crée un monde imaginaire où la vie et le mythe se condensent pour former une image déconcertante de la condition humaine actuelle ?",
      answers: ["Mo Yan","V. S. Naipaul","Juan Ramón Jiménez","Kenzaburo Oe"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12522: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Kenzaburo Oe a-t-il reçu le Prix Nobel en 1994 ?",
      answers: ["qui, dans des romans caractérisés par une force visionnaire et une portée poétique, donne vie à un aspect essentiel de la réalité américaine","qui, avec une force poétique, crée un monde imaginaire où la vie et le mythe se condensent pour former une image déconcertante de la condition humaine actuelle","qui émule les bouffons du Moyen Âge en flagellant l’autorité et en défendant la dignité des opprimés","pour une poésie qui, avec une précision ironique, permet au contexte historique et biologique de se manifester dans des fragments de réalité humaine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12523: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Kenzaburo Oe a-t-il reçu le Prix Nobel en 1994 ?",
      answers: ["Chimie","Physique","Paix","Littérature"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12524: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Yasser Arafat a-t-il reçu le Prix Nobel de Paix pour leurs efforts visant à créer la paix au Moyen-Orient ?",
      answers: ["2002","2014","1994","2003"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12525: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1994 pour leurs efforts visant à créer la paix au Moyen-Orient ?",
      answers: ["Ales Bialiatski","Leymah Gbowee","Shimon Peres","Yasser Arafat"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12526: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Yasser Arafat a-t-il reçu le Prix Nobel en 1994 ?",
      answers: ["pour leurs efforts visant à réduire le rôle des armes nucléaires dans la politique internationale","pour leur contribution à la réduction des tensions et à la promotion de la paix dans le monde","pour son travail en faveur de la paix en Amérique centrale","pour leurs efforts visant à créer la paix au Moyen-Orient"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12527: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Yasser Arafat a-t-il reçu le Prix Nobel en 1994 ?",
      answers: ["Paix","Sciences Économiques","Physiologie ou Médecine","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12528: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Shimon Peres a-t-il reçu le Prix Nobel de Paix pour leurs efforts visant à créer la paix au Moyen-Orient ?",
      answers: ["1994","1972","1973","2002"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12529: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1994 pour leurs efforts visant à créer la paix au Moyen-Orient ?",
      answers: ["Shimon Peres","Lester B. Pearson","Médecins Sans Frontières","Joseph Rotblat"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12530: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Shimon Peres a-t-il reçu le Prix Nobel en 1994 ?",
      answers: ["pour leurs efforts visant à réduire le rôle des armes nucléaires dans la politique internationale","pour son travail humanitaire exceptionnel pendant la Seconde Guerre mondiale","pour leurs efforts visant à créer la paix au Moyen-Orient","pour son travail pour la démocratie et les droits humains en Corée du Sud et en Asie de l’Est, et pour la paix avec la Corée du Nord"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12531: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Shimon Peres a-t-il reçu le Prix Nobel en 1994 ?",
      answers: ["Paix","Physiologie ou Médecine","Littérature","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12532: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Yitzhak Rabin a-t-il reçu le Prix Nobel de Paix pour leurs efforts visant à créer la paix au Moyen-Orient ?",
      answers: ["1993","1995","1957","1994"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12533: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1994 pour leurs efforts visant à créer la paix au Moyen-Orient ?",
      answers: ["Mouvement Pugwash","Alva Myrdal","Joseph Rotblat","Yitzhak Rabin"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12534: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Yitzhak Rabin a-t-il reçu le Prix Nobel en 1994 ?",
      answers: ["pour ses efforts extraordinaires visant à renforcer la diplomatie internationale et la coopération entre les peuples","pour leurs efforts visant à créer la paix au Moyen-Orient","en reconnaissance de leur travail humanitaire pionnier dans plusieurs continents","pour leur travail pour la fin pacifique du régime de l’apartheid et pour poser les bases d’une nouvelle Afrique du Sud démocratique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12535: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Yitzhak Rabin a-t-il reçu le Prix Nobel en 1994 ?",
      answers: ["Chimie","Paix","Sciences Économiques","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12536: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année John C. Harsanyi a-t-il reçu le Prix Nobel de Sciences Économiques pour leurs analyses pionnières des équilibres dans la théorie des jeux non coopératifs ?",
      answers: ["2007","1993","1994","2003"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12537: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1994 pour leurs analyses pionnières des équilibres dans la théorie des jeux non coopératifs ?",
      answers: ["Daniel Kahneman","John F. Nash Jr.","John C. Harsanyi","Robert E. Lucas Jr."],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12538: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison John C. Harsanyi a-t-il reçu le Prix Nobel en 1994 ?",
      answers: ["pour ses méthodes d’analyse des données microéconomiques","pour leurs analyses pionnières des équilibres dans la théorie des jeux non coopératifs","pour ses méthodes d’analyse des séries temporelles économiques avec co-intégration","pour avoir renouvelé la recherche en histoire économique en appliquant la théorie économique et les méthodes quantitatives"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12539: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie John C. Harsanyi a-t-il reçu le Prix Nobel en 1994 ?",
      answers: ["Littérature","Physique","Sciences Économiques","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12540: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année John F. Nash Jr. a-t-il reçu le Prix Nobel de Sciences Économiques pour leurs analyses pionnières des équilibres dans la théorie des jeux non coopératifs ?",
      answers: ["1976","1996","1994","1992"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12541: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1994 pour leurs analyses pionnières des équilibres dans la théorie des jeux non coopératifs ?",
      answers: ["Guido W. Imbens","William Vickrey","James A. Mirrlees","John F. Nash Jr."],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12542: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison John F. Nash Jr. a-t-il reçu le Prix Nobel en 1994 ?",
      answers: ["pour ses méthodes d’analyse des choix discrets en économie","pour leurs analyses pionnières des équilibres dans la théorie des jeux non coopératifs","pour avoir développé et appliqué l’hypothèse des anticipations rationnelles","pour leurs contributions fondamentales à la théorie économique des incitations sous information asymétrique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12543: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie John F. Nash Jr. a-t-il reçu le Prix Nobel en 1994 ?",
      answers: ["Sciences Économiques","Paix","Physiologie ou Médecine","Littérature"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12544: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Reinhard Selten a-t-il reçu le Prix Nobel de Sciences Économiques pour leurs analyses pionnières des équilibres dans la théorie des jeux non coopératifs ?",
      answers: ["1997","1919","1994","1992"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12545: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1994 pour leurs analyses pionnières des équilibres dans la théorie des jeux non coopératifs ?",
      answers: ["John C. Harsanyi","Robert W. Fogel","Reinhard Selten","James A. Mirrlees"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12546: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Reinhard Selten a-t-il reçu le Prix Nobel en 1994 ?",
      answers: ["pour leurs analyses pionnières des équilibres dans la théorie des jeux non coopératifs","pour leurs contributions pionnières à la théorie de l’équilibre économique général et à la théorie du bien-être","pour son développement des bases contractuelles et constitutionnelles de la théorie des décisions économiques et politiques","pour leurs contributions fondamentales à la théorie économique des incitations sous information asymétrique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12547: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Reinhard Selten a-t-il reçu le Prix Nobel en 1994 ?",
      answers: ["Littérature","Sciences Économiques","Physique","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12548: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Martin L. Perl a-t-il reçu le Prix Nobel de Physique pour la découverte du lepton tau ?",
      answers: ["1986","1995","2000","1996"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12549: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1995 pour la découverte du lepton tau ?",
      answers: ["Bertram N. Brockhouse","Robert W. Wilson","Martin L. Perl","Ferenc Krausz"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12550: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Martin L. Perl a-t-il reçu le Prix Nobel en 1995 ?",
      answers: ["pour le développement de la spectroscopie neutronique","pour la découverte du lepton tau","pour leur théorie développée conjointement de la supraconductivité, généralement appelée la théorie BCS","pour la découverte d’un objet compact supermassif au centre de notre galaxie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12551: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Martin L. Perl a-t-il reçu le Prix Nobel en 1995 ?",
      answers: ["Paix","Physique","Physiologie ou Médecine","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12552: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Frederick Reines a-t-il reçu le Prix Nobel de Physique pour la détection du neutrino ?",
      answers: ["1995","1999","2002","1992"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12553: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1995 pour la détection du neutrino ?",
      answers: ["Frederick Reines","Nevill F. Mott","Isamu Akasaki","Martin L. Perl"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12554: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Frederick Reines a-t-il reçu le Prix Nobel en 1995 ?",
      answers: ["pour leur découverte de la superfluidité dans l’hélium-3","pour leurs contributions à la théorie unifiée des interactions faible et électromagnétique entre particules élémentaires","pour la détection du neutrino","pour le développement de semi-conducteurs utilisés dans l’électronique à haute vitesse et l’optoélectronique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12555: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Frederick Reines a-t-il reçu le Prix Nobel en 1995 ?",
      answers: ["Chimie","Physique","Physiologie ou Médecine","Littérature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12556: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Paul J. Crutzen a-t-il reçu le Prix Nobel de Chimie pour leurs travaux sur la chimie de l’atmosphère, notamment concernant la formation et la décomposition de l’ozone ?",
      answers: ["1973","1995","2008","1986"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12557: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1995 pour leurs travaux sur la chimie de l’atmosphère, notamment concernant la formation et la décomposition de l’ozone ?",
      answers: ["Mario J. Molina","Roger D. Kornberg","Paul J. Crutzen","Robert F. Curl Jr."],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12558: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Paul J. Crutzen a-t-il reçu le Prix Nobel en 1995 ?",
      answers: ["pour son travail sur les réactions d’oxydation catalysées de manière chirale","pour ses contributions fondamentales à l’établissement de la mutagenèse dirigée par oligonucléotides","pour leurs travaux sur la chimie de l’atmosphère, notamment concernant la formation et la décomposition de l’ozone","pour leurs recherches sur la fermentation des sucres et les enzymes fermentatives"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12559: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Paul J. Crutzen a-t-il reçu le Prix Nobel en 1995 ?",
      answers: ["Physiologie ou Médecine","Chimie","Sciences Économiques","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12560: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Mario J. Molina a-t-il reçu le Prix Nobel de Chimie pour leurs travaux sur la chimie de l’atmosphère, notamment concernant la formation et la décomposition de l’ozone ?",
      answers: ["2006","2000","1996","1995"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12561: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1995 pour leurs travaux sur la chimie de l’atmosphère, notamment concernant la formation et la décomposition de l’ozone ?",
      answers: ["Mario J. Molina","F. Sherwood Rowland","Jerome Karle","Alan J. Heeger"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12562: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Mario J. Molina a-t-il reçu le Prix Nobel en 1995 ?",
      answers: ["pour leurs travaux sur la chimie de l’atmosphère, notamment concernant la formation et la décomposition de l’ozone","pour la découverte et le développement des polymères conducteurs","pour la première découverte d’une enzyme transportant des ions, la Na+, K+-ATPase","pour son développement de la théorie de la fonctionnelle de la densité"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12563: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Mario J. Molina a-t-il reçu le Prix Nobel en 1995 ?",
      answers: ["Physiologie ou Médecine","Littérature","Physique","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12564: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année F. Sherwood Rowland a-t-il reçu le Prix Nobel de Chimie pour leurs travaux sur la chimie de l’atmosphère, notamment concernant la formation et la décomposition de l’ozone ?",
      answers: ["2003","1995","1994","1997"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12565: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1995 pour leurs travaux sur la chimie de l’atmosphère, notamment concernant la formation et la décomposition de l’ozone ?",
      answers: ["Rudolph A. Marcus","Roger Y. Tsien","F. Sherwood Rowland","Roger D. Kornberg"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12566: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison F. Sherwood Rowland a-t-il reçu le Prix Nobel en 1995 ?",
      answers: ["pour leur découverte des fullerènes","pour son travail sur les réactions d’oxydation catalysées de manière chirale","pour sa contribution à la chimie des carbocations","pour leurs travaux sur la chimie de l’atmosphère, notamment concernant la formation et la décomposition de l’ozone"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12567: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie F. Sherwood Rowland a-t-il reçu le Prix Nobel en 1995 ?",
      answers: ["Littérature","Chimie","Physiologie ou Médecine","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12568: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Edward B. Lewis a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant le contrôle génétique du développement précoce de l’embryon ?",
      answers: ["2009","1995","1992","1960"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12569: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1995 pour leurs découvertes concernant le contrôle génétique du développement précoce de l’embryon ?",
      answers: ["Sir John Eccles","Richard J. Roberts","Edmond H. Fischer","Edward B. Lewis"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12570: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Edward B. Lewis a-t-il reçu le Prix Nobel en 1995 ?",
      answers: ["pour leurs découvertes concernant le contrôle génétique du développement précoce de l’embryon","pour sa découverte du principe génétique de la génération de la diversité des anticorps","pour sa découverte du Spiroptera carcinoma","pour leurs découvertes sur le système de transport vésiculaire dans les cellules"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12571: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Edward B. Lewis a-t-il reçu le Prix Nobel en 1995 ?",
      answers: ["Physiologie ou Médecine","Physique","Chimie","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12572: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Christiane Nüsslein-Volhard a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant le contrôle génétique du développement précoce de l’embryon ?",
      answers: ["2000","1996","1994","1995"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12573: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1995 pour leurs découvertes concernant le contrôle génétique du développement précoce de l’embryon ?",
      answers: ["William C. Campbell","Peter C. Doherty","Christiane Nüsslein-Volhard","Renato Dulbecco"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12574: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Christiane Nüsslein-Volhard a-t-il reçu le Prix Nobel en 1995 ?",
      answers: ["pour leurs découvertes sur les gènes discontinus","pour leurs découvertes concernant le contrôle génétique du développement précoce de l’embryon","pour leurs découvertes concernant la transmission chimique des impulsions nerveuses","pour leurs découvertes concernant les processus physiologiques et chimiques primaires dans la vision"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12575: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Christiane Nüsslein-Volhard a-t-il reçu le Prix Nobel en 1995 ?",
      answers: ["Physiologie ou Médecine","Physique","Paix","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12576: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Eric F. Wieschaus a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant le contrôle génétique du développement précoce de l’embryon ?",
      answers: ["1996","1983","1986","1995"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12577: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1995 pour leurs découvertes concernant le contrôle génétique du développement précoce de l’embryon ?",
      answers: ["Jules A. Hoffmann","Eric F. Wieschaus","Paul Greengard","Edwin G. Krebs"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12578: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Eric F. Wieschaus a-t-il reçu le Prix Nobel en 1995 ?",
      answers: ["pour leurs découvertes sur les gènes discontinus","pour leur interprétation du code génétique et sa fonction dans la synthèse des protéines","pour leurs découvertes concernant le contrôle génétique du développement précoce de l’embryon","pour leurs découvertes concernant la phosphorylation réversible des protéines comme mécanisme de régulation biologique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12579: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Eric F. Wieschaus a-t-il reçu le Prix Nobel en 1995 ?",
      answers: ["Chimie","Physique","Physiologie ou Médecine","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12580: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Seamus Heaney a-t-il reçu le Prix Nobel de Littérature pour des œuvres d’une beauté lyrique et d’une profondeur éthique, qui exaltent les miracles du quotidien et le passé vivant ?",
      answers: ["1995","1902","1984","1948"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12581: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1995 pour des œuvres d’une beauté lyrique et d’une profondeur éthique, qui exaltent les miracles du quotidien et le passé vivant ?",
      answers: ["Günter Grass","Eugene O’Neill","Seamus Heaney","Juan Ramón Jiménez"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12582: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Seamus Heaney a-t-il reçu le Prix Nobel en 1995 ?",
      answers: ["pour des œuvres d’une beauté lyrique et d’une profondeur éthique, qui exaltent les miracles du quotidien et le passé vivant","qui, dans des romans caractérisés par une force visionnaire et une portée poétique, donne vie à un aspect essentiel de la réalité américaine","qui, dans ses romans, combine la créativité du poète et du peintre avec une profonde conscience du temps dans la représentation de la condition humaine","pour la puissance artistique et l’intégrité avec lesquelles il a dépeint une phase historique dans la vie du peuple russe dans son épopée du Don"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12583: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Seamus Heaney a-t-il reçu le Prix Nobel en 1995 ?",
      answers: ["Paix","Littérature","Sciences Économiques","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12584: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Joseph Rotblat a-t-il reçu le Prix Nobel de Paix pour leurs efforts visant à réduire le rôle des armes nucléaires dans la politique internationale ?",
      answers: ["1993","1991","1974","1995"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12585: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1995 pour leurs efforts visant à réduire le rôle des armes nucléaires dans la politique internationale ?",
      answers: ["Grameen Bank","Bureau International Permanent de la Paix","Joseph Rotblat","Organisation pour l’Interdiction des Armes Chimiques (OIAC)"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12586: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Joseph Rotblat a-t-il reçu le Prix Nobel en 1995 ?",
      answers: ["pour son travail en faveur de la paix en Amérique centrale","pour leurs efforts visant à réduire le rôle des armes nucléaires dans la politique internationale","pour son rôle de leader dans le processus de paix qui a marqué une étape importante dans l’histoire mondiale","pour leurs efforts visant à trouver une solution pacifique au conflit en Irlande du Nord"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12587: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Joseph Rotblat a-t-il reçu le Prix Nobel en 1995 ?",
      answers: ["Littérature","Physique","Chimie","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12588: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Mouvement Pugwash a-t-il reçu le Prix Nobel de Paix pour leurs efforts visant à réduire le rôle des armes nucléaires dans la politique internationale ?",
      answers: ["1994","1995","1993","1997"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12589: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1995 pour leurs efforts visant à réduire le rôle des armes nucléaires dans la politique internationale ?",
      answers: ["Shimon Peres","Yitzhak Rabin","Médecins Sans Frontières","Mouvement Pugwash"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12590: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Mouvement Pugwash a-t-il reçu le Prix Nobel en 1995 ?",
      answers: ["pour leur travail en faveur d’une solution juste et pacifique au conflit au Timor oriental","pour leurs efforts visant à créer la paix au Moyen-Orient","pour leurs efforts visant à réduire le rôle des armes nucléaires dans la politique internationale","pour sa lutte non violente pour la liberté syndicale et les droits des travailleurs en Pologne"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12591: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Mouvement Pugwash a-t-il reçu le Prix Nobel en 1995 ?",
      answers: ["Physique","Chimie","Paix","Sciences Économiques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12592: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Robert E. Lucas Jr. a-t-il reçu le Prix Nobel de Sciences Économiques pour avoir développé et appliqué l’hypothèse des anticipations rationnelles ?",
      answers: ["1995","2013","1993","1996"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12593: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1995 pour avoir développé et appliqué l’hypothèse des anticipations rationnelles ?",
      answers: ["Milton Friedman","Reinhard Selten","Michael Kremer","Robert E. Lucas Jr."],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12594: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Robert E. Lucas Jr. a-t-il reçu le Prix Nobel en 1995 ?",
      answers: ["pour ses contributions à l’économie du bien-être","pour avoir développé et appliqué l’hypothèse des anticipations rationnelles","pour leur analyse des marchés avec information asymétrique","pour avoir amélioré notre compréhension des conflits et de la coopération à travers l’analyse de la théorie des jeux"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12595: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Robert E. Lucas Jr. a-t-il reçu le Prix Nobel en 1995 ?",
      answers: ["Paix","Sciences Économiques","Littérature","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12596: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année David M. Lee a-t-il reçu le Prix Nobel de Physique pour leur découverte de la superfluidité dans l’hélium-3 ?",
      answers: ["1983","1992","1996","1988"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12597: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1996 pour leur découverte de la superfluidité dans l’hélium-3 ?",
      answers: ["Daniel C. Tsui","David M. Lee","Joseph H. Taylor Jr.","Martin L. Perl"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12598: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison David M. Lee a-t-il reçu le Prix Nobel en 1996 ?",
      answers: ["pour leur découverte de la superfluidité dans l’hélium-3","pour son travail fondamental sur l’optique électronique et la conception du premier microscope électronique","pour la découverte de la liberté asymptotique dans la théorie de l’interaction forte","pour leur théorie développée conjointement de la supraconductivité, généralement appelée la théorie BCS"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12599: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie David M. Lee a-t-il reçu le Prix Nobel en 1996 ?",
      answers: ["Physiologie ou Médecine","Chimie","Physique","Sciences Économiques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12600: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Douglas D. Osheroff a-t-il reçu le Prix Nobel de Physique pour leur découverte de la superfluidité dans l’hélium-3 ?",
      answers: ["1996","1978","2000","1959"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12601: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1996 pour leur découverte de la superfluidité dans l’hélium-3 ?",
      answers: ["Hiroshi Amano","Horst L. Störmer","Douglas D. Osheroff","John Bardeen"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12602: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Douglas D. Osheroff a-t-il reçu le Prix Nobel en 1996 ?",
      answers: ["pour le développement de méthodes pour refroidir et piéger les atomes avec la lumière laser","pour la découverte d’un nouveau type de pulsar, une découverte qui a ouvert de nouvelles possibilités pour l’étude de la gravitation","pour leur conception du microscope à effet tunnel","pour leur découverte de la superfluidité dans l’hélium-3"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12603: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Douglas D. Osheroff a-t-il reçu le Prix Nobel en 1996 ?",
      answers: ["Physique","Paix","Littérature","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12604: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Robert C. Richardson a-t-il reçu le Prix Nobel de Physique pour leur découverte de la superfluidité dans l’hélium-3 ?",
      answers: ["1995","1996","1991","1953"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12605: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1996 pour leur découverte de la superfluidité dans l’hélium-3 ?",
      answers: ["Luis W. Alvarez","Peter W. Higgs","Frederick Reines","Robert C. Richardson"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12606: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Robert C. Richardson a-t-il reçu le Prix Nobel en 1996 ?",
      answers: ["pour leur contribution au développement de la spectroscopie laser","pour leur découverte de la superfluidité dans l’hélium-3","pour des découvertes théoriques sur les transitions de phase topologiques et les phases topologiques de la matière","pour leurs contributions fondamentales à la compréhension des interactions électrofaibles dans la théorie quantique des champs"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12607: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Robert C. Richardson a-t-il reçu le Prix Nobel en 1996 ?",
      answers: ["Sciences Économiques","Paix","Physiologie ou Médecine","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12608: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Robert F. Curl Jr. a-t-il reçu le Prix Nobel de Chimie pour leur découverte des fullerènes ?",
      answers: ["1996","1997","1990","1931"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12609: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1996 pour leur découverte des fullerènes ?",
      answers: ["Robert F. Curl Jr.","Richard E. Smalley","Max F. Perutz","John B. Fenn"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12610: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Robert F. Curl Jr. a-t-il reçu le Prix Nobel en 1996 ?",
      answers: ["pour leur découverte des fullerènes","pour leurs contributions à la dynamique des processus chimiques élémentaires","pour la découverte et le développement des polymères conducteurs","pour son développement de la théorie de la fonctionnelle de la densité"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12611: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Robert F. Curl Jr. a-t-il reçu le Prix Nobel en 1996 ?",
      answers: ["Chimie","Physique","Physiologie ou Médecine","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12612: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Sir Harold W. Kroto a-t-il reçu le Prix Nobel de Chimie pour leur découverte des fullerènes ?",
      answers: ["1996","1964","1991","2002"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12613: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1996 pour leur découverte des fullerènes ?",
      answers: ["Alfred Werner","John A. Pople","Sir Harold W. Kroto","Ahmed H. Zewail"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12614: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Sir Harold W. Kroto a-t-il reçu le Prix Nobel en 1996 ?",
      answers: ["pour leurs travaux sur la chimie de l’atmosphère, notamment concernant la formation et la décomposition de l’ozone","pour la détermination de la structure tridimensionnelle d’un centre réactionnel photosynthétique","pour leur découverte des fullerènes","pour leur élucidation du mécanisme enzymatique sous-jacent à la synthèse de l’adénosine triphosphate (ATP)"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12615: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Sir Harold W. Kroto a-t-il reçu le Prix Nobel en 1996 ?",
      answers: ["Chimie","Paix","Littérature","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12616: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Richard E. Smalley a-t-il reçu le Prix Nobel de Chimie pour leur découverte des fullerènes ?",
      answers: ["1996","1998","1986","2006"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12617: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1996 pour leur découverte des fullerènes ?",
      answers: ["Richard R. Ernst","Richard E. Smalley","Johann Deisenhofer","Gerhard Ertl"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12618: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Richard E. Smalley a-t-il reçu le Prix Nobel en 1996 ?",
      answers: ["pour le développement de la spectroscopie par résonance magnétique nucléaire pour déterminer la structure tridimensionnelle des macromolécules biologiques","pour la première découverte d’une enzyme transportant des ions, la Na+, K+-ATPase","pour son développement de la théorie de la fonctionnelle de la densité","pour leur découverte des fullerènes"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12619: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Richard E. Smalley a-t-il reçu le Prix Nobel en 1996 ?",
      answers: ["Physique","Chimie","Paix","Littérature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12620: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Peter C. Doherty a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant la spécificité de la réponse immunitaire à médiation cellulaire ?",
      answers: ["2003","1996","2019","1999"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12621: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1996 pour leurs découvertes concernant la spécificité de la réponse immunitaire à médiation cellulaire ?",
      answers: ["Robert F. Furchgott","Peter C. Doherty","Sydney Brenner","Howard M. Temin"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12622: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Peter C. Doherty a-t-il reçu le Prix Nobel en 1996 ?",
      answers: ["pour leurs découvertes sur les gènes discontinus","pour la découverte du virus de l’hépatite C","pour leurs découvertes concernant le monoxyde d’azote comme molécule de signalisation dans le système cardiovasculaire","pour leurs découvertes concernant la spécificité de la réponse immunitaire à médiation cellulaire"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12623: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Peter C. Doherty a-t-il reçu le Prix Nobel en 1996 ?",
      answers: ["Physique","Physiologie ou Médecine","Littérature","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12624: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Rolf M. Zinkernagel a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant la spécificité de la réponse immunitaire à médiation cellulaire ?",
      answers: ["1995","1966","1996","2000"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12625: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1996 pour leurs découvertes concernant la spécificité de la réponse immunitaire à médiation cellulaire ?",
      answers: ["Rolf M. Zinkernagel","Stanley B. Prusiner","Martin Rodbell","Peter C. Doherty"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12626: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Rolf M. Zinkernagel a-t-il reçu le Prix Nobel en 1996 ?",
      answers: ["pour leurs découvertes sur les gènes discontinus","pour leurs découvertes concernant la production d’hormones peptidiques dans le cerveau","pour leurs découvertes concernant le monoxyde d’azote comme molécule de signalisation dans le système cardiovasculaire","pour leurs découvertes concernant la spécificité de la réponse immunitaire à médiation cellulaire"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12627: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Rolf M. Zinkernagel a-t-il reçu le Prix Nobel en 1996 ?",
      answers: ["Littérature","Chimie","Paix","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12628: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Wisława Szymborska a-t-il reçu le Prix Nobel de Littérature pour une poésie qui, avec une précision ironique, permet au contexte historique et biologique de se manifester dans des fragments de réalité humaine ?",
      answers: ["1977","2014","1945","1996"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12629: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1996 pour une poésie qui, avec une précision ironique, permet au contexte historique et biologique de se manifester dans des fragments de réalité humaine ?",
      answers: ["Bob Dylan","Wisława Szymborska","Gao Xingjian","Annie Ernaux"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12630: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Wisława Szymborska a-t-il reçu le Prix Nobel en 1996 ?",
      answers: ["dont les contes burlesques et noirs dépeignent le visage oublié de l’histoire","qui, avec des paraboles soutenues par l’imagination, la compassion et l’ironie, nous permet de saisir une réalité évasive","qui, avec un réalisme hallucinatoire, fusionne contes populaires, histoire et contemporain","pour une poésie qui, avec une précision ironique, permet au contexte historique et biologique de se manifester dans des fragments de réalité humaine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12631: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Wisława Szymborska a-t-il reçu le Prix Nobel en 1996 ?",
      answers: ["Physiologie ou Médecine","Littérature","Physique","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12632: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Carlos Filipe Ximenes Belo a-t-il reçu le Prix Nobel de Paix pour leur travail en faveur d’une solution juste et pacifique au conflit au Timor oriental ?",
      answers: ["1996","2023","2010","1998"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12633: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1996 pour leur travail en faveur d’une solution juste et pacifique au conflit au Timor oriental ?",
      answers: ["Yasser Arafat","Joseph Rotblat","Mouvement Pugwash","Carlos Filipe Ximenes Belo"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12634: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Carlos Filipe Ximenes Belo a-t-il reçu le Prix Nobel en 1996 ?",
      answers: ["pour sa lutte longue et non violente pour les droits humains fondamentaux en Chine","pour leur travail visant à interdire et éliminer les mines antipersonnel","pour ses contributions à la révolution verte, augmentant la production alimentaire mondiale","pour leur travail en faveur d’une solution juste et pacifique au conflit au Timor oriental"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12635: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Carlos Filipe Ximenes Belo a-t-il reçu le Prix Nobel en 1996 ?",
      answers: ["Physiologie ou Médecine","Physique","Paix","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12636: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année José Ramos-Horta a-t-il reçu le Prix Nobel de Paix pour leur travail en faveur d’une solution juste et pacifique au conflit au Timor oriental ?",
      answers: ["1995","1996","1981","1962"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12637: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1996 pour leur travail en faveur d’une solution juste et pacifique au conflit au Timor oriental ?",
      answers: ["Conseil des Amis pour le Service (Quakers britanniques)","José Ramos-Horta","Bureau International du Travail (BIT)","Campagne Internationale pour l’Interdiction des Mines Antipersonnel (ICBL)"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12638: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison José Ramos-Horta a-t-il reçu le Prix Nobel en 1996 ?",
      answers: ["pour leur travail en faveur d’une solution juste et pacifique au conflit au Timor oriental","pour son rôle de figure unificatrice dans la campagne non violente contre l’apartheid en Afrique du Sud","pour leurs efforts visant à réduire le rôle des armes nucléaires dans la politique internationale","pour leur lutte non violente pour la sécurité des femmes et pour les droits des femmes à participer pleinement aux processus de paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12639: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie José Ramos-Horta a-t-il reçu le Prix Nobel en 1996 ?",
      answers: ["Physiologie ou Médecine","Littérature","Physique","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12640: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année James A. Mirrlees a-t-il reçu le Prix Nobel de Sciences Économiques pour leurs contributions fondamentales à la théorie économique des incitations sous information asymétrique ?",
      answers: ["2016","1995","1996","2001"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12641: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1996 pour leurs contributions fondamentales à la théorie économique des incitations sous information asymétrique ?",
      answers: ["Thomas J. Sargent","Oliver Hart","George J. Stigler","James A. Mirrlees"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12642: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison James A. Mirrlees a-t-il reçu le Prix Nobel en 1996 ?",
      answers: ["pour ses recherches sur les banques et les crises financières","pour ses études sur la manière dont les institutions sont formées et affectent la prospérité","pour leurs contributions fondamentales à la théorie économique des incitations sous information asymétrique","pour son analyse des modèles commerciaux et de la localisation de l’activité économique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12643: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie James A. Mirrlees a-t-il reçu le Prix Nobel en 1996 ?",
      answers: ["Physique","Physiologie ou Médecine","Sciences Économiques","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12644: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année William Vickrey a-t-il reçu le Prix Nobel de Sciences Économiques pour leurs contributions fondamentales à la théorie économique des incitations sous information asymétrique ?",
      answers: ["1995","1996","1985","1997"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12645: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1996 pour leurs contributions fondamentales à la théorie économique des incitations sous information asymétrique ?",
      answers: ["Harry M. Markowitz","James A. Mirrlees","William Vickrey","Reinhard Selten"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12646: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison William Vickrey a-t-il reçu le Prix Nobel en 1996 ?",
      answers: ["pour avoir développé et appliqué l’hypothèse des anticipations rationnelles","pour la théorie des allocations stables et la pratique de la conception de marchés","pour leurs contributions fondamentales à la théorie économique des incitations sous information asymétrique","pour leurs contributions pionnières à la théorie de l’économie financière"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12647: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie William Vickrey a-t-il reçu le Prix Nobel en 1996 ?",
      answers: ["Physique","Paix","Sciences Économiques","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12648: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Steven Chu a-t-il reçu le Prix Nobel de Physique pour le développement de méthodes pour refroidir et piéger les atomes avec la lumière laser ?",
      answers: ["1987","2005","1997","1999"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12649: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1997 pour le développement de méthodes pour refroidir et piéger les atomes avec la lumière laser ?",
      answers: ["Steven Chu","Claude Cohen-Tannoudji","Martin L. Perl","Wilhelm Wien"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12650: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Steven Chu a-t-il reçu le Prix Nobel en 1997 ?",
      answers: ["pour la découverte de nouvelles formes productives de la théorie atomique","pour le développement de méthodes pour refroidir et piéger les atomes avec la lumière laser","pour leur théorie développée conjointement de la supraconductivité, généralement appelée la théorie BCS","pour la découverte de l’origine de la brisure de symétrie qui prédit l’existence d’au moins trois familles de quarks dans la nature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12651: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Steven Chu a-t-il reçu le Prix Nobel en 1997 ?",
      answers: ["Chimie","Paix","Physique","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12652: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Claude Cohen-Tannoudji a-t-il reçu le Prix Nobel de Physique pour le développement de méthodes pour refroidir et piéger les atomes avec la lumière laser ?",
      answers: ["1979","1987","1991","1997"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12653: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1997 pour le développement de méthodes pour refroidir et piéger les atomes avec la lumière laser ?",
      answers: ["John R. Schrieffer","Claude Cohen-Tannoudji","George F. Smoot","Roy J. Glauber"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12654: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Claude Cohen-Tannoudji a-t-il reçu le Prix Nobel en 1997 ?",
      answers: ["pour la réalisation de la condensation de Bose-Einstein dans des gaz dilués d’atomes alcalins","pour le développement de méthodes pour refroidir et piéger les atomes avec la lumière laser","pour leur découverte de l’effet Hall quantique fractionnaire","pour leur théorie développée conjointement de la supraconductivité, généralement appelée la théorie BCS"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12655: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Claude Cohen-Tannoudji a-t-il reçu le Prix Nobel en 1997 ?",
      answers: ["Chimie","Physique","Physiologie ou Médecine","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12656: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année William D. Phillips a-t-il reçu le Prix Nobel de Physique pour le développement de méthodes pour refroidir et piéger les atomes avec la lumière laser ?",
      answers: ["1997","1986","1994","1975"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12657: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1997 pour le développement de méthodes pour refroidir et piéger les atomes avec la lumière laser ?",
      answers: ["David M. Lee","Horst L. Störmer","Polykarp Kusch","William D. Phillips"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12658: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison William D. Phillips a-t-il reçu le Prix Nobel en 1997 ?",
      answers: ["pour le développement de méthodes pour refroidir et piéger les atomes avec la lumière laser","pour ses contributions pionnières à l’astrophysique, qui ont conduit à la découverte des sources de rayons X cosmiques","pour la modélisation physique du climat terrestre, la quantification de sa variabilité et la prédiction fiable du réchauffement climatique","pour leur découverte de la superfluidité dans l’hélium-3"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12659: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie William D. Phillips a-t-il reçu le Prix Nobel en 1997 ?",
      answers: ["Chimie","Physiologie ou Médecine","Paix","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12660: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Paul D. Boyer a-t-il reçu le Prix Nobel de Chimie pour leur élucidation du mécanisme enzymatique sous-jacent à la synthèse de l’adénosine triphosphate (ATP) ?",
      answers: ["1997","2016","2015","2005"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12661: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1997 pour leur élucidation du mécanisme enzymatique sous-jacent à la synthèse de l’adénosine triphosphate (ATP) ?",
      answers: ["Sir Harold W. Kroto","Herbert A. Hauptman","Paul D. Boyer","Walter Gilbert"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12662: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Paul D. Boyer a-t-il reçu le Prix Nobel en 1997 ?",
      answers: ["pour leur invention de la chromatographie de partage","en reconnaissance des services extraordinaires qu’il a rendus à l’avancement de la chimie par sa théorie de la dissociation électrolytique","pour leur élucidation du mécanisme enzymatique sous-jacent à la synthèse de l’adénosine triphosphate (ATP)","pour leurs travaux sur la chimie de l’atmosphère, notamment concernant la formation et la décomposition de l’ozone"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12663: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Paul D. Boyer a-t-il reçu le Prix Nobel en 1997 ?",
      answers: ["Sciences Économiques","Littérature","Physique","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12664: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année John E. Walker a-t-il reçu le Prix Nobel de Chimie pour leur élucidation du mécanisme enzymatique sous-jacent à la synthèse de l’adénosine triphosphate (ATP) ?",
      answers: ["2008","1984","1997","1996"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12665: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1997 pour leur élucidation du mécanisme enzymatique sous-jacent à la synthèse de l’adénosine triphosphate (ATP) ?",
      answers: ["Roderick MacKinnon","Paul D. Boyer","Jens C. Skou","John E. Walker"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12666: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison John E. Walker a-t-il reçu le Prix Nobel en 1997 ?",
      answers: ["pour leur élucidation du mécanisme enzymatique sous-jacent à la synthèse de l’adénosine triphosphate (ATP)","pour leur découverte des fullerènes","pour ses études structurales et mécanistiques des canaux ioniques","pour la détermination de la structure tridimensionnelle d’un centre réactionnel photosynthétique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12667: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie John E. Walker a-t-il reçu le Prix Nobel en 1997 ?",
      answers: ["Physique","Paix","Littérature","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12668: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Jens C. Skou a-t-il reçu le Prix Nobel de Chimie pour la première découverte d’une enzyme transportant des ions, la Na+, K+-ATPase ?",
      answers: ["1950","1998","1997","1999"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12669: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1997 pour la première découverte d’une enzyme transportant des ions, la Na+, K+-ATPase ?",
      answers: ["Ronald G.W. Norrish","John E. Walker","Paul D. Boyer","Jens C. Skou"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12670: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Jens C. Skou a-t-il reçu le Prix Nobel en 1997 ?",
      answers: ["pour la première découverte d’une enzyme transportant des ions, la Na+, K+-ATPase","pour ses contributions fondamentales à l’établissement de la mutagenèse dirigée par oligonucléotides","pour son travail sur les réactions d’hydrogénation catalysées de manière chirale","pour ses contributions à la théorie des réactions de transfert d’électrons dans les systèmes chimiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12671: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Jens C. Skou a-t-il reçu le Prix Nobel en 1997 ?",
      answers: ["Physiologie ou Médecine","Sciences Économiques","Chimie","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12672: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Stanley B. Prusiner a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour sa découverte des prions – un nouveau principe biologique d’infection ?",
      answers: ["1997","1964","1984","1931"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12673: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1997 pour sa découverte des prions – un nouveau principe biologique d’infection ?",
      answers: ["Christiane Nüsslein-Volhard","Tim Hunt","Stanley B. Prusiner","Sir Paul M. Nurse"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12674: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Stanley B. Prusiner a-t-il reçu le Prix Nobel en 1997 ?",
      answers: ["pour sa découverte des prions – un nouveau principe biologique d’infection","pour leurs découvertes concernant les structures génétiquement déterminées à la surface des cellules qui régulent les réactions immunitaires","pour leurs découvertes concernant le contrôle génétique du développement précoce de l’embryon","pour ses découvertes concernant les composés synthétiques qui inhibent l’action de certaines substances corporelles, notamment leur effet sur le système vasculaire et les muscles squelettiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12675: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Stanley B. Prusiner a-t-il reçu le Prix Nobel en 1997 ?",
      answers: ["Physique","Littérature","Physiologie ou Médecine","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12676: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Dario Fo a-t-il reçu le Prix Nobel de Littérature qui émule les bouffons du Moyen Âge en flagellant l’autorité et en défendant la dignité des opprimés ?",
      answers: ["1997","1994","1908","1998"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12677: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1997 qui émule les bouffons du Moyen Âge en flagellant l’autorité et en défendant la dignité des opprimés ?",
      answers: ["Seamus Heaney","Jon Fosse","V. S. Naipaul","Dario Fo"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12678: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Dario Fo a-t-il reçu le Prix Nobel en 1997 ?",
      answers: ["qui, avec une force poétique, crée un monde imaginaire où la vie et le mythe se condensent pour former une image déconcertante de la condition humaine actuelle","qui émule les bouffons du Moyen Âge en flagellant l’autorité et en défendant la dignité des opprimés","qui, par son écriture épique magnifique, a rendu un grand service à l’humanité","pour son œuvre polyphonique, un monument à la souffrance et au courage de notre temps"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12679: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Dario Fo a-t-il reçu le Prix Nobel en 1997 ?",
      answers: ["Littérature","Chimie","Physique","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12680: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Campagne Internationale pour l’Interdiction des Mines Antipersonnel (ICBL) a-t-il reçu le Prix Nobel de Paix pour leur travail visant à interdire et éliminer les mines antipersonnel ?",
      answers: ["1997","1990","1958","2001"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12681: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1997 pour leur travail visant à interdire et éliminer les mines antipersonnel ?",
      answers: ["Joseph Rotblat","Campagne Internationale pour l’Interdiction des Mines Antipersonnel (ICBL)","José Ramos-Horta","Carlos Filipe Ximenes Belo"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12682: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Campagne Internationale pour l’Interdiction des Mines Antipersonnel (ICBL) a-t-il reçu le Prix Nobel en 1997 ?",
      answers: ["pour leur travail en faveur d’une solution juste et pacifique au conflit au Timor oriental","pour son travail en faveur de la paix en Amérique centrale","pour son travail en faveur des droits humains et de la libération des prisonniers politiques","pour leur travail visant à interdire et éliminer les mines antipersonnel"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12683: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Campagne Internationale pour l’Interdiction des Mines Antipersonnel (ICBL) a-t-il reçu le Prix Nobel en 1997 ?",
      answers: ["Physiologie ou Médecine","Chimie","Littérature","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12684: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Jody Williams a-t-il reçu le Prix Nobel de Paix pour leur travail visant à interdire et éliminer les mines antipersonnel ?",
      answers: ["2011","1996","1997","1938"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12685: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1997 pour leur travail visant à interdire et éliminer les mines antipersonnel ?",
      answers: ["Muhammad Yunus","Joseph Rotblat","Dalaï Lama (Tenzin Gyatso)","Jody Williams"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12686: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Jody Williams a-t-il reçu le Prix Nobel en 1997 ?",
      answers: ["pour leurs contributions à la négociation des accords de Camp David pour la paix au Moyen-Orient","pour leur lutte non violente pour la sécurité des femmes et pour les droits des femmes à participer pleinement aux processus de paix","pour leur contribution à la réduction des tensions et à la promotion de la paix dans le monde","pour leur travail visant à interdire et éliminer les mines antipersonnel"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12687: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Jody Williams a-t-il reçu le Prix Nobel en 1997 ?",
      answers: ["Paix","Physique","Physiologie ou Médecine","Littérature"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12688: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Robert C. Merton a-t-il reçu le Prix Nobel de Sciences Économiques pour une nouvelle méthode de détermination de la valeur des produits dérivés ?",
      answers: ["1953","1996","1997","2010"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12689: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1997 pour une nouvelle méthode de détermination de la valeur des produits dérivés ?",
      answers: ["Robert C. Merton","Amartya Sen","Reinhard Selten","John R. Hicks"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12690: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Robert C. Merton a-t-il reçu le Prix Nobel en 1997 ?",
      answers: ["pour ses analyses pionnières de l’épargne et des marchés financiers","pour son analyse des arbitrages intertemporels en politique macroéconomique","pour leurs contributions fondamentales à la théorie économique des incitations sous information asymétrique","pour une nouvelle méthode de détermination de la valeur des produits dérivés"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12691: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Robert C. Merton a-t-il reçu le Prix Nobel en 1997 ?",
      answers: ["Paix","Chimie","Physique","Sciences Économiques"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12692: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Myron S. Scholes a-t-il reçu le Prix Nobel de Sciences Économiques pour une nouvelle méthode de détermination de la valeur des produits dérivés ?",
      answers: ["2003","2020","1997","1989"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12693: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1997 pour une nouvelle méthode de détermination de la valeur des produits dérivés ?",
      answers: ["Myron S. Scholes","Maurice Allais","Ragnar Frisch","William Vickrey"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12694: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Myron S. Scholes a-t-il reçu le Prix Nobel en 1997 ?",
      answers: ["pour ses contributions à l’économie du bien-être","pour ses méthodes d’analyse des données microéconomiques","pour une nouvelle méthode de détermination de la valeur des produits dérivés","pour leur analyse des marchés avec des frictions de recherche"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12695: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Myron S. Scholes a-t-il reçu le Prix Nobel en 1997 ?",
      answers: ["Sciences Économiques","Physiologie ou Médecine","Physique","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12696: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Robert B. Laughlin a-t-il reçu le Prix Nobel de Physique pour leur découverte de l’effet Hall quantique fractionnaire ?",
      answers: ["1994","1921","2005","1998"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12697: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1998 pour leur découverte de l’effet Hall quantique fractionnaire ?",
      answers: ["Daniel C. Tsui","Robert B. Laughlin","Georges Charpak","Kip S. Thorne"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12698: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Robert B. Laughlin a-t-il reçu le Prix Nobel en 1998 ?",
      answers: ["pour le développement de méthodes pour refroidir et piéger les atomes avec la lumière laser","pour ses découvertes et recherches dans le domaine de la spectroscopie des rayons X","pour leur découverte de l’effet Hall quantique fractionnaire","pour leurs contributions au développement de la spectroscopie de précision basée sur le laser"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12699: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Robert B. Laughlin a-t-il reçu le Prix Nobel en 1998 ?",
      answers: ["Paix","Sciences Économiques","Physiologie ou Médecine","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12700: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Horst L. Störmer a-t-il reçu le Prix Nobel de Physique pour leur découverte de l’effet Hall quantique fractionnaire ?",
      answers: ["2015","1998","1989","1999"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12701: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1998 pour leur découverte de l’effet Hall quantique fractionnaire ?",
      answers: ["Henry W. Kendall","Horst L. Störmer","Daniel C. Tsui","Robert B. Laughlin"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12702: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Horst L. Störmer a-t-il reçu le Prix Nobel en 1998 ?",
      answers: ["pour leurs découvertes expérimentales concernant les phénomènes de tunnel dans les semi-conducteurs et les supraconducteurs, respectivement","pour leur découverte de l’effet Hall quantique fractionnaire","pour la découverte théorique d’un mécanisme contribuant à notre compréhension de l’origine de la masse des particules subatomiques","pour la découverte de l’expansion accelérée de l’univers par l’observation des supernovae lointaines"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12703: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Horst L. Störmer a-t-il reçu le Prix Nobel en 1998 ?",
      answers: ["Littérature","Chimie","Physique","Paix"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12704: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Daniel C. Tsui a-t-il reçu le Prix Nobel de Physique pour leur découverte de l’effet Hall quantique fractionnaire ?",
      answers: ["1990","1985","1998","2009"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12705: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1998 pour leur découverte de l’effet Hall quantique fractionnaire ?",
      answers: ["Nevill F. Mott","William D. Phillips","Daniel C. Tsui","Clifford G. Shull"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12706: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Daniel C. Tsui a-t-il reçu le Prix Nobel en 1998 ?",
      answers: ["pour leur découverte de l’effet Hall quantique fractionnaire","pour leur percée importante dans la découverte de la supraconductivité dans les matériaux céramiques","pour leur théorie développée conjointement de la supraconductivité, généralement appelée la théorie BCS","pour leurs contributions fondamentales à l’électrodynamique quantique, avec des conséquences profondes pour la physique des particules élémentaires"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12707: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Daniel C. Tsui a-t-il reçu le Prix Nobel en 1998 ?",
      answers: ["Physiologie ou Médecine","Paix","Physique","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12708: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Walter Kohn a-t-il reçu le Prix Nobel de Chimie pour son développement de la théorie de la fonctionnelle de la densité ?",
      answers: ["1988","1975","2006","1998"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12709: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1998 pour son développement de la théorie de la fonctionnelle de la densité ?",
      answers: ["Robert F. Curl Jr.","Brian K. Kobilka","John A. Pople","Walter Kohn"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12710: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Walter Kohn a-t-il reçu le Prix Nobel en 1998 ?",
      answers: ["pour son invention de la méthode de réaction en chaîne par polymérase (PCR)","pour son développement de la théorie de la fonctionnelle de la densité","pour le développement de réactions de couplage catalysées par le palladium en synthèse organique","pour leurs travaux sur la chimie de l’atmosphère, notamment concernant la formation et la décomposition de l’ozone"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12711: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Walter Kohn a-t-il reçu le Prix Nobel en 1998 ?",
      answers: ["Paix","Physiologie ou Médecine","Littérature","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12712: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année John A. Pople a-t-il reçu le Prix Nobel de Chimie pour ses développements de méthodes computationnelles en chimie quantique ?",
      answers: ["2008","2007","1970","1998"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12713: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1998 pour ses développements de méthodes computationnelles en chimie quantique ?",
      answers: ["Jens C. Skou","Peter Agre","John A. Pople","Lars Onsager"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12714: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison John A. Pople a-t-il reçu le Prix Nobel en 1998 ?",
      answers: ["pour la première découverte d’une enzyme transportant des ions, la Na+, K+-ATPase","pour ses développements de méthodes computationnelles en chimie quantique","pour sa démonstration de la nature hétérogène des solutions colloïdales et pour les méthodes qu’il a utilisées, qui sont devenues fondamentales en chimie colloïdale moderne","pour leur élucidation du mécanisme enzymatique sous-jacent à la synthèse de l’adénosine triphosphate (ATP)"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12715: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie John A. Pople a-t-il reçu le Prix Nobel en 1998 ?",
      answers: ["Littérature","Chimie","Paix","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12716: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Robert F. Furchgott a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant le monoxyde d’azote comme molécule de signalisation dans le système cardiovasculaire ?",
      answers: ["1991","1999","1998","1993"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12717: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1998 pour leurs découvertes concernant le monoxyde d’azote comme molécule de signalisation dans le système cardiovasculaire ?",
      answers: ["Svante Pääbo","Edvard I. Moser","Ferid Murad","Robert F. Furchgott"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12718: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Robert F. Furchgott a-t-il reçu le Prix Nobel en 1998 ?",
      answers: ["pour leurs découvertes sur la régulation du cycle cellulaire","pour leurs découvertes concernant le contrôle génétique du développement précoce de l’embryon","pour leurs découvertes concernant le monoxyde d’azote comme molécule de signalisation dans le système cardiovasculaire","pour leurs découvertes sur les cellules qui constituent un système de positionnement dans le cerveau"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12719: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Robert F. Furchgott a-t-il reçu le Prix Nobel en 1998 ?",
      answers: ["Physiologie ou Médecine","Littérature","Paix","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12720: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Louis J. Ignarro a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant le monoxyde d’azote comme molécule de signalisation dans le système cardiovasculaire ?",
      answers: ["1999","2005","2001","1998"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12721: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1998 pour leurs découvertes concernant le monoxyde d’azote comme molécule de signalisation dans le système cardiovasculaire ?",
      answers: ["Louis J. Ignarro","Leland H. Hartwell","George H. Hitchings","Thomas C. Südhof"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12722: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Louis J. Ignarro a-t-il reçu le Prix Nobel en 1998 ?",
      answers: ["pour leur découverte des mécanismes de la synthèse biologique de l’acide ribonucléique et de l’acide désoxyribonucléique","pour leurs découvertes concernant les transplantations d’organes et de cellules dans le traitement des maladies","pour leurs découvertes concernant le monoxyde d’azote comme molécule de signalisation dans le système cardiovasculaire","pour ses découvertes concernant la transmission des signaux dans le système nerveux"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12723: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Louis J. Ignarro a-t-il reçu le Prix Nobel en 1998 ?",
      answers: ["Sciences Économiques","Chimie","Physiologie ou Médecine","Paix"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12724: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Ferid Murad a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant le monoxyde d’azote comme molécule de signalisation dans le système cardiovasculaire ?",
      answers: ["1974","1997","1998","1993"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12725: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1998 pour leurs découvertes concernant le monoxyde d’azote comme molécule de signalisation dans le système cardiovasculaire ?",
      answers: ["Sydney Brenner","Ferid Murad","Robert F. Furchgott","Sune K. Bergström"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12726: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Ferid Murad a-t-il reçu le Prix Nobel en 1998 ?",
      answers: ["pour leurs découvertes concernant le traitement de l’information dans le système visuel","pour leurs découvertes concernant le monoxyde d’azote comme molécule de signalisation dans le système cardiovasculaire","pour leurs découvertes des mécanismes moléculaires contrôlant le rythme circadien","pour leurs découvertes sur la régulation du cycle cellulaire"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12727: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Ferid Murad a-t-il reçu le Prix Nobel en 1998 ?",
      answers: ["Littérature","Physiologie ou Médecine","Physique","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12728: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année José Saramago a-t-il reçu le Prix Nobel de Littérature qui, avec des paraboles soutenues par l’imagination, la compassion et l’ironie, nous permet de saisir une réalité évasive ?",
      answers: ["1998","1989","1999","1916"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12729: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1998 qui, avec des paraboles soutenues par l’imagination, la compassion et l’ironie, nous permet de saisir une réalité évasive ?",
      answers: ["Dario Fo","Camilo José Cela","Sully Prudhomme","José Saramago"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12730: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison José Saramago a-t-il reçu le Prix Nobel en 1998 ?",
      answers: ["qui, avec des paraboles soutenues par l’imagination, la compassion et l’ironie, nous permet de saisir une réalité évasive","qui, par son écriture épique magnifique, a rendu un grand service à l’humanité","pour une œuvre d’une portée universelle, marquée d’amertume et d’ingéniosité linguistique, qui a ouvert de nouvelles voies au roman et au théâtre chinois","qui, dans des romans caractérisés par une force visionnaire et une portée poétique, donne vie à un aspect essentiel de la réalité américaine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12731: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie José Saramago a-t-il reçu le Prix Nobel en 1998 ?",
      answers: ["Sciences Économiques","Paix","Littérature","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12732: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année John Hume a-t-il reçu le Prix Nobel de Paix pour leurs efforts visant à trouver une solution pacifique au conflit en Irlande du Nord ?",
      answers: ["2009","1999","2002","1998"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12733: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1998 pour leurs efforts visant à trouver une solution pacifique au conflit en Irlande du Nord ?",
      answers: ["David Trimble","John Hume","Rigoberta Menchú Tum","Kim Dae-jung"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12734: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison John Hume a-t-il reçu le Prix Nobel en 1998 ?",
      answers: ["pour leur travail visant à interdire et éliminer les mines antipersonnel","pour ses décennies d’efforts inlassables pour trouver des solutions pacifiques aux conflits internationaux","pour leur travail visant à promouvoir une solution pacifique au conflit en Irlande du Nord","pour leurs efforts visant à trouver une solution pacifique au conflit en Irlande du Nord"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12735: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie John Hume a-t-il reçu le Prix Nobel en 1998 ?",
      answers: ["Physique","Littérature","Physiologie ou Médecine","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12736: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année David Trimble a-t-il reçu le Prix Nobel de Paix pour leurs efforts visant à trouver une solution pacifique au conflit en Irlande du Nord ?",
      answers: ["1998","2000","1997","2007"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12737: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1998 pour leurs efforts visant à trouver une solution pacifique au conflit en Irlande du Nord ?",
      answers: ["Mohamed ElBaradei","Médecins Sans Frontières","Liu Xiaobo","David Trimble"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12738: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison David Trimble a-t-il reçu le Prix Nobel en 1998 ?",
      answers: ["pour sa contribution décisive à la construction d’une démocratie pluraliste en Tunisie après la Révolution du Jasmin de 2011","pour leur travail en faveur de la paix et des réformes sociales","pour leurs efforts en faveur de la paix en tant que leaders du mouvement pacifiste international","pour leurs efforts visant à trouver une solution pacifique au conflit en Irlande du Nord"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12739: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie David Trimble a-t-il reçu le Prix Nobel en 1998 ?",
      answers: ["Chimie","Littérature","Paix","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12740: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Amartya Sen a-t-il reçu le Prix Nobel de Sciences Économiques pour ses contributions à l’économie du bien-être ?",
      answers: ["1993","1981","1998","1995"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12741: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1998 pour ses contributions à l’économie du bien-être ?",
      answers: ["James J. Heckman","Douglass C. North","Milton Friedman","Amartya Sen"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12742: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Amartya Sen a-t-il reçu le Prix Nobel en 1998 ?",
      answers: ["pour ses études sur la manière dont les institutions sont formées et affectent la prospérité","pour leurs travaux empiriques sur la cause et l’effet en macroéconomie","pour avoir posé les bases de la théorie de la conception des mécanismes","pour ses contributions à l’économie du bien-être"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12743: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Amartya Sen a-t-il reçu le Prix Nobel en 1998 ?",
      answers: ["Physiologie ou Médecine","Physique","Sciences Économiques","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12744: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Gerardus ’t Hooft a-t-il reçu le Prix Nobel de Physique pour leurs contributions fondamentales à la compréhension des interactions électrofaibles dans la théorie quantique des champs ?",
      answers: ["1977","1999","2002","2000"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12745: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1999 pour leurs contributions fondamentales à la compréhension des interactions électrofaibles dans la théorie quantique des champs ?",
      answers: ["Sir Edward Appleton","Horst L. Störmer","Gerardus ’t Hooft","William D. Phillips"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12746: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Gerardus ’t Hooft a-t-il reçu le Prix Nobel en 1999 ?",
      answers: ["pour le développement de la spectroscopie neutronique","pour leurs contributions fondamentales à la compréhension des interactions électrofaibles dans la théorie quantique des champs","pour leurs contributions pionnières à l’astrophysique, notamment la détection des neutrinos cosmiques","pour leurs contributions au développement de la spectroscopie de précision basée sur le laser"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12747: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Gerardus ’t Hooft a-t-il reçu le Prix Nobel en 1999 ?",
      answers: ["Littérature","Physiologie ou Médecine","Chimie","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12748: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Martinus J. G. Veltman a-t-il reçu le Prix Nobel de Physique pour leurs contributions fondamentales à la compréhension des interactions électrofaibles dans la théorie quantique des champs ?",
      answers: ["1999","2000","2008","1998"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12749: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 1999 pour leurs contributions fondamentales à la compréhension des interactions électrofaibles dans la théorie quantique des champs ?",
      answers: ["Robert W. Wilson","Herbert Kroemer","Martinus J. G. Veltman","Gerardus ’t Hooft"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12750: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Martinus J. G. Veltman a-t-il reçu le Prix Nobel en 1999 ?",
      answers: ["pour le développement de la technique du piège à ions","pour des méthodes expérimentales générant des impulsions lumineuses extrêmement courtes permettant l’étude des dynamiques électroniques dans la matière","pour leur découverte de l’effet Hall quantique fractionnaire","pour leurs contributions fondamentales à la compréhension des interactions électrofaibles dans la théorie quantique des champs"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12751: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Martinus J. G. Veltman a-t-il reçu le Prix Nobel en 1999 ?",
      answers: ["Physique","Physiologie ou Médecine","Chimie","Littérature"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12752: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Ahmed H. Zewail a-t-il reçu le Prix Nobel de Chimie pour ses études sur la dynamique des réactions chimiques à l’échelle femtoseconde ?",
      answers: ["2006","2000","1999","1985"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12753: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 1999 pour ses études sur la dynamique des réactions chimiques à l’échelle femtoseconde ?",
      answers: ["John E. Walker","Ahmed H. Zewail","James B. Sumner","John A. Pople"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12754: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Ahmed H. Zewail a-t-il reçu le Prix Nobel en 1999 ?",
      answers: ["pour ses études sur la dynamique des réactions chimiques à l’échelle femtoseconde","pour la découverte et le développement des polymères conducteurs","en reconnaissance des services qu’il a rendus à l’avancement de la chimie organique et de l’industrie chimique par ses travaux sur les colorants organiques et les composés hydroaromatiques","pour son développement de la théorie de la fonctionnelle de la densité"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12755: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Ahmed H. Zewail a-t-il reçu le Prix Nobel en 1999 ?",
      answers: ["Paix","Physiologie ou Médecine","Chimie","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12756: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Günter Blobel a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour la découverte que les protéines ont des signaux intrinsèques qui régissent leur transport et leur localisation dans la cellule ?",
      answers: ["2002","2007","1999","1985"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12757: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 1999 pour la découverte que les protéines ont des signaux intrinsèques qui régissent leur transport et leur localisation dans la cellule ?",
      answers: ["Paul Greengard","J. Robin Warren","Robert F. Furchgott","Günter Blobel"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12758: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Günter Blobel a-t-il reçu le Prix Nobel en 1999 ?",
      answers: ["pour ses découvertes concernant une nouvelle thérapie contre le paludisme","pour la découverte de l’insuline","pour la découverte que les protéines ont des signaux intrinsèques qui régissent leur transport et leur localisation dans la cellule","pour leur découverte des protéines G et leur rôle dans la transduction des signaux dans les cellules"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12759: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Günter Blobel a-t-il reçu le Prix Nobel en 1999 ?",
      answers: ["Sciences Économiques","Physiologie ou Médecine","Paix","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12760: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Günter Grass a-t-il reçu le Prix Nobel de Littérature dont les contes burlesques et noirs dépeignent le visage oublié de l’histoire ?",
      answers: ["1987","2003","1994","1999"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12761: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 1999 dont les contes burlesques et noirs dépeignent le visage oublié de l’histoire ?",
      answers: ["José Saramago","Dario Fo","Gao Xingjian","Günter Grass"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12762: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Günter Grass a-t-il reçu le Prix Nobel en 1999 ?",
      answers: ["dont les contes burlesques et noirs dépeignent le visage oublié de l’histoire","qui, avec une force poétique, crée un monde imaginaire où la vie et le mythe se condensent pour former une image déconcertante de la condition humaine actuelle","pour son œuvre lyrique éminente, qui rend un hommage artistique à la culture grecque","pour une œuvre qui défend la fragile expérience de l’individu contre l’arbitraire barbare de l’histoire"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12763: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Günter Grass a-t-il reçu le Prix Nobel en 1999 ?",
      answers: ["Physiologie ou Médecine","Littérature","Paix","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12764: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Médecins Sans Frontières a-t-il reçu le Prix Nobel de Paix en reconnaissance de leur travail humanitaire pionnier dans plusieurs continents ?",
      answers: ["1999","1997","1956","2008"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12765: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 1999 en reconnaissance de leur travail humanitaire pionnier dans plusieurs continents ?",
      answers: ["Rigoberta Menchú Tum","Médecins Sans Frontières","Organisation pour l’Interdiction des Armes Chimiques (OIAC)","Andrei Sakharov"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12766: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Médecins Sans Frontières a-t-il reçu le Prix Nobel en 1999 ?",
      answers: ["en reconnaissance de leur travail humanitaire pionnier dans plusieurs continents","pour leurs efforts visant à trouver une solution pacifique au conflit en Irlande du Nord","pour leurs contributions à la paix à travers la diplomatie et le mouvement pacifiste","pour leur travail visant à interdire et éliminer les mines antipersonnel"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12767: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Médecins Sans Frontières a-t-il reçu le Prix Nobel en 1999 ?",
      answers: ["Paix","Physiologie ou Médecine","Physique","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12768: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Robert A. Mundell a-t-il reçu le Prix Nobel de Sciences Économiques pour son analyse des politiques monétaires et fiscales sous différents régimes de taux de change ?",
      answers: ["1978","1994","2001","1999"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12769: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 1999 pour son analyse des politiques monétaires et fiscales sous différents régimes de taux de change ?",
      answers: ["Robert C. Merton","Robert J. Aumann","Clive W. J. Granger","Robert A. Mundell"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12770: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Robert A. Mundell a-t-il reçu le Prix Nobel en 1999 ?",
      answers: ["pour avoir amélioré notre compréhension des conflits et de la coopération à travers l’analyse de la théorie des jeux","pour son analyse des politiques monétaires et fiscales sous différents régimes de taux de change","pour ses analyses pionnières de l’épargne et des marchés financiers","pour ses méthodes d’analyse des données microéconomiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12771: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Robert A. Mundell a-t-il reçu le Prix Nobel en 1999 ?",
      answers: ["Sciences Économiques","Chimie","Physique","Littérature"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12772: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Zhores I. Alferov a-t-il reçu le Prix Nobel de Physique pour le développement de semi-conducteurs utilisés dans l’électronique à haute vitesse et l’optoélectronique ?",
      answers: ["1947","2000","2008","2018"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12773: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2000 pour le développement de semi-conducteurs utilisés dans l’électronique à haute vitesse et l’optoélectronique ?",
      answers: ["Zhores I. Alferov","Richard E. Taylor","Jack S. Kilby","J. Hans D. Jensen"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12774: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Zhores I. Alferov a-t-il reçu le Prix Nobel en 2000 ?",
      answers: ["pour leurs contributions pionnières à l’astrophysique, notamment la détection des neutrinos cosmiques","pour la découverte de la magnétorésistance géante","pour sa contribution à l’invention du circuit intégré","pour le développement de semi-conducteurs utilisés dans l’électronique à haute vitesse et l’optoélectronique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12775: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Zhores I. Alferov a-t-il reçu le Prix Nobel en 2000 ?",
      answers: ["Chimie","Physique","Paix","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12776: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Herbert Kroemer a-t-il reçu le Prix Nobel de Physique pour le développement de semi-conducteurs utilisés dans l’électronique à haute vitesse et l’optoélectronique ?",
      answers: ["2000","1972","1924","1998"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12777: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2000 pour le développement de semi-conducteurs utilisés dans l’électronique à haute vitesse et l’optoélectronique ?",
      answers: ["Herbert Kroemer","Jack S. Kilby","Masatoshi Koshiba","Raymond Davis Jr."],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12778: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Herbert Kroemer a-t-il reçu le Prix Nobel en 2000 ?",
      answers: ["pour leurs découvertes expérimentales concernant les phénomènes de tunnel dans les semi-conducteurs et les supraconducteurs, respectivement","pour la découverte d’un nouveau type de pulsar, une découverte qui a ouvert de nouvelles possibilités pour l’étude de la gravitation","pour le développement de semi-conducteurs utilisés dans l’électronique à haute vitesse et l’optoélectronique","pour l’invention de la chambre à bulles"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12779: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Herbert Kroemer a-t-il reçu le Prix Nobel en 2000 ?",
      answers: ["Chimie","Littérature","Physique","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12780: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Jack S. Kilby a-t-il reçu le Prix Nobel de Physique pour sa contribution à l’invention du circuit intégré ?",
      answers: ["2016","2000","1954","2002"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12781: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2000 pour sa contribution à l’invention du circuit intégré ?",
      answers: ["Shuji Nakamura","Herbert Kroemer","Jack S. Kilby","Martinus J. G. Veltman"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12782: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Jack S. Kilby a-t-il reçu le Prix Nobel en 2000 ?",
      answers: ["pour leurs investigations théoriques fondamentales sur la structure électronique des systèmes magnétiques et désordonnés","pour leurs contributions pionnières à la théorie des supraconducteurs et des superfluides","pour sa contribution à l’invention du circuit intégré","pour des découvertes théoriques sur les transitions de phase topologiques et les phases topologiques de la matière"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12783: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Jack S. Kilby a-t-il reçu le Prix Nobel en 2000 ?",
      answers: ["Paix","Physiologie ou Médecine","Littérature","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12784: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Alan J. Heeger a-t-il reçu le Prix Nobel de Chimie pour la découverte et le développement des polymères conducteurs ?",
      answers: ["1957","2001","2000","1993"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12785: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2000 pour la découverte et le développement des polymères conducteurs ?",
      answers: ["Bernard L. Feringa","John B. Fenn","Alan J. Heeger","Paul D. Boyer"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12786: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Alan J. Heeger a-t-il reçu le Prix Nobel en 2000 ?",
      answers: ["pour leurs travaux sur la chimie de l’atmosphère, notamment concernant la formation et la décomposition de l’ozone","pour ses développements de méthodes computationnelles en chimie quantique","pour son travail sur les réactions d’hydrogénation catalysées de manière chirale","pour la découverte et le développement des polymères conducteurs"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12787: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Alan J. Heeger a-t-il reçu le Prix Nobel en 2000 ?",
      answers: ["Physique","Chimie","Physiologie ou Médecine","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12788: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Alan G. MacDiarmid a-t-il reçu le Prix Nobel de Chimie pour la découverte et le développement des polymères conducteurs ?",
      answers: ["1999","2000","1960","1997"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12789: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2000 pour la découverte et le développement des polymères conducteurs ?",
      answers: ["Mario J. Molina","Alan G. MacDiarmid","Ryoji Noyori","Ada E. Yonath"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12790: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Alan G. MacDiarmid a-t-il reçu le Prix Nobel en 2000 ?",
      answers: ["pour la découverte et le développement des polymères conducteurs","pour des études sur les récepteurs couplés aux protéines G","pour son développement de la théorie de la fonctionnelle de la densité","pour des études sur la structure et la fonction du ribosome"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12791: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Alan G. MacDiarmid a-t-il reçu le Prix Nobel en 2000 ?",
      answers: ["Chimie","Physique","Paix","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12792: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Hideki Shirakawa a-t-il reçu le Prix Nobel de Chimie pour la découverte et le développement des polymères conducteurs ?",
      answers: ["2023","1998","2005","2000"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12793: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2000 pour la découverte et le développement des polymères conducteurs ?",
      answers: ["Hideki Shirakawa","M. Stanley Whittingham","Gerhard Ertl","Richard Henderson"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12794: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Hideki Shirakawa a-t-il reçu le Prix Nobel en 2000 ?",
      answers: ["pour le développement de méthodes d’analyse des macromolécules biologiques","en reconnaissance des services qu’il a rendus à la chimie organique et à l’industrie chimique par ses travaux pionniers dans le domaine des composés alicycliques","pour le développement de la spectroscopie par résonance magnétique nucléaire pour déterminer la structure tridimensionnelle des macromolécules biologiques","pour la découverte et le développement des polymères conducteurs"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12795: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Hideki Shirakawa a-t-il reçu le Prix Nobel en 2000 ?",
      answers: ["Sciences Économiques","Littérature","Chimie","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12796: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Arvid Carlsson a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour ses découvertes concernant la transmission des signaux dans le système nerveux ?",
      answers: ["1999","2004","2000","2015"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12797: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2000 pour ses découvertes concernant la transmission des signaux dans le système nerveux ?",
      answers: ["Nikolaas Tinbergen","Alfred G. Gilman","Arvid Carlsson","Eric R. Kandel"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12798: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Arvid Carlsson a-t-il reçu le Prix Nobel en 2000 ?",
      answers: ["pour ses découvertes concernant la transmission des signaux dans le système nerveux","pour sa découverte du principe génétique de la génération de la diversité des anticorps","pour leurs découvertes sur la régulation du cycle cellulaire","pour leurs découvertes concernant la phosphorylation réversible des protéines comme mécanisme de régulation biologique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12799: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Arvid Carlsson a-t-il reçu le Prix Nobel en 2000 ?",
      answers: ["Littérature","Sciences Économiques","Physiologie ou Médecine","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12800: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Paul Greengard a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour ses découvertes concernant la transmission des signaux dans le système nerveux ?",
      answers: ["2001","2000","2011","1996"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12801: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2000 pour ses découvertes concernant la transmission des signaux dans le système nerveux ?",
      answers: ["Paul Greengard","François Jacob","Tim Hunt","Yoshinori Ohsumi"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12802: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Paul Greengard a-t-il reçu le Prix Nobel en 2000 ?",
      answers: ["pour leurs découvertes concernant l’imagerie par résonance magnétique","pour le développement de la tomographie assistée par ordinateur","pour leurs découvertes sur la régulation du cycle cellulaire","pour ses découvertes concernant la transmission des signaux dans le système nerveux"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12803: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Paul Greengard a-t-il reçu le Prix Nobel en 2000 ?",
      answers: ["Littérature","Chimie","Physiologie ou Médecine","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12804: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Eric R. Kandel a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour ses découvertes concernant la transmission des signaux dans le système nerveux ?",
      answers: ["2004","2010","2005","2000"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12805: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2000 pour ses découvertes concernant la transmission des signaux dans le système nerveux ?",
      answers: ["Eric R. Kandel","Arvid Carlsson","Erwin Neher","Günter Blobel"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12806: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Eric R. Kandel a-t-il reçu le Prix Nobel en 2000 ?",
      answers: ["pour la découverte du virus de l’hépatite C","pour leurs découvertes sur les modifications des bases nucléosidiques qui ont permis le développement de vaccins à ARNm efficaces contre le COVID-19","pour leurs découvertes sur la régulation du cycle cellulaire","pour ses découvertes concernant la transmission des signaux dans le système nerveux"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12807: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Eric R. Kandel a-t-il reçu le Prix Nobel en 2000 ?",
      answers: ["Paix","Physique","Littérature","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12808: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Gao Xingjian a-t-il reçu le Prix Nobel de Littérature pour une œuvre d’une portée universelle, marquée d’amertume et d’ingéniosité linguistique, qui a ouvert de nouvelles voies au roman et au théâtre chinois ?",
      answers: ["2004","1998","1948","2000"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12809: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 2000 pour une œuvre d’une portée universelle, marquée d’amertume et d’ingéniosité linguistique, qui a ouvert de nouvelles voies au roman et au théâtre chinois ?",
      answers: ["Seamus Heaney","V. S. Naipaul","Gao Xingjian","François Mauriac"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12810: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Gao Xingjian a-t-il reçu le Prix Nobel en 2000 ?",
      answers: ["dont les contes burlesques et noirs dépeignent le visage oublié de l’histoire","pour une œuvre d’une portée universelle, marquée d’amertume et d’ingéniosité linguistique, qui a ouvert de nouvelles voies au roman et au théâtre chinois","qui, avec la concentration de la poésie et la franchise de la prose, dépeint le paysage des dépossédés","pour avoir uni une prose narrative perceptive à un regard incorruptible dans des œuvres qui nous obligent à voir la présence d’histoires supprimées"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12811: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Gao Xingjian a-t-il reçu le Prix Nobel en 2000 ?",
      answers: ["Physiologie ou Médecine","Paix","Littérature","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12812: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Kim Dae-jung a-t-il reçu le Prix Nobel de Paix pour son travail pour la démocratie et les droits humains en Corée du Sud et en Asie de l’Est, et pour la paix avec la Corée du Nord ?",
      answers: ["2001","2000","1937","1992"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12813: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2000 pour son travail pour la démocratie et les droits humains en Corée du Sud et en Asie de l’Est, et pour la paix avec la Corée du Nord ?",
      answers: ["Jody Williams","Wangari Maathai","Al Gore","Kim Dae-jung"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12814: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Kim Dae-jung a-t-il reçu le Prix Nobel en 2000 ?",
      answers: ["pour ses efforts visant à obtenir un monde sans armes nucléaires et pour avoir démontré par des témoignages que les armes nucléaires ne doivent plus jamais être utilisées","pour leur travail visant à interdire et éliminer les mines antipersonnel","pour leurs efforts visant à trouver une solution pacifique au conflit en Irlande du Nord","pour son travail pour la démocratie et les droits humains en Corée du Sud et en Asie de l’Est, et pour la paix avec la Corée du Nord"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12815: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Kim Dae-jung a-t-il reçu le Prix Nobel en 2000 ?",
      answers: ["Chimie","Physiologie ou Médecine","Sciences Économiques","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12816: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année James J. Heckman a-t-il reçu le Prix Nobel de Sciences Économiques pour ses méthodes d’analyse des données microéconomiques ?",
      answers: ["1995","2005","2000","2008"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12817: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2000 pour ses méthodes d’analyse des données microéconomiques ?",
      answers: ["Edward C. Prescott","James J. Heckman","George A. Akerlof","Joseph E. Stiglitz"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12818: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison James J. Heckman a-t-il reçu le Prix Nobel en 2000 ?",
      answers: ["pour ses méthodes d’analyse des données microéconomiques","pour leurs analyses pionnières des équilibres dans la théorie des jeux non coopératifs","pour sa découverte et sa clarification de la signification des coûts de transaction et des droits de propriété dans la structure économique","pour ses méthodes d’analyse des choix discrets en économie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12819: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie James J. Heckman a-t-il reçu le Prix Nobel en 2000 ?",
      answers: ["Littérature","Physique","Sciences Économiques","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12820: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Daniel L. McFadden a-t-il reçu le Prix Nobel de Sciences Économiques pour ses méthodes d’analyse des choix discrets en économie ?",
      answers: ["2000","1984","2009","1974"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12821: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2000 pour ses méthodes d’analyse des choix discrets en économie ?",
      answers: ["James J. Heckman","Vernon L. Smith","Joseph E. Stiglitz","Daniel L. McFadden"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12822: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Daniel L. McFadden a-t-il reçu le Prix Nobel en 2000 ?",
      answers: ["pour ses méthodes d’analyse des choix discrets en économie","pour leur analyse des marchés avec information asymétrique","pour avoir intégré des perspectives psychologiques dans l’analyse économique, notamment sur le comportement humain sous incertitude","pour avoir développé et appliqué l’hypothèse des anticipations rationnelles"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12823: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Daniel L. McFadden a-t-il reçu le Prix Nobel en 2000 ?",
      answers: ["Chimie","Sciences Économiques","Physique","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12824: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Eric A. Cornell a-t-il reçu le Prix Nobel de Physique pour la réalisation de la condensation de Bose-Einstein dans des gaz dilués d’atomes alcalins ?",
      answers: ["2001","2022","2004","1993"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12825: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2001 pour la réalisation de la condensation de Bose-Einstein dans des gaz dilués d’atomes alcalins ?",
      answers: ["Arthur B. McDonald","Eric A. Cornell","Wolfgang Ketterle","John J. Hopfield"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12826: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Eric A. Cornell a-t-il reçu le Prix Nobel en 2001 ?",
      answers: ["pour la découverte de la liberté asymptotique dans la théorie de l’interaction forte","pour l’invention de diodes électroluminescentes bleues efficaces, permettant des sources de lumière blanche brillantes et économes en énergie","pour leur développement de nouvelles méthodes pour la mesure précise des propriétés magnétiques nucléaires","pour la réalisation de la condensation de Bose-Einstein dans des gaz dilués d’atomes alcalins"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12827: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Eric A. Cornell a-t-il reçu le Prix Nobel en 2001 ?",
      answers: ["Physique","Paix","Physiologie ou Médecine","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12828: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Wolfgang Ketterle a-t-il reçu le Prix Nobel de Physique pour la réalisation de la condensation de Bose-Einstein dans des gaz dilués d’atomes alcalins ?",
      answers: ["2003","1995","2001","1976"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12829: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2001 pour la réalisation de la condensation de Bose-Einstein dans des gaz dilués d’atomes alcalins ?",
      answers: ["Norman F. Ramsey","Wolfgang Ketterle","Frank Wilczek","Klaus Hasselmann"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12830: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Wolfgang Ketterle a-t-il reçu le Prix Nobel en 2001 ?",
      answers: ["pour sa méthode de reproduction des couleurs par photographie basée sur le phénomène d’interférence","pour leurs contributions pionnières à l’astrophysique, notamment la détection des neutrinos cosmiques","pour la découverte de la liberté asymptotique dans la théorie de l’interaction forte","pour la réalisation de la condensation de Bose-Einstein dans des gaz dilués d’atomes alcalins"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12831: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Wolfgang Ketterle a-t-il reçu le Prix Nobel en 2001 ?",
      answers: ["Physiologie ou Médecine","Littérature","Paix","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12832: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Carl E. Wieman a-t-il reçu le Prix Nobel de Physique pour la réalisation de la condensation de Bose-Einstein dans des gaz dilués d’atomes alcalins ?",
      answers: ["2001","2002","1966","2000"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12833: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2001 pour la réalisation de la condensation de Bose-Einstein dans des gaz dilués d’atomes alcalins ?",
      answers: ["Carl E. Wieman","James Peebles","J. Michael Kosterlitz","David J. Thouless"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12834: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Carl E. Wieman a-t-il reçu le Prix Nobel en 2001 ?",
      answers: ["pour la méthode du faisceau de neutrinos et la démonstration de la structure en doublet des leptons par la découverte du neutrino muonique","pour la réalisation de la condensation de Bose-Einstein dans des gaz dilués d’atomes alcalins","pour la détection du neutrino","pour la découverte d’un nouveau type de pulsar, une découverte qui a ouvert de nouvelles possibilités pour l’étude de la gravitation"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12835: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Carl E. Wieman a-t-il reçu le Prix Nobel en 2001 ?",
      answers: ["Physique","Littérature","Paix","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12836: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année William S. Knowles a-t-il reçu le Prix Nobel de Chimie pour son travail sur les réactions d’hydrogénation catalysées de manière chirale ?",
      answers: ["1987","2001","1992","2011"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12837: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2001 pour son travail sur les réactions d’hydrogénation catalysées de manière chirale ?",
      answers: ["Kurt Wüthrich","John W. Cornforth","William S. Knowles","Dorothy Crowfoot Hodgkin"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12838: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison William S. Knowles a-t-il reçu le Prix Nobel en 2001 ?",
      answers: ["pour ses développements de méthodes computationnelles en chimie quantique","pour ses déterminations par des techniques de rayons X des structures de substances biochimiques importantes","pour son travail sur les réactions d’hydrogénation catalysées de manière chirale","pour la découverte des quasi-cristaux"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12839: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie William S. Knowles a-t-il reçu le Prix Nobel en 2001 ?",
      answers: ["Littérature","Chimie","Physiologie ou Médecine","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12840: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Ryoji Noyori a-t-il reçu le Prix Nobel de Chimie pour son travail sur les réactions d’hydrogénation catalysées de manière chirale ?",
      answers: ["2003","2021","2001","2000"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12841: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2001 pour son travail sur les réactions d’hydrogénation catalysées de manière chirale ?",
      answers: ["William S. Knowles","Walter Kohn","Jens C. Skou","Ryoji Noyori"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12842: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Ryoji Noyori a-t-il reçu le Prix Nobel en 2001 ?",
      answers: ["pour son travail sur les réactions d’hydrogénation catalysées de manière chirale","pour ses études structurales et mécanistiques des canaux ioniques","pour son travail sur les réactions d’oxydation catalysées de manière chirale","pour ses contributions à la thermodynamique hors équilibre, en particulier la théorie des structures dissipatives"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12843: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Ryoji Noyori a-t-il reçu le Prix Nobel en 2001 ?",
      answers: ["Paix","Physique","Chimie","Sciences Économiques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12844: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année K. Barry Sharpless a-t-il reçu le Prix Nobel de Chimie pour son travail sur les réactions d’oxydation catalysées de manière chirale ?",
      answers: ["2001","2006","1996","2004"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12845: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2001 pour son travail sur les réactions d’oxydation catalysées de manière chirale ?",
      answers: ["K. Barry Sharpless","Peter Agre","John A. Pople","Robert H. Grubbs"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12846: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison K. Barry Sharpless a-t-il reçu le Prix Nobel en 2001 ?",
      answers: ["pour sa démonstration de la nature hétérogène des solutions colloïdales et pour les méthodes qu’il a utilisées, qui sont devenues fondamentales en chimie colloïdale moderne","pour leur découverte des fullerènes","pour son travail sur les réactions d’oxydation catalysées de manière chirale","pour le développement de méthodes d’analyse des macromolécules biologiques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12847: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie K. Barry Sharpless a-t-il reçu le Prix Nobel en 2001 ?",
      answers: ["Chimie","Physique","Paix","Littérature"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12848: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Leland H. Hartwell a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes sur la régulation du cycle cellulaire ?",
      answers: ["1990","1967","2001","1994"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12849: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2001 pour leurs découvertes sur la régulation du cycle cellulaire ?",
      answers: ["H. Robert Horvitz","Leland H. Hartwell","Sir John B. Gurdon","Phillip A. Sharp"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12850: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Leland H. Hartwell a-t-il reçu le Prix Nobel en 2001 ?",
      answers: ["pour leurs découvertes sur la régulation du cycle cellulaire","pour leurs découvertes concernant le monoxyde d’azote comme molécule de signalisation dans le système cardiovasculaire","pour la découverte que les protéines ont des signaux intrinsèques qui régissent leur transport et leur localisation dans la cellule","pour leurs découvertes concernant la thérapie par le foie dans les cas d’anémie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12851: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Leland H. Hartwell a-t-il reçu le Prix Nobel en 2001 ?",
      answers: ["Physique","Paix","Physiologie ou Médecine","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12852: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Tim Hunt a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes sur la régulation du cycle cellulaire ?",
      answers: ["1999","2001","1980","2002"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12853: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2001 pour leurs découvertes sur la régulation du cycle cellulaire ?",
      answers: ["Tim Hunt","Arvid Carlsson","Alfred G. Gilman","Godfrey N. Hounsfield"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12854: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Tim Hunt a-t-il reçu le Prix Nobel en 2001 ?",
      answers: ["pour leurs découvertes concernant les mécanismes ioniques impliqués dans l’excitation et l’inhibition dans les parties périphériques et centrales de la membrane des cellules nerveuses","pour leurs découvertes sur la régulation du cycle cellulaire","pour leurs découvertes concernant l’imagerie par résonance magnétique","pour leurs découvertes sur la régulation génétique du développement des organes et de la mort cellulaire programmée"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12855: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Tim Hunt a-t-il reçu le Prix Nobel en 2001 ?",
      answers: ["Physiologie ou Médecine","Physique","Chimie","Sciences Économiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12856: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Sir Paul M. Nurse a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes sur la régulation du cycle cellulaire ?",
      answers: ["1949","1994","2001","2002"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12857: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2001 pour leurs découvertes sur la régulation du cycle cellulaire ?",
      answers: ["Leland H. Hartwell","Karl von Frisch","Alfred G. Gilman","Sir Paul M. Nurse"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12858: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Sir Paul M. Nurse a-t-il reçu le Prix Nobel en 2001 ?",
      answers: ["pour leurs découvertes concernant l’organisation structurelle et fonctionnelle de la cellule","pour leurs découvertes concernant les hormones du cortex surrénalien, leur structure et leurs effets biologiques","pour leurs découvertes concernant une nouvelle thérapie contre les infections causées par des parasites","pour leurs découvertes sur la régulation du cycle cellulaire"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12859: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Sir Paul M. Nurse a-t-il reçu le Prix Nobel en 2001 ?",
      answers: ["Paix","Physiologie ou Médecine","Physique","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12860: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année V. S. Naipaul a-t-il reçu le Prix Nobel de Littérature pour avoir uni une prose narrative perceptive à un regard incorruptible dans des œuvres qui nous obligent à voir la présence d’histoires supprimées ?",
      answers: ["2004","2001","1970","2002"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12861: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 2001 pour avoir uni une prose narrative perceptive à un regard incorruptible dans des œuvres qui nous obligent à voir la présence d’histoires supprimées ?",
      answers: ["V. S. Naipaul","Doris Lessing","Herta Müller","Elfriede Jelinek"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12862: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison V. S. Naipaul a-t-il reçu le Prix Nobel en 2001 ?",
      answers: ["pour une poésie qui, avec une précision ironique, permet au contexte historique et biologique de se manifester dans des fragments de réalité humaine","pour une œuvre d’une portée universelle, marquée d’amertume et d’ingéniosité linguistique, qui a ouvert de nouvelles voies au roman et au théâtre chinois","pour avoir uni une prose narrative perceptive à un regard incorruptible dans des œuvres qui nous obligent à voir la présence d’histoires supprimées","qui, à travers des œuvres riches en nuances, a donné forme à un art narratif arabe qui s’applique à toute l’humanité"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12863: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie V. S. Naipaul a-t-il reçu le Prix Nobel en 2001 ?",
      answers: ["Littérature","Physique","Paix","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12864: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Nations Unies (ONU) a-t-il reçu le Prix Nobel de Paix pour leur travail en faveur d’un monde mieux organisé et plus pacifique ?",
      answers: ["2003","1990","2005","2001"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12865: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2001 pour leur travail en faveur d’un monde mieux organisé et plus pacifique ?",
      answers: ["Fonds des Nations Unies pour l’Enfance (UNICEF)","Kofi Annan","Nations Unies (ONU)","Christian Lous Lange"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12866: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Nations Unies (ONU) a-t-il reçu le Prix Nobel en 2001 ?",
      answers: ["pour leur travail en faveur d’un monde mieux organisé et plus pacifique","pour son travail en faveur de la justice sociale et de la réconciliation ethno-culturelle basée sur le respect des droits des peuples indigènes","pour leurs efforts visant à empêcher l’utilisation militaire de l’énergie nucléaire et à promouvoir son usage pacifique","pour sa lutte non violente pour la liberté syndicale et les droits des travailleurs en Pologne"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12867: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Nations Unies (ONU) a-t-il reçu le Prix Nobel en 2001 ?",
      answers: ["Paix","Physiologie ou Médecine","Sciences Économiques","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12868: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Kofi Annan a-t-il reçu le Prix Nobel de Paix pour leur travail en faveur d’un monde mieux organisé et plus pacifique ?",
      answers: ["2001","1989","1996","1976"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12869: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2001 pour leur travail en faveur d’un monde mieux organisé et plus pacifique ?",
      answers: ["José Ramos-Horta","Comité International de la Croix-Rouge (CICR)","Kofi Annan","Lester B. Pearson"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12870: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Kofi Annan a-t-il reçu le Prix Nobel en 2001 ?",
      answers: ["pour leurs efforts visant à créer un développement économique et social par le bas","pour leur travail en faveur d’un monde mieux organisé et plus pacifique","pour ses efforts en faveur de la démocratie et des droits humains, notamment pour les femmes et les enfants","pour leurs efforts visant à trouver une solution pacifique au conflit en Irlande du Nord"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12871: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Kofi Annan a-t-il reçu le Prix Nobel en 2001 ?",
      answers: ["Sciences Économiques","Paix","Chimie","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12872: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année George A. Akerlof a-t-il reçu le Prix Nobel de Sciences Économiques pour leur analyse des marchés avec information asymétrique ?",
      answers: ["2020","1972","2001","2002"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12873: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2001 pour leur analyse des marchés avec information asymétrique ?",
      answers: ["Paul Krugman","George A. Akerlof","Elinor Ostrom","Douglass C. North"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12874: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison George A. Akerlof a-t-il reçu le Prix Nobel en 2001 ?",
      answers: ["pour avoir intégré des perspectives psychologiques dans l’analyse économique, notamment sur le comportement humain sous incertitude","pour leur analyse des marchés avec information asymétrique","pour leurs contributions fondamentales à la théorie économique des incitations sous information asymétrique","pour leurs analyses pionnières des équilibres dans la théorie des jeux non coopératifs"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12875: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie George A. Akerlof a-t-il reçu le Prix Nobel en 2001 ?",
      answers: ["Sciences Économiques","Physique","Littérature","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12876: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année A. Michael Spence a-t-il reçu le Prix Nobel de Sciences Économiques pour leur analyse des marchés avec information asymétrique ?",
      answers: ["2001","1989","2008","1984"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12877: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2001 pour leur analyse des marchés avec information asymétrique ?",
      answers: ["Joseph E. Stiglitz","A. Michael Spence","Daniel Kahneman","Daniel L. McFadden"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12878: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison A. Michael Spence a-t-il reçu le Prix Nobel en 2001 ?",
      answers: ["pour son analyse de la gouvernance économique, notamment des biens communs","pour ses contributions à l’économie du bien-être","pour leur analyse des marchés avec information asymétrique","pour leurs contributions pionnières à la théorie de l’économie financière"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12879: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie A. Michael Spence a-t-il reçu le Prix Nobel en 2001 ?",
      answers: ["Chimie","Physiologie ou Médecine","Physique","Sciences Économiques"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12880: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Joseph E. Stiglitz a-t-il reçu le Prix Nobel de Sciences Économiques pour leur analyse des marchés avec information asymétrique ?",
      answers: ["1990","1962","2012","2001"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12881: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2001 pour leur analyse des marchés avec information asymétrique ?",
      answers: ["Vernon L. Smith","Amartya Sen","Robert F. Engle","Joseph E. Stiglitz"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12882: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Joseph E. Stiglitz a-t-il reçu le Prix Nobel en 2001 ?",
      answers: ["pour avoir établi des expériences de laboratoire comme outil dans l’analyse économique empirique","pour ses méthodes d’analyse des séries temporelles économiques avec volatilité variable","pour la théorie des allocations stables et la pratique de la conception de marchés","pour leur analyse des marchés avec information asymétrique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12883: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Joseph E. Stiglitz a-t-il reçu le Prix Nobel en 2001 ?",
      answers: ["Littérature","Chimie","Physiologie ou Médecine","Sciences Économiques"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12884: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Raymond Davis Jr. a-t-il reçu le Prix Nobel de Physique pour leurs contributions pionnières à l’astrophysique, notamment la détection des neutrinos cosmiques ?",
      answers: ["2007","1955","2002","1966"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12885: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2002 pour leurs contributions pionnières à l’astrophysique, notamment la détection des neutrinos cosmiques ?",
      answers: ["Raymond Davis Jr.","Philip W. Anderson","Frank Wilczek","Jack S. Kilby"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12886: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Raymond Davis Jr. a-t-il reçu le Prix Nobel en 2002 ?",
      answers: ["pour le développement de semi-conducteurs utilisés dans l’électronique à haute vitesse et l’optoélectronique","pour leurs contributions pionnières à l’astrophysique, notamment la détection des neutrinos cosmiques","pour ses réalisations pionnières concernant la transmission de la lumière dans les fibres pour la communication optique","pour la découverte de la liberté asymptotique dans la théorie de l’interaction forte"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12887: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Raymond Davis Jr. a-t-il reçu le Prix Nobel en 2002 ?",
      answers: ["Sciences Économiques","Physiologie ou Médecine","Physique","Paix"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12888: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Masatoshi Koshiba a-t-il reçu le Prix Nobel de Physique pour leurs contributions pionnières à l’astrophysique, notamment la détection des neutrinos cosmiques ?",
      answers: ["1969","2003","2002","2000"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12889: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2002 pour leurs contributions pionnières à l’astrophysique, notamment la détection des neutrinos cosmiques ?",
      answers: ["J. Michael Kosterlitz","Wilhelm C. Röntgen","Masatoshi Koshiba","Aleksandr M. Prokhorov"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12890: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Masatoshi Koshiba a-t-il reçu le Prix Nobel en 2002 ?",
      answers: ["pour sa méthode de rendre visibles les trajectoires des particules chargées électriquement au moyen de la condensation de la vapeur","pour la découverte de la liberté asymptotique dans la théorie de l’interaction forte","pour ses recherches fondamentales en mécanique quantique, en particulier pour son interprétation statistique de la fonction d’onde","pour leurs contributions pionnières à l’astrophysique, notamment la détection des neutrinos cosmiques"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12891: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Masatoshi Koshiba a-t-il reçu le Prix Nobel en 2002 ?",
      answers: ["Physique","Sciences Économiques","Littérature","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12892: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Riccardo Giacconi a-t-il reçu le Prix Nobel de Physique pour ses contributions pionnières à l’astrophysique, qui ont conduit à la découverte des sources de rayons X cosmiques ?",
      answers: ["2005","2002","1930","1994"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12893: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2002 pour ses contributions pionnières à l’astrophysique, qui ont conduit à la découverte des sources de rayons X cosmiques ?",
      answers: ["John C. Mather","Frederick Reines","Riccardo Giacconi","Raymond Davis Jr."],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12894: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Riccardo Giacconi a-t-il reçu le Prix Nobel en 2002 ?",
      answers: ["pour leurs contributions fondamentales à la compréhension des interactions électrofaibles dans la théorie quantique des champs","pour ses contributions pionnières à l’astrophysique, qui ont conduit à la découverte des sources de rayons X cosmiques","pour la découverte de la liberté asymptotique dans la théorie de l’interaction forte","pour avoir découvert que les méthodes développées pour étudier les phénomènes d’ordre dans les systèmes simples peuvent être généralisées à des formes plus complexes de la matière"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12895: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Riccardo Giacconi a-t-il reçu le Prix Nobel en 2002 ?",
      answers: ["Physiologie ou Médecine","Physique","Chimie","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12896: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année John B. Fenn a-t-il reçu le Prix Nobel de Chimie pour le développement de méthodes d’analyse des macromolécules biologiques ?",
      answers: ["1920","1999","2002","1994"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12897: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2002 pour le développement de méthodes d’analyse des macromolécules biologiques ?",
      answers: ["Osamu Shimomura","John B. Fenn","Hideki Shirakawa","Kurt Wüthrich"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12898: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison John B. Fenn a-t-il reçu le Prix Nobel en 2002 ?",
      answers: ["pour la conception et la synthèse de machines moléculaires","pour le développement de méthodes d’analyse des macromolécules biologiques","pour la découverte et le développement des polymères conducteurs","pour le développement de la microscopie à fluorescence à super-résolution"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12899: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie John B. Fenn a-t-il reçu le Prix Nobel en 2002 ?",
      answers: ["Paix","Littérature","Physiologie ou Médecine","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12900: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Koichi Tanaka a-t-il reçu le Prix Nobel de Chimie pour le développement de méthodes d’analyse des macromolécules biologiques ?",
      answers: ["1908","2007","2002","2013"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12901: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2002 pour le développement de méthodes d’analyse des macromolécules biologiques ?",
      answers: ["Osamu Shimomura","Peter Agre","Martin Chalfie","Koichi Tanaka"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12902: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Koichi Tanaka a-t-il reçu le Prix Nobel en 2002 ?",
      answers: ["pour leurs recherches sur la fermentation des sucres et les enzymes fermentatives","pour le développement de méthodes d’analyse des macromolécules biologiques","pour ses études structurales et mécanistiques des canaux ioniques","pour le développement de la spectroscopie par résonance magnétique nucléaire pour déterminer la structure tridimensionnelle des macromolécules biologiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12903: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Koichi Tanaka a-t-il reçu le Prix Nobel en 2002 ?",
      answers: ["Physique","Paix","Chimie","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12904: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Kurt Wüthrich a-t-il reçu le Prix Nobel de Chimie pour le développement de la spectroscopie par résonance magnétique nucléaire pour déterminer la structure tridimensionnelle des macromolécules biologiques ?",
      answers: ["1999","2002","2000","1979"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12905: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2002 pour le développement de la spectroscopie par résonance magnétique nucléaire pour déterminer la structure tridimensionnelle des macromolécules biologiques ?",
      answers: ["Kurt Wüthrich","Peter Agre","Koichi Tanaka","Gerhard Herzberg"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12906: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Kurt Wüthrich a-t-il reçu le Prix Nobel en 2002 ?",
      answers: ["pour le développement de la spectroscopie par résonance magnétique nucléaire pour déterminer la structure tridimensionnelle des macromolécules biologiques","pour son travail sur les réactions d’oxydation catalysées de manière chirale","pour leur découverte et le développement de la synthèse par diène","pour la première découverte d’une enzyme transportant des ions, la Na+, K+-ATPase"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12907: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Kurt Wüthrich a-t-il reçu le Prix Nobel en 2002 ?",
      answers: ["Paix","Physique","Physiologie ou Médecine","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12908: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Sydney Brenner a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes sur la régulation génétique du développement des organes et de la mort cellulaire programmée ?",
      answers: ["2003","2002","2001","1999"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12909: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2002 pour leurs découvertes sur la régulation génétique du développement des organes et de la mort cellulaire programmée ?",
      answers: ["Sydney Brenner","Françoise Barré-Sinoussi","Leland H. Hartwell","Sir Peter Mansfield"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12910: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Sydney Brenner a-t-il reçu le Prix Nobel en 2002 ?",
      answers: ["pour leurs découvertes sur la régulation génétique du développement des organes et de la mort cellulaire programmée","pour leurs découvertes des facteurs de croissance","pour leur découverte des protéines G et leur rôle dans la transduction des signaux dans les cellules","pour leurs découvertes concernant le contrôle génétique du développement précoce de l’embryon"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12911: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Sydney Brenner a-t-il reçu le Prix Nobel en 2002 ?",
      answers: ["Paix","Littérature","Sciences Économiques","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12912: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année H. Robert Horvitz a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes sur la régulation génétique du développement des organes et de la mort cellulaire programmée ?",
      answers: ["2007","2001","2006","2002"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12913: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2002 pour leurs découvertes sur la régulation génétique du développement des organes et de la mort cellulaire programmée ?",
      answers: ["Eric R. Kandel","Robert G. Edwards","H. Robert Horvitz","Tim Hunt"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12914: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison H. Robert Horvitz a-t-il reçu le Prix Nobel en 2002 ?",
      answers: ["pour ses découvertes concernant le traitement hormonal du cancer de la prostate","pour leurs découvertes sur la régulation du cycle cellulaire","pour leur découverte des protéines G et leur rôle dans la transduction des signaux dans les cellules","pour leurs découvertes sur la régulation génétique du développement des organes et de la mort cellulaire programmée"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12915: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie H. Robert Horvitz a-t-il reçu le Prix Nobel en 2002 ?",
      answers: ["Sciences Économiques","Chimie","Physique","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12916: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année John E. Sulston a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes sur la régulation génétique du développement des organes et de la mort cellulaire programmée ?",
      answers: ["1999","1982","1992","2002"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12917: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2002 pour leurs découvertes sur la régulation génétique du développement des organes et de la mort cellulaire programmée ?",
      answers: ["Drew Weissman","John E. Sulston","André Lwoff","Richard Axel"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12918: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison John E. Sulston a-t-il reçu le Prix Nobel en 2002 ?",
      answers: ["pour leurs découvertes concernant la phosphorylation réversible des protéines comme mécanisme de régulation biologique","pour leurs découvertes sur la régulation du cycle cellulaire","pour leurs découvertes sur la régulation génétique du développement des organes et de la mort cellulaire programmée","pour leurs découvertes concernant la spécificité de la réponse immunitaire à médiation cellulaire"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12919: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie John E. Sulston a-t-il reçu le Prix Nobel en 2002 ?",
      answers: ["Sciences Économiques","Physiologie ou Médecine","Chimie","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12920: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Imre Kertész a-t-il reçu le Prix Nobel de Littérature pour une œuvre qui défend la fragile expérience de l’individu contre l’arbitraire barbare de l’histoire ?",
      answers: ["2002","2003","1997","2000"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12921: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 2002 pour une œuvre qui défend la fragile expérience de l’individu contre l’arbitraire barbare de l’histoire ?",
      answers: ["Imre Kertész","Jean-Paul Sartre","Dario Fo","Gao Xingjian"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12922: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Imre Kertész a-t-il reçu le Prix Nobel en 2002 ?",
      answers: ["dont les contes burlesques et noirs dépeignent le visage oublié de l’histoire","pour sa poésie qui, avec une fraîcheur, une sensualité et une inventivité riches, donne une image libératrice de l’esprit indomptable et de la polyvalence de l’homme","maîtresse de la nouvelle contemporaine","pour une œuvre qui défend la fragile expérience de l’individu contre l’arbitraire barbare de l’histoire"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12923: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Imre Kertész a-t-il reçu le Prix Nobel en 2002 ?",
      answers: ["Physique","Chimie","Littérature","Paix"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12924: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Jimmy Carter a-t-il reçu le Prix Nobel de Paix pour ses décennies d’efforts inlassables pour trouver des solutions pacifiques aux conflits internationaux ?",
      answers: ["2002","2014","1944","2004"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12925: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2002 pour ses décennies d’efforts inlassables pour trouver des solutions pacifiques aux conflits internationaux ?",
      answers: ["Liu Xiaobo","Jimmy Carter","Nations Unies (ONU)","Shirin Ebadi"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12926: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Jimmy Carter a-t-il reçu le Prix Nobel en 2002 ?",
      answers: ["pour ses efforts en faveur de la démocratie et des droits humains, notamment pour les femmes et les enfants","pour leur travail en faveur d’un monde mieux organisé et plus pacifique","pour son travail en faveur de la paix et de la coopération internationale","pour ses décennies d’efforts inlassables pour trouver des solutions pacifiques aux conflits internationaux"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12927: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Jimmy Carter a-t-il reçu le Prix Nobel en 2002 ?",
      answers: ["Physiologie ou Médecine","Chimie","Physique","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12928: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Daniel Kahneman a-t-il reçu le Prix Nobel de Sciences Économiques pour avoir intégré des perspectives psychologiques dans l’analyse économique, notamment sur le comportement humain sous incertitude ?",
      answers: ["2002","1959","2003","1910"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12929: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2002 pour avoir intégré des perspectives psychologiques dans l’analyse économique, notamment sur le comportement humain sous incertitude ?",
      answers: ["Daniel Kahneman","Roger B. Myerson","Clive W. J. Granger","Vernon L. Smith"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12930: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Daniel Kahneman a-t-il reçu le Prix Nobel en 2002 ?",
      answers: ["pour leurs contributions pionnières à la théorie de l’équilibre économique général et à la théorie du bien-être","pour ses recherches sur les banques et les crises financières","pour avoir intégré des perspectives psychologiques dans l’analyse économique, notamment sur le comportement humain sous incertitude","pour leurs contributions méthodologiques à l’analyse des relations causales"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12931: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Daniel Kahneman a-t-il reçu le Prix Nobel en 2002 ?",
      answers: ["Physiologie ou Médecine","Littérature","Sciences Économiques","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12932: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Vernon L. Smith a-t-il reçu le Prix Nobel de Sciences Économiques pour avoir établi des expériences de laboratoire comme outil dans l’analyse économique empirique ?",
      answers: ["1964","2004","1971","2002"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12933: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2002 pour avoir établi des expériences de laboratoire comme outil dans l’analyse économique empirique ?",
      answers: ["Vernon L. Smith","George A. Akerlof","Thomas C. Schelling","Daniel Kahneman"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12934: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Vernon L. Smith a-t-il reçu le Prix Nobel en 2002 ?",
      answers: ["pour ses améliorations à la théorie des enchères et ses inventions de nouveaux formats d’enchères","pour leurs contributions à la macroéconomie dynamique","pour leurs travaux empiriques sur la cause et l’effet en macroéconomie","pour avoir établi des expériences de laboratoire comme outil dans l’analyse économique empirique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12935: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Vernon L. Smith a-t-il reçu le Prix Nobel en 2002 ?",
      answers: ["Physiologie ou Médecine","Sciences Économiques","Littérature","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12936: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Alexei A. Abrikosov a-t-il reçu le Prix Nobel de Physique pour leurs contributions pionnières à la théorie des supraconducteurs et des superfluides ?",
      answers: ["2004","1919","2006","2003"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12937: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2003 pour leurs contributions pionnières à la théorie des supraconducteurs et des superfluides ?",
      answers: ["David J. Gross","Toshihide Maskawa","Alexei A. Abrikosov","Masatoshi Koshiba"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12938: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Alexei A. Abrikosov a-t-il reçu le Prix Nobel en 2003 ?",
      answers: ["pour leurs contributions pionnières à la théorie des supraconducteurs et des superfluides","pour ses contributions pionnières à l’astrophysique, qui ont conduit à la découverte des sources de rayons X cosmiques","pour leur découverte de la superfluidité dans l’hélium-3","pour leur découverte de la forme du corps noir et de l’anisotropie du fond diffus cosmologique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12939: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Alexei A. Abrikosov a-t-il reçu le Prix Nobel en 2003 ?",
      answers: ["Chimie","Physiologie ou Médecine","Paix","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12940: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Vitaly L. Ginzburg a-t-il reçu le Prix Nobel de Physique pour leurs contributions pionnières à la théorie des supraconducteurs et des superfluides ?",
      answers: ["1994","2003","1931","2002"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12941: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2003 pour leurs contributions pionnières à la théorie des supraconducteurs et des superfluides ?",
      answers: ["Vitaly L. Ginzburg","Masatoshi Koshiba","Wolfgang Paul","Alexei A. Abrikosov"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12942: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Vitaly L. Ginzburg a-t-il reçu le Prix Nobel en 2003 ?",
      answers: ["pour la découverte de la liberté asymptotique dans la théorie de l’interaction forte","pour ses études théoriques des processus physiques importants pour la structure et l’évolution des étoiles","pour la modélisation physique du climat terrestre, la quantification de sa variabilité et la prédiction fiable du réchauffement climatique","pour leurs contributions pionnières à la théorie des supraconducteurs et des superfluides"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12943: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Vitaly L. Ginzburg a-t-il reçu le Prix Nobel en 2003 ?",
      answers: ["Littérature","Physiologie ou Médecine","Paix","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12944: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Anthony J. Leggett a-t-il reçu le Prix Nobel de Physique pour leurs contributions pionnières à la théorie des supraconducteurs et des superfluides ?",
      answers: ["2003","1971","1996","2005"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12945: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2003 pour leurs contributions pionnières à la théorie des supraconducteurs et des superfluides ?",
      answers: ["Anthony J. Leggett","Aleksandr M. Prokhorov","David M. Lee","Gerd Binnig"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12946: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Anthony J. Leggett a-t-il reçu le Prix Nobel en 2003 ?",
      answers: ["pour leurs contributions pionnières à la théorie des supraconducteurs et des superfluides","pour leurs contributions pionnières à l’astrophysique, notamment la détection des neutrinos cosmiques","pour sa contribution à l’invention du circuit intégré","pour leurs contributions au développement de la spectroscopie de précision basée sur le laser"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12947: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Anthony J. Leggett a-t-il reçu le Prix Nobel en 2003 ?",
      answers: ["Physique","Physiologie ou Médecine","Chimie","Sciences Économiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12948: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Peter Agre a-t-il reçu le Prix Nobel de Chimie pour la découverte des canaux d’eau dans les membranes cellulaires ?",
      answers: ["1994","1996","2003","1995"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12949: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2003 pour la découverte des canaux d’eau dans les membranes cellulaires ?",
      answers: ["Kurt Wüthrich","Roderick MacKinnon","Peter Agre","Aaron Ciechanover"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12950: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Peter Agre a-t-il reçu le Prix Nobel en 2003 ?",
      answers: ["pour la découverte des canaux d’eau dans les membranes cellulaires","pour la technique de phage display des peptides et des anticorps","pour le développement de la spectroscopie par résonance magnétique nucléaire pour déterminer la structure tridimensionnelle des macromolécules biologiques","pour le développement de la microscopie à fluorescence à super-résolution"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12951: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Peter Agre a-t-il reçu le Prix Nobel en 2003 ?",
      answers: ["Physiologie ou Médecine","Paix","Chimie","Sciences Économiques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12952: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Roderick MacKinnon a-t-il reçu le Prix Nobel de Chimie pour ses études structurales et mécanistiques des canaux ioniques ?",
      answers: ["2003","2007","2008","2010"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12953: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2003 pour ses études structurales et mécanistiques des canaux ioniques ?",
      answers: ["Jacques Dubochet","Roderick MacKinnon","Irwin Rose","Peter Agre"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12954: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Roderick MacKinnon a-t-il reçu le Prix Nobel en 2003 ?",
      answers: ["pour le développement de méthodes d’analyse des macromolécules biologiques","pour leur découverte des fullerènes","pour le développement d’une méthode d’édition du génome","pour ses études structurales et mécanistiques des canaux ioniques"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12955: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Roderick MacKinnon a-t-il reçu le Prix Nobel en 2003 ?",
      answers: ["Chimie","Littérature","Physiologie ou Médecine","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12956: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Paul C. Lauterbur a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant l’imagerie par résonance magnétique ?",
      answers: ["1971","2003","2007","2016"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12957: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2003 pour leurs découvertes concernant l’imagerie par résonance magnétique ?",
      answers: ["Paul C. Lauterbur","Barry J. Marshall","Sir Peter Mansfield","Joseph E. Murray"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12958: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Paul C. Lauterbur a-t-il reçu le Prix Nobel en 2003 ?",
      answers: ["pour leur découverte de la bactérie Helicobacter pylori et son rôle dans la gastrite et l’ulcère gastrique","pour sa découverte des cellules dendritiques et de leur rôle dans l’immunité adaptative","pour leurs découvertes sur la régulation du cycle cellulaire","pour leurs découvertes concernant l’imagerie par résonance magnétique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12959: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Paul C. Lauterbur a-t-il reçu le Prix Nobel en 2003 ?",
      answers: ["Paix","Physiologie ou Médecine","Physique","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12960: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Sir Peter Mansfield a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant l’imagerie par résonance magnétique ?",
      answers: ["2005","1995","2003","1958"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12961: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2003 pour leurs découvertes concernant l’imagerie par résonance magnétique ?",
      answers: ["Niels K. Jerne","Sir Peter Mansfield","H. Robert Horvitz","Michael Houghton"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12962: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Sir Peter Mansfield a-t-il reçu le Prix Nobel en 2003 ?",
      answers: ["pour leurs découvertes sur les récepteurs olfactifs et l’organisation du système olfactif","pour sa découverte relative à la production de chaleur dans les muscles","pour leur découverte de la bactérie Helicobacter pylori et son rôle dans la gastrite et l’ulcère gastrique","pour leurs découvertes concernant l’imagerie par résonance magnétique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12963: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Sir Peter Mansfield a-t-il reçu le Prix Nobel en 2003 ?",
      answers: ["Physique","Chimie","Physiologie ou Médecine","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12964: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année J. M. Coetzee a-t-il reçu le Prix Nobel de Littérature qui, dans d’innombrables déguisements, dépeint l’implication surprenante de l’étranger ?",
      answers: ["1958","2004","2003","2016"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12965: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 2003 qui, dans d’innombrables déguisements, dépeint l’implication surprenante de l’étranger ?",
      answers: ["Jaroslav Seifert","J. M. Coetzee","Alice Munro","Imre Kertész"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12966: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison J. M. Coetzee a-t-il reçu le Prix Nobel en 2003 ?",
      answers: ["pour sa puissance épique vivante qui a renouvelé le grand art narratif de l’Islande","pour une écriture passionnée aux vastes horizons, caractérisée par une intelligence sensuelle et une intégrité humaniste","qui, avec des paraboles soutenues par l’imagination, la compassion et l’ironie, nous permet de saisir une réalité évasive","qui, dans d’innombrables déguisements, dépeint l’implication surprenante de l’étranger"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12967: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie J. M. Coetzee a-t-il reçu le Prix Nobel en 2003 ?",
      answers: ["Paix","Chimie","Littérature","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12968: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Shirin Ebadi a-t-il reçu le Prix Nobel de Paix pour ses efforts en faveur de la démocratie et des droits humains, notamment pour les femmes et les enfants ?",
      answers: ["2005","2000","2003","1950"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12969: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2003 pour ses efforts en faveur de la démocratie et des droits humains, notamment pour les femmes et les enfants ?",
      answers: ["John Hume","Jody Williams","Wangari Maathai","Shirin Ebadi"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12970: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Shirin Ebadi a-t-il reçu le Prix Nobel en 2003 ?",
      answers: ["pour ses décennies d’efforts inlassables pour trouver des solutions pacifiques aux conflits internationaux","pour sa contribution décisive à la construction d’une démocratie pluraliste en Tunisie après la Révolution du Jasmin de 2011","pour ses efforts en faveur de la démocratie et des droits humains, notamment pour les femmes et les enfants","pour leur lutte non violente pour la sécurité des femmes et pour les droits des femmes à participer pleinement aux processus de paix"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12971: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Shirin Ebadi a-t-il reçu le Prix Nobel en 2003 ?",
      answers: ["Physique","Paix","Sciences Économiques","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12972: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Robert F. Engle a-t-il reçu le Prix Nobel de Sciences Économiques pour ses méthodes d’analyse des séries temporelles économiques avec volatilité variable ?",
      answers: ["1996","2002","2001","2003"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12973: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2003 pour ses méthodes d’analyse des séries temporelles économiques avec volatilité variable ?",
      answers: ["Robert B. Wilson","Joshua D. Angrist","Robert F. Engle","Robert A. Mundell"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12974: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Robert F. Engle a-t-il reçu le Prix Nobel en 2003 ?",
      answers: ["pour avoir posé les bases de la théorie de la conception des mécanismes","pour leur analyse des marchés avec des frictions de recherche","pour avoir intégré des perspectives psychologiques dans l’analyse économique, notamment sur le comportement humain sous incertitude","pour ses méthodes d’analyse des séries temporelles économiques avec volatilité variable"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12975: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Robert F. Engle a-t-il reçu le Prix Nobel en 2003 ?",
      answers: ["Physiologie ou Médecine","Sciences Économiques","Physique","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12976: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Clive W. J. Granger a-t-il reçu le Prix Nobel de Sciences Économiques pour ses méthodes d’analyse des séries temporelles économiques avec co-intégration ?",
      answers: ["1968","2000","2003","2004"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12977: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2003 pour ses méthodes d’analyse des séries temporelles économiques avec co-intégration ?",
      answers: ["Trygve Haavelmo","John R. Hicks","Clive W. J. Granger","A. Michael Spence"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12978: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Clive W. J. Granger a-t-il reçu le Prix Nobel en 2003 ?",
      answers: ["pour ses méthodes d’analyse des séries temporelles économiques avec co-intégration","pour ses réalisations dans les domaines de l’analyse de la consommation, de l’histoire et de la théorie monétaire et pour sa démonstration de la complexité de la politique de stabilisation","pour leur analyse des marchés avec des frictions de recherche","pour ses méthodes d’analyse des séries temporelles économiques avec volatilité variable"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12979: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Clive W. J. Granger a-t-il reçu le Prix Nobel en 2003 ?",
      answers: ["Sciences Économiques","Physique","Chimie","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12980: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année David J. Gross a-t-il reçu le Prix Nobel de Physique pour la découverte de la liberté asymptotique dans la théorie de l’interaction forte ?",
      answers: ["1995","2005","2012","2004"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12981: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2004 pour la découverte de la liberté asymptotique dans la théorie de l’interaction forte ?",
      answers: ["Robert B. Laughlin","David J. Gross","Alexei A. Abrikosov","Takaaki Kajita"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12982: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison David J. Gross a-t-il reçu le Prix Nobel en 2004 ?",
      answers: ["pour l’invention de diodes électroluminescentes bleues efficaces, permettant des sources de lumière blanche brillantes et économes en énergie","pour la découverte de la liberté asymptotique dans la théorie de l’interaction forte","pour leur découverte de la forme du corps noir et de l’anisotropie du fond diffus cosmologique","pour l’invention d’un appareil permettant de produire des pressions extrêmement élevées et pour les découvertes qu’il a réalisées dans le domaine de la physique des hautes pressions"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12983: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie David J. Gross a-t-il reçu le Prix Nobel en 2004 ?",
      answers: ["Physiologie ou Médecine","Littérature","Physique","Paix"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12984: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année H. David Politzer a-t-il reçu le Prix Nobel de Physique pour la découverte de la liberté asymptotique dans la théorie de l’interaction forte ?",
      answers: ["2004","2000","2001","1993"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12985: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2004 pour la découverte de la liberté asymptotique dans la théorie de l’interaction forte ?",
      answers: ["David M. Lee","Eric A. Cornell","Jack S. Kilby","H. David Politzer"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12986: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison H. David Politzer a-t-il reçu le Prix Nobel en 2004 ?",
      answers: ["pour leurs contributions pionnières à la théorie des supraconducteurs et des superfluides","pour leurs contributions fondamentales à la compréhension des interactions électrofaibles dans la théorie quantique des champs","pour le développement de la technique de diffraction neutronique","pour la découverte de la liberté asymptotique dans la théorie de l’interaction forte"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12987: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie H. David Politzer a-t-il reçu le Prix Nobel en 2004 ?",
      answers: ["Sciences Économiques","Physiologie ou Médecine","Physique","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12988: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Frank Wilczek a-t-il reçu le Prix Nobel de Physique pour la découverte de la liberté asymptotique dans la théorie de l’interaction forte ?",
      answers: ["2024","2007","2004","1995"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12989: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2004 pour la découverte de la liberté asymptotique dans la théorie de l’interaction forte ?",
      answers: ["Wolfgang Ketterle","David J. Wineland","Frank Wilczek","H. David Politzer"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12990: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Frank Wilczek a-t-il reçu le Prix Nobel en 2004 ?",
      answers: ["pour la découverte de la liberté asymptotique dans la théorie de l’interaction forte","pour leur découverte de la forme du corps noir et de l’anisotropie du fond diffus cosmologique","pour la découverte de l’expansion accélérée de l’univers par l’observation des supernovae lointaines","pour l’invention d’un capteur d’imagerie à semi-conducteur – le capteur CCD"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12991: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Frank Wilczek a-t-il reçu le Prix Nobel en 2004 ?",
      answers: ["Physique","Physiologie ou Médecine","Chimie","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12992: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Aaron Ciechanover a-t-il reçu le Prix Nobel de Chimie pour la découverte de la dégradation des protéines médiée par l’ubiquitine ?",
      answers: ["1950","1994","2004","1935"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id12993: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2004 pour la découverte de la dégradation des protéines médiée par l’ubiquitine ?",
      answers: ["Avram Hershko","Aaron Ciechanover","Koichi Tanaka","Robert F. Curl Jr."],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12994: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Aaron Ciechanover a-t-il reçu le Prix Nobel en 2004 ?",
      answers: ["pour la découverte de la dégradation des protéines médiée par l’ubiquitine","pour le développement de modèles multi-échelles pour les systèmes chimiques complexes","pour le développement de la méthode de métathèse en synthèse organique","pour ses études structurales et mécanistiques des canaux ioniques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12995: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Aaron Ciechanover a-t-il reçu le Prix Nobel en 2004 ?",
      answers: ["Paix","Chimie","Littérature","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12996: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Avram Hershko a-t-il reçu le Prix Nobel de Chimie pour la découverte de la dégradation des protéines médiée par l’ubiquitine ?",
      answers: ["2004","2009","1944","1995"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id12997: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2004 pour la découverte de la dégradation des protéines médiée par l’ubiquitine ?",
      answers: ["Sir Gregory P. Winter","Avram Hershko","Morten Meldal","Robert H. Grubbs"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id12998: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Avram Hershko a-t-il reçu le Prix Nobel en 2004 ?",
      answers: ["pour la découverte et le développement de la protéine fluorescente verte (GFP)","pour le développement de la méthode de métathèse en synthèse organique","pour leurs travaux pionniers, réalisés indépendamment, sur la chimie des organométalliques, appelés composés sandwich","pour la découverte de la dégradation des protéines médiée par l’ubiquitine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id12999: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Avram Hershko a-t-il reçu le Prix Nobel en 2004 ?",
      answers: ["Chimie","Physiologie ou Médecine","Paix","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13000: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Irwin Rose a-t-il reçu le Prix Nobel de Chimie pour la découverte de la dégradation des protéines médiée par l’ubiquitine ?",
      answers: ["2004","2008","1979","1981"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13001: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2004 pour la découverte de la dégradation des protéines médiée par l’ubiquitine ?",
      answers: ["Aaron Klug","Irwin Rose","Carolyn R. Bertozzi","Max F. Perutz"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13002: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Irwin Rose a-t-il reçu le Prix Nobel en 2004 ?",
      answers: ["pour des études mécanistiques sur la réparation de l’ADN","pour des études sur la structure et la fonction du ribosome","pour la découverte de la dégradation des protéines médiée par l’ubiquitine","pour le développement de la microscopie à fluorescence à super-résolution"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13003: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Irwin Rose a-t-il reçu le Prix Nobel en 2004 ?",
      answers: ["Physique","Chimie","Sciences Économiques","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13004: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Richard Axel a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes sur les récepteurs olfactifs et l’organisation du système olfactif ?",
      answers: ["2003","2004","2016","1910"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13005: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2004 pour leurs découvertes sur les récepteurs olfactifs et l’organisation du système olfactif ?",
      answers: ["Jack W. Szostak","Richard Axel","Carol W. Greider","Albert Claude"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13006: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Richard Axel a-t-il reçu le Prix Nobel en 2004 ?",
      answers: ["pour leurs découvertes sur la régulation du cycle cellulaire","pour leurs découvertes sur les principes de l’introduction de modifications génétiques spécifiques chez la souris par l’utilisation de cellules souches embryonnaires","pour leurs découvertes sur les récepteurs olfactifs et l’organisation du système olfactif","pour leurs découvertes concernant l’imagerie par résonance magnétique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13007: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Richard Axel a-t-il reçu le Prix Nobel en 2004 ?",
      answers: ["Chimie","Sciences Économiques","Littérature","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13008: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Linda B. Buck a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes sur les récepteurs olfactifs et l’organisation du système olfactif ?",
      answers: ["2004","2007","2009","2006"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13009: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2004 pour leurs découvertes sur les récepteurs olfactifs et l’organisation du système olfactif ?",
      answers: ["Edward B. Lewis","Tim Hunt","Barbara McClintock","Linda B. Buck"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13010: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Linda B. Buck a-t-il reçu le Prix Nobel en 2004 ?",
      answers: ["pour leur découverte de la bactérie Helicobacter pylori et son rôle dans la gastrite et l’ulcère gastrique","pour leurs découvertes concernant les prostaglandines et les substances biologiquement actives apparentées","pour leur découverte de l’origine cellulaire des rétrovirus oncogènes","pour leurs découvertes sur les récepteurs olfactifs et l’organisation du système olfactif"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13011: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Linda B. Buck a-t-il reçu le Prix Nobel en 2004 ?",
      answers: ["Sciences Économiques","Physiologie ou Médecine","Littérature","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13012: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Elfriede Jelinek a-t-il reçu le Prix Nobel de Littérature pour son flux musical de voix et contrevoix dans des romans et des pièces qui révèlent l’absurdité des clichés sociaux ?",
      answers: ["1933","2017","2018","2004"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13013: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 2004 pour son flux musical de voix et contrevoix dans des romans et des pièces qui révèlent l’absurdité des clichés sociaux ?",
      answers: ["Elias Canetti","Kenzaburo Oe","Elfriede Jelinek","Herta Müller"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13014: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Elfriede Jelinek a-t-il reçu le Prix Nobel en 2004 ?",
      answers: ["pour l’art rigoureux avec lequel il a développé les traditions de la prose classique russe","pour des œuvres d’une beauté lyrique et d’une profondeur éthique, qui exaltent les miracles du quotidien et le passé vivant","pour son flux musical de voix et contrevoix dans des romans et des pièces qui révèlent l’absurdité des clichés sociaux","qui, dans ses pièces, révèle le précipice sous les bavardages quotidiens et force l’entrée dans les pièces fermées de l’oppression"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13015: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Elfriede Jelinek a-t-il reçu le Prix Nobel en 2004 ?",
      answers: ["Physiologie ou Médecine","Physique","Littérature","Sciences Économiques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13016: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Wangari Maathai a-t-il reçu le Prix Nobel de Paix pour sa contribution au développement durable, à la démocratie et à la paix ?",
      answers: ["2004","2003","2014","1998"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13017: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2004 pour sa contribution au développement durable, à la démocratie et à la paix ?",
      answers: ["Mikhail Gorbachev","Comité Américain des Amis pour le Service (Quakers américains)","Wangari Maathai","Grameen Bank"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13018: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Wangari Maathai a-t-il reçu le Prix Nobel en 2004 ?",
      answers: ["pour sa contribution au développement durable, à la démocratie et à la paix","pour leur travail en faveur d’un monde mieux organisé et plus pacifique","pour leurs efforts visant à créer un développement économique et social par le bas","pour ses efforts en faveur de la démocratie et des droits humains, notamment pour les femmes et les enfants"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13019: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Wangari Maathai a-t-il reçu le Prix Nobel en 2004 ?",
      answers: ["Physique","Chimie","Physiologie ou Médecine","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13020: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Finn E. Kydland a-t-il reçu le Prix Nobel de Sciences Économiques pour leurs contributions à la macroéconomie dynamique ?",
      answers: ["2004","2013","2023","2005"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13021: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2004 pour leurs contributions à la macroéconomie dynamique ?",
      answers: ["Leonid Hurwicz","Edward C. Prescott","Finn E. Kydland","James J. Heckman"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13022: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Finn E. Kydland a-t-il reçu le Prix Nobel en 2004 ?",
      answers: ["pour leur analyse des marchés avec information asymétrique","pour leurs contributions à la macroéconomie dynamique","pour la théorie des allocations stables et la pratique de la conception de marchés","pour son analyse de la gouvernance économique, notamment des biens communs"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13023: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Finn E. Kydland a-t-il reçu le Prix Nobel en 2004 ?",
      answers: ["Sciences Économiques","Littérature","Physique","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13024: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Edward C. Prescott a-t-il reçu le Prix Nobel de Sciences Économiques pour leurs contributions à la macroéconomie dynamique ?",
      answers: ["2003","2004","2013","2010"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13025: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2004 pour leurs contributions à la macroéconomie dynamique ?",
      answers: ["Finn E. Kydland","Claudia Goldin","Edward C. Prescott","Bengt Holmström"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13026: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Edward C. Prescott a-t-il reçu le Prix Nobel en 2004 ?",
      answers: ["pour avoir posé les bases de la théorie de la conception des mécanismes","pour leurs contributions à la macroéconomie dynamique","pour ses études sur la manière dont les institutions sont formées et affectent la prospérité","pour avoir intégré des perspectives psychologiques dans l’analyse économique, notamment sur le comportement humain sous incertitude"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13027: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Edward C. Prescott a-t-il reçu le Prix Nobel en 2004 ?",
      answers: ["Paix","Chimie","Sciences Économiques","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13028: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Roy J. Glauber a-t-il reçu le Prix Nobel de Physique pour sa contribution à la théorie quantique de la cohérence optique ?",
      answers: ["2005","2004","1960","1986"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13029: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2005 pour sa contribution à la théorie quantique de la cohérence optique ?",
      answers: ["John R. Schrieffer","John L. Hall","Roy J. Glauber","Serge Haroche"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13030: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Roy J. Glauber a-t-il reçu le Prix Nobel en 2005 ?",
      answers: ["pour la découverte de l’origine de la brisure de symétrie qui prédit l’existence d’au moins trois familles de quarks dans la nature","pour l’invention de diodes électroluminescentes bleues efficaces, permettant des sources de lumière blanche brillantes et économes en énergie","pour sa contribution à la théorie quantique de la cohérence optique","pour l’invention de la chambre à bulles"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13031: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Roy J. Glauber a-t-il reçu le Prix Nobel en 2005 ?",
      answers: ["Physique","Littérature","Chimie","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13032: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année John L. Hall a-t-il reçu le Prix Nobel de Physique pour leurs contributions au développement de la spectroscopie de précision basée sur le laser ?",
      answers: ["2002","2004","2005","1991"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13033: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2005 pour leurs contributions au développement de la spectroscopie de précision basée sur le laser ?",
      answers: ["George F. Smoot","David M. Lee","Peter Grünberg","John L. Hall"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13034: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison John L. Hall a-t-il reçu le Prix Nobel en 2005 ?",
      answers: ["pour la découverte de la liberté asymptotique dans la théorie de l’interaction forte","pour leurs contributions au développement de la spectroscopie de précision basée sur le laser","pour des découvertes théoriques sur les transitions de phase topologiques et les phases topologiques de la matière","pour sa contribution à la théorie quantique de la cohérence optique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13035: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie John L. Hall a-t-il reçu le Prix Nobel en 2005 ?",
      answers: ["Physique","Physiologie ou Médecine","Littérature","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13036: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Theodor W. Hänsch a-t-il reçu le Prix Nobel de Physique pour leurs contributions au développement de la spectroscopie de précision basée sur le laser ?",
      answers: ["1996","1994","2005","2006"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13037: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2005 pour leurs contributions au développement de la spectroscopie de précision basée sur le laser ?",
      answers: ["Roy J. Glauber","Theodor W. Hänsch","Luis W. Alvarez","Raymond Davis Jr."],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13038: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Theodor W. Hänsch a-t-il reçu le Prix Nobel en 2005 ?",
      answers: ["pour leurs contributions au développement de la spectroscopie de précision basée sur le laser","pour sa contribution à l’invention du circuit intégré","pour ses inventions et découvertes fondamentales dans la physique des basses températures","pour leur contribution au développement de la spectroscopie laser"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13039: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Theodor W. Hänsch a-t-il reçu le Prix Nobel en 2005 ?",
      answers: ["Chimie","Physique","Sciences Économiques","Littérature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13040: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Yves Chauvin a-t-il reçu le Prix Nobel de Chimie pour le développement de la méthode de métathèse en synthèse organique ?",
      answers: ["2005","2006","2002","1944"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13041: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2005 pour le développement de la méthode de métathèse en synthèse organique ?",
      answers: ["Ronald G.W. Norrish","Hans von Euler-Chelpin","Robert H. Grubbs","Yves Chauvin"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13042: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Yves Chauvin a-t-il reçu le Prix Nobel en 2005 ?",
      answers: ["pour son développement de la méthodologie de la synthèse chimique sur phase solide","pour le développement de réactions de couplage catalysées par le palladium en synthèse organique","pour leur élucidation du mécanisme enzymatique sous-jacent à la synthèse de l’adénosine triphosphate (ATP)","pour le développement de la méthode de métathèse en synthèse organique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13043: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Yves Chauvin a-t-il reçu le Prix Nobel en 2005 ?",
      answers: ["Physiologie ou Médecine","Chimie","Littérature","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13044: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Robert H. Grubbs a-t-il reçu le Prix Nobel de Chimie pour le développement de la méthode de métathèse en synthèse organique ?",
      answers: ["1916","2005","1906","2003"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13045: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2005 pour le développement de la méthode de métathèse en synthèse organique ?",
      answers: ["Richard F. Heck","Yves Chauvin","Ada E. Yonath","Robert H. Grubbs"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13046: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Robert H. Grubbs a-t-il reçu le Prix Nobel en 2005 ?",
      answers: ["pour le développement de la méthode de métathèse en synthèse organique","pour la découverte de la dégradation des protéines médiée par l’ubiquitine","pour le développement de la microscopie à fluorescence à super-résolution","pour ses études des processus chimiques sur les surfaces solides"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13047: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Robert H. Grubbs a-t-il reçu le Prix Nobel en 2005 ?",
      answers: ["Chimie","Physique","Littérature","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13048: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Richard R. Schrock a-t-il reçu le Prix Nobel de Chimie pour le développement de la méthode de métathèse en synthèse organique ?",
      answers: ["1970","2005","1976","2008"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13049: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2005 pour le développement de la méthode de métathèse en synthèse organique ?",
      answers: ["Hideki Shirakawa","Richard R. Schrock","Venkatraman Ramakrishnan","William H. Stein"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13050: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Richard R. Schrock a-t-il reçu le Prix Nobel en 2005 ?",
      answers: ["pour ses contributions à la théorie des réactions de transfert d’électrons dans les systèmes chimiques","pour sa découverte de la fission nucléaire des noyaux lourds","pour le développement de modèles multi-échelles pour les systèmes chimiques complexes","pour le développement de la méthode de métathèse en synthèse organique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13051: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Richard R. Schrock a-t-il reçu le Prix Nobel en 2005 ?",
      answers: ["Chimie","Paix","Sciences Économiques","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13052: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Barry J. Marshall a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leur découverte de la bactérie Helicobacter pylori et son rôle dans la gastrite et l’ulcère gastrique ?",
      answers: ["2007","2014","2005","1999"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13053: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2005 pour leur découverte de la bactérie Helicobacter pylori et son rôle dans la gastrite et l’ulcère gastrique ?",
      answers: ["Werner Forssmann","George H. Hitchings","Barry J. Marshall","Charles M. Rice"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13054: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Barry J. Marshall a-t-il reçu le Prix Nobel en 2005 ?",
      answers: ["pour leurs découvertes sur les principes de l’introduction de modifications génétiques spécifiques chez la souris par l’utilisation de cellules souches embryonnaires","pour leurs découvertes concernant le monoxyde d’azote comme molécule de signalisation dans le système cardiovasculaire","pour leur découverte de la bactérie Helicobacter pylori et son rôle dans la gastrite et l’ulcère gastrique","pour leurs découvertes concernant l’activation de l’immunité innée"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13055: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Barry J. Marshall a-t-il reçu le Prix Nobel en 2005 ?",
      answers: ["Physique","Chimie","Paix","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13056: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année J. Robin Warren a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leur découverte de la bactérie Helicobacter pylori et son rôle dans la gastrite et l’ulcère gastrique ?",
      answers: ["2007","2005","2006","2013"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13057: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2005 pour leur découverte de la bactérie Helicobacter pylori et son rôle dans la gastrite et l’ulcère gastrique ?",
      answers: ["Barry J. Marshall","Edward L. Tatum","Andrew Z. Fire","J. Robin Warren"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13058: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison J. Robin Warren a-t-il reçu le Prix Nobel en 2005 ?",
      answers: ["pour leur découverte de l’interférence par ARN – silencing génique par ARN double brin","pour leur découverte de la bactérie Helicobacter pylori et son rôle dans la gastrite et l’ulcère gastrique","pour leurs découvertes sur les récepteurs olfactifs et l’organisation du système olfactif","pour leurs découvertes concernant les transplantations d’organes et de cellules dans le traitement des maladies"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13059: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie J. Robin Warren a-t-il reçu le Prix Nobel en 2005 ?",
      answers: ["Physiologie ou Médecine","Physique","Sciences Économiques","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13060: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Harold Pinter a-t-il reçu le Prix Nobel de Littérature qui, dans ses pièces, révèle le précipice sous les bavardages quotidiens et force l’entrée dans les pièces fermées de l’oppression ?",
      answers: ["1998","2019","2005","2011"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13061: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 2005 qui, dans ses pièces, révèle le précipice sous les bavardages quotidiens et force l’entrée dans les pièces fermées de l’oppression ?",
      answers: ["Eugene O’Neill","Herta Müller","Harold Pinter","Svetlana Alexievitch"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13062: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Harold Pinter a-t-il reçu le Prix Nobel en 2005 ?",
      answers: ["pour sa pénétration sans compromis et empreinte de compassion des effets du colonialisme et du destin des réfugiés","qui, dans ses pièces, révèle le précipice sous les bavardages quotidiens et force l’entrée dans les pièces fermées de l’oppression","cette épopée de l’expérience féminine qui, avec scepticisme, feu et une force visionnaire, a soumis une civilisation divisée à un examen","pour sa puissance épique vivante qui a renouvelé le grand art narratif de l’Islande"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13063: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Harold Pinter a-t-il reçu le Prix Nobel en 2005 ?",
      answers: ["Littérature","Chimie","Physique","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13064: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Agence Internationale de l’Énergie Atomique (AIEA) a-t-il reçu le Prix Nobel de Paix pour leurs efforts visant à empêcher l’utilisation militaire de l’énergie nucléaire et à promouvoir son usage pacifique ?",
      answers: ["1988","2021","2004","2005"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13065: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2005 pour leurs efforts visant à empêcher l’utilisation militaire de l’énergie nucléaire et à promouvoir son usage pacifique ?",
      answers: ["Juan Manuel Santos","Agence Internationale de l’Énergie Atomique (AIEA)","Frederik Willem de Klerk","Aung San Suu Kyi"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13066: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Agence Internationale de l’Énergie Atomique (AIEA) a-t-il reçu le Prix Nobel en 2005 ?",
      answers: ["pour ses efforts importants sur plusieurs continents et pendant plus de trois décennies pour résoudre les conflits internationaux","pour leur travail en faveur d’une solution juste et pacifique au conflit au Timor oriental","pour son travail visant à attirer l’attention sur les conséquences humanitaires catastrophiques de l’utilisation des armes nucléaires","pour leurs efforts visant à empêcher l’utilisation militaire de l’énergie nucléaire et à promouvoir son usage pacifique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13067: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Agence Internationale de l’Énergie Atomique (AIEA) a-t-il reçu le Prix Nobel en 2005 ?",
      answers: ["Littérature","Physique","Sciences Économiques","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13068: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Mohamed ElBaradei a-t-il reçu le Prix Nobel de Paix pour leurs efforts visant à empêcher l’utilisation militaire de l’énergie nucléaire et à promouvoir son usage pacifique ?",
      answers: ["2005","2004","2010","1960"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13069: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2005 pour leurs efforts visant à empêcher l’utilisation militaire de l’énergie nucléaire et à promouvoir son usage pacifique ?",
      answers: ["Dmitry Muratov","Grameen Bank","Wangari Maathai","Mohamed ElBaradei"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13070: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Mohamed ElBaradei a-t-il reçu le Prix Nobel en 2005 ?",
      answers: ["pour ses décennies d’efforts inlassables pour trouver des solutions pacifiques aux conflits internationaux","pour leurs efforts visant à créer un développement économique et social par le bas","pour leurs efforts visant à développer et diffuser une meilleure compréhension du changement climatique d’origine humaine","pour leurs efforts visant à empêcher l’utilisation militaire de l’énergie nucléaire et à promouvoir son usage pacifique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13071: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Mohamed ElBaradei a-t-il reçu le Prix Nobel en 2005 ?",
      answers: ["Littérature","Paix","Physique","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13072: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Robert J. Aumann a-t-il reçu le Prix Nobel de Sciences Économiques pour avoir amélioré notre compréhension des conflits et de la coopération à travers l’analyse de la théorie des jeux ?",
      answers: ["2006","2010","2001","2005"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13073: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2005 pour avoir amélioré notre compréhension des conflits et de la coopération à travers l’analyse de la théorie des jeux ?",
      answers: ["Robert J. Aumann","Finn E. Kydland","Paul M. Romer","Michael Kremer"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13074: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Robert J. Aumann a-t-il reçu le Prix Nobel en 2005 ?",
      answers: ["pour avoir amélioré notre compréhension des conflits et de la coopération à travers l’analyse de la théorie des jeux","pour leur analyse des marchés avec information asymétrique","pour avoir posé les bases de la théorie de la conception des mécanismes","pour avoir intégré des perspectives psychologiques dans l’analyse économique, notamment sur le comportement humain sous incertitude"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13075: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Robert J. Aumann a-t-il reçu le Prix Nobel en 2005 ?",
      answers: ["Chimie","Physique","Sciences Économiques","Paix"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13076: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Thomas C. Schelling a-t-il reçu le Prix Nobel de Sciences Économiques pour avoir amélioré notre compréhension des conflits et de la coopération à travers l’analyse de la théorie des jeux ?",
      answers: ["2002","2005","2007","1982"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13077: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2005 pour avoir amélioré notre compréhension des conflits et de la coopération à travers l’analyse de la théorie des jeux ?",
      answers: ["Edmund S. Phelps","Thomas C. Schelling","Milton Friedman","Robert J. Aumann"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13078: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Thomas C. Schelling a-t-il reçu le Prix Nobel en 2005 ?",
      answers: ["pour avoir établi des expériences de laboratoire comme outil dans l’analyse économique empirique","pour ses méthodes d’analyse des séries temporelles économiques avec volatilité variable","pour avoir posé les bases de la théorie de la conception des mécanismes","pour avoir amélioré notre compréhension des conflits et de la coopération à travers l’analyse de la théorie des jeux"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13079: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Thomas C. Schelling a-t-il reçu le Prix Nobel en 2005 ?",
      answers: ["Physique","Littérature","Chimie","Sciences Économiques"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13080: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année John C. Mather a-t-il reçu le Prix Nobel de Physique pour leur découverte de la forme du corps noir et de l’anisotropie du fond diffus cosmologique ?",
      answers: ["2006","1999","1997","1931"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13081: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2006 pour leur découverte de la forme du corps noir et de l’anisotropie du fond diffus cosmologique ?",
      answers: ["Eric A. Cornell","Yoichiro Nambu","Steven Weinberg","John C. Mather"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13082: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison John C. Mather a-t-il reçu le Prix Nobel en 2006 ?",
      answers: ["pour le développement de semi-conducteurs utilisés dans l’électronique à haute vitesse et l’optoélectronique","pour leur découverte de la forme du corps noir et de l’anisotropie du fond diffus cosmologique","pour ses réalisations pionnières concernant la transmission de la lumière dans les fibres pour la communication optique","pour la découverte de la liberté asymptotique dans la théorie de l’interaction forte"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13083: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie John C. Mather a-t-il reçu le Prix Nobel en 2006 ?",
      answers: ["Paix","Littérature","Physique","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13084: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année George F. Smoot a-t-il reçu le Prix Nobel de Physique pour leur découverte de la forme du corps noir et de l’anisotropie du fond diffus cosmologique ?",
      answers: ["1998","2006","2003","1989"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13085: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2006 pour leur découverte de la forme du corps noir et de l’anisotropie du fond diffus cosmologique ?",
      answers: ["James Franck","John C. Mather","Reinhard Genzel","George F. Smoot"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13086: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison George F. Smoot a-t-il reçu le Prix Nobel en 2006 ?",
      answers: ["pour la découverte de la liberté asymptotique dans la théorie de l’interaction forte","pour la découverte de l’expansion accélérée de l’univers par l’observation des supernovae lointaines","pour leurs contributions pionnières à l’astrophysique, notamment la détection des neutrinos cosmiques","pour leur découverte de la forme du corps noir et de l’anisotropie du fond diffus cosmologique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13087: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie George F. Smoot a-t-il reçu le Prix Nobel en 2006 ?",
      answers: ["Chimie","Physique","Littérature","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13088: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Roger D. Kornberg a-t-il reçu le Prix Nobel de Chimie pour ses études sur les bases moléculaires de la transcription eucaryote ?",
      answers: ["2009","1980","2006","1947"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13089: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2006 pour ses études sur les bases moléculaires de la transcription eucaryote ?",
      answers: ["Richard R. Schrock","Dan Shechtman","Jens C. Skou","Roger D. Kornberg"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13090: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Roger D. Kornberg a-t-il reçu le Prix Nobel en 2006 ?",
      answers: ["pour leur développement et leur utilisation de molécules avec des interactions spécifiques de reconnaissance structurale","pour la conception et la synthèse de machines moléculaires","pour leurs recherches sur la fermentation des sucres et les enzymes fermentatives","pour ses études sur les bases moléculaires de la transcription eucaryote"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13091: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Roger D. Kornberg a-t-il reçu le Prix Nobel en 2006 ?",
      answers: ["Physiologie ou Médecine","Paix","Chimie","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13092: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Andrew Z. Fire a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leur découverte de l’interférence par ARN – silencing génique par ARN double brin ?",
      answers: ["2002","2009","2006","1995"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13093: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2006 pour leur découverte de l’interférence par ARN – silencing génique par ARN double brin ?",
      answers: ["Andrew Z. Fire","Luc Montagnier","Alan L. Hodgkin","Har Gobind Khorana"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13094: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Andrew Z. Fire a-t-il reçu le Prix Nobel en 2006 ?",
      answers: ["pour leurs découvertes concernant le mécanisme et la régulation du métabolisme du cholestérol et des acides gras","pour leur découverte de l’interférence par ARN – silencing génique par ARN double brin","pour sa découverte des papillomavirus humains causant le cancer du col de l’utérus","pour leur découverte du virus de l’immunodéficience humaine (VIH)"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13095: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Andrew Z. Fire a-t-il reçu le Prix Nobel en 2006 ?",
      answers: ["Physiologie ou Médecine","Physique","Paix","Sciences Économiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13096: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Craig C. Mello a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leur découverte de l’interférence par ARN – silencing génique par ARN double brin ?",
      answers: ["2022","2006","1927","2008"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13097: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2006 pour leur découverte de l’interférence par ARN – silencing génique par ARN double brin ?",
      answers: ["Oliver Smithies","Luc Montagnier","Craig C. Mello","Thomas C. Südhof"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13098: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Craig C. Mello a-t-il reçu le Prix Nobel en 2006 ?",
      answers: ["pour leur découverte de l’interférence par ARN – silencing génique par ARN double brin","pour sa découverte des cellules dendritiques et de leur rôle dans l’immunité adaptative","pour leurs découvertes concernant les prostaglandines et les substances biologiquement actives apparentées","pour la découverte de la manière dont les chromosomes sont protégés par les télomères et l’enzyme télomérase"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13099: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Craig C. Mello a-t-il reçu le Prix Nobel en 2006 ?",
      answers: ["Physiologie ou Médecine","Littérature","Physique","Sciences Économiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13100: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Orhan Pamuk a-t-il reçu le Prix Nobel de Littérature qui, dans sa quête de l’âme mélancolique de sa ville natale, a découvert de nouveaux symboles pour le choc et l’entrelacement des cultures ?",
      answers: ["2009","2006","1999","1995"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13101: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 2006 qui, dans sa quête de l’âme mélancolique de sa ville natale, a découvert de nouveaux symboles pour le choc et l’entrelacement des cultures ?",
      answers: ["Orhan Pamuk","Tomas Tranströmer","Doris Lessing","Derek Walcott"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13102: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Orhan Pamuk a-t-il reçu le Prix Nobel en 2006 ?",
      answers: ["qui, dans sa quête de l’âme mélancolique de sa ville natale, a découvert de nouveaux symboles pour le choc et l’entrelacement des cultures","pour ses écrits empreints d’idéalisme décrivant la vie sur son île natale et traitant avec profondeur et sympathie les problèmes humains en général","pour son œuvre polyphonique, un monument à la souffrance et au courage de notre temps","pour des œuvres d’une beauté lyrique et d’une profondeur éthique, qui exaltent les miracles du quotidien et le passé vivant"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13103: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Orhan Pamuk a-t-il reçu le Prix Nobel en 2006 ?",
      answers: ["Paix","Littérature","Chimie","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13104: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Muhammad Yunus a-t-il reçu le Prix Nobel de Paix pour leurs efforts visant à créer un développement économique et social par le bas ?",
      answers: ["2005","2006","2000","1991"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13105: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2006 pour leurs efforts visant à créer un développement économique et social par le bas ?",
      answers: ["Tawakkol Karman","Muhammad Yunus","Kim Dae-jung","Grameen Bank"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13106: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Muhammad Yunus a-t-il reçu le Prix Nobel en 2006 ?",
      answers: ["pour leurs efforts visant à trouver une solution pacifique au conflit en Irlande du Nord","pour ses efforts extraordinaires visant à renforcer la diplomatie internationale et la coopération entre les peuples","pour leurs efforts visant à sauvegarder la liberté d’expression, condition préalable à la démocratie et à une paix durable","pour leurs efforts visant à créer un développement économique et social par le bas"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13107: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Muhammad Yunus a-t-il reçu le Prix Nobel en 2006 ?",
      answers: ["Littérature","Physique","Paix","Sciences Économiques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13108: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Grameen Bank a-t-il reçu le Prix Nobel de Paix pour leurs efforts visant à créer un développement économique et social par le bas ?",
      answers: ["2002","1909","1920","2006"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13109: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2006 pour leurs efforts visant à créer un développement économique et social par le bas ?",
      answers: ["Nations Unies (ONU)","Grameen Bank","Groupe d’Experts Intergouvernemental sur l’Évolution du Climat (GIEC)","Agence Internationale de l’Énergie Atomique (AIEA)"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13110: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Grameen Bank a-t-il reçu le Prix Nobel en 2006 ?",
      answers: ["pour leurs efforts visant à créer un développement économique et social par le bas","pour leurs efforts visant à trouver une solution pacifique au conflit en Irlande du Nord","pour son travail de longue date en faveur de la paix et de l’arbitrage international","pour sa contribution au développement durable, à la démocratie et à la paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13111: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Grameen Bank a-t-il reçu le Prix Nobel en 2006 ?",
      answers: ["Physiologie ou Médecine","Physique","Chimie","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13112: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Edmund S. Phelps a-t-il reçu le Prix Nobel de Sciences Économiques pour son analyse des arbitrages intertemporels en politique macroéconomique ?",
      answers: ["2006","2004","2013","1965"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13113: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2006 pour son analyse des arbitrages intertemporels en politique macroéconomique ?",
      answers: ["Lawrence R. Klein","Edmund S. Phelps","Robert M. Solow","Roger B. Myerson"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13114: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Edmund S. Phelps a-t-il reçu le Prix Nobel en 2006 ?",
      answers: ["pour ses améliorations à la théorie des enchères et ses inventions de nouveaux formats d’enchères","pour ses analyses pionnières de l’épargne et des marchés financiers","pour avoir posé les bases de la théorie de la conception des mécanismes","pour son analyse des arbitrages intertemporels en politique macroéconomique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13115: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Edmund S. Phelps a-t-il reçu le Prix Nobel en 2006 ?",
      answers: ["Chimie","Physique","Sciences Économiques","Paix"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13116: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Albert Fert a-t-il reçu le Prix Nobel de Physique pour la découverte de la magnétorésistance géante ?",
      answers: ["2004","1918","2008","2007"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13117: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2007 pour la découverte de la magnétorésistance géante ?",
      answers: ["Carlo Rubbia","Peter Grünberg","Yoichiro Nambu","Albert Fert"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13118: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Albert Fert a-t-il reçu le Prix Nobel en 2007 ?",
      answers: ["pour la découverte de la magnétorésistance géante","pour sa contribution à la théorie quantique de la cohérence optique","pour l’invention de diodes électroluminescentes bleues efficaces, permettant des sources de lumière blanche brillantes et économes en énergie","pour leur percée importante dans la découverte de la supraconductivité dans les matériaux céramiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13119: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Albert Fert a-t-il reçu le Prix Nobel en 2007 ?",
      answers: ["Sciences Économiques","Paix","Physique","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13120: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Peter Grünberg a-t-il reçu le Prix Nobel de Physique pour la découverte de la magnétorésistance géante ?",
      answers: ["2004","1997","2007","2005"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13121: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2007 pour la découverte de la magnétorésistance géante ?",
      answers: ["David J. Gross","Albert Fert","Peter Grünberg","Andre Geim"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13122: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Peter Grünberg a-t-il reçu le Prix Nobel en 2007 ?",
      answers: ["pour la découverte de la magnétorésistance géante","pour leur méthode de génération d’impulsions optiques ultra-courtes et de haute intensité","pour la découverte de la liberté asymptotique dans la théorie de l’interaction forte","pour leurs investigations théoriques fondamentales sur la structure électronique des systèmes magnétiques et désordonnés"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13123: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Peter Grünberg a-t-il reçu le Prix Nobel en 2007 ?",
      answers: ["Paix","Littérature","Sciences Économiques","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13124: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Gerhard Ertl a-t-il reçu le Prix Nobel de Chimie pour ses études des processus chimiques sur les surfaces solides ?",
      answers: ["2009","2007","2015","2006"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13125: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2007 pour ses études des processus chimiques sur les surfaces solides ?",
      answers: ["Richard R. Schrock","Sir Gregory P. Winter","Alan G. MacDiarmid","Gerhard Ertl"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13126: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Gerhard Ertl a-t-il reçu le Prix Nobel en 2007 ?",
      answers: ["pour la détermination de la structure tridimensionnelle d’un centre réactionnel photosynthétique","pour des études sur la structure et la fonction du ribosome","pour ses études structurales et mécanistiques des canaux ioniques","pour ses études des processus chimiques sur les surfaces solides"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13127: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Gerhard Ertl a-t-il reçu le Prix Nobel en 2007 ?",
      answers: ["Paix","Physiologie ou Médecine","Chimie","Sciences Économiques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13128: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Mario R. Capecchi a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes sur les principes de l’introduction de modifications génétiques spécifiques chez la souris par l’utilisation de cellules souches embryonnaires ?",
      answers: ["2006","1997","2007","1928"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13129: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2007 pour leurs découvertes sur les principes de l’introduction de modifications génétiques spécifiques chez la souris par l’utilisation de cellules souches embryonnaires ?",
      answers: ["Mario R. Capecchi","Otto F. Meyerhof","Andrew F. Huxley","Thomas C. Südhof"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13130: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Mario R. Capecchi a-t-il reçu le Prix Nobel en 2007 ?",
      answers: ["pour leurs découvertes sur le système de transport vésiculaire dans les cellules","pour leurs découvertes sur les principes de l’introduction de modifications génétiques spécifiques chez la souris par l’utilisation de cellules souches embryonnaires","pour leurs découvertes sur la régulation du cycle cellulaire","pour sa découverte du mécanisme de l’électrocardiogramme"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13131: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Mario R. Capecchi a-t-il reçu le Prix Nobel en 2007 ?",
      answers: ["Paix","Chimie","Littérature","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13132: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Sir Martin J. Evans a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes sur les principes de l’introduction de modifications génétiques spécifiques chez la souris par l’utilisation de cellules souches embryonnaires ?",
      answers: ["1946","2007","2013","2010"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13133: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2007 pour leurs découvertes sur les principes de l’introduction de modifications génétiques spécifiques chez la souris par l’utilisation de cellules souches embryonnaires ?",
      answers: ["Rosalyn Yalow","Jack W. Szostak","George Wald","Sir Martin J. Evans"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13134: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Sir Martin J. Evans a-t-il reçu le Prix Nobel en 2007 ?",
      answers: ["pour leurs découvertes sur les principes de l’introduction de modifications génétiques spécifiques chez la souris par l’utilisation de cellules souches embryonnaires","pour leurs découvertes sur les cellules qui constituent un système de positionnement dans le cerveau","pour ses découvertes concernant la transmission des signaux dans le système nerveux","pour leurs découvertes sur la régulation du cycle cellulaire"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13135: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Sir Martin J. Evans a-t-il reçu le Prix Nobel en 2007 ?",
      answers: ["Sciences Économiques","Physiologie ou Médecine","Physique","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13136: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Oliver Smithies a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes sur les principes de l’introduction de modifications génétiques spécifiques chez la souris par l’utilisation de cellules souches embryonnaires ?",
      answers: ["2007","1990","2021","2014"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13137: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2007 pour leurs découvertes sur les principes de l’introduction de modifications génétiques spécifiques chez la souris par l’utilisation de cellules souches embryonnaires ?",
      answers: ["Karl Landsteiner","Oliver Smithies","Sir Martin J. Evans","Thomas C. Südhof"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13138: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Oliver Smithies a-t-il reçu le Prix Nobel en 2007 ?",
      answers: ["pour leurs découvertes concernant une nouvelle thérapie contre les infections causées par des parasites","pour leurs découvertes sur les principes de l’introduction de modifications génétiques spécifiques chez la souris par l’utilisation de cellules souches embryonnaires","pour leur découverte de la bactérie Helicobacter pylori et son rôle dans la gastrite et l’ulcère gastrique","pour sa découverte de l’effet organisateur dans le développement embryonnaire"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13139: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Oliver Smithies a-t-il reçu le Prix Nobel en 2007 ?",
      answers: ["Chimie","Physiologie ou Médecine","Paix","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13140: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Doris Lessing a-t-il reçu le Prix Nobel de Littérature cette épopée de l’expérience féminine qui, avec scepticisme, feu et une force visionnaire, a soumis une civilisation divisée à un examen ?",
      answers: ["2003","2001","2008","2007"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13141: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 2007 cette épopée de l’expérience féminine qui, avec scepticisme, feu et une force visionnaire, a soumis une civilisation divisée à un examen ?",
      answers: ["Doris Lessing","Jean-Marie Gustave Le Clézio","Svetlana Alexievitch","Louise Glück"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13142: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Doris Lessing a-t-il reçu le Prix Nobel en 2007 ?",
      answers: ["auteur de nouveaux départs, d’aventures poétiques et d’extases sensuelles, explorateur d’une humanité au-delà et en deçà de la civilisation régnante","cette épopée de l’expérience féminine qui, avec scepticisme, feu et une force visionnaire, a soumis une civilisation divisée à un examen","qui, avec un réalisme hallucinatoire, fusionne contes populaires, histoire et contemporain","pour une œuvre influente qui, avec une ingéniosité linguistique, a exploré la périphérie et la spécificité de l’expérience humaine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13143: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Doris Lessing a-t-il reçu le Prix Nobel en 2007 ?",
      answers: ["Physiologie ou Médecine","Physique","Littérature","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13144: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Groupe d’Experts Intergouvernemental sur l’Évolution du Climat (GIEC) a-t-il reçu le Prix Nobel de Paix pour leurs efforts visant à développer et diffuser une meilleure compréhension du changement climatique d’origine humaine ?",
      answers: ["1943","2010","2001","2007"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13145: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2007 pour leurs efforts visant à développer et diffuser une meilleure compréhension du changement climatique d’origine humaine ?",
      answers: ["Tobias M.C. Asser","Médecins Sans Frontières","Muhammad Yunus","Groupe d’Experts Intergouvernemental sur l’Évolution du Climat (GIEC)"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13146: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Groupe d’Experts Intergouvernemental sur l’Évolution du Climat (GIEC) a-t-il reçu le Prix Nobel en 2007 ?",
      answers: ["pour leurs efforts visant à promouvoir les droits humains et la paix dans leurs pays respectifs","pour leurs efforts visant à développer et diffuser une meilleure compréhension du changement climatique d’origine humaine","pour leurs efforts visant à créer un développement économique et social par le bas","pour leur lutte contre l’oppression des enfants et des jeunes et pour le droit de tous les enfants à l’éducation"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13147: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Groupe d’Experts Intergouvernemental sur l’Évolution du Climat (GIEC) a-t-il reçu le Prix Nobel en 2007 ?",
      answers: ["Physique","Littérature","Physiologie ou Médecine","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13148: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Al Gore a-t-il reçu le Prix Nobel de Paix pour leurs efforts visant à développer et diffuser une meilleure compréhension du changement climatique d’origine humaine ?",
      answers: ["2016","1961","2007","2010"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13149: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2007 pour leurs efforts visant à développer et diffuser une meilleure compréhension du changement climatique d’origine humaine ?",
      answers: ["Al Gore","Kailash Satyarthi","Ligue des Sociétés de la Croix-Rouge","Groupe d’Experts Intergouvernemental sur l’Évolution du Climat (GIEC)"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13150: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Al Gore a-t-il reçu le Prix Nobel en 2007 ?",
      answers: ["pour leurs efforts visant à créer un développement économique et social par le bas","pour ses décennies d’efforts inlassables pour trouver des solutions pacifiques aux conflits internationaux","pour leurs efforts visant à développer et diffuser une meilleure compréhension du changement climatique d’origine humaine","pour leurs efforts visant à sauvegarder la liberté d’expression, condition préalable à la démocratie et à une paix durable"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13151: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Al Gore a-t-il reçu le Prix Nobel en 2007 ?",
      answers: ["Littérature","Physique","Physiologie ou Médecine","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13152: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Leonid Hurwicz a-t-il reçu le Prix Nobel de Sciences Économiques pour avoir posé les bases de la théorie de la conception des mécanismes ?",
      answers: ["1982","2006","2007","2005"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13153: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2007 pour avoir posé les bases de la théorie de la conception des mécanismes ?",
      answers: ["William F. Sharpe","Leonid Hurwicz","Eugene F. Fama","Elinor Ostrom"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13154: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Leonid Hurwicz a-t-il reçu le Prix Nobel en 2007 ?",
      answers: ["pour son analyse de la puissance du marché et de la régulation","pour avoir posé les bases de la théorie de la conception des mécanismes","pour son analyse des modèles commerciaux et de la localisation de l’activité économique","pour ses études sur la manière dont les institutions sont formées et affectent la prospérité"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13155: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Leonid Hurwicz a-t-il reçu le Prix Nobel en 2007 ?",
      answers: ["Littérature","Sciences Économiques","Physique","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13156: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Eric S. Maskin a-t-il reçu le Prix Nobel de Sciences Économiques pour avoir posé les bases de la théorie de la conception des mécanismes ?",
      answers: ["1996","2007","1967","1981"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13157: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2007 pour avoir posé les bases de la théorie de la conception des mécanismes ?",
      answers: ["Eric S. Maskin","Michael Kremer","Oliver E. Williamson","Vernon L. Smith"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13158: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Eric S. Maskin a-t-il reçu le Prix Nobel en 2007 ?",
      answers: ["pour ses études sur la manière dont les institutions sont formées et affectent la prospérité","pour ses méthodes d’analyse des séries temporelles économiques avec volatilité variable","pour avoir posé les bases de la théorie de la conception des mécanismes","pour son analyse des arbitrages intertemporels en politique macroéconomique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13159: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Eric S. Maskin a-t-il reçu le Prix Nobel en 2007 ?",
      answers: ["Paix","Physique","Sciences Économiques","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13160: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Roger B. Myerson a-t-il reçu le Prix Nobel de Sciences Économiques pour avoir posé les bases de la théorie de la conception des mécanismes ?",
      answers: ["2018","1920","1995","2007"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13161: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2007 pour avoir posé les bases de la théorie de la conception des mécanismes ?",
      answers: ["Paul Krugman","Eric S. Maskin","Roger B. Myerson","Finn E. Kydland"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13162: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Roger B. Myerson a-t-il reçu le Prix Nobel en 2007 ?",
      answers: ["pour leurs contributions à la macroéconomie dynamique","pour ses méthodes d’analyse des choix discrets en économie","pour ses recherches pionnières sur le processus de prise de décision au sein des organisations économiques","pour avoir posé les bases de la théorie de la conception des mécanismes"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13163: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Roger B. Myerson a-t-il reçu le Prix Nobel en 2007 ?",
      answers: ["Physique","Sciences Économiques","Chimie","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13164: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Yoichiro Nambu a-t-il reçu le Prix Nobel de Physique pour la découverte du mécanisme de la brisure spontanée de la symétrie en physique des particules ?",
      answers: ["2013","2019","2008","2007"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13165: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2008 pour la découverte du mécanisme de la brisure spontanée de la symétrie en physique des particules ?",
      answers: ["Andre Geim","Takaaki Kajita","Yoichiro Nambu","Johannes Stark"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13166: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Yoichiro Nambu a-t-il reçu le Prix Nobel en 2008 ?",
      answers: ["pour la découverte de la liberté asymptotique dans la théorie de l’interaction forte","pour leur découverte de la forme du corps noir et de l’anisotropie du fond diffus cosmologique","pour sa contribution à l’invention du circuit intégré","pour la découverte du mécanisme de la brisure spontanée de la symétrie en physique des particules"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13167: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Yoichiro Nambu a-t-il reçu le Prix Nobel en 2008 ?",
      answers: ["Chimie","Paix","Physique","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13168: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Makoto Kobayashi a-t-il reçu le Prix Nobel de Physique pour la découverte de l’origine de la brisure de symétrie qui prédit l’existence d’au moins trois familles de quarks dans la nature ?",
      answers: ["2006","1977","2008","2015"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13169: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2008 pour la découverte de l’origine de la brisure de symétrie qui prédit l’existence d’au moins trois familles de quarks dans la nature ?",
      answers: ["Brian P. Schmidt","J. Hans D. Jensen","Nevill F. Mott","Makoto Kobayashi"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13170: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Makoto Kobayashi a-t-il reçu le Prix Nobel en 2008 ?",
      answers: ["pour la découverte de l’origine de la brisure de symétrie qui prédit l’existence d’au moins trois familles de quarks dans la nature","pour la découverte de l’expansion accelérée de l’univers par l’observation des supernovae lointaines","pour leur méthode de génération d’impulsions optiques ultra-courtes et de haute intensité","pour la réalisation de la condensation de Bose-Einstein dans des gaz dilués d’atomes alcalins"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13171: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Makoto Kobayashi a-t-il reçu le Prix Nobel en 2008 ?",
      answers: ["Littérature","Chimie","Paix","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13172: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Toshihide Maskawa a-t-il reçu le Prix Nobel de Physique pour la découverte de l’origine de la brisure de symétrie qui prédit l’existence d’au moins trois familles de quarks dans la nature ?",
      answers: ["2009","2008","2005","1995"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13173: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2008 pour la découverte de l’origine de la brisure de symétrie qui prédit l’existence d’au moins trois familles de quarks dans la nature ?",
      answers: ["Peter Grünberg","Douglas D. Osheroff","Toshihide Maskawa","Makoto Kobayashi"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13174: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Toshihide Maskawa a-t-il reçu le Prix Nobel en 2008 ?",
      answers: ["pour des expériences révolutionnaires sur le matériau bidimensionnel graphène","pour la découverte de l’origine de la brisure de symétrie qui prédit l’existence d’au moins trois familles de quarks dans la nature","pour leur développement de nouvelles méthodes pour la mesure précise des propriétés magnétiques nucléaires","pour l’invention d’un capteur d’imagerie à semi-conducteur – le capteur CCD"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13175: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Toshihide Maskawa a-t-il reçu le Prix Nobel en 2008 ?",
      answers: ["Chimie","Physique","Sciences Économiques","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13176: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Osamu Shimomura a-t-il reçu le Prix Nobel de Chimie pour la découverte et le développement de la protéine fluorescente verte (GFP) ?",
      answers: ["2009","2008","2005","1998"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13177: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2008 pour la découverte et le développement de la protéine fluorescente verte (GFP) ?",
      answers: ["Hartmut Michel","Osamu Shimomura","Paul D. Boyer","Ernst Otto Fischer"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13178: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Osamu Shimomura a-t-il reçu le Prix Nobel en 2008 ?",
      answers: ["pour ses études sur la dynamique des réactions chimiques à l’échelle femtoseconde","pour des études sur la structure et la fonction du ribosome","pour la découverte et le développement de la protéine fluorescente verte (GFP)","pour le développement de la catalyse organique asymétrique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13179: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Osamu Shimomura a-t-il reçu le Prix Nobel en 2008 ?",
      answers: ["Littérature","Chimie","Physique","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13180: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Martin Chalfie a-t-il reçu le Prix Nobel de Chimie pour la découverte et le développement de la protéine fluorescente verte (GFP) ?",
      answers: ["2006","1910","2008","1992"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13181: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2008 pour la découverte et le développement de la protéine fluorescente verte (GFP) ?",
      answers: ["Richard L.M. Synge","Alan G. MacDiarmid","Moungi G. Bawendi","Martin Chalfie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13182: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Martin Chalfie a-t-il reçu le Prix Nobel en 2008 ?",
      answers: ["pour des études sur la structure et la fonction du ribosome","pour la découverte et le développement de la protéine fluorescente verte (GFP)","pour des études mécanistiques sur la réparation de l’ADN","pour leurs recherches sur les mécanismes des réactions chimiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13183: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Martin Chalfie a-t-il reçu le Prix Nobel en 2008 ?",
      answers: ["Physiologie ou Médecine","Paix","Chimie","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13184: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Roger Y. Tsien a-t-il reçu le Prix Nobel de Chimie pour la découverte et le développement de la protéine fluorescente verte (GFP) ?",
      answers: ["2013","2010","2022","2008"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13185: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2008 pour la découverte et le développement de la protéine fluorescente verte (GFP) ?",
      answers: ["Ahmed H. Zewail","Kurt Wüthrich","Roger Y. Tsien","Avram Hershko"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13186: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Roger Y. Tsien a-t-il reçu le Prix Nobel en 2008 ?",
      answers: ["pour ses études sur les bases moléculaires de la transcription eucaryote","pour le développement de modèles multi-échelles pour les systèmes chimiques complexes","pour la découverte et le développement de la protéine fluorescente verte (GFP)","pour la découverte des canaux d’eau dans les membranes cellulaires"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13187: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Roger Y. Tsien a-t-il reçu le Prix Nobel en 2008 ?",
      answers: ["Physique","Sciences Économiques","Chimie","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13188: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Harald zur Hausen a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour sa découverte des papillomavirus humains causant le cancer du col de l’utérus ?",
      answers: ["1998","2009","2004","2008"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13189: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2008 pour sa découverte des papillomavirus humains causant le cancer du col de l’utérus ?",
      answers: ["Sir Martin J. Evans","Harald zur Hausen","Mario R. Capecchi","Paul H. Müller"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13190: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Harald zur Hausen a-t-il reçu le Prix Nobel en 2008 ?",
      answers: ["pour leur découverte que les gènes agissent en régulant des événements chimiques définis","pour le développement de radio-immunoessais des hormones peptidiques","pour la découverte de la manière dont les chromosomes sont protégés par les télomères et l’enzyme télomérase","pour sa découverte des papillomavirus humains causant le cancer du col de l’utérus"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13191: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Harald zur Hausen a-t-il reçu le Prix Nobel en 2008 ?",
      answers: ["Paix","Chimie","Physiologie ou Médecine","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13192: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Françoise Barré-Sinoussi a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leur découverte du virus de l’immunodéficience humaine (VIH) ?",
      answers: ["2008","1927","2011","1990"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13193: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2008 pour leur découverte du virus de l’immunodéficience humaine (VIH) ?",
      answers: ["Harald zur Hausen","Françoise Barré-Sinoussi","Sydney Brenner","Daniel Bovet"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13194: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Françoise Barré-Sinoussi a-t-il reçu le Prix Nobel en 2008 ?",
      answers: ["pour leurs découvertes concernant l’organisation structurelle et fonctionnelle de la cellule","pour leurs découvertes sur les principes de l’introduction de modifications génétiques spécifiques chez la souris par l’utilisation de cellules souches embryonnaires","pour leurs découvertes concernant de nouveaux mécanismes d’origine et de dissémination des maladies infectieuses","pour leur découverte du virus de l’immunodéficience humaine (VIH)"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13195: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Françoise Barré-Sinoussi a-t-il reçu le Prix Nobel en 2008 ?",
      answers: ["Physiologie ou Médecine","Physique","Sciences Économiques","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13196: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Luc Montagnier a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leur découverte du virus de l’immunodéficience humaine (VIH) ?",
      answers: ["2008","1969","1989","2001"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13197: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2008 pour leur découverte du virus de l’immunodéficience humaine (VIH) ?",
      answers: ["Luc Montagnier","Arvid Carlsson","Sir Paul M. Nurse","Françoise Barré-Sinoussi"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13198: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Luc Montagnier a-t-il reçu le Prix Nobel en 2008 ?",
      answers: ["pour ses découvertes sur la manière dont les cellules détectent et s’adaptent à la disponibilité de l’oxygène","pour leur découverte des protéines G et leur rôle dans la transduction des signaux dans les cellules","pour leur découverte du virus de l’immunodéficience humaine (VIH)","pour sa découverte des papillomavirus humains causant le cancer du col de l’utérus"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13199: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Luc Montagnier a-t-il reçu le Prix Nobel en 2008 ?",
      answers: ["Chimie","Physique","Physiologie ou Médecine","Paix"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13200: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Jean-Marie Gustave Le Clézio a-t-il reçu le Prix Nobel de Littérature auteur de nouveaux départs, d’aventures poétiques et d’extases sensuelles, explorateur d’une humanité au-delà et en deçà de la civilisation régnante ?",
      answers: ["2000","2024","2004","2008"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13201: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 2008 auteur de nouveaux départs, d’aventures poétiques et d’extases sensuelles, explorateur d’une humanité au-delà et en deçà de la civilisation régnante ?",
      answers: ["Harold Pinter","Dario Fo","Jean-Marie Gustave Le Clézio","J. M. Coetzee"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13202: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Jean-Marie Gustave Le Clézio a-t-il reçu le Prix Nobel en 2008 ?",
      answers: ["qui, avec un réalisme hallucinatoire, fusionne contes populaires, histoire et contemporain","auteur de nouveaux départs, d’aventures poétiques et d’extases sensuelles, explorateur d’une humanité au-delà et en deçà de la civilisation régnante","qui, dans ses pièces, révèle le précipice sous les bavardages quotidiens et force l’entrée dans les pièces fermées de l’oppression","pour sa cartographie des structures du pouvoir et ses images tranchantes de la résistance, de la révolte et de la défaite de l’individu"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13203: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Jean-Marie Gustave Le Clézio a-t-il reçu le Prix Nobel en 2008 ?",
      answers: ["Paix","Littérature","Physique","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13204: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Martti Ahtisaari a-t-il reçu le Prix Nobel de Paix pour ses efforts importants sur plusieurs continents et pendant plus de trois décennies pour résoudre les conflits internationaux ?",
      answers: ["2008","2009","1964","1991"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13205: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2008 pour ses efforts importants sur plusieurs continents et pendant plus de trois décennies pour résoudre les conflits internationaux ?",
      answers: ["Martti Ahtisaari","Nadia Murad","Albert Schweitzer","Comité International de la Croix-Rouge (CICR)"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13206: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Martti Ahtisaari a-t-il reçu le Prix Nobel en 2008 ?",
      answers: ["pour ses efforts visant à instaurer la paix et la coopération internationale, notamment pour son initiative décisive dans la résolution du conflit frontalier avec l’Érythrée","pour ses efforts en faveur de la paix et de la diplomatie internationale","pour ses efforts importants sur plusieurs continents et pendant plus de trois décennies pour résoudre les conflits internationaux","pour sa lutte longue et non violente pour les droits humains fondamentaux en Chine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13207: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Martti Ahtisaari a-t-il reçu le Prix Nobel en 2008 ?",
      answers: ["Physique","Paix","Chimie","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13208: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Paul Krugman a-t-il reçu le Prix Nobel de Sciences Économiques pour son analyse des modèles commerciaux et de la localisation de l’activité économique ?",
      answers: ["1999","2014","2022","2008"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13209: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2008 pour son analyse des modèles commerciaux et de la localisation de l’activité économique ?",
      answers: ["Thomas C. Schelling","Oliver E. Williamson","Paul Krugman","Peter A. Diamond"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13210: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Paul Krugman a-t-il reçu le Prix Nobel en 2008 ?",
      answers: ["pour son analyse de la gouvernance économique, notamment des limites des entreprises","pour avoir amélioré notre compréhension des conflits et de la coopération à travers l’analyse de la théorie des jeux","pour son analyse des arbitrages intertemporels en politique macroéconomique","pour son analyse des modèles commerciaux et de la localisation de l’activité économique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13211: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Paul Krugman a-t-il reçu le Prix Nobel en 2008 ?",
      answers: ["Physique","Physiologie ou Médecine","Chimie","Sciences Économiques"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13212: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Charles K. Kao a-t-il reçu le Prix Nobel de Physique pour ses réalisations pionnières concernant la transmission de la lumière dans les fibres pour la communication optique ?",
      answers: ["2009","2003","2010","1952"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13213: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2009 pour ses réalisations pionnières concernant la transmission de la lumière dans les fibres pour la communication optique ?",
      answers: ["François Englert","Charles K. Kao","Willard S. Boyle","Barry C. Barish"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13214: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Charles K. Kao a-t-il reçu le Prix Nobel en 2009 ?",
      answers: ["pour la découverte de l’expansion accélérée de l’univers par l’observation des supernovae lointaines","pour des découvertes théoriques sur les transitions de phase topologiques et les phases topologiques de la matière","pour ses réalisations pionnières concernant la transmission de la lumière dans les fibres pour la communication optique","pour l’invention d’un capteur d’imagerie à semi-conducteur – le capteur CCD"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13215: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Charles K. Kao a-t-il reçu le Prix Nobel en 2009 ?",
      answers: ["Physique","Paix","Chimie","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13216: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Willard S. Boyle a-t-il reçu le Prix Nobel de Physique pour l’invention d’un capteur d’imagerie à semi-conducteur – le capteur CCD ?",
      answers: ["2009","1977","2007","2010"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13217: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2009 pour l’invention d’un capteur d’imagerie à semi-conducteur – le capteur CCD ?",
      answers: ["John C. Mather","Claude Cohen-Tannoudji","Leo Esaki","Willard S. Boyle"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13218: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Willard S. Boyle a-t-il reçu le Prix Nobel en 2009 ?",
      answers: ["pour la découverte de la magnétorésistance géante","pour le développement de la technique de diffraction neutronique","pour la découverte du neutron","pour l’invention d’un capteur d’imagerie à semi-conducteur – le capteur CCD"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13219: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Willard S. Boyle a-t-il reçu le Prix Nobel en 2009 ?",
      answers: ["Physique","Paix","Chimie","Littérature"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13220: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année George E. Smith a-t-il reçu le Prix Nobel de Physique pour l’invention d’un capteur d’imagerie à semi-conducteur – le capteur CCD ?",
      answers: ["2009","2023","2006","1977"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13221: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2009 pour l’invention d’un capteur d’imagerie à semi-conducteur – le capteur CCD ?",
      answers: ["Brian P. Schmidt","David M. Lee","Charles K. Kao","George E. Smith"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13222: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison George E. Smith a-t-il reçu le Prix Nobel en 2009 ?",
      answers: ["pour la découverte de l’origine de la brisure de symétrie qui prédit l’existence d’au moins trois familles de quarks dans la nature","pour l’invention d’un capteur d’imagerie à semi-conducteur – le capteur CCD","pour ses réalisations pionnières concernant la transmission de la lumière dans les fibres pour la communication optique","pour leurs contributions au développement de la spectroscopie de précision basée sur le laser"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13223: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie George E. Smith a-t-il reçu le Prix Nobel en 2009 ?",
      answers: ["Littérature","Chimie","Physique","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13224: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Venkatraman Ramakrishnan a-t-il reçu le Prix Nobel de Chimie pour des études sur la structure et la fonction du ribosome ?",
      answers: ["2009","1999","2010","2011"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13225: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2009 pour des études sur la structure et la fonction du ribosome ?",
      answers: ["Koichi Tanaka","Ada E. Yonath","Thomas A. Steitz","Venkatraman Ramakrishnan"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13226: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Venkatraman Ramakrishnan a-t-il reçu le Prix Nobel en 2009 ?",
      answers: ["pour des études sur la structure et la fonction du ribosome","pour ses études des processus chimiques sur les surfaces solides","pour le développement des batteries lithium-ion","pour la découverte des quasi-cristaux"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13227: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Venkatraman Ramakrishnan a-t-il reçu le Prix Nobel en 2009 ?",
      answers: ["Chimie","Physique","Physiologie ou Médecine","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13228: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Thomas A. Steitz a-t-il reçu le Prix Nobel de Chimie pour des études sur la structure et la fonction du ribosome ?",
      answers: ["2009","2005","1981","2007"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13229: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2009 pour des études sur la structure et la fonction du ribosome ?",
      answers: ["Thomas A. Steitz","Bernard L. Feringa","Kary B. Mullis","Sir J. Fraser Stoddart"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13230: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Thomas A. Steitz a-t-il reçu le Prix Nobel en 2009 ?",
      answers: ["pour des études sur la structure et la fonction du ribosome","pour la découverte et le développement de la protéine fluorescente verte (GFP)","pour leurs travaux sur la chimie de l’atmosphère, notamment concernant la formation et la décomposition de l’ozone","pour le développement de réactions de couplage catalysées par le palladium en synthèse organique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13231: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Thomas A. Steitz a-t-il reçu le Prix Nobel en 2009 ?",
      answers: ["Physique","Sciences Économiques","Paix","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13232: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Ada E. Yonath a-t-il reçu le Prix Nobel de Chimie pour des études sur la structure et la fonction du ribosome ?",
      answers: ["1913","2005","2009","1954"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13233: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2009 pour des études sur la structure et la fonction du ribosome ?",
      answers: ["Ada E. Yonath","Rudolph A. Marcus","Ei-ichi Negishi","Richard F. Heck"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13234: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Ada E. Yonath a-t-il reçu le Prix Nobel en 2009 ?",
      answers: ["pour la découverte et le développement des polymères conducteurs","pour la prédiction de la structure des protéines","pour leurs contributions à la compréhension de la connexion entre la structure chimique et l’activité catalytique du centre actif de la molécule de ribonucléase","pour des études sur la structure et la fonction du ribosome"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13235: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Ada E. Yonath a-t-il reçu le Prix Nobel en 2009 ?",
      answers: ["Sciences Économiques","Chimie","Littérature","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13236: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Elizabeth H. Blackburn a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour la découverte de la manière dont les chromosomes sont protégés par les télomères et l’enzyme télomérase ?",
      answers: ["2008","2009","2000","2012"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13237: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2009 pour la découverte de la manière dont les chromosomes sont protégés par les télomères et l’enzyme télomérase ?",
      answers: ["Carol W. Greider","Elizabeth H. Blackburn","Gary Ruvkun","Jack W. Szostak"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13238: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Elizabeth H. Blackburn a-t-il reçu le Prix Nobel en 2009 ?",
      answers: ["pour leur découverte que les gènes agissent en régulant des événements chimiques définis","pour leurs découvertes concernant l’activation de l’immunité innée","pour la découverte de la manière dont les chromosomes sont protégés par les télomères et l’enzyme télomérase","pour leur découverte des protéines G et leur rôle dans la transduction des signaux dans les cellules"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13239: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Elizabeth H. Blackburn a-t-il reçu le Prix Nobel en 2009 ?",
      answers: ["Physique","Paix","Physiologie ou Médecine","Sciences Économiques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13240: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Carol W. Greider a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour la découverte de la manière dont les chromosomes sont protégés par les télomères et l’enzyme télomérase ?",
      answers: ["2009","2014","2012","1997"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13241: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2009 pour la découverte de la manière dont les chromosomes sont protégés par les télomères et l’enzyme télomérase ?",
      answers: ["Elizabeth H. Blackburn","Carol W. Greider","Rolf M. Zinkernagel","Oliver Smithies"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13242: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Carol W. Greider a-t-il reçu le Prix Nobel en 2009 ?",
      answers: ["pour leurs découvertes sur les principes de l’introduction de modifications génétiques spécifiques chez la souris par l’utilisation de cellules souches embryonnaires","pour la découverte de la manière dont les chromosomes sont protégés par les télomères et l’enzyme télomérase","pour leurs découvertes des mécanismes moléculaires contrôlant le rythme circadien","pour leurs découvertes sur le système de transport vésiculaire dans les cellules"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13243: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Carol W. Greider a-t-il reçu le Prix Nobel en 2009 ?",
      answers: ["Paix","Physiologie ou Médecine","Physique","Littérature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13244: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Jack W. Szostak a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour la découverte de la manière dont les chromosomes sont protégés par les télomères et l’enzyme télomérase ?",
      answers: ["2012","2009","2016","1950"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13245: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2009 pour la découverte de la manière dont les chromosomes sont protégés par les télomères et l’enzyme télomérase ?",
      answers: ["Andrew Z. Fire","Mario R. Capecchi","Willem Einthoven","Jack W. Szostak"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13246: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Jack W. Szostak a-t-il reçu le Prix Nobel en 2009 ?",
      answers: ["pour leur découverte du virus de l’immunodéficience humaine (VIH)","pour ses découvertes sur la manière dont les cellules détectent et s’adaptent à la disponibilité de l’oxygène","pour la découverte du virus de l’hépatite C","pour la découverte de la manière dont les chromosomes sont protégés par les télomères et l’enzyme télomérase"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13247: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Jack W. Szostak a-t-il reçu le Prix Nobel en 2009 ?",
      answers: ["Physiologie ou Médecine","Physique","Littérature","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13248: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Herta Müller a-t-il reçu le Prix Nobel de Littérature qui, avec la concentration de la poésie et la franchise de la prose, dépeint le paysage des dépossédés ?",
      answers: ["2009","2010","2008","2015"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13249: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 2009 qui, avec la concentration de la poésie et la franchise de la prose, dépeint le paysage des dépossédés ?",
      answers: ["Seamus Heaney","Pearl Buck","Herta Müller","Shmuel Yosef Agnon"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13250: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Herta Müller a-t-il reçu le Prix Nobel en 2009 ?",
      answers: ["qui, avec un réalisme hallucinatoire, fusionne contes populaires, histoire et contemporain","qui, dans ses romans, combine la créativité du poète et du peintre avec une profonde conscience du temps dans la représentation de la condition humaine","qui, avec la concentration de la poésie et la franchise de la prose, dépeint le paysage des dépossédés","qui, dans ses pièces, révèle le précipice sous les bavardages quotidiens et force l’entrée dans les pièces fermées de l’oppression"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13251: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Herta Müller a-t-il reçu le Prix Nobel en 2009 ?",
      answers: ["Littérature","Physique","Chimie","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13252: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Barack H. Obama a-t-il reçu le Prix Nobel de Paix pour ses efforts extraordinaires visant à renforcer la diplomatie internationale et la coopération entre les peuples ?",
      answers: ["2009","2018","2011","2008"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13253: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2009 pour ses efforts extraordinaires visant à renforcer la diplomatie internationale et la coopération entre les peuples ?",
      answers: ["Grameen Bank","Léon Bourgeois","Barack H. Obama","Kim Dae-jung"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13254: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Barack H. Obama a-t-il reçu le Prix Nobel en 2009 ?",
      answers: ["pour son rôle dans la négociation de la paix dans la guerre russo-japonaise","pour leur travail en faveur d’une solution juste et pacifique au conflit au Timor oriental","pour son message de paix, d’expiation et de dignité humaine en tant que témoin de l’Holocauste","pour ses efforts extraordinaires visant à renforcer la diplomatie internationale et la coopération entre les peuples"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13255: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Barack H. Obama a-t-il reçu le Prix Nobel en 2009 ?",
      answers: ["Chimie","Paix","Physique","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13256: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Elinor Ostrom a-t-il reçu le Prix Nobel de Sciences Économiques pour son analyse de la gouvernance économique, notamment des biens communs ?",
      answers: ["1991","2009","1953","2005"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13257: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2009 pour son analyse de la gouvernance économique, notamment des biens communs ?",
      answers: ["Robert J. Shiller","Christopher A. Pissarides","Elinor Ostrom","Jean Tirole"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13258: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Elinor Ostrom a-t-il reçu le Prix Nobel en 2009 ?",
      answers: ["pour ses réalisations dans les domaines de l’analyse de la consommation, de l’histoire et de la théorie monétaire et pour sa démonstration de la complexité de la politique de stabilisation","pour avoir développé et appliqué des modèles dynamiques à l’analyse des processus économiques","pour avoir amélioré notre compréhension des conflits et de la coopération à travers l’analyse de la théorie des jeux","pour son analyse de la gouvernance économique, notamment des biens communs"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13259: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Elinor Ostrom a-t-il reçu le Prix Nobel en 2009 ?",
      answers: ["Littérature","Chimie","Physique","Sciences Économiques"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13260: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Oliver E. Williamson a-t-il reçu le Prix Nobel de Sciences Économiques pour son analyse de la gouvernance économique, notamment des limites des entreprises ?",
      answers: ["1985","1962","2009","2001"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13261: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2009 pour son analyse de la gouvernance économique, notamment des limites des entreprises ?",
      answers: ["Oliver E. Williamson","Elinor Ostrom","Paul Krugman","Christopher A. Pissarides"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13262: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Oliver E. Williamson a-t-il reçu le Prix Nobel en 2009 ?",
      answers: ["pour avoir posé les bases de la théorie de la conception des mécanismes","pour leur analyse des marchés avec des frictions de recherche","pour son analyse de la gouvernance économique, notamment des limites des entreprises","pour ses améliorations à la théorie des enchères et ses inventions de nouveaux formats d’enchères"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13263: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Oliver E. Williamson a-t-il reçu le Prix Nobel en 2009 ?",
      answers: ["Physiologie ou Médecine","Sciences Économiques","Paix","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13264: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Andre Geim a-t-il reçu le Prix Nobel de Physique pour des expériences révolutionnaires sur le matériau bidimensionnel graphène ?",
      answers: ["2010","2007","1997","2013"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13265: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2010 pour des expériences révolutionnaires sur le matériau bidimensionnel graphène ?",
      answers: ["Roger Penrose","Andre Geim","Barry C. Barish","Brian P. Schmidt"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13266: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Andre Geim a-t-il reçu le Prix Nobel en 2010 ?",
      answers: ["pour la découverte du mécanisme de la brisure spontanée de la symétrie en physique des particules","pour ses inventions et découvertes fondamentales dans la physique des basses températures","pour des expériences révolutionnaires sur le matériau bidimensionnel graphène","pour la découverte de l’expansion accelérée de l’univers par l’observation des supernovae lointaines"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13267: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Andre Geim a-t-il reçu le Prix Nobel en 2010 ?",
      answers: ["Physique","Littérature","Physiologie ou Médecine","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13268: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Konstantin Novoselov a-t-il reçu le Prix Nobel de Physique pour des expériences révolutionnaires sur le matériau bidimensionnel graphène ?",
      answers: ["2016","1928","2010","2009"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13269: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2010 pour des expériences révolutionnaires sur le matériau bidimensionnel graphène ?",
      answers: ["Andre Geim","Peter Grünberg","Konstantin Novoselov","Julian Schwinger"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13270: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Konstantin Novoselov a-t-il reçu le Prix Nobel en 2010 ?",
      answers: ["pour la méthode du faisceau de neutrinos et la démonstration de la structure en doublet des leptons par la découverte du neutrino muonique","pour leurs contributions au développement de la spectroscopie de précision basée sur le laser","pour la découverte théorique d’un mécanisme contribuant à notre compréhension de l’origine de la masse des particules subatomiques","pour des expériences révolutionnaires sur le matériau bidimensionnel graphène"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13271: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Konstantin Novoselov a-t-il reçu le Prix Nobel en 2010 ?",
      answers: ["Chimie","Littérature","Physiologie ou Médecine","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13272: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Robert G. Edwards a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour le développement de la fécondation in vitro ?",
      answers: ["2000","1973","2010","2022"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13273: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2010 pour le développement de la fécondation in vitro ?",
      answers: ["Michael W. Young","Andrew V. Schally","Sir James W. Black","Robert G. Edwards"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13274: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Robert G. Edwards a-t-il reçu le Prix Nobel en 2010 ?",
      answers: ["pour la découverte du virus de l’hépatite C","pour le développement de la fécondation in vitro","pour leurs découvertes sur les modifications des bases nucléosidiques qui ont permis le développement de vaccins à ARNm efficaces contre le COVID-19","pour leurs découvertes sur la régulation du cycle cellulaire"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13275: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Robert G. Edwards a-t-il reçu le Prix Nobel en 2010 ?",
      answers: ["Physiologie ou Médecine","Sciences Économiques","Physique","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13276: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Richard F. Heck a-t-il reçu le Prix Nobel de Chimie pour le développement de réactions de couplage catalysées par le palladium en synthèse organique ?",
      answers: ["2010","2011","1998","1997"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13277: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2010 pour le développement de réactions de couplage catalysées par le palladium en synthèse organique ?",
      answers: ["Akira Suzuki","Richard F. Heck","Thomas R. Cech","Ada E. Yonath"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13278: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Richard F. Heck a-t-il reçu le Prix Nobel en 2010 ?",
      answers: ["pour leur élucidation du mécanisme enzymatique sous-jacent à la synthèse de l’adénosine triphosphate (ATP)","pour ses études des processus chimiques sur les surfaces solides","pour le développement de réactions de couplage catalysées par le palladium en synthèse organique","pour le développement de la catalyse organique asymétrique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13279: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Richard F. Heck a-t-il reçu le Prix Nobel en 2010 ?",
      answers: ["Paix","Physique","Physiologie ou Médecine","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13280: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Ei-ichi Negishi a-t-il reçu le Prix Nobel de Chimie pour le développement de réactions de couplage catalysées par le palladium en synthèse organique ?",
      answers: ["2011","2010","2006","2012"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13281: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2010 pour le développement de réactions de couplage catalysées par le palladium en synthèse organique ?",
      answers: ["Roger Y. Tsien","Ei-ichi Negishi","Richard R. Schrock","Paul Berg"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13282: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Ei-ichi Negishi a-t-il reçu le Prix Nobel en 2010 ?",
      answers: ["pour le développement de réactions de couplage catalysées par le palladium en synthèse organique","pour le développement de la cryo-microscopie électronique pour la détermination de la structure à haute résolution des biomolécules en solution","pour la technique de phage display des peptides et des anticorps","pour le développement de modèles multi-échelles pour les systèmes chimiques complexes"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13283: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Ei-ichi Negishi a-t-il reçu le Prix Nobel en 2010 ?",
      answers: ["Paix","Chimie","Littérature","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13284: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Akira Suzuki a-t-il reçu le Prix Nobel de Chimie pour le développement de réactions de couplage catalysées par le palladium en synthèse organique ?",
      answers: ["1938","2006","1997","2010"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13285: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2010 pour le développement de réactions de couplage catalysées par le palladium en synthèse organique ?",
      answers: ["Akira Suzuki","Richard F. Heck","Ada E. Yonath","Avram Hershko"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13286: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Akira Suzuki a-t-il reçu le Prix Nobel en 2010 ?",
      answers: ["pour le développement de modèles multi-échelles pour les systèmes chimiques complexes","pour le développement de la méthode de métathèse en synthèse organique","pour le développement de la spectroscopie par résonance magnétique nucléaire pour déterminer la structure tridimensionnelle des macromolécules biologiques","pour le développement de réactions de couplage catalysées par le palladium en synthèse organique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13287: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Akira Suzuki a-t-il reçu le Prix Nobel en 2010 ?",
      answers: ["Littérature","Sciences Économiques","Physiologie ou Médecine","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13288: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Mario Vargas Llosa a-t-il reçu le Prix Nobel de Littérature pour sa cartographie des structures du pouvoir et ses images tranchantes de la résistance, de la révolte et de la défaite de l’individu ?",
      answers: ["1978","2011","2023","2010"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13289: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 2010 pour sa cartographie des structures du pouvoir et ses images tranchantes de la résistance, de la révolte et de la défaite de l’individu ?",
      answers: ["Kazuo Ishiguro","Patrick Modiano","Mario Vargas Llosa","Kenzaburo Oe"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13290: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Mario Vargas Llosa a-t-il reçu le Prix Nobel en 2010 ?",
      answers: ["qui, avec un réalisme hallucinatoire, fusionne contes populaires, histoire et contemporain","pour sa cartographie des structures du pouvoir et ses images tranchantes de la résistance, de la révolte et de la défaite de l’individu","qui, avec une lucidité sans compromis, exprime la condition exposée de l’homme dans un monde de conflits sévères","pour sa grande épopée nationale, 'Les Paysans'"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13291: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Mario Vargas Llosa a-t-il reçu le Prix Nobel en 2010 ?",
      answers: ["Littérature","Paix","Physiologie ou Médecine","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13292: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Liu Xiaobo a-t-il reçu le Prix Nobel de Paix pour sa lutte longue et non violente pour les droits humains fondamentaux en Chine ?",
      answers: ["2010","1998","1981","2021"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13293: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2010 pour sa lutte longue et non violente pour les droits humains fondamentaux en Chine ?",
      answers: ["Kailash Satyarthi","Liu Xiaobo","Quartet du Dialogue National Tunisien","Carl von Ossietzky"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13294: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Liu Xiaobo a-t-il reçu le Prix Nobel en 2010 ?",
      answers: ["pour son rôle dans le Plan Marshall et ses efforts pour promouvoir la paix en Europe","pour son travail dans la rédaction de la Déclaration universelle des droits de l’homme","pour ses efforts extraordinaires visant à renforcer la diplomatie internationale et la coopération entre les peuples","pour sa lutte longue et non violente pour les droits humains fondamentaux en Chine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13295: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Liu Xiaobo a-t-il reçu le Prix Nobel en 2010 ?",
      answers: ["Chimie","Physique","Paix","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13296: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Peter A. Diamond a-t-il reçu le Prix Nobel de Sciences Économiques pour leur analyse des marchés avec des frictions de recherche ?",
      answers: ["2017","2007","2010","2009"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13297: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2010 pour leur analyse des marchés avec des frictions de recherche ?",
      answers: ["Christopher A. Sims","Peter A. Diamond","Christopher A. Pissarides","Dale T. Mortensen"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13298: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Peter A. Diamond a-t-il reçu le Prix Nobel en 2010 ?",
      answers: ["pour leurs analyses pionnières du développement économique, avec une attention particulière aux problèmes des pays en développement","pour leur analyse des marchés avec des frictions de recherche","pour son analyse de la gouvernance économique, notamment des biens communs","pour une nouvelle méthode de détermination de la valeur des produits dérivés"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13299: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Peter A. Diamond a-t-il reçu le Prix Nobel en 2010 ?",
      answers: ["Sciences Économiques","Physiologie ou Médecine","Physique","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13300: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Dale T. Mortensen a-t-il reçu le Prix Nobel de Sciences Économiques pour leur analyse des marchés avec des frictions de recherche ?",
      answers: ["2010","1976","2017","1987"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13301: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2010 pour leur analyse des marchés avec des frictions de recherche ?",
      answers: ["Peter A. Diamond","Eugene F. Fama","Dale T. Mortensen","James A. Robinson"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13302: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Dale T. Mortensen a-t-il reçu le Prix Nobel en 2010 ?",
      answers: ["pour sa clarification des fondements de la théorie économétrique probabiliste et son analyse des structures économiques simultanées","pour leur analyse des marchés avec des frictions de recherche","pour avoir posé les bases de la théorie de la conception des mécanismes","pour leurs contributions méthodologiques à l’analyse des relations causales"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13303: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Dale T. Mortensen a-t-il reçu le Prix Nobel en 2010 ?",
      answers: ["Sciences Économiques","Physiologie ou Médecine","Physique","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13304: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Christopher A. Pissarides a-t-il reçu le Prix Nobel de Sciences Économiques pour leur analyse des marchés avec des frictions de recherche ?",
      answers: ["2015","2010","2004","2003"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13305: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2010 pour leur analyse des marchés avec des frictions de recherche ?",
      answers: ["Christopher A. Pissarides","Peter A. Diamond","Paul R. Milgrom","Alvin E. Roth"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13306: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Christopher A. Pissarides a-t-il reçu le Prix Nobel en 2010 ?",
      answers: ["pour avoir intégré des perspectives psychologiques dans l’analyse économique, notamment sur le comportement humain sous incertitude","pour avoir étendu l’analyse microéconomique à une large gamme de comportements humains et d’interactions","pour son analyse de la gouvernance économique, notamment des biens communs","pour leur analyse des marchés avec des frictions de recherche"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13307: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Christopher A. Pissarides a-t-il reçu le Prix Nobel en 2010 ?",
      answers: ["Chimie","Sciences Économiques","Physique","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13308: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Saul Perlmutter a-t-il reçu le Prix Nobel de Physique pour la découverte de l’expansion accélérée de l’univers par l’observation des supernovae lointaines ?",
      answers: ["2002","2015","2011","1993"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13309: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2011 pour la découverte de l’expansion accélérée de l’univers par l’observation des supernovae lointaines ?",
      answers: ["Brian P. Schmidt","George E. Smith","Saul Perlmutter","John C. Mather"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13310: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Saul Perlmutter a-t-il reçu le Prix Nobel en 2011 ?",
      answers: ["pour la découverte de l’expansion accélérée de l’univers par l’observation des supernovae lointaines","pour la méthode du faisceau de neutrinos et la démonstration de la structure en doublet des leptons par la découverte du neutrino muonique","pour la découverte de la magnétorésistance géante","pour des expériences avec des photons intriqués, établissant la violation des inégalités de Bell et ouvrant la voie à la science de l’information quantique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13311: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Saul Perlmutter a-t-il reçu le Prix Nobel en 2011 ?",
      answers: ["Physique","Chimie","Physiologie ou Médecine","Littérature"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13312: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Brian P. Schmidt a-t-il reçu le Prix Nobel de Physique pour la découverte de l’expansion accelérée de l’univers par l’observation des supernovae lointaines ?",
      answers: ["2011","2012","2013","2015"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13313: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2011 pour la découverte de l’expansion accelérée de l’univers par l’observation des supernovae lointaines ?",
      answers: ["Brian P. Schmidt","Roy J. Glauber","H. David Politzer","Anthony J. Leggett"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13314: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Brian P. Schmidt a-t-il reçu le Prix Nobel en 2011 ?",
      answers: ["pour la découverte d’une exoplanète orbitant autour d’une étoile de type solaire","pour la modélisation physique du climat terrestre, la quantification de sa variabilité et la prédiction fiable du réchauffement climatique","pour leur méthode de génération d’impulsions optiques ultra-courtes et de haute intensité","pour la découverte de l’expansion accelérée de l’univers par l’observation des supernovae lointaines"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13315: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Brian P. Schmidt a-t-il reçu le Prix Nobel en 2011 ?",
      answers: ["Paix","Physiologie ou Médecine","Chimie","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13316: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Adam G. Riess a-t-il reçu le Prix Nobel de Physique pour la découverte de l’expansion accelérée de l’univers par l’observation des supernovae lointaines ?",
      answers: ["1979","1993","2003","2011"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13317: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2011 pour la découverte de l’expansion accelérée de l’univers par l’observation des supernovae lointaines ?",
      answers: ["Charles H. Townes","Adam G. Riess","Barry C. Barish","Isamu Akasaki"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13318: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Adam G. Riess a-t-il reçu le Prix Nobel en 2011 ?",
      answers: ["pour la découverte de l’expansion accelérée de l’univers par l’observation des supernovae lointaines","pour des expériences avec des photons intriqués, établissant la violation des inégalités de Bell et ouvrant la voie à la science de l’information quantique","pour l’invention d’un capteur d’imagerie à semi-conducteur – le capteur CCD","pour leur développement de nouvelles méthodes pour la mesure précise des propriétés magnétiques nucléaires"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13319: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Adam G. Riess a-t-il reçu le Prix Nobel en 2011 ?",
      answers: ["Paix","Littérature","Sciences Économiques","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13320: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Dan Shechtman a-t-il reçu le Prix Nobel de Chimie pour la découverte des quasi-cristaux ?",
      answers: ["2012","2005","2011","2001"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13321: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2011 pour la découverte des quasi-cristaux ?",
      answers: ["Osamu Shimomura","Ei-ichi Negishi","Yuan T. Lee","Dan Shechtman"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13322: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Dan Shechtman a-t-il reçu le Prix Nobel en 2011 ?",
      answers: ["pour le développement de modèles multi-échelles pour les systèmes chimiques complexes","pour l’évolution dirigée des enzymes","pour leur découverte des fullerènes","pour la découverte des quasi-cristaux"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13323: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Dan Shechtman a-t-il reçu le Prix Nobel en 2011 ?",
      answers: ["Physiologie ou Médecine","Chimie","Littérature","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13324: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Bruce A. Beutler a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant l’activation de l’immunité innée ?",
      answers: ["2011","2010","2022","1947"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13325: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2011 pour leurs découvertes concernant l’activation de l’immunité innée ?",
      answers: ["Bruce A. Beutler","Shinya Yamanaka","J. Robin Warren","Tasuku Honjo"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13326: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Bruce A. Beutler a-t-il reçu le Prix Nobel en 2011 ?",
      answers: ["pour sa découverte des cellules dendritiques et de leur rôle dans l’immunité adaptative","pour la découverte des microARN, une nouvelle classe de petites molécules d’ARN qui jouent un rôle crucial dans la régulation génique","pour ses découvertes sur les récepteurs de la température et du toucher","pour leurs découvertes concernant l’activation de l’immunité innée"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13327: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Bruce A. Beutler a-t-il reçu le Prix Nobel en 2011 ?",
      answers: ["Littérature","Physique","Physiologie ou Médecine","Paix"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13328: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Jules A. Hoffmann a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant l’activation de l’immunité innée ?",
      answers: ["1996","2012","1980","2011"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13329: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2011 pour leurs découvertes concernant l’activation de l’immunité innée ?",
      answers: ["Ferid Murad","Bruce A. Beutler","Jules A. Hoffmann","Allvar Gullstrand"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13330: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Jules A. Hoffmann a-t-il reçu le Prix Nobel en 2011 ?",
      answers: ["pour la découverte de la manière dont les chromosomes sont protégés par les télomères et l’enzyme télomérase","pour la découverte du virus de l’hépatite C","pour leurs découvertes sur les principes de l’introduction de modifications génétiques spécifiques chez la souris par l’utilisation de cellules souches embryonnaires","pour leurs découvertes concernant l’activation de l’immunité innée"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13331: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Jules A. Hoffmann a-t-il reçu le Prix Nobel en 2011 ?",
      answers: ["Physique","Littérature","Chimie","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13332: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Ralph M. Steinman a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour sa découverte des cellules dendritiques et de leur rôle dans l’immunité adaptative ?",
      answers: ["2006","2011","1995","1970"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13333: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2011 pour sa découverte des cellules dendritiques et de leur rôle dans l’immunité adaptative ?",
      answers: ["John E. Sulston","Ralph M. Steinman","Sir John B. Gurdon","Barry J. Marshall"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13334: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Ralph M. Steinman a-t-il reçu le Prix Nobel en 2011 ?",
      answers: ["pour sa découverte des cellules dendritiques et de leur rôle dans l’immunité adaptative","pour la découverte de la manière dont les chromosomes sont protégés par les télomères et l’enzyme télomérase","pour leurs découvertes concernant le contrôle génétique du développement précoce de l’embryon","pour leurs découvertes concernant l’activation de l’immunité innée"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13335: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Ralph M. Steinman a-t-il reçu le Prix Nobel en 2011 ?",
      answers: ["Chimie","Littérature","Physiologie ou Médecine","Sciences Économiques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13336: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Tomas Tranströmer a-t-il reçu le Prix Nobel de Littérature parce que, à travers ses images denses et translucides, il nous donne un accès renouvelé à la réalité ?",
      answers: ["2009","1973","2011","2008"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13337: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 2011 parce que, à travers ses images denses et translucides, il nous donne un accès renouvelé à la réalité ?",
      answers: ["Nelly Sachs","Tomas Tranströmer","Mo Yan","Mario Vargas Llosa"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13338: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Tomas Tranströmer a-t-il reçu le Prix Nobel en 2011 ?",
      answers: ["pour ses pièces de théâtre et sa prose innovantes qui donnent une voix à l’indicible","qui, avec la concentration de la poésie et la franchise de la prose, dépeint le paysage des dépossédés","maîtresse de la nouvelle contemporaine","parce que, à travers ses images denses et translucides, il nous donne un accès renouvelé à la réalité"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13339: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Tomas Tranströmer a-t-il reçu le Prix Nobel en 2011 ?",
      answers: ["Physiologie ou Médecine","Littérature","Physique","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13340: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Ellen Johnson Sirleaf a-t-il reçu le Prix Nobel de Paix pour leur lutte non violente pour la sécurité des femmes et pour les droits des femmes à participer pleinement aux processus de paix ?",
      answers: ["2011","1998","2004","2019"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13341: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2011 pour leur lutte non violente pour la sécurité des femmes et pour les droits des femmes à participer pleinement aux processus de paix ?",
      answers: ["Mohamed ElBaradei","Tawakkol Karman","Leymah Gbowee","Ellen Johnson Sirleaf"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13342: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Ellen Johnson Sirleaf a-t-il reçu le Prix Nobel en 2011 ?",
      answers: ["pour avoir contribué pendant plus de six décennies à la promotion de la paix, de la réconciliation, de la démocratie et des droits humains en Europe","pour leur lutte non violente pour la sécurité des femmes et pour les droits des femmes à participer pleinement aux processus de paix","pour sa contribution décisive à la construction d’une démocratie pluraliste en Tunisie après la Révolution du Jasmin de 2011","pour ses efforts considérables visant à éliminer les armes chimiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13343: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Ellen Johnson Sirleaf a-t-il reçu le Prix Nobel en 2011 ?",
      answers: ["Paix","Chimie","Physiologie ou Médecine","Littérature"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13344: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Leymah Gbowee a-t-il reçu le Prix Nobel de Paix pour leur lutte non violente pour la sécurité des femmes et pour les droits des femmes à participer pleinement aux processus de paix ?",
      answers: ["2006","1988","2005","2011"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13345: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2011 pour leur lutte non violente pour la sécurité des femmes et pour les droits des femmes à participer pleinement aux processus de paix ?",
      answers: ["Groupe d’Experts Intergouvernemental sur l’Évolution du Climat (GIEC)","Leymah Gbowee","Ellen Johnson Sirleaf","Martti Ahtisaari"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13346: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Leymah Gbowee a-t-il reçu le Prix Nobel en 2011 ?",
      answers: ["pour ses efforts extraordinaires visant à renforcer la diplomatie internationale et la coopération entre les peuples","pour son rôle de leader dans la défense non violente des droits humains en Amérique latine","pour leur lutte non violente pour la sécurité des femmes et pour les droits des femmes à participer pleinement aux processus de paix","pour sa contribution décisive à la construction d’une démocratie pluraliste en Tunisie après la Révolution du Jasmin de 2011"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13347: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Leymah Gbowee a-t-il reçu le Prix Nobel en 2011 ?",
      answers: ["Physique","Chimie","Sciences Économiques","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13348: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Tawakkol Karman a-t-il reçu le Prix Nobel de Paix pour leur lutte non violente pour la sécurité des femmes et pour les droits des femmes à participer pleinement aux processus de paix ?",
      answers: ["1972","2011","2009","1994"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13349: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2011 pour leur lutte non violente pour la sécurité des femmes et pour les droits des femmes à participer pleinement aux processus de paix ?",
      answers: ["Tawakkol Karman","Jimmy Carter","Ellen Johnson Sirleaf","Aung San Suu Kyi"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13350: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Tawakkol Karman a-t-il reçu le Prix Nobel en 2011 ?",
      answers: ["pour ses efforts importants sur plusieurs continents et pendant plus de trois décennies pour résoudre les conflits internationaux","pour son travail de longue date en faveur de la paix et du désarmement","pour son travail humanitaire, notamment en faveur des réfugiés et des victimes de la Première Guerre mondiale","pour leur lutte non violente pour la sécurité des femmes et pour les droits des femmes à participer pleinement aux processus de paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13351: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Tawakkol Karman a-t-il reçu le Prix Nobel en 2011 ?",
      answers: ["Littérature","Chimie","Paix","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13352: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Thomas J. Sargent a-t-il reçu le Prix Nobel de Sciences Économiques pour leurs travaux empiriques sur la cause et l’effet en macroéconomie ?",
      answers: ["1992","2003","1965","2011"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13353: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2011 pour leurs travaux empiriques sur la cause et l’effet en macroéconomie ?",
      answers: ["Alvin E. Roth","Thomas J. Sargent","Amartya Sen","A. Michael Spence"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13354: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Thomas J. Sargent a-t-il reçu le Prix Nobel en 2011 ?",
      answers: ["pour ses méthodes d’analyse des données microéconomiques","pour leur analyse des marchés avec des frictions de recherche","pour leurs travaux empiriques sur la cause et l’effet en macroéconomie","pour leur approche expérimentale visant à réduire la pauvreté dans le monde"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13355: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Thomas J. Sargent a-t-il reçu le Prix Nobel en 2011 ?",
      answers: ["Chimie","Paix","Sciences Économiques","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13356: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Christopher A. Sims a-t-il reçu le Prix Nobel de Sciences Économiques pour leurs travaux empiriques sur la cause et l’effet en macroéconomie ?",
      answers: ["2012","2011","2021","2016"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13357: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2011 pour leurs travaux empiriques sur la cause et l’effet en macroéconomie ?",
      answers: ["Lloyd S. Shapley","Oliver E. Williamson","Thomas J. Sargent","Christopher A. Sims"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13358: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Christopher A. Sims a-t-il reçu le Prix Nobel en 2011 ?",
      answers: ["pour son analyse de la théorie des marchés financiers et de leurs relations avec les décisions de dépenses, l’emploi, la production et les prix","pour sa clarification des fondements de la théorie économétrique probabiliste et son analyse des structures économiques simultanées","pour son analyse des modèles commerciaux et de la localisation de l’activité économique","pour leurs travaux empiriques sur la cause et l’effet en macroéconomie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13359: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Christopher A. Sims a-t-il reçu le Prix Nobel en 2011 ?",
      answers: ["Sciences Économiques","Physiologie ou Médecine","Physique","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13360: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Serge Haroche a-t-il reçu le Prix Nobel de Physique pour des méthodes expérimentales révolutionnaires permettant la mesure et la manipulation des systèmes quantiques individuels ?",
      answers: ["2006","2001","2003","2012"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13361: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2012 pour des méthodes expérimentales révolutionnaires permettant la mesure et la manipulation des systèmes quantiques individuels ?",
      answers: ["Serge Haroche","Zhores I. Alferov","Carl D. Anderson","F. Duncan M. Haldane"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13362: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Serge Haroche a-t-il reçu le Prix Nobel en 2012 ?",
      answers: ["pour leurs travaux pionniers sur la transmutation des noyaux atomiques par des particules accélérées artificiellement","pour des méthodes expérimentales révolutionnaires permettant la mesure et la manipulation des systèmes quantiques individuels","pour l’invention des pinces optiques et leur application aux systèmes biologiques","pour leurs contributions au développement de la spectroscopie de précision basée sur le laser"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13363: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Serge Haroche a-t-il reçu le Prix Nobel en 2012 ?",
      answers: ["Physique","Paix","Chimie","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13364: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année David J. Wineland a-t-il reçu le Prix Nobel de Physique pour des méthodes expérimentales révolutionnaires permettant la mesure et la manipulation des systèmes quantiques individuels ?",
      answers: ["2009","1987","2012","2010"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13365: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2012 pour des méthodes expérimentales révolutionnaires permettant la mesure et la manipulation des systèmes quantiques individuels ?",
      answers: ["Brian P. Schmidt","David J. Wineland","Adam G. Riess","James Peebles"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13366: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison David J. Wineland a-t-il reçu le Prix Nobel en 2012 ?",
      answers: ["pour ses réalisations pionnières concernant la transmission de la lumière dans les fibres pour la communication optique","pour l’invention de diodes électroluminescentes bleues efficaces, permettant des sources de lumière blanche brillantes et économes en énergie","pour la découverte de l’expansion accelérée de l’univers par l’observation des supernovae lointaines","pour des méthodes expérimentales révolutionnaires permettant la mesure et la manipulation des systèmes quantiques individuels"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13367: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie David J. Wineland a-t-il reçu le Prix Nobel en 2012 ?",
      answers: ["Physiologie ou Médecine","Paix","Littérature","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13368: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Robert J. Lefkowitz a-t-il reçu le Prix Nobel de Chimie pour des études sur les récepteurs couplés aux protéines G ?",
      answers: ["2011","2023","1910","2012"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13369: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2012 pour des études sur les récepteurs couplés aux protéines G ?",
      answers: ["Arieh Warshel","Nikolay N. Semenov","Ei-ichi Negishi","Robert J. Lefkowitz"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13370: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Robert J. Lefkowitz a-t-il reçu le Prix Nobel en 2012 ?",
      answers: ["pour le développement de la microscopie à fluorescence à super-résolution","pour la découverte et le développement de la protéine fluorescente verte (GFP)","pour ses études des processus chimiques sur les surfaces solides","pour des études sur les récepteurs couplés aux protéines G"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13371: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Robert J. Lefkowitz a-t-il reçu le Prix Nobel en 2012 ?",
      answers: ["Physiologie ou Médecine","Chimie","Sciences Économiques","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13372: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Brian K. Kobilka a-t-il reçu le Prix Nobel de Chimie pour des études sur les récepteurs couplés aux protéines G ?",
      answers: ["2012","1921","2010","1968"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13373: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2012 pour des études sur les récepteurs couplés aux protéines G ?",
      answers: ["Brian K. Kobilka","Michael Smith","Robert F. Curl Jr.","Paul Berg"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13374: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Brian K. Kobilka a-t-il reçu le Prix Nobel en 2012 ?",
      answers: ["pour le développement de réactions de couplage catalysées par le palladium en synthèse organique","pour des études sur les récepteurs couplés aux protéines G","pour ses études des processus chimiques sur les surfaces solides","pour la découverte des quasi-cristaux"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13375: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Brian K. Kobilka a-t-il reçu le Prix Nobel en 2012 ?",
      answers: ["Sciences Économiques","Physique","Physiologie ou Médecine","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13376: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Sir John B. Gurdon a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour la découverte que les cellules matures peuvent être reprogrammées pour devenir pluripotentes ?",
      answers: ["1997","1985","2010","2012"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13377: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2012 pour la découverte que les cellules matures peuvent être reprogrammées pour devenir pluripotentes ?",
      answers: ["Louis J. Ignarro","Shinya Yamanaka","Sir John B. Gurdon","Jeffrey C. Hall"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13378: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Sir John B. Gurdon a-t-il reçu le Prix Nobel en 2012 ?",
      answers: ["pour la découverte que les cellules matures peuvent être reprogrammées pour devenir pluripotentes","pour leur découverte du virus de l’immunodéficience humaine (VIH)","pour sa découverte des cellules dendritiques et de leur rôle dans l’immunité adaptative","pour leurs découvertes sur le système de transport vésiculaire dans les cellules"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13379: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Sir John B. Gurdon a-t-il reçu le Prix Nobel en 2012 ?",
      answers: ["Physiologie ou Médecine","Sciences Économiques","Physique","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13380: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Shinya Yamanaka a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour la découverte que les cellules matures peuvent être reprogrammées pour devenir pluripotentes ?",
      answers: ["2021","2012","2014","1918"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13381: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2012 pour la découverte que les cellules matures peuvent être reprogrammées pour devenir pluripotentes ?",
      answers: ["Shinya Yamanaka","Tu Youyou","Jack W. Szostak","Sir John B. Gurdon"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13382: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Shinya Yamanaka a-t-il reçu le Prix Nobel en 2012 ?",
      answers: ["pour sa découverte de l’efficacité élevée du DDT comme poison de contact contre plusieurs arthropodes","pour ses découvertes concernant la transmission des signaux dans le système nerveux","pour leurs découvertes sur les cellules qui constituent un système de positionnement dans le cerveau","pour la découverte que les cellules matures peuvent être reprogrammées pour devenir pluripotentes"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13383: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Shinya Yamanaka a-t-il reçu le Prix Nobel en 2012 ?",
      answers: ["Chimie","Littérature","Sciences Économiques","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13384: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Mo Yan a-t-il reçu le Prix Nobel de Littérature qui, avec un réalisme hallucinatoire, fusionne contes populaires, histoire et contemporain ?",
      answers: ["2012","2008","1965","2007"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13385: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 2012 qui, avec un réalisme hallucinatoire, fusionne contes populaires, histoire et contemporain ?",
      answers: ["Pablo Neruda","Annie Ernaux","Hermann Hesse","Mo Yan"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13386: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Mo Yan a-t-il reçu le Prix Nobel en 2012 ?",
      answers: ["pour avoir créé de nouvelles expressions poétiques dans la grande tradition de la chanson américaine","qui, dans d’innombrables déguisements, dépeint l’implication surprenante de l’étranger","qui, avec un réalisme hallucinatoire, fusionne contes populaires, histoire et contemporain","pour son œuvre qui, riche en idées et empreinte d’un esprit de liberté et de quête de vérité, a exercé une profonde influence sur notre époque"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13387: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Mo Yan a-t-il reçu le Prix Nobel en 2012 ?",
      answers: ["Littérature","Physique","Physiologie ou Médecine","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13388: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Union Européenne (UE) a-t-il reçu le Prix Nobel de Paix pour avoir contribué pendant plus de six décennies à la promotion de la paix, de la réconciliation, de la démocratie et des droits humains en Europe ?",
      answers: ["2012","1997","1937","2015"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13389: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2012 pour avoir contribué pendant plus de six décennies à la promotion de la paix, de la réconciliation, de la démocratie et des droits humains en Europe ?",
      answers: ["Memorial","Wangari Maathai","Union Européenne (UE)","Nadia Murad"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13390: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Union Européenne (UE) a-t-il reçu le Prix Nobel en 2012 ?",
      answers: ["pour leur lutte non violente pour la sécurité des femmes et pour les droits des femmes à participer pleinement aux processus de paix","pour ses efforts considérables visant à éliminer les armes chimiques","pour son travail de médiation en Palestine en 1948-1949","pour avoir contribué pendant plus de six décennies à la promotion de la paix, de la réconciliation, de la démocratie et des droits humains en Europe"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13391: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Union Européenne (UE) a-t-il reçu le Prix Nobel en 2012 ?",
      answers: ["Paix","Physiologie ou Médecine","Littérature","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13392: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Alvin E. Roth a-t-il reçu le Prix Nobel de Sciences Économiques pour la théorie des allocations stables et la pratique de la conception de marchés ?",
      answers: ["2006","2012","2019","2020"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13393: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2012 pour la théorie des allocations stables et la pratique de la conception de marchés ?",
      answers: ["Lloyd S. Shapley","Alvin E. Roth","Edmund S. Phelps","William D. Nordhaus"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13394: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Alvin E. Roth a-t-il reçu le Prix Nobel en 2012 ?",
      answers: ["pour avoir étendu l’analyse microéconomique à une large gamme de comportements humains et d’interactions","pour la théorie des allocations stables et la pratique de la conception de marchés","pour avoir posé les bases de la théorie de la conception des mécanismes","pour leur analyse des marchés avec des frictions de recherche"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13395: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Alvin E. Roth a-t-il reçu le Prix Nobel en 2012 ?",
      answers: ["Physiologie ou Médecine","Physique","Sciences Économiques","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13396: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Lloyd S. Shapley a-t-il reçu le Prix Nobel de Sciences Économiques pour la théorie des allocations stables et la pratique de la conception de marchés ?",
      answers: ["2015","2013","2012","2017"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13397: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2012 pour la théorie des allocations stables et la pratique de la conception de marchés ?",
      answers: ["Alvin E. Roth","Lloyd S. Shapley","Peter A. Diamond","Christopher A. Pissarides"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13398: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Lloyd S. Shapley a-t-il reçu le Prix Nobel en 2012 ?",
      answers: ["pour leur analyse empirique des prix des actifs","pour leurs contributions à la théorie des contrats","pour la théorie des allocations stables et la pratique de la conception de marchés","pour son analyse de la puissance du marché et de la régulation"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13399: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Lloyd S. Shapley a-t-il reçu le Prix Nobel en 2012 ?",
      answers: ["Sciences Économiques","Physiologie ou Médecine","Littérature","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13400: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année François Englert a-t-il reçu le Prix Nobel de Physique pour la découverte théorique d’un mécanisme contribuant à notre compréhension de l’origine de la masse des particules subatomiques ?",
      answers: ["1904","2013","1995","2011"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13401: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2013 pour la découverte théorique d’un mécanisme contribuant à notre compréhension de l’origine de la masse des particules subatomiques ?",
      answers: ["David J. Wineland","Isamu Akasaki","François Englert","Giorgio Parisi"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13402: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison François Englert a-t-il reçu le Prix Nobel en 2013 ?",
      answers: ["pour la découverte théorique d’un mécanisme contribuant à notre compréhension de l’origine de la masse des particules subatomiques","pour l’invention de diodes électroluminescentes bleues efficaces, permettant des sources de lumière blanche brillantes et économes en énergie","pour leur découverte de l’antiproton","pour sa contribution à l’invention du circuit intégré"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13403: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie François Englert a-t-il reçu le Prix Nobel en 2013 ?",
      answers: ["Physique","Physiologie ou Médecine","Sciences Économiques","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13404: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Peter W. Higgs a-t-il reçu le Prix Nobel de Physique pour la découverte théorique d’un mécanisme contribuant à notre compréhension de l’origine de la masse des particules subatomiques ?",
      answers: ["2006","1975","2013","2005"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13405: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2013 pour la découverte théorique d’un mécanisme contribuant à notre compréhension de l’origine de la masse des particules subatomiques ?",
      answers: ["Peter W. Higgs","George E. Smith","Philip W. Anderson","Brian P. Schmidt"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13406: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Peter W. Higgs a-t-il reçu le Prix Nobel en 2013 ?",
      answers: ["pour la découverte théorique d’un mécanisme contribuant à notre compréhension de l’origine de la masse des particules subatomiques","pour la découverte de l’expansion accelérée de l’univers par l’observation des supernovae lointaines","pour l’invention de diodes électroluminescentes bleues efficaces, permettant des sources de lumière blanche brillantes et économes en énergie","pour la découverte de l’expansion accélérée de l’univers par l’observation des supernovae lointaines"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13407: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Peter W. Higgs a-t-il reçu le Prix Nobel en 2013 ?",
      answers: ["Littérature","Sciences Économiques","Physique","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13408: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Martin Karplus a-t-il reçu le Prix Nobel de Chimie pour le développement de modèles multi-échelles pour les systèmes chimiques complexes ?",
      answers: ["1928","1989","2013","1963"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13409: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2013 pour le développement de modèles multi-échelles pour les systèmes chimiques complexes ?",
      answers: ["Martin Karplus","David Baker","Eduard Buchner","Michael Levitt"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13410: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Martin Karplus a-t-il reçu le Prix Nobel en 2013 ?",
      answers: ["pour l’évolution dirigée des enzymes","pour des études sur les récepteurs couplés aux protéines G","pour des études mécanistiques sur la réparation de l’ADN","pour le développement de modèles multi-échelles pour les systèmes chimiques complexes"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13411: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Martin Karplus a-t-il reçu le Prix Nobel en 2013 ?",
      answers: ["Sciences Économiques","Chimie","Paix","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13412: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Michael Levitt a-t-il reçu le Prix Nobel de Chimie pour le développement de modèles multi-échelles pour les systèmes chimiques complexes ?",
      answers: ["2004","1971","2013","1982"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13413: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2013 pour le développement de modèles multi-échelles pour les systèmes chimiques complexes ?",
      answers: ["Michael Levitt","William E. Moerner","Arieh Warshel","Thomas A. Steitz"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13414: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Michael Levitt a-t-il reçu le Prix Nobel en 2013 ?",
      answers: ["pour le développement de la cryo-microscopie électronique pour la détermination de la structure à haute résolution des biomolécules en solution","pour le développement de modèles multi-échelles pour les systèmes chimiques complexes","pour la découverte de la dégradation des protéines médiée par l’ubiquitine","pour la conception et la synthèse de machines moléculaires"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13415: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Michael Levitt a-t-il reçu le Prix Nobel en 2013 ?",
      answers: ["Paix","Physiologie ou Médecine","Physique","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13416: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Arieh Warshel a-t-il reçu le Prix Nobel de Chimie pour le développement de modèles multi-échelles pour les systèmes chimiques complexes ?",
      answers: ["2019","1994","2013","1961"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13417: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2013 pour le développement de modèles multi-échelles pour les systèmes chimiques complexes ?",
      answers: ["Martin Karplus","Theodor Svedberg","Arieh Warshel","Stefan W. Hell"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13418: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Arieh Warshel a-t-il reçu le Prix Nobel en 2013 ?",
      answers: ["pour la découverte et le développement de la protéine fluorescente verte (GFP)","pour la découverte des canaux d’eau dans les membranes cellulaires","pour la découverte de la dégradation des protéines médiée par l’ubiquitine","pour le développement de modèles multi-échelles pour les systèmes chimiques complexes"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13419: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Arieh Warshel a-t-il reçu le Prix Nobel en 2013 ?",
      answers: ["Paix","Littérature","Chimie","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13420: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année James E. Rothman a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes sur le système de transport vésiculaire dans les cellules ?",
      answers: ["1945","1988","2013","2005"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13421: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2013 pour leurs découvertes sur le système de transport vésiculaire dans les cellules ?",
      answers: ["May-Britt Moser","Eric F. Wieschaus","Michael Houghton","James E. Rothman"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13422: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison James E. Rothman a-t-il reçu le Prix Nobel en 2013 ?",
      answers: ["pour leurs découvertes sur le système de transport vésiculaire dans les cellules","pour ses découvertes sur les mécanismes de l’autophagie","pour leurs découvertes concernant l’activation de l’immunité innée","pour leur découverte du virus de l’immunodéficience humaine (VIH)"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13423: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie James E. Rothman a-t-il reçu le Prix Nobel en 2013 ?",
      answers: ["Physique","Sciences Économiques","Physiologie ou Médecine","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13424: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Randy W. Schekman a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes sur le système de transport vésiculaire dans les cellules ?",
      answers: ["1982","2008","2013","1974"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13425: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2013 pour leurs découvertes sur le système de transport vésiculaire dans les cellules ?",
      answers: ["Thomas C. Südhof","Randy W. Schekman","David Julius","Edmond H. Fischer"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13426: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Randy W. Schekman a-t-il reçu le Prix Nobel en 2013 ?",
      answers: ["pour leurs découvertes sur les principes de l’introduction de modifications génétiques spécifiques chez la souris par l’utilisation de cellules souches embryonnaires","pour la découverte que les cellules matures peuvent être reprogrammées pour devenir pluripotentes","pour leurs découvertes sur le système de transport vésiculaire dans les cellules","pour sa découverte des cellules dendritiques et de leur rôle dans l’immunité adaptative"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13427: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Randy W. Schekman a-t-il reçu le Prix Nobel en 2013 ?",
      answers: ["Littérature","Sciences Économiques","Physiologie ou Médecine","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13428: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Thomas C. Südhof a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes sur le système de transport vésiculaire dans les cellules ?",
      answers: ["2018","2001","2013","2012"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13429: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2013 pour leurs découvertes sur le système de transport vésiculaire dans les cellules ?",
      answers: ["Thomas C. Südhof","Corneille Heymans","Randy W. Schekman","Edvard I. Moser"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13430: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Thomas C. Südhof a-t-il reçu le Prix Nobel en 2013 ?",
      answers: ["pour sa découverte des cellules dendritiques et de leur rôle dans l’immunité adaptative","pour leurs découvertes concernant l’activation de l’immunité innée","pour leurs découvertes sur le système de transport vésiculaire dans les cellules","pour leurs découvertes de principes importants pour le traitement médicamenteux"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13431: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Thomas C. Südhof a-t-il reçu le Prix Nobel en 2013 ?",
      answers: ["Sciences Économiques","Physiologie ou Médecine","Physique","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13432: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Alice Munro a-t-il reçu le Prix Nobel de Littérature maîtresse de la nouvelle contemporaine ?",
      answers: ["2013","1948","1970","2011"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13433: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 2013 maîtresse de la nouvelle contemporaine ?",
      answers: ["Shmuel Yosef Agnon","Samuel Beckett","Alice Munro","Mo Yan"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13434: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Alice Munro a-t-il reçu le Prix Nobel en 2013 ?",
      answers: ["pour avoir créé de nouvelles expressions poétiques dans la grande tradition de la chanson américaine","auteur de nouveaux départs, d’aventures poétiques et d’extases sensuelles, explorateur d’une humanité au-delà et en deçà de la civilisation régnante","maîtresse de la nouvelle contemporaine","pour une imagination narrative qui, avec une passion encyclopédique, représente le franchissement des frontières comme une forme de vie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13435: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Alice Munro a-t-il reçu le Prix Nobel en 2013 ?",
      answers: ["Physique","Chimie","Physiologie ou Médecine","Littérature"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13436: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Organisation pour l’Interdiction des Armes Chimiques (OIAC) a-t-il reçu le Prix Nobel de Paix pour ses efforts considérables visant à éliminer les armes chimiques ?",
      answers: ["1945","2017","2013","1968"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13437: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2013 pour ses efforts considérables visant à éliminer les armes chimiques ?",
      answers: ["Lech Wałęsa","Organisation pour l’Interdiction des Armes Chimiques (OIAC)","Ellen Johnson Sirleaf","Union Européenne (UE)"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13438: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Organisation pour l’Interdiction des Armes Chimiques (OIAC) a-t-il reçu le Prix Nobel en 2013 ?",
      answers: ["pour sa contribution décisive à la construction d’une démocratie pluraliste en Tunisie après la Révolution du Jasmin de 2011","pour ses efforts visant à combattre la faim et à améliorer les conditions de paix dans les zones de conflit","pour ses efforts considérables visant à éliminer les armes chimiques","pour son travail humanitaire en faveur des réfugiés"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13439: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Organisation pour l’Interdiction des Armes Chimiques (OIAC) a-t-il reçu le Prix Nobel en 2013 ?",
      answers: ["Paix","Sciences Économiques","Physiologie ou Médecine","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13440: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Eugene F. Fama a-t-il reçu le Prix Nobel de Sciences Économiques pour leur analyse empirique des prix des actifs ?",
      answers: ["2015","1957","2013","1950"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13441: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2013 pour leur analyse empirique des prix des actifs ?",
      answers: ["Robert J. Shiller","Vernon L. Smith","Clive W. J. Granger","Eugene F. Fama"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13442: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Eugene F. Fama a-t-il reçu le Prix Nobel en 2013 ?",
      answers: ["pour la théorie des allocations stables et la pratique de la conception de marchés","pour leur analyse empirique des prix des actifs","pour leurs analyses pionnières des équilibres dans la théorie des jeux non coopératifs","pour ses recherches sur les banques et les crises financières"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13443: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Eugene F. Fama a-t-il reçu le Prix Nobel en 2013 ?",
      answers: ["Chimie","Sciences Économiques","Paix","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13444: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Lars Peter Hansen a-t-il reçu le Prix Nobel de Sciences Économiques pour leur analyse empirique des prix des actifs ?",
      answers: ["2011","1952","2013","1951"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13445: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2013 pour leur analyse empirique des prix des actifs ?",
      answers: ["Robert J. Aumann","Robert J. Shiller","Richard H. Thaler","Lars Peter Hansen"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13446: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Lars Peter Hansen a-t-il reçu le Prix Nobel en 2013 ?",
      answers: ["pour leur analyse empirique des prix des actifs","pour son analyse de la consommation, de la pauvreté et du bien-être","pour ses méthodes d’analyse des séries temporelles économiques avec volatilité variable","pour leur analyse des marchés avec des frictions de recherche"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13447: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Lars Peter Hansen a-t-il reçu le Prix Nobel en 2013 ?",
      answers: ["Paix","Sciences Économiques","Chimie","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13448: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Robert J. Shiller a-t-il reçu le Prix Nobel de Sciences Économiques pour leur analyse empirique des prix des actifs ?",
      answers: ["1914","2013","1952","1998"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13449: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2013 pour leur analyse empirique des prix des actifs ?",
      answers: ["Robert J. Shiller","Jean Tirole","John C. Harsanyi","Eugene F. Fama"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13450: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Robert J. Shiller a-t-il reçu le Prix Nobel en 2013 ?",
      answers: ["pour son analyse de la consommation, de la pauvreté et du bien-être","pour leur analyse empirique des prix des actifs","pour la théorie des allocations stables et la pratique de la conception de marchés","pour leurs analyses pionnières des équilibres dans la théorie des jeux non coopératifs"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13451: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Robert J. Shiller a-t-il reçu le Prix Nobel en 2013 ?",
      answers: ["Sciences Économiques","Physiologie ou Médecine","Littérature","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13452: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Isamu Akasaki a-t-il reçu le Prix Nobel de Physique pour l’invention de diodes électroluminescentes bleues efficaces, permettant des sources de lumière blanche brillantes et économes en énergie ?",
      answers: ["2014","2001","2018","2017"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13453: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2014 pour l’invention de diodes électroluminescentes bleues efficaces, permettant des sources de lumière blanche brillantes et économes en énergie ?",
      answers: ["Charles K. Kao","Peter W. Higgs","Albert Fert","Isamu Akasaki"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13454: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Isamu Akasaki a-t-il reçu le Prix Nobel en 2014 ?",
      answers: ["pour son invention et son développement de détecteurs de particules, notamment la chambre proportionnelle à fils multiples","pour la découverte des violations de principes fondamentaux de symétrie dans la désintégration des mésons K neutres","pour le développement de la spectroscopie neutronique","pour l’invention de diodes électroluminescentes bleues efficaces, permettant des sources de lumière blanche brillantes et économes en énergie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13455: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Isamu Akasaki a-t-il reçu le Prix Nobel en 2014 ?",
      answers: ["Paix","Sciences Économiques","Physiologie ou Médecine","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13456: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Hiroshi Amano a-t-il reçu le Prix Nobel de Physique pour l’invention de diodes électroluminescentes bleues efficaces, permettant des sources de lumière blanche brillantes et économes en énergie ?",
      answers: ["2005","2014","2013","2007"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13457: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2014 pour l’invention de diodes électroluminescentes bleues efficaces, permettant des sources de lumière blanche brillantes et économes en énergie ?",
      answers: ["Hiroshi Amano","Alain Aspect","Toshihide Maskawa","Subrahmanyan Chandrasekhar"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13458: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Hiroshi Amano a-t-il reçu le Prix Nobel en 2014 ?",
      answers: ["pour son travail fondamental sur l’optique électronique et la conception du premier microscope électronique","pour ses réalisations pionnières concernant la transmission de la lumière dans les fibres pour la communication optique","pour des découvertes théoriques sur les transitions de phase topologiques et les phases topologiques de la matière","pour l’invention de diodes électroluminescentes bleues efficaces, permettant des sources de lumière blanche brillantes et économes en énergie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13459: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Hiroshi Amano a-t-il reçu le Prix Nobel en 2014 ?",
      answers: ["Chimie","Paix","Physiologie ou Médecine","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13460: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Shuji Nakamura a-t-il reçu le Prix Nobel de Physique pour l’invention de diodes électroluminescentes bleues efficaces, permettant des sources de lumière blanche brillantes et économes en énergie ?",
      answers: ["2024","2014","2009","2008"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13461: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2014 pour l’invention de diodes électroluminescentes bleues efficaces, permettant des sources de lumière blanche brillantes et économes en énergie ?",
      answers: ["Shuji Nakamura","Isidor I. Rabi","Konstantin Novoselov","Adam G. Riess"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13462: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Shuji Nakamura a-t-il reçu le Prix Nobel en 2014 ?",
      answers: ["pour l’invention de diodes électroluminescentes bleues efficaces, permettant des sources de lumière blanche brillantes et économes en énergie","pour la découverte d’un objet compact supermassif au centre de notre galaxie","pour des découvertes théoriques sur les transitions de phase topologiques et les phases topologiques de la matière","pour la découverte théorique d’un mécanisme contribuant à notre compréhension de l’origine de la masse des particules subatomiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13463: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Shuji Nakamura a-t-il reçu le Prix Nobel en 2014 ?",
      answers: ["Sciences Économiques","Littérature","Physique","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13464: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Eric Betzig a-t-il reçu le Prix Nobel de Chimie pour le développement de la microscopie à fluorescence à super-résolution ?",
      answers: ["1970","2015","2006","2014"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13465: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2014 pour le développement de la microscopie à fluorescence à super-résolution ?",
      answers: ["Stefan W. Hell","Paul Modrich","Eric Betzig","Jacques Dubochet"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13466: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Eric Betzig a-t-il reçu le Prix Nobel en 2014 ?",
      answers: ["pour la conception et la synthèse de machines moléculaires","pour le développement de la microscopie à fluorescence à super-résolution","pour ses études des processus chimiques sur les surfaces solides","pour le développement de modèles multi-échelles pour les systèmes chimiques complexes"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13467: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Eric Betzig a-t-il reçu le Prix Nobel en 2014 ?",
      answers: ["Physique","Physiologie ou Médecine","Sciences Économiques","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13468: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Stefan W. Hell a-t-il reçu le Prix Nobel de Chimie pour le développement de la microscopie à fluorescence à super-résolution ?",
      answers: ["2013","1988","2014","2017"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13469: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2014 pour le développement de la microscopie à fluorescence à super-résolution ?",
      answers: ["Stefan W. Hell","David W.C. MacMillan","Demis Hassabis","Ada E. Yonath"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13470: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Stefan W. Hell a-t-il reçu le Prix Nobel en 2014 ?",
      answers: ["pour des études sur les récepteurs couplés aux protéines G","pour le développement de la cryo-microscopie électronique pour la détermination de la structure à haute résolution des biomolécules en solution","pour le développement de la microscopie à fluorescence à super-résolution","pour le développement de réactions de couplage catalysées par le palladium en synthèse organique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13471: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Stefan W. Hell a-t-il reçu le Prix Nobel en 2014 ?",
      answers: ["Chimie","Littérature","Physique","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13472: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année William E. Moerner a-t-il reçu le Prix Nobel de Chimie pour le développement de la microscopie à fluorescence à super-résolution ?",
      answers: ["2010","2013","2014","1996"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13473: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2014 pour le développement de la microscopie à fluorescence à super-résolution ?",
      answers: ["Tomas Lindahl","Eric Betzig","Demis Hassabis","William E. Moerner"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13474: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison William E. Moerner a-t-il reçu le Prix Nobel en 2014 ?",
      answers: ["pour des études sur la structure et la fonction du ribosome","pour leurs travaux sur la chimie de l’atmosphère, notamment concernant la formation et la décomposition de l’ozone","pour le développement de la microscopie à fluorescence à super-résolution","pour la prédiction de la structure des protéines"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13475: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie William E. Moerner a-t-il reçu le Prix Nobel en 2014 ?",
      answers: ["Littérature","Physiologie ou Médecine","Paix","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13476: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année John O’Keefe a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes sur les cellules qui constituent un système de positionnement dans le cerveau ?",
      answers: ["2014","2015","2012","2013"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13477: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2014 pour leurs découvertes sur les cellules qui constituent un système de positionnement dans le cerveau ?",
      answers: ["Shinya Yamanaka","John O’Keefe","François Jacob","James E. Rothman"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13478: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison John O’Keefe a-t-il reçu le Prix Nobel en 2014 ?",
      answers: ["pour leurs découvertes concernant une nouvelle thérapie contre les infections causées par des parasites","pour leurs découvertes sur les cellules qui constituent un système de positionnement dans le cerveau","pour leurs découvertes sur le système de transport vésiculaire dans les cellules","pour ses découvertes sur les récepteurs de la température et du toucher"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13479: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie John O’Keefe a-t-il reçu le Prix Nobel en 2014 ?",
      answers: ["Littérature","Physiologie ou Médecine","Chimie","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13480: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année May-Britt Moser a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes sur les cellules qui constituent un système de positionnement dans le cerveau ?",
      answers: ["2024","2014","2002","2016"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13481: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2014 pour leurs découvertes sur les cellules qui constituent un système de positionnement dans le cerveau ?",
      answers: ["Andrew V. Schally","Satoshi Ōmura","May-Britt Moser","Shinya Yamanaka"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13482: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison May-Britt Moser a-t-il reçu le Prix Nobel en 2014 ?",
      answers: ["pour ses découvertes concernant une nouvelle thérapie contre le paludisme","pour leurs découvertes sur le système de transport vésiculaire dans les cellules","pour ses découvertes sur les mécanismes de l’autophagie","pour leurs découvertes sur les cellules qui constituent un système de positionnement dans le cerveau"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13483: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie May-Britt Moser a-t-il reçu le Prix Nobel en 2014 ?",
      answers: ["Paix","Chimie","Physiologie ou Médecine","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13484: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Edvard I. Moser a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes sur les cellules qui constituent un système de positionnement dans le cerveau ?",
      answers: ["1988","2013","2002","2014"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13485: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2014 pour leurs découvertes sur les cellules qui constituent un système de positionnement dans le cerveau ?",
      answers: ["Joseph L. Goldstein","William C. Campbell","Edvard I. Moser","John O’Keefe"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13486: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Edvard I. Moser a-t-il reçu le Prix Nobel en 2014 ?",
      answers: ["pour ses découvertes concernant une nouvelle thérapie contre le paludisme","pour leurs découvertes concernant une nouvelle thérapie contre les infections causées par des parasites","pour leurs découvertes sur les cellules qui constituent un système de positionnement dans le cerveau","pour ses découvertes sur les récepteurs de la température et du toucher"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13487: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Edvard I. Moser a-t-il reçu le Prix Nobel en 2014 ?",
      answers: ["Physiologie ou Médecine","Littérature","Physique","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13488: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Patrick Modiano a-t-il reçu le Prix Nobel de Littérature pour l’art de la mémoire avec lequel il a évoqué les destinées humaines les plus insaisissables et dévoilé le monde de l’Occupation ?",
      answers: ["1999","1991","2014","2017"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13489: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 2014 pour l’art de la mémoire avec lequel il a évoqué les destinées humaines les plus insaisissables et dévoilé le monde de l’Occupation ?",
      answers: ["Mo Yan","Bob Dylan","Patrick Modiano","Kazuo Ishiguro"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13490: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Patrick Modiano a-t-il reçu le Prix Nobel en 2014 ?",
      answers: ["pour l’art de la mémoire avec lequel il a évoqué les destinées humaines les plus insaisissables et dévoilé le monde de l’Occupation","pour ses romans et nouvelles, dans lesquels le fantastique et le réaliste se combinent dans un monde richement composé d’imagination","pour son œuvre polyphonique, un monument à la souffrance et au courage de notre temps","pour une œuvre influente qui, avec une ingéniosité linguistique, a exploré la périphérie et la spécificité de l’expérience humaine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13491: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Patrick Modiano a-t-il reçu le Prix Nobel en 2014 ?",
      answers: ["Sciences Économiques","Littérature","Chimie","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13492: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Kailash Satyarthi a-t-il reçu le Prix Nobel de Paix pour leur lutte contre l’oppression des enfants et des jeunes et pour le droit de tous les enfants à l’éducation ?",
      answers: ["2011","2014","2018","2024"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13493: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2014 pour leur lutte contre l’oppression des enfants et des jeunes et pour le droit de tous les enfants à l’éducation ?",
      answers: ["Memorial","Kailash Satyarthi","Carlos Saavedra Lamas","Programme Alimentaire Mondial"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13494: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Kailash Satyarthi a-t-il reçu le Prix Nobel en 2014 ?",
      answers: ["pour leur lutte contre l’oppression des enfants et des jeunes et pour le droit de tous les enfants à l’éducation","en reconnaissance de leur travail humanitaire pionnier dans plusieurs continents","pour son travail pour la démocratie et les droits humains en Corée du Sud et en Asie de l’Est, et pour la paix avec la Corée du Nord","pour leurs efforts visant à sauvegarder la liberté d’expression, condition préalable à la démocratie et à une paix durable"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13495: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Kailash Satyarthi a-t-il reçu le Prix Nobel en 2014 ?",
      answers: ["Paix","Physiologie ou Médecine","Chimie","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13496: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Malala Yousafzai a-t-il reçu le Prix Nobel de Paix pour leur lutte contre l’oppression des enfants et des jeunes et pour le droit de tous les enfants à l’éducation ?",
      answers: ["2014","2023","2005","2022"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13497: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2014 pour leur lutte contre l’oppression des enfants et des jeunes et pour le droit de tous les enfants à l’éducation ?",
      answers: ["Gustav Stresemann","Kailash Satyarthi","Grameen Bank","Malala Yousafzai"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13498: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Malala Yousafzai a-t-il reçu le Prix Nobel en 2014 ?",
      answers: ["pour son rôle de leader dans la défense non violente des droits humains en Amérique latine","pour leur lutte contre l’oppression des enfants et des jeunes et pour le droit de tous les enfants à l’éducation","pour leurs efforts visant à mettre fin à l’utilisation de la violence sexuelle comme arme de guerre","pour sa contribution décisive à la construction d’une démocratie pluraliste en Tunisie après la Révolution du Jasmin de 2011"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13499: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Malala Yousafzai a-t-il reçu le Prix Nobel en 2014 ?",
      answers: ["Chimie","Physique","Littérature","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13500: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Jean Tirole a-t-il reçu le Prix Nobel de Sciences Économiques pour son analyse de la puissance du marché et de la régulation ?",
      answers: ["2014","2012","2013","1944"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13501: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2014 pour son analyse de la puissance du marché et de la régulation ?",
      answers: ["Bengt Holmström","Robert J. Shiller","Claudia Goldin","Jean Tirole"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13502: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Jean Tirole a-t-il reçu le Prix Nobel en 2014 ?",
      answers: ["pour leur analyse empirique des prix des actifs","pour avoir renouvelé la recherche en histoire économique en appliquant la théorie économique et les méthodes quantitatives","pour leur approche expérimentale visant à réduire la pauvreté dans le monde","pour son analyse de la puissance du marché et de la régulation"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13503: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Jean Tirole a-t-il reçu le Prix Nobel en 2014 ?",
      answers: ["Physiologie ou Médecine","Sciences Économiques","Physique","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13504: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Takaaki Kajita a-t-il reçu le Prix Nobel de Physique pour la découverte des oscillations des neutrinos, qui montre que les neutrinos ont une masse ?",
      answers: ["2000","2011","1984","2015"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13505: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2015 pour la découverte des oscillations des neutrinos, qui montre que les neutrinos ont une masse ?",
      answers: ["Barry C. Barish","Frederick Reines","Takaaki Kajita","Arthur B. McDonald"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13506: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Takaaki Kajita a-t-il reçu le Prix Nobel en 2015 ?",
      answers: ["pour leurs contributions au développement de la spectroscopie de précision basée sur le laser","pour leurs contributions fondamentales à l’électrodynamique quantique, avec des conséquences profondes pour la physique des particules élémentaires","pour la découverte des oscillations des neutrinos, qui montre que les neutrinos ont une masse","pour la découverte de la magnétorésistance géante"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13507: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Takaaki Kajita a-t-il reçu le Prix Nobel en 2015 ?",
      answers: ["Physiologie ou Médecine","Sciences Économiques","Littérature","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13508: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Arthur B. McDonald a-t-il reçu le Prix Nobel de Physique pour la découverte des oscillations des neutrinos, qui montre que les neutrinos ont une masse ?",
      answers: ["2015","1992","2014","2012"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13509: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2015 pour la découverte des oscillations des neutrinos, qui montre que les neutrinos ont une masse ?",
      answers: ["Georges Charpak","Arthur B. McDonald","Kip S. Thorne","Robert B. Laughlin"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13510: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Arthur B. McDonald a-t-il reçu le Prix Nobel en 2015 ?",
      answers: ["pour la découverte d’un objet compact supermassif au centre de notre galaxie","pour la découverte des oscillations des neutrinos, qui montre que les neutrinos ont une masse","pour des méthodes expérimentales générant des impulsions lumineuses extrêmement courtes permettant l’étude des dynamiques électroniques dans la matière","pour leur percée importante dans la découverte de la supraconductivité dans les matériaux céramiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13511: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Arthur B. McDonald a-t-il reçu le Prix Nobel en 2015 ?",
      answers: ["Physiologie ou Médecine","Physique","Paix","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13512: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Tomas Lindahl a-t-il reçu le Prix Nobel de Chimie pour des études mécanistiques sur la réparation de l’ADN ?",
      answers: ["2015","2018","2013","2023"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13513: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2015 pour des études mécanistiques sur la réparation de l’ADN ?",
      answers: ["M. Stanley Whittingham","William E. Moerner","Tomas Lindahl","Frances H. Arnold"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13514: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Tomas Lindahl a-t-il reçu le Prix Nobel en 2015 ?",
      answers: ["pour des études sur les récepteurs couplés aux protéines G","pour son travail sur les réactions d’oxydation catalysées de manière chirale","pour la conception et la synthèse de machines moléculaires","pour des études mécanistiques sur la réparation de l’ADN"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13515: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Tomas Lindahl a-t-il reçu le Prix Nobel en 2015 ?",
      answers: ["Physique","Chimie","Physiologie ou Médecine","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13516: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Paul Modrich a-t-il reçu le Prix Nobel de Chimie pour des études mécanistiques sur la réparation de l’ADN ?",
      answers: ["2017","2015","2006","2019"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13517: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2015 pour des études mécanistiques sur la réparation de l’ADN ?",
      answers: ["Sir J. Fraser Stoddart","Paul Modrich","Aziz Sancar","Michael Levitt"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13518: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Paul Modrich a-t-il reçu le Prix Nobel en 2015 ?",
      answers: ["pour la découverte de la dégradation des protéines médiée par l’ubiquitine","pour des études sur les récepteurs couplés aux protéines G","pour leur élucidation du mécanisme enzymatique sous-jacent à la synthèse de l’adénosine triphosphate (ATP)","pour des études mécanistiques sur la réparation de l’ADN"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13519: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Paul Modrich a-t-il reçu le Prix Nobel en 2015 ?",
      answers: ["Physique","Paix","Chimie","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13520: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Aziz Sancar a-t-il reçu le Prix Nobel de Chimie pour des études mécanistiques sur la réparation de l’ADN ?",
      answers: ["1970","2015","2016","2022"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13521: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2015 pour des études mécanistiques sur la réparation de l’ADN ?",
      answers: ["Louis E. Brus","Tomas Lindahl","Fritz Pregl","Aziz Sancar"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13522: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Aziz Sancar a-t-il reçu le Prix Nobel en 2015 ?",
      answers: ["pour le développement de la microscopie à fluorescence à super-résolution","pour leurs découvertes dans le domaine de la chimie et de la technologie des hauts polymères","pour des études mécanistiques sur la réparation de l’ADN","pour le développement de réactions de couplage catalysées par le palladium en synthèse organique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13523: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Aziz Sancar a-t-il reçu le Prix Nobel en 2015 ?",
      answers: ["Paix","Chimie","Physiologie ou Médecine","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13524: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année William C. Campbell a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant une nouvelle thérapie contre les infections causées par des parasites ?",
      answers: ["1972","2003","2008","2015"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13525: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2015 pour leurs découvertes concernant une nouvelle thérapie contre les infections causées par des parasites ?",
      answers: ["Ulf von Euler","William C. Campbell","Yoshinori Ohsumi","David Julius"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13526: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison William C. Campbell a-t-il reçu le Prix Nobel en 2015 ?",
      answers: ["pour la découverte que les protéines ont des signaux intrinsèques qui régissent leur transport et leur localisation dans la cellule","pour leurs découvertes sur le système de transport vésiculaire dans les cellules","pour leurs découvertes concernant une nouvelle thérapie contre les infections causées par des parasites","pour leurs découvertes sur les principes de l’introduction de modifications génétiques spécifiques chez la souris par l’utilisation de cellules souches embryonnaires"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13527: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie William C. Campbell a-t-il reçu le Prix Nobel en 2015 ?",
      answers: ["Physique","Physiologie ou Médecine","Littérature","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13528: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Satoshi Ōmura a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes concernant une nouvelle thérapie contre les infections causées par des parasites ?",
      answers: ["2008","2015","2014","2021"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13529: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2015 pour leurs découvertes concernant une nouvelle thérapie contre les infections causées par des parasites ?",
      answers: ["James P. Allison","Satoshi Ōmura","Katalin Karikó","Yoshinori Ohsumi"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13530: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Satoshi Ōmura a-t-il reçu le Prix Nobel en 2015 ?",
      answers: ["pour leurs découvertes concernant une nouvelle thérapie contre les infections causées par des parasites","pour leurs découvertes sur les cellules qui constituent un système de positionnement dans le cerveau","pour la découverte que les cellules matures peuvent être reprogrammées pour devenir pluripotentes","pour leurs découvertes de principes importants pour le traitement médicamenteux"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13531: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Satoshi Ōmura a-t-il reçu le Prix Nobel en 2015 ?",
      answers: ["Physique","Physiologie ou Médecine","Chimie","Littérature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13532: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Tu Youyou a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour ses découvertes concernant une nouvelle thérapie contre le paludisme ?",
      answers: ["1999","2006","2016","2015"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13533: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2015 pour ses découvertes concernant une nouvelle thérapie contre le paludisme ?",
      answers: ["Sir John B. Gurdon","May-Britt Moser","Tu Youyou","Satoshi Ōmura"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13534: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Tu Youyou a-t-il reçu le Prix Nobel en 2015 ?",
      answers: ["pour leurs découvertes sur les modifications des bases nucléosidiques qui ont permis le développement de vaccins à ARNm efficaces contre le COVID-19","pour leur découverte de la thérapie du cancer par inhibition de la régulation immunitaire négative","pour ses découvertes concernant une nouvelle thérapie contre le paludisme","pour leurs découvertes sur les cellules qui constituent un système de positionnement dans le cerveau"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13535: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Tu Youyou a-t-il reçu le Prix Nobel en 2015 ?",
      answers: ["Physique","Littérature","Physiologie ou Médecine","Paix"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13536: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Svetlana Alexievitch a-t-il reçu le Prix Nobel de Littérature pour son œuvre polyphonique, un monument à la souffrance et au courage de notre temps ?",
      answers: ["2014","2015","2018","1969"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13537: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 2015 pour son œuvre polyphonique, un monument à la souffrance et au courage de notre temps ?",
      answers: ["Patrick Modiano","Svetlana Alexievitch","Kazuo Ishiguro","Shmuel Yosef Agnon"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13538: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Svetlana Alexievitch a-t-il reçu le Prix Nobel en 2015 ?",
      answers: ["pour l’art de la mémoire avec lequel il a évoqué les destinées humaines les plus insaisissables et dévoilé le monde de l’Occupation","pour son œuvre polyphonique, un monument à la souffrance et au courage de notre temps","en reconnaissance de sa quête sérieuse de la vérité, de sa puissance pénétrante de pensée et de son style chaleureux et vivant","pour avoir créé de nouvelles expressions poétiques dans la grande tradition de la chanson américaine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13539: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Svetlana Alexievitch a-t-il reçu le Prix Nobel en 2015 ?",
      answers: ["Physiologie ou Médecine","Littérature","Physique","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13540: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Quartet du Dialogue National Tunisien a-t-il reçu le Prix Nobel de Paix pour sa contribution décisive à la construction d’une démocratie pluraliste en Tunisie après la Révolution du Jasmin de 2011 ?",
      answers: ["2015","2021","2016","2014"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13541: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2015 pour sa contribution décisive à la construction d’une démocratie pluraliste en Tunisie après la Révolution du Jasmin de 2011 ?",
      answers: ["Juan Manuel Santos","Quartet du Dialogue National Tunisien","Malala Yousafzai","Muhammad Yunus"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13542: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Quartet du Dialogue National Tunisien a-t-il reçu le Prix Nobel en 2015 ?",
      answers: ["pour ses décennies d’efforts inlassables pour trouver des solutions pacifiques aux conflits internationaux","pour sa lutte non violente pour la liberté syndicale et les droits des travailleurs en Pologne","pour sa contribution décisive à la construction d’une démocratie pluraliste en Tunisie après la Révolution du Jasmin de 2011","pour leurs efforts visant à mettre fin à l’utilisation de la violence sexuelle comme arme de guerre"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13543: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Quartet du Dialogue National Tunisien a-t-il reçu le Prix Nobel en 2015 ?",
      answers: ["Paix","Littérature","Chimie","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13544: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Angus Deaton a-t-il reçu le Prix Nobel de Sciences Économiques pour son analyse de la consommation, de la pauvreté et du bien-être ?",
      answers: ["2012","2015","2016","2018"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13545: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2015 pour son analyse de la consommation, de la pauvreté et du bien-être ?",
      answers: ["Elinor Ostrom","Myron S. Scholes","Angus Deaton","Oliver Hart"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13546: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Angus Deaton a-t-il reçu le Prix Nobel en 2015 ?",
      answers: ["pour la théorie des allocations stables et la pratique de la conception de marchés","pour son analyse de la gouvernance économique, notamment des limites des entreprises","pour ses études sur la manière dont les institutions sont formées et affectent la prospérité","pour son analyse de la consommation, de la pauvreté et du bien-être"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13547: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Angus Deaton a-t-il reçu le Prix Nobel en 2015 ?",
      answers: ["Sciences Économiques","Littérature","Chimie","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13548: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année David J. Thouless a-t-il reçu le Prix Nobel de Physique pour des découvertes théoriques sur les transitions de phase topologiques et les phases topologiques de la matière ?",
      answers: ["2016","1981","1993","2007"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13549: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2016 pour des découvertes théoriques sur les transitions de phase topologiques et les phases topologiques de la matière ?",
      answers: ["H. David Politzer","Peter W. Higgs","Hiroshi Amano","David J. Thouless"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13550: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison David J. Thouless a-t-il reçu le Prix Nobel en 2016 ?",
      answers: ["pour ses contributions à la théorie des réactions nucléaires, en particulier ses découvertes concernant la production d’énergie dans les étoiles","pour des découvertes théoriques sur les transitions de phase topologiques et les phases topologiques de la matière","pour ses contributions théoriques à notre compréhension de l’univers, notamment sur la cosmologie physique","pour ses découvertes et inventions fondamentales qui permettent l’apprentissage automatique avec des réseaux neuronaux artificiels"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13551: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie David J. Thouless a-t-il reçu le Prix Nobel en 2016 ?",
      answers: ["Physique","Paix","Chimie","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13552: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année F. Duncan M. Haldane a-t-il reçu le Prix Nobel de Physique pour des découvertes théoriques sur les transitions de phase topologiques et les phases topologiques de la matière ?",
      answers: ["2018","2016","2017","2020"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13553: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2016 pour des découvertes théoriques sur les transitions de phase topologiques et les phases topologiques de la matière ?",
      answers: ["F. Duncan M. Haldane","Donna Strickland","Reinhard Genzel","J. Michael Kosterlitz"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13554: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison F. Duncan M. Haldane a-t-il reçu le Prix Nobel en 2016 ?",
      answers: ["pour la découverte d’un objet compact supermassif au centre de notre galaxie","pour des découvertes théoriques sur les transitions de phase topologiques et les phases topologiques de la matière","pour ses découvertes et inventions fondamentales qui permettent l’apprentissage automatique avec des réseaux neuronaux artificiels","pour l’invention de diodes électroluminescentes bleues efficaces, permettant des sources de lumière blanche brillantes et économes en énergie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13555: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie F. Duncan M. Haldane a-t-il reçu le Prix Nobel en 2016 ?",
      answers: ["Physique","Physiologie ou Médecine","Chimie","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13556: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année J. Michael Kosterlitz a-t-il reçu le Prix Nobel de Physique pour des découvertes théoriques sur les transitions de phase topologiques et les phases topologiques de la matière ?",
      answers: ["2016","2013","1997","2011"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13557: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2016 pour des découvertes théoriques sur les transitions de phase topologiques et les phases topologiques de la matière ?",
      answers: ["Gérard Mourou","Martin Ryle","J. Michael Kosterlitz","David J. Thouless"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13558: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison J. Michael Kosterlitz a-t-il reçu le Prix Nobel en 2016 ?",
      answers: ["pour la modélisation physique du climat terrestre, la quantification de sa variabilité et la prédiction fiable du réchauffement climatique","pour des découvertes théoriques sur les transitions de phase topologiques et les phases topologiques de la matière","pour l’invention de diodes électroluminescentes bleues efficaces, permettant des sources de lumière blanche brillantes et économes en énergie","pour la découverte du mécanisme de la brisure spontanée de la symétrie en physique des particules"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13559: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie J. Michael Kosterlitz a-t-il reçu le Prix Nobel en 2016 ?",
      answers: ["Physique","Physiologie ou Médecine","Littérature","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13560: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Jean-Pierre Sauvage a-t-il reçu le Prix Nobel de Chimie pour la conception et la synthèse de machines moléculaires ?",
      answers: ["2014","1918","2002","2016"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13561: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2016 pour la conception et la synthèse de machines moléculaires ?",
      answers: ["George P. Smith","Jacques Dubochet","Bernard L. Feringa","Jean-Pierre Sauvage"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13562: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Jean-Pierre Sauvage a-t-il reçu le Prix Nobel en 2016 ?",
      answers: ["pour le développement de la microscopie à fluorescence à super-résolution","pour ses études sur les bases moléculaires de la transcription eucaryote","pour des études mécanistiques sur la réparation de l’ADN","pour la conception et la synthèse de machines moléculaires"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13563: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Jean-Pierre Sauvage a-t-il reçu le Prix Nobel en 2016 ?",
      answers: ["Paix","Chimie","Physique","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13564: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Sir J. Fraser Stoddart a-t-il reçu le Prix Nobel de Chimie pour la conception et la synthèse de machines moléculaires ?",
      answers: ["2009","2017","2016","1990"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13565: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2016 pour la conception et la synthèse de machines moléculaires ?",
      answers: ["Ronald G.W. Norrish","Michael Levitt","Sir J. Fraser Stoddart","Jean-Pierre Sauvage"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13566: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Sir J. Fraser Stoddart a-t-il reçu le Prix Nobel en 2016 ?",
      answers: ["pour la conception et la synthèse de machines moléculaires","pour le développement de la cryo-microscopie électronique pour la détermination de la structure à haute résolution des biomolécules en solution","pour son travail sur les hormones sexuelles","pour le développement de la catalyse organique asymétrique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13567: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Sir J. Fraser Stoddart a-t-il reçu le Prix Nobel en 2016 ?",
      answers: ["Physiologie ou Médecine","Sciences Économiques","Chimie","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13568: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Bernard L. Feringa a-t-il reçu le Prix Nobel de Chimie pour la conception et la synthèse de machines moléculaires ?",
      answers: ["2019","1978","2015","2016"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13569: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2016 pour la conception et la synthèse de machines moléculaires ?",
      answers: ["George P. Smith","Jean-Pierre Sauvage","Martin Karplus","Bernard L. Feringa"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13570: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Bernard L. Feringa a-t-il reçu le Prix Nobel en 2016 ?",
      answers: ["pour le développement de la cryo-microscopie électronique pour la détermination de la structure à haute résolution des biomolécules en solution","pour le développement de modèles multi-échelles pour les systèmes chimiques complexes","pour des études mécanistiques sur la réparation de l’ADN","pour la conception et la synthèse de machines moléculaires"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13571: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Bernard L. Feringa a-t-il reçu le Prix Nobel en 2016 ?",
      answers: ["Sciences Économiques","Physique","Littérature","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13572: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Yoshinori Ohsumi a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour ses découvertes sur les mécanismes de l’autophagie ?",
      answers: ["2016","1964","1984","2021"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13573: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2016 pour ses découvertes sur les mécanismes de l’autophagie ?",
      answers: ["Ralph M. Steinman","William C. Campbell","Yoshinori Ohsumi","May-Britt Moser"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13574: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Yoshinori Ohsumi a-t-il reçu le Prix Nobel en 2016 ?",
      answers: ["pour leurs découvertes concernant une nouvelle thérapie contre les infections causées par des parasites","pour leurs découvertes sur la régulation génétique du développement des organes et de la mort cellulaire programmée","pour ses découvertes sur les mécanismes de l’autophagie","pour leurs découvertes concernant l’imagerie par résonance magnétique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13575: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Yoshinori Ohsumi a-t-il reçu le Prix Nobel en 2016 ?",
      answers: ["Physiologie ou Médecine","Chimie","Littérature","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13576: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Bob Dylan a-t-il reçu le Prix Nobel de Littérature pour avoir créé de nouvelles expressions poétiques dans la grande tradition de la chanson américaine ?",
      answers: ["2015","2016","2013","2014"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13577: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 2016 pour avoir créé de nouvelles expressions poétiques dans la grande tradition de la chanson américaine ?",
      answers: ["Peter Handke","Eyvind Johnson","Bob Dylan","Svetlana Alexievitch"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13578: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Bob Dylan a-t-il reçu le Prix Nobel en 2016 ?",
      answers: ["pour une œuvre influente qui, avec une ingéniosité linguistique, a exploré la périphérie et la spécificité de l’expérience humaine","dont les contes burlesques et noirs dépeignent le visage oublié de l’histoire","qui, dans des romans d’une grande force émotionnelle, a révélé l’abîme sous notre illusion de connexion avec le monde","pour avoir créé de nouvelles expressions poétiques dans la grande tradition de la chanson américaine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13579: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Bob Dylan a-t-il reçu le Prix Nobel en 2016 ?",
      answers: ["Littérature","Physique","Physiologie ou Médecine","Sciences Économiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13580: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Juan Manuel Santos a-t-il reçu le Prix Nobel de Paix pour ses efforts résolus visant à mettre fin à plus de 50 ans de guerre civile dans son pays ?",
      answers: ["2017","2016","2015","2001"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13581: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2016 pour ses efforts résolus visant à mettre fin à plus de 50 ans de guerre civile dans son pays ?",
      answers: ["Nadia Murad","Juan Manuel Santos","Eisaku Satō","Anwar Sadat"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13582: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Juan Manuel Santos a-t-il reçu le Prix Nobel en 2016 ?",
      answers: ["pour ses efforts résolus visant à mettre fin à plus de 50 ans de guerre civile dans son pays","pour leur lutte non violente pour la sécurité des femmes et pour les droits des femmes à participer pleinement aux processus de paix","pour leur lutte contre l’oppression des enfants et des jeunes et pour le droit de tous les enfants à l’éducation","pour son rôle dans le plan Dawes visant à stabiliser l’économie allemande et à promouvoir la paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13583: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Juan Manuel Santos a-t-il reçu le Prix Nobel en 2016 ?",
      answers: ["Physiologie ou Médecine","Sciences Économiques","Physique","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13584: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Oliver Hart a-t-il reçu le Prix Nobel de Sciences Économiques pour leurs contributions à la théorie des contrats ?",
      answers: ["1924","2016","2015","2017"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13585: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2016 pour leurs contributions à la théorie des contrats ?",
      answers: ["Abhijit Banerjee","Bengt Holmström","Simon Johnson","Oliver Hart"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13586: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Oliver Hart a-t-il reçu le Prix Nobel en 2016 ?",
      answers: ["pour avoir intégré les innovations technologiques dans l’analyse macroéconomique à long terme","pour leurs contributions à la théorie des contrats","pour ses contributions à l’économie comportementale","pour son analyse de la théorie des marchés financiers et de leurs relations avec les décisions de dépenses, l’emploi, la production et les prix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13587: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Oliver Hart a-t-il reçu le Prix Nobel en 2016 ?",
      answers: ["Littérature","Sciences Économiques","Physiologie ou Médecine","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13588: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Bengt Holmström a-t-il reçu le Prix Nobel de Sciences Économiques pour leurs contributions à la théorie des contrats ?",
      answers: ["2016","2018","2021","1986"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13589: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2016 pour leurs contributions à la théorie des contrats ?",
      answers: ["Guido W. Imbens","Bengt Holmström","Eugene F. Fama","Richard H. Thaler"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13590: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Bengt Holmström a-t-il reçu le Prix Nobel en 2016 ?",
      answers: ["pour ses contributions fondamentales au développement des systèmes de comptabilité nationale","pour avoir intégré des perspectives psychologiques dans l’analyse économique, notamment sur le comportement humain sous incertitude","pour leurs contributions à la théorie des contrats","pour avoir intégré les innovations technologiques dans l’analyse macroéconomique à long terme"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13591: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Bengt Holmström a-t-il reçu le Prix Nobel en 2016 ?",
      answers: ["Sciences Économiques","Physique","Chimie","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13592: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Jacques Dubochet a-t-il reçu le Prix Nobel de Chimie pour le développement de la cryo-microscopie électronique pour la détermination de la structure à haute résolution des biomolécules en solution ?",
      answers: ["2024","1991","1986","2017"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13593: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2017 pour le développement de la cryo-microscopie électronique pour la détermination de la structure à haute résolution des biomolécules en solution ?",
      answers: ["Sir Gregory P. Winter","Michael Smith","Jacques Dubochet","George P. Smith"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13594: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Jacques Dubochet a-t-il reçu le Prix Nobel en 2017 ?",
      answers: ["pour des études sur la structure et la fonction du ribosome","pour le développement des batteries lithium-ion","pour des études mécanistiques sur la réparation de l’ADN","pour le développement de la cryo-microscopie électronique pour la détermination de la structure à haute résolution des biomolécules en solution"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13595: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Jacques Dubochet a-t-il reçu le Prix Nobel en 2017 ?",
      answers: ["Chimie","Physique","Sciences Économiques","Littérature"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13596: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Joachim Frank a-t-il reçu le Prix Nobel de Chimie pour le développement de la cryo-microscopie électronique pour la détermination de la structure à haute résolution des biomolécules en solution ?",
      answers: ["2017","1968","1916","2022"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13597: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2017 pour le développement de la cryo-microscopie électronique pour la détermination de la structure à haute résolution des biomolécules en solution ?",
      answers: ["Dan Shechtman","Joachim Frank","Eric Betzig","Aziz Sancar"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13598: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Joachim Frank a-t-il reçu le Prix Nobel en 2017 ?",
      answers: ["pour la conception et la synthèse de machines moléculaires","pour le développement de modèles multi-échelles pour les systèmes chimiques complexes","pour le développement de réactions de couplage catalysées par le palladium en synthèse organique","pour le développement de la cryo-microscopie électronique pour la détermination de la structure à haute résolution des biomolécules en solution"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13599: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Joachim Frank a-t-il reçu le Prix Nobel en 2017 ?",
      answers: ["Paix","Sciences Économiques","Littérature","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13600: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Richard Henderson a-t-il reçu le Prix Nobel de Chimie pour le développement de la cryo-microscopie électronique pour la détermination de la structure à haute résolution des biomolécules en solution ?",
      answers: ["2017","2016","1984","2002"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13601: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2017 pour le développement de la cryo-microscopie électronique pour la détermination de la structure à haute résolution des biomolécules en solution ?",
      answers: ["Joachim Frank","Carl Bosch","Richard Henderson","Ronald G.W. Norrish"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13602: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Richard Henderson a-t-il reçu le Prix Nobel en 2017 ?",
      answers: ["pour le développement de la méthode de métathèse en synthèse organique","pour le développement de la cryo-microscopie électronique pour la détermination de la structure à haute résolution des biomolécules en solution","pour la conception et la synthèse de machines moléculaires","pour la technique de phage display des peptides et des anticorps"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13603: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Richard Henderson a-t-il reçu le Prix Nobel en 2017 ?",
      answers: ["Physiologie ou Médecine","Physique","Chimie","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13604: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Rainer Weiss a-t-il reçu le Prix Nobel de Physique pour des contributions décisives à l’observatoire LIGO et à la détection des ondes gravitationnelles ?",
      answers: ["1974","2017","2015","2022"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13605: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2017 pour des contributions décisives à l’observatoire LIGO et à la détection des ondes gravitationnelles ?",
      answers: ["Kip S. Thorne","Shuji Nakamura","François Englert","Rainer Weiss"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13606: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Rainer Weiss a-t-il reçu le Prix Nobel en 2017 ?",
      answers: ["pour la découverte d’une exoplanète orbitant autour d’une étoile de type solaire","pour des contributions décisives à l’observatoire LIGO et à la détection des ondes gravitationnelles","pour l’invention des pinces optiques et leur application aux systèmes biologiques","pour la réalisation de la condensation de Bose-Einstein dans des gaz dilués d’atomes alcalins"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13607: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Rainer Weiss a-t-il reçu le Prix Nobel en 2017 ?",
      answers: ["Chimie","Littérature","Physiologie ou Médecine","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13608: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Barry C. Barish a-t-il reçu le Prix Nobel de Physique pour des contributions décisives à l’observatoire LIGO et à la détection des ondes gravitationnelles ?",
      answers: ["2002","1935","2017","2008"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13609: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2017 pour des contributions décisives à l’observatoire LIGO et à la détection des ondes gravitationnelles ?",
      answers: ["Saul Perlmutter","Barry C. Barish","Rainer Weiss","Michel Mayor"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13610: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Barry C. Barish a-t-il reçu le Prix Nobel en 2017 ?",
      answers: ["pour le développement de la technique de diffraction neutronique","pour la découverte d’un objet compact supermassif au centre de notre galaxie","pour des contributions décisives à l’observatoire LIGO et à la détection des ondes gravitationnelles","pour la découverte théorique d’un mécanisme contribuant à notre compréhension de l’origine de la masse des particules subatomiques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13611: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Barry C. Barish a-t-il reçu le Prix Nobel en 2017 ?",
      answers: ["Chimie","Physiologie ou Médecine","Paix","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13612: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Kip S. Thorne a-t-il reçu le Prix Nobel de Physique pour des contributions décisives à l’observatoire LIGO et à la détection des ondes gravitationnelles ?",
      answers: ["1949","1972","2020","2017"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13613: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2017 pour des contributions décisives à l’observatoire LIGO et à la détection des ondes gravitationnelles ?",
      answers: ["Carl E. Wieman","Kip S. Thorne","Didier Queloz","David J. Wineland"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13614: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Kip S. Thorne a-t-il reçu le Prix Nobel en 2017 ?",
      answers: ["pour l’invention et le développement du cyclotron et pour les résultats obtenus, en particulier en ce qui concerne les éléments radioactifs artificiels","pour la découverte d’une exoplanète orbitant autour d’une étoile de type solaire","pour des contributions décisives à l’observatoire LIGO et à la détection des ondes gravitationnelles","pour leurs investigations théoriques fondamentales sur la structure électronique des systèmes magnétiques et désordonnés"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13615: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Kip S. Thorne a-t-il reçu le Prix Nobel en 2017 ?",
      answers: ["Physiologie ou Médecine","Chimie","Sciences Économiques","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13616: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Jeffrey C. Hall a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes des mécanismes moléculaires contrôlant le rythme circadien ?",
      answers: ["2017","1971","2006","2023"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13617: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2017 pour leurs découvertes des mécanismes moléculaires contrôlant le rythme circadien ?",
      answers: ["Ardem Patapoutian","Gregg L. Semenza","Ferid Murad","Jeffrey C. Hall"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13618: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Jeffrey C. Hall a-t-il reçu le Prix Nobel en 2017 ?",
      answers: ["pour leurs découvertes des mécanismes moléculaires contrôlant le rythme circadien","pour leur découverte de la capacité du virus de la poliomyélite à se développer dans des cultures de divers types de tissus","pour le développement de la fécondation in vitro","pour leurs découvertes concernant le contrôle génétique du développement précoce de l’embryon"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13619: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Jeffrey C. Hall a-t-il reçu le Prix Nobel en 2017 ?",
      answers: ["Physiologie ou Médecine","Physique","Chimie","Littérature"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13620: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Michael Rosbash a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes des mécanismes moléculaires contrôlant le rythme circadien ?",
      answers: ["1935","1995","2017","2018"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13621: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2017 pour leurs découvertes des mécanismes moléculaires contrôlant le rythme circadien ?",
      answers: ["Michael Rosbash","Jules A. Hoffmann","John O’Keefe","Sir John B. Gurdon"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13622: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Michael Rosbash a-t-il reçu le Prix Nobel en 2017 ?",
      answers: ["pour ses découvertes sur les récepteurs de la température et du toucher","pour leurs découvertes des mécanismes moléculaires contrôlant le rythme circadien","pour leurs découvertes sur les récepteurs olfactifs et l’organisation du système olfactif","pour ses découvertes sur les mécanismes de l’autophagie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13623: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Michael Rosbash a-t-il reçu le Prix Nobel en 2017 ?",
      answers: ["Littérature","Physiologie ou Médecine","Chimie","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13624: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Michael W. Young a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes des mécanismes moléculaires contrôlant le rythme circadien ?",
      answers: ["2017","2018","2004","2016"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13625: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2017 pour leurs découvertes des mécanismes moléculaires contrôlant le rythme circadien ?",
      answers: ["Charles M. Rice","Michael W. Young","Christian de Duve","Hans A. Krebs"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13626: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Michael W. Young a-t-il reçu le Prix Nobel en 2017 ?",
      answers: ["pour leurs découvertes des mécanismes moléculaires contrôlant le rythme circadien","pour leurs découvertes sur les cellules qui constituent un système de positionnement dans le cerveau","pour ses découvertes sur les mécanismes de l’autophagie","pour leur découverte de la thérapie du cancer par inhibition de la régulation immunitaire négative"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13627: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Michael W. Young a-t-il reçu le Prix Nobel en 2017 ?",
      answers: ["Physique","Physiologie ou Médecine","Chimie","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13628: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Kazuo Ishiguro a-t-il reçu le Prix Nobel de Littérature qui, dans des romans d’une grande force émotionnelle, a révélé l’abîme sous notre illusion de connexion avec le monde ?",
      answers: ["2006","2020","2017","2021"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13629: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 2017 qui, dans des romans d’une grande force émotionnelle, a révélé l’abîme sous notre illusion de connexion avec le monde ?",
      answers: ["Kazuo Ishiguro","Alice Munro","Pablo Neruda","Patrick Modiano"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13630: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Kazuo Ishiguro a-t-il reçu le Prix Nobel en 2017 ?",
      answers: ["qui, dans des romans d’une grande force émotionnelle, a révélé l’abîme sous notre illusion de connexion avec le monde","pour avoir créé de nouvelles expressions poétiques dans la grande tradition de la chanson américaine","qui, avec un réalisme hallucinatoire, fusionne contes populaires, histoire et contemporain","cette épopée de l’expérience féminine qui, avec scepticisme, feu et une force visionnaire, a soumis une civilisation divisée à un examen"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13631: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Kazuo Ishiguro a-t-il reçu le Prix Nobel en 2017 ?",
      answers: ["Sciences Économiques","Paix","Chimie","Littérature"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13632: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Campagne Internationale pour l’Abolition des Armes Nucléaires (ICAN) a-t-il reçu le Prix Nobel de Paix pour son travail visant à attirer l’attention sur les conséquences humanitaires catastrophiques de l’utilisation des armes nucléaires ?",
      answers: ["2019","2016","2017","2021"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13633: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2017 pour son travail visant à attirer l’attention sur les conséquences humanitaires catastrophiques de l’utilisation des armes nucléaires ?",
      answers: ["Narges Mohammadi","Anwar Sadat","Campagne Internationale pour l’Abolition des Armes Nucléaires (ICAN)","Denis Mukwege"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13634: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Campagne Internationale pour l’Abolition des Armes Nucléaires (ICAN) a-t-il reçu le Prix Nobel en 2017 ?",
      answers: ["pour leurs contributions à la réconciliation franco-allemande et à la paix mondiale","pour son travail en renforçant les Nations Unies et en promouvant la paix mondiale","pour son travail visant à attirer l’attention sur les conséquences humanitaires catastrophiques de l’utilisation des armes nucléaires","pour ses efforts extraordinaires visant à renforcer la diplomatie internationale et la coopération entre les peuples"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13635: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Campagne Internationale pour l’Abolition des Armes Nucléaires (ICAN) a-t-il reçu le Prix Nobel en 2017 ?",
      answers: ["Chimie","Paix","Physique","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13636: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Richard H. Thaler a-t-il reçu le Prix Nobel de Sciences Économiques pour ses contributions à l’économie comportementale ?",
      answers: ["1906","2017","2012","2007"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13637: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2017 pour ses contributions à l’économie comportementale ?",
      answers: ["David Card","Richard H. Thaler","William D. Nordhaus","Angus Deaton"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13638: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Richard H. Thaler a-t-il reçu le Prix Nobel en 2017 ?",
      answers: ["pour ses contributions à l’économie comportementale","pour son analyse des modèles commerciaux et de la localisation de l’activité économique","pour leurs contributions à la théorie des contrats","pour avoir incorporé de nouvelles méthodes analytiques dans la théorie économique et pour sa reformulation rigoureuse de la théorie de l’équilibre général"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13639: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Richard H. Thaler a-t-il reçu le Prix Nobel en 2017 ?",
      answers: ["Physique","Paix","Littérature","Sciences Économiques"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13640: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Arthur Ashkin a-t-il reçu le Prix Nobel de Physique pour l’invention des pinces optiques et leur application aux systèmes biologiques ?",
      answers: ["1952","2018","1985","2019"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13641: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2018 pour l’invention des pinces optiques et leur application aux systèmes biologiques ?",
      answers: ["Arthur Ashkin","Kai M. Siegbahn","Andrea Ghez","Andre Geim"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13642: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Arthur Ashkin a-t-il reçu le Prix Nobel en 2018 ?",
      answers: ["pour l’invention des pinces optiques et leur application aux systèmes biologiques","pour leurs contributions à la théorie unifiée des interactions faible et électromagnétique entre particules élémentaires","pour l’invention d’un capteur d’imagerie à semi-conducteur – le capteur CCD","pour ses contributions théoriques à notre compréhension de l’univers, notamment sur la cosmologie physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13643: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Arthur Ashkin a-t-il reçu le Prix Nobel en 2018 ?",
      answers: ["Physique","Physiologie ou Médecine","Sciences Économiques","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13644: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Gérard Mourou a-t-il reçu le Prix Nobel de Physique pour leur méthode de génération d’impulsions optiques ultra-courtes et de haute intensité ?",
      answers: ["1987","1928","2015","2018"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13645: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2018 pour leur méthode de génération d’impulsions optiques ultra-courtes et de haute intensité ?",
      answers: ["Gérard Mourou","Charles K. Kao","Peter W. Higgs","Shuji Nakamura"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13646: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Gérard Mourou a-t-il reçu le Prix Nobel en 2018 ?",
      answers: ["pour leur méthode de génération d’impulsions optiques ultra-courtes et de haute intensité","pour leur contribution au développement de la spectroscopie laser","pour l’invention de diodes électroluminescentes bleues efficaces, permettant des sources de lumière blanche brillantes et économes en énergie","pour des contributions décisives à l’observatoire LIGO et à la détection des ondes gravitationnelles"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13647: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Gérard Mourou a-t-il reçu le Prix Nobel en 2018 ?",
      answers: ["Physiologie ou Médecine","Physique","Paix","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13648: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Donna Strickland a-t-il reçu le Prix Nobel de Physique pour leur méthode de génération d’impulsions optiques ultra-courtes et de haute intensité ?",
      answers: ["1981","2018","2019","2020"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13649: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2018 pour leur méthode de génération d’impulsions optiques ultra-courtes et de haute intensité ?",
      answers: ["Donna Strickland","Hiroshi Amano","John F. Clauser","Kip S. Thorne"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13650: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Donna Strickland a-t-il reçu le Prix Nobel en 2018 ?",
      answers: ["pour leur découverte de la superfluidité dans l’hélium-3","pour l’invention des pinces optiques et leur application aux systèmes biologiques","pour le développement de semi-conducteurs utilisés dans l’électronique à haute vitesse et l’optoélectronique","pour leur méthode de génération d’impulsions optiques ultra-courtes et de haute intensité"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13651: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Donna Strickland a-t-il reçu le Prix Nobel en 2018 ?",
      answers: ["Physiologie ou Médecine","Physique","Littérature","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13652: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Frances H. Arnold a-t-il reçu le Prix Nobel de Chimie pour l’évolution dirigée des enzymes ?",
      answers: ["2020","2018","1986","1993"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13653: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2018 pour l’évolution dirigée des enzymes ?",
      answers: ["Kary B. Mullis","Louis E. Brus","Morten Meldal","Frances H. Arnold"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13654: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Frances H. Arnold a-t-il reçu le Prix Nobel en 2018 ?",
      answers: ["pour l’évolution dirigée des enzymes","pour le développement de la méthode de métathèse en synthèse organique","pour leurs contributions au développement du concept de conformation et son application en chimie","pour son travail sur les réactions d’hydrogénation catalysées de manière chirale"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13655: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Frances H. Arnold a-t-il reçu le Prix Nobel en 2018 ?",
      answers: ["Physiologie ou Médecine","Littérature","Chimie","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13656: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année George P. Smith a-t-il reçu le Prix Nobel de Chimie pour la technique de phage display des peptides et des anticorps ?",
      answers: ["2019","2018","2014","1974"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13657: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2018 pour la technique de phage display des peptides et des anticorps ?",
      answers: ["George P. Smith","Alexey I. Ekimov","Kurt Wüthrich","David W.C. MacMillan"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13658: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison George P. Smith a-t-il reçu le Prix Nobel en 2018 ?",
      answers: ["pour la conception et la synthèse de machines moléculaires","pour des études mécanistiques sur la réparation de l’ADN","pour la technique de phage display des peptides et des anticorps","pour son travail sur les réactions d’hydrogénation catalysées de manière chirale"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13659: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie George P. Smith a-t-il reçu le Prix Nobel en 2018 ?",
      answers: ["Chimie","Sciences Économiques","Paix","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13660: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Sir Gregory P. Winter a-t-il reçu le Prix Nobel de Chimie pour la technique de phage display des peptides et des anticorps ?",
      answers: ["2018","2016","2023","1997"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13661: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2018 pour la technique de phage display des peptides et des anticorps ?",
      answers: ["Richard Henderson","Stefan W. Hell","Sir Gregory P. Winter","Bernard L. Feringa"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13662: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Sir Gregory P. Winter a-t-il reçu le Prix Nobel en 2018 ?",
      answers: ["pour le développement de la cryo-microscopie électronique pour la détermination de la structure à haute résolution des biomolécules en solution","pour l’évolution dirigée des enzymes","pour la technique de phage display des peptides et des anticorps","pour leur préparation d’enzymes et de protéines virales sous une forme pure"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13663: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Sir Gregory P. Winter a-t-il reçu le Prix Nobel en 2018 ?",
      answers: ["Paix","Chimie","Physiologie ou Médecine","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13664: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année James P. Allison a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leur découverte de la thérapie du cancer par inhibition de la régulation immunitaire négative ?",
      answers: ["2024","2019","2012","2018"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13665: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2018 pour leur découverte de la thérapie du cancer par inhibition de la régulation immunitaire négative ?",
      answers: ["James P. Allison","Françoise Barré-Sinoussi","Michael W. Young","Drew Weissman"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13666: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison James P. Allison a-t-il reçu le Prix Nobel en 2018 ?",
      answers: ["pour leurs découvertes concernant l’activation de l’immunité innée","pour leur découverte de la thérapie du cancer par inhibition de la régulation immunitaire négative","pour leurs découvertes sur le système de transport vésiculaire dans les cellules","pour la découverte du virus de l’hépatite C"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13667: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie James P. Allison a-t-il reçu le Prix Nobel en 2018 ?",
      answers: ["Physique","Chimie","Physiologie ou Médecine","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13668: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Tasuku Honjo a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leur découverte de la thérapie du cancer par inhibition de la régulation immunitaire négative ?",
      answers: ["2019","2018","2014","2022"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13669: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2018 pour leur découverte de la thérapie du cancer par inhibition de la régulation immunitaire négative ?",
      answers: ["William C. Campbell","Tasuku Honjo","Michael Houghton","William G. Kaelin Jr."],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13670: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Tasuku Honjo a-t-il reçu le Prix Nobel en 2018 ?",
      answers: ["pour leurs découvertes concernant les mécanismes ioniques impliqués dans l’excitation et l’inhibition dans les parties périphériques et centrales de la membrane des cellules nerveuses","pour leurs découvertes sur les modifications des bases nucléosidiques qui ont permis le développement de vaccins à ARNm efficaces contre le COVID-19","pour leurs découvertes sur les récepteurs olfactifs et l’organisation du système olfactif","pour leur découverte de la thérapie du cancer par inhibition de la régulation immunitaire négative"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13671: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Tasuku Honjo a-t-il reçu le Prix Nobel en 2018 ?",
      answers: ["Chimie","Physique","Sciences Économiques","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13672: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Olga Tokarczuk a-t-il reçu le Prix Nobel de Littérature pour une imagination narrative qui, avec une passion encyclopédique, représente le franchissement des frontières comme une forme de vie ?",
      answers: ["2015","1925","2018","1913"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13673: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 2018 pour une imagination narrative qui, avec une passion encyclopédique, représente le franchissement des frontières comme une forme de vie ?",
      answers: ["Olga Tokarczuk","Bob Dylan","Jon Fosse","Kazuo Ishiguro"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13674: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Olga Tokarczuk a-t-il reçu le Prix Nobel en 2018 ?",
      answers: ["qui, dans d’innombrables déguisements, dépeint l’implication surprenante de l’étranger","pour une imagination narrative qui, avec une passion encyclopédique, représente le franchissement des frontières comme une forme de vie","qui, avec un réalisme hallucinatoire, fusionne contes populaires, histoire et contemporain","pour avoir créé de nouvelles expressions poétiques dans la grande tradition de la chanson américaine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13675: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Olga Tokarczuk a-t-il reçu le Prix Nobel en 2018 ?",
      answers: ["Littérature","Physiologie ou Médecine","Physique","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13676: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Denis Mukwege a-t-il reçu le Prix Nobel de Paix pour leurs efforts visant à mettre fin à l’utilisation de la violence sexuelle comme arme de guerre ?",
      answers: ["2018","2005","1999","2017"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13677: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2018 pour leurs efforts visant à mettre fin à l’utilisation de la violence sexuelle comme arme de guerre ?",
      answers: ["Joseph Rotblat","Kim Dae-jung","Denis Mukwege","Nadia Murad"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13678: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Denis Mukwege a-t-il reçu le Prix Nobel en 2018 ?",
      answers: ["pour leurs efforts visant à mettre fin à l’utilisation de la violence sexuelle comme arme de guerre","pour leurs efforts visant à promouvoir les droits humains et la paix dans leurs pays respectifs","pour sa contribution au développement durable, à la démocratie et à la paix","pour ses efforts résolus visant à mettre fin à plus de 50 ans de guerre civile dans son pays"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13679: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Denis Mukwege a-t-il reçu le Prix Nobel en 2018 ?",
      answers: ["Chimie","Paix","Physiologie ou Médecine","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13680: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Nadia Murad a-t-il reçu le Prix Nobel de Paix pour leurs efforts visant à mettre fin à l’utilisation de la violence sexuelle comme arme de guerre ?",
      answers: ["2006","2018","2017","1969"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13681: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2018 pour leurs efforts visant à mettre fin à l’utilisation de la violence sexuelle comme arme de guerre ?",
      answers: ["Denis Mukwege","Dmitry Muratov","Juan Manuel Santos","Nadia Murad"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13682: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Nadia Murad a-t-il reçu le Prix Nobel en 2018 ?",
      answers: ["pour leurs efforts visant à promouvoir les droits humains et la paix dans leurs pays respectifs","pour leurs efforts visant à mettre fin à l’utilisation de la violence sexuelle comme arme de guerre","pour ses efforts en faveur de la démocratie et des droits humains, notamment pour les femmes et les enfants","pour son travail visant à promouvoir la justice sociale et les droits des travailleurs"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13683: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Nadia Murad a-t-il reçu le Prix Nobel en 2018 ?",
      answers: ["Paix","Littérature","Physiologie ou Médecine","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13684: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année William D. Nordhaus a-t-il reçu le Prix Nobel de Sciences Économiques pour avoir intégré le changement climatique dans l’analyse macroéconomique à long terme ?",
      answers: ["2018","2021","2017","1903"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13685: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2018 pour avoir intégré le changement climatique dans l’analyse macroéconomique à long terme ?",
      answers: ["William D. Nordhaus","Joshua D. Angrist","Claudia Goldin","Paul M. Romer"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13686: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison William D. Nordhaus a-t-il reçu le Prix Nobel en 2018 ?",
      answers: ["pour avoir intégré le changement climatique dans l’analyse macroéconomique à long terme","pour leur analyse empirique des prix des actifs","pour leurs contributions pionnières à la théorie de l’économie financière","pour avoir intégré les innovations technologiques dans l’analyse macroéconomique à long terme"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13687: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie William D. Nordhaus a-t-il reçu le Prix Nobel en 2018 ?",
      answers: ["Sciences Économiques","Paix","Chimie","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13688: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Paul M. Romer a-t-il reçu le Prix Nobel de Sciences Économiques pour avoir intégré les innovations technologiques dans l’analyse macroéconomique à long terme ?",
      answers: ["2017","2003","2013","2018"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13689: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2018 pour avoir intégré les innovations technologiques dans l’analyse macroéconomique à long terme ?",
      answers: ["Paul R. Milgrom","Paul M. Romer","Esther Duflo","Richard H. Thaler"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13690: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Paul M. Romer a-t-il reçu le Prix Nobel en 2018 ?",
      answers: ["pour avoir intégré le changement climatique dans l’analyse macroéconomique à long terme","pour leurs travaux empiriques sur la cause et l’effet en macroéconomie","pour avoir intégré les innovations technologiques dans l’analyse macroéconomique à long terme","pour leur approche expérimentale visant à réduire la pauvreté dans le monde"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13691: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Paul M. Romer a-t-il reçu le Prix Nobel en 2018 ?",
      answers: ["Sciences Économiques","Chimie","Physiologie ou Médecine","Littérature"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13692: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année James Peebles a-t-il reçu le Prix Nobel de Physique pour ses contributions théoriques à notre compréhension de l’univers, notamment sur la cosmologie physique ?",
      answers: ["1909","2002","2016","2019"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13693: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2019 pour ses contributions théoriques à notre compréhension de l’univers, notamment sur la cosmologie physique ?",
      answers: ["James Peebles","John C. Mather","Roger Penrose","John L. Hall"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13694: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison James Peebles a-t-il reçu le Prix Nobel en 2019 ?",
      answers: ["pour des contributions décisives à l’observatoire LIGO et à la détection des ondes gravitationnelles","pour des expériences révolutionnaires sur le matériau bidimensionnel graphène","pour la découverte d’une exoplanète orbitant autour d’une étoile de type solaire","pour ses contributions théoriques à notre compréhension de l’univers, notamment sur la cosmologie physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13695: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie James Peebles a-t-il reçu le Prix Nobel en 2019 ?",
      answers: ["Chimie","Physique","Littérature","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13696: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Michel Mayor a-t-il reçu le Prix Nobel de Physique pour la découverte d’une exoplanète orbitant autour d’une étoile de type solaire ?",
      answers: ["2019","1971","2024","1907"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13697: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2019 pour la découverte d’une exoplanète orbitant autour d’une étoile de type solaire ?",
      answers: ["Michel Mayor","Robert A. Millikan","Robert C. Richardson","Didier Queloz"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13698: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Michel Mayor a-t-il reçu le Prix Nobel en 2019 ?",
      answers: ["pour des méthodes expérimentales générant des impulsions lumineuses extrêmement courtes permettant l’étude des dynamiques électroniques dans la matière","pour l’invention de diodes électroluminescentes bleues efficaces, permettant des sources de lumière blanche brillantes et économes en énergie","pour la découverte d’une exoplanète orbitant autour d’une étoile de type solaire","pour ses contributions théoriques à notre compréhension de l’univers, notamment sur la cosmologie physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13699: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Michel Mayor a-t-il reçu le Prix Nobel en 2019 ?",
      answers: ["Physique","Littérature","Chimie","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13700: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Didier Queloz a-t-il reçu le Prix Nobel de Physique pour la découverte d’une exoplanète orbitant autour d’une étoile de type solaire ?",
      answers: ["2018","2021","1999","2019"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13701: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2019 pour la découverte d’une exoplanète orbitant autour d’une étoile de type solaire ?",
      answers: ["Didier Queloz","John C. Mather","Michel Mayor","Arthur Ashkin"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13702: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Didier Queloz a-t-il reçu le Prix Nobel en 2019 ?",
      answers: ["pour ses contributions théoriques à notre compréhension de l’univers, notamment sur la cosmologie physique","pour la découverte d’une exoplanète orbitant autour d’une étoile de type solaire","pour leur découverte de la forme du corps noir et de l’anisotropie du fond diffus cosmologique","pour leur percée importante dans la découverte de la supraconductivité dans les matériaux céramiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13703: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Didier Queloz a-t-il reçu le Prix Nobel en 2019 ?",
      answers: ["Physique","Chimie","Paix","Littérature"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13704: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année John B. Goodenough a-t-il reçu le Prix Nobel de Chimie pour le développement des batteries lithium-ion ?",
      answers: ["2016","2019","2017","2018"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13705: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2019 pour le développement des batteries lithium-ion ?",
      answers: ["John B. Goodenough","Walter Kohn","F. Sherwood Rowland","Joachim Frank"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13706: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison John B. Goodenough a-t-il reçu le Prix Nobel en 2019 ?",
      answers: ["pour la prédiction de la structure des protéines","pour le développement des batteries lithium-ion","pour le développement d’une méthode d’édition du génome","pour la technique de phage display des peptides et des anticorps"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13707: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie John B. Goodenough a-t-il reçu le Prix Nobel en 2019 ?",
      answers: ["Chimie","Physiologie ou Médecine","Paix","Sciences Économiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13708: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année M. Stanley Whittingham a-t-il reçu le Prix Nobel de Chimie pour le développement des batteries lithium-ion ?",
      answers: ["2022","2019","2014","1948"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13709: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2019 pour le développement des batteries lithium-ion ?",
      answers: ["Akira Yoshino","Roger Y. Tsien","John B. Fenn","M. Stanley Whittingham"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13710: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison M. Stanley Whittingham a-t-il reçu le Prix Nobel en 2019 ?",
      answers: ["pour le développement des batteries lithium-ion","pour le développement de la cryo-microscopie électronique pour la détermination de la structure à haute résolution des biomolécules en solution","pour le développement de la catalyse organique asymétrique","pour ses contributions fondamentales à l’établissement de la mutagenèse dirigée par oligonucléotides"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13711: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie M. Stanley Whittingham a-t-il reçu le Prix Nobel en 2019 ?",
      answers: ["Chimie","Paix","Littérature","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13712: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Akira Yoshino a-t-il reçu le Prix Nobel de Chimie pour le développement des batteries lithium-ion ?",
      answers: ["2022","1970","2019","2021"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13713: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2019 pour le développement des batteries lithium-ion ?",
      answers: ["John Jumper","Akira Yoshino","Herbert C. Brown","David W.C. MacMillan"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13714: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Akira Yoshino a-t-il reçu le Prix Nobel en 2019 ?",
      answers: ["pour la découverte et la synthèse des points quantiques","pour le développement des batteries lithium-ion","pour la détermination de la structure tridimensionnelle d’un centre réactionnel photosynthétique","pour l’évolution dirigée des enzymes"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13715: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Akira Yoshino a-t-il reçu le Prix Nobel en 2019 ?",
      answers: ["Physique","Paix","Littérature","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13716: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année William G. Kaelin Jr. a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour ses découvertes sur la manière dont les cellules détectent et s’adaptent à la disponibilité de l’oxygène ?",
      answers: ["2011","2019","2023","1903"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13717: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2019 pour ses découvertes sur la manière dont les cellules détectent et s’adaptent à la disponibilité de l’oxygène ?",
      answers: ["Jeffrey C. Hall","Tasuku Honjo","William G. Kaelin Jr.","Michael Rosbash"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13718: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison William G. Kaelin Jr. a-t-il reçu le Prix Nobel en 2019 ?",
      answers: ["pour sa découverte du principe génétique de la génération de la diversité des anticorps","pour la découverte du virus de l’hépatite C","pour ses découvertes sur la manière dont les cellules détectent et s’adaptent à la disponibilité de l’oxygène","pour ses découvertes sur les génomes des hominidés éteints et l’évolution humaine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13719: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie William G. Kaelin Jr. a-t-il reçu le Prix Nobel en 2019 ?",
      answers: ["Sciences Économiques","Chimie","Physiologie ou Médecine","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13720: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Sir Peter J. Ratcliffe a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour ses découvertes sur la manière dont les cellules détectent et s’adaptent à la disponibilité de l’oxygène ?",
      answers: ["2019","2017","2018","2021"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13721: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2019 pour ses découvertes sur la manière dont les cellules détectent et s’adaptent à la disponibilité de l’oxygène ?",
      answers: ["Sir Peter J. Ratcliffe","Tasuku Honjo","Edward L. Tatum","James P. Allison"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13722: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Sir Peter J. Ratcliffe a-t-il reçu le Prix Nobel en 2019 ?",
      answers: ["pour ses découvertes sur les récepteurs de la température et du toucher","pour ses découvertes sur les mécanismes de l’autophagie","pour la découverte du virus de l’hépatite C","pour ses découvertes sur la manière dont les cellules détectent et s’adaptent à la disponibilité de l’oxygène"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13723: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Sir Peter J. Ratcliffe a-t-il reçu le Prix Nobel en 2019 ?",
      answers: ["Physiologie ou Médecine","Chimie","Paix","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13724: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Gregg L. Semenza a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour ses découvertes sur la manière dont les cellules détectent et s’adaptent à la disponibilité de l’oxygène ?",
      answers: ["2019","1968","1904","2013"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13725: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2019 pour ses découvertes sur la manière dont les cellules détectent et s’adaptent à la disponibilité de l’oxygène ?",
      answers: ["William G. Kaelin Jr.","Tasuku Honjo","James E. Rothman","Gregg L. Semenza"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13726: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Gregg L. Semenza a-t-il reçu le Prix Nobel en 2019 ?",
      answers: ["pour leur découverte du virus de l’immunodéficience humaine (VIH)","pour leurs découvertes des mécanismes moléculaires contrôlant le rythme circadien","pour leur découverte de la thérapie du cancer par inhibition de la régulation immunitaire négative","pour ses découvertes sur la manière dont les cellules détectent et s’adaptent à la disponibilité de l’oxygène"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13727: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Gregg L. Semenza a-t-il reçu le Prix Nobel en 2019 ?",
      answers: ["Chimie","Physique","Paix","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13728: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Peter Handke a-t-il reçu le Prix Nobel de Littérature pour une œuvre influente qui, avec une ingéniosité linguistique, a exploré la périphérie et la spécificité de l’expérience humaine ?",
      answers: ["2003","2019","2020","1917"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13729: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 2019 pour une œuvre influente qui, avec une ingéniosité linguistique, a exploré la périphérie et la spécificité de l’expérience humaine ?",
      answers: ["Peter Handke","Alice Munro","Annie Ernaux","Olga Tokarczuk"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13730: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Peter Handke a-t-il reçu le Prix Nobel en 2019 ?",
      answers: ["pour une œuvre influente qui, avec une ingéniosité linguistique, a exploré la périphérie et la spécificité de l’expérience humaine","pour ses pièces de théâtre et sa prose innovantes qui donnent une voix à l’indicible","qui, avec la concentration de la poésie et la franchise de la prose, dépeint le paysage des dépossédés","pour sa pénétration sans compromis et empreinte de compassion des effets du colonialisme et du destin des réfugiés"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13731: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Peter Handke a-t-il reçu le Prix Nobel en 2019 ?",
      answers: ["Chimie","Physiologie ou Médecine","Paix","Littérature"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13732: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Abiy Ahmed Ali a-t-il reçu le Prix Nobel de Paix pour ses efforts visant à instaurer la paix et la coopération internationale, notamment pour son initiative décisive dans la résolution du conflit frontalier avec l’Érythrée ?",
      answers: ["1927","2019","2018","2016"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13733: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2019 pour ses efforts visant à instaurer la paix et la coopération internationale, notamment pour son initiative décisive dans la résolution du conflit frontalier avec l’Érythrée ?",
      answers: ["Desmond Tutu","Ales Bialiatski","Dmitry Muratov","Abiy Ahmed Ali"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13734: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Abiy Ahmed Ali a-t-il reçu le Prix Nobel en 2019 ?",
      answers: ["pour leur lutte non violente pour la sécurité des femmes et pour les droits des femmes à participer pleinement aux processus de paix","pour ses efforts résolus visant à mettre fin à plus de 50 ans de guerre civile dans son pays","pour ses efforts visant à instaurer la paix et la coopération internationale, notamment pour son initiative décisive dans la résolution du conflit frontalier avec l’Érythrée","pour leurs efforts visant à promouvoir les droits humains et la paix dans leurs pays respectifs"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13735: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Abiy Ahmed Ali a-t-il reçu le Prix Nobel en 2019 ?",
      answers: ["Littérature","Physiologie ou Médecine","Chimie","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13736: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Abhijit Banerjee a-t-il reçu le Prix Nobel de Sciences Économiques pour leur approche expérimentale visant à réduire la pauvreté dans le monde ?",
      answers: ["2016","2003","2019","2020"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13737: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2019 pour leur approche expérimentale visant à réduire la pauvreté dans le monde ?",
      answers: ["Esther Duflo","Richard H. Thaler","William D. Nordhaus","Abhijit Banerjee"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13738: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Abhijit Banerjee a-t-il reçu le Prix Nobel en 2019 ?",
      answers: ["pour son analyse de la consommation, de la pauvreté et du bien-être","pour leur approche expérimentale visant à réduire la pauvreté dans le monde","pour ses réalisations dans les domaines de l’analyse de la consommation, de l’histoire et de la théorie monétaire et pour sa démonstration de la complexité de la politique de stabilisation","pour leurs contributions à la théorie des contrats"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13739: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Abhijit Banerjee a-t-il reçu le Prix Nobel en 2019 ?",
      answers: ["Physique","Sciences Économiques","Chimie","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13740: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Esther Duflo a-t-il reçu le Prix Nobel de Sciences Économiques pour leur approche expérimentale visant à réduire la pauvreté dans le monde ?",
      answers: ["2019","1944","2021","2020"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13741: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2019 pour leur approche expérimentale visant à réduire la pauvreté dans le monde ?",
      answers: ["Elinor Ostrom","Esther Duflo","Michael Kremer","Eugene F. Fama"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13742: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Esther Duflo a-t-il reçu le Prix Nobel en 2019 ?",
      answers: ["pour ses méthodes d’analyse des séries temporelles économiques avec volatilité variable","pour ses contributions à l’économie comportementale","pour leur approche expérimentale visant à réduire la pauvreté dans le monde","pour leurs contributions à la théorie des contrats"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13743: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Esther Duflo a-t-il reçu le Prix Nobel en 2019 ?",
      answers: ["Littérature","Physiologie ou Médecine","Paix","Sciences Économiques"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13744: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Michael Kremer a-t-il reçu le Prix Nobel de Sciences Économiques pour leur approche expérimentale visant à réduire la pauvreté dans le monde ?",
      answers: ["2019","2018","2020","2015"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13745: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2019 pour leur approche expérimentale visant à réduire la pauvreté dans le monde ?",
      answers: ["Paul M. Romer","Abhijit Banerjee","Thomas C. Schelling","Michael Kremer"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13746: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Michael Kremer a-t-il reçu le Prix Nobel en 2019 ?",
      answers: ["pour ses améliorations à la théorie des enchères et ses inventions de nouveaux formats d’enchères","pour leur approche expérimentale visant à réduire la pauvreté dans le monde","pour ses études sur la manière dont les institutions sont formées et affectent la prospérité","pour leurs travaux empiriques sur la cause et l’effet en macroéconomie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13747: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Michael Kremer a-t-il reçu le Prix Nobel en 2019 ?",
      answers: ["Sciences Économiques","Paix","Physique","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13748: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Roger Penrose a-t-il reçu le Prix Nobel de Physique pour la découverte que la formation des trous noirs est une prédiction robuste de la théorie de la relativité générale ?",
      answers: ["2021","1955","1993","2020"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13749: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2020 pour la découverte que la formation des trous noirs est une prédiction robuste de la théorie de la relativité générale ?",
      answers: ["Syukuro Manabe","Sheldon Glashow","Roger Penrose","Hans G. Dehmelt"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13750: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Roger Penrose a-t-il reçu le Prix Nobel en 2020 ?",
      answers: ["pour la découverte que la formation des trous noirs est une prédiction robuste de la théorie de la relativité générale","pour avoir découvert que les méthodes développées pour étudier les phénomènes d’ordre dans les systèmes simples peuvent être généralisées à des formes plus complexes de la matière","pour la découverte d’un objet compact supermassif au centre de notre galaxie","pour la découverte théorique d’un mécanisme contribuant à notre compréhension de l’origine de la masse des particules subatomiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13751: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Roger Penrose a-t-il reçu le Prix Nobel en 2020 ?",
      answers: ["Littérature","Chimie","Physiologie ou Médecine","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13752: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Reinhard Genzel a-t-il reçu le Prix Nobel de Physique pour la découverte d’un objet compact supermassif au centre de notre galaxie ?",
      answers: ["2015","1949","2020","2004"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13753: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2020 pour la découverte d’un objet compact supermassif au centre de notre galaxie ?",
      answers: ["Konstantin Novoselov","Reinhard Genzel","Klaus Hasselmann","Roger Penrose"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13754: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Reinhard Genzel a-t-il reçu le Prix Nobel en 2020 ?",
      answers: ["pour la découverte de la liberté asymptotique dans la théorie de l’interaction forte","pour des expériences avec des photons intriqués, établissant la violation des inégalités de Bell et ouvrant la voie à la science de l’information quantique","pour la découverte d’un objet compact supermassif au centre de notre galaxie","pour des méthodes expérimentales générant des impulsions lumineuses extrêmement courtes permettant l’étude des dynamiques électroniques dans la matière"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13755: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Reinhard Genzel a-t-il reçu le Prix Nobel en 2020 ?",
      answers: ["Physique","Littérature","Paix","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13756: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Andrea Ghez a-t-il reçu le Prix Nobel de Physique pour la découverte d’un objet compact supermassif au centre de notre galaxie ?",
      answers: ["2003","2020","2019","1986"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13757: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2020 pour la découverte d’un objet compact supermassif au centre de notre galaxie ?",
      answers: ["Gérard Mourou","Peter W. Higgs","Andrea Ghez","Roger Penrose"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13758: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Andrea Ghez a-t-il reçu le Prix Nobel en 2020 ?",
      answers: ["pour des découvertes théoriques sur les transitions de phase topologiques et les phases topologiques de la matière","pour la découverte d’un objet compact supermassif au centre de notre galaxie","pour l’invention de diodes électroluminescentes bleues efficaces, permettant des sources de lumière blanche brillantes et économes en énergie","pour des méthodes expérimentales générant des impulsions lumineuses extrêmement courtes permettant l’étude des dynamiques électroniques dans la matière"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13759: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Andrea Ghez a-t-il reçu le Prix Nobel en 2020 ?",
      answers: ["Littérature","Physique","Paix","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13760: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Emmanuelle Charpentier a-t-il reçu le Prix Nobel de Chimie pour le développement d’une méthode d’édition du génome ?",
      answers: ["2021","2020","1960","2024"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13761: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2020 pour le développement d’une méthode d’édition du génome ?",
      answers: ["Richard Henderson","George P. Smith","Emmanuelle Charpentier","Carolyn R. Bertozzi"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13762: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Emmanuelle Charpentier a-t-il reçu le Prix Nobel en 2020 ?",
      answers: ["pour le développement d’une méthode d’édition du génome","pour le développement de la microscopie à fluorescence à super-résolution","pour son travail sur la ribonucléase, en particulier concernant la connexion entre la séquence d’acides aminés et la conformation biologiquement active","pour le développement de la catalyse organique asymétrique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13763: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Emmanuelle Charpentier a-t-il reçu le Prix Nobel en 2020 ?",
      answers: ["Chimie","Physique","Sciences Économiques","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13764: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Jennifer A. Doudna a-t-il reçu le Prix Nobel de Chimie pour le développement d’une méthode d’édition du génome ?",
      answers: ["1988","1990","2002","2020"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13765: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2020 pour le développement d’une méthode d’édition du génome ?",
      answers: ["Jennifer A. Doudna","Martin Chalfie","M. Stanley Whittingham","Paul Modrich"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13766: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Jennifer A. Doudna a-t-il reçu le Prix Nobel en 2020 ?",
      answers: ["pour le développement d’une méthode d’édition du génome","pour ses contributions exceptionnelles à l’art de la synthèse organique","pour la découverte et la synthèse des points quantiques","pour le développement de la catalyse organique asymétrique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13767: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Jennifer A. Doudna a-t-il reçu le Prix Nobel en 2020 ?",
      answers: ["Paix","Chimie","Physiologie ou Médecine","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13768: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Harvey J. Alter a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour la découverte du virus de l’hépatite C ?",
      answers: ["1969","2020","2019","2010"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13769: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2020 pour la découverte du virus de l’hépatite C ?",
      answers: ["Harvey J. Alter","Godfrey N. Hounsfield","Yoshinori Ohsumi","Michael Houghton"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13770: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Harvey J. Alter a-t-il reçu le Prix Nobel en 2020 ?",
      answers: ["pour la découverte du virus de l’hépatite C","pour leurs découvertes concernant la spécificité de la réponse immunitaire à médiation cellulaire","pour leurs découvertes de principes importants pour le traitement médicamenteux","pour leurs découvertes sur le système de transport vésiculaire dans les cellules"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13771: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Harvey J. Alter a-t-il reçu le Prix Nobel en 2020 ?",
      answers: ["Physique","Paix","Physiologie ou Médecine","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13772: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Michael Houghton a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour la découverte du virus de l’hépatite C ?",
      answers: ["2011","2021","1938","2020"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13773: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2020 pour la découverte du virus de l’hépatite C ?",
      answers: ["Charles M. Rice","Max Delbrück","Jeffrey C. Hall","Michael Houghton"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13774: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Michael Houghton a-t-il reçu le Prix Nobel en 2020 ?",
      answers: ["pour ses découvertes sur la manière dont les cellules détectent et s’adaptent à la disponibilité de l’oxygène","pour leur découverte de la thérapie du cancer par inhibition de la régulation immunitaire négative","pour la découverte que les cellules matures peuvent être reprogrammées pour devenir pluripotentes","pour la découverte du virus de l’hépatite C"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13775: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Michael Houghton a-t-il reçu le Prix Nobel en 2020 ?",
      answers: ["Physiologie ou Médecine","Paix","Sciences Économiques","Littérature"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13776: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Charles M. Rice a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour la découverte du virus de l’hépatite C ?",
      answers: ["2023","2020","2021","2007"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13777: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2020 pour la découverte du virus de l’hépatite C ?",
      answers: ["Shinya Yamanaka","Charles M. Rice","Gregg L. Semenza","David Julius"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13778: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Charles M. Rice a-t-il reçu le Prix Nobel en 2020 ?",
      answers: ["pour leurs découvertes sur les modifications des bases nucléosidiques qui ont permis le développement de vaccins à ARNm efficaces contre le COVID-19","pour leurs découvertes concernant une nouvelle thérapie contre les infections causées par des parasites","pour la découverte du virus de l’hépatite C","pour leurs découvertes sur les cellules qui constituent un système de positionnement dans le cerveau"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13779: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Charles M. Rice a-t-il reçu le Prix Nobel en 2020 ?",
      answers: ["Physiologie ou Médecine","Littérature","Physique","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13780: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Louise Glück a-t-il reçu le Prix Nobel de Littérature pour sa voix poétique inimitable qui, avec une beauté austère, rend l’existence individuelle universelle ?",
      answers: ["2023","2020","2019","2000"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13781: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 2020 pour sa voix poétique inimitable qui, avec une beauté austère, rend l’existence individuelle universelle ?",
      answers: ["Kazuo Ishiguro","Annie Ernaux","Patrick Modiano","Louise Glück"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13782: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Louise Glück a-t-il reçu le Prix Nobel en 2020 ?",
      answers: ["qui, dans des romans d’une grande force émotionnelle, a révélé l’abîme sous notre illusion de connexion avec le monde","qui, dans sa quête de l’âme mélancolique de sa ville natale, a découvert de nouveaux symboles pour le choc et l’entrelacement des cultures","pour le courage et l’acuité clinique avec lesquels elle dévoile les racines, les éloignements et les contraintes collectives de la mémoire personnelle","pour sa voix poétique inimitable qui, avec une beauté austère, rend l’existence individuelle universelle"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13783: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Louise Glück a-t-il reçu le Prix Nobel en 2020 ?",
      answers: ["Sciences Économiques","Littérature","Physique","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13784: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Programme Alimentaire Mondial a-t-il reçu le Prix Nobel de Paix pour ses efforts visant à combattre la faim et à améliorer les conditions de paix dans les zones de conflit ?",
      answers: ["1954","2021","2020","1997"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13785: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2020 pour ses efforts visant à combattre la faim et à améliorer les conditions de paix dans les zones de conflit ?",
      answers: ["Programme Alimentaire Mondial","Denis Mukwege","Centre pour les Libertés Civiles","Memorial"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13786: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Programme Alimentaire Mondial a-t-il reçu le Prix Nobel en 2020 ?",
      answers: ["pour son travail visant à promouvoir la justice sociale et les droits des travailleurs","pour leurs efforts visant à promouvoir les droits humains et la paix dans leurs pays respectifs","pour ses efforts visant à combattre la faim et à améliorer les conditions de paix dans les zones de conflit","pour leurs efforts visant à sauvegarder la liberté d’expression, condition préalable à la démocratie et à une paix durable"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13787: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Programme Alimentaire Mondial a-t-il reçu le Prix Nobel en 2020 ?",
      answers: ["Littérature","Physique","Physiologie ou Médecine","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13788: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Paul R. Milgrom a-t-il reçu le Prix Nobel de Sciences Économiques pour ses améliorations à la théorie des enchères et ses inventions de nouveaux formats d’enchères ?",
      answers: ["2020","2021","2019","2009"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13789: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2020 pour ses améliorations à la théorie des enchères et ses inventions de nouveaux formats d’enchères ?",
      answers: ["Paul R. Milgrom","Clive W. J. Granger","Claudia Goldin","William D. Nordhaus"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13790: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Paul R. Milgrom a-t-il reçu le Prix Nobel en 2020 ?",
      answers: ["pour avoir amélioré notre compréhension des résultats des femmes sur le marché du travail","pour leurs contributions à la théorie des contrats","pour son analyse de la puissance du marché et de la régulation","pour ses améliorations à la théorie des enchères et ses inventions de nouveaux formats d’enchères"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13791: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Paul R. Milgrom a-t-il reçu le Prix Nobel en 2020 ?",
      answers: ["Littérature","Sciences Économiques","Physiologie ou Médecine","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13792: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Robert B. Wilson a-t-il reçu le Prix Nobel de Sciences Économiques pour ses améliorations à la théorie des enchères et ses inventions de nouveaux formats d’enchères ?",
      answers: ["2020","1997","2021","2019"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13793: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2020 pour ses améliorations à la théorie des enchères et ses inventions de nouveaux formats d’enchères ?",
      answers: ["Abhijit Banerjee","Paul R. Milgrom","Robert B. Wilson","Robert J. Shiller"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13794: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Robert B. Wilson a-t-il reçu le Prix Nobel en 2020 ?",
      answers: ["pour ses études sur la manière dont les institutions sont formées et affectent la prospérité","pour avoir posé les bases de la théorie de la conception des mécanismes","pour ses améliorations à la théorie des enchères et ses inventions de nouveaux formats d’enchères","pour leurs contributions méthodologiques à l’analyse des relations causales"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13795: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Robert B. Wilson a-t-il reçu le Prix Nobel en 2020 ?",
      answers: ["Physiologie ou Médecine","Littérature","Sciences Économiques","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13796: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Syukuro Manabe a-t-il reçu le Prix Nobel de Physique pour la modélisation physique du climat terrestre, la quantification de sa variabilité et la prédiction fiable du réchauffement climatique ?",
      answers: ["2015","2024","1974","2021"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13797: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2021 pour la modélisation physique du climat terrestre, la quantification de sa variabilité et la prédiction fiable du réchauffement climatique ?",
      answers: ["Giorgio Parisi","Riccardo Giacconi","Syukuro Manabe","Albert Fert"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13798: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Syukuro Manabe a-t-il reçu le Prix Nobel en 2021 ?",
      answers: ["pour la découverte de l’interaction entre le désordre et les fluctuations dans les systèmes physiques, de l’échelle atomique à l’échelle planétaire","pour la découverte du mécanisme de la brisure spontanée de la symétrie en physique des particules","pour la modélisation physique du climat terrestre, la quantification de sa variabilité et la prédiction fiable du réchauffement climatique","pour des expériences avec des photons intriqués, établissant la violation des inégalités de Bell et ouvrant la voie à la science de l’information quantique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13799: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Syukuro Manabe a-t-il reçu le Prix Nobel en 2021 ?",
      answers: ["Physique","Sciences Économiques","Physiologie ou Médecine","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13800: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Klaus Hasselmann a-t-il reçu le Prix Nobel de Physique pour la modélisation physique du climat terrestre, la quantification de sa variabilité et la prédiction fiable du réchauffement climatique ?",
      answers: ["2022","2007","2021","2023"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13801: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2021 pour la modélisation physique du climat terrestre, la quantification de sa variabilité et la prédiction fiable du réchauffement climatique ?",
      answers: ["John F. Clauser","Klaus Hasselmann","Roy J. Glauber","James Peebles"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13802: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Klaus Hasselmann a-t-il reçu le Prix Nobel en 2021 ?",
      answers: ["pour la découverte d’un objet compact supermassif au centre de notre galaxie","pour leurs recherches pionnières sur la diffusion inélastique profonde des électrons sur les protons et les neutrons liés","pour la modélisation physique du climat terrestre, la quantification de sa variabilité et la prédiction fiable du réchauffement climatique","pour la découverte que la formation des trous noirs est une prédiction robuste de la théorie de la relativité générale"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13803: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Klaus Hasselmann a-t-il reçu le Prix Nobel en 2021 ?",
      answers: ["Paix","Chimie","Physique","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13804: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Giorgio Parisi a-t-il reçu le Prix Nobel de Physique pour la découverte de l’interaction entre le désordre et les fluctuations dans les systèmes physiques, de l’échelle atomique à l’échelle planétaire ?",
      answers: ["2021","1948","2019","2007"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13805: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2021 pour la découverte de l’interaction entre le désordre et les fluctuations dans les systèmes physiques, de l’échelle atomique à l’échelle planétaire ?",
      answers: ["Ferenc Krausz","Konstantin Novoselov","Giorgio Parisi","John Bardeen"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13806: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Giorgio Parisi a-t-il reçu le Prix Nobel en 2021 ?",
      answers: ["pour la découverte que la formation des trous noirs est une prédiction robuste de la théorie de la relativité générale","pour des expériences avec des photons intriqués, établissant la violation des inégalités de Bell et ouvrant la voie à la science de l’information quantique","pour la découverte de l’interaction entre le désordre et les fluctuations dans les systèmes physiques, de l’échelle atomique à l’échelle planétaire","pour des contributions décisives à l’observatoire LIGO et à la détection des ondes gravitationnelles"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13807: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Giorgio Parisi a-t-il reçu le Prix Nobel en 2021 ?",
      answers: ["Paix","Physiologie ou Médecine","Littérature","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13808: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Benjamin List a-t-il reçu le Prix Nobel de Chimie pour le développement de la catalyse organique asymétrique ?",
      answers: ["2021","2006","2016","2007"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13809: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2021 pour le développement de la catalyse organique asymétrique ?",
      answers: ["David W.C. MacMillan","Jennifer A. Doudna","Benjamin List","Bernard L. Feringa"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13810: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Benjamin List a-t-il reçu le Prix Nobel en 2021 ?",
      answers: ["pour le développement de la chimie bioorthogonale","pour la découverte et la synthèse des points quantiques","pour le développement de la catalyse organique asymétrique","pour le développement de la microscopie à fluorescence à super-résolution"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13811: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Benjamin List a-t-il reçu le Prix Nobel en 2021 ?",
      answers: ["Physiologie ou Médecine","Chimie","Paix","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13812: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année David W.C. MacMillan a-t-il reçu le Prix Nobel de Chimie pour le développement de la catalyse organique asymétrique ?",
      answers: ["2022","2014","1950","2021"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13813: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2021 pour le développement de la catalyse organique asymétrique ?",
      answers: ["John B. Fenn","Robert H. Grubbs","David W.C. MacMillan","Carolyn R. Bertozzi"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13814: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison David W.C. MacMillan a-t-il reçu le Prix Nobel en 2021 ?",
      answers: ["pour le développement de la chimie click","pour des études mécanistiques sur la réparation de l’ADN","pour sa découverte, au moyen de son spectromètre de masse, des isotopes dans un grand nombre d’éléments non radioactifs, et pour son énonciation de la règle des nombres entiers","pour le développement de la catalyse organique asymétrique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13815: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie David W.C. MacMillan a-t-il reçu le Prix Nobel en 2021 ?",
      answers: ["Paix","Physique","Littérature","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13816: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année David Julius a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour ses découvertes sur les récepteurs de la température et du toucher ?",
      answers: ["2016","2020","2021","2023"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13817: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2021 pour ses découvertes sur les récepteurs de la température et du toucher ?",
      answers: ["Sir Peter Mansfield","Ralph M. Steinman","David Julius","Karl von Frisch"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13818: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison David Julius a-t-il reçu le Prix Nobel en 2021 ?",
      answers: ["pour leur découverte du virus de l’immunodéficience humaine (VIH)","pour leurs découvertes de principes importants pour le traitement médicamenteux","pour ses découvertes sur les récepteurs de la température et du toucher","pour la découverte du virus de l’hépatite C"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13819: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie David Julius a-t-il reçu le Prix Nobel en 2021 ?",
      answers: ["Paix","Physiologie ou Médecine","Chimie","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13820: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Ardem Patapoutian a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour ses découvertes sur les récepteurs de la température et du toucher ?",
      answers: ["2022","2021","1925","2020"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13821: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2021 pour ses découvertes sur les récepteurs de la température et du toucher ?",
      answers: ["Ardem Patapoutian","Alan L. Hodgkin","Michael W. Young","James E. Rothman"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13822: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Ardem Patapoutian a-t-il reçu le Prix Nobel en 2021 ?",
      answers: ["pour ses découvertes sur les récepteurs de la température et du toucher","pour ses découvertes sur les mécanismes de l’autophagie","pour leurs découvertes sur les gènes discontinus","pour ses découvertes sur la manière dont les cellules détectent et s’adaptent à la disponibilité de l’oxygène"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13823: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Ardem Patapoutian a-t-il reçu le Prix Nobel en 2021 ?",
      answers: ["Sciences Économiques","Physique","Physiologie ou Médecine","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13824: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Abdulrazak Gurnah a-t-il reçu le Prix Nobel de Littérature pour sa pénétration sans compromis et empreinte de compassion des effets du colonialisme et du destin des réfugiés ?",
      answers: ["2000","2014","1991","2021"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13825: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 2021 pour sa pénétration sans compromis et empreinte de compassion des effets du colonialisme et du destin des réfugiés ?",
      answers: ["Vicente Aleixandre","Annie Ernaux","Olga Tokarczuk","Abdulrazak Gurnah"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13826: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Abdulrazak Gurnah a-t-il reçu le Prix Nobel en 2021 ?",
      answers: ["pour le courage et l’acuité clinique avec lesquels elle dévoile les racines, les éloignements et les contraintes collectives de la mémoire personnelle","pour sa pénétration sans compromis et empreinte de compassion des effets du colonialisme et du destin des réfugiés","pour une œuvre influente qui, avec une ingéniosité linguistique, a exploré la périphérie et la spécificité de l’expérience humaine","pour sa prose poétique intense qui confronte les traumatismes historiques et expose la fragilité de la vie humaine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13827: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Abdulrazak Gurnah a-t-il reçu le Prix Nobel en 2021 ?",
      answers: ["Sciences Économiques","Littérature","Physique","Paix"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13828: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Maria Ressa a-t-il reçu le Prix Nobel de Paix pour leurs efforts visant à sauvegarder la liberté d’expression, condition préalable à la démocratie et à une paix durable ?",
      answers: ["1996","2021","2020","1984"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13829: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2021 pour leurs efforts visant à sauvegarder la liberté d’expression, condition préalable à la démocratie et à une paix durable ?",
      answers: ["Denis Mukwege","Nihon Hidankyo","Maria Ressa","Shimon Peres"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13830: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Maria Ressa a-t-il reçu le Prix Nobel en 2021 ?",
      answers: ["pour leurs efforts visant à sauvegarder la liberté d’expression, condition préalable à la démocratie et à une paix durable","pour ses efforts visant à instaurer la paix et la coopération internationale, notamment pour son initiative décisive dans la résolution du conflit frontalier avec l’Érythrée","pour son combat contre l’oppression des femmes en Iran et sa lutte pour les droits humains et la liberté pour tous","pour leur lutte contre l’oppression des enfants et des jeunes et pour le droit de tous les enfants à l’éducation"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13831: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Maria Ressa a-t-il reçu le Prix Nobel en 2021 ?",
      answers: ["Physique","Chimie","Physiologie ou Médecine","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13832: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Dmitry Muratov a-t-il reçu le Prix Nobel de Paix pour leurs efforts visant à sauvegarder la liberté d’expression, condition préalable à la démocratie et à une paix durable ?",
      answers: ["2023","2011","2021","2009"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13833: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2021 pour leurs efforts visant à sauvegarder la liberté d’expression, condition préalable à la démocratie et à une paix durable ?",
      answers: ["Adolfo Pérez Esquivel","Denis Mukwege","Centre pour les Libertés Civiles","Dmitry Muratov"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13834: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Dmitry Muratov a-t-il reçu le Prix Nobel en 2021 ?",
      answers: ["pour ses efforts visant à combattre la faim et à améliorer les conditions de paix dans les zones de conflit","pour leurs efforts visant à sauvegarder la liberté d’expression, condition préalable à la démocratie et à une paix durable","pour leur travail en faveur du désarmement et de la paix mondiale","pour sa contribution décisive à la construction d’une démocratie pluraliste en Tunisie après la Révolution du Jasmin de 2011"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13835: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Dmitry Muratov a-t-il reçu le Prix Nobel en 2021 ?",
      answers: ["Physiologie ou Médecine","Paix","Chimie","Littérature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13836: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année David Card a-t-il reçu le Prix Nobel de Sciences Économiques pour ses contributions empiriques à l’économie du travail ?",
      answers: ["2021","2001","2016","2023"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13837: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2021 pour ses contributions empiriques à l’économie du travail ?",
      answers: ["Robert J. Aumann","Michael Kremer","David Card","Robert B. Wilson"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13838: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison David Card a-t-il reçu le Prix Nobel en 2021 ?",
      answers: ["pour son analyse de la consommation, de la pauvreté et du bien-être","pour ses contributions empiriques à l’économie du travail","pour leurs contributions méthodologiques à l’analyse des relations causales","pour sa découverte et sa clarification de la signification des coûts de transaction et des droits de propriété dans la structure économique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13839: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie David Card a-t-il reçu le Prix Nobel en 2021 ?",
      answers: ["Physique","Paix","Sciences Économiques","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13840: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Joshua D. Angrist a-t-il reçu le Prix Nobel de Sciences Économiques pour leurs contributions méthodologiques à l’analyse des relations causales ?",
      answers: ["2021","1909","1981","1995"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13841: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2021 pour leurs contributions méthodologiques à l’analyse des relations causales ?",
      answers: ["David Card","Ben S. Bernanke","Joshua D. Angrist","Guido W. Imbens"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13842: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Joshua D. Angrist a-t-il reçu le Prix Nobel en 2021 ?",
      answers: ["pour ses recherches sur les banques et les crises financières","pour leurs contributions méthodologiques à l’analyse des relations causales","pour leur approche expérimentale visant à réduire la pauvreté dans le monde","pour ses contributions empiriques à l’économie du travail"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13843: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Joshua D. Angrist a-t-il reçu le Prix Nobel en 2021 ?",
      answers: ["Sciences Économiques","Physiologie ou Médecine","Chimie","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13844: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Guido W. Imbens a-t-il reçu le Prix Nobel de Sciences Économiques pour leurs contributions méthodologiques à l’analyse des relations causales ?",
      answers: ["2017","1954","2022","2021"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13845: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2021 pour leurs contributions méthodologiques à l’analyse des relations causales ?",
      answers: ["Guido W. Imbens","Clive W. J. Granger","Ben S. Bernanke","Robert F. Engle"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13846: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Guido W. Imbens a-t-il reçu le Prix Nobel en 2021 ?",
      answers: ["pour ses contributions empiriques à l’économie du travail","pour leurs contributions méthodologiques à l’analyse des relations causales","pour ses améliorations à la théorie des enchères et ses inventions de nouveaux formats d’enchères","pour ses recherches sur les banques et les crises financières"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13847: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Guido W. Imbens a-t-il reçu le Prix Nobel en 2021 ?",
      answers: ["Sciences Économiques","Paix","Chimie","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13848: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Alain Aspect a-t-il reçu le Prix Nobel de Physique pour des expériences avec des photons intriqués, établissant la violation des inégalités de Bell et ouvrant la voie à la science de l’information quantique ?",
      answers: ["2022","1947","1993","2000"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13849: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2022 pour des expériences avec des photons intriqués, établissant la violation des inégalités de Bell et ouvrant la voie à la science de l’information quantique ?",
      answers: ["Aage N. Bohr","Anton Zeilinger","John F. Clauser","Alain Aspect"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13850: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Alain Aspect a-t-il reçu le Prix Nobel en 2022 ?",
      answers: ["pour ses découvertes et recherches dans le domaine de la spectroscopie des rayons X","pour le développement de la spectroscopie neutronique","pour des méthodes expérimentales révolutionnaires permettant la mesure et la manipulation des systèmes quantiques individuels","pour des expériences avec des photons intriqués, établissant la violation des inégalités de Bell et ouvrant la voie à la science de l’information quantique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13851: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Alain Aspect a-t-il reçu le Prix Nobel en 2022 ?",
      answers: ["Paix","Sciences Économiques","Physique","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13852: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année John F. Clauser a-t-il reçu le Prix Nobel de Physique pour des expériences avec des photons intriqués, établissant la violation des inégalités de Bell et ouvrant la voie à la science de l’information quantique ?",
      answers: ["2020","2018","2022","2016"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13853: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2022 pour des expériences avec des photons intriqués, établissant la violation des inégalités de Bell et ouvrant la voie à la science de l’information quantique ?",
      answers: ["Giorgio Parisi","Shuji Nakamura","Alain Aspect","John F. Clauser"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13854: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison John F. Clauser a-t-il reçu le Prix Nobel en 2022 ?",
      answers: ["pour la découverte de l’interaction entre le désordre et les fluctuations dans les systèmes physiques, de l’échelle atomique à l’échelle planétaire","pour la découverte que la formation des trous noirs est une prédiction robuste de la théorie de la relativité générale","pour la découverte d’un nouveau type de pulsar, une découverte qui a ouvert de nouvelles possibilités pour l’étude de la gravitation","pour des expériences avec des photons intriqués, établissant la violation des inégalités de Bell et ouvrant la voie à la science de l’information quantique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13855: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie John F. Clauser a-t-il reçu le Prix Nobel en 2022 ?",
      answers: ["Paix","Littérature","Physique","Chimie"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13856: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Anton Zeilinger a-t-il reçu le Prix Nobel de Physique pour des expériences avec des photons intriqués, établissant la violation des inégalités de Bell et ouvrant la voie à la science de l’information quantique ?",
      answers: ["1994","2023","2021","2022"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13857: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2022 pour des expériences avec des photons intriqués, établissant la violation des inégalités de Bell et ouvrant la voie à la science de l’information quantique ?",
      answers: ["Anton Zeilinger","John F. Clauser","Robert B. Laughlin","Andrea Ghez"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13858: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Anton Zeilinger a-t-il reçu le Prix Nobel en 2022 ?",
      answers: ["pour des expériences avec des photons intriqués, établissant la violation des inégalités de Bell et ouvrant la voie à la science de l’information quantique","pour sa contribution à la théorie quantique de la cohérence optique","pour leur méthode de génération d’impulsions optiques ultra-courtes et de haute intensité","pour l’invention d’un capteur d’imagerie à semi-conducteur – le capteur CCD"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13859: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Anton Zeilinger a-t-il reçu le Prix Nobel en 2022 ?",
      answers: ["Physique","Physiologie ou Médecine","Littérature","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13860: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Carolyn R. Bertozzi a-t-il reçu le Prix Nobel de Chimie pour le développement de la chimie bioorthogonale ?",
      answers: ["2023","2018","2021","2022"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13861: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2022 pour le développement de la chimie bioorthogonale ?",
      answers: ["Roger D. Kornberg","Carolyn R. Bertozzi","Alexey I. Ekimov","Moungi G. Bawendi"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13862: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Carolyn R. Bertozzi a-t-il reçu le Prix Nobel en 2022 ?",
      answers: ["pour le développement de la chimie bioorthogonale","pour le développement de la catalyse organique asymétrique","pour le développement de la réaction de cycloaddition alcyne-azide catalysée par le cuivre","pour leurs découvertes dans la chimie des éléments transuraniens"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13863: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Carolyn R. Bertozzi a-t-il reçu le Prix Nobel en 2022 ?",
      answers: ["Paix","Littérature","Sciences Économiques","Chimie"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13864: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Morten Meldal a-t-il reçu le Prix Nobel de Chimie pour le développement de la réaction de cycloaddition alcyne-azide catalysée par le cuivre ?",
      answers: ["2002","2009","2022","1945"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13865: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2022 pour le développement de la réaction de cycloaddition alcyne-azide catalysée par le cuivre ?",
      answers: ["Morten Meldal","Emmanuelle Charpentier","Svante A. Arrhenius","Benjamin List"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13866: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Morten Meldal a-t-il reçu le Prix Nobel en 2022 ?",
      answers: ["pour le développement de la catalyse organique asymétrique","pour le développement de la chimie bioorthogonale","pour le développement de la réaction de cycloaddition alcyne-azide catalysée par le cuivre","pour le développement de la méthode de métathèse en synthèse organique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13867: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Morten Meldal a-t-il reçu le Prix Nobel en 2022 ?",
      answers: ["Chimie","Physiologie ou Médecine","Sciences Économiques","Physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13868: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année K. Barry Sharpless a-t-il reçu le Prix Nobel de Chimie pour le développement de la chimie click ?",
      answers: ["1980","2022","1999","2023"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13869: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2022 pour le développement de la chimie click ?",
      answers: ["Akira Yoshino","K. Barry Sharpless","Carolyn R. Bertozzi","Bruce Merrifield"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13870: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison K. Barry Sharpless a-t-il reçu le Prix Nobel en 2022 ?",
      answers: ["pour la découverte et le développement des polymères conducteurs","pour l’évolution dirigée des enzymes","pour des études mécanistiques sur la réparation de l’ADN","pour le développement de la chimie click"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13871: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie K. Barry Sharpless a-t-il reçu le Prix Nobel en 2022 ?",
      answers: ["Physiologie ou Médecine","Chimie","Paix","Sciences Économiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13872: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Svante Pääbo a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour ses découvertes sur les génomes des hominidés éteints et l’évolution humaine ?",
      answers: ["2021","2006","2023","2022"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13873: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2022 pour ses découvertes sur les génomes des hominidés éteints et l’évolution humaine ?",
      answers: ["David Julius","Konrad Bloch","Hermann J. Muller","Svante Pääbo"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13874: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Svante Pääbo a-t-il reçu le Prix Nobel en 2022 ?",
      answers: ["pour la découverte du virus de l’hépatite C","pour ses découvertes concernant la spécialisation fonctionnelle des hémisphères cérébraux","pour ses découvertes sur les génomes des hominidés éteints et l’évolution humaine","pour la découverte des microARN, une nouvelle classe de petites molécules d’ARN qui jouent un rôle crucial dans la régulation génique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13875: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Svante Pääbo a-t-il reçu le Prix Nobel en 2022 ?",
      answers: ["Littérature","Physiologie ou Médecine","Paix","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13876: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Annie Ernaux a-t-il reçu le Prix Nobel de Littérature pour le courage et l’acuité clinique avec lesquels elle dévoile les racines, les éloignements et les contraintes collectives de la mémoire personnelle ?",
      answers: ["2023","2022","1997","1999"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13877: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 2022 pour le courage et l’acuité clinique avec lesquels elle dévoile les racines, les éloignements et les contraintes collectives de la mémoire personnelle ?",
      answers: ["Annie Ernaux","Bob Dylan","Abdulrazak Gurnah","Seamus Heaney"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13878: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Annie Ernaux a-t-il reçu le Prix Nobel en 2022 ?",
      answers: ["pour une œuvre qui défend la fragile expérience de l’individu contre l’arbitraire barbare de l’histoire","pour avoir uni une prose narrative perceptive à un regard incorruptible dans des œuvres qui nous obligent à voir la présence d’histoires supprimées","qui, avec un réalisme hallucinatoire, fusionne contes populaires, histoire et contemporain","pour le courage et l’acuité clinique avec lesquels elle dévoile les racines, les éloignements et les contraintes collectives de la mémoire personnelle"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13879: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Annie Ernaux a-t-il reçu le Prix Nobel en 2022 ?",
      answers: ["Littérature","Paix","Physique","Chimie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13880: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Ales Bialiatski a-t-il reçu le Prix Nobel de Paix pour leurs efforts visant à promouvoir les droits humains et la paix dans leurs pays respectifs ?",
      answers: ["2003","2021","2022","1998"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13881: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2022 pour leurs efforts visant à promouvoir les droits humains et la paix dans leurs pays respectifs ?",
      answers: ["Fredrik Bajer","Jimmy Carter","Centre pour les Libertés Civiles","Ales Bialiatski"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13882: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Ales Bialiatski a-t-il reçu le Prix Nobel en 2022 ?",
      answers: ["pour leurs efforts visant à mettre fin à l’utilisation de la violence sexuelle comme arme de guerre","pour leurs efforts visant à promouvoir les droits humains et la paix dans leurs pays respectifs","pour ses efforts visant à obtenir un monde sans armes nucléaires et pour avoir démontré par des témoignages que les armes nucléaires ne doivent plus jamais être utilisées","pour son combat contre l’oppression des femmes en Iran et sa lutte pour les droits humains et la liberté pour tous"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13883: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Ales Bialiatski a-t-il reçu le Prix Nobel en 2022 ?",
      answers: ["Physique","Paix","Sciences Économiques","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13884: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Memorial a-t-il reçu le Prix Nobel de Paix pour leurs efforts visant à promouvoir les droits humains et la paix dans leurs pays respectifs ?",
      answers: ["2019","2022","2014","2013"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13885: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2022 pour leurs efforts visant à promouvoir les droits humains et la paix dans leurs pays respectifs ?",
      answers: ["Memorial","Agence Internationale de l’Énergie Atomique (AIEA)","Narges Mohammadi","Liu Xiaobo"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13886: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Memorial a-t-il reçu le Prix Nobel en 2022 ?",
      answers: ["pour ses efforts considérables visant à éliminer les armes chimiques","pour ses efforts visant à instaurer la paix et la coopération internationale, notamment pour son initiative décisive dans la résolution du conflit frontalier avec l’Érythrée","pour leurs efforts visant à promouvoir les droits humains et la paix dans leurs pays respectifs","pour son combat contre l’oppression des femmes en Iran et sa lutte pour les droits humains et la liberté pour tous"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13887: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Memorial a-t-il reçu le Prix Nobel en 2022 ?",
      answers: ["Chimie","Littérature","Physique","Paix"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13888: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Centre pour les Libertés Civiles a-t-il reçu le Prix Nobel de Paix pour leurs efforts visant à promouvoir les droits humains et la paix dans leurs pays respectifs ?",
      answers: ["2021","2022","1976","2010"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13889: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2022 pour leurs efforts visant à promouvoir les droits humains et la paix dans leurs pays respectifs ?",
      answers: ["Ales Bialiatski","Memorial","Quartet du Dialogue National Tunisien","Centre pour les Libertés Civiles"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13890: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Centre pour les Libertés Civiles a-t-il reçu le Prix Nobel en 2022 ?",
      answers: ["pour leurs efforts visant à promouvoir les droits humains et la paix dans leurs pays respectifs","pour leur lutte contre l’oppression des enfants et des jeunes et pour le droit de tous les enfants à l’éducation","pour son message de paix, d’expiation et de dignité humaine en tant que témoin de l’Holocauste","pour leurs efforts visant à sauvegarder la liberté d’expression, condition préalable à la démocratie et à une paix durable"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13891: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Centre pour les Libertés Civiles a-t-il reçu le Prix Nobel en 2022 ?",
      answers: ["Paix","Chimie","Physiologie ou Médecine","Littérature"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13892: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Ben S. Bernanke a-t-il reçu le Prix Nobel de Sciences Économiques pour ses recherches sur les banques et les crises financières ?",
      answers: ["2018","1982","2014","2022"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13893: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2022 pour ses recherches sur les banques et les crises financières ?",
      answers: ["Guido W. Imbens","Finn E. Kydland","Ben S. Bernanke","Lars Peter Hansen"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13894: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Ben S. Bernanke a-t-il reçu le Prix Nobel en 2022 ?",
      answers: ["pour leurs contributions à la théorie des contrats","pour la théorie des allocations stables et la pratique de la conception de marchés","pour ses recherches sur les banques et les crises financières","pour ses études sur la manière dont les institutions sont formées et affectent la prospérité"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13895: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Ben S. Bernanke a-t-il reçu le Prix Nobel en 2022 ?",
      answers: ["Chimie","Physique","Sciences Économiques","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13896: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Douglas W. Diamond a-t-il reçu le Prix Nobel de Sciences Économiques pour ses recherches sur les banques et les crises financières ?",
      answers: ["2021","2022","2004","1986"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13897: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2022 pour ses recherches sur les banques et les crises financières ?",
      answers: ["David Card","Robert B. Wilson","Simon Johnson","Douglas W. Diamond"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13898: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Douglas W. Diamond a-t-il reçu le Prix Nobel en 2022 ?",
      answers: ["pour ses recherches sur les banques et les crises financières","pour avoir posé les bases de la théorie de la conception des mécanismes","pour leur approche expérimentale visant à réduire la pauvreté dans le monde","pour son analyse de la gouvernance économique, notamment des limites des entreprises"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13899: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Douglas W. Diamond a-t-il reçu le Prix Nobel en 2022 ?",
      answers: ["Physique","Sciences Économiques","Paix","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13900: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Philip H. Dybvig a-t-il reçu le Prix Nobel de Sciences Économiques pour ses recherches sur les banques et les crises financières ?",
      answers: ["2024","2022","2008","2018"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13901: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2022 pour ses recherches sur les banques et les crises financières ?",
      answers: ["Eugene F. Fama","Douglas W. Diamond","Philip H. Dybvig","James A. Robinson"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13902: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Philip H. Dybvig a-t-il reçu le Prix Nobel en 2022 ?",
      answers: ["pour leurs contributions à la macroéconomie dynamique","pour ses études sur la manière dont les institutions sont formées et affectent la prospérité","pour avoir amélioré notre compréhension des résultats des femmes sur le marché du travail","pour ses recherches sur les banques et les crises financières"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13903: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Philip H. Dybvig a-t-il reçu le Prix Nobel en 2022 ?",
      answers: ["Physique","Paix","Sciences Économiques","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13904: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Pierre Agostini a-t-il reçu le Prix Nobel de Physique pour des méthodes expérimentales générant des impulsions lumineuses extrêmement courtes permettant l’étude des dynamiques électroniques dans la matière ?",
      answers: ["2023","2024","1993","2022"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13905: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2023 pour des méthodes expérimentales générant des impulsions lumineuses extrêmement courtes permettant l’étude des dynamiques électroniques dans la matière ?",
      answers: ["Hannes Alfvén","Pierre Agostini","Gérard Mourou","Georges Charpak"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13906: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Pierre Agostini a-t-il reçu le Prix Nobel en 2023 ?",
      answers: ["pour ses découvertes et inventions fondamentales qui permettent l’apprentissage automatique avec des réseaux neuronaux artificiels","pour des méthodes expérimentales générant des impulsions lumineuses extrêmement courtes permettant l’étude des dynamiques électroniques dans la matière","pour le développement de la technique de diffraction neutronique","pour la découverte d’un nouveau type de pulsar, une découverte qui a ouvert de nouvelles possibilités pour l’étude de la gravitation"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13907: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Pierre Agostini a-t-il reçu le Prix Nobel en 2023 ?",
      answers: ["Physiologie ou Médecine","Physique","Chimie","Littérature"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13908: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Ferenc Krausz a-t-il reçu le Prix Nobel de Physique pour des méthodes expérimentales générant des impulsions lumineuses extrêmement courtes permettant l’étude des dynamiques électroniques dans la matière ?",
      answers: ["2021","2023","2002","2018"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13909: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2023 pour des méthodes expérimentales générant des impulsions lumineuses extrêmement courtes permettant l’étude des dynamiques électroniques dans la matière ?",
      answers: ["Carl E. Wieman","Anne L’Huillier","Ferenc Krausz","Charles Édouard Guillaume"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13910: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Ferenc Krausz a-t-il reçu le Prix Nobel en 2023 ?",
      answers: ["pour des méthodes expérimentales générant des impulsions lumineuses extrêmement courtes permettant l’étude des dynamiques électroniques dans la matière","pour leurs travaux pionniers dans la découverte d’une nouvelle particule élémentaire lourde","pour la découverte d’une exoplanète orbitant autour d’une étoile de type solaire","pour la modélisation physique du climat terrestre, la quantification de sa variabilité et la prédiction fiable du réchauffement climatique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13911: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Ferenc Krausz a-t-il reçu le Prix Nobel en 2023 ?",
      answers: ["Physiologie ou Médecine","Littérature","Sciences Économiques","Physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13912: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Anne L’Huillier a-t-il reçu le Prix Nobel de Physique pour des méthodes expérimentales générant des impulsions lumineuses extrêmement courtes permettant l’étude des dynamiques électroniques dans la matière ?",
      answers: ["2009","2017","2023","2021"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13913: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2023 pour des méthodes expérimentales générant des impulsions lumineuses extrêmement courtes permettant l’étude des dynamiques électroniques dans la matière ?",
      answers: ["Heinrich Rohrer","Anne L’Huillier","Walter H. Brattain","Pierre Agostini"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13914: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Anne L’Huillier a-t-il reçu le Prix Nobel en 2023 ?",
      answers: ["pour la découverte des oscillations des neutrinos, qui montre que les neutrinos ont une masse","pour des expériences avec des photons intriqués, établissant la violation des inégalités de Bell et ouvrant la voie à la science de l’information quantique","pour ses découvertes et inventions fondamentales qui permettent l’apprentissage automatique avec des réseaux neuronaux artificiels","pour des méthodes expérimentales générant des impulsions lumineuses extrêmement courtes permettant l’étude des dynamiques électroniques dans la matière"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13915: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Anne L’Huillier a-t-il reçu le Prix Nobel en 2023 ?",
      answers: ["Chimie","Sciences Économiques","Physique","Littérature"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13916: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Moungi G. Bawendi a-t-il reçu le Prix Nobel de Chimie pour la découverte et la synthèse des points quantiques ?",
      answers: ["2022","2018","2023","2021"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13917: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2023 pour la découverte et la synthèse des points quantiques ?",
      answers: ["Moungi G. Bawendi","John C. Kendrew","Carolyn R. Bertozzi","George P. Smith"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13918: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Moungi G. Bawendi a-t-il reçu le Prix Nobel en 2023 ?",
      answers: ["pour la découverte et la synthèse des points quantiques","pour des études mécanistiques sur la réparation de l’ADN","pour la découverte de la dégradation des protéines médiée par l’ubiquitine","pour ses recherches sur la stéréochimie des molécules organiques et des réactions"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13919: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Moungi G. Bawendi a-t-il reçu le Prix Nobel en 2023 ?",
      answers: ["Sciences Économiques","Chimie","Littérature","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13920: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Louis E. Brus a-t-il reçu le Prix Nobel de Chimie pour la découverte et la synthèse des points quantiques ?",
      answers: ["2023","2024","2022","1968"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13921: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2023 pour la découverte et la synthèse des points quantiques ?",
      answers: ["Christian B. Anfinsen","Louis E. Brus","John Jumper","Sir Gregory P. Winter"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13922: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Louis E. Brus a-t-il reçu le Prix Nobel en 2023 ?",
      answers: ["pour le développement de réactions de couplage catalysées par le palladium en synthèse organique","pour la conception computationnelle de protéines","pour la découverte et la synthèse des points quantiques","pour le développement de la chimie bioorthogonale"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13923: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Louis E. Brus a-t-il reçu le Prix Nobel en 2023 ?",
      answers: ["Sciences Économiques","Physiologie ou Médecine","Chimie","Physique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13924: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Alexey I. Ekimov a-t-il reçu le Prix Nobel de Chimie pour la découverte et la synthèse des points quantiques ?",
      answers: ["2024","2021","1997","2023"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13925: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2023 pour la découverte et la synthèse des points quantiques ?",
      answers: ["Alexey I. Ekimov","Richard Henderson","Arieh Warshel","David Baker"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13926: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Alexey I. Ekimov a-t-il reçu le Prix Nobel en 2023 ?",
      answers: ["pour leur découverte des propriétés catalytiques de l’ARN","pour le développement de la chimie bioorthogonale","pour leurs recherches sur la fermentation des sucres et les enzymes fermentatives","pour la découverte et la synthèse des points quantiques"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13927: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Alexey I. Ekimov a-t-il reçu le Prix Nobel en 2023 ?",
      answers: ["Littérature","Chimie","Physiologie ou Médecine","Physique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13928: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Katalin Karikó a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes sur les modifications des bases nucléosidiques qui ont permis le développement de vaccins à ARNm efficaces contre le COVID-19 ?",
      answers: ["1987","2024","2023","1952"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13929: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2023 pour leurs découvertes sur les modifications des bases nucléosidiques qui ont permis le développement de vaccins à ARNm efficaces contre le COVID-19 ?",
      answers: ["William G. Kaelin Jr.","Katalin Karikó","Jack W. Szostak","Tasuku Honjo"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13930: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Katalin Karikó a-t-il reçu le Prix Nobel en 2023 ?",
      answers: ["pour leurs découvertes concernant les transmetteurs humoraux dans les terminaisons nerveuses et le mécanisme de leur stockage, libération et inactivation","pour sa découverte des papillomavirus humains causant le cancer du col de l’utérus","pour la découverte des microARN, une nouvelle classe de petites molécules d’ARN qui jouent un rôle crucial dans la régulation génique","pour leurs découvertes sur les modifications des bases nucléosidiques qui ont permis le développement de vaccins à ARNm efficaces contre le COVID-19"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13931: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Katalin Karikó a-t-il reçu le Prix Nobel en 2023 ?",
      answers: ["Chimie","Paix","Sciences Économiques","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13932: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Drew Weissman a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour leurs découvertes sur les modifications des bases nucléosidiques qui ont permis le développement de vaccins à ARNm efficaces contre le COVID-19 ?",
      answers: ["2020","2023","2021","2022"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13933: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2023 pour leurs découvertes sur les modifications des bases nucléosidiques qui ont permis le développement de vaccins à ARNm efficaces contre le COVID-19 ?",
      answers: ["Harvey J. Alter","Johannes A.B. Fibiger","Drew Weissman","Max Delbrück"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13934: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Drew Weissman a-t-il reçu le Prix Nobel en 2023 ?",
      answers: ["pour sa découverte de la nature chimique de la vitamine K","pour leurs découvertes sur les modifications des bases nucléosidiques qui ont permis le développement de vaccins à ARNm efficaces contre le COVID-19","pour leurs découvertes sur le système de transport vésiculaire dans les cellules","pour la découverte des microARN, une nouvelle classe de petites molécules d’ARN qui jouent un rôle crucial dans la régulation génique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13935: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Drew Weissman a-t-il reçu le Prix Nobel en 2023 ?",
      answers: ["Paix","Physiologie ou Médecine","Physique","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13936: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Jon Fosse a-t-il reçu le Prix Nobel de Littérature pour ses pièces de théâtre et sa prose innovantes qui donnent une voix à l’indicible ?",
      answers: ["2013","2023","2024","2021"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13937: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 2023 pour ses pièces de théâtre et sa prose innovantes qui donnent une voix à l’indicible ?",
      answers: ["Han Kang","Abdulrazak Gurnah","Louise Glück","Jon Fosse"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13938: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Jon Fosse a-t-il reçu le Prix Nobel en 2023 ?",
      answers: ["pour son œuvre polyphonique, un monument à la souffrance et au courage de notre temps","qui, avec un réalisme hallucinatoire, fusionne contes populaires, histoire et contemporain","pour ses pièces de théâtre et sa prose innovantes qui donnent une voix à l’indicible","pour sa cartographie des structures du pouvoir et ses images tranchantes de la résistance, de la révolte et de la défaite de l’individu"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13939: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Jon Fosse a-t-il reçu le Prix Nobel en 2023 ?",
      answers: ["Physiologie ou Médecine","Physique","Littérature","Paix"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13940: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Narges Mohammadi a-t-il reçu le Prix Nobel de Paix pour son combat contre l’oppression des femmes en Iran et sa lutte pour les droits humains et la liberté pour tous ?",
      answers: ["1923","2003","2023","1921"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13941: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2023 pour son combat contre l’oppression des femmes en Iran et sa lutte pour les droits humains et la liberté pour tous ?",
      answers: ["Narges Mohammadi","Programme Alimentaire Mondial","Maria Ressa","Centre pour les Libertés Civiles"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13942: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Narges Mohammadi a-t-il reçu le Prix Nobel en 2023 ?",
      answers: ["pour son rôle dans la négociation de la paix dans la guerre russo-japonaise","pour son combat contre l’oppression des femmes en Iran et sa lutte pour les droits humains et la liberté pour tous","pour leurs efforts visant à sauvegarder la liberté d’expression, condition préalable à la démocratie et à une paix durable","pour leurs efforts visant à promouvoir les droits humains et la paix dans leurs pays respectifs"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13943: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Narges Mohammadi a-t-il reçu le Prix Nobel en 2023 ?",
      answers: ["Paix","Physique","Sciences Économiques","Littérature"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13944: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Claudia Goldin a-t-il reçu le Prix Nobel de Sciences Économiques pour avoir amélioré notre compréhension des résultats des femmes sur le marché du travail ?",
      answers: ["2022","2023","2015","2020"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13945: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2023 pour avoir amélioré notre compréhension des résultats des femmes sur le marché du travail ?",
      answers: ["Amartya Sen","Elinor Ostrom","Claudia Goldin","Ben S. Bernanke"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13946: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Claudia Goldin a-t-il reçu le Prix Nobel en 2023 ?",
      answers: ["pour ses recherches sur les banques et les crises financières","pour ses améliorations à la théorie des enchères et ses inventions de nouveaux formats d’enchères","pour leurs contributions à la théorie des contrats","pour avoir amélioré notre compréhension des résultats des femmes sur le marché du travail"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13947: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Claudia Goldin a-t-il reçu le Prix Nobel en 2023 ?",
      answers: ["Littérature","Physique","Physiologie ou Médecine","Sciences Économiques"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13948: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année John J. Hopfield a-t-il reçu le Prix Nobel de Physique pour ses découvertes et inventions fondamentales qui permettent l’apprentissage automatique avec des réseaux neuronaux artificiels ?",
      answers: ["2006","2021","2023","2024"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13949: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2024 pour ses découvertes et inventions fondamentales qui permettent l’apprentissage automatique avec des réseaux neuronaux artificiels ?",
      answers: ["John J. Hopfield","Michel Mayor","James Peebles","Anne L’Huillier"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13950: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison John J. Hopfield a-t-il reçu le Prix Nobel en 2024 ?",
      answers: ["pour des méthodes expérimentales générant des impulsions lumineuses extrêmement courtes permettant l’étude des dynamiques électroniques dans la matière","pour le développement de semi-conducteurs utilisés dans l’électronique à haute vitesse et l’optoélectronique","pour ses découvertes et inventions fondamentales qui permettent l’apprentissage automatique avec des réseaux neuronaux artificiels","pour des expériences avec des photons intriqués, établissant la violation des inégalités de Bell et ouvrant la voie à la science de l’information quantique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13951: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie John J. Hopfield a-t-il reçu le Prix Nobel en 2024 ?",
      answers: ["Physiologie ou Médecine","Littérature","Physique","Paix"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13952: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Geoffrey Hinton a-t-il reçu le Prix Nobel de Physique pour ses découvertes et inventions fondamentales qui permettent l’apprentissage automatique avec des réseaux neuronaux artificiels ?",
      answers: ["1998","2022","2024","1979"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13953: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physique en 2024 pour ses découvertes et inventions fondamentales qui permettent l’apprentissage automatique avec des réseaux neuronaux artificiels ?",
      answers: ["Reinhard Genzel","Geoffrey Hinton","Anne L’Huillier","John Bardeen"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13954: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Geoffrey Hinton a-t-il reçu le Prix Nobel en 2024 ?",
      answers: ["pour ses contributions fondamentales à la magnétohydrodynamique avec des applications fructueuses dans différents domaines de la physique des plasmas","pour sa démonstration de l’existence de nouveaux éléments radioactifs produits par irradiation neutronique et pour sa découverte connexe des réactions nucléaires provoquées par des neutrons lents","pour ses découvertes et inventions fondamentales qui permettent l’apprentissage automatique avec des réseaux neuronaux artificiels","pour des méthodes expérimentales générant des impulsions lumineuses extrêmement courtes permettant l’étude des dynamiques électroniques dans la matière"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13955: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Geoffrey Hinton a-t-il reçu le Prix Nobel en 2024 ?",
      answers: ["Littérature","Sciences Économiques","Physique","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13956: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année David Baker a-t-il reçu le Prix Nobel de Chimie pour la conception computationnelle de protéines ?",
      answers: ["2013","2024","1994","1979"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13957: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2024 pour la conception computationnelle de protéines ?",
      answers: ["Louis E. Brus","David Baker","Alexey I. Ekimov","Richard Henderson"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13958: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison David Baker a-t-il reçu le Prix Nobel en 2024 ?",
      answers: ["pour le développement de modèles multi-échelles pour les systèmes chimiques complexes","pour la découverte et la synthèse des points quantiques","pour la conception computationnelle de protéines","pour des études sur la structure et la fonction du ribosome"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13959: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie David Baker a-t-il reçu le Prix Nobel en 2024 ?",
      answers: ["Chimie","Physique","Littérature","Sciences Économiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13960: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Demis Hassabis a-t-il reçu le Prix Nobel de Chimie pour la prédiction de la structure des protéines ?",
      answers: ["2015","2024","2008","2023"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13961: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2024 pour la prédiction de la structure des protéines ?",
      answers: ["Louis E. Brus","John C. Kendrew","John Jumper","Demis Hassabis"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13962: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Demis Hassabis a-t-il reçu le Prix Nobel en 2024 ?",
      answers: ["pour la détermination de la structure tridimensionnelle d’un centre réactionnel photosynthétique","pour le développement de la chimie bioorthogonale","pour la prédiction de la structure des protéines","pour la conception et la synthèse de machines moléculaires"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13963: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Demis Hassabis a-t-il reçu le Prix Nobel en 2024 ?",
      answers: ["Physique","Chimie","Littérature","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13964: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année John Jumper a-t-il reçu le Prix Nobel de Chimie pour la prédiction de la structure des protéines ?",
      answers: ["1933","2003","2018","2024"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13965: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Chimie en 2024 pour la prédiction de la structure des protéines ?",
      answers: ["John Jumper","Moungi G. Bawendi","Ei-ichi Negishi","Alexey I. Ekimov"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13966: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison John Jumper a-t-il reçu le Prix Nobel en 2024 ?",
      answers: ["pour le développement de la spectroscopie par résonance magnétique nucléaire pour déterminer la structure tridimensionnelle des macromolécules biologiques","pour leur développement de l’utilisation des composés de bore et de phosphore, respectivement, dans la synthèse organique","pour la prédiction de la structure des protéines","pour la découverte et la synthèse des points quantiques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13967: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie John Jumper a-t-il reçu le Prix Nobel en 2024 ?",
      answers: ["Physique","Paix","Chimie","Physiologie ou Médecine"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13968: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Victor Ambros a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour la découverte des microARN, une nouvelle classe de petites molécules d’ARN qui jouent un rôle crucial dans la régulation génique ?",
      answers: ["2024","1982","2004","2003"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13969: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2024 pour la découverte des microARN, une nouvelle classe de petites molécules d’ARN qui jouent un rôle crucial dans la régulation génique ?",
      answers: ["Charles M. Rice","Michael Rosbash","Victor Ambros","Drew Weissman"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13970: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Victor Ambros a-t-il reçu le Prix Nobel en 2024 ?",
      answers: ["pour la découverte de l’insuline","pour la découverte du virus de l’hépatite C","pour ses découvertes sur la manière dont les cellules détectent et s’adaptent à la disponibilité de l’oxygène","pour la découverte des microARN, une nouvelle classe de petites molécules d’ARN qui jouent un rôle crucial dans la régulation génique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13971: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Victor Ambros a-t-il reçu le Prix Nobel en 2024 ?",
      answers: ["Physique","Littérature","Paix","Physiologie ou Médecine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13972: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Gary Ruvkun a-t-il reçu le Prix Nobel de Physiologie ou Médecine pour la découverte des microARN, une nouvelle classe de petites molécules d’ARN qui jouent un rôle crucial dans la régulation génique ?",
      answers: ["2015","2024","2022","2008"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13973: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Physiologie ou Médecine en 2024 pour la découverte des microARN, une nouvelle classe de petites molécules d’ARN qui jouent un rôle crucial dans la régulation génique ?",
      answers: ["Gary Ruvkun","Tasuku Honjo","J. Robin Warren","Katalin Karikó"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13974: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Gary Ruvkun a-t-il reçu le Prix Nobel en 2024 ?",
      answers: ["pour ses découvertes concernant les composés synthétiques qui inhibent l’action de certaines substances corporelles, notamment leur effet sur le système vasculaire et les muscles squelettiques","pour leur découverte du virus de l’immunodéficience humaine (VIH)","pour ses découvertes sur la manière dont les cellules détectent et s’adaptent à la disponibilité de l’oxygène","pour la découverte des microARN, une nouvelle classe de petites molécules d’ARN qui jouent un rôle crucial dans la régulation génique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13975: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Gary Ruvkun a-t-il reçu le Prix Nobel en 2024 ?",
      answers: ["Physiologie ou Médecine","Chimie","Littérature","Paix"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13976: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "En quelle année Han Kang a-t-il reçu le Prix Nobel de Littérature pour sa prose poétique intense qui confronte les traumatismes historiques et expose la fragilité de la vie humaine ?",
      answers: ["2024","2023","2018","2022"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13977: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Qui a reçu le Prix Nobel de Littérature en 2024 pour sa prose poétique intense qui confronte les traumatismes historiques et expose la fragilité de la vie humaine ?",
      answers: ["Han Kang","Elias Canetti","Olga Tokarczuk","Alice Munro"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13978: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Pour quelle raison Han Kang a-t-il reçu le Prix Nobel en 2024 ?",
      answers: ["pour le courage et l’acuité clinique avec lesquels elle dévoile les racines, les éloignements et les contraintes collectives de la mémoire personnelle","maîtresse de la nouvelle contemporaine","pour une prose riche et intense qui, avec une compassion contenue, forme une vision provocante de la vulnérabilité humaine","pour sa prose poétique intense qui confronte les traumatismes historiques et expose la fragilité de la vie humaine"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13979: {
      themes: ["Littérature","Littérature et Langues","Histoire","Prix Nobel"],
      question: "Dans quelle catégorie Han Kang a-t-il reçu le Prix Nobel en 2024 ?",
      answers: ["Physique","Sciences Économiques","Physiologie ou Médecine","Littérature"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13980: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "En quelle année Nihon Hidankyo a-t-il reçu le Prix Nobel de Paix pour ses efforts visant à obtenir un monde sans armes nucléaires et pour avoir démontré par des témoignages que les armes nucléaires ne doivent plus jamais être utilisées ?",
      answers: ["1984","2009","2024","2021"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13981: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Paix en 2024 pour ses efforts visant à obtenir un monde sans armes nucléaires et pour avoir démontré par des témoignages que les armes nucléaires ne doivent plus jamais être utilisées ?",
      answers: ["Wangari Maathai","Campagne Internationale pour l’Abolition des Armes Nucléaires (ICAN)","Nihon Hidankyo","Ales Bialiatski"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13982: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Nihon Hidankyo a-t-il reçu le Prix Nobel en 2024 ?",
      answers: ["pour leurs efforts visant à promouvoir les droits humains et la paix dans leurs pays respectifs","pour ses efforts visant à obtenir un monde sans armes nucléaires et pour avoir démontré par des témoignages que les armes nucléaires ne doivent plus jamais être utilisées","pour leur travail humanitaire et leurs efforts pour la paix","pour leur travail pour la fin pacifique du régime de l’apartheid et pour poser les bases d’une nouvelle Afrique du Sud démocratique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13983: {
      themes: ["Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Nihon Hidankyo a-t-il reçu le Prix Nobel en 2024 ?",
      answers: ["Littérature","Paix","Chimie","Physiologie ou Médecine"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13984: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Daron Acemoglu a-t-il reçu le Prix Nobel de Sciences Économiques pour ses études sur la manière dont les institutions sont formées et affectent la prospérité ?",
      answers: ["2024","2019","1911","2015"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13985: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2024 pour ses études sur la manière dont les institutions sont formées et affectent la prospérité ?",
      answers: ["Ben S. Bernanke","Simon Johnson","Daron Acemoglu","Robert A. Mundell"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13986: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Daron Acemoglu a-t-il reçu le Prix Nobel en 2024 ?",
      answers: ["pour ses études sur la manière dont les institutions sont formées et affectent la prospérité","pour leur approche expérimentale visant à réduire la pauvreté dans le monde","pour ses améliorations à la théorie des enchères et ses inventions de nouveaux formats d’enchères","pour ses recherches sur les banques et les crises financières"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13987: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Daron Acemoglu a-t-il reçu le Prix Nobel en 2024 ?",
      answers: ["Physiologie ou Médecine","Sciences Économiques","Littérature","Chimie"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13988: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année Simon Johnson a-t-il reçu le Prix Nobel de Sciences Économiques pour ses études sur la manière dont les institutions sont formées et affectent la prospérité ?",
      answers: ["2023","2008","2024","2012"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13989: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2024 pour ses études sur la manière dont les institutions sont formées et affectent la prospérité ?",
      answers: ["David Card","Simon Johnson","Daron Acemoglu","Daniel L. McFadden"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id13990: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison Simon Johnson a-t-il reçu le Prix Nobel en 2024 ?",
      answers: ["pour avoir amélioré notre compréhension des résultats des femmes sur le marché du travail","pour leurs contributions à la théorie des contrats","pour avoir intégré des perspectives psychologiques dans l’analyse économique, notamment sur le comportement humain sous incertitude","pour ses études sur la manière dont les institutions sont formées et affectent la prospérité"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13991: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie Simon Johnson a-t-il reçu le Prix Nobel en 2024 ?",
      answers: ["Physiologie ou Médecine","Chimie","Physique","Sciences Économiques"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13992: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "En quelle année James A. Robinson a-t-il reçu le Prix Nobel de Sciences Économiques pour ses études sur la manière dont les institutions sont formées et affectent la prospérité ?",
      answers: ["2017","2006","2010","2024"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13993: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Qui a reçu le Prix Nobel de Sciences Économiques en 2024 pour ses études sur la manière dont les institutions sont formées et affectent la prospérité ?",
      answers: ["Simon Johnson","William D. Nordhaus","Abhijit Banerjee","James A. Robinson"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13994: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Pour quelle raison James A. Robinson a-t-il reçu le Prix Nobel en 2024 ?",
      answers: ["pour ses contributions empiriques à l’économie du travail","pour ses recherches sur les banques et les crises financières","pour son interprétation empiriquement fondée de la croissance économique qui a conduit à une nouvelle compréhension approfondie de la structure économique et sociale","pour ses études sur la manière dont les institutions sont formées et affectent la prospérité"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id13995: {
      themes: ["Science","Science et Nature","Histoire","Prix Nobel","Divers"],
      question: "Dans quelle catégorie James A. Robinson a-t-il reçu le Prix Nobel en 2024 ?",
      answers: ["Sciences Économiques","Physique","Chimie","Physiologie ou Médecine"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13996: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Lars Ahlfors a-t-il reçu la Médaille Fields pour ses travaux sur les fonctions méromorphes et la théorie des recouvrements ?",
      answers: ["1950","1966","1936","1954"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13997: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1936 pour ses travaux sur les fonctions méromorphes et la théorie des recouvrements ?",
      answers: ["Jesse Douglas","Kunihiko Kodaira","Lars Ahlfors","Martin Hairer"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id13998: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Lars Ahlfors a-t-il reçu la Médaille Fields en 1936 ?",
      answers: ["pour ses travaux sur les fonctions méromorphes et la théorie des recouvrements","pour ses travaux sur la classification des variétés algébriques","pour ses travaux sur les systèmes dynamiques","pour sa résolution du problème de Plateau sur les surfaces minimales"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id13999: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Jesse Douglas a-t-il reçu la Médaille Fields pour sa résolution du problème de Plateau sur les surfaces minimales ?",
      answers: ["2002","1936","1986","1990"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14000: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1936 pour sa résolution du problème de Plateau sur les surfaces minimales ?",
      answers: ["Jesse Douglas","Alan Baker","Terence Tao","Lars Ahlfors"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14001: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Jesse Douglas a-t-il reçu la Médaille Fields en 1936 ?",
      answers: ["pour sa résolution du problème de la conjecture de Thue-Siegel en théorie des nombres","pour sa résolution du problème de Plateau sur les surfaces minimales","pour ses travaux sur les nombres transcendants en théorie des nombres","pour sa classification des variétés de dimension quatre"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14002: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Laurent Schwartz a-t-il reçu la Médaille Fields pour son développement de la théorie des distributions ?",
      answers: ["1990","1954","1966","1950"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14003: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1950 pour son développement de la théorie des distributions ?",
      answers: ["Vaughan Jones","Laurent Schwartz","Atle Selberg","John G. Thompson"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14004: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Laurent Schwartz a-t-il reçu la Médaille Fields en 1950 ?",
      answers: ["pour son développement de la théorie des distributions","pour sa création de la théorie des catastrophes et ses travaux en topologie différentielle","pour sa refonte de la géométrie algébrique moderne","pour ses contributions à la théorie des nombres, notamment la preuve élémentaire du théorème des nombres premiers"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14005: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Atle Selberg a-t-il reçu la Médaille Fields pour ses contributions à la théorie des nombres, notamment la preuve élémentaire du théorème des nombres premiers ?",
      answers: ["1936","1950","1954","1958"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14006: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1950 pour ses contributions à la théorie des nombres, notamment la preuve élémentaire du théorème des nombres premiers ?",
      answers: ["Atle Selberg","Daniel Quillen","Laurent Schwartz","Michael Freedman"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14007: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Atle Selberg a-t-il reçu la Médaille Fields en 1950 ?",
      answers: ["pour ses contributions à la topologie algébrique et à la théorie des nombres","pour ses contributions à la théorie des nombres, notamment la preuve élémentaire du théorème des nombres premiers","pour ses contributions à la théorie des nombres et à la dynamique","pour son développement de la théorie des distributions"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14008: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Kunihiko Kodaira a-t-il reçu la Médaille Fields pour ses travaux en géométrie algébrique et sur les variétés complexes ?",
      answers: ["2010","1954","1962","1958"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14009: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1954 pour ses travaux en géométrie algébrique et sur les variétés complexes ?",
      answers: ["Michael Atiyah","Kunihiko Kodaira","Jean-Pierre Serre","Vladimir Voevodsky"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14010: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Kunihiko Kodaira a-t-il reçu la Médaille Fields en 1954 ?",
      answers: ["pour ses contributions à la topologie algébrique et à la théorie des nombres","pour ses travaux en géométrie algébrique et sur les variétés complexes","pour son développement de la théorie des distributions","pour sa preuve de la conjecture de Poincaré et de la géométrisation de Thurston"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14011: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Jean-Pierre Serre a-t-il reçu la Médaille Fields pour ses contributions à la topologie algébrique et à la théorie des nombres ?",
      answers: ["1950","1966","1962","1954"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14012: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1954 pour ses contributions à la topologie algébrique et à la théorie des nombres ?",
      answers: ["Jean-Pierre Serre","René Thom","Stanislav Smirnov","Laurent Schwartz"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14013: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Jean-Pierre Serre a-t-il reçu la Médaille Fields en 1954 ?",
      answers: ["pour sa création de la théorie des catastrophes et ses travaux en topologie différentielle","pour ses contributions à l’analyse mathématique","pour ses contributions à la topologie algébrique et à la théorie des nombres","pour ses travaux en géométrie algébrique et sur les variétés complexes"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14014: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Klaus Roth a-t-il reçu la Médaille Fields pour sa résolution du problème de la conjecture de Thue-Siegel en théorie des nombres ?",
      answers: ["1958","1954","1970","1978"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14015: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1958 pour sa résolution du problème de la conjecture de Thue-Siegel en théorie des nombres ?",
      answers: ["René Thom","Lars Hörmander","Klaus Roth","Kunihiko Kodaira"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14016: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Klaus Roth a-t-il reçu la Médaille Fields en 1958 ?",
      answers: ["pour sa création de la théorie des catastrophes et ses travaux en topologie différentielle","pour ses contributions aux équations aux dérivées partielles","pour sa résolution du problème de la conjecture de Thue-Siegel en théorie des nombres","pour sa résolution des singularités en géométrie algébrique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14017: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année René Thom a-t-il reçu la Médaille Fields pour sa création de la théorie des catastrophes et ses travaux en topologie différentielle ?",
      answers: ["1950","1958","1962","1974"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14018: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1958 pour sa création de la théorie des catastrophes et ses travaux en topologie différentielle ?",
      answers: ["René Thom","Klaus Roth","Maryam Mirzakhani","John G. Thompson"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14019: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison René Thom a-t-il reçu la Médaille Fields en 1958 ?",
      answers: ["pour ses contributions à la topologie algébrique et à la théorie des nombres","pour ses travaux sur les équations différentielles et la conjecture de Calabi","pour sa création de la théorie des catastrophes et ses travaux en topologie différentielle","pour ses contributions à la théorie des nombres et à la géométrie arithmétique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14020: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Lars Hörmander a-t-il reçu la Médaille Fields pour ses contributions aux équations aux dérivées partielles ?",
      answers: ["1986","1966","1978","1962"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14021: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1962 pour ses contributions aux équations aux dérivées partielles ?",
      answers: ["Lars Hörmander","Paul Cohen","René Thom","Michael Atiyah"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14022: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Lars Hörmander a-t-il reçu la Médaille Fields en 1962 ?",
      answers: ["pour ses contributions aux équations aux dérivées partielles","pour ses travaux sur les nombres transcendants en théorie des nombres","pour ses contributions à la théorie des algèbres de von Neumann","pour ses contributions à la topologie différentielle et à la théorie des systèmes dynamiques"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14023: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année John Milnor a-t-il reçu la Médaille Fields pour sa découverte des sphères exotiques en topologie différentielle ?",
      answers: ["1970","1958","1982","1962"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14024: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1962 pour sa découverte des sphères exotiques en topologie différentielle ?",
      answers: ["John Milnor","Alexander Grothendieck","René Thom","Lars Hörmander"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14025: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison John Milnor a-t-il reçu la Médaille Fields en 1962 ?",
      answers: ["pour sa découverte des invariants de Donaldson en topologie","pour sa découverte des sphères exotiques en topologie différentielle","pour ses contributions aux équations aux dérivées partielles","pour ses travaux sur les algèbres quantiques et la géométrie algébrique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14026: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Michael Atiyah a-t-il reçu la Médaille Fields pour ses travaux sur la théorie K et le théorème de l’indice ?",
      answers: ["2002","1954","1966","1962"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14027: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1966 pour ses travaux sur la théorie K et le théorème de l’indice ?",
      answers: ["Michael Atiyah","Alan Baker","Stephen Smale","Alexander Grothendieck"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14028: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Michael Atiyah a-t-il reçu la Médaille Fields en 1966 ?",
      answers: ["pour sa preuve de l’indépendance de l’hypothèse du continu et de l’axiome du choix","pour ses contributions à la topologie algébrique et aux systèmes dynamiques","pour ses travaux sur la théorie K et le théorème de l’indice","pour sa refonte de la géométrie algébrique moderne"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14029: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Paul Cohen a-t-il reçu la Médaille Fields pour sa preuve de l’indépendance de l’hypothèse du continu et de l’axiome du choix ?",
      answers: ["1978","1966","1962","1990"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14030: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1966 pour sa preuve de l’indépendance de l’hypothèse du continu et de l’axiome du choix ?",
      answers: ["Paul Cohen","John G. Thompson","Michael Atiyah","René Thom"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14031: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Paul Cohen a-t-il reçu la Médaille Fields en 1966 ?",
      answers: ["pour ses travaux sur la théorie K et le théorème de l’indice","pour sa preuve de l’indépendance de l’hypothèse du continu et de l’axiome du choix","pour ses contributions à la théorie des nombres et à la géométrie arithmétique","pour ses contributions à la topologie différentielle et à la théorie des systèmes dynamiques"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14032: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Alexander Grothendieck a-t-il reçu la Médaille Fields pour sa refonte de la géométrie algébrique moderne ?",
      answers: ["1950","1966","2010","1998"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14033: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1966 pour sa refonte de la géométrie algébrique moderne ?",
      answers: ["Alexander Grothendieck","Heisuke Hironaka","Paul Cohen","Stephen Smale"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14034: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Alexander Grothendieck a-t-il reçu la Médaille Fields en 1966 ?",
      answers: ["pour sa refonte de la géométrie algébrique moderne","pour ses travaux sur les équations différentielles et la conjecture de Calabi","pour ses contributions à la topologie différentielle et à la théorie des systèmes dynamiques","pour ses travaux sur les nombres transcendants en théorie des nombres"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14035: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Stephen Smale a-t-il reçu la Médaille Fields pour ses contributions à la topologie différentielle et à la théorie des systèmes dynamiques ?",
      answers: ["1966","1958","1974","1950"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14036: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1966 pour ses contributions à la topologie différentielle et à la théorie des systèmes dynamiques ?",
      answers: ["Paul Cohen","Stephen Smale","Alexander Grothendieck","Laurent Lafforgue"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14037: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Stephen Smale a-t-il reçu la Médaille Fields en 1966 ?",
      answers: ["pour ses contributions à la topologie différentielle et à la théorie des systèmes dynamiques","pour sa preuve de l’indépendance de l’hypothèse du continu et de l’axiome du choix","pour sa révolution dans la géométrie des variétés en trois dimensions","pour sa refonte de la géométrie algébrique moderne"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14038: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Alan Baker a-t-il reçu la Médaille Fields pour ses travaux sur les nombres transcendants en théorie des nombres ?",
      answers: ["1970","2014","1966","1982"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14039: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1970 pour ses travaux sur les nombres transcendants en théorie des nombres ?",
      answers: ["John G. Thompson","Alan Baker","Jean-Pierre Serre","Enrico Bombieri"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14040: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Alan Baker a-t-il reçu la Médaille Fields en 1970 ?",
      answers: ["pour ses contributions à la topologie algébrique et aux systèmes dynamiques","pour ses contributions à la physique mathématique et à la théorie des cordes","pour sa résolution des singularités en géométrie algébrique","pour ses travaux sur les nombres transcendants en théorie des nombres"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14041: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Heisuke Hironaka a-t-il reçu la Médaille Fields pour sa résolution des singularités en géométrie algébrique ?",
      answers: ["1990","1970","1974","1982"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14042: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1970 pour sa résolution des singularités en géométrie algébrique ?",
      answers: ["Michael Atiyah","Gregori Margulis","Heisuke Hironaka","Alan Baker"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14043: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Heisuke Hironaka a-t-il reçu la Médaille Fields en 1970 ?",
      answers: ["pour sa preuve de la conjecture de Mordell en géométrie arithmétique","pour sa résolution des singularités en géométrie algébrique","pour sa classification des groupes finis simples","pour ses travaux sur la théorie K et le théorème de l’indice"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14044: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Sergei Novikov a-t-il reçu la Médaille Fields pour ses contributions à la topologie algébrique et aux systèmes dynamiques ?",
      answers: ["1970","1962","1974","2006"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14045: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1970 pour ses contributions à la topologie algébrique et aux systèmes dynamiques ?",
      answers: ["Sergei Novikov","John G. Thompson","Gregori Margulis","Daniel Quillen"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14046: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Sergei Novikov a-t-il reçu la Médaille Fields en 1970 ?",
      answers: ["pour sa classification des groupes finis simples","pour sa résolution des singularités en géométrie algébrique","pour ses contributions à la topologie algébrique et aux systèmes dynamiques","pour ses travaux sur les nombres transcendants en théorie des nombres"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14047: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année John G. Thompson a-t-il reçu la Médaille Fields pour sa classification des groupes finis simples ?",
      answers: ["1970","1958","1986","1998"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14048: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1970 pour sa classification des groupes finis simples ?",
      answers: ["Heisuke Hironaka","Sergei Novikov","Alan Baker","John G. Thompson"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14049: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison John G. Thompson a-t-il reçu la Médaille Fields en 1970 ?",
      answers: ["pour sa classification des groupes finis simples","pour ses contributions à la topologie algébrique et aux systèmes dynamiques","pour ses travaux sur les nombres transcendants en théorie des nombres","pour sa résolution des singularités en géométrie algébrique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14050: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Enrico Bombieri a-t-il reçu la Médaille Fields pour ses contributions à la théorie des nombres et à la géométrie arithmétique ?",
      answers: ["1974","1994","1982","1970"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14051: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1974 pour ses contributions à la théorie des nombres et à la géométrie arithmétique ?",
      answers: ["Enrico Bombieri","David Mumford","Richard Borcherds","Charles Fefferman"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14052: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Enrico Bombieri a-t-il reçu la Médaille Fields en 1974 ?",
      answers: ["pour sa classification des variétés de dimension quatre","pour sa preuve de l’indépendance de l’hypothèse du continu et de l’axiome du choix","pour ses travaux sur les variétés abéliennes et la géométrie algébrique","pour ses contributions à la théorie des nombres et à la géométrie arithmétique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14053: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année David Mumford a-t-il reçu la Médaille Fields pour ses travaux sur les variétés abéliennes et la géométrie algébrique ?",
      answers: ["1990","1962","1974","1950"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14054: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1974 pour ses travaux sur les variétés abéliennes et la géométrie algébrique ?",
      answers: ["Pierre Deligne","Shigefumi Mori","David Mumford","Enrico Bombieri"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14055: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison David Mumford a-t-il reçu la Médaille Fields en 1974 ?",
      answers: ["pour sa résolution des singularités en géométrie algébrique","pour ses travaux sur les variétés abéliennes et la géométrie algébrique","pour sa théorie des structures de régularité en équations différentielles stochastiques","pour sa preuve des conjectures de Weil en géométrie algébrique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14056: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Pierre Deligne a-t-il reçu la Médaille Fields pour sa preuve des conjectures de Weil en géométrie algébrique ?",
      answers: ["1978","1954","2006","1950"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14057: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1978 pour sa preuve des conjectures de Weil en géométrie algébrique ?",
      answers: ["Charles Fefferman","Sergei Novikov","Pierre Deligne","Gregori Margulis"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14058: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Pierre Deligne a-t-il reçu la Médaille Fields en 1978 ?",
      answers: ["pour sa création de la K-théorie algébrique","pour ses contributions à l’analyse harmonique, la théorie des nombres et les équations différentielles","pour sa preuve des conjectures de Weil en géométrie algébrique","pour sa révolution dans la géométrie des variétés en trois dimensions"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14059: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Charles Fefferman a-t-il reçu la Médaille Fields pour ses contributions à l’analyse mathématique ?",
      answers: ["1958","1978","2006","1982"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14060: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1978 pour ses contributions à l’analyse mathématique ?",
      answers: ["Charles Fefferman","Pierre Deligne","Alan Baker","Daniel Quillen"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14061: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Charles Fefferman a-t-il reçu la Médaille Fields en 1978 ?",
      answers: ["pour sa création de la K-théorie algébrique","pour sa preuve des conjectures de Weil en géométrie algébrique","pour ses travaux sur les nombres transcendants en théorie des nombres","pour ses contributions à l’analyse mathématique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14062: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Gregori Margulis a-t-il reçu la Médaille Fields pour ses travaux sur les groupes de Lie et la géométrie discrète ?",
      answers: ["1974","1978","1990","1982"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14063: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1978 pour ses travaux sur les groupes de Lie et la géométrie discrète ?",
      answers: ["Charles Fefferman","Pierre Deligne","Gregori Margulis","William Thurston"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14064: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Gregori Margulis a-t-il reçu la Médaille Fields en 1978 ?",
      answers: ["pour sa preuve des conjectures de Weil en géométrie algébrique","pour ses travaux sur les groupes de Lie et la géométrie discrète","pour ses contributions à l’analyse mathématique","pour sa création de la K-théorie algébrique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14065: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Daniel Quillen a-t-il reçu la Médaille Fields pour sa création de la K-théorie algébrique ?",
      answers: ["1954","1970","1962","1978"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14066: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1978 pour sa création de la K-théorie algébrique ?",
      answers: ["Daniel Quillen","Elon Lindenstrauss","Simon Donaldson","Pierre Deligne"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14067: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Daniel Quillen a-t-il reçu la Médaille Fields en 1978 ?",
      answers: ["pour sa création de la K-théorie algébrique","pour ses travaux sur les groupes de Lie et la géométrie discrète","pour ses travaux sur les algèbres quantiques et la géométrie algébrique","pour ses travaux sur la répartition des nombres premiers"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14068: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Alain Connes a-t-il reçu la Médaille Fields pour ses contributions à la théorie des algèbres de von Neumann ?",
      answers: ["2010","1998","1982","2002"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14069: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1982 pour ses contributions à la théorie des algèbres de von Neumann ?",
      answers: ["John Milnor","Charles Fefferman","Alain Connes","Simon Donaldson"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14070: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Alain Connes a-t-il reçu la Médaille Fields en 1982 ?",
      answers: ["pour ses travaux sur les équations différentielles et la conjecture de Calabi","pour ses contributions à la théorie des algèbres de von Neumann","pour sa découverte des sphères exotiques en topologie différentielle","pour ses travaux sur les groupes de Lie et la géométrie discrète"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14071: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année William Thurston a-t-il reçu la Médaille Fields pour sa révolution dans la géométrie des variétés en trois dimensions ?",
      answers: ["1982","2002","2006","1998"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14072: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1982 pour sa révolution dans la géométrie des variétés en trois dimensions ?",
      answers: ["Shing-Tung Yau","Gregori Margulis","William Thurston","Alain Connes"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14073: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison William Thurston a-t-il reçu la Médaille Fields en 1982 ?",
      answers: ["pour ses contributions à la topologie algébrique et aux systèmes dynamiques","pour sa classification des variétés de dimension quatre","pour sa révolution dans la géométrie des variétés en trois dimensions","pour ses contributions à la topologie algébrique et à la théorie des nombres"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14074: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Shing-Tung Yau a-t-il reçu la Médaille Fields pour ses travaux sur les équations différentielles et la conjecture de Calabi ?",
      answers: ["1970","1982","1966","1994"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14075: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1982 pour ses travaux sur les équations différentielles et la conjecture de Calabi ?",
      answers: ["Michael Atiyah","Shing-Tung Yau","William Thurston","Alain Connes"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14076: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Shing-Tung Yau a-t-il reçu la Médaille Fields en 1982 ?",
      answers: ["pour ses contributions à la théorie des algèbres de von Neumann","pour sa révolution dans la géométrie des variétés en trois dimensions","pour sa création des espaces perfectoïdes en géométrie arithmétique","pour ses travaux sur les équations différentielles et la conjecture de Calabi"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14077: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Simon Donaldson a-t-il reçu la Médaille Fields pour sa découverte des invariants de Donaldson en topologie ?",
      answers: ["1986","1990","2014","2010"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14078: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1986 pour sa découverte des invariants de Donaldson en topologie ?",
      answers: ["Gerd Faltings","Maxim Kontsevich","Simon Donaldson","Shigefumi Mori"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14079: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Simon Donaldson a-t-il reçu la Médaille Fields en 1986 ?",
      answers: ["pour sa preuve de la conjecture de Mordell en géométrie arithmétique","pour sa découverte des invariants de Donaldson en topologie","pour ses contributions à la théorie des algèbres de von Neumann","pour ses travaux sur les algèbres quantiques et la géométrie algébrique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14080: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Gerd Faltings a-t-il reçu la Médaille Fields pour sa preuve de la conjecture de Mordell en géométrie arithmétique ?",
      answers: ["1986","1990","1994","1974"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14081: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1986 pour sa preuve de la conjecture de Mordell en géométrie arithmétique ?",
      answers: ["Michael Freedman","Manjul Bhargava","Simon Donaldson","Gerd Faltings"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14082: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Gerd Faltings a-t-il reçu la Médaille Fields en 1986 ?",
      answers: ["pour sa découverte des invariants de Donaldson en topologie","pour sa classification des variétés de dimension quatre","pour sa preuve de la conjecture de Mordell en géométrie arithmétique","pour sa classification des groupes finis simples"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14083: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Michael Freedman a-t-il reçu la Médaille Fields pour sa classification des variétés de dimension quatre ?",
      answers: ["1966","1970","1986","1982"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14084: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1986 pour sa classification des variétés de dimension quatre ?",
      answers: ["David Mumford","Simon Donaldson","Gerd Faltings","Michael Freedman"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14085: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Michael Freedman a-t-il reçu la Médaille Fields en 1986 ?",
      answers: ["pour sa découverte des invariants de nœuds en théorie des nœuds","pour sa création de la K-théorie algébrique","pour sa découverte des invariants de Donaldson en topologie","pour sa classification des variétés de dimension quatre"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14086: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Vladimir Drinfeld a-t-il reçu la Médaille Fields pour ses travaux sur les algèbres quantiques et la géométrie algébrique ?",
      answers: ["1994","1990","1974","1970"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14087: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1990 pour ses travaux sur les algèbres quantiques et la géométrie algébrique ?",
      answers: ["Shigefumi Mori","Jean Bourgain","Michael Freedman","Vladimir Drinfeld"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14088: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Vladimir Drinfeld a-t-il reçu la Médaille Fields en 1990 ?",
      answers: ["pour sa classification des variétés algébriques en dimension trois","pour sa preuve de la conjecture de Mordell en géométrie arithmétique","pour sa création de la théorie des catastrophes et ses travaux en topologie différentielle","pour ses travaux sur les algèbres quantiques et la géométrie algébrique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14089: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Vaughan Jones a-t-il reçu la Médaille Fields pour sa découverte des invariants de nœuds en théorie des nœuds ?",
      answers: ["1970","1990","1986","1966"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14090: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1990 pour sa découverte des invariants de nœuds en théorie des nœuds ?",
      answers: ["Gerd Faltings","Shigefumi Mori","Simon Donaldson","Vaughan Jones"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14091: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Vaughan Jones a-t-il reçu la Médaille Fields en 1990 ?",
      answers: ["pour ses travaux sur les variétés abéliennes et la géométrie algébrique","pour ses travaux en géométrie algébrique et en physique mathématique","pour sa classification des variétés algébriques en dimension trois","pour sa découverte des invariants de nœuds en théorie des nœuds"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14092: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Shigefumi Mori a-t-il reçu la Médaille Fields pour sa classification des variétés algébriques en dimension trois ?",
      answers: ["1994","2018","1982","1990"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14093: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1990 pour sa classification des variétés algébriques en dimension trois ?",
      answers: ["Vaughan Jones","Vladimir Drinfeld","Shigefumi Mori","Simon Donaldson"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14094: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Shigefumi Mori a-t-il reçu la Médaille Fields en 1990 ?",
      answers: ["pour ses travaux sur les groupes de Lie et la géométrie discrète","pour sa création des espaces perfectoïdes en géométrie arithmétique","pour sa découverte des invariants de Donaldson en topologie","pour sa classification des variétés algébriques en dimension trois"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14095: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Edward Witten a-t-il reçu la Médaille Fields pour ses contributions à la physique mathématique et à la théorie des cordes ?",
      answers: ["1966","1990","1982","1978"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14096: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1990 pour ses contributions à la physique mathématique et à la théorie des cordes ?",
      answers: ["Shigefumi Mori","Alexander Grothendieck","Vladimir Drinfeld","Edward Witten"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14097: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Edward Witten a-t-il reçu la Médaille Fields en 1990 ?",
      answers: ["pour sa découverte des invariants de nœuds en théorie des nœuds","pour ses contributions reliant la théorie des probabilités, la géométrie algébrique et la physique","pour ses contributions à la physique mathématique et à la théorie des cordes","pour sa classification des variétés de dimension quatre"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14098: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Jean Bourgain a-t-il reçu la Médaille Fields pour ses travaux en analyse harmonique et en théorie des nombres ?",
      answers: ["1994","1998","1990","2010"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14099: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1994 pour ses travaux en analyse harmonique et en théorie des nombres ?",
      answers: ["Efim Zelmanov","Jean Bourgain","Maxim Kontsevich","Pierre-Louis Lions"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14100: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Jean Bourgain a-t-il reçu la Médaille Fields en 1994 ?",
      answers: ["pour sa preuve de la conjecture de la monstruosité en théorie des groupes","pour ses travaux sur les systèmes dynamiques","pour sa découverte des invariants de Donaldson en topologie","pour ses travaux en analyse harmonique et en théorie des nombres"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14101: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Pierre-Louis Lions a-t-il reçu la Médaille Fields pour ses contributions aux équations aux dérivées partielles non linéaires ?",
      answers: ["1990","1982","1998","1994"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14102: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1994 pour ses contributions aux équations aux dérivées partielles non linéaires ?",
      answers: ["Ngô Bảo Châu","Pierre-Louis Lions","Jean Bourgain","Jean-Christophe Yoccoz"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14103: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Pierre-Louis Lions a-t-il reçu la Médaille Fields en 1994 ?",
      answers: ["pour ses contributions aux équations aux dérivées partielles non linéaires","pour ses contributions à la physique mathématique et à la théorie des cordes","pour ses travaux sur les équations différentielles et la conjecture de Calabi","pour ses contributions à l’équation de Boltzmann et à la théorie du transport optimal"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14104: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Jean-Christophe Yoccoz a-t-il reçu la Médaille Fields pour ses travaux sur les systèmes dynamiques ?",
      answers: ["2002","2006","1994","1986"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14105: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1994 pour ses travaux sur les systèmes dynamiques ?",
      answers: ["Pierre-Louis Lions","Jean-Christophe Yoccoz","Efim Zelmanov","Vaughan Jones"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14106: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Jean-Christophe Yoccoz a-t-il reçu la Médaille Fields en 1994 ?",
      answers: ["pour ses contributions à la géométrie hyperbolique et aux systèmes dynamiques","pour ses contributions aux équations aux dérivées partielles non linéaires","pour ses travaux sur les systèmes dynamiques","pour ses travaux en analyse harmonique et en théorie des nombres"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14107: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Efim Zelmanov a-t-il reçu la Médaille Fields pour sa résolution du problème de Burnside restreint en théorie des groupes ?",
      answers: ["1990","1994","2002","1974"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14108: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1994 pour sa résolution du problème de Burnside restreint en théorie des groupes ?",
      answers: ["Jean-Christophe Yoccoz","Shigefumi Mori","Pierre-Louis Lions","Efim Zelmanov"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14109: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Efim Zelmanov a-t-il reçu la Médaille Fields en 1994 ?",
      answers: ["pour sa résolution du problème de Burnside restreint en théorie des groupes","pour ses contributions à la théorie des nombres et à la dynamique","pour ses travaux en analyse harmonique et en théorie des nombres","pour ses contributions à la théorie des algèbres de von Neumann"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14110: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Richard Borcherds a-t-il reçu la Médaille Fields pour sa preuve de la conjecture de la monstruosité en théorie des groupes ?",
      answers: ["1998","1986","1970","2002"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14111: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1998 pour sa preuve de la conjecture de la monstruosité en théorie des groupes ?",
      answers: ["Vladimir Voevodsky","Jean Bourgain","Richard Borcherds","Curtis McMullen"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14112: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Richard Borcherds a-t-il reçu la Médaille Fields en 1998 ?",
      answers: ["pour ses travaux sur la percolation et les modèles de physique statistique","pour ses contributions à la géométrie hyperbolique et aux systèmes dynamiques","pour sa classification des variétés algébriques en dimension trois","pour sa preuve de la conjecture de la monstruosité en théorie des groupes"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14113: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Timothy Gowers a-t-il reçu la Médaille Fields pour ses contributions à la combinatoire et à l’analyse fonctionnelle ?",
      answers: ["1990","1994","2006","1998"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14114: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1998 pour ses contributions à la combinatoire et à l’analyse fonctionnelle ?",
      answers: ["Andrei Okounkov","Grigori Perelman","Richard Borcherds","Timothy Gowers"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14115: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Timothy Gowers a-t-il reçu la Médaille Fields en 1998 ?",
      answers: ["pour ses travaux en géométrie algébrique et en physique mathématique","pour ses contributions à la géométrie hyperbolique et aux systèmes dynamiques","pour ses contributions à la combinatoire et à l’analyse fonctionnelle","pour sa classification des groupes finis simples"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14116: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Maxim Kontsevich a-t-il reçu la Médaille Fields pour ses travaux en géométrie algébrique et en physique mathématique ?",
      answers: ["1998","1994","1936","1950"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14117: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1998 pour ses travaux en géométrie algébrique et en physique mathématique ?",
      answers: ["Curtis McMullen","Shigefumi Mori","Timothy Gowers","Maxim Kontsevich"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14118: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Maxim Kontsevich a-t-il reçu la Médaille Fields en 1998 ?",
      answers: ["pour ses contributions à la combinatoire et à l’analyse fonctionnelle","pour ses contributions à la géométrie hyperbolique et aux systèmes dynamiques","pour ses travaux sur les processus stochastiques et la géométrie aléatoire","pour ses travaux en géométrie algébrique et en physique mathématique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14119: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Curtis McMullen a-t-il reçu la Médaille Fields pour ses contributions à la géométrie hyperbolique et aux systèmes dynamiques ?",
      answers: ["2002","2014","1998","1994"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14120: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 1998 pour ses contributions à la géométrie hyperbolique et aux systèmes dynamiques ?",
      answers: ["Andrei Okounkov","Alain Connes","Curtis McMullen","Wendelin Werner"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14121: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Curtis McMullen a-t-il reçu la Médaille Fields en 1998 ?",
      answers: ["pour ses contributions à la théorie des algèbres de von Neumann","pour ses contributions à la géométrie hyperbolique et aux systèmes dynamiques","pour ses travaux en géométrie algébrique et en physique mathématique","pour ses contributions à la combinatoire et à l’analyse fonctionnelle"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14122: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Laurent Lafforgue a-t-il reçu la Médaille Fields pour sa preuve du programme de Langlands pour les corps de fonctions ?",
      answers: ["1970","1990","2006","2002"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14123: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 2002 pour sa preuve du programme de Langlands pour les corps de fonctions ?",
      answers: ["Jean-Christophe Yoccoz","Andrei Okounkov","Vladimir Voevodsky","Laurent Lafforgue"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14124: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Laurent Lafforgue a-t-il reçu la Médaille Fields en 2002 ?",
      answers: ["pour sa preuve du programme de Langlands pour les corps de fonctions","pour sa preuve du lemme fondamental dans le programme de Langlands","pour ses travaux sur les processus stochastiques et la géométrie aléatoire","pour sa création de la théorie des catastrophes et ses travaux en topologie différentielle"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14125: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Vladimir Voevodsky a-t-il reçu la Médaille Fields pour sa création de la théorie de l’homotopie motivique ?",
      answers: ["1974","2010","2002","2022"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14126: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 2002 pour sa création de la théorie de l’homotopie motivique ?",
      answers: ["Vladimir Voevodsky","Laurent Schwartz","Andrei Okounkov","Curtis McMullen"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14127: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Vladimir Voevodsky a-t-il reçu la Médaille Fields en 2002 ?",
      answers: ["pour ses contributions aux systèmes dynamiques et à la théorie du chaos","pour sa découverte des invariants de nœuds en théorie des nœuds","pour sa création de la théorie de l’homotopie motivique","pour ses contributions à la combinatoire et à l’analyse fonctionnelle"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14128: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Andrei Okounkov a-t-il reçu la Médaille Fields pour ses contributions reliant la théorie des probabilités, la géométrie algébrique et la physique ?",
      answers: ["2006","1998","2002","1994"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14129: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 2006 pour ses contributions reliant la théorie des probabilités, la géométrie algébrique et la physique ?",
      answers: ["Wendelin Werner","Grigori Perelman","Andrei Okounkov","Terence Tao"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14130: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Andrei Okounkov a-t-il reçu la Médaille Fields en 2006 ?",
      answers: ["pour ses travaux sur les transitions de phase en physique statistique","pour ses contributions à l’analyse harmonique, la théorie des nombres et les équations différentielles","pour sa preuve de la conjecture de Poincaré et de la géométrisation de Thurston","pour ses contributions reliant la théorie des probabilités, la géométrie algébrique et la physique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14131: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Grigori Perelman a-t-il reçu la Médaille Fields pour sa preuve de la conjecture de Poincaré et de la géométrisation de Thurston ?",
      answers: ["1998","2006","1982","2010"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14132: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 2006 pour sa preuve de la conjecture de Poincaré et de la géométrisation de Thurston ?",
      answers: ["Grigori Perelman","Timothy Gowers","Andrei Okounkov","Caucher Birkar"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14133: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Grigori Perelman a-t-il reçu la Médaille Fields en 2006 ?",
      answers: ["pour sa preuve du programme de Langlands pour les corps de fonctions","pour ses contributions à la combinatoire et à l’analyse fonctionnelle","pour ses contributions reliant la théorie des probabilités, la géométrie algébrique et la physique","pour sa preuve de la conjecture de Poincaré et de la géométrisation de Thurston"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14134: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Terence Tao a-t-il reçu la Médaille Fields pour ses contributions à l’analyse harmonique, la théorie des nombres et les équations différentielles ?",
      answers: ["1998","2006","1982","2014"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14135: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 2006 pour ses contributions à l’analyse harmonique, la théorie des nombres et les équations différentielles ?",
      answers: ["Caucher Birkar","Grigori Perelman","Terence Tao","Timothy Gowers"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14136: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Terence Tao a-t-il reçu la Médaille Fields en 2006 ?",
      answers: ["pour ses contributions reliant la théorie des probabilités, la géométrie algébrique et la physique","pour ses contributions aux systèmes dynamiques et à la théorie du chaos","pour sa preuve de la conjecture de Poincaré et de la géométrisation de Thurston","pour ses contributions à l’analyse harmonique, la théorie des nombres et les équations différentielles"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14137: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Wendelin Werner a-t-il reçu la Médaille Fields pour ses travaux sur les processus stochastiques et la géométrie aléatoire ?",
      answers: ["2006","2002","2010","1990"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14138: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 2006 pour ses travaux sur les processus stochastiques et la géométrie aléatoire ?",
      answers: ["Wendelin Werner","Andrei Okounkov","Grigori Perelman","Laurent Lafforgue"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14139: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Wendelin Werner a-t-il reçu la Médaille Fields en 2006 ?",
      answers: ["pour ses travaux sur les processus stochastiques et la géométrie aléatoire","pour ses contributions à l’analyse harmonique, la théorie des nombres et les équations différentielles","pour sa preuve de la conjecture de Poincaré et de la géométrisation de Thurston","pour ses contributions reliant la théorie des probabilités, la géométrie algébrique et la physique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14140: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Elon Lindenstrauss a-t-il reçu la Médaille Fields pour ses contributions à la théorie ergodique et aux systèmes dynamiques ?",
      answers: ["2010","1986","2006","2018"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14141: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 2010 pour ses contributions à la théorie ergodique et aux systèmes dynamiques ?",
      answers: ["Ngô Bảo Châu","Elon Lindenstrauss","Stanislav Smirnov","Shigefumi Mori"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14142: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Elon Lindenstrauss a-t-il reçu la Médaille Fields en 2010 ?",
      answers: ["pour ses contributions à la théorie ergodique et aux systèmes dynamiques","pour sa preuve du lemme fondamental dans le programme de Langlands","pour ses travaux sur la percolation et les modèles de physique statistique","pour sa résolution du problème de Burnside restreint en théorie des groupes"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14143: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Ngô Bảo Châu a-t-il reçu la Médaille Fields pour sa preuve du lemme fondamental dans le programme de Langlands ?",
      answers: ["2022","2010","2006","1998"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14144: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 2010 pour sa preuve du lemme fondamental dans le programme de Langlands ?",
      answers: ["Ngô Bảo Châu","Akshay Venkatesh","Gerd Faltings","Cédric Villani"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14145: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Ngô Bảo Châu a-t-il reçu la Médaille Fields en 2010 ?",
      answers: ["pour sa preuve de la conjecture de Poincaré et de la géométrisation de Thurston","pour sa preuve du lemme fondamental dans le programme de Langlands","pour ses contributions à la théorie ergodique et aux systèmes dynamiques","pour ses travaux sur la percolation et les modèles de physique statistique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14146: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Stanislav Smirnov a-t-il reçu la Médaille Fields pour ses travaux sur la percolation et les modèles de physique statistique ?",
      answers: ["1986","2002","1966","2010"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14147: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 2010 pour ses travaux sur la percolation et les modèles de physique statistique ?",
      answers: ["Elon Lindenstrauss","Ngô Bảo Châu","Stanislav Smirnov","June Huh"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14148: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Stanislav Smirnov a-t-il reçu la Médaille Fields en 2010 ?",
      answers: ["pour ses contributions à l’équation de Boltzmann et à la théorie du transport optimal","pour ses contributions reliant la théorie des probabilités, la géométrie algébrique et la physique","pour ses travaux sur la percolation et les modèles de physique statistique","pour sa découverte des sphères exotiques en topologie différentielle"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14149: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Cédric Villani a-t-il reçu la Médaille Fields pour ses contributions à l’équation de Boltzmann et à la théorie du transport optimal ?",
      answers: ["2010","2014","1998","1994"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14150: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 2010 pour ses contributions à l’équation de Boltzmann et à la théorie du transport optimal ?",
      answers: ["Martin Hairer","Cédric Villani","Artur Avila","Wendelin Werner"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14151: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Cédric Villani a-t-il reçu la Médaille Fields en 2010 ?",
      answers: ["pour ses contributions à la théorie ergodique et aux systèmes dynamiques","pour sa preuve du lemme fondamental dans le programme de Langlands","pour ses contributions à l’équation de Boltzmann et à la théorie du transport optimal","pour ses travaux sur la percolation et les modèles de physique statistique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14152: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Artur Avila a-t-il reçu la Médaille Fields pour ses contributions aux systèmes dynamiques et à la théorie du chaos ?",
      answers: ["2014","2010","2018","1990"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14153: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 2014 pour ses contributions aux systèmes dynamiques et à la théorie du chaos ?",
      answers: ["Maryam Mirzakhani","Wendelin Werner","Alain Connes","Artur Avila"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14154: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Artur Avila a-t-il reçu la Médaille Fields en 2014 ?",
      answers: ["pour ses travaux en théorie des nombres et en géométrie algébrique","pour ses contributions aux systèmes dynamiques et à la théorie du chaos","pour ses travaux sur la classification des variétés algébriques","pour ses contributions à la géométrie des surfaces de Riemann"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14155: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Manjul Bhargava a-t-il reçu la Médaille Fields pour ses travaux en théorie des nombres et en géométrie algébrique ?",
      answers: ["2014","2002","1986","2018"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14156: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 2014 pour ses travaux en théorie des nombres et en géométrie algébrique ?",
      answers: ["Manjul Bhargava","Charles Fefferman","Peter Scholze","Artur Avila"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14157: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Manjul Bhargava a-t-il reçu la Médaille Fields en 2014 ?",
      answers: ["pour ses contributions à la combinatoire via la théorie de Hodge","pour ses travaux en théorie des nombres et en géométrie algébrique","pour ses contributions à la théorie des nombres et à la dynamique","pour sa preuve du programme de Langlands pour les corps de fonctions"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14158: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Martin Hairer a-t-il reçu la Médaille Fields pour sa théorie des structures de régularité en équations différentielles stochastiques ?",
      answers: ["1982","1974","2014","1998"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14159: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 2014 pour sa théorie des structures de régularité en équations différentielles stochastiques ?",
      answers: ["Artur Avila","Maryam Mirzakhani","Manjul Bhargava","Martin Hairer"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14160: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Martin Hairer a-t-il reçu la Médaille Fields en 2014 ?",
      answers: ["pour sa théorie des structures de régularité en équations différentielles stochastiques","pour ses contributions à la géométrie des surfaces de Riemann","pour ses contributions reliant la théorie des probabilités, la géométrie algébrique et la physique","pour sa refonte de la géométrie algébrique moderne"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14161: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Maryam Mirzakhani a-t-il reçu la Médaille Fields pour ses contributions à la géométrie des surfaces de Riemann ?",
      answers: ["2014","2010","2018","2006"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14162: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 2014 pour ses contributions à la géométrie des surfaces de Riemann ?",
      answers: ["Elon Lindenstrauss","Maryam Mirzakhani","Martin Hairer","Wendelin Werner"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14163: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Maryam Mirzakhani a-t-il reçu la Médaille Fields en 2014 ?",
      answers: ["pour ses travaux en théorie des nombres et en géométrie algébrique","pour sa théorie des structures de régularité en équations différentielles stochastiques","pour sa découverte des sphères exotiques en topologie différentielle","pour ses contributions à la géométrie des surfaces de Riemann"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14164: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Caucher Birkar a-t-il reçu la Médaille Fields pour ses travaux sur la classification des variétés algébriques ?",
      answers: ["2006","2018","1998","2014"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14165: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 2018 pour ses travaux sur la classification des variétés algébriques ?",
      answers: ["Wendelin Werner","Caucher Birkar","Alessio Figalli","Peter Scholze"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14166: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Caucher Birkar a-t-il reçu la Médaille Fields en 2018 ?",
      answers: ["pour ses contributions au transport optimal et aux équations différentielles","pour ses travaux sur la répartition des nombres premiers","pour ses contributions à la théorie des nombres et à la dynamique","pour ses travaux sur la classification des variétés algébriques"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14167: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Alessio Figalli a-t-il reçu la Médaille Fields pour ses contributions au transport optimal et aux équations différentielles ?",
      answers: ["2014","1994","2010","2018"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14168: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 2018 pour ses contributions au transport optimal et aux équations différentielles ?",
      answers: ["Andrei Okounkov","Alessio Figalli","Akshay Venkatesh","Caucher Birkar"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14169: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Alessio Figalli a-t-il reçu la Médaille Fields en 2018 ?",
      answers: ["pour ses contributions au transport optimal et aux équations différentielles","pour ses contributions à la théorie des nombres et à la dynamique","pour ses travaux sur la répartition des nombres premiers","pour ses contributions aux systèmes dynamiques et à la théorie du chaos"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14170: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Peter Scholze a-t-il reçu la Médaille Fields pour sa création des espaces perfectoïdes en géométrie arithmétique ?",
      answers: ["1970","1994","2018","2014"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14171: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 2018 pour sa création des espaces perfectoïdes en géométrie arithmétique ?",
      answers: ["Martin Hairer","Maryna Viazovska","Caucher Birkar","Peter Scholze"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14172: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Peter Scholze a-t-il reçu la Médaille Fields en 2018 ?",
      answers: ["pour ses contributions au transport optimal et aux équations différentielles","pour ses travaux sur les variétés abéliennes et la géométrie algébrique","pour sa création des espaces perfectoïdes en géométrie arithmétique","pour ses travaux sur la classification des variétés algébriques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14173: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Akshay Venkatesh a-t-il reçu la Médaille Fields pour ses contributions à la théorie des nombres et à la dynamique ?",
      answers: ["2018","1986","2014","1974"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14174: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 2018 pour ses contributions à la théorie des nombres et à la dynamique ?",
      answers: ["Alessio Figalli","Akshay Venkatesh","June Huh","Caucher Birkar"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14175: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Akshay Venkatesh a-t-il reçu la Médaille Fields en 2018 ?",
      answers: ["pour ses contributions aux systèmes dynamiques et à la théorie du chaos","pour ses contributions au transport optimal et aux équations différentielles","pour ses contributions à la théorie des nombres et à la dynamique","pour sa création des espaces perfectoïdes en géométrie arithmétique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14176: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Hugo Duminil-Copin a-t-il reçu la Médaille Fields pour ses travaux sur les transitions de phase en physique statistique ?",
      answers: ["2022","2018","1982","2014"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14177: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 2022 pour ses travaux sur les transitions de phase en physique statistique ?",
      answers: ["June Huh","James Maynard","Hugo Duminil-Copin","William Thurston"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14178: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Hugo Duminil-Copin a-t-il reçu la Médaille Fields en 2022 ?",
      answers: ["pour sa résolution du problème de Burnside restreint en théorie des groupes","pour ses contributions à l’analyse harmonique, la théorie des nombres et les équations différentielles","pour ses travaux en géométrie algébrique et en physique mathématique","pour ses travaux sur les transitions de phase en physique statistique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14179: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année June Huh a-t-il reçu la Médaille Fields pour ses contributions à la combinatoire via la théorie de Hodge ?",
      answers: ["2022","2006","2018","1990"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14180: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 2022 pour ses contributions à la combinatoire via la théorie de Hodge ?",
      answers: ["Hugo Duminil-Copin","Maryna Viazovska","June Huh","James Maynard"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14181: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison June Huh a-t-il reçu la Médaille Fields en 2022 ?",
      answers: ["pour ses contributions à la combinatoire via la théorie de Hodge","pour ses contributions au transport optimal et aux équations différentielles","pour sa classification des variétés de dimension quatre","pour sa résolution du problème d’empilement des sphères en dimension 8"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14182: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année James Maynard a-t-il reçu la Médaille Fields pour ses travaux sur la répartition des nombres premiers ?",
      answers: ["2022","2006","2018","2002"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14183: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 2022 pour ses travaux sur la répartition des nombres premiers ?",
      answers: ["Maryna Viazovska","Martin Hairer","James Maynard","Maxim Kontsevich"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14184: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison James Maynard a-t-il reçu la Médaille Fields en 2022 ?",
      answers: ["pour ses travaux sur les transitions de phase en physique statistique","pour ses travaux sur la répartition des nombres premiers","pour sa preuve du lemme fondamental dans le programme de Langlands","pour ses contributions aux systèmes dynamiques et à la théorie du chaos"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14185: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "En quelle année Maryna Viazovska a-t-il reçu la Médaille Fields pour sa résolution du problème d’empilement des sphères en dimension 8 ?",
      answers: ["1982","2022","1962","2018"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14186: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Qui a reçu la Médaille Fields en 2022 pour sa résolution du problème d’empilement des sphères en dimension 8 ?",
      answers: ["Maryna Viazovska","Andrei Okounkov","Vladimir Drinfeld","Hugo Duminil-Copin"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14187: {
      themes: ["Mathématiques","Histoire","Science","Science et Nature","Médaille Fields","Divers"],
      question: "Pour quelle raison Maryna Viazovska a-t-il reçu la Médaille Fields en 2022 ?",
      answers: ["pour ses travaux sur les transitions de phase en physique statistique","pour ses contributions à la combinatoire via la théorie de Hodge","pour sa résolution du problème d’empilement des sphères en dimension 8","pour ses travaux sur la classification des variétés algébriques"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14188: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Alan J. Perlis a-t-il reçu le Prix Turing pour son travail pionnier sur les compilateurs et les langages de programmation ?",
      answers: ["1971","1967","1966","1968"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14189: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1966 pour son travail pionnier sur les compilateurs et les langages de programmation ?",
      answers: ["Marvin Minsky","Stephen A. Cook","Alan J. Perlis","James H. Wilkinson"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14190: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Alan J. Perlis a-t-il reçu le Prix Turing en 1966 ?",
      answers: ["pour son travail pionnier sur les compilateurs et les langages de programmation","pour ses contributions à l’intelligence artificielle et aux systèmes cognitifs","pour le développement des langages Pascal et Modula","pour la conception et la construction du premier ordinateur à programme enregistré"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14191: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Maurice V. Wilkes a-t-il reçu le Prix Turing pour la conception et la construction du premier ordinateur à programme enregistré ?",
      answers: ["2010","1967","1966","1968"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14192: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1967 pour la conception et la construction du premier ordinateur à programme enregistré ?",
      answers: ["Donald E. Knuth","Raj Reddy","Richard W. Hamming","Maurice V. Wilkes"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14193: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Maurice V. Wilkes a-t-il reçu le Prix Turing en 1967 ?",
      answers: ["pour la conception et la construction du premier ordinateur à programme enregistré","pour ses travaux sur les codes correcteurs d’erreurs et la théorie de l’information","pour ses contributions à la conception des premiers ordinateurs personnels","pour ses contributions aux systèmes distribués et aux ordinateurs personnels"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14194: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Richard W. Hamming a-t-il reçu le Prix Turing pour ses travaux sur les codes correcteurs d’erreurs et la théorie de l’information ?",
      answers: ["1973","1968","2012","1980"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14195: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1968 pour ses travaux sur les codes correcteurs d’erreurs et la théorie de l’information ?",
      answers: ["Fernando J. Corbató","Allen Newell","Richard W. Hamming","Dana S. Scott"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14196: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Richard W. Hamming a-t-il reçu le Prix Turing en 1968 ?",
      answers: ["pour ses travaux sur les codes correcteurs d’erreurs et la théorie de l’information","pour ses contributions fondamentales à l’intelligence artificielle","pour la conception et la construction du premier ordinateur à programme enregistré","pour ses contributions aux systèmes de bases de données"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14197: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Marvin Minsky a-t-il reçu le Prix Turing pour ses contributions fondamentales à l’intelligence artificielle ?",
      answers: ["1969","1985","1971","1970"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14198: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1969 pour ses contributions fondamentales à l’intelligence artificielle ?",
      answers: ["David A. Patterson","Michael O. Rabin","Marvin Minsky","Maurice V. Wilkes"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14199: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Marvin Minsky a-t-il reçu le Prix Turing en 1969 ?",
      answers: ["pour ses contributions fondamentales à l’intelligence artificielle","pour ses recherches en analyse numérique et en calcul scientifique","pour la conception et la construction du premier ordinateur à programme enregistré","pour la création du modèle relationnel des bases de données"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14200: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année James H. Wilkinson a-t-il reçu le Prix Turing pour ses recherches en analyse numérique et en calcul scientifique ?",
      answers: ["1968","1978","1970","1969"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14201: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1970 pour ses recherches en analyse numérique et en calcul scientifique ?",
      answers: ["James H. Wilkinson","Edsger W. Dijkstra","Richard M. Karp","Dennis M. Ritchie"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14202: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison James H. Wilkinson a-t-il reçu le Prix Turing en 1970 ?",
      answers: ["pour la conception et la construction du premier ordinateur à programme enregistré","pour ses recherches en analyse numérique et en calcul scientifique","pour ses travaux sur les automates et la théorie de la calculabilité","pour ses travaux sur la programmation structurée et les algorithmes"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14203: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année John McCarthy a-t-il reçu le Prix Turing pour ses contributions à l’intelligence artificielle et au langage LISP ?",
      answers: ["1971","2009","1981","1970"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14204: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1971 pour ses contributions à l’intelligence artificielle et au langage LISP ?",
      answers: ["John Backus","John McCarthy","Marvin Minsky","Richard M. Karp"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14205: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison John McCarthy a-t-il reçu le Prix Turing en 1971 ?",
      answers: ["pour ses travaux sur les automates et la théorie de la calculabilité","pour ses contributions à l’intelligence artificielle et au langage LISP","pour ses contributions aux algorithmes et aux compilateurs","pour la création du paradigme de programmation orientée objet"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14206: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Edsger W. Dijkstra a-t-il reçu le Prix Turing pour ses travaux sur la programmation structurée et les algorithmes ?",
      answers: ["1972","1971","1969","1970"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14207: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1972 pour ses travaux sur la programmation structurée et les algorithmes ?",
      answers: ["Edsger W. Dijkstra","Richard M. Karp","Marvin Minsky","John Backus"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14208: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Edsger W. Dijkstra a-t-il reçu le Prix Turing en 1972 ?",
      answers: ["pour ses contributions aux systèmes d’exploitation à temps partagé","pour ses travaux sur la programmation structurée et les algorithmes","pour ses contributions fondamentales à l’intelligence artificielle","pour ses recherches en analyse numérique et en calcul scientifique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14209: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Charles W. Bachman a-t-il reçu le Prix Turing pour ses contributions aux systèmes de bases de données ?",
      answers: ["1967","1974","1970","1973"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14210: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1973 pour ses contributions aux systèmes de bases de données ?",
      answers: ["Donald E. Knuth","Charles W. Bachman","Niklaus Wirth","Manuel Blum"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14211: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Charles W. Bachman a-t-il reçu le Prix Turing en 1973 ?",
      answers: ["pour ses contributions aux systèmes de bases de données","pour l’invention du World Wide Web","pour ses travaux sur les codes correcteurs d’erreurs et la théorie de l’information","pour ses contributions à l’intelligence artificielle et au langage LISP"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14212: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Donald E. Knuth a-t-il reçu le Prix Turing pour ses travaux sur les algorithmes et l’art de programmer ?",
      answers: ["1992","1999","1996","1974"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14213: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1974 pour ses travaux sur les algorithmes et l’art de programmer ?",
      answers: ["Donald E. Knuth","Martin E. Hellman","John Backus","Allen Newell"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14214: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Donald E. Knuth a-t-il reçu le Prix Turing en 1974 ?",
      answers: ["pour ses contributions aux bases de données et aux transactions","pour la création d’UNIX et ses contributions aux systèmes d’exploitation","pour ses travaux sur les automates et la théorie de la calculabilité","pour ses travaux sur les algorithmes et l’art de programmer"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14215: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Allen Newell a-t-il reçu le Prix Turing pour ses contributions à l’intelligence artificielle et aux systèmes cognitifs ?",
      answers: ["1970","1974","1975","1973"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14216: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1975 pour ses contributions à l’intelligence artificielle et aux systèmes cognitifs ?",
      answers: ["Donald E. Knuth","Herbert A. Simon","Allen Newell","Charles P. Thacker"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14217: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Allen Newell a-t-il reçu le Prix Turing en 1975 ?",
      answers: ["pour ses contributions à l’intelligence artificielle et aux systèmes cognitifs","pour ses travaux sur les algorithmes et l’art de programmer","pour ses travaux sur les codes correcteurs d’erreurs et la théorie de l’information","pour ses contributions à la théorie des algorithmes et de la complexité"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14218: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Herbert A. Simon a-t-il reçu le Prix Turing pour ses contributions à l’intelligence artificielle et aux systèmes cognitifs ?",
      answers: ["1977","1975","2018","1974"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14219: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1975 pour ses contributions à l’intelligence artificielle et aux systèmes cognitifs ?",
      answers: ["Herbert A. Simon","John Backus","Richard M. Karp","Allen Newell"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14220: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Herbert A. Simon a-t-il reçu le Prix Turing en 1975 ?",
      answers: ["pour ses contributions à l’apprentissage profond","pour ses contributions à la théorie de la complexité computationnelle","pour ses contributions fondamentales à l’intelligence artificielle","pour ses contributions à l’intelligence artificielle et aux systèmes cognitifs"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14221: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Michael O. Rabin a-t-il reçu le Prix Turing pour ses travaux sur les automates et la théorie de la calculabilité ?",
      answers: ["1969","1975","1977","1976"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14222: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1976 pour ses travaux sur les automates et la théorie de la calculabilité ?",
      answers: ["Herbert A. Simon","Michael O. Rabin","Dana S. Scott","Kenneth E. Iverson"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14223: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Michael O. Rabin a-t-il reçu le Prix Turing en 1976 ?",
      answers: ["pour ses contributions à l’intelligence artificielle et aux systèmes cognitifs","pour ses recherches en analyse numérique et en calcul scientifique","pour ses travaux sur les automates et la théorie de la calculabilité","pour ses travaux sur la théorie des processus concurrents"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14224: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Dana S. Scott a-t-il reçu le Prix Turing pour ses travaux sur les automates et la théorie de la calculabilité ?",
      answers: ["1981","1979","1976","1974"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14225: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1976 pour ses travaux sur les automates et la théorie de la calculabilité ?",
      answers: ["John Backus","Donald E. Knuth","Dana S. Scott","Alan C. Kay"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14226: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Dana S. Scott a-t-il reçu le Prix Turing en 1976 ?",
      answers: ["pour la conception du langage FORTRAN et des compilateurs","pour ses travaux sur les automates et la théorie de la calculabilité","pour ses contributions à l’architecture des ordinateurs et aux compilateurs","pour ses contributions aux systèmes de bases de données modernes"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14227: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année John Backus a-t-il reçu le Prix Turing pour la conception du langage FORTRAN et des compilateurs ?",
      answers: ["1982","1977","1976","2002"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14228: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1977 pour la conception du langage FORTRAN et des compilateurs ?",
      answers: ["Richard W. Hamming","Robert W. Floyd","John Backus","Stephen A. Cook"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14229: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison John Backus a-t-il reçu le Prix Turing en 1977 ?",
      answers: ["pour ses recherches en analyse numérique et en calcul scientifique","pour ses contributions à l’intelligence artificielle et au langage LISP","pour la conception du langage FORTRAN et des compilateurs","pour ses contributions à la théorie de la complexité computationnelle"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14230: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Robert W. Floyd a-t-il reçu le Prix Turing pour ses contributions à la vérification des programmes et aux algorithmes ?",
      answers: ["1978","1977","2001","1976"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14231: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1978 pour ses contributions à la vérification des programmes et aux algorithmes ?",
      answers: ["Silvio Micali","Douglas C. Engelbart","Robert W. Floyd","John Backus"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14232: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Robert W. Floyd a-t-il reçu le Prix Turing en 1978 ?",
      answers: ["pour ses contributions au développement d’Internet et de TCP/IP","pour la conception du langage FORTRAN et des compilateurs","pour ses contributions à la vérification des programmes et aux algorithmes","pour ses contributions à la théorie des algorithmes et de la complexité"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14233: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Kenneth E. Iverson a-t-il reçu le Prix Turing pour la création du langage APL et ses applications ?",
      answers: ["1979","1987","2008","1977"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14234: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1979 pour la création du langage APL et ses applications ?",
      answers: ["John Backus","Michael O. Rabin","Kenneth E. Iverson","Douglas C. Engelbart"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14235: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Kenneth E. Iverson a-t-il reçu le Prix Turing en 1979 ?",
      answers: ["pour ses travaux sur la sémantique des langages de programmation","pour la création du langage APL et ses applications","pour la création du modèle relationnel des bases de données","pour ses contributions aux systèmes d’exploitation à temps partagé"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14236: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année C. Antony R. Hoare a-t-il reçu le Prix Turing pour ses travaux sur la sémantique des langages de programmation ?",
      answers: ["2011","1990","1980","1993"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14237: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1980 pour ses travaux sur la sémantique des langages de programmation ?",
      answers: ["C. Antony R. Hoare","Robert W. Floyd","Herbert A. Simon","Edgar F. Codd"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14238: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison C. Antony R. Hoare a-t-il reçu le Prix Turing en 1980 ?",
      answers: ["pour ses travaux sur la sémantique des langages de programmation","pour la création du modèle relationnel des bases de données","pour ses contributions à la théorie de la complexité computationnelle","pour la création du langage APL et ses applications"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14239: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Edgar F. Codd a-t-il reçu le Prix Turing pour la création du modèle relationnel des bases de données ?",
      answers: ["1983","1979","1981","1986"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14240: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1981 pour la création du modèle relationnel des bases de données ?",
      answers: ["Donald E. Knuth","Peter Naur","Dennis M. Ritchie","Edgar F. Codd"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14241: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Edgar F. Codd a-t-il reçu le Prix Turing en 1981 ?",
      answers: ["pour la création du modèle relationnel des bases de données","pour la création d’UNIX et ses contributions aux systèmes d’exploitation","pour ses contributions à la théorie des algorithmes et de la complexité","pour ses contributions à l’intelligence artificielle et au langage LISP"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14242: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Stephen A. Cook a-t-il reçu le Prix Turing pour ses contributions à la théorie de la complexité computationnelle ?",
      answers: ["1986","1982","1970","1991"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14243: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1982 pour ses contributions à la théorie de la complexité computationnelle ?",
      answers: ["Stephen A. Cook","Robert M. Metcalfe","Allen Newell","Leslie Lamport"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14244: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Stephen A. Cook a-t-il reçu le Prix Turing en 1982 ?",
      answers: ["pour ses contributions aux systèmes distribués et aux ordinateurs personnels","pour la création d’UNIX et du langage C","pour ses travaux sur la sémantique des langages de programmation","pour ses contributions à la théorie de la complexité computationnelle"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14245: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Ken Thompson a-t-il reçu le Prix Turing pour la création d’UNIX et ses contributions aux systèmes d’exploitation ?",
      answers: ["1988","2012","1979","1983"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14246: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1983 pour la création d’UNIX et ses contributions aux systèmes d’exploitation ?",
      answers: ["Amir Pnueli","Ken Thompson","Dennis M. Ritchie","Avi Wigderson"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14247: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Ken Thompson a-t-il reçu le Prix Turing en 1983 ?",
      answers: ["pour la création d’UNIX et ses contributions aux systèmes d’exploitation","pour ses contributions aux systèmes experts et à l’IA","pour ses contributions au développement d’Internet et de TCP/IP","pour la création d’UNIX et du langage C"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14248: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Dennis M. Ritchie a-t-il reçu le Prix Turing pour la création d’UNIX et du langage C ?",
      answers: ["1983","1984","1974","1988"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14249: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1983 pour la création d’UNIX et du langage C ?",
      answers: ["Marvin Minsky","Dennis M. Ritchie","William M. Kahan","Ken Thompson"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14250: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Dennis M. Ritchie a-t-il reçu le Prix Turing en 1983 ?",
      answers: ["pour la création d’UNIX et du langage C","pour le développement des langages Pascal et Modula","pour ses contributions au développement d’Internet et de TCP/IP","pour ses contributions à la théorie de la complexité computationnelle"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14251: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Niklaus Wirth a-t-il reçu le Prix Turing pour le développement des langages Pascal et Modula ?",
      answers: ["1976","1984","2022","1985"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14252: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1984 pour le développement des langages Pascal et Modula ?",
      answers: ["Butler W. Lampson","Kenneth E. Iverson","Niklaus Wirth","Yoshua Bengio"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14253: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Niklaus Wirth a-t-il reçu le Prix Turing en 1984 ?",
      answers: ["pour la création du langage APL et ses applications","pour ses travaux sur l’arithmétique en virgule flottante","pour ses contributions à la conception des premiers ordinateurs personnels","pour le développement des langages Pascal et Modula"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14254: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Richard M. Karp a-t-il reçu le Prix Turing pour ses contributions à la théorie des algorithmes et de la complexité ?",
      answers: ["2000","1973","1985","1986"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14255: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1985 pour ses contributions à la théorie des algorithmes et de la complexité ?",
      answers: ["Dana S. Scott","Niklaus Wirth","Fernando J. Corbató","Richard M. Karp"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14256: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Richard M. Karp a-t-il reçu le Prix Turing en 1985 ?",
      answers: ["pour la création d’UNIX et du langage C","pour la conception du langage FORTRAN et des compilateurs","pour ses contributions à la théorie des algorithmes et de la complexité","pour ses contributions à l’architecture des ordinateurs et aux compilateurs"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14257: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année John E. Hopcroft a-t-il reçu le Prix Turing pour ses travaux sur les algorithmes et la théorie des automates ?",
      answers: ["1987","1993","1990","1986"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14258: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1986 pour ses travaux sur les algorithmes et la théorie des automates ?",
      answers: ["Edsger W. Dijkstra","John E. Hopcroft","Leonard M. Adleman","Robert E. Tarjan"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14259: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison John E. Hopcroft a-t-il reçu le Prix Turing en 1986 ?",
      answers: ["pour ses travaux sur les algorithmes et la théorie des automates","pour ses contributions au développement d’Internet et de TCP/IP","pour le développement des langages Pascal et Modula","pour ses contributions à la théorie des algorithmes et de la complexité"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14260: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Robert E. Tarjan a-t-il reçu le Prix Turing pour ses travaux sur les algorithmes et les structures de données ?",
      answers: ["2006","1986","1991","1981"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14261: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1986 pour ses travaux sur les algorithmes et les structures de données ?",
      answers: ["Richard M. Karp","Robert E. Tarjan","John E. Hopcroft","Butler W. Lampson"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14262: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Robert E. Tarjan a-t-il reçu le Prix Turing en 1986 ?",
      answers: ["pour ses contributions à la théorie de la complexité computationnelle","pour ses travaux sur la sémantique des langages de programmation","pour ses contributions aux systèmes d’exploitation à temps partagé","pour ses travaux sur les algorithmes et les structures de données"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14263: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année John Cocke a-t-il reçu le Prix Turing pour ses contributions à l’architecture des ordinateurs et aux compilateurs ?",
      answers: ["1970","1986","1987","1991"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14264: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1987 pour ses contributions à l’architecture des ordinateurs et aux compilateurs ?",
      answers: ["John Cocke","Charles W. Bachman","James N. Gray","Leslie Lamport"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14265: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison John Cocke a-t-il reçu le Prix Turing en 1987 ?",
      answers: ["pour ses contributions à l’intelligence artificielle et aux systèmes cognitifs","pour ses contributions aux graphismes interactifs et à la CAO","pour ses contributions à l’architecture des ordinateurs et aux compilateurs","pour la création d’UNIX et ses contributions aux systèmes d’exploitation"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14266: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Ivan E. Sutherland a-t-il reçu le Prix Turing pour ses contributions aux graphismes interactifs et à la CAO ?",
      answers: ["2006","1988","1987","1986"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14267: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1988 pour ses contributions aux graphismes interactifs et à la CAO ?",
      answers: ["Ivan E. Sutherland","Fernando J. Corbató","Yann LeCun","Robin Milner"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14268: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Ivan E. Sutherland a-t-il reçu le Prix Turing en 1988 ?",
      answers: ["pour ses contributions aux systèmes distribués et aux ordinateurs personnels","pour ses travaux sur la cryptographie et la théorie de la complexité","pour ses travaux sur l’arithmétique en virgule flottante","pour ses contributions aux graphismes interactifs et à la CAO"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14269: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année William M. Kahan a-t-il reçu le Prix Turing pour ses travaux sur l’arithmétique en virgule flottante ?",
      answers: ["1987","1989","1992","1991"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14270: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1989 pour ses travaux sur l’arithmétique en virgule flottante ?",
      answers: ["Edward A. Feigenbaum","William M. Kahan","John E. Hopcroft","Butler W. Lampson"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14271: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison William M. Kahan a-t-il reçu le Prix Turing en 1989 ?",
      answers: ["pour ses contributions aux systèmes experts et à l’IA","pour ses contributions à l’apprentissage profond","pour ses travaux sur l’arithmétique en virgule flottante","pour ses contributions aux bases de données et aux transactions"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14272: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Fernando J. Corbató a-t-il reçu le Prix Turing pour ses contributions aux systèmes d’exploitation à temps partagé ?",
      answers: ["1993","1997","1990","1991"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14273: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1990 pour ses contributions aux systèmes d’exploitation à temps partagé ?",
      answers: ["Douglas C. Engelbart","Fernando J. Corbató","Edsger W. Dijkstra","John Backus"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14274: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Fernando J. Corbató a-t-il reçu le Prix Turing en 1990 ?",
      answers: ["pour ses contributions aux systèmes d’exploitation à temps partagé","pour la création du paradigme de programmation orientée objet","pour ses contributions à la vérification formelle des systèmes","pour ses contributions aux systèmes distribués et aux ordinateurs personnels"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14275: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Robin Milner a-t-il reçu le Prix Turing pour ses travaux sur la théorie des processus concurrents ?",
      answers: ["1991","1968","1992","1995"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14276: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1991 pour ses travaux sur la théorie des processus concurrents ?",
      answers: ["Vinton G. Cerf","Fernando J. Corbató","Robin Milner","Frances E. Allen"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14277: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Robin Milner a-t-il reçu le Prix Turing en 1991 ?",
      answers: ["pour la création d’UNIX et ses contributions aux systèmes d’exploitation","pour ses travaux sur la théorie des processus concurrents","pour ses contributions à la cryptographie et à la théorie des jeux","pour ses contributions à l’architecture des ordinateurs et aux compilateurs"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14278: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Butler W. Lampson a-t-il reçu le Prix Turing pour ses contributions aux systèmes distribués et aux ordinateurs personnels ?",
      answers: ["1992","2001","1981","1978"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14279: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1992 pour ses contributions aux systèmes distribués et aux ordinateurs personnels ?",
      answers: ["Fernando J. Corbató","Richard E. Stearns","Butler W. Lampson","John E. Hopcroft"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14280: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Butler W. Lampson a-t-il reçu le Prix Turing en 1992 ?",
      answers: ["pour la création d’UNIX et ses contributions aux systèmes d’exploitation","pour ses travaux sur la théorie des processus concurrents","pour ses contributions à la reconnaissance vocale et à l’IA","pour ses contributions aux systèmes distribués et aux ordinateurs personnels"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14281: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Juris Hartmanis a-t-il reçu le Prix Turing pour ses contributions à la théorie de la complexité computationnelle ?",
      answers: ["1976","1988","1989","1993"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14282: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1993 pour ses contributions à la théorie de la complexité computationnelle ?",
      answers: ["Juris Hartmanis","Jack J. Dongarra","Manuel Blum","Douglas C. Engelbart"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14283: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Juris Hartmanis a-t-il reçu le Prix Turing en 1993 ?",
      answers: ["pour ses travaux sur la théorie des processus concurrents","pour ses contributions à la théorie de la complexité computationnelle","pour ses contributions à la reconnaissance vocale et à l’IA","pour ses contributions à la théorie des algorithmes et de la complexité"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14284: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Richard E. Stearns a-t-il reçu le Prix Turing pour ses contributions à la théorie de la complexité computationnelle ?",
      answers: ["2001","1993","2008","1997"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14285: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1993 pour ses contributions à la théorie de la complexité computationnelle ?",
      answers: ["Juris Hartmanis","Richard E. Stearns","Allen Newell","Edward A. Feigenbaum"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14286: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Richard E. Stearns a-t-il reçu le Prix Turing en 1993 ?",
      answers: ["pour ses travaux sur la cryptographie et la théorie de la complexité","pour la création du paradigme de programmation orientée objet","pour ses contributions à la théorie de la complexité computationnelle","pour la conception et la construction du premier ordinateur à programme enregistré"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14287: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Edward A. Feigenbaum a-t-il reçu le Prix Turing pour ses contributions aux systèmes experts et à l’IA ?",
      answers: ["1989","1993","1991","1994"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14288: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1994 pour ses contributions aux systèmes experts et à l’IA ?",
      answers: ["Alan C. Kay","Raj Reddy","Edward A. Feigenbaum","Edsger W. Dijkstra"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14289: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Edward A. Feigenbaum a-t-il reçu le Prix Turing en 1994 ?",
      answers: ["pour la création du langage APL et ses applications","pour ses contributions aux systèmes experts et à l’IA","pour ses travaux sur la sémantique des langages de programmation","pour ses contributions à la reconnaissance vocale et à l’IA"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14290: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Raj Reddy a-t-il reçu le Prix Turing pour ses contributions à la reconnaissance vocale et à l’IA ?",
      answers: ["2021","2000","1994","2003"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14291: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1994 pour ses contributions à la reconnaissance vocale et à l’IA ?",
      answers: ["Raj Reddy","Andrew G. Barto","E. Allen Emerson","Leslie Lamport"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14292: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Raj Reddy a-t-il reçu le Prix Turing en 1994 ?",
      answers: ["pour ses contributions aux systèmes d’exploitation à temps partagé","pour ses travaux sur la théorie des processus concurrents","pour ses contributions aux bases de données et aux transactions","pour ses contributions à la reconnaissance vocale et à l’IA"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14293: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Manuel Blum a-t-il reçu le Prix Turing pour ses travaux sur la cryptographie et la théorie de la complexité ?",
      answers: ["2000","2004","1999","1995"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14294: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1995 pour ses travaux sur la cryptographie et la théorie de la complexité ?",
      answers: ["C. Antony R. Hoare","Manuel Blum","Ivan E. Sutherland","Amir Pnueli"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14295: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Manuel Blum a-t-il reçu le Prix Turing en 1995 ?",
      answers: ["pour ses travaux sur la cryptographie et la théorie de la complexité","pour ses contributions à la cryptographie à clé publique","pour ses contributions au développement d’Internet et de TCP/IP","pour ses contributions à la reconnaissance vocale et à l’IA"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14296: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Amir Pnueli a-t-il reçu le Prix Turing pour ses contributions à la vérification temporelle des systèmes ?",
      answers: ["1996","1977","1979","2009"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14297: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1996 pour ses contributions à la vérification temporelle des systèmes ?",
      answers: ["Richard M. Karp","Amir Pnueli","Whitfield Diffie","Edward A. Feigenbaum"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14298: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Amir Pnueli a-t-il reçu le Prix Turing en 1996 ?",
      answers: ["pour ses contributions à la théorie de la complexité et à la cryptographie","pour ses travaux sur les algorithmes et la théorie des automates","pour ses contributions à la vérification temporelle des systèmes","pour ses contributions à la cryptographie à clé publique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14299: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Douglas C. Engelbart a-t-il reçu le Prix Turing pour ses inventions sur l’interaction homme-ordinateur ?",
      answers: ["1996","1979","1994","1997"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14300: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1997 pour ses inventions sur l’interaction homme-ordinateur ?",
      answers: ["Juris Hartmanis","Kristen Nygaard","Kenneth E. Iverson","Douglas C. Engelbart"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14301: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Douglas C. Engelbart a-t-il reçu le Prix Turing en 1997 ?",
      answers: ["pour ses inventions sur l’interaction homme-ordinateur","pour ses contributions à la théorie de la complexité et à la cryptographie","pour ses travaux sur l’arithmétique en virgule flottante","pour ses travaux sur la théorie des processus concurrents"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14302: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année James N. Gray a-t-il reçu le Prix Turing pour ses contributions aux bases de données et aux transactions ?",
      answers: ["1998","2013","1997","2003"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14303: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1998 pour ses contributions aux bases de données et aux transactions ?",
      answers: ["James N. Gray","Juris Hartmanis","Charles W. Bachman","Amir Pnueli"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14304: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison James N. Gray a-t-il reçu le Prix Turing en 1998 ?",
      answers: ["pour ses contributions aux bases de données et aux transactions","pour ses contributions à l’optimisation des compilateurs","pour ses contributions à l’architecture logicielle et à la gestion de projets","pour ses contributions aux systèmes distribués et aux ordinateurs personnels"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14305: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Frederick P. Brooks Jr. a-t-il reçu le Prix Turing pour ses contributions à l’architecture logicielle et à la gestion de projets ?",
      answers: ["2021","2010","1999","2000"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14306: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 1999 pour ses contributions à l’architecture logicielle et à la gestion de projets ?",
      answers: ["Charles W. Bachman","Frederick P. Brooks Jr.","Douglas C. Engelbart","Richard S. Sutton"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14307: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Frederick P. Brooks Jr. a-t-il reçu le Prix Turing en 1999 ?",
      answers: ["pour la création d’UNIX et ses contributions aux systèmes d’exploitation","pour ses contributions à la vérification temporelle des systèmes","pour ses contributions aux graphismes interactifs et à la CAO","pour ses contributions à l’architecture logicielle et à la gestion de projets"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14308: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Andrew C. Yao a-t-il reçu le Prix Turing pour ses contributions à la théorie de la complexité et à la cryptographie ?",
      answers: ["2006","2003","2000","1975"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14309: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2000 pour ses contributions à la théorie de la complexité et à la cryptographie ?",
      answers: ["Kristen Nygaard","Andrew C. Yao","Douglas C. Engelbart","Vinton G. Cerf"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14310: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Andrew C. Yao a-t-il reçu le Prix Turing en 2000 ?",
      answers: ["pour ses contributions à la théorie de la complexité et à la cryptographie","pour ses contributions à l’apprentissage profond","pour ses contributions aux graphismes 3D et à l’imagerie numérique","pour ses contributions à l’optimisation des compilateurs"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14311: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Ole-Johan Dahl a-t-il reçu le Prix Turing pour la création du paradigme de programmation orientée objet ?",
      answers: ["2001","2002","1999","2000"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14312: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2001 pour la création du paradigme de programmation orientée objet ?",
      answers: ["Kristen Nygaard","Ole-Johan Dahl","Kenneth E. Iverson","Juris Hartmanis"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14313: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Ole-Johan Dahl a-t-il reçu le Prix Turing en 2001 ?",
      answers: ["pour ses contributions aux interfaces graphiques et à la programmation orientée objet","pour ses contributions à la cryptographie à clé publique","pour ses contributions à l’architecture des ordinateurs et aux compilateurs","pour la création du paradigme de programmation orientée objet"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14314: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Kristen Nygaard a-t-il reçu le Prix Turing pour la création du paradigme de programmation orientée objet ?",
      answers: ["1991","2001","1990","2020"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14315: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2001 pour la création du paradigme de programmation orientée objet ?",
      answers: ["Robert E. Kahn","Kristen Nygaard","Dennis M. Ritchie","Ole-Johan Dahl"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14316: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Kristen Nygaard a-t-il reçu le Prix Turing en 2001 ?",
      answers: ["pour ses contributions à la cryptographie à clé publique","pour la création du paradigme de programmation orientée objet","pour ses contributions aux algorithmes numériques et aux bibliothèques logicielles","pour ses contributions aux bases de données et aux transactions"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14317: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Ronald L. Rivest a-t-il reçu le Prix Turing pour ses contributions à la cryptographie à clé publique ?",
      answers: ["2002","2013","2001","2012"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14318: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2002 pour ses contributions à la cryptographie à clé publique ?",
      answers: ["Niklaus Wirth","E. Allen Emerson","Ronald L. Rivest","Adi Shamir"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14319: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Ronald L. Rivest a-t-il reçu le Prix Turing en 2002 ?",
      answers: ["pour ses contributions à l’architecture logicielle et à la gestion de projets","pour ses contributions à la cryptographie à clé publique","pour ses contributions aux fondements de l’apprentissage par renforcement","pour ses contributions au développement d’Internet et de TCP/IP"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14320: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Adi Shamir a-t-il reçu le Prix Turing pour ses contributions à la cryptographie à clé publique ?",
      answers: ["2002","1995","2005","2000"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14321: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2002 pour ses contributions à la cryptographie à clé publique ?",
      answers: ["Butler W. Lampson","Adi Shamir","Allen Newell","Frederick P. Brooks Jr."],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14322: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Adi Shamir a-t-il reçu le Prix Turing en 2002 ?",
      answers: ["pour ses inventions sur l’interaction homme-ordinateur","pour ses travaux sur la cryptographie et la théorie de la complexité","pour ses contributions à la théorie de la complexité et à la cryptographie","pour ses contributions à la cryptographie à clé publique"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14323: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Leonard M. Adleman a-t-il reçu le Prix Turing pour ses contributions à la cryptographie à clé publique ?",
      answers: ["2002","1994","2001","2004"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14324: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2002 pour ses contributions à la cryptographie à clé publique ?",
      answers: ["Ronald L. Rivest","Leonard M. Adleman","Charles P. Thacker","Robert E. Kahn"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14325: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Leonard M. Adleman a-t-il reçu le Prix Turing en 2002 ?",
      answers: ["pour ses contributions à la vérification formelle des systèmes","pour ses travaux sur les langages de programmation et la définition d’ALGOL","pour ses contributions à la cryptographie à clé publique","pour ses contributions à la cryptographie et à la théorie des jeux"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14326: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Alan C. Kay a-t-il reçu le Prix Turing pour ses contributions aux interfaces graphiques et à la programmation orientée objet ?",
      answers: ["2003","2002","2001","2013"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14327: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2003 pour ses contributions aux interfaces graphiques et à la programmation orientée objet ?",
      answers: ["Adi Shamir","Geoffrey E. Hinton","Robert W. Floyd","Alan C. Kay"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14328: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Alan C. Kay a-t-il reçu le Prix Turing en 2003 ?",
      answers: ["pour ses travaux sur les langages de programmation et la définition d’ALGOL","pour ses contributions aux interfaces graphiques et à la programmation orientée objet","pour ses travaux sur les algorithmes et l’art de programmer","pour ses contributions à la cryptographie et à la théorie des jeux"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14329: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Vinton G. Cerf a-t-il reçu le Prix Turing pour ses contributions au développement d’Internet et de TCP/IP ?",
      answers: ["2005","2004","2007","2006"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14330: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2004 pour ses contributions au développement d’Internet et de TCP/IP ?",
      answers: ["Barbara H. Liskov","Martin E. Hellman","Ronald L. Rivest","Vinton G. Cerf"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14331: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Vinton G. Cerf a-t-il reçu le Prix Turing en 2004 ?",
      answers: ["pour la création du paradigme de programmation orientée objet","pour ses contributions aux systèmes de bases de données modernes","pour ses contributions à la conception des premiers ordinateurs personnels","pour ses contributions au développement d’Internet et de TCP/IP"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14332: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Robert E. Kahn a-t-il reçu le Prix Turing pour ses contributions au développement d’Internet et de TCP/IP ?",
      answers: ["2004","2005","2012","1991"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14333: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2004 pour ses contributions au développement d’Internet et de TCP/IP ?",
      answers: ["Kristen Nygaard","Robert E. Kahn","Vinton G. Cerf","Michael Stonebraker"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14334: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Robert E. Kahn a-t-il reçu le Prix Turing en 2004 ?",
      answers: ["pour ses inventions sur l’interaction homme-ordinateur","pour ses contributions aux systèmes de bases de données modernes","pour ses contributions à l’optimisation des compilateurs","pour ses contributions au développement d’Internet et de TCP/IP"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14335: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Peter Naur a-t-il reçu le Prix Turing pour ses travaux sur les langages de programmation et la définition d’ALGOL ?",
      answers: ["2006","2011","2005","2001"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14336: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2005 pour ses travaux sur les langages de programmation et la définition d’ALGOL ?",
      answers: ["Amir Pnueli","Martin E. Hellman","Peter Naur","Joseph Sifakis"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14337: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Peter Naur a-t-il reçu le Prix Turing en 2005 ?",
      answers: ["pour ses contributions à l’optimisation des compilateurs","pour ses contributions aux réseaux bayésiens et à l’IA probabiliste","pour ses travaux sur les langages de programmation et la définition d’ALGOL","pour ses contributions à la cryptographie à clé publique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14338: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Frances E. Allen a-t-il reçu le Prix Turing pour ses contributions à l’optimisation des compilateurs ?",
      answers: ["1993","2003","1971","2006"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14339: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2006 pour ses contributions à l’optimisation des compilateurs ?",
      answers: ["E. Allen Emerson","Frances E. Allen","Silvio Micali","Alan C. Kay"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14340: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Frances E. Allen a-t-il reçu le Prix Turing en 2006 ?",
      answers: ["pour ses travaux sur l’arithmétique en virgule flottante","pour ses contributions au développement d’Internet et de TCP/IP","pour ses contributions à l’optimisation des compilateurs","pour ses contributions à la cryptographie à clé publique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14341: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Edmund M. Clarke a-t-il reçu le Prix Turing pour ses contributions à la vérification formelle des systèmes ?",
      answers: ["2007","2006","1969","1994"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14342: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2007 pour ses contributions à la vérification formelle des systèmes ?",
      answers: ["Edgar F. Codd","Edmund M. Clarke","Andrew C. Yao","E. Allen Emerson"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14343: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Edmund M. Clarke a-t-il reçu le Prix Turing en 2007 ?",
      answers: ["pour ses contributions à la vérification formelle des systèmes","pour ses contributions à l’optimisation des compilateurs","pour ses contributions à la cryptographie et à la théorie des jeux","pour ses contributions aux fondements des langages de programmation"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14344: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année E. Allen Emerson a-t-il reçu le Prix Turing pour ses contributions à la vérification formelle des systèmes ?",
      answers: ["2005","2007","2014","1999"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14345: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2007 pour ses contributions à la vérification formelle des systèmes ?",
      answers: ["C. Antony R. Hoare","Edwin E. Catmull","Leonard M. Adleman","E. Allen Emerson"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14346: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison E. Allen Emerson a-t-il reçu le Prix Turing en 2007 ?",
      answers: ["pour ses contributions à l’architecture logicielle et à la gestion de projets","pour ses contributions aux graphismes 3D et à l’imagerie numérique","pour ses contributions à la vérification formelle des systèmes","pour ses contributions aux fondements de l’apprentissage par renforcement"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14347: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Joseph Sifakis a-t-il reçu le Prix Turing pour ses contributions à la vérification formelle des systèmes ?",
      answers: ["2010","2004","2007","2008"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14348: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2007 pour ses contributions à la vérification formelle des systèmes ?",
      answers: ["E. Allen Emerson","Douglas C. Engelbart","Leslie Lamport","Joseph Sifakis"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14349: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Joseph Sifakis a-t-il reçu le Prix Turing en 2007 ?",
      answers: ["pour ses contributions aux interfaces graphiques et à la programmation orientée objet","pour ses contributions à la vérification formelle des systèmes","pour ses travaux sur les langages de programmation et la définition d’ALGOL","pour ses contributions au développement d’Internet et de TCP/IP"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14350: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Barbara H. Liskov a-t-il reçu le Prix Turing pour ses contributions aux fondements des langages de programmation ?",
      answers: ["1999","2007","2008","1982"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14351: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2008 pour ses contributions aux fondements des langages de programmation ?",
      answers: ["Manuel Blum","Barbara H. Liskov","Kristen Nygaard","Adi Shamir"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14352: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Barbara H. Liskov a-t-il reçu le Prix Turing en 2008 ?",
      answers: ["pour ses contributions aux fondements des langages de programmation","pour ses contributions à l’optimisation des compilateurs","pour ses travaux sur les langages de programmation et la définition d’ALGOL","pour ses contributions à la théorie de la computation et à l’aléatoire"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14353: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Charles P. Thacker a-t-il reçu le Prix Turing pour ses contributions à la conception des premiers ordinateurs personnels ?",
      answers: ["2008","2009","1983","2015"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14354: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2009 pour ses contributions à la conception des premiers ordinateurs personnels ?",
      answers: ["Charles P. Thacker","Martin E. Hellman","Vinton G. Cerf","Edward A. Feigenbaum"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14355: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Charles P. Thacker a-t-il reçu le Prix Turing en 2009 ?",
      answers: ["pour ses contributions aux fondements des langages de programmation","pour ses contributions aux systèmes d’exploitation à temps partagé","pour ses contributions à la conception des premiers ordinateurs personnels","pour ses contributions aux graphismes 3D et à l’imagerie numérique"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14356: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Leslie G. Valiant a-t-il reçu le Prix Turing pour ses contributions à la théorie de l’apprentissage computationnel ?",
      answers: ["2014","2002","2010","2011"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14357: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2010 pour ses contributions à la théorie de l’apprentissage computationnel ?",
      answers: ["Charles P. Thacker","Leslie G. Valiant","Raj Reddy","Ole-Johan Dahl"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14358: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Leslie G. Valiant a-t-il reçu le Prix Turing en 2010 ?",
      answers: ["pour ses travaux sur les algorithmes et les structures de données","pour ses contributions à la théorie de l’apprentissage computationnel","pour ses contributions aux fondements des langages de programmation","pour la création du paradigme de programmation orientée objet"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14359: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Judea Pearl a-t-il reçu le Prix Turing pour ses contributions aux réseaux bayésiens et à l’IA probabiliste ?",
      answers: ["2011","2014","2009","1979"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14360: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2011 pour ses contributions aux réseaux bayésiens et à l’IA probabiliste ?",
      answers: ["Silvio Micali","Joseph Sifakis","Judea Pearl","Vinton G. Cerf"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14361: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Judea Pearl a-t-il reçu le Prix Turing en 2011 ?",
      answers: ["pour ses contributions aux graphismes 3D et à l’imagerie numérique","pour ses contributions aux réseaux bayésiens et à l’IA probabiliste","pour ses contributions à la cryptographie et à la théorie des jeux","pour ses contributions à la cryptographie à clé publique"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14362: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Silvio Micali a-t-il reçu le Prix Turing pour ses contributions à la cryptographie et à la théorie des jeux ?",
      answers: ["2011","1992","2018","2012"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14363: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2012 pour ses contributions à la cryptographie et à la théorie des jeux ?",
      answers: ["Silvio Micali","Adi Shamir","Leslie G. Valiant","Yoshua Bengio"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14364: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Silvio Micali a-t-il reçu le Prix Turing en 2012 ?",
      answers: ["pour ses contributions à la cryptographie et à la théorie des jeux","pour ses contributions aux systèmes distribués et concurrents","pour ses contributions à l’apprentissage profond","pour ses contributions à la théorie de l’apprentissage computationnel"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14365: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Shafi Goldwasser a-t-il reçu le Prix Turing pour ses contributions à la cryptographie et à la théorie des jeux ?",
      answers: ["2012","2021","2013","2007"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14366: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2012 pour ses contributions à la cryptographie et à la théorie des jeux ?",
      answers: ["John L. Hennessy","Raj Reddy","John Cocke","Shafi Goldwasser"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14367: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Shafi Goldwasser a-t-il reçu le Prix Turing en 2012 ?",
      answers: ["pour ses contributions à la cryptographie et à la théorie des jeux","pour ses contributions à la cryptographie à clé publique","pour ses contributions aux systèmes de bases de données modernes","pour ses contributions à l’apprentissage profond"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14368: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Leslie Lamport a-t-il reçu le Prix Turing pour ses contributions aux systèmes distribués et concurrents ?",
      answers: ["2017","1976","1985","2013"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14369: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2013 pour ses contributions aux systèmes distribués et concurrents ?",
      answers: ["Robert M. Metcalfe","Leslie Lamport","Sir Tim Berners-Lee","Michael Stonebraker"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14370: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Leslie Lamport a-t-il reçu le Prix Turing en 2013 ?",
      answers: ["pour ses contributions à la théorie de l’apprentissage computationnel","pour ses contributions à la cryptographie et à la théorie des jeux","pour ses contributions à la cryptographie à clé publique","pour ses contributions aux systèmes distribués et concurrents"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14371: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Michael Stonebraker a-t-il reçu le Prix Turing pour ses contributions aux systèmes de bases de données modernes ?",
      answers: ["2011","2013","2017","2014"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14372: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2014 pour ses contributions aux systèmes de bases de données modernes ?",
      answers: ["Michael Stonebraker","Martin E. Hellman","Robin Milner","Juris Hartmanis"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14373: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Michael Stonebraker a-t-il reçu le Prix Turing en 2014 ?",
      answers: ["pour ses contributions à la théorie de la complexité computationnelle","pour ses contributions aux systèmes de bases de données modernes","pour ses contributions à la conception des premiers ordinateurs personnels","pour ses contributions à la vérification formelle des systèmes"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14374: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Whitfield Diffie a-t-il reçu le Prix Turing pour ses contributions à la cryptographie à clé publique ?",
      answers: ["2015","1984","2020","2011"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14375: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2015 pour ses contributions à la cryptographie à clé publique ?",
      answers: ["Michael Stonebraker","Raj Reddy","Whitfield Diffie","Martin E. Hellman"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14376: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Whitfield Diffie a-t-il reçu le Prix Turing en 2015 ?",
      answers: ["pour ses contributions à la cryptographie à clé publique","pour ses travaux sur les automates et la théorie de la calculabilité","pour ses travaux sur la cryptographie et la théorie de la complexité","pour ses contributions à l’architecture RISC"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14377: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Martin E. Hellman a-t-il reçu le Prix Turing pour ses contributions à la cryptographie à clé publique ?",
      answers: ["2021","2007","2015","2014"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14378: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2015 pour ses contributions à la cryptographie à clé publique ?",
      answers: ["Martin E. Hellman","Robin Milner","Adi Shamir","Judea Pearl"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14379: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Martin E. Hellman a-t-il reçu le Prix Turing en 2015 ?",
      answers: ["pour ses contributions à l’architecture RISC","pour ses contributions à la cryptographie à clé publique","pour ses contributions aux fondements des langages de programmation","pour ses contributions aux fondements de l’apprentissage par renforcement"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14380: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Sir Tim Berners-Lee a-t-il reçu le Prix Turing pour l’invention du World Wide Web ?",
      answers: ["2016","2015","1966","1978"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14381: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2016 pour l’invention du World Wide Web ?",
      answers: ["Dana S. Scott","Jack J. Dongarra","Frances E. Allen","Sir Tim Berners-Lee"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14382: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Sir Tim Berners-Lee a-t-il reçu le Prix Turing en 2016 ?",
      answers: ["pour ses contributions à l’apprentissage profond","pour ses contributions à la cryptographie à clé publique","pour l’invention du World Wide Web","pour ses contributions à l’optimisation des compilateurs"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14383: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année John L. Hennessy a-t-il reçu le Prix Turing pour ses contributions à l’architecture RISC ?",
      answers: ["2021","2014","2015","2017"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14384: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2017 pour ses contributions à l’architecture RISC ?",
      answers: ["David A. Patterson","John L. Hennessy","Juris Hartmanis","Yann LeCun"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14385: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison John L. Hennessy a-t-il reçu le Prix Turing en 2017 ?",
      answers: ["pour ses contributions à l’apprentissage profond","pour le développement des langages Pascal et Modula","pour l’invention du World Wide Web","pour ses contributions à l’architecture RISC"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14386: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année David A. Patterson a-t-il reçu le Prix Turing pour ses contributions à l’architecture RISC ?",
      answers: ["2014","2024","2017","2021"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14387: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2017 pour ses contributions à l’architecture RISC ?",
      answers: ["David A. Patterson","Martin E. Hellman","Judea Pearl","Sir Tim Berners-Lee"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14388: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison David A. Patterson a-t-il reçu le Prix Turing en 2017 ?",
      answers: ["pour ses contributions à la cryptographie à clé publique","pour ses contributions aux graphismes 3D et à l’imagerie numérique","pour ses contributions à l’architecture RISC","pour ses contributions à l’optimisation des compilateurs"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14389: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Yoshua Bengio a-t-il reçu le Prix Turing pour ses contributions à l’apprentissage profond ?",
      answers: ["2016","2012","1989","2018"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14390: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2018 pour ses contributions à l’apprentissage profond ?",
      answers: ["Raj Reddy","Robert M. Metcalfe","Yoshua Bengio","Robert W. Floyd"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14391: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Yoshua Bengio a-t-il reçu le Prix Turing en 2018 ?",
      answers: ["pour ses travaux sur les algorithmes et l’art de programmer","pour ses contributions à l’architecture RISC","pour ses contributions aux graphismes 3D et à l’imagerie numérique","pour ses contributions à l’apprentissage profond"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14392: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Geoffrey E. Hinton a-t-il reçu le Prix Turing pour ses contributions à l’apprentissage profond ?",
      answers: ["2019","2010","2018","2003"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14393: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2018 pour ses contributions à l’apprentissage profond ?",
      answers: ["Yoshua Bengio","Geoffrey E. Hinton","John L. Hennessy","Yann LeCun"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14394: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Geoffrey E. Hinton a-t-il reçu le Prix Turing en 2018 ?",
      answers: ["pour ses travaux sur les algorithmes et les structures de données","pour ses contributions aux graphismes 3D et à l’imagerie numérique","pour ses contributions à l’apprentissage profond","pour ses contributions à l’architecture RISC"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14395: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Yann LeCun a-t-il reçu le Prix Turing pour ses contributions à l’apprentissage profond ?",
      answers: ["2018","2010","1990","2019"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14396: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2018 pour ses contributions à l’apprentissage profond ?",
      answers: ["Dana S. Scott","Yann LeCun","David A. Patterson","Geoffrey E. Hinton"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14397: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Yann LeCun a-t-il reçu le Prix Turing en 2018 ?",
      answers: ["pour ses contributions à la cryptographie à clé publique","pour ses contributions au développement d’Internet et de TCP/IP","pour ses contributions à l’apprentissage profond","pour ses contributions aux algorithmes et aux compilateurs"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14398: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Edwin E. Catmull a-t-il reçu le Prix Turing pour ses contributions aux graphismes 3D et à l’imagerie numérique ?",
      answers: ["2019","2012","2023","1999"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14399: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2019 pour ses contributions aux graphismes 3D et à l’imagerie numérique ?",
      answers: ["Ronald L. Rivest","Edwin E. Catmull","Yann LeCun","John Backus"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14400: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Edwin E. Catmull a-t-il reçu le Prix Turing en 2019 ?",
      answers: ["pour ses contributions aux graphismes 3D et à l’imagerie numérique","pour ses contributions aux fondements de l’apprentissage par renforcement","pour ses contributions à l’architecture RISC","pour ses contributions à l’apprentissage profond"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14401: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Patrick M. Hanrahan a-t-il reçu le Prix Turing pour ses contributions aux graphismes 3D et à l’imagerie numérique ?",
      answers: ["2000","2020","2019","1995"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14402: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2019 pour ses contributions aux graphismes 3D et à l’imagerie numérique ?",
      answers: ["Yoshua Bengio","Leslie G. Valiant","Sir Tim Berners-Lee","Patrick M. Hanrahan"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14403: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Patrick M. Hanrahan a-t-il reçu le Prix Turing en 2019 ?",
      answers: ["pour ses contributions à la cryptographie et à la théorie des jeux","pour ses travaux sur les codes correcteurs d’erreurs et la théorie de l’information","pour ses contributions aux graphismes 3D et à l’imagerie numérique","pour la création du modèle relationnel des bases de données"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14404: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Alfred V. Aho a-t-il reçu le Prix Turing pour ses contributions aux algorithmes et aux compilateurs ?",
      answers: ["1990","2021","1966","2020"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14405: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2020 pour ses contributions aux algorithmes et aux compilateurs ?",
      answers: ["Stephen A. Cook","Jack J. Dongarra","Alfred V. Aho","Ivan E. Sutherland"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14406: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Alfred V. Aho a-t-il reçu le Prix Turing en 2020 ?",
      answers: ["pour ses contributions aux réseaux bayésiens et à l’IA probabiliste","pour ses contributions aux fondements de l’apprentissage par renforcement","pour ses contributions aux algorithmes et aux compilateurs","pour ses contributions à la conception des premiers ordinateurs personnels"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14407: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Jeffrey D. Ullman a-t-il reçu le Prix Turing pour ses contributions aux algorithmes et aux compilateurs ?",
      answers: ["2018","2017","2020","2019"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14408: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2020 pour ses contributions aux algorithmes et aux compilateurs ?",
      answers: ["Yoshua Bengio","Jack J. Dongarra","Jeffrey D. Ullman","Patrick M. Hanrahan"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14409: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Jeffrey D. Ullman a-t-il reçu le Prix Turing en 2020 ?",
      answers: ["pour ses contributions à l’apprentissage profond","pour ses contributions aux graphismes 3D et à l’imagerie numérique","pour ses contributions aux algorithmes numériques et aux bibliothèques logicielles","pour ses contributions aux algorithmes et aux compilateurs"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14410: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Jack J. Dongarra a-t-il reçu le Prix Turing pour ses contributions aux algorithmes numériques et aux bibliothèques logicielles ?",
      answers: ["2022","2017","2004","2021"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14411: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2021 pour ses contributions aux algorithmes numériques et aux bibliothèques logicielles ?",
      answers: ["Alfred V. Aho","Patrick M. Hanrahan","Jack J. Dongarra","Edwin E. Catmull"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14412: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Jack J. Dongarra a-t-il reçu le Prix Turing en 2021 ?",
      answers: ["pour ses contributions aux algorithmes numériques et aux bibliothèques logicielles","pour l’invention et la standardisation d’Ethernet","pour ses contributions à l’optimisation des compilateurs","pour ses contributions à la cryptographie à clé publique"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14413: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Robert M. Metcalfe a-t-il reçu le Prix Turing pour l’invention et la standardisation d’Ethernet ?",
      answers: ["2008","2022","1997","1977"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14414: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2022 pour l’invention et la standardisation d’Ethernet ?",
      answers: ["Charles P. Thacker","Frederick P. Brooks Jr.","Robert M. Metcalfe","Patrick M. Hanrahan"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14415: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Robert M. Metcalfe a-t-il reçu le Prix Turing en 2022 ?",
      answers: ["pour ses contributions à la cryptographie et à la théorie des jeux","pour ses travaux sur la programmation structurée et les algorithmes","pour l’invention et la standardisation d’Ethernet","pour ses contributions aux algorithmes numériques et aux bibliothèques logicielles"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14416: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Avi Wigderson a-t-il reçu le Prix Turing pour ses contributions à la théorie de la computation et à l’aléatoire ?",
      answers: ["2023","2024","2011","1997"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14417: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2023 pour ses contributions à la théorie de la computation et à l’aléatoire ?",
      answers: ["Stephen A. Cook","Richard S. Sutton","Avi Wigderson","Alfred V. Aho"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14418: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Avi Wigderson a-t-il reçu le Prix Turing en 2023 ?",
      answers: ["pour ses contributions à la théorie de la computation et à l’aléatoire","pour ses contributions aux graphismes 3D et à l’imagerie numérique","pour ses contributions aux algorithmes et aux compilateurs","pour ses contributions aux fondements de l’apprentissage par renforcement"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14419: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Andrew G. Barto a-t-il reçu le Prix Turing pour ses contributions aux fondements de l’apprentissage par renforcement ?",
      answers: ["2024","2014","1989","2020"],
      correctAnswer: 0,
      box: 1,
      doneToday: null
    },
    id14420: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2024 pour ses contributions aux fondements de l’apprentissage par renforcement ?",
      answers: ["Robert M. Metcalfe","Andrew G. Barto","Richard M. Karp","Richard S. Sutton"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
    id14421: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Andrew G. Barto a-t-il reçu le Prix Turing en 2024 ?",
      answers: ["pour ses contributions à l’apprentissage profond","pour ses contributions à la théorie de la computation et à l’aléatoire","pour ses contributions aux algorithmes et aux compilateurs","pour ses contributions aux fondements de l’apprentissage par renforcement"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14422: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "En quelle année Richard S. Sutton a-t-il reçu le Prix Turing pour ses contributions aux fondements de l’apprentissage par renforcement ?",
      answers: ["1994","2023","1972","2024"],
      correctAnswer: 3,
      box: 1,
      doneToday: null
    },
    id14423: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Qui a reçu le Prix Turing en 2024 pour ses contributions aux fondements de l’apprentissage par renforcement ?",
      answers: ["Douglas C. Engelbart","Jack J. Dongarra","Richard S. Sutton","Robert M. Metcalfe"],
      correctAnswer: 2,
      box: 1,
      doneToday: null
    },
    id14424: {
      themes: ["Informatique","Histoire","Science","Science et Nature","Prix Turing"],
      question: "Pour quelle raison Richard S. Sutton a-t-il reçu le Prix Turing en 2024 ?",
      answers: ["pour ses contributions aux algorithmes numériques et aux bibliothèques logicielles","pour ses contributions aux fondements de l’apprentissage par renforcement","pour l’invention et la standardisation d’Ethernet","pour ses contributions à la théorie de la computation et à l’aléatoire"],
      correctAnswer: 1,
      box: 1,
      doneToday: null
    },
  };
  export default NobelPrize;
//  module.exports = NobelPrize;